import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.string.small";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { settings } from 'carbon-components';
import ScrollToTop from 'react-scroll-up';
import { Dropdown, CodeSnippet } from 'carbon-components-react';
import { Link } from 'gatsby';
import Prism$1 from 'prismjs';
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var prefix = settings.prefix;
var IBMLogo = React.createElement("svg", {
  width: "81",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("g", {
  fill: "#BEBDBD",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 32h15.689v-2.038H0zM0 27.721h15.689v-2.038H0zM4.483 23.442h6.724v-2.037H4.483zM4.483 19.164h6.724v-2.038H4.483zM4.483 14.885h6.724v-2.037H4.483zM4.482 10.606h6.724V8.568H4.482zM0 6.327h15.689V4.29H0zM0 2.049h15.689V.011H0zM17.93 29.963V32h16.504a8.521 8.521 0 0 0 5.54-2.037H17.93zM17.93 25.683v2.038h23.914a8.535 8.535 0 0 0 .85-2.038H17.93zM22.412 23.442h6.724v-2.037h-6.724zM40.124 17.126H22.412v2.038H41.77a8.62 8.62 0 0 0-1.645-2.038M22.413 12.848v2.036h17.786a8.612 8.612 0 0 0 1.644-2.037h-19.43zM42.693 6.327a8.447 8.447 0 0 0-.85-2.037H17.93v2.037h24.763zM39.974 2.049a8.521 8.521 0 0 0-5.54-2.037H17.93v2.037h22.044zM22.412 10.606h6.724V8.568h-6.724zM35.453 10.606h7.29a8.603 8.603 0 0 0 .248-2.038h-7.538v2.038zM35.453 21.405v2.037h7.538c0-.703-.09-1.384-.248-2.037h-7.29zM57.457 0H44.825v2.038h13.34zM44.826 32h11.21v-2.038h-11.21zM44.826 27.72h11.21v-2.038h-11.21zM49.309 23.439h6.727v-2.038h-6.727zM49.309 19.159h6.727v-2.038h-6.727zM69.488 32h11.21v-2.038h-11.21zM69.488 27.72h11.21v-2.038h-11.21zM69.488 23.439h6.726v-2.038h-6.726zM69.487 19.159h6.726v-2.038h-6.726zM69.488 14.879h6.726V12.84H63.606l-.707 2.038h5.903l.686-1.94zM61.916 12.84H49.31v2.039h6.726v-1.94l.686 1.94h5.903zM76.213 8.56H65.091l-.707 2.038h11.83zM68.06 0l-.706 2.038h13.344V0zM62.757 32l.72-2.038h-1.432zM61.254 27.72h3.015l.72-2.038h-4.455zM59.743 23.44h6.037l.72-2.039h-7.476zM58.232 19.159h9.06l.719-2.038h-10.5zM49.309 10.598h11.83l-.707-2.038H49.309zM65.868 6.318h14.83V4.28H66.576zM58.947 4.28H44.826v2.038h14.828z"
})));

var WebsiteFooter = function WebsiteFooter(_ref) {
  var children = _ref.children,
      linksCol1 = _ref.linksCol1,
      linksCol2 = _ref.linksCol2,
      logoOffset = _ref.logoOffset;
  var logoClassNames = classnames(["".concat(prefix, "--col-lg-12")], _defineProperty({}, "".concat(prefix, "--offset-lg-4"), logoOffset));
  return React.createElement("footer", {
    className: "".concat(prefix, "--website-footer")
  }, React.createElement("div", {
    className: "".concat(prefix, "--grid")
  }, React.createElement("div", {
    className: "".concat(prefix, "--row")
  }, React.createElement("nav", {
    "aria-label": "Footer nav",
    className: "".concat(prefix, "--website-footer__nav ").concat(prefix, "--col-lg-2 ").concat(prefix, "--col-md-2 ").concat(prefix, "--offset-lg-4")
  }, React.createElement("ul", null, linksCol1 && linksCol1.map(function (link, i) {
    return React.createElement("li", {
      key: i
    }, React.createElement("a", {
      className: "".concat(prefix, "--website-footer__link"),
      href: link.href,
      "aria-label": link.linkText
    }, link.linkText));
  }))), React.createElement("nav", {
    "aria-label": "Footer nav continued",
    className: "".concat(prefix, "--website-footer__nav ").concat(prefix, "--col-lg-2 ").concat(prefix, "--col-md-2")
  }, React.createElement("ul", null, linksCol2 && linksCol2.map(function (link, i) {
    return React.createElement("li", {
      key: i
    }, React.createElement("a", {
      className: "".concat(prefix, "--website-footer__link"),
      href: link.href,
      "aria-label": link.linkText
    }, link.linkText));
  }))), React.createElement("div", {
    className: "".concat(prefix, "--website-footer__content ").concat(prefix, "--col-lg-5 ").concat(prefix, "--col-md-4 ").concat(prefix, "--offset-lg-2")
  }, children)), React.createElement("div", {
    className: "${prefix}--row"
  }, React.createElement("div", {
    className: logoClassNames
  }, IBMLogo))));
};

WebsiteFooter.propTypes = {
  /**
   * Specify an array of links
   */
  linksCol1: PropTypes.array,

  /**
   * Specify second array of links
   */
  linksCol2: PropTypes.array,

  /**
   * Specifcy whether logo should be offset 4 columns, defaults to true
   */
  logoOffset: PropTypes.bool
};
WebsiteFooter.defaultProps = {
  logoOffset: true
};
var prefix$1 = settings.prefix;

var WebsiteSwitcher = function WebsiteSwitcher(props) {
  var isSwitcherOpen = props.isSwitcherOpen,
      links = props.links;
  var classNames = classnames("".concat(prefix$1, "--website-switcher"), _defineProperty({}, "".concat(prefix$1, "--website-switcher--expanded"), isSwitcherOpen));
  return React.createElement("nav", {
    className: classNames,
    "aria-label": "website switcher"
  }, React.createElement("ul", {
    style: {
      display: !isSwitcherOpen && 'none'
    },
    className: "".concat(prefix$1, "--website-switcher__list")
  }, links && links.map(function (link, i) {
    return React.createElement("li", {
      key: i,
      className: "".concat(prefix$1, "--website-switcher-list__item")
    }, React.createElement("a", {
      className: "".concat(prefix$1, "--website-switcher-list__item-link"),
      tabIndex: isSwitcherOpen ? 0 : -1,
      href: link.href,
      "aria-label": link.linkText
    }, link.linkText));
  })));
};

WebsiteSwitcher.propTypes = {
  /**
   * Specify an array of links
   */
  links: PropTypes.array
};
var prefix$2 = settings.prefix;

var FourOhFour =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FourOhFour, _React$Component);

  function FourOhFour() {
    _classCallCheck(this, FourOhFour);

    return _possibleConstructorReturn(this, _getPrototypeOf(FourOhFour).apply(this, arguments));
  }

  _createClass(FourOhFour, [{
    key: "render",
    value: function render() {
      if (typeof document !== 'undefined') {
        document.body.style.background = '#282828';
      }

      return React.createElement("div", {
        className: "page-content fourohfour"
      }, React.createElement("div", {
        className: "".concat(prefix$2, "--grid")
      }, React.createElement("div", {
        className: "".concat(prefix$2, "--row")
      }, React.createElement("div", {
        className: "".concat(prefix$2, "--col-lg-12 ").concat(prefix$2, "--offset-lg-4 fourohfour-body")
      }, React.createElement("div", {
        className: "fourohfour-body"
      }, React.createElement("h2", {
        className: "fourohfour-body__heading"
      }, "Something's wrong..."), React.createElement("p", {
        className: "fourohfour-body__text"
      }, "Sorry, we cannot find the page you are looking for."), React.createElement("p", {
        className: "fourohfour-body__text"
      }, "Maybe some of these most visited links will help you?"), this.props.children, React.createElement("h5", {
        className: "fourohfour-body__404"
      }, "404"))))));
    }
  }]);

  return FourOhFour;
}(React.Component);

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
/**
 * Copyright IBM Corp. 2018, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


var defaultAttributes = {
  // Reference:
  // https://github.com/IBM/carbon-components-react/issues/1392
  // https://github.com/PolymerElements/iron-iconset-svg/pull/47
  // `focusable` is a string attribute which is why we do not use a boolean here
  focusable: 'false',
  preserveAspectRatio: 'xMidYMid meet',
  // Reference:
  // https://github.com/ckeditor/ckeditor5/issues/668#issuecomment-344844027
  style: 'will-change: transform;'
};
/**
 * Get supplementary HTML attributes for a given <svg> element based on existing
 * attributes.
 */

function getAttributes() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      width = _ref.width,
      height = _ref.height,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? "0 0 ".concat(width, " ").concat(height) : _ref$viewBox,
      attributes = _objectWithoutProperties$1(_ref, ["width", "height", "viewBox"]);

  var tabindex = attributes.tabindex,
      rest = _objectWithoutProperties$1(attributes, ["tabindex"]);

  var iconAttributes = _objectSpread$1({}, defaultAttributes, rest, {
    width: width,
    height: height,
    viewBox: viewBox
  }); // TODO: attributes.title assumes that the consumer will implement <title> and
  // correctly set `aria-labelledby`.


  if (iconAttributes['aria-label'] || iconAttributes['aria-labelledby'] || iconAttributes.title) {
    iconAttributes.role = 'img'; // Reference:
    // https://allyjs.io/tutorials/focusing-in-svg.html

    if (tabindex !== undefined && tabindex !== null) {
      iconAttributes.focusable = 'true';
      iconAttributes.tabindex = tabindex;
    }
  } else {
    iconAttributes['aria-hidden'] = true;
  }

  return iconAttributes;
}

function _typeof$1(obj) {
  if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
    _typeof$1 = function _typeof$$1(obj) {
      return _typeof(obj);
    };
  } else {
    _typeof$1 = function _typeof$$1(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
    };
  }

  return _typeof$1(obj);
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$2(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var defaultStyle = {
  "willChange": "transform"
};
var AddFilled16 = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      style = _ref.style,
      tabIndex = _ref.tabIndex,
      rest = _objectWithoutProperties$2(_ref, ["className", "children", "style", "tabIndex"]);

  var _getAttributes = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes.tabindex,
      props = _objectWithoutProperties$2(_getAttributes, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.2 1 1 4.2 1 8s3.2 7 7 7 7-3.2 7-7-3.2-7-7-7zm3 7.5H8.5V11h-1V8.5H5v-1h2.5V5h1v2.5H11v1z'
  }));
});
AddFilled16.displayName = 'AddFilled16';
AddFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AddOutline16 = React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      children = _ref2.children,
      style = _ref2.style,
      tabIndex = _ref2.tabIndex,
      rest = _objectWithoutProperties$2(_ref2, ["className", "children", "style", "tabIndex"]);

  var _getAttributes2 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes2.tabindex,
      props = _objectWithoutProperties$2(_getAttributes2, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6m0-1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z'
  }), React.createElement('path', {
    d: 'M11 7.5H8.5V5h-1v2.5H5v1h2.5V11h1V8.5H11z'
  }));
});
AddOutline16.displayName = 'AddOutline16';
AddOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Add16 = React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
      children = _ref3.children,
      style = _ref3.style,
      tabIndex = _ref3.tabIndex,
      rest = _objectWithoutProperties$2(_ref3, ["className", "children", "style", "tabIndex"]);

  var _getAttributes3 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes3.tabindex,
      props = _objectWithoutProperties$2(_getAttributes3, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.5 7.5V3h-1v4.5H3v1h4.5V13h1V8.5H13v-1z'
  }));
});
Add16.displayName = 'Add16';
Add16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Add16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Apps16 = React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
      children = _ref4.children,
      style = _ref4.style,
      tabIndex = _ref4.tabIndex,
      rest = _objectWithoutProperties$2(_ref4, ["className", "children", "style", "tabIndex"]);

  var _getAttributes4 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes4.tabindex,
      props = _objectWithoutProperties$2(_getAttributes4, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 2v2H2V2h2zm1-1H1v4h4V1zm4 1v2H7V2h2zm1-1H6v4h4V1zm4 1v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zm4 1v2H7V7h2zm1-1H6v4h4V6zm4 1v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zm4 1v2H7v-2h2zm1-1H6v4h4v-4zm4 1v2h-2v-2h2zm1-1h-4v4h4v-4z'
  }));
});
Apps16.displayName = 'Apps16';
Apps16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Apps16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDown16 = React.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
      children = _ref5.children,
      style = _ref5.style,
      tabIndex = _ref5.tabIndex,
      rest = _objectWithoutProperties$2(_ref5, ["className", "children", "style", "tabIndex"]);

  var _getAttributes5 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes5.tabindex,
      props = _objectWithoutProperties$2(_getAttributes5, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.3 9.3l-3.8 3.8V1h-1v12.1L3.7 9.3 3 10l5 5 5-5z'
  }));
});
ArrowDown16.displayName = 'ArrowDown16';
ArrowDown16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDown16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowLeft16 = React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
      children = _ref6.children,
      style = _ref6.style,
      tabIndex = _ref6.tabIndex,
      rest = _objectWithoutProperties$2(_ref6, ["className", "children", "style", "tabIndex"]);

  var _getAttributes6 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes6.tabindex,
      props = _objectWithoutProperties$2(_getAttributes6, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6.7 12.3L2.9 8.5H15v-1H2.9l3.8-3.8L6 3 1 8l5 5z'
  }));
});
ArrowLeft16.displayName = 'ArrowLeft16';
ArrowLeft16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowLeft16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowRight16 = React.forwardRef(function (_ref7, ref) {
  var className = _ref7.className,
      children = _ref7.children,
      style = _ref7.style,
      tabIndex = _ref7.tabIndex,
      rest = _objectWithoutProperties$2(_ref7, ["className", "children", "style", "tabIndex"]);

  var _getAttributes7 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes7.tabindex,
      props = _objectWithoutProperties$2(_getAttributes7, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.3 3.7l3.8 3.8H1v1h12.1l-3.8 3.8.7.7 5-5-5-5z'
  }));
});
ArrowRight16.displayName = 'ArrowRight16';
ArrowRight16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowRight16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUp16 = React.forwardRef(function (_ref8, ref) {
  var className = _ref8.className,
      children = _ref8.children,
      style = _ref8.style,
      tabIndex = _ref8.tabIndex,
      rest = _objectWithoutProperties$2(_ref8, ["className", "children", "style", "tabIndex"]);

  var _getAttributes8 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes8.tabindex,
      props = _objectWithoutProperties$2(_getAttributes8, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3.7 6.7l3.8-3.8V15h1V2.9l3.8 3.8.7-.7-5-5-5 5z'
  }));
});
ArrowUp16.displayName = 'ArrowUp16';
ArrowUp16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUp16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Arrows16 = React.forwardRef(function (_ref9, ref) {
  var className = _ref9.className,
      children = _ref9.children,
      style = _ref9.style,
      tabIndex = _ref9.tabIndex,
      rest = _objectWithoutProperties$2(_ref9, ["className", "children", "style", "tabIndex"]);

  var _getAttributes9 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes9.tabindex,
      props = _objectWithoutProperties$2(_getAttributes9, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.8 10.3L12 12.1V2h-1v10.1l-1.8-1.8-.7.7 3 3 3-3zM4.5 2l-3 3 .7.7L4 3.9V14h1V3.9l1.8 1.8.7-.7z'
  }));
});
Arrows16.displayName = 'Arrows16';
Arrows16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Arrows16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Asleep16 = React.forwardRef(function (_ref10, ref) {
  var className = _ref10.className,
      children = _ref10.children,
      style = _ref10.style,
      tabIndex = _ref10.tabIndex,
      rest = _objectWithoutProperties$2(_ref10, ["className", "children", "style", "tabIndex"]);

  var _getAttributes10 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes10.tabindex,
      props = _objectWithoutProperties$2(_getAttributes10, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.2 2.3c-1 4.4 1.7 8.7 6.1 9.8h.2c-1.1 1.2-2.7 1.8-4.3 1.8H9c-3.4-.1-6-2.9-5.8-6.2 0-2.4 1.6-4.6 4-5.4M8 1c-3.9.6-6.5 4.3-5.9 8.1.6 3.3 3.4 5.8 6.8 5.9h.3c2.3 0 4.4-1.1 5.8-3 .2-.2.1-.6-.1-.7-.1-.1-.2-.1-.3-.1-3.9-.3-6.7-3.8-6.4-7.6.1-.6.2-1.2.4-1.8.1-.3 0-.6-.3-.7C8.1 1 8.1 1 8 1z'
  }));
});
Asleep16.displayName = 'Asleep16';
Asleep16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Asleep16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Attachment16 = React.forwardRef(function (_ref11, ref) {
  var className = _ref11.className,
      children = _ref11.children,
      style = _ref11.style,
      tabIndex = _ref11.tabIndex,
      rest = _objectWithoutProperties$2(_ref11, ["className", "children", "style", "tabIndex"]);

  var _getAttributes11 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes11.tabindex,
      props = _objectWithoutProperties$2(_getAttributes11, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14.1 9L7 1.9C5.6.6 3.3.7 2 2.1S.7 5.6 1.9 7l1.6 1.6.8-.8-1.6-1.6c-1-.9-1-2.5-.1-3.5s2.5-1 3.5-.1l.1.1 7.1 7.1c1 .9 1 2.5.1 3.5s-2.5 1-3.5.1l-.1-.1-3.3-3.4c-.6-.5-.6-1.4 0-1.9s1.4-.5 1.9 0l1.7 1.7.8-.7-1.8-1.8c-1-.9-2.5-.9-3.5.1-.9.9-.9 2.4 0 3.3L9 14.1c1.4 1.3 3.7 1.2 5-.2s1.3-3.5.1-4.9z'
  }));
});
Attachment16.displayName = 'Attachment16';
Attachment16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Attachment16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Awake16 = React.forwardRef(function (_ref12, ref) {
  var className = _ref12.className,
      children = _ref12.children,
      style = _ref12.style,
      tabIndex = _ref12.tabIndex,
      rest = _objectWithoutProperties$2(_ref12, ["className", "children", "style", "tabIndex"]);

  var _getAttributes12 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes12.tabindex,
      props = _objectWithoutProperties$2(_getAttributes12, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.5 1h1v2.5h-1zm3.304 3.454l1.768-1.768.707.707-1.768 1.768zM12.5 7.5H15v1h-2.5zm-1.662 4.01l.707-.706 1.768 1.767-.707.707zM7.5 12.5h1V15h-1zm-4.778.11l1.768-1.77.707.707-1.768 1.768zM1 7.5h2.5v1H1zm1.688-4.07l.707-.706L5.163 4.49l-.707.707zM8 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-1C6.3 5 5 6.3 5 8s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z'
  }));
});
Awake16.displayName = 'Awake16';
Awake16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Awake16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BackToTop16 = React.forwardRef(function (_ref13, ref) {
  var className = _ref13.className,
      children = _ref13.children,
      style = _ref13.style,
      tabIndex = _ref13.tabIndex,
      rest = _objectWithoutProperties$2(_ref13, ["className", "children", "style", "tabIndex"]);

  var _getAttributes13 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes13.tabindex,
      props = _objectWithoutProperties$2(_getAttributes13, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 7l-5 5 .7.7L8 8.4l4.3 4.3.7-.7zM2 4h12v1H2z'
  }));
});
BackToTop16.displayName = 'BackToTop16';
BackToTop16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BackToTop16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calendar16 = React.forwardRef(function (_ref14, ref) {
  var className = _ref14.className,
      children = _ref14.children,
      style = _ref14.style,
      tabIndex = _ref14.tabIndex,
      rest = _objectWithoutProperties$2(_ref14, ["className", "children", "style", "tabIndex"]);

  var _getAttributes14 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes14.tabindex,
      props = _objectWithoutProperties$2(_getAttributes14, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 2h-2V1h-1v1H6V1H5v1H3c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm0 11H3V6h10v7zm0-8H3V3h2v1h1V3h4v1h1V3h2v2z'
  }));
});
Calendar16.displayName = 'Calendar16';
Calendar16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calendar16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretDown16 = React.forwardRef(function (_ref15, ref) {
  var className = _ref15.className,
      children = _ref15.children,
      style = _ref15.style,
      tabIndex = _ref15.tabIndex,
      rest = _objectWithoutProperties$2(_ref15, ["className", "children", "style", "tabIndex"]);

  var _getAttributes15 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes15.tabindex,
      props = _objectWithoutProperties$2(_getAttributes15, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 6l-4 4-4-4z'
  }));
});
CaretDown16.displayName = 'CaretDown16';
CaretDown16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretDown16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretLeft16 = React.forwardRef(function (_ref16, ref) {
  var className = _ref16.className,
      children = _ref16.children,
      style = _ref16.style,
      tabIndex = _ref16.tabIndex,
      rest = _objectWithoutProperties$2(_ref16, ["className", "children", "style", "tabIndex"]);

  var _getAttributes16 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes16.tabindex,
      props = _objectWithoutProperties$2(_getAttributes16, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 12L6 8l5-4z'
  }));
});
CaretLeft16.displayName = 'CaretLeft16';
CaretLeft16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretLeft16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretRight16 = React.forwardRef(function (_ref17, ref) {
  var className = _ref17.className,
      children = _ref17.children,
      style = _ref17.style,
      tabIndex = _ref17.tabIndex,
      rest = _objectWithoutProperties$2(_ref17, ["className", "children", "style", "tabIndex"]);

  var _getAttributes17 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes17.tabindex,
      props = _objectWithoutProperties$2(_getAttributes17, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 4l5 4-5 4z'
  }));
});
CaretRight16.displayName = 'CaretRight16';
CaretRight16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretRight16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretSortDown16 = React.forwardRef(function (_ref18, ref) {
  var className = _ref18.className,
      children = _ref18.children,
      style = _ref18.style,
      tabIndex = _ref18.tabIndex,
      rest = _objectWithoutProperties$2(_ref18, ["className", "children", "style", "tabIndex"]);

  var _getAttributes18 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes18.tabindex,
      props = _objectWithoutProperties$2(_getAttributes18, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.5 10L8 14l-3.5-4z'
  }));
});
CaretSortDown16.displayName = 'CaretSortDown16';
CaretSortDown16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretSortDown16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretSortUp16 = React.forwardRef(function (_ref19, ref) {
  var className = _ref19.className,
      children = _ref19.children,
      style = _ref19.style,
      tabIndex = _ref19.tabIndex,
      rest = _objectWithoutProperties$2(_ref19, ["className", "children", "style", "tabIndex"]);

  var _getAttributes19 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes19.tabindex,
      props = _objectWithoutProperties$2(_getAttributes19, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4.5 6L8 2l3.5 4z'
  }));
});
CaretSortUp16.displayName = 'CaretSortUp16';
CaretSortUp16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretSortUp16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretSort16 = React.forwardRef(function (_ref20, ref) {
  var className = _ref20.className,
      children = _ref20.children,
      style = _ref20.style,
      tabIndex = _ref20.tabIndex,
      rest = _objectWithoutProperties$2(_ref20, ["className", "children", "style", "tabIndex"]);

  var _getAttributes20 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes20.tabindex,
      props = _objectWithoutProperties$2(_getAttributes20, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4.5 6L8 2l3.5 4zm7 4L8 14l-3.5-4z'
  }));
});
CaretSort16.displayName = 'CaretSort16';
CaretSort16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretSort16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretUp16 = React.forwardRef(function (_ref21, ref) {
  var className = _ref21.className,
      children = _ref21.children,
      style = _ref21.style,
      tabIndex = _ref21.tabIndex,
      rest = _objectWithoutProperties$2(_ref21, ["className", "children", "style", "tabIndex"]);

  var _getAttributes21 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes21.tabindex,
      props = _objectWithoutProperties$2(_getAttributes21, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 10l4-4 4 4z'
  }));
});
CaretUp16.displayName = 'CaretUp16';
CaretUp16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretUp16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chat16 = React.forwardRef(function (_ref22, ref) {
  var className = _ref22.className,
      children = _ref22.children,
      style = _ref22.style,
      tabIndex = _ref22.tabIndex,
      rest = _objectWithoutProperties$2(_ref22, ["className", "children", "style", "tabIndex"]);

  var _getAttributes22 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes22.tabindex,
      props = _objectWithoutProperties$2(_getAttributes22, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.9 14l-.9-.5 2-3.5h3c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h4.5v1H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3z'
  }), React.createElement('path', {
    d: 'M4 4h8v1H4zm0 3h5v1H4z'
  }));
});
Chat16.displayName = 'Chat16';
Chat16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chat16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckmarkFilled16 = React.forwardRef(function (_ref23, ref) {
  var className = _ref23.className,
      children = _ref23.children,
      style = _ref23.style,
      tabIndex = _ref23.tabIndex,
      rest = _objectWithoutProperties$2(_ref23, ["className", "children", "style", "tabIndex"]);

  var _getAttributes23 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes23.tabindex,
      props = _objectWithoutProperties$2(_getAttributes23, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm-1 9.8L4.5 8.2l.8-.8L7 9.2l3.7-3.7.8.8L7 10.8z'
  }));
});
CheckmarkFilled16.displayName = 'CheckmarkFilled16';
CheckmarkFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckmarkFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckmarkOutline16 = React.forwardRef(function (_ref24, ref) {
  var className = _ref24.className,
      children = _ref24.children,
      style = _ref24.style,
      tabIndex = _ref24.tabIndex,
      rest = _objectWithoutProperties$2(_ref24, ["className", "children", "style", "tabIndex"]);

  var _getAttributes24 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes24.tabindex,
      props = _objectWithoutProperties$2(_getAttributes24, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 13c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z'
  }), React.createElement('path', {
    d: 'M7 10.8L4.5 8.3l.8-.8L7 9.2l3.7-3.7.8.8z'
  }));
});
CheckmarkOutline16.displayName = 'CheckmarkOutline16';
CheckmarkOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckmarkOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronDown16 = React.forwardRef(function (_ref25, ref) {
  var className = _ref25.className,
      children = _ref25.children,
      style = _ref25.style,
      tabIndex = _ref25.tabIndex,
      rest = _objectWithoutProperties$2(_ref25, ["className", "children", "style", "tabIndex"]);

  var _getAttributes25 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes25.tabindex,
      props = _objectWithoutProperties$2(_getAttributes25, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 11L3 6l.7-.7L8 9.6l4.3-4.3.7.7z'
  }));
});
ChevronDown16.displayName = 'ChevronDown16';
ChevronDown16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronDown16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronLeft16 = React.forwardRef(function (_ref26, ref) {
  var className = _ref26.className,
      children = _ref26.children,
      style = _ref26.style,
      tabIndex = _ref26.tabIndex,
      rest = _objectWithoutProperties$2(_ref26, ["className", "children", "style", "tabIndex"]);

  var _getAttributes26 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes26.tabindex,
      props = _objectWithoutProperties$2(_getAttributes26, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 8l5-5 .7.7L6.4 8l4.3 4.3-.7.7z'
  }));
});
ChevronLeft16.displayName = 'ChevronLeft16';
ChevronLeft16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronLeft16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronRight16 = React.forwardRef(function (_ref27, ref) {
  var className = _ref27.className,
      children = _ref27.children,
      style = _ref27.style,
      tabIndex = _ref27.tabIndex,
      rest = _objectWithoutProperties$2(_ref27, ["className", "children", "style", "tabIndex"]);

  var _getAttributes27 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes27.tabindex,
      props = _objectWithoutProperties$2(_getAttributes27, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 8l-5 5-.7-.7L9.6 8 5.3 3.7 6 3z'
  }));
});
ChevronRight16.displayName = 'ChevronRight16';
ChevronRight16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronRight16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronSortDown16 = React.forwardRef(function (_ref28, ref) {
  var className = _ref28.className,
      children = _ref28.children,
      style = _ref28.style,
      tabIndex = _ref28.tabIndex,
      rest = _objectWithoutProperties$2(_ref28, ["className", "children", "style", "tabIndex"]);

  var _getAttributes28 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes28.tabindex,
      props = _objectWithoutProperties$2(_getAttributes28, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 14l-3.5-3.5.7-.7L8 12.6l2.8-2.8.7.7z'
  }));
});
ChevronSortDown16.displayName = 'ChevronSortDown16';
ChevronSortDown16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronSortDown16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronSortUp16 = React.forwardRef(function (_ref29, ref) {
  var className = _ref29.className,
      children = _ref29.children,
      style = _ref29.style,
      tabIndex = _ref29.tabIndex,
      rest = _objectWithoutProperties$2(_ref29, ["className", "children", "style", "tabIndex"]);

  var _getAttributes29 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes29.tabindex,
      props = _objectWithoutProperties$2(_getAttributes29, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 2l3.5 3.5-.7.7L8 3.4 5.2 6.2l-.7-.7z'
  }));
});
ChevronSortUp16.displayName = 'ChevronSortUp16';
ChevronSortUp16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronSortUp16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronSort16 = React.forwardRef(function (_ref30, ref) {
  var className = _ref30.className,
      children = _ref30.children,
      style = _ref30.style,
      tabIndex = _ref30.tabIndex,
      rest = _objectWithoutProperties$2(_ref30, ["className", "children", "style", "tabIndex"]);

  var _getAttributes30 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes30.tabindex,
      props = _objectWithoutProperties$2(_getAttributes30, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 14l-3.5-3.5.7-.7L8 12.6l2.8-2.8.7.7zM8 2l3.5 3.5-.7.7L8 3.4 5.2 6.2l-.7-.7z'
  }));
});
ChevronSort16.displayName = 'ChevronSort16';
ChevronSort16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronSort16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronUp16 = React.forwardRef(function (_ref31, ref) {
  var className = _ref31.className,
      children = _ref31.children,
      style = _ref31.style,
      tabIndex = _ref31.tabIndex,
      rest = _objectWithoutProperties$2(_ref31, ["className", "children", "style", "tabIndex"]);

  var _getAttributes31 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes31.tabindex,
      props = _objectWithoutProperties$2(_getAttributes31, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 5l5 5-.7.7L8 6.4l-4.3 4.3L3 10z'
  }));
});
ChevronUp16.displayName = 'ChevronUp16';
ChevronUp16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronUp16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloseFilled16 = React.forwardRef(function (_ref32, ref) {
  var className = _ref32.className,
      children = _ref32.children,
      style = _ref32.style,
      tabIndex = _ref32.tabIndex,
      rest = _objectWithoutProperties$2(_ref32, ["className", "children", "style", "tabIndex"]);

  var _getAttributes32 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes32.tabindex,
      props = _objectWithoutProperties$2(_getAttributes32, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm2.7 10.5L8 8.8l-2.7 2.7-.8-.8L7.2 8 4.5 5.3l.8-.8L8 7.2l2.7-2.7.8.8L8.8 8l2.7 2.7-.8.8z'
  }));
});
CloseFilled16.displayName = 'CloseFilled16';
CloseFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloseFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloseOutline16 = React.forwardRef(function (_ref33, ref) {
  var className = _ref33.className,
      children = _ref33.children,
      style = _ref33.style,
      tabIndex = _ref33.tabIndex,
      rest = _objectWithoutProperties$2(_ref33, ["className", "children", "style", "tabIndex"]);

  var _getAttributes33 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes33.tabindex,
      props = _objectWithoutProperties$2(_getAttributes33, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 13c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z'
  }), React.createElement('path', {
    d: 'M10.7 11.5L8 8.8l-2.7 2.7-.8-.8L7.2 8 4.5 5.3l.8-.8L8 7.2l2.7-2.7.8.8L8.8 8l2.7 2.7z'
  }));
});
CloseOutline16.displayName = 'CloseOutline16';
CloseOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloseOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Close16 = React.forwardRef(function (_ref34, ref) {
  var className = _ref34.className,
      children = _ref34.children,
      style = _ref34.style,
      tabIndex = _ref34.tabIndex,
      rest = _objectWithoutProperties$2(_ref34, ["className", "children", "style", "tabIndex"]);

  var _getAttributes34 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes34.tabindex,
      props = _objectWithoutProperties$2(_getAttributes34, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4.7l-.7-.7L8 7.3 4.7 4l-.7.7L7.3 8 4 11.3l.7.7L8 8.7l3.3 3.3.7-.7L8.7 8z'
  }));
});
Close16.displayName = 'Close16';
Close16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Close16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Code16 = React.forwardRef(function (_ref35, ref) {
  var className = _ref35.className,
      children = _ref35.children,
      style = _ref35.style,
      tabIndex = _ref35.tabIndex,
      rest = _objectWithoutProperties$2(_ref35, ["className", "children", "style", "tabIndex"]);

  var _getAttributes35 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes35.tabindex,
      props = _objectWithoutProperties$2(_getAttributes35, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15.5 8L12 11.5l-.7-.7L14.1 8l-2.8-2.8.7-.7zM.5 8L4 4.5l.7.7L1.9 8l2.8 2.8-.7.7zm5.72 4.697l2.615-9.756.966.26-2.614 9.755z'
  }));
});
Code16.displayName = 'Code16';
Code16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Code16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CopyFile16 = React.forwardRef(function (_ref36, ref) {
  var className = _ref36.className,
      children = _ref36.children,
      style = _ref36.style,
      tabIndex = _ref36.tabIndex,
      rest = _objectWithoutProperties$2(_ref36, ["className", "children", "style", "tabIndex"]);

  var _getAttributes36 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes36.tabindex,
      props = _objectWithoutProperties$2(_getAttributes36, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14.72 7.35l-3-3.06A1 1 0 0 0 11 4H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V8a1 1 0 0 0-.28-.65zM11 5l3 3h-3zm-6 9V5h5v3a1 1 0 0 0 1 1h3v5z'
  }), React.createElement('path', {
    d: 'M2 9H1V2a1 1 0 0 1 1-1h7v1H2z'
  }));
});
CopyFile16.displayName = 'CopyFile16';
CopyFile16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CopyFile16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Copy16 = React.forwardRef(function (_ref37, ref) {
  var className = _ref37.className,
      children = _ref37.children,
      style = _ref37.style,
      tabIndex = _ref37.tabIndex,
      rest = _objectWithoutProperties$2(_ref37, ["className", "children", "style", "tabIndex"]);

  var _getAttributes37 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes37.tabindex,
      props = _objectWithoutProperties$2(_getAttributes37, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 5v9H5V5h9m0-1H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z'
  }), React.createElement('path', {
    d: 'M2 9H1V2a1 1 0 0 1 1-1h7v1H2z'
  }));
});
Copy16.displayName = 'Copy16';
Copy16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Copy16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Delete16 = React.forwardRef(function (_ref38, ref) {
  var className = _ref38.className,
      children = _ref38.children,
      style = _ref38.style,
      tabIndex = _ref38.tabIndex,
      rest = _objectWithoutProperties$2(_ref38, ["className", "children", "style", "tabIndex"]);

  var _getAttributes38 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes38.tabindex,
      props = _objectWithoutProperties$2(_getAttributes38, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h1v6H6zm3 0h1v6H9z'
  }), React.createElement('path', {
    d: 'M2 3v1h1v10c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4h1V3H2zm2 11V4h8v10H4zM6 1h4v1H6z'
  }));
});
Delete16.displayName = 'Delete16';
Delete16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Delete16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Document16 = React.forwardRef(function (_ref39, ref) {
  var className = _ref39.className,
      children = _ref39.children,
      style = _ref39.style,
      tabIndex = _ref39.tabIndex,
      rest = _objectWithoutProperties$2(_ref39, ["className", "children", "style", "tabIndex"]);

  var _getAttributes39 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes39.tabindex,
      props = _objectWithoutProperties$2(_getAttributes39, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.9 4.7L9.4 1.2C9.3 1.1 9.1 1 9 1H4c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V5c0-.1-.1-.3-.1-.3zM9 2.2L11.8 5H9V2.2zM12 14H4V2h4v3c0 .6.4 1 1 1h3v8z'
  }), React.createElement('path', {
    d: 'M5 11h6v1H5zm0-3h6v1H5z'
  }));
});
Document16.displayName = 'Document16';
Document16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Document16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DownToBottom16 = React.forwardRef(function (_ref40, ref) {
  var className = _ref40.className,
      children = _ref40.children,
      style = _ref40.style,
      tabIndex = _ref40.tabIndex,
      rest = _objectWithoutProperties$2(_ref40, ["className", "children", "style", "tabIndex"]);

  var _getAttributes40 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes40.tabindex,
      props = _objectWithoutProperties$2(_getAttributes40, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 10l5-5-.7-.7L8 8.6 3.7 4.3 3 5zm-6 2h12v1H2z'
  }));
});
DownToBottom16.displayName = 'DownToBottom16';
DownToBottom16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DownToBottom16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Download16 = React.forwardRef(function (_ref41, ref) {
  var className = _ref41.className,
      children = _ref41.children,
      style = _ref41.style,
      tabIndex = _ref41.tabIndex,
      rest = _objectWithoutProperties$2(_ref41, ["className", "children", "style", "tabIndex"]);

  var _getAttributes41 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes41.tabindex,
      props = _objectWithoutProperties$2(_getAttributes41, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 7l-.7-.7-3.8 3.8V1h-1v9.1L3.7 6.3 3 7l5 5zm0 5v2H3v-2H2v2c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-2h-1z'
  }));
});
Download16.displayName = 'Download16';
Download16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Download16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Draggable16 = React.forwardRef(function (_ref42, ref) {
  var className = _ref42.className,
      children = _ref42.children,
      style = _ref42.style,
      tabIndex = _ref42.tabIndex,
      rest = _objectWithoutProperties$2(_ref42, ["className", "children", "style", "tabIndex"]);

  var _getAttributes42 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes42.tabindex,
      props = _objectWithoutProperties$2(_getAttributes42, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 3h2v2H5zm4 0h2v2H9zM5 7h2v2H5zm4 0h2v2H9zm-4 4h2v2H5zm4 0h2v2H9z'
  }));
});
Draggable16.displayName = 'Draggable16';
Draggable16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Draggable16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Edit16 = React.forwardRef(function (_ref43, ref) {
  var className = _ref43.className,
      children = _ref43.children,
      style = _ref43.style,
      tabIndex = _ref43.tabIndex,
      rest = _objectWithoutProperties$2(_ref43, ["className", "children", "style", "tabIndex"]);

  var _getAttributes43 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes43.tabindex,
      props = _objectWithoutProperties$2(_getAttributes43, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M1 13h14v1H1zm11.7-8.5c.4-.4.4-1 0-1.4l-1.8-1.8c-.4-.4-1-.4-1.4 0L2 8.8V12h3.2l7.5-7.5zM10.2 2L12 3.8l-1.5 1.5-1.8-1.8L10.2 2zM3 11V9.2l5-5L9.8 6l-5 5H3z'
  }));
});
Edit16.displayName = 'Edit16';
Edit16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Edit16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Email16 = React.forwardRef(function (_ref44, ref) {
  var className = _ref44.className,
      children = _ref44.children,
      style = _ref44.style,
      tabIndex = _ref44.tabIndex,
      rest = _objectWithoutProperties$2(_ref44, ["className", "children", "style", "tabIndex"]);

  var _getAttributes44 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes44.tabindex,
      props = _objectWithoutProperties$2(_getAttributes44, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 3H2c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm-1.1 1L8 7.4 3.1 4h9.8zM2 12V4.5l5.7 4c.2.1.4.1.6 0l5.7-4V12H2z'
  }));
});
Email16.displayName = 'Email16';
Email16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Email16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ErrorFilled16 = React.forwardRef(function (_ref45, ref) {
  var className = _ref45.className,
      children = _ref45.children,
      style = _ref45.style,
      tabIndex = _ref45.tabIndex,
      rest = _objectWithoutProperties$2(_ref45, ["className", "children", "style", "tabIndex"]);

  var _getAttributes45 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes45.tabindex,
      props = _objectWithoutProperties$2(_getAttributes45, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm2.7 10.5L4.5 5.3l.8-.8 6.2 6.2-.8.8z'
  }));
});
ErrorFilled16.displayName = 'ErrorFilled16';
ErrorFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ErrorFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ErrorOutline16 = React.forwardRef(function (_ref46, ref) {
  var className = _ref46.className,
      children = _ref46.children,
      style = _ref46.style,
      tabIndex = _ref46.tabIndex,
      rest = _objectWithoutProperties$2(_ref46, ["className", "children", "style", "tabIndex"]);

  var _getAttributes46 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes46.tabindex,
      props = _objectWithoutProperties$2(_getAttributes46, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 13c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z'
  }), React.createElement('path', {
    d: 'M4.464 5.313l.778-.778 6.223 6.223-.778.777z'
  }));
});
ErrorOutline16.displayName = 'ErrorOutline16';
ErrorOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ErrorOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Export16 = React.forwardRef(function (_ref47, ref) {
  var className = _ref47.className,
      children = _ref47.children,
      style = _ref47.style,
      tabIndex = _ref47.tabIndex,
      rest = _objectWithoutProperties$2(_ref47, ["className", "children", "style", "tabIndex"]);

  var _getAttributes47 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes47.tabindex,
      props = _objectWithoutProperties$2(_getAttributes47, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 12v2H3v-2H2v2c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-2h-1zM3 6l.7.7 3.8-3.8V12h1V2.9l3.8 3.8.7-.7-5-5z'
  }));
});
Export16.displayName = 'Export16';
Export16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Export16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Fade16 = React.forwardRef(function (_ref48, ref) {
  var className = _ref48.className,
      children = _ref48.children,
      style = _ref48.style,
      tabIndex = _ref48.tabIndex,
      rest = _objectWithoutProperties$2(_ref48, ["className", "children", "style", "tabIndex"]);

  var _getAttributes48 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes48.tabindex,
      props = _objectWithoutProperties$2(_getAttributes48, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4.1 12.6l-.6.8c.6.5 1.3.9 2.1 1.2l.3-.9c-.6-.3-1.2-.7-1.8-1.1zM2.1 9l-1 .2c.1.8.4 1.6.8 2.3l.9-.5c-.4-.6-.6-1.3-.7-2zm3.8-6.6l-.3-1c-.8.3-1.5.7-2.1 1.3l.6.8c.6-.5 1.2-.9 1.8-1.1zM2.8 5l-.9-.5c-.4.7-.6 1.5-.8 2.3l1 .2c.1-.7.4-1.4.7-2zM8 1v1c3.3 0 6 2.7 6 6s-2.7 6-6 6v1c3.9 0 7-3.1 7-7s-3.1-7-7-7z'
  }));
});
Fade16.displayName = 'Fade16';
Fade16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Fade16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FavoriteFilled16 = React.forwardRef(function (_ref49, ref) {
  var className = _ref49.className,
      children = _ref49.children,
      style = _ref49.style,
      tabIndex = _ref49.tabIndex,
      rest = _objectWithoutProperties$2(_ref49, ["className", "children", "style", "tabIndex"]);

  var _getAttributes49 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes49.tabindex,
      props = _objectWithoutProperties$2(_getAttributes49, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.2 2c-1 0-2 .4-2.7 1.1l-.5.6-.6-.6C6 1.6 3.6 1.6 2.1 3.1S.6 7 2.1 8.5l5.9 6 5.9-6c1.5-1.5 1.5-3.9 0-5.4-.7-.7-1.7-1.1-2.7-1.1z'
  }));
});
FavoriteFilled16.displayName = 'FavoriteFilled16';
FavoriteFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FavoriteFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Favorite16 = React.forwardRef(function (_ref50, ref) {
  var className = _ref50.className,
      children = _ref50.children,
      style = _ref50.style,
      tabIndex = _ref50.tabIndex,
      rest = _objectWithoutProperties$2(_ref50, ["className", "children", "style", "tabIndex"]);

  var _getAttributes50 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes50.tabindex,
      props = _objectWithoutProperties$2(_getAttributes50, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.2 3c.7 0 1.4.3 2 .8 1.1 1.1 1.1 2.9 0 4L8 13.1 2.8 7.8c-1.1-1.1-1.1-2.9 0-4s2.8-1.1 3.9 0L8 5.1l1.3-1.3c.5-.5 1.2-.8 1.9-.8m0-1c-1 0-2 .4-2.7 1.1l-.5.6-.6-.6C6 1.6 3.6 1.6 2.1 3.1S.6 7 2.1 8.5l5.9 6 5.9-6c1.5-1.5 1.5-3.9 0-5.4-.7-.7-1.7-1.1-2.7-1.1z'
  }));
});
Favorite16.displayName = 'Favorite16';
Favorite16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Favorite16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Filter16 = React.forwardRef(function (_ref51, ref) {
  var className = _ref51.className,
      children = _ref51.children,
      style = _ref51.style,
      tabIndex = _ref51.tabIndex,
      rest = _objectWithoutProperties$2(_ref51, ["className", "children", "style", "tabIndex"]);

  var _getAttributes51 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes51.tabindex,
      props = _objectWithoutProperties$2(_getAttributes51, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 4h-2.1c-.2-1.1-1.2-2-2.4-2s-2.2.9-2.4 2H1v1h7.1c.2 1.1 1.2 2 2.4 2s2.2-.9 2.4-2H15V4zm-4.5 2C9.7 6 9 5.3 9 4.5S9.7 3 10.5 3s1.5.7 1.5 1.5S11.3 6 10.5 6zM1 12h2.1c.2 1.1 1.2 2 2.4 2s2.2-.9 2.4-2H15v-1H7.9c-.2-1.1-1.2-2-2.4-2s-2.2.9-2.4 2H1v1zm4.5-2c.8 0 1.5.7 1.5 1.5S6.3 13 5.5 13 4 12.3 4 11.5 4.7 10 5.5 10z'
  }));
});
Filter16.displayName = 'Filter16';
Filter16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Filter16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderAdd16 = React.forwardRef(function (_ref52, ref) {
  var className = _ref52.className,
      children = _ref52.children,
      style = _ref52.style,
      tabIndex = _ref52.tabIndex,
      rest = _objectWithoutProperties$2(_ref52, ["className", "children", "style", "tabIndex"]);

  var _getAttributes52 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes52.tabindex,
      props = _objectWithoutProperties$2(_getAttributes52, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 10h-1v2h-2v1h2v2h1v-2h2v-1h-2z'
  }), React.createElement('path', {
    d: 'M14 4H8L6.3 2.3c-.2-.2-.4-.3-.7-.3H2c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h6v-1H2V3h3.6l1.7 1.7.3.3H14v4h1V5c0-.6-.4-1-1-1z'
  }));
});
FolderAdd16.displayName = 'FolderAdd16';
FolderAdd16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderAdd16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Folder16 = React.forwardRef(function (_ref53, ref) {
  var className = _ref53.className,
      children = _ref53.children,
      style = _ref53.style,
      tabIndex = _ref53.tabIndex,
      rest = _objectWithoutProperties$2(_ref53, ["className", "children", "style", "tabIndex"]);

  var _getAttributes53 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes53.tabindex,
      props = _objectWithoutProperties$2(_getAttributes53, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5.6 3l1.7 1.7.3.3H14v8H2V3h3.6m0-1H2c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H8L6.3 2.3c-.2-.2-.4-.3-.7-.3z'
  }));
});
Folder16.displayName = 'Folder16';
Folder16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Folder16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forum16 = React.forwardRef(function (_ref54, ref) {
  var className = _ref54.className,
      children = _ref54.children,
      style = _ref54.style,
      tabIndex = _ref54.tabIndex,
      rest = _objectWithoutProperties$2(_ref54, ["className", "children", "style", "tabIndex"]);

  var _getAttributes54 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes54.tabindex,
      props = _objectWithoutProperties$2(_getAttributes54, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 9H1V2.5C1 1.7 1.7 1 2.5 1H9v1H2v7z'
  }), React.createElement('path', {
    d: 'M14 3H4c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1h4v-1H4V4h10v7h-3.6L8 14.4l.8.6 2.1-3H14c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1z'
  }));
});
Forum16.displayName = 'Forum16';
Forum16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forum16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Grid16 = React.forwardRef(function (_ref55, ref) {
  var className = _ref55.className,
      children = _ref55.children,
      style = _ref55.style,
      tabIndex = _ref55.tabIndex,
      rest = _objectWithoutProperties$2(_ref55, ["className", "children", "style", "tabIndex"]);

  var _getAttributes55 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes55.tabindex,
      props = _objectWithoutProperties$2(_getAttributes55, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 2H3c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm0 4H3V3h3v3zm7-4h-3c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm0 4h-3V3h3v3zM6 9H3c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h3c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1zm0 4H3v-3h3v3zm7-4h-3c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h3c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1zm0 4h-3v-3h3v3z'
  }));
});
Grid16.displayName = 'Grid16';
Grid16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Grid16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var HelpFilled16 = React.forwardRef(function (_ref56, ref) {
  var className = _ref56.className,
      children = _ref56.children,
      style = _ref56.style,
      tabIndex = _ref56.tabIndex,
      rest = _objectWithoutProperties$2(_ref56, ["className", "children", "style", "tabIndex"]);

  var _getAttributes56 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes56.tabindex,
      props = _objectWithoutProperties$2(_getAttributes56, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 11.5c-.4 0-.8-.3-.8-.8s.4-.7.8-.7.8.3.8.8-.4.7-.8.7zm.6-3.9v1.2H7.4V7.5h1.1c.7 0 1.2-.6 1.1-1.3 0-.6-.5-1.1-1.1-1.1h-.7c-.7 0-1.2.5-1.2 1.2v.3H5.4v-.3C5.4 5 6.5 4 7.8 4h.7c1.3 0 2.3 1.1 2.2 2.4 0 1.2-.9 2.2-2.1 2.2z'
  }));
});
HelpFilled16.displayName = 'HelpFilled16';
HelpFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
HelpFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Help16 = React.forwardRef(function (_ref57, ref) {
  var className = _ref57.className,
      children = _ref57.children,
      style = _ref57.style,
      tabIndex = _ref57.tabIndex,
      rest = _objectWithoutProperties$2(_ref57, ["className", "children", "style", "tabIndex"]);

  var _getAttributes57 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes57.tabindex,
      props = _objectWithoutProperties$2(_getAttributes57, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 13c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z'
  }), React.createElement('circle', {
    cx: '8',
    cy: '11.8',
    r: '.8'
  }), React.createElement('path', {
    d: 'M8.5 4h-.7C6.5 4 5.5 5 5.5 6.2v.2h1v-.2c0-.6.6-1.2 1.3-1.2h.8c.7 0 1.2.6 1.2 1.2s-.6 1.3-1.3 1.3h-1v2.2h1V8.5c1.2 0 2.2-1 2.2-2.2S9.7 4 8.5 4z'
  }));
});
Help16.displayName = 'Help16';
Help16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Help16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var InformationFilled16 = React.forwardRef(function (_ref58, ref) {
  var className = _ref58.className,
      children = _ref58.children,
      style = _ref58.style,
      tabIndex = _ref58.tabIndex,
      rest = _objectWithoutProperties$2(_ref58, ["className", "children", "style", "tabIndex"]);

  var _getAttributes58 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes58.tabindex,
      props = _objectWithoutProperties$2(_getAttributes58, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 2.5c.4 0 .8.3.8.8S8.4 5 8 5s-.8-.3-.8-.8.4-.7.8-.7zm2 8.6H6V11h1.4V7.6h-.9V6.4h2.1v4.5H10v1.2z'
  }));
});
InformationFilled16.displayName = 'InformationFilled16';
InformationFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
InformationFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Information16 = React.forwardRef(function (_ref59, ref) {
  var className = _ref59.className,
      children = _ref59.children,
      style = _ref59.style,
      tabIndex = _ref59.tabIndex,
      rest = _objectWithoutProperties$2(_ref59, ["className", "children", "style", "tabIndex"]);

  var _getAttributes59 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes59.tabindex,
      props = _objectWithoutProperties$2(_getAttributes59, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.5 11V6.5h-2v1h1V11H6v1h4v-1zM8 3.5c-.4 0-.8.3-.8.8s.4.7.8.7.8-.3.8-.8-.4-.7-.8-.7z'
  }), React.createElement('path', {
    d: 'M8 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z'
  }));
});
Information16.displayName = 'Information16';
Information16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Information16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Launch16 = React.forwardRef(function (_ref60, ref) {
  var className = _ref60.className,
      children = _ref60.children,
      style = _ref60.style,
      tabIndex = _ref60.tabIndex,
      rest = _objectWithoutProperties$2(_ref60, ["className", "children", "style", "tabIndex"]);

  var _getAttributes60 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes60.tabindex,
      props = _objectWithoutProperties$2(_getAttributes60, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 14H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h5v1H3v10h10V8h1v5c0 .6-.4 1-1 1z'
  }), React.createElement('path', {
    d: 'M10 1v1h3.3L9 6.3l.7.7L14 2.7V6h1V1z'
  }));
});
Launch16.displayName = 'Launch16';
Launch16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Launch16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListBulleted16 = React.forwardRef(function (_ref61, ref) {
  var className = _ref61.className,
      children = _ref61.children,
      style = _ref61.style,
      tabIndex = _ref61.tabIndex,
      rest = _objectWithoutProperties$2(_ref61, ["className", "children", "style", "tabIndex"]);

  var _getAttributes61 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes61.tabindex,
      props = _objectWithoutProperties$2(_getAttributes61, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '3.5',
    cy: '4.5',
    r: '1.5'
  }), React.createElement('circle', {
    cx: '3.5',
    cy: '11.5',
    r: '1.5'
  }), React.createElement('path', {
    d: 'M8 11h7v1H8zm0-7h7v1H8z'
  }));
});
ListBulleted16.displayName = 'ListBulleted16';
ListBulleted16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListBulleted16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Locked16 = React.forwardRef(function (_ref62, ref) {
  var className = _ref62.className,
      children = _ref62.children,
      style = _ref62.style,
      tabIndex = _ref62.tabIndex,
      rest = _objectWithoutProperties$2(_ref62, ["className", "children", "style", "tabIndex"]);

  var _getAttributes62 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes62.tabindex,
      props = _objectWithoutProperties$2(_getAttributes62, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 7h-1V4c0-1.7-1.3-3-3-3S5 2.3 5 4v3H4c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1zM6 4c0-1.1.9-2 2-2s2 .9 2 2v3H6V4zm6 10H4V8h8v6z'
  }));
});
Locked16.displayName = 'Locked16';
Locked16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Locked16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Maximize16 = React.forwardRef(function (_ref63, ref) {
  var className = _ref63.className,
      children = _ref63.children,
      style = _ref63.style,
      tabIndex = _ref63.tabIndex,
      rest = _objectWithoutProperties$2(_ref63, ["className", "children", "style", "tabIndex"]);

  var _getAttributes63 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes63.tabindex,
      props = _objectWithoutProperties$2(_getAttributes63, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 1v1h3.3L8.5 6.8l.7.7L14 2.7V6h1V1zM7.5 9.2l-.7-.7L2 13.3V10H1v5h5v-1H2.7z'
  }));
});
Maximize16.displayName = 'Maximize16';
Maximize16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Maximize16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Menu16 = React.forwardRef(function (_ref64, ref) {
  var className = _ref64.className,
      children = _ref64.children,
      style = _ref64.style,
      tabIndex = _ref64.tabIndex,
      rest = _objectWithoutProperties$2(_ref64, ["className", "children", "style", "tabIndex"]);

  var _getAttributes64 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes64.tabindex,
      props = _objectWithoutProperties$2(_getAttributes64, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 12h12v1H2zm0-3h12v1H2zm0-3h12v1H2zm0-3h12v1H2z'
  }));
});
Menu16.displayName = 'Menu16';
Menu16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Menu16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Minimize16 = React.forwardRef(function (_ref65, ref) {
  var className = _ref65.className,
      children = _ref65.children,
      style = _ref65.style,
      tabIndex = _ref65.tabIndex,
      rest = _objectWithoutProperties$2(_ref65, ["className", "children", "style", "tabIndex"]);

  var _getAttributes65 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes65.tabindex,
      props = _objectWithoutProperties$2(_getAttributes65, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 9v1h2.3L1 14.3l.7.7L6 10.7V13h1V9zm10-2V6h-2.3L15 1.7l-.7-.7L10 5.3V3H9v4z'
  }));
});
Minimize16.displayName = 'Minimize16';
Minimize16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Minimize16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MisuseOutline16 = React.forwardRef(function (_ref66, ref) {
  var className = _ref66.className,
      children = _ref66.children,
      style = _ref66.style,
      tabIndex = _ref66.tabIndex,
      rest = _objectWithoutProperties$2(_ref66, ["className", "children", "style", "tabIndex"]);

  var _getAttributes66 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes66.tabindex,
      props = _objectWithoutProperties$2(_getAttributes66, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 13c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z'
  }), React.createElement('path', {
    d: 'M10.7 11.5L8 8.8l-2.7 2.7-.8-.8L7.2 8 4.5 5.3l.8-.8L8 7.2l2.7-2.7.8.8L8.8 8l2.7 2.7z'
  }));
});
MisuseOutline16.displayName = 'MisuseOutline16';
MisuseOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MisuseOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Misuse16 = React.forwardRef(function (_ref67, ref) {
  var className = _ref67.className,
      children = _ref67.children,
      style = _ref67.style,
      tabIndex = _ref67.tabIndex,
      rest = _objectWithoutProperties$2(_ref67, ["className", "children", "style", "tabIndex"]);

  var _getAttributes67 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes67.tabindex,
      props = _objectWithoutProperties$2(_getAttributes67, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm2.7 10.5L8 8.8l-2.7 2.7-.8-.8L7.2 8 4.5 5.3l.8-.8L8 7.2l2.7-2.7.8.8L8.8 8l2.7 2.7-.8.8z'
  }));
});
Misuse16.displayName = 'Misuse16';
Misuse16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Misuse16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NewTab16 = React.forwardRef(function (_ref68, ref) {
  var className = _ref68.className,
      children = _ref68.children,
      style = _ref68.style,
      tabIndex = _ref68.tabIndex,
      rest = _objectWithoutProperties$2(_ref68, ["className", "children", "style", "tabIndex"]);

  var _getAttributes68 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes68.tabindex,
      props = _objectWithoutProperties$2(_getAttributes68, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 13H3V3h5V2H3c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V8h-1v5z'
  }), React.createElement('path', {
    d: 'M13 3V1h-1v2h-2v1h2v2h1V4h2V3z'
  }));
});
NewTab16.displayName = 'NewTab16';
NewTab16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NewTab16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationOff16 = React.forwardRef(function (_ref69, ref) {
  var className = _ref69.className,
      children = _ref69.children,
      style = _ref69.style,
      tabIndex = _ref69.tabIndex,
      rest = _objectWithoutProperties$2(_ref69, ["className", "children", "style", "tabIndex"]);

  var _getAttributes69 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes69.tabindex,
      props = _objectWithoutProperties$2(_getAttributes69, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2.5 11.5v-.8l1.3-1.4c.1 0 .2-.2.2-.3V6.5c0-2.2 1.8-4 4-4 .9 0 1.8.3 2.5.9l.7-.7c-.7-.7-1.7-1.1-2.7-1.2v-1h-1v1C5 1.8 3 3.9 3 6.5v2.3l-1.4 1.3c-.1.1-.2.2-.1.4v1h1zM13 8.8V6.5c0-.8-.2-1.6-.5-2.2L15 1.7l-.7-.7L1 14.3l.7.7 2.5-2.5h1.3C5.5 13.9 6.6 15 8 15s2.5-1.1 2.5-2.5H14c.3 0 .5-.2.5-.4v-1.6c0-.1-.1-.3-.1-.4L13 8.8zM8 14c-.8 0-1.5-.7-1.5-1.5h3c0 .8-.7 1.5-1.5 1.5zm5.5-2.5H5.2L11.7 5c.2.5.3 1 .3 1.5V9c0 .1.1.3.1.4l1.4 1.3v.8z'
  }));
});
NotificationOff16.displayName = 'NotificationOff16';
NotificationOff16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationOff16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Notification16 = React.forwardRef(function (_ref70, ref) {
  var className = _ref70.className,
      children = _ref70.children,
      style = _ref70.style,
      tabIndex = _ref70.tabIndex,
      rest = _objectWithoutProperties$2(_ref70, ["className", "children", "style", "tabIndex"]);

  var _getAttributes70 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes70.tabindex,
      props = _objectWithoutProperties$2(_getAttributes70, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14.4 10.1L13 8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5 1.8 3 3.9 3 6.5v2.3l-1.4 1.3c-.1.1-.2.2-.1.4V12c0 .3.2.5.4.5h3.6C5.5 13.9 6.6 15 8 15s2.5-1.1 2.5-2.5H14c.3 0 .5-.2.5-.4v-1.6c0-.1-.1-.3-.1-.4zM8 14c-.8 0-1.5-.7-1.5-1.5h3c0 .8-.7 1.5-1.5 1.5zm5.5-2.5h-11v-.8l1.3-1.4c.1 0 .2-.2.2-.3V6.5c0-2.2 1.8-4 4-4s4 1.8 4 4V9c0 .1.1.3.1.4l1.4 1.3v.8z'
  }));
});
Notification16.displayName = 'Notification16';
Notification16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Notification16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuHorizontal16 = React.forwardRef(function (_ref71, ref) {
  var className = _ref71.className,
      children = _ref71.children,
      style = _ref71.style,
      tabIndex = _ref71.tabIndex,
      rest = _objectWithoutProperties$2(_ref71, ["className", "children", "style", "tabIndex"]);

  var _getAttributes71 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes71.tabindex,
      props = _objectWithoutProperties$2(_getAttributes71, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '3',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '8',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '13',
    cy: '8',
    r: '1'
  }));
});
OverflowMenuHorizontal16.displayName = 'OverflowMenuHorizontal16';
OverflowMenuHorizontal16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuHorizontal16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuVertical16 = React.forwardRef(function (_ref72, ref) {
  var className = _ref72.className,
      children = _ref72.children,
      style = _ref72.style,
      tabIndex = _ref72.tabIndex,
      rest = _objectWithoutProperties$2(_ref72, ["className", "children", "style", "tabIndex"]);

  var _getAttributes72 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes72.tabindex,
      props = _objectWithoutProperties$2(_getAttributes72, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '8',
    cy: '3',
    r: '1'
  }), React.createElement('circle', {
    cx: '8',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '8',
    cy: '13',
    r: '1'
  }));
});
OverflowMenuVertical16.displayName = 'OverflowMenuVertical16';
OverflowMenuVertical16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuVertical16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutlineFilled16 = React.forwardRef(function (_ref73, ref) {
  var className = _ref73.className,
      children = _ref73.children,
      style = _ref73.style,
      tabIndex = _ref73.tabIndex,
      rest = _objectWithoutProperties$2(_ref73, ["className", "children", "style", "tabIndex"]);

  var _getAttributes73 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes73.tabindex,
      props = _objectWithoutProperties$2(_getAttributes73, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zM7 11H6V5h1v6zm3 0H9V5h1v6z'
  }));
});
PauseOutlineFilled16.displayName = 'PauseOutlineFilled16';
PauseOutlineFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutlineFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutline16 = React.forwardRef(function (_ref74, ref) {
  var className = _ref74.className,
      children = _ref74.children,
      style = _ref74.style,
      tabIndex = _ref74.tabIndex,
      rest = _objectWithoutProperties$2(_ref74, ["className", "children", "style", "tabIndex"]);

  var _getAttributes74 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes74.tabindex,
      props = _objectWithoutProperties$2(_getAttributes74, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 5H6v6h1V5zm3 0H9v6h1V5z'
  }), React.createElement('path', {
    d: 'M8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6m0-1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z'
  }));
});
PauseOutline16.displayName = 'PauseOutline16';
PauseOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pause16 = React.forwardRef(function (_ref75, ref) {
  var className = _ref75.className,
      children = _ref75.children,
      style = _ref75.style,
      tabIndex = _ref75.tabIndex,
      rest = _objectWithoutProperties$2(_ref75, ["className", "children", "style", "tabIndex"]);

  var _getAttributes75 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes75.tabindex,
      props = _objectWithoutProperties$2(_getAttributes75, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 4v8H4V4h2m0-1H4c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm6 1v8h-2V4h2m0-1h-2c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1z'
  }));
});
Pause16.displayName = 'Pause16';
Pause16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pause16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayFilled16 = React.forwardRef(function (_ref76, ref) {
  var className = _ref76.className,
      children = _ref76.children,
      style = _ref76.style,
      tabIndex = _ref76.tabIndex,
      rest = _objectWithoutProperties$2(_ref76, ["className", "children", "style", "tabIndex"]);

  var _getAttributes76 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes76.tabindex,
      props = _objectWithoutProperties$2(_getAttributes76, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm3.7 7.4l-5.5 3c-.2.1-.3.1-.5 0s-.2-.3-.2-.4V5c0-.2.1-.3.2-.4.2-.1.3-.1.5 0l5.5 3c.3.1.4.4.2.6 0 .1-.1.2-.2.2z'
  }));
});
PlayFilled16.displayName = 'PlayFilled16';
PlayFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutlineFilled16 = React.forwardRef(function (_ref77, ref) {
  var className = _ref77.className,
      children = _ref77.children,
      style = _ref77.style,
      tabIndex = _ref77.tabIndex,
      rest = _objectWithoutProperties$2(_ref77, ["className", "children", "style", "tabIndex"]);

  var _getAttributes77 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes77.tabindex,
      props = _objectWithoutProperties$2(_getAttributes77, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm3.7 7.4l-5.5 3c-.2.1-.3.1-.5 0s-.2-.3-.2-.4V5c0-.2.1-.3.2-.4.2-.1.3-.1.5 0l5.5 3c.3.1.4.4.2.6 0 .1-.1.2-.2.2z'
  }), React.createElement('path', {
    d: 'M6.5 10.2l4-2.2-4-2.2z'
  }));
});
PlayOutlineFilled16.displayName = 'PlayOutlineFilled16';
PlayOutlineFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutlineFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutline16 = React.forwardRef(function (_ref78, ref) {
  var className = _ref78.className,
      children = _ref78.children,
      style = _ref78.style,
      tabIndex = _ref78.tabIndex,
      rest = _objectWithoutProperties$2(_ref78, ["className", "children", "style", "tabIndex"]);

  var _getAttributes78 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes78.tabindex,
      props = _objectWithoutProperties$2(_getAttributes78, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6m0-1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z'
  }), React.createElement('path', {
    d: 'M6 11.5c-.1 0-.2 0-.3-.1-.2-.1-.2-.3-.2-.4V5c0-.2.1-.3.2-.4.2-.1.3-.1.5 0l5.5 3c.3.1.4.4.2.6 0 .1-.1.2-.2.2l-5.5 3c0 .1-.1.1-.2.1zm.5-5.7v4.3l4-2.2-4-2.1z'
  }));
});
PlayOutline16.displayName = 'PlayOutline16';
PlayOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Play16 = React.forwardRef(function (_ref79, ref) {
  var className = _ref79.className,
      children = _ref79.children,
      style = _ref79.style,
      tabIndex = _ref79.tabIndex,
      rest = _objectWithoutProperties$2(_ref79, ["className", "children", "style", "tabIndex"]);

  var _getAttributes79 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes79.tabindex,
      props = _objectWithoutProperties$2(_getAttributes79, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3.5 14c-.3 0-.5-.2-.5-.5v-11c0-.2.1-.3.2-.4.2-.1.4-.1.6 0l9.5 5.5c.2.1.3.4.2.7 0 .1-.1.1-.2.2L3.8 14h-.3zM4 3.4v9.3L12 8 4 3.4z'
  }));
});
Play16.displayName = 'Play16';
Play16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Play16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Power16 = React.forwardRef(function (_ref80, ref) {
  var className = _ref80.className,
      children = _ref80.children,
      style = _ref80.style,
      tabIndex = _ref80.tabIndex,
      rest = _objectWithoutProperties$2(_ref80, ["className", "children", "style", "tabIndex"]);

  var _getAttributes80 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes80.tabindex,
      props = _objectWithoutProperties$2(_getAttributes80, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.2 2.9l-.5.9c2.6 1.5 3.5 4.9 2 7.5s-4.9 3.5-7.5 2-3.5-4.9-2-7.5c.5-.8 1.2-1.5 2-2l-.4-.9C1.7 4.7.6 8.7 2.4 11.8s5.8 4.2 8.9 2.4 4.2-5.8 2.4-8.9c-.6-1-1.5-1.9-2.5-2.4z'
  }), React.createElement('path', {
    d: 'M7.5 1h1v7h-1z'
  }));
});
Power16.displayName = 'Power16';
Power16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Power16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Restart16 = React.forwardRef(function (_ref81, ref) {
  var className = _ref81.className,
      children = _ref81.children,
      style = _ref81.style,
      tabIndex = _ref81.tabIndex,
      rest = _objectWithoutProperties$2(_ref81, ["className", "children", "style", "tabIndex"]);

  var _getAttributes81 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes81.tabindex,
      props = _objectWithoutProperties$2(_getAttributes81, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 9c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5h3.1L9.3 5.8l.7.7 3-3-3-3-.7.7L11.1 3H8C4.7 3 2 5.7 2 9s2.7 6 6 6 6-2.7 6-6h-1z'
  }));
});
Restart16.displayName = 'Restart16';
Restart16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Restart16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Save16 = React.forwardRef(function (_ref82, ref) {
  var className = _ref82.className,
      children = _ref82.children,
      style = _ref82.style,
      tabIndex = _ref82.tabIndex,
      rest = _objectWithoutProperties$2(_ref82, ["className", "children", "style", "tabIndex"]);

  var _getAttributes82 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes82.tabindex,
      props = _objectWithoutProperties$2(_getAttributes82, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.9 4.6l-2.5-2.5c-.1 0-.3-.1-.4-.1H3c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V5c0-.1-.1-.3-.1-.4zM6 3h4v2H6V3zm4 10H6V9h4v4zm1 0V9c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1v4H3V3h2v2c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V3.2l2 2V13h-2z'
  }));
});
Save16.displayName = 'Save16';
Save16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Save16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Search16 = React.forwardRef(function (_ref83, ref) {
  var className = _ref83.className,
      children = _ref83.children,
      style = _ref83.style,
      tabIndex = _ref83.tabIndex,
      rest = _objectWithoutProperties$2(_ref83, ["className", "children", "style", "tabIndex"]);

  var _getAttributes83 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes83.tabindex,
      props = _objectWithoutProperties$2(_getAttributes83, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 14.3L10.7 10c1.9-2.3 1.6-5.8-.7-7.7S4.2.7 2.3 3 .7 8.8 3 10.7c2 1.7 5 1.7 7 0l4.3 4.3.7-.7zM2 6.5C2 4 4 2 6.5 2S11 4 11 6.5 9 11 6.5 11 2 9 2 6.5z'
  }));
});
Search16.displayName = 'Search16';
Search16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Search16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Settings16 = React.forwardRef(function (_ref84, ref) {
  var className = _ref84.className,
      children = _ref84.children,
      style = _ref84.style,
      tabIndex = _ref84.tabIndex,
      rest = _objectWithoutProperties$2(_ref84, ["className", "children", "style", "tabIndex"]);

  var _getAttributes84 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes84.tabindex,
      props = _objectWithoutProperties$2(_getAttributes84, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.5 8.4v-.8l1-.8c.4-.3.4-.9.2-1.3l-1.2-2c-.2-.3-.5-.5-.9-.5-.1 0-.2 0-.3.1l-1.2.4c-.2-.1-.4-.3-.7-.4l-.3-1.3c0-.5-.4-.8-.9-.8H6.8c-.5 0-.9.3-1 .8l-.2 1.3c-.3.1-.5.2-.7.3L3.7 3h-.3c-.4 0-.7.2-.9.5l-1.2 2c-.2.4-.1.9.3 1.3l.9.9v.8l-.9.7c-.4.3-.5.9-.2 1.3l1.2 2c.1.3.4.5.8.5.1 0 .2 0 .3-.1l1.2-.4c.2.1.4.3.7.4l.3 1.3c.1.5.5.8 1 .8h2.4c.5 0 .9-.3 1-.8l.3-1.3c.2-.1.4-.2.7-.4l1.2.4c.1 0 .2.1.3.1.4 0 .7-.2.9-.5l1.1-2c.2-.4.2-.9-.2-1.3l-1.1-.8zm-.9 3.6l-1.7-.6c-.4.3-.9.6-1.4.8L9.2 14H6.8l-.4-1.8c-.5-.2-.9-.5-1.4-.8l-1.6.6-1.2-2 1.4-1.2c-.1-.5-.1-1.1 0-1.6L2.2 6l1.2-2 1.7.6c.4-.4.9-.6 1.4-.8L6.8 2h2.4l.4 1.8c.5.2.9.5 1.4.8l1.6-.6 1.2 2-1.4 1.2c.1.5.1 1.1 0 1.6l1.4 1.2-1.2 2z'
  }), React.createElement('path', {
    d: 'M8 11c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3c0 1.6-1.3 3-3 3zm0-5c-1.1 0-2 .8-2 1.9V8c0 1.1.8 2 1.9 2H8c1.1 0 2-.8 2-1.9V8c0-1.1-.8-2-2-2 .1 0 0 0 0 0z'
  }));
});
Settings16.displayName = 'Settings16';
Settings16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Settings16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarFilled16 = React.forwardRef(function (_ref85, ref) {
  var className = _ref85.className,
      children = _ref85.children,
      style = _ref85.style,
      tabIndex = _ref85.tabIndex,
      rest = _objectWithoutProperties$2(_ref85, ["className", "children", "style", "tabIndex"]);

  var _getAttributes85 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes85.tabindex,
      props = _objectWithoutProperties$2(_getAttributes85, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1L5.7 5.6l-5.1.7 3.7 3.6-.8 5.1L8 12.6l4.6 2.4-.9-5.1 3.7-3.6-5.1-.7L8 1z'
  }));
});
StarFilled16.displayName = 'StarFilled16';
StarFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarHalf16 = React.forwardRef(function (_ref86, ref) {
  var className = _ref86.className,
      children = _ref86.children,
      style = _ref86.style,
      tabIndex = _ref86.tabIndex,
      rest = _objectWithoutProperties$2(_ref86, ["className", "children", "style", "tabIndex"]);

  var _getAttributes86 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes86.tabindex,
      props = _objectWithoutProperties$2(_getAttributes86, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5.7 5.6l-5.1.7 3.7 3.6-.8 5.1L8 12.6V1z'
  }));
});
StarHalf16.displayName = 'StarHalf16';
StarHalf16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarHalf16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Star16 = React.forwardRef(function (_ref87, ref) {
  var className = _ref87.className,
      children = _ref87.children,
      style = _ref87.style,
      tabIndex = _ref87.tabIndex,
      rest = _objectWithoutProperties$2(_ref87, ["className", "children", "style", "tabIndex"]);

  var _getAttributes87 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes87.tabindex,
      props = _objectWithoutProperties$2(_getAttributes87, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 3.3l1.4 2.8.2.5.5.1 3.1.4L11 9.2l-.4.4.1.5.5 3.1-2.8-1.4-.4-.3-.5.2-2.8 1.4.5-3.1.1-.5-.3-.3L2.8 7l3.1-.4.5-.1.2-.5L8 3.3M8 1L5.7 5.6l-5.1.7 3.7 3.6-.8 5.1L8 12.6l4.6 2.4-.9-5.1 3.7-3.6-5.1-.7L8 1z'
  }));
});
Star16.displayName = 'Star16';
Star16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Star16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopFilled16 = React.forwardRef(function (_ref88, ref) {
  var className = _ref88.className,
      children = _ref88.children,
      style = _ref88.style,
      tabIndex = _ref88.tabIndex,
      rest = _objectWithoutProperties$2(_ref88, ["className", "children", "style", "tabIndex"]);

  var _getAttributes88 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes88.tabindex,
      props = _objectWithoutProperties$2(_getAttributes88, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm3 9c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v4z'
  }));
});
StopFilled16.displayName = 'StopFilled16';
StopFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutlineFilled16 = React.forwardRef(function (_ref89, ref) {
  var className = _ref89.className,
      children = _ref89.children,
      style = _ref89.style,
      tabIndex = _ref89.tabIndex,
      rest = _objectWithoutProperties$2(_ref89, ["className", "children", "style", "tabIndex"]);

  var _getAttributes89 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes89.tabindex,
      props = _objectWithoutProperties$2(_getAttributes89, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm3 9c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v4z'
  }), React.createElement('path', {
    d: 'M6 6h4v4H6z'
  }));
});
StopOutlineFilled16.displayName = 'StopOutlineFilled16';
StopOutlineFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutlineFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutline16 = React.forwardRef(function (_ref90, ref) {
  var className = _ref90.className,
      children = _ref90.children,
      style = _ref90.style,
      tabIndex = _ref90.tabIndex,
      rest = _objectWithoutProperties$2(_ref90, ["className", "children", "style", "tabIndex"]);

  var _getAttributes90 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes90.tabindex,
      props = _objectWithoutProperties$2(_getAttributes90, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6m0-1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z'
  }), React.createElement('path', {
    d: 'M10 6v4H6V6h4m0-1H6c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1z'
  }));
});
StopOutline16.displayName = 'StopOutline16';
StopOutline16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutline16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Stop16 = React.forwardRef(function (_ref91, ref) {
  var className = _ref91.className,
      children = _ref91.children,
      style = _ref91.style,
      tabIndex = _ref91.tabIndex,
      rest = _objectWithoutProperties$2(_ref91, ["className", "children", "style", "tabIndex"]);

  var _getAttributes91 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes91.tabindex,
      props = _objectWithoutProperties$2(_getAttributes91, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4v8H4V4h8m0-1H4c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1z'
  }));
});
Stop16.displayName = 'Stop16';
Stop16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Stop16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SubtractAlt16 = React.forwardRef(function (_ref92, ref) {
  var className = _ref92.className,
      children = _ref92.children,
      style = _ref92.style,
      tabIndex = _ref92.tabIndex,
      rest = _objectWithoutProperties$2(_ref92, ["className", "children", "style", "tabIndex"]);

  var _getAttributes92 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes92.tabindex,
      props = _objectWithoutProperties$2(_getAttributes92, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6m0-1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z'
  }), React.createElement('path', {
    d: 'M5 7.5h6v1H5z'
  }));
});
SubtractAlt16.displayName = 'SubtractAlt16';
SubtractAlt16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SubtractAlt16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Subtract16 = React.forwardRef(function (_ref93, ref) {
  var className = _ref93.className,
      children = _ref93.children,
      style = _ref93.style,
      tabIndex = _ref93.tabIndex,
      rest = _objectWithoutProperties$2(_ref93, ["className", "children", "style", "tabIndex"]);

  var _getAttributes93 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes93.tabindex,
      props = _objectWithoutProperties$2(_getAttributes93, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 7.5h8v1H4z'
  }));
});
Subtract16.displayName = 'Subtract16';
Subtract16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Subtract16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TrashCan16 = React.forwardRef(function (_ref94, ref) {
  var className = _ref94.className,
      children = _ref94.children,
      style = _ref94.style,
      tabIndex = _ref94.tabIndex,
      rest = _objectWithoutProperties$2(_ref94, ["className", "children", "style", "tabIndex"]);

  var _getAttributes94 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes94.tabindex,
      props = _objectWithoutProperties$2(_getAttributes94, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h1v6H6zm3 0h1v6H9z'
  }), React.createElement('path', {
    d: 'M2 3v1h1v10c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4h1V3H2zm2 11V4h8v10H4zM6 1h4v1H6z'
  }));
});
TrashCan16.displayName = 'TrashCan16';
TrashCan16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TrashCan16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Unlocked16 = React.forwardRef(function (_ref95, ref) {
  var className = _ref95.className,
      children = _ref95.children,
      style = _ref95.style,
      tabIndex = _ref95.tabIndex,
      rest = _objectWithoutProperties$2(_ref95, ["className", "children", "style", "tabIndex"]);

  var _getAttributes95 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes95.tabindex,
      props = _objectWithoutProperties$2(_getAttributes95, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 7H6V4c0-1.1.9-2 2-2s2 .9 2 2h1c0-1.7-1.3-3-3-3S5 2.3 5 4v3H4c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1zm0 7H4V8h8v6z'
  }));
});
Unlocked16.displayName = 'Unlocked16';
Unlocked16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Unlocked16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UpToTop16 = React.forwardRef(function (_ref96, ref) {
  var className = _ref96.className,
      children = _ref96.children,
      style = _ref96.style,
      tabIndex = _ref96.tabIndex,
      rest = _objectWithoutProperties$2(_ref96, ["className", "children", "style", "tabIndex"]);

  var _getAttributes96 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes96.tabindex,
      props = _objectWithoutProperties$2(_getAttributes96, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 6l-5 5 .7.7L8 7.4l4.3 4.3.7-.7zM2 3h12v1H2z'
  }));
});
UpToTop16.displayName = 'UpToTop16';
UpToTop16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UpToTop16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Upload16 = React.forwardRef(function (_ref97, ref) {
  var className = _ref97.className,
      children = _ref97.children,
      style = _ref97.style,
      tabIndex = _ref97.tabIndex,
      rest = _objectWithoutProperties$2(_ref97, ["className", "children", "style", "tabIndex"]);

  var _getAttributes97 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes97.tabindex,
      props = _objectWithoutProperties$2(_getAttributes97, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 9l.7.7 3.8-3.8V15h1V5.9l3.8 3.8.7-.7-5-5zm0-5V2h10v2h1V2c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v2h1z'
  }));
});
Upload16.displayName = 'Upload16';
Upload16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Upload16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAvatar16 = React.forwardRef(function (_ref98, ref) {
  var className = _ref98.className,
      children = _ref98.children,
      style = _ref98.style,
      tabIndex = _ref98.tabIndex,
      rest = _objectWithoutProperties$2(_ref98, ["className", "children", "style", "tabIndex"]);

  var _getAttributes98 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes98.tabindex,
      props = _objectWithoutProperties$2(_getAttributes98, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zM5 13.2v-1.5c0-.9.6-1.6 1.5-1.7h3c.9.1 1.5.8 1.5 1.7v1.5c-1.9 1.1-4.1 1.1-6 0zm7-1.2v-.8c0-.9-1.1-2.1-2.5-2.2h-3C5.1 9.1 4 10.3 4 11.7v.8c-2.5-2.2-2.7-6-.5-8.5s6-2.7 8.5-.5 2.7 6 .5 8.5c-.1.2-.3.3-.5.5V12z'
  }), React.createElement('path', {
    d: 'M8 3C6.6 3 5.5 4.1 5.5 5.5S6.6 8 8 8s2.5-1.1 2.5-2.5S9.4 3 8 3zm0 4c-.8 0-1.5-.7-1.5-1.5S7.2 4 8 4s1.5.7 1.5 1.5S8.8 7 8 7z'
  }));
});
UserAvatar16.displayName = 'UserAvatar16';
UserAvatar16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAvatar16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var User16 = React.forwardRef(function (_ref99, ref) {
  var className = _ref99.className,
      children = _ref99.children,
      style = _ref99.style,
      tabIndex = _ref99.tabIndex,
      rest = _objectWithoutProperties$2(_ref99, ["className", "children", "style", "tabIndex"]);

  var _getAttributes99 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes99.tabindex,
      props = _objectWithoutProperties$2(_getAttributes99, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 2c1.4 0 2.5 1.1 2.5 2.5S9.4 7 8 7 5.5 5.9 5.5 4.5 6.6 2 8 2m0-1C6.1 1 4.5 2.6 4.5 4.5S6.1 8 8 8s3.5-1.6 3.5-3.5S9.9 1 8 1zm5 14h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1 10 4 11.1 4 12.5V15H3v-2.5C3 10.6 4.6 9 6.5 9h3c1.9 0 3.5 1.6 3.5 3.5V15z'
  }));
});
User16.displayName = 'User16';
User16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
User16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewOff16 = React.forwardRef(function (_ref100, ref) {
  var className = _ref100.className,
      children = _ref100.children,
      style = _ref100.style,
      tabIndex = _ref100.tabIndex,
      rest = _objectWithoutProperties$2(_ref100, ["className", "children", "style", "tabIndex"]);

  var _getAttributes100 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes100.tabindex,
      props = _objectWithoutProperties$2(_getAttributes100, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2.6 11.3l.7-.7C2.6 9.8 1.9 9 1.5 8c1-2.5 3.8-4.5 6.5-4.5.7 0 1.4.1 2 .4l.8-.8C9.9 2.7 9 2.5 8 2.5 4.7 2.6 1.7 4.7.5 7.8v.3c.5 1.2 1.2 2.3 2.1 3.2z'
  }), React.createElement('path', {
    d: 'M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9c-1.5-.5-3.2.4-3.6 2-.1.5-.1 1.1 0 1.6l.9-.9zm9.5-.1c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7l-.7-.7L1 14.3l.7.7 2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3v-.4zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7c.2.3.3.6.3 1zm-2 4.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2-1.1 2.5-3.9 4.5-6.5 4.5z'
  }));
});
ViewOff16.displayName = 'ViewOff16';
ViewOff16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewOff16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var View16 = React.forwardRef(function (_ref101, ref) {
  var className = _ref101.className,
      children = _ref101.children,
      style = _ref101.style,
      tabIndex = _ref101.tabIndex,
      rest = _objectWithoutProperties$2(_ref101, ["className", "children", "style", "tabIndex"]);

  var _getAttributes101 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes101.tabindex,
      props = _objectWithoutProperties$2(_getAttributes101, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15.5 7.8C14.3 4.7 11.3 2.6 8 2.5 4.7 2.6 1.7 4.7.5 7.8v.3c1.2 3.1 4.1 5.2 7.5 5.3 3.3-.1 6.3-2.2 7.5-5.3v-.3zM8 12.5c-2.7 0-5.4-2-6.5-4.5 1-2.5 3.8-4.5 6.5-4.5s5.4 2 6.5 4.5c-1.1 2.5-3.9 4.5-6.5 4.5z'
  }), React.createElement('path', {
    d: 'M8 5C6.3 5 5 6.3 5 8s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
  }));
});
View16.displayName = 'View16';
View16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
View16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAltFilled16 = React.forwardRef(function (_ref102, ref) {
  var className = _ref102.className,
      children = _ref102.children,
      style = _ref102.style,
      tabIndex = _ref102.tabIndex,
      rest = _objectWithoutProperties$2(_ref102, ["className", "children", "style", "tabIndex"]);

  var _getAttributes102 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes102.tabindex,
      props = _objectWithoutProperties$2(_getAttributes102, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14.9 13.3l-6.5-12c-.1-.3-.4-.4-.6-.2-.1 0-.2.1-.2.2l-6.5 12c-.1.2-.1.3 0 .5.1.1.2.2.4.2h13c.2 0 .3-.1.4-.2.1-.2.1-.4 0-.5zM7.4 5.5h1.1v4H7.4v-4zm.6 6.7c-.4 0-.8-.3-.8-.8s.3-.8.8-.8c.4 0 .8.3.8.8s-.4.8-.8.8z'
  }));
});
WarningAltFilled16.displayName = 'WarningAltFilled16';
WarningAltFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAltFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAlt16 = React.forwardRef(function (_ref103, ref) {
  var className = _ref103.className,
      children = _ref103.children,
      style = _ref103.style,
      tabIndex = _ref103.tabIndex,
      rest = _objectWithoutProperties$2(_ref103, ["className", "children", "style", "tabIndex"]);

  var _getAttributes103 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes103.tabindex,
      props = _objectWithoutProperties$2(_getAttributes103, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14.5 14h-13c-.2 0-.3-.1-.4-.2-.1-.2-.1-.3 0-.5l6.5-12c.1-.3.4-.4.6-.2.1 0 .2.1.2.2l6.5 12c.1.2.1.3 0 .5 0 .1-.2.2-.4.2zM2.3 13h11.3L8 2.5 2.3 13z'
  }), React.createElement('path', {
    d: 'M7.5 6h1v3.5h-1zm.5 4.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z'
  }));
});
WarningAlt16.displayName = 'WarningAlt16';
WarningAlt16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAlt16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningFilled16 = React.forwardRef(function (_ref104, ref) {
  var className = _ref104.className,
      children = _ref104.children,
      style = _ref104.style,
      tabIndex = _ref104.tabIndex,
      rest = _objectWithoutProperties$2(_ref104, ["className", "children", "style", "tabIndex"]);

  var _getAttributes104 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes104.tabindex,
      props = _objectWithoutProperties$2(_getAttributes104, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm-.5 3h1v5h-1V4zm.5 8c-.6 0-1-.4-1-1s.5-1 1-1 1 .4 1 1-.5 1-1 1z'
  }));
});
WarningFilled16.displayName = 'WarningFilled16';
WarningFilled16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningFilled16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Warning16 = React.forwardRef(function (_ref105, ref) {
  var className = _ref105.className,
      children = _ref105.children,
      style = _ref105.style,
      tabIndex = _ref105.tabIndex,
      rest = _objectWithoutProperties$2(_ref105, ["className", "children", "style", "tabIndex"]);

  var _getAttributes105 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes105.tabindex,
      props = _objectWithoutProperties$2(_getAttributes105, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 13c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z'
  }), React.createElement('path', {
    d: 'M7.5 4h1v5h-1zm.5 6.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z'
  }));
});
Warning16.displayName = 'Warning16';
Warning16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Warning16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomIn16 = React.forwardRef(function (_ref106, ref) {
  var className = _ref106.className,
      children = _ref106.children,
      style = _ref106.style,
      tabIndex = _ref106.tabIndex,
      rest = _objectWithoutProperties$2(_ref106, ["className", "children", "style", "tabIndex"]);

  var _getAttributes106 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes106.tabindex,
      props = _objectWithoutProperties$2(_getAttributes106, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 6H7V4H6v2H4v1h2v2h1V7h2z'
  }), React.createElement('path', {
    d: 'M10.7 10c.8-1 1.3-2.2 1.3-3.5C12 3.5 9.5 1 6.5 1S1 3.5 1 6.5 3.5 12 6.5 12c1.3 0 2.5-.5 3.5-1.3l3.8 3.8.7-.7-3.8-3.8zm-4.2 1C4 11 2 9 2 6.5S4 2 6.5 2 11 4 11 6.5 9 11 6.5 11z'
  }));
});
ZoomIn16.displayName = 'ZoomIn16';
ZoomIn16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomIn16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomOut16 = React.forwardRef(function (_ref107, ref) {
  var className = _ref107.className,
      children = _ref107.children,
      style = _ref107.style,
      tabIndex = _ref107.tabIndex,
      rest = _objectWithoutProperties$2(_ref107, ["className", "children", "style", "tabIndex"]);

  var _getAttributes107 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes107.tabindex,
      props = _objectWithoutProperties$2(_getAttributes107, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h5v1H4z'
  }), React.createElement('path', {
    d: 'M10.7 10c.8-1 1.3-2.2 1.3-3.5C12 3.5 9.5 1 6.5 1S1 3.5 1 6.5 3.5 12 6.5 12c1.3 0 2.5-.5 3.5-1.3l3.8 3.8.7-.7-3.8-3.8zm-4.2 1C4 11 2 9 2 6.5S4 2 6.5 2 11 4 11 6.5 9 11 6.5 11z'
  }));
});
ZoomOut16.displayName = 'ZoomOut16';
ZoomOut16.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomOut16.defaultProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Menu20 = React.forwardRef(function (_ref108, ref) {
  var className = _ref108.className,
      children = _ref108.children,
      style = _ref108.style,
      tabIndex = _ref108.tabIndex,
      rest = _objectWithoutProperties$2(_ref108, ["className", "children", "style", "tabIndex"]);

  var _getAttributes108 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes108.tabindex,
      props = _objectWithoutProperties$2(_getAttributes108, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 15h16v1.2H2zm0-3.8h16v1.2H2zm0-3.7h16v1.2H2zm0-3.7h16V5H2z'
  }));
});
Menu20.displayName = 'Menu20';
Menu20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Menu20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 20 20',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Menu24 = React.forwardRef(function (_ref109, ref) {
  var className = _ref109.className,
      children = _ref109.children,
      style = _ref109.style,
      tabIndex = _ref109.tabIndex,
      rest = _objectWithoutProperties$2(_ref109, ["className", "children", "style", "tabIndex"]);

  var _getAttributes109 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes109.tabindex,
      props = _objectWithoutProperties$2(_getAttributes109, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 18h18v1.5H3zm0-4.5h18V15H3zM3 9h18v1.5H3zm0-4.5h18V6H3z'
  }));
});
Menu24.displayName = 'Menu24';
Menu24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Menu24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};

var _4KFilled32 = React.forwardRef(function (_ref110, ref) {
  var className = _ref110.className,
      children = _ref110.children,
      style = _ref110.style,
      tabIndex = _ref110.tabIndex,
      rest = _objectWithoutProperties$2(_ref110, ["className", "children", "style", "tabIndex"]);

  var _getAttributes110 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes110.tabindex,
      props = _objectWithoutProperties$2(_getAttributes110, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM14 21h-2v-4H8v-6h2v4h2v-4h2zm10.19 0H22l-2.09-4.06-.91 1.33V21h-2V11h2v4.39L22 11h2.19l-3 4.38z'
  }));
});

_4KFilled32.displayName = '_4KFilled32';
_4KFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
_4KFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};

var _4KFilled24 = React.forwardRef(function (_ref111, ref) {
  var className = _ref111.className,
      children = _ref111.children,
      style = _ref111.style,
      tabIndex = _ref111.tabIndex,
      rest = _objectWithoutProperties$2(_ref111, ["className", "children", "style", "tabIndex"]);

  var _getAttributes111 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes111.tabindex,
      props = _objectWithoutProperties$2(_getAttributes111, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM14 21h-2v-4H8v-6h2v4h2v-4h2zm10.19 0H22l-2.09-4.06-.91 1.33V21h-2V11h2v4.39L22 11h2.19l-3 4.38z'
  }));
});

_4KFilled24.displayName = '_4KFilled24';
_4KFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
_4KFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};

var _4KFilled20 = React.forwardRef(function (_ref112, ref) {
  var className = _ref112.className,
      children = _ref112.children,
      style = _ref112.style,
      tabIndex = _ref112.tabIndex,
      rest = _objectWithoutProperties$2(_ref112, ["className", "children", "style", "tabIndex"]);

  var _getAttributes112 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes112.tabindex,
      props = _objectWithoutProperties$2(_getAttributes112, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM14 21h-2v-4H8v-6h2v4h2v-4h2zm10.19 0H22l-2.09-4.06-.91 1.33V21h-2V11h2v4.39L22 11h2.19l-3 4.38z'
  }));
});

_4KFilled20.displayName = '_4KFilled20';
_4KFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
_4KFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};

var _4K32 = React.forwardRef(function (_ref113, ref) {
  var className = _ref113.className,
      children = _ref113.children,
      style = _ref113.style,
      tabIndex = _ref113.tabIndex,
      rest = _objectWithoutProperties$2(_ref113, ["className", "children", "style", "tabIndex"]);

  var _getAttributes113 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes113.tabindex,
      props = _objectWithoutProperties$2(_getAttributes113, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 11.03v4h-2v-4H8v6h4v4h2v-10h-2zm12.19 0H22l-3 4.39v-4.39h-2v10h2V18.3l.91-1.33L22 21.03h2.19l-2.99-5.62 2.99-4.38z'
  }), React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM4 8v16h24V8z'
  }));
});

_4K32.displayName = '_4K32';
_4K32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
_4K32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};

var _4K24 = React.forwardRef(function (_ref114, ref) {
  var className = _ref114.className,
      children = _ref114.children,
      style = _ref114.style,
      tabIndex = _ref114.tabIndex,
      rest = _objectWithoutProperties$2(_ref114, ["className", "children", "style", "tabIndex"]);

  var _getAttributes114 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes114.tabindex,
      props = _objectWithoutProperties$2(_getAttributes114, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 11.03v4h-2v-4H8v6h4v4h2v-10h-2zm12.19 0H22l-3 4.39v-4.39h-2v10h2V18.3l.91-1.33L22 21.03h2.19l-2.99-5.62 2.99-4.38z'
  }), React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM4 8v16h24V8z'
  }));
});

_4K24.displayName = '_4K24';
_4K24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
_4K24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};

var _4K20 = React.forwardRef(function (_ref115, ref) {
  var className = _ref115.className,
      children = _ref115.children,
      style = _ref115.style,
      tabIndex = _ref115.tabIndex,
      rest = _objectWithoutProperties$2(_ref115, ["className", "children", "style", "tabIndex"]);

  var _getAttributes115 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes115.tabindex,
      props = _objectWithoutProperties$2(_getAttributes115, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 11.03v4h-2v-4H8v6h4v4h2v-10h-2zm12.19 0H22l-3 4.39v-4.39h-2v10h2V18.3l.91-1.33L22 21.03h2.19l-2.99-5.62 2.99-4.38z'
  }), React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM4 8v16h24V8z'
  }));
});

_4K20.displayName = '_4K20';
_4K20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
_4K20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Api_132 = React.forwardRef(function (_ref116, ref) {
  var className = _ref116.className,
      children = _ref116.children,
      style = _ref116.style,
      tabIndex = _ref116.tabIndex,
      rest = _objectWithoutProperties$2(_ref116, ["className", "children", "style", "tabIndex"]);

  var _getAttributes116 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes116.tabindex,
      props = _objectWithoutProperties$2(_getAttributes116, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 9H4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm18-5h3v10h-3v2h8v-2h-3V11h3V9h-8v2zm-8 12h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4z'
  }));
});
Api_132.displayName = 'Api_132';
Api_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Api_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Api_124 = React.forwardRef(function (_ref117, ref) {
  var className = _ref117.className,
      children = _ref117.children,
      style = _ref117.style,
      tabIndex = _ref117.tabIndex,
      rest = _objectWithoutProperties$2(_ref117, ["className", "children", "style", "tabIndex"]);

  var _getAttributes117 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes117.tabindex,
      props = _objectWithoutProperties$2(_getAttributes117, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 9H4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm18-5h3v10h-3v2h8v-2h-3V11h3V9h-8v2zm-8 12h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4z'
  }));
});
Api_124.displayName = 'Api_124';
Api_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Api_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Api_120 = React.forwardRef(function (_ref118, ref) {
  var className = _ref118.className,
      children = _ref118.children,
      style = _ref118.style,
      tabIndex = _ref118.tabIndex,
      rest = _objectWithoutProperties$2(_ref118, ["className", "children", "style", "tabIndex"]);

  var _getAttributes118 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes118.tabindex,
      props = _objectWithoutProperties$2(_getAttributes118, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 9H4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm18-5h3v10h-3v2h8v-2h-3V11h3V9h-8v2zm-8 12h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4z'
  }));
});
Api_120.displayName = 'Api_120';
Api_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Api_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cad32 = React.forwardRef(function (_ref119, ref) {
  var className = _ref119.className,
      children = _ref119.children,
      style = _ref119.style,
      tabIndex = _ref119.tabIndex,
      rest = _objectWithoutProperties$2(_ref119, ["className", "children", "style", "tabIndex"]);

  var _getAttributes119 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes119.tabindex,
      props = _objectWithoutProperties$2(_getAttributes119, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm12 7h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zm-14 2H4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H4v10h6z'
  }));
});
Cad32.displayName = 'Cad32';
Cad32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cad32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cad24 = React.forwardRef(function (_ref120, ref) {
  var className = _ref120.className,
      children = _ref120.children,
      style = _ref120.style,
      tabIndex = _ref120.tabIndex,
      rest = _objectWithoutProperties$2(_ref120, ["className", "children", "style", "tabIndex"]);

  var _getAttributes120 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes120.tabindex,
      props = _objectWithoutProperties$2(_getAttributes120, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm12 7h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zm-14 2H4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H4v10h6z'
  }));
});
Cad24.displayName = 'Cad24';
Cad24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cad24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cad20 = React.forwardRef(function (_ref121, ref) {
  var className = _ref121.className,
      children = _ref121.children,
      style = _ref121.style,
      tabIndex = _ref121.tabIndex,
      rest = _objectWithoutProperties$2(_ref121, ["className", "children", "style", "tabIndex"]);

  var _getAttributes121 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes121.tabindex,
      props = _objectWithoutProperties$2(_getAttributes121, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm12 7h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zm-14 2H4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H4v10h6z'
  }));
});
Cad20.displayName = 'Cad20';
Cad20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cad20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Dvr32 = React.forwardRef(function (_ref122, ref) {
  var className = _ref122.className,
      children = _ref122.children,
      style = _ref122.style,
      tabIndex = _ref122.tabIndex,
      rest = _objectWithoutProperties$2(_ref122, ["className", "children", "style", "tabIndex"]);

  var _getAttributes122 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes122.tabindex,
      props = _objectWithoutProperties$2(_getAttributes122, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 15v-4a2 2 0 0 0-2-2h-6v14h2v-6h1.48l2.34 6H30l-2.33-6H28a2 2 0 0 0 2-2zm-6-4h4v4h-4zm-6-2l-2 13-2-13h-2l2.52 14h2.96L20 9h-2zM6 23H2V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H4z'
  }));
});
Dvr32.displayName = 'Dvr32';
Dvr32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Dvr32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Dvr24 = React.forwardRef(function (_ref123, ref) {
  var className = _ref123.className,
      children = _ref123.children,
      style = _ref123.style,
      tabIndex = _ref123.tabIndex,
      rest = _objectWithoutProperties$2(_ref123, ["className", "children", "style", "tabIndex"]);

  var _getAttributes123 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes123.tabindex,
      props = _objectWithoutProperties$2(_getAttributes123, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 15v-4a2 2 0 0 0-2-2h-6v14h2v-6h1.48l2.34 6H30l-2.33-6H28a2 2 0 0 0 2-2zm-6-4h4v4h-4zm-6-2l-2 13-2-13h-2l2.52 14h2.96L20 9h-2zM6 23H2V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H4z'
  }));
});
Dvr24.displayName = 'Dvr24';
Dvr24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Dvr24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Dvr20 = React.forwardRef(function (_ref124, ref) {
  var className = _ref124.className,
      children = _ref124.children,
      style = _ref124.style,
      tabIndex = _ref124.tabIndex,
      rest = _objectWithoutProperties$2(_ref124, ["className", "children", "style", "tabIndex"]);

  var _getAttributes124 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes124.tabindex,
      props = _objectWithoutProperties$2(_getAttributes124, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 15v-4a2 2 0 0 0-2-2h-6v14h2v-6h1.48l2.34 6H30l-2.33-6H28a2 2 0 0 0 2-2zm-6-4h4v4h-4zm-6-2l-2 13-2-13h-2l2.52 14h2.96L20 9h-2zM6 23H2V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H4z'
  }));
});
Dvr20.displayName = 'Dvr20';
Dvr20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Dvr20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Gif32 = React.forwardRef(function (_ref125, ref) {
  var className = _ref125.className,
      children = _ref125.children,
      style = _ref125.style,
      tabIndex = _ref125.tabIndex,
      rest = _objectWithoutProperties$2(_ref125, ["className", "children", "style", "tabIndex"]);

  var _getAttributes125 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes125.tabindex,
      props = _objectWithoutProperties$2(_getAttributes125, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 12v8a3 3 0 0 0 3 3h5v-8H6v2h2v4H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5V9H5a3 3 0 0 0-3 3zm28-1V9h-8v14h2v-6h5v-2h-5v-4h6zM12 9v2h3v10h-3v2h8v-2h-3V11h3V9h-8z'
  }));
});
Gif32.displayName = 'Gif32';
Gif32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Gif32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Gif24 = React.forwardRef(function (_ref126, ref) {
  var className = _ref126.className,
      children = _ref126.children,
      style = _ref126.style,
      tabIndex = _ref126.tabIndex,
      rest = _objectWithoutProperties$2(_ref126, ["className", "children", "style", "tabIndex"]);

  var _getAttributes126 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes126.tabindex,
      props = _objectWithoutProperties$2(_getAttributes126, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 12v8a3 3 0 0 0 3 3h5v-8H6v2h2v4H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5V9H5a3 3 0 0 0-3 3zm28-1V9h-8v14h2v-6h5v-2h-5v-4h6zM12 9v2h3v10h-3v2h8v-2h-3V11h3V9h-8z'
  }));
});
Gif24.displayName = 'Gif24';
Gif24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Gif24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Gif20 = React.forwardRef(function (_ref127, ref) {
  var className = _ref127.className,
      children = _ref127.children,
      style = _ref127.style,
      tabIndex = _ref127.tabIndex,
      rest = _objectWithoutProperties$2(_ref127, ["className", "children", "style", "tabIndex"]);

  var _getAttributes127 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes127.tabindex,
      props = _objectWithoutProperties$2(_getAttributes127, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 12v8a3 3 0 0 0 3 3h5v-8H6v2h2v4H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h5V9H5a3 3 0 0 0-3 3zm28-1V9h-8v14h2v-6h5v-2h-5v-4h6zM12 9v2h3v10h-3v2h8v-2h-3V11h3V9h-8z'
  }));
});
Gif20.displayName = 'Gif20';
Gif20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Gif20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var HdFilled32 = React.forwardRef(function (_ref128, ref) {
  var className = _ref128.className,
      children = _ref128.children,
      style = _ref128.style,
      tabIndex = _ref128.tabIndex,
      rest = _objectWithoutProperties$2(_ref128, ["className", "children", "style", "tabIndex"]);

  var _getAttributes128 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes128.tabindex,
      props = _objectWithoutProperties$2(_getAttributes128, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 13h-2v6h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM15 21h-2v-4h-3v4H8V11h2v4h3v-4h2zm10-3a3 3 0 0 1-3 3h-4V11h4a3 3 0 0 1 3 3z'
  }));
});
HdFilled32.displayName = 'HdFilled32';
HdFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
HdFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var HdFilled24 = React.forwardRef(function (_ref129, ref) {
  var className = _ref129.className,
      children = _ref129.children,
      style = _ref129.style,
      tabIndex = _ref129.tabIndex,
      rest = _objectWithoutProperties$2(_ref129, ["className", "children", "style", "tabIndex"]);

  var _getAttributes129 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes129.tabindex,
      props = _objectWithoutProperties$2(_getAttributes129, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 13h-2v6h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM15 21h-2v-4h-3v4H8V11h2v4h3v-4h2zm10-3a3 3 0 0 1-3 3h-4V11h4a3 3 0 0 1 3 3z'
  }));
});
HdFilled24.displayName = 'HdFilled24';
HdFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
HdFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var HdFilled20 = React.forwardRef(function (_ref130, ref) {
  var className = _ref130.className,
      children = _ref130.children,
      style = _ref130.style,
      tabIndex = _ref130.tabIndex,
      rest = _objectWithoutProperties$2(_ref130, ["className", "children", "style", "tabIndex"]);

  var _getAttributes130 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes130.tabindex,
      props = _objectWithoutProperties$2(_getAttributes130, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 13h-2v6h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM15 21h-2v-4h-3v4H8V11h2v4h3v-4h2zm10-3a3 3 0 0 1-3 3h-4V11h4a3 3 0 0 1 3 3z'
  }));
});
HdFilled20.displayName = 'HdFilled20';
HdFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
HdFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hd32 = React.forwardRef(function (_ref131, ref) {
  var className = _ref131.className,
      children = _ref131.children,
      style = _ref131.style,
      tabIndex = _ref131.tabIndex,
      rest = _objectWithoutProperties$2(_ref131, ["className", "children", "style", "tabIndex"]);

  var _getAttributes131 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes131.tabindex,
      props = _objectWithoutProperties$2(_getAttributes131, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 24V8h24v16z'
  }), React.createElement('path', {
    d: 'M22 11h-4v10h4a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3zm1 7a1 1 0 0 1-1 1h-2v-6h2a1 1 0 0 1 1 1zm-10-7v4h-3v-4H8v10h2v-4h3v4h2V11h-2z'
  }));
});
Hd32.displayName = 'Hd32';
Hd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hd24 = React.forwardRef(function (_ref132, ref) {
  var className = _ref132.className,
      children = _ref132.children,
      style = _ref132.style,
      tabIndex = _ref132.tabIndex,
      rest = _objectWithoutProperties$2(_ref132, ["className", "children", "style", "tabIndex"]);

  var _getAttributes132 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes132.tabindex,
      props = _objectWithoutProperties$2(_getAttributes132, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 24V8h24v16z'
  }), React.createElement('path', {
    d: 'M22 11h-4v10h4a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3zm1 7a1 1 0 0 1-1 1h-2v-6h2a1 1 0 0 1 1 1zm-10-7v4h-3v-4H8v10h2v-4h3v4h2V11h-2z'
  }));
});
Hd24.displayName = 'Hd24';
Hd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hd20 = React.forwardRef(function (_ref133, ref) {
  var className = _ref133.className,
      children = _ref133.children,
      style = _ref133.style,
      tabIndex = _ref133.tabIndex,
      rest = _objectWithoutProperties$2(_ref133, ["className", "children", "style", "tabIndex"]);

  var _getAttributes133 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes133.tabindex,
      props = _objectWithoutProperties$2(_getAttributes133, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 24V8h24v16z'
  }), React.createElement('path', {
    d: 'M22 11h-4v10h4a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3zm1 7a1 1 0 0 1-1 1h-2v-6h2a1 1 0 0 1 1 1zm-10-7v4h-3v-4H8v10h2v-4h3v4h2V11h-2z'
  }));
});
Hd20.displayName = 'Hd20';
Hd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hdr32 = React.forwardRef(function (_ref134, ref) {
  var className = _ref134.className,
      children = _ref134.children,
      style = _ref134.style,
      tabIndex = _ref134.tabIndex,
      rest = _objectWithoutProperties$2(_ref134, ["className", "children", "style", "tabIndex"]);

  var _getAttributes134 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes134.tabindex,
      props = _objectWithoutProperties$2(_getAttributes134, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 15v-4a2 2 0 0 0-2-2h-6v14h2v-6h1.48l2.34 6H30l-2.33-6H28a2 2 0 0 0 2-2zm-6-4h4v4h-4zm-8 12h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zM8 9v6H4V9H2v14h2v-6h4v6h2V9H8z'
  }));
});
Hdr32.displayName = 'Hdr32';
Hdr32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hdr32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hdr24 = React.forwardRef(function (_ref135, ref) {
  var className = _ref135.className,
      children = _ref135.children,
      style = _ref135.style,
      tabIndex = _ref135.tabIndex,
      rest = _objectWithoutProperties$2(_ref135, ["className", "children", "style", "tabIndex"]);

  var _getAttributes135 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes135.tabindex,
      props = _objectWithoutProperties$2(_getAttributes135, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 15v-4a2 2 0 0 0-2-2h-6v14h2v-6h1.48l2.34 6H30l-2.33-6H28a2 2 0 0 0 2-2zm-6-4h4v4h-4zm-8 12h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zM8 9v6H4V9H2v14h2v-6h4v6h2V9H8z'
  }));
});
Hdr24.displayName = 'Hdr24';
Hdr24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hdr24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hdr20 = React.forwardRef(function (_ref136, ref) {
  var className = _ref136.className,
      children = _ref136.children,
      style = _ref136.style,
      tabIndex = _ref136.tabIndex,
      rest = _objectWithoutProperties$2(_ref136, ["className", "children", "style", "tabIndex"]);

  var _getAttributes136 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes136.tabindex,
      props = _objectWithoutProperties$2(_getAttributes136, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 15v-4a2 2 0 0 0-2-2h-6v14h2v-6h1.48l2.34 6H30l-2.33-6H28a2 2 0 0 0 2-2zm-6-4h4v4h-4zm-8 12h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zM8 9v6H4V9H2v14h2v-6h4v6h2V9H8z'
  }));
});
Hdr20.displayName = 'Hdr20';
Hdr20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hdr20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IsoFilled32 = React.forwardRef(function (_ref137, ref) {
  var className = _ref137.className,
      children = _ref137.children,
      style = _ref137.style,
      tabIndex = _ref137.tabIndex,
      rest = _objectWithoutProperties$2(_ref137, ["className", "children", "style", "tabIndex"]);

  var _getAttributes137 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes137.tabindex,
      props = _objectWithoutProperties$2(_getAttributes137, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 13h3v6h-3z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM8 21H6V11h2zm9-8h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5zm9 6a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2z'
  }));
});
IsoFilled32.displayName = 'IsoFilled32';
IsoFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IsoFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IsoFilled24 = React.forwardRef(function (_ref138, ref) {
  var className = _ref138.className,
      children = _ref138.children,
      style = _ref138.style,
      tabIndex = _ref138.tabIndex,
      rest = _objectWithoutProperties$2(_ref138, ["className", "children", "style", "tabIndex"]);

  var _getAttributes138 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes138.tabindex,
      props = _objectWithoutProperties$2(_getAttributes138, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 13h3v6h-3z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM8 21H6V11h2zm9-8h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5zm9 6a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2z'
  }));
});
IsoFilled24.displayName = 'IsoFilled24';
IsoFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IsoFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IsoFilled20 = React.forwardRef(function (_ref139, ref) {
  var className = _ref139.className,
      children = _ref139.children,
      style = _ref139.style,
      tabIndex = _ref139.tabIndex,
      rest = _objectWithoutProperties$2(_ref139, ["className", "children", "style", "tabIndex"]);

  var _getAttributes139 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes139.tabindex,
      props = _objectWithoutProperties$2(_getAttributes139, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 13h3v6h-3z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM8 21H6V11h2zm9-8h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5zm9 6a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2z'
  }));
});
IsoFilled20.displayName = 'IsoFilled20';
IsoFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IsoFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IsoOutline32 = React.forwardRef(function (_ref140, ref) {
  var className = _ref140.className,
      children = _ref140.children,
      style = _ref140.style,
      tabIndex = _ref140.tabIndex,
      rest = _objectWithoutProperties$2(_ref140, ["className", "children", "style", "tabIndex"]);

  var _getAttributes140 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes140.tabindex,
      props = _objectWithoutProperties$2(_getAttributes140, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21h-3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-3-8v6h3v-6zm-6 8h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5v2h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zM6 11h2v10H6z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 24V8h24v16z'
  }));
});
IsoOutline32.displayName = 'IsoOutline32';
IsoOutline32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IsoOutline32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IsoOutline24 = React.forwardRef(function (_ref141, ref) {
  var className = _ref141.className,
      children = _ref141.children,
      style = _ref141.style,
      tabIndex = _ref141.tabIndex,
      rest = _objectWithoutProperties$2(_ref141, ["className", "children", "style", "tabIndex"]);

  var _getAttributes141 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes141.tabindex,
      props = _objectWithoutProperties$2(_getAttributes141, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21h-3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-3-8v6h3v-6zm-6 8h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5v2h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zM6 11h2v10H6z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 24V8h24v16z'
  }));
});
IsoOutline24.displayName = 'IsoOutline24';
IsoOutline24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IsoOutline24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IsoOutline20 = React.forwardRef(function (_ref142, ref) {
  var className = _ref142.className,
      children = _ref142.children,
      style = _ref142.style,
      tabIndex = _ref142.tabIndex,
      rest = _objectWithoutProperties$2(_ref142, ["className", "children", "style", "tabIndex"]);

  var _getAttributes142 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes142.tabindex,
      props = _objectWithoutProperties$2(_getAttributes142, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21h-3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-3-8v6h3v-6zm-6 8h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5v2h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zM6 11h2v10H6z'
  }), React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 24V8h24v16z'
  }));
});
IsoOutline20.displayName = 'IsoOutline20';
IsoOutline20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IsoOutline20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Iso32 = React.forwardRef(function (_ref143, ref) {
  var className = _ref143.className,
      children = _ref143.children,
      style = _ref143.style,
      tabIndex = _ref143.tabIndex,
      rest = _objectWithoutProperties$2(_ref143, ["className", "children", "style", "tabIndex"]);

  var _getAttributes143 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes143.tabindex,
      props = _objectWithoutProperties$2(_getAttributes143, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11zm-6 12h-6v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM2 11h3v10H2v2h8v-2H7V11h3V9H2v2z'
  }));
});
Iso32.displayName = 'Iso32';
Iso32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Iso32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Iso24 = React.forwardRef(function (_ref144, ref) {
  var className = _ref144.className,
      children = _ref144.children,
      style = _ref144.style,
      tabIndex = _ref144.tabIndex,
      rest = _objectWithoutProperties$2(_ref144, ["className", "children", "style", "tabIndex"]);

  var _getAttributes144 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes144.tabindex,
      props = _objectWithoutProperties$2(_getAttributes144, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11zm-6 12h-6v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM2 11h3v10H2v2h8v-2H7V11h3V9H2v2z'
  }));
});
Iso24.displayName = 'Iso24';
Iso24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Iso24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Iso20 = React.forwardRef(function (_ref145, ref) {
  var className = _ref145.className,
      children = _ref145.children,
      style = _ref145.style,
      tabIndex = _ref145.tabIndex,
      rest = _objectWithoutProperties$2(_ref145, ["className", "children", "style", "tabIndex"]);

  var _getAttributes145 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes145.tabindex,
      props = _objectWithoutProperties$2(_getAttributes145, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11zm-6 12h-6v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM2 11h3v10H2v2h8v-2H7V11h3V9H2v2z'
  }));
});
Iso20.displayName = 'Iso20';
Iso20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Iso20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Jpg32 = React.forwardRef(function (_ref146, ref) {
  var className = _ref146.className,
      children = _ref146.children,
      style = _ref146.style,
      tabIndex = _ref146.tabIndex,
      rest = _objectWithoutProperties$2(_ref146, ["className", "children", "style", "tabIndex"]);

  var _getAttributes146 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes146.tabindex,
      props = _objectWithoutProperties$2(_getAttributes146, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zm-16 0h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zm-6 7H4a2 2 0 0 1-2-2v-2h2v2h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
Jpg32.displayName = 'Jpg32';
Jpg32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Jpg32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Jpg24 = React.forwardRef(function (_ref147, ref) {
  var className = _ref147.className,
      children = _ref147.children,
      style = _ref147.style,
      tabIndex = _ref147.tabIndex,
      rest = _objectWithoutProperties$2(_ref147, ["className", "children", "style", "tabIndex"]);

  var _getAttributes147 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes147.tabindex,
      props = _objectWithoutProperties$2(_getAttributes147, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zm-16 0h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zm-6 7H4a2 2 0 0 1-2-2v-2h2v2h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
Jpg24.displayName = 'Jpg24';
Jpg24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Jpg24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Jpg20 = React.forwardRef(function (_ref148, ref) {
  var className = _ref148.className,
      children = _ref148.children,
      style = _ref148.style,
      tabIndex = _ref148.tabIndex,
      rest = _objectWithoutProperties$2(_ref148, ["className", "children", "style", "tabIndex"]);

  var _getAttributes148 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes148.tabindex,
      props = _objectWithoutProperties$2(_getAttributes148, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zm-16 0h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zm-6 7H4a2 2 0 0 1-2-2v-2h2v2h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
Jpg20.displayName = 'Jpg20';
Jpg20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Jpg20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mov32 = React.forwardRef(function (_ref149, ref) {
  var className = _ref149.className,
      children = _ref149.children,
      style = _ref149.style,
      tabIndex = _ref149.tabIndex,
      rest = _objectWithoutProperties$2(_ref149, ["className", "children", "style", "tabIndex"]);

  var _getAttributes149 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes149.tabindex,
      props = _objectWithoutProperties$2(_getAttributes149, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9l-2 13-2-13h-2l2.52 14h2.96L30 9h-2zM18 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mov32.displayName = 'Mov32';
Mov32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mov32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mov24 = React.forwardRef(function (_ref150, ref) {
  var className = _ref150.className,
      children = _ref150.children,
      style = _ref150.style,
      tabIndex = _ref150.tabIndex,
      rest = _objectWithoutProperties$2(_ref150, ["className", "children", "style", "tabIndex"]);

  var _getAttributes150 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes150.tabindex,
      props = _objectWithoutProperties$2(_getAttributes150, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9l-2 13-2-13h-2l2.52 14h2.96L30 9h-2zM18 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mov24.displayName = 'Mov24';
Mov24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mov24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mov20 = React.forwardRef(function (_ref151, ref) {
  var className = _ref151.className,
      children = _ref151.children,
      style = _ref151.style,
      tabIndex = _ref151.tabIndex,
      rest = _objectWithoutProperties$2(_ref151, ["className", "children", "style", "tabIndex"]);

  var _getAttributes151 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes151.tabindex,
      props = _objectWithoutProperties$2(_getAttributes151, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9l-2 13-2-13h-2l2.52 14h2.96L30 9h-2zM18 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mov20.displayName = 'Mov20';
Mov20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mov20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mp332 = React.forwardRef(function (_ref152, ref) {
  var className = _ref152.className,
      children = _ref152.children,
      style = _ref152.style,
      tabIndex = _ref152.tabIndex,
      rest = _objectWithoutProperties$2(_ref152, ["className", "children", "style", "tabIndex"]);

  var _getAttributes152 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes152.tabindex,
      props = _objectWithoutProperties$2(_getAttributes152, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-6v2h6v4h-4v2h4v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mp332.displayName = 'Mp332';
Mp332.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mp332.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mp324 = React.forwardRef(function (_ref153, ref) {
  var className = _ref153.className,
      children = _ref153.children,
      style = _ref153.style,
      tabIndex = _ref153.tabIndex,
      rest = _objectWithoutProperties$2(_ref153, ["className", "children", "style", "tabIndex"]);

  var _getAttributes153 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes153.tabindex,
      props = _objectWithoutProperties$2(_getAttributes153, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-6v2h6v4h-4v2h4v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mp324.displayName = 'Mp324';
Mp324.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mp324.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mp320 = React.forwardRef(function (_ref154, ref) {
  var className = _ref154.className,
      children = _ref154.children,
      style = _ref154.style,
      tabIndex = _ref154.tabIndex,
      rest = _objectWithoutProperties$2(_ref154, ["className", "children", "style", "tabIndex"]);

  var _getAttributes154 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes154.tabindex,
      props = _objectWithoutProperties$2(_getAttributes154, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-6v2h6v4h-4v2h4v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mp320.displayName = 'Mp320';
Mp320.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mp320.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mp432 = React.forwardRef(function (_ref155, ref) {
  var className = _ref155.className,
      children = _ref155.children,
      style = _ref155.style,
      tabIndex = _ref155.tabIndex,
      rest = _objectWithoutProperties$2(_ref155, ["className", "children", "style", "tabIndex"]);

  var _getAttributes155 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes155.tabindex,
      props = _objectWithoutProperties$2(_getAttributes155, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.5 22.5v-4h-5v-9h1v8h4v-8h1v8h1v1h-1v4h-1z'
  }), React.createElement('path', {
    d: 'M28 10v8-8m1-1h-2v8h-3V9h-2v10h5v4h2v-4h1v-2h-1V9zM14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mp432.displayName = 'Mp432';
Mp432.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mp432.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mp424 = React.forwardRef(function (_ref156, ref) {
  var className = _ref156.className,
      children = _ref156.children,
      style = _ref156.style,
      tabIndex = _ref156.tabIndex,
      rest = _objectWithoutProperties$2(_ref156, ["className", "children", "style", "tabIndex"]);

  var _getAttributes156 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes156.tabindex,
      props = _objectWithoutProperties$2(_getAttributes156, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.5 22.5v-4h-5v-9h1v8h4v-8h1v8h1v1h-1v4h-1z'
  }), React.createElement('path', {
    d: 'M28 10v8-8m1-1h-2v8h-3V9h-2v10h5v4h2v-4h1v-2h-1V9zM14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mp424.displayName = 'Mp424';
Mp424.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mp424.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mp420 = React.forwardRef(function (_ref157, ref) {
  var className = _ref157.className,
      children = _ref157.children,
      style = _ref157.style,
      tabIndex = _ref157.tabIndex,
      rest = _objectWithoutProperties$2(_ref157, ["className", "children", "style", "tabIndex"]);

  var _getAttributes157 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes157.tabindex,
      props = _objectWithoutProperties$2(_getAttributes157, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.5 22.5v-4h-5v-9h1v8h4v-8h1v8h1v1h-1v4h-1z'
  }), React.createElement('path', {
    d: 'M28 10v8-8m1-1h-2v8h-3V9h-2v10h5v4h2v-4h1v-2h-1V9zM14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zM8 9l-1.51 5L6 15.98 5.54 14 4 9H2v14h2v-8l-.16-2 .58 2L6 19.63 7.58 15l.58-2L8 15v8h2V9H8z'
  }));
});
Mp420.displayName = 'Mp420';
Mp420.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mp420.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pdf32 = React.forwardRef(function (_ref158, ref) {
  var className = _ref158.className,
      children = _ref158.children,
      style = _ref158.style,
      tabIndex = _ref158.tabIndex,
      rest = _objectWithoutProperties$2(_ref158, ["className", "children", "style", "tabIndex"]);

  var _getAttributes158 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes158.tabindex,
      props = _objectWithoutProperties$2(_getAttributes158, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 11V9h-8v14h2v-6h5v-2h-5v-4h6zM8 9H2v14h2v-5h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm0 7H4v-5h4zm8 7h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2z'
  }));
});
Pdf32.displayName = 'Pdf32';
Pdf32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pdf32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pdf24 = React.forwardRef(function (_ref159, ref) {
  var className = _ref159.className,
      children = _ref159.children,
      style = _ref159.style,
      tabIndex = _ref159.tabIndex,
      rest = _objectWithoutProperties$2(_ref159, ["className", "children", "style", "tabIndex"]);

  var _getAttributes159 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes159.tabindex,
      props = _objectWithoutProperties$2(_getAttributes159, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 11V9h-8v14h2v-6h5v-2h-5v-4h6zM8 9H2v14h2v-5h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm0 7H4v-5h4zm8 7h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2z'
  }));
});
Pdf24.displayName = 'Pdf24';
Pdf24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pdf24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pdf20 = React.forwardRef(function (_ref160, ref) {
  var className = _ref160.className,
      children = _ref160.children,
      style = _ref160.style,
      tabIndex = _ref160.tabIndex,
      rest = _objectWithoutProperties$2(_ref160, ["className", "children", "style", "tabIndex"]);

  var _getAttributes160 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes160.tabindex,
      props = _objectWithoutProperties$2(_getAttributes160, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 11V9h-8v14h2v-6h5v-2h-5v-4h6zM8 9H2v14h2v-5h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm0 7H4v-5h4zm8 7h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2z'
  }));
});
Pdf20.displayName = 'Pdf20';
Pdf20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pdf20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Png32 = React.forwardRef(function (_ref161, ref) {
  var className = _ref161.className,
      children = _ref161.children,
      style = _ref161.style,
      tabIndex = _ref161.tabIndex,
      rest = _objectWithoutProperties$2(_ref161, ["className", "children", "style", "tabIndex"]);

  var _getAttributes161 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes161.tabindex,
      props = _objectWithoutProperties$2(_getAttributes161, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zm-12-4L14.32 9H12v14h2V13l3.68 10H20V9h-2v10zM4 23H2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4zm0-7h4v-5H4z'
  }));
});
Png32.displayName = 'Png32';
Png32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Png32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Png24 = React.forwardRef(function (_ref162, ref) {
  var className = _ref162.className,
      children = _ref162.children,
      style = _ref162.style,
      tabIndex = _ref162.tabIndex,
      rest = _objectWithoutProperties$2(_ref162, ["className", "children", "style", "tabIndex"]);

  var _getAttributes162 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes162.tabindex,
      props = _objectWithoutProperties$2(_getAttributes162, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zm-12-4L14.32 9H12v14h2V13l3.68 10H20V9h-2v10zM4 23H2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4zm0-7h4v-5H4z'
  }));
});
Png24.displayName = 'Png24';
Png24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Png24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Png20 = React.forwardRef(function (_ref163, ref) {
  var className = _ref163.className,
      children = _ref163.children,
      style = _ref163.style,
      tabIndex = _ref163.tabIndex,
      rest = _objectWithoutProperties$2(_ref163, ["className", "children", "style", "tabIndex"]);

  var _getAttributes163 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes163.tabindex,
      props = _objectWithoutProperties$2(_getAttributes163, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zm-12-4L14.32 9H12v14h2V13l3.68 10H20V9h-2v10zM4 23H2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4zm0-7h4v-5H4z'
  }));
});
Png20.displayName = 'Png20';
Png20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Png20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QH32 = React.forwardRef(function (_ref164, ref) {
  var className = _ref164.className,
      children = _ref164.children,
      style = _ref164.style,
      tabIndex = _ref164.tabIndex,
      rest = _objectWithoutProperties$2(_ref164, ["className", "children", "style", "tabIndex"]);

  var _getAttributes164 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes164.tabindex,
      props = _objectWithoutProperties$2(_getAttributes164, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9v6h-4V9h-2v14h2v-6h4v6h2V9h-2z'
  }));
});
QH32.displayName = 'QH32';
QH32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QH32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QH24 = React.forwardRef(function (_ref165, ref) {
  var className = _ref165.className,
      children = _ref165.children,
      style = _ref165.style,
      tabIndex = _ref165.tabIndex,
      rest = _objectWithoutProperties$2(_ref165, ["className", "children", "style", "tabIndex"]);

  var _getAttributes165 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes165.tabindex,
      props = _objectWithoutProperties$2(_getAttributes165, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9v6h-4V9h-2v14h2v-6h4v6h2V9h-2z'
  }));
});
QH24.displayName = 'QH24';
QH24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QH24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QH20 = React.forwardRef(function (_ref166, ref) {
  var className = _ref166.className,
      children = _ref166.children,
      style = _ref166.style,
      tabIndex = _ref166.tabIndex,
      rest = _objectWithoutProperties$2(_ref166, ["className", "children", "style", "tabIndex"]);

  var _getAttributes166 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes166.tabindex,
      props = _objectWithoutProperties$2(_getAttributes166, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9v6h-4V9h-2v14h2v-6h4v6h2V9h-2z'
  }));
});
QH20.displayName = 'QH20';
QH20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QH20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QSAlt32 = React.forwardRef(function (_ref167, ref) {
  var className = _ref167.className,
      children = _ref167.children,
      style = _ref167.style,
      tabIndex = _ref167.tabIndex,
      rest = _objectWithoutProperties$2(_ref167, ["className", "children", "style", "tabIndex"]);

  var _getAttributes167 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes167.tabindex,
      props = _objectWithoutProperties$2(_getAttributes167, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 9h-2V7h-2v2h-2v2h2v6h2v-6h2V9zM14 23H8v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
QSAlt32.displayName = 'QSAlt32';
QSAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QSAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QSAlt24 = React.forwardRef(function (_ref168, ref) {
  var className = _ref168.className,
      children = _ref168.children,
      style = _ref168.style,
      tabIndex = _ref168.tabIndex,
      rest = _objectWithoutProperties$2(_ref168, ["className", "children", "style", "tabIndex"]);

  var _getAttributes168 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes168.tabindex,
      props = _objectWithoutProperties$2(_getAttributes168, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 9h-2V7h-2v2h-2v2h2v6h2v-6h2V9zM14 23H8v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
QSAlt24.displayName = 'QSAlt24';
QSAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QSAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QSAlt20 = React.forwardRef(function (_ref169, ref) {
  var className = _ref169.className,
      children = _ref169.children,
      style = _ref169.style,
      tabIndex = _ref169.tabIndex,
      rest = _objectWithoutProperties$2(_ref169, ["className", "children", "style", "tabIndex"]);

  var _getAttributes169 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes169.tabindex,
      props = _objectWithoutProperties$2(_getAttributes169, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 9h-2V7h-2v2h-2v2h2v6h2v-6h2V9zM14 23H8v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
QSAlt20.displayName = 'QSAlt20';
QSAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QSAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QS32 = React.forwardRef(function (_ref170, ref) {
  var className = _ref170.className,
      children = _ref170.children,
      style = _ref170.style,
      tabIndex = _ref170.tabIndex,
      rest = _objectWithoutProperties$2(_ref170, ["className", "children", "style", "tabIndex"]);

  var _getAttributes170 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes170.tabindex,
      props = _objectWithoutProperties$2(_getAttributes170, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-6v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
QS32.displayName = 'QS32';
QS32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QS32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QS24 = React.forwardRef(function (_ref171, ref) {
  var className = _ref171.className,
      children = _ref171.children,
      style = _ref171.style,
      tabIndex = _ref171.tabIndex,
      rest = _objectWithoutProperties$2(_ref171, ["className", "children", "style", "tabIndex"]);

  var _getAttributes171 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes171.tabindex,
      props = _objectWithoutProperties$2(_getAttributes171, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-6v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
QS24.displayName = 'QS24';
QS24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QS24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QS20 = React.forwardRef(function (_ref172, ref) {
  var className = _ref172.className,
      children = _ref172.children,
      style = _ref172.style,
      tabIndex = _ref172.tabIndex,
      rest = _objectWithoutProperties$2(_ref172, ["className", "children", "style", "tabIndex"]);

  var _getAttributes172 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes172.tabindex,
      props = _objectWithoutProperties$2(_getAttributes172, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-6v-2h6v-4h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
QS20.displayName = 'QS20';
QS20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QS20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QTAlt32 = React.forwardRef(function (_ref173, ref) {
  var className = _ref173.className,
      children = _ref173.children,
      style = _ref173.style,
      tabIndex = _ref173.tabIndex,
      rest = _objectWithoutProperties$2(_ref173, ["className", "children", "style", "tabIndex"]);

  var _getAttributes173 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes173.tabindex,
      props = _objectWithoutProperties$2(_getAttributes173, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 11h3v12h2V11h3V9H8v2zm16-2h-2V7h-2v2h-2v2h2v6l1 1 1-1v-6h2V9z'
  }));
});
QTAlt32.displayName = 'QTAlt32';
QTAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QTAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QTAlt24 = React.forwardRef(function (_ref174, ref) {
  var className = _ref174.className,
      children = _ref174.children,
      style = _ref174.style,
      tabIndex = _ref174.tabIndex,
      rest = _objectWithoutProperties$2(_ref174, ["className", "children", "style", "tabIndex"]);

  var _getAttributes174 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes174.tabindex,
      props = _objectWithoutProperties$2(_getAttributes174, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 11h3v12h2V11h3V9H8v2zm16-2h-2V7h-2v2h-2v2h2v6l1 1 1-1v-6h2V9z'
  }));
});
QTAlt24.displayName = 'QTAlt24';
QTAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QTAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QTAlt20 = React.forwardRef(function (_ref175, ref) {
  var className = _ref175.className,
      children = _ref175.children,
      style = _ref175.style,
      tabIndex = _ref175.tabIndex,
      rest = _objectWithoutProperties$2(_ref175, ["className", "children", "style", "tabIndex"]);

  var _getAttributes175 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes175.tabindex,
      props = _objectWithoutProperties$2(_getAttributes175, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 11h3v12h2V11h3V9H8v2zm16-2h-2V7h-2v2h-2v2h2v6l1 1 1-1v-6h2V9z'
  }));
});
QTAlt20.displayName = 'QTAlt20';
QTAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QTAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QT32 = React.forwardRef(function (_ref176, ref) {
  var className = _ref176.className,
      children = _ref176.children,
      style = _ref176.style,
      tabIndex = _ref176.tabIndex,
      rest = _objectWithoutProperties$2(_ref176, ["className", "children", "style", "tabIndex"]);

  var _getAttributes176 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes176.tabindex,
      props = _objectWithoutProperties$2(_getAttributes176, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 11h3v12h2V11h3V9h-8v2z'
  }));
});
QT32.displayName = 'QT32';
QT32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QT32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QT24 = React.forwardRef(function (_ref177, ref) {
  var className = _ref177.className,
      children = _ref177.children,
      style = _ref177.style,
      tabIndex = _ref177.tabIndex,
      rest = _objectWithoutProperties$2(_ref177, ["className", "children", "style", "tabIndex"]);

  var _getAttributes177 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes177.tabindex,
      props = _objectWithoutProperties$2(_getAttributes177, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 11h3v12h2V11h3V9h-8v2z'
  }));
});
QT24.displayName = 'QT24';
QT24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QT24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QT20 = React.forwardRef(function (_ref178, ref) {
  var className = _ref178.className,
      children = _ref178.children,
      style = _ref178.style,
      tabIndex = _ref178.tabIndex,
      rest = _objectWithoutProperties$2(_ref178, ["className", "children", "style", "tabIndex"]);

  var _getAttributes178 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes178.tabindex,
      props = _objectWithoutProperties$2(_getAttributes178, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 11h3v12h2V11h3V9h-8v2z'
  }));
});
QT20.displayName = 'QT20';
QT20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QT20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU132 = React.forwardRef(function (_ref179, ref) {
  var className = _ref179.className,
      children = _ref179.children,
      style = _ref179.style,
      tabIndex = _ref179.tabIndex,
      rest = _objectWithoutProperties$2(_ref179, ["className", "children", "style", "tabIndex"]);

  var _getAttributes179 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes179.tabindex,
      props = _objectWithoutProperties$2(_getAttributes179, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm9-2V9h-5v2h3v10h-3v2h8v-2h-3z'
  }));
});
QU132.displayName = 'QU132';
QU132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU124 = React.forwardRef(function (_ref180, ref) {
  var className = _ref180.className,
      children = _ref180.children,
      style = _ref180.style,
      tabIndex = _ref180.tabIndex,
      rest = _objectWithoutProperties$2(_ref180, ["className", "children", "style", "tabIndex"]);

  var _getAttributes180 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes180.tabindex,
      props = _objectWithoutProperties$2(_getAttributes180, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm9-2V9h-5v2h3v10h-3v2h8v-2h-3z'
  }));
});
QU124.displayName = 'QU124';
QU124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU120 = React.forwardRef(function (_ref181, ref) {
  var className = _ref181.className,
      children = _ref181.children,
      style = _ref181.style,
      tabIndex = _ref181.tabIndex,
      rest = _objectWithoutProperties$2(_ref181, ["className", "children", "style", "tabIndex"]);

  var _getAttributes181 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes181.tabindex,
      props = _objectWithoutProperties$2(_getAttributes181, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm9-2V9h-5v2h3v10h-3v2h8v-2h-3z'
  }));
});
QU120.displayName = 'QU120';
QU120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU232 = React.forwardRef(function (_ref182, ref) {
  var className = _ref182.className,
      children = _ref182.children,
      style = _ref182.style,
      tabIndex = _ref182.tabIndex,
      rest = _objectWithoutProperties$2(_ref182, ["className", "children", "style", "tabIndex"]);

  var _getAttributes182 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes182.tabindex,
      props = _objectWithoutProperties$2(_getAttributes182, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm12 0h-8v-6a2 2 0 0 1 2-2h4v-4h-6V9h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4h6z'
  }));
});
QU232.displayName = 'QU232';
QU232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU224 = React.forwardRef(function (_ref183, ref) {
  var className = _ref183.className,
      children = _ref183.children,
      style = _ref183.style,
      tabIndex = _ref183.tabIndex,
      rest = _objectWithoutProperties$2(_ref183, ["className", "children", "style", "tabIndex"]);

  var _getAttributes183 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes183.tabindex,
      props = _objectWithoutProperties$2(_getAttributes183, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm12 0h-8v-6a2 2 0 0 1 2-2h4v-4h-6V9h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4h6z'
  }));
});
QU224.displayName = 'QU224';
QU224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU220 = React.forwardRef(function (_ref184, ref) {
  var className = _ref184.className,
      children = _ref184.children,
      style = _ref184.style,
      tabIndex = _ref184.tabIndex,
      rest = _objectWithoutProperties$2(_ref184, ["className", "children", "style", "tabIndex"]);

  var _getAttributes184 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes184.tabindex,
      props = _objectWithoutProperties$2(_getAttributes184, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm12 0h-8v-6a2 2 0 0 1 2-2h4v-4h-6V9h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4h6z'
  }));
});
QU220.displayName = 'QU220';
QU220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU332 = React.forwardRef(function (_ref185, ref) {
  var className = _ref185.className,
      children = _ref185.children,
      style = _ref185.style,
      tabIndex = _ref185.tabIndex,
      rest = _objectWithoutProperties$2(_ref185, ["className", "children", "style", "tabIndex"]);

  var _getAttributes185 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes185.tabindex,
      props = _objectWithoutProperties$2(_getAttributes185, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zM23 9h-6v2h6v4h-5v2h5v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
QU332.displayName = 'QU332';
QU332.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU332.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU324 = React.forwardRef(function (_ref186, ref) {
  var className = _ref186.className,
      children = _ref186.children,
      style = _ref186.style,
      tabIndex = _ref186.tabIndex,
      rest = _objectWithoutProperties$2(_ref186, ["className", "children", "style", "tabIndex"]);

  var _getAttributes186 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes186.tabindex,
      props = _objectWithoutProperties$2(_getAttributes186, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zM23 9h-6v2h6v4h-5v2h5v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
QU324.displayName = 'QU324';
QU324.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU324.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QU320 = React.forwardRef(function (_ref187, ref) {
  var className = _ref187.className,
      children = _ref187.children,
      style = _ref187.style,
      tabIndex = _ref187.tabIndex,
      rest = _objectWithoutProperties$2(_ref187, ["className", "children", "style", "tabIndex"]);

  var _getAttributes187 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes187.tabindex,
      props = _objectWithoutProperties$2(_getAttributes187, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 23H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zM23 9h-6v2h6v4h-5v2h5v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
QU320.displayName = 'QU320';
QU320.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QU320.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QX32 = React.forwardRef(function (_ref188, ref) {
  var className = _ref188.className,
      children = _ref188.children,
      style = _ref188.style,
      tabIndex = _ref188.tabIndex,
      rest = _objectWithoutProperties$2(_ref188, ["className", "children", "style", "tabIndex"]);

  var _getAttributes188 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes188.tabindex,
      props = _objectWithoutProperties$2(_getAttributes188, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-2l-2 6-2-6h-2l2.75 7L12 23h2l2-6 2 6h2l-2.75-7L20 9z'
  }));
});
QX32.displayName = 'QX32';
QX32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QX32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QX24 = React.forwardRef(function (_ref189, ref) {
  var className = _ref189.className,
      children = _ref189.children,
      style = _ref189.style,
      tabIndex = _ref189.tabIndex,
      rest = _objectWithoutProperties$2(_ref189, ["className", "children", "style", "tabIndex"]);

  var _getAttributes189 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes189.tabindex,
      props = _objectWithoutProperties$2(_getAttributes189, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-2l-2 6-2-6h-2l2.75 7L12 23h2l2-6 2 6h2l-2.75-7L20 9z'
  }));
});
QX24.displayName = 'QX24';
QX24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QX24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QX20 = React.forwardRef(function (_ref190, ref) {
  var className = _ref190.className,
      children = _ref190.children,
      style = _ref190.style,
      tabIndex = _ref190.tabIndex,
      rest = _objectWithoutProperties$2(_ref190, ["className", "children", "style", "tabIndex"]);

  var _getAttributes190 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes190.tabindex,
      props = _objectWithoutProperties$2(_getAttributes190, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-2l-2 6-2-6h-2l2.75 7L12 23h2l2-6 2 6h2l-2.75-7L20 9z'
  }));
});
QX20.displayName = 'QX20';
QX20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QX20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QY32 = React.forwardRef(function (_ref191, ref) {
  var className = _ref191.className,
      children = _ref191.children,
      style = _ref191.style,
      tabIndex = _ref191.tabIndex,
      rest = _objectWithoutProperties$2(_ref191, ["className", "children", "style", "tabIndex"]);

  var _getAttributes191 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes191.tabindex,
      props = _objectWithoutProperties$2(_getAttributes191, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-2l-2 7-2-7h-2l3 9v5h2v-5l3-9z'
  }));
});
QY32.displayName = 'QY32';
QY32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QY32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QY24 = React.forwardRef(function (_ref192, ref) {
  var className = _ref192.className,
      children = _ref192.children,
      style = _ref192.style,
      tabIndex = _ref192.tabIndex,
      rest = _objectWithoutProperties$2(_ref192, ["className", "children", "style", "tabIndex"]);

  var _getAttributes192 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes192.tabindex,
      props = _objectWithoutProperties$2(_getAttributes192, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-2l-2 7-2-7h-2l3 9v5h2v-5l3-9z'
  }));
});
QY24.displayName = 'QY24';
QY24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QY24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QY20 = React.forwardRef(function (_ref193, ref) {
  var className = _ref193.className,
      children = _ref193.children,
      style = _ref193.style,
      tabIndex = _ref193.tabIndex,
      rest = _objectWithoutProperties$2(_ref193, ["className", "children", "style", "tabIndex"]);

  var _getAttributes193 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes193.tabindex,
      props = _objectWithoutProperties$2(_getAttributes193, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-2l-2 7-2-7h-2l3 9v5h2v-5l3-9z'
  }));
});
QY20.displayName = 'QY20';
QY20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QY20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QZ32 = React.forwardRef(function (_ref194, ref) {
  var className = _ref194.className,
      children = _ref194.children,
      style = _ref194.style,
      tabIndex = _ref194.tabIndex,
      rest = _objectWithoutProperties$2(_ref194, ["className", "children", "style", "tabIndex"]);

  var _getAttributes194 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes194.tabindex,
      props = _objectWithoutProperties$2(_getAttributes194, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-8v2h6l-6 10v2h8v-2h-6l6-10V9z'
  }));
});
QZ32.displayName = 'QZ32';
QZ32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QZ32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QZ24 = React.forwardRef(function (_ref195, ref) {
  var className = _ref195.className,
      children = _ref195.children,
      style = _ref195.style,
      tabIndex = _ref195.tabIndex,
      rest = _objectWithoutProperties$2(_ref195, ["className", "children", "style", "tabIndex"]);

  var _getAttributes195 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes195.tabindex,
      props = _objectWithoutProperties$2(_getAttributes195, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-8v2h6l-6 10v2h8v-2h-6l6-10V9z'
  }));
});
QZ24.displayName = 'QZ24';
QZ24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QZ24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QZ20 = React.forwardRef(function (_ref196, ref) {
  var className = _ref196.className,
      children = _ref196.children,
      style = _ref196.style,
      tabIndex = _ref196.tabIndex,
      rest = _objectWithoutProperties$2(_ref196, ["className", "children", "style", "tabIndex"]);

  var _getAttributes196 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes196.tabindex,
      props = _objectWithoutProperties$2(_getAttributes196, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-8v2h6l-6 10v2h8v-2h-6l6-10V9z'
  }));
});
QZ20.displayName = 'QZ20';
QZ20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QZ20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QBarrier32 = React.forwardRef(function (_ref197, ref) {
  var className = _ref197.className,
      children = _ref197.children,
      style = _ref197.style,
      tabIndex = _ref197.tabIndex,
      rest = _objectWithoutProperties$2(_ref197, ["className", "children", "style", "tabIndex"]);

  var _getAttributes197 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes197.tabindex,
      props = _objectWithoutProperties$2(_getAttributes197, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 5h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2z'
  }));
});
QBarrier32.displayName = 'QBarrier32';
QBarrier32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QBarrier32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QBarrier24 = React.forwardRef(function (_ref198, ref) {
  var className = _ref198.className,
      children = _ref198.children,
      style = _ref198.style,
      tabIndex = _ref198.tabIndex,
      rest = _objectWithoutProperties$2(_ref198, ["className", "children", "style", "tabIndex"]);

  var _getAttributes198 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes198.tabindex,
      props = _objectWithoutProperties$2(_getAttributes198, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 5h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2z'
  }));
});
QBarrier24.displayName = 'QBarrier24';
QBarrier24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QBarrier24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QBarrier20 = React.forwardRef(function (_ref199, ref) {
  var className = _ref199.className,
      children = _ref199.children,
      style = _ref199.style,
      tabIndex = _ref199.tabIndex,
      rest = _objectWithoutProperties$2(_ref199, ["className", "children", "style", "tabIndex"]);

  var _getAttributes199 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes199.tabindex,
      props = _objectWithoutProperties$2(_getAttributes199, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 5h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2z'
  }));
});
QBarrier20.displayName = 'QBarrier20';
QBarrier20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QBarrier20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QBlochSphere32 = React.forwardRef(function (_ref200, ref) {
  var className = _ref200.className,
      children = _ref200.children,
      style = _ref200.style,
      tabIndex = _ref200.tabIndex,
      rest = _objectWithoutProperties$2(_ref200, ["className", "children", "style", "tabIndex"]);

  var _getAttributes200 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes200.tabindex,
      props = _objectWithoutProperties$2(_getAttributes200, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.87 7.84l-1.74-1L16 14a2 2 0 1 0 2 2 2 2 0 0 0-.27-1z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 11.17 7.65 25.69 25.69 0 0 0-3.69-1.5l-1 1.77a22.7 22.7 0 0 1 5.41 2.39 11.05 11.05 0 0 1 0 3.38A22.92 22.92 0 0 1 16 21a22.92 22.92 0 0 1-11.87-3.31 11.05 11.05 0 0 1 0-3.38A22.8 22.8 0 0 1 15 11V9a25 25 0 0 0-10.17 2.6A12 12 0 0 1 16 4zm0 24a12 12 0 0 1-11.17-7.65A24.88 24.88 0 0 0 16 23a24.88 24.88 0 0 0 11.17-2.65A12 12 0 0 1 16 28z'
  }));
});
QBlochSphere32.displayName = 'QBlochSphere32';
QBlochSphere32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QBlochSphere32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QBlochSphere24 = React.forwardRef(function (_ref201, ref) {
  var className = _ref201.className,
      children = _ref201.children,
      style = _ref201.style,
      tabIndex = _ref201.tabIndex,
      rest = _objectWithoutProperties$2(_ref201, ["className", "children", "style", "tabIndex"]);

  var _getAttributes201 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes201.tabindex,
      props = _objectWithoutProperties$2(_getAttributes201, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.87 7.84l-1.74-1L16 14a2 2 0 1 0 2 2 2 2 0 0 0-.27-1z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 11.17 7.65 25.69 25.69 0 0 0-3.69-1.5l-1 1.77a22.7 22.7 0 0 1 5.41 2.39 11.05 11.05 0 0 1 0 3.38A22.92 22.92 0 0 1 16 21a22.92 22.92 0 0 1-11.87-3.31 11.05 11.05 0 0 1 0-3.38A22.8 22.8 0 0 1 15 11V9a25 25 0 0 0-10.17 2.6A12 12 0 0 1 16 4zm0 24a12 12 0 0 1-11.17-7.65A24.88 24.88 0 0 0 16 23a24.88 24.88 0 0 0 11.17-2.65A12 12 0 0 1 16 28z'
  }));
});
QBlochSphere24.displayName = 'QBlochSphere24';
QBlochSphere24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QBlochSphere24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QBlochSphere20 = React.forwardRef(function (_ref202, ref) {
  var className = _ref202.className,
      children = _ref202.children,
      style = _ref202.style,
      tabIndex = _ref202.tabIndex,
      rest = _objectWithoutProperties$2(_ref202, ["className", "children", "style", "tabIndex"]);

  var _getAttributes202 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes202.tabindex,
      props = _objectWithoutProperties$2(_getAttributes202, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.87 7.84l-1.74-1L16 14a2 2 0 1 0 2 2 2 2 0 0 0-.27-1z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 11.17 7.65 25.69 25.69 0 0 0-3.69-1.5l-1 1.77a22.7 22.7 0 0 1 5.41 2.39 11.05 11.05 0 0 1 0 3.38A22.92 22.92 0 0 1 16 21a22.92 22.92 0 0 1-11.87-3.31 11.05 11.05 0 0 1 0-3.38A22.8 22.8 0 0 1 15 11V9a25 25 0 0 0-10.17 2.6A12 12 0 0 1 16 4zm0 24a12 12 0 0 1-11.17-7.65A24.88 24.88 0 0 0 16 23a24.88 24.88 0 0 0 11.17-2.65A12 12 0 0 1 16 28z'
  }));
});
QBlochSphere20.displayName = 'QBlochSphere20';
QBlochSphere20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QBlochSphere20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCU132 = React.forwardRef(function (_ref203, ref) {
  var className = _ref203.className,
      children = _ref203.children,
      style = _ref203.style,
      tabIndex = _ref203.tabIndex,
      rest = _objectWithoutProperties$2(_ref203, ["className", "children", "style", "tabIndex"]);

  var _getAttributes203 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes203.tabindex,
      props = _objectWithoutProperties$2(_getAttributes203, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm8 0h-4a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm9-2V9.01h-5v2h3V21h-3v2h8v-2h-3z'
  }));
});
QCU132.displayName = 'QCU132';
QCU132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCU132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCU124 = React.forwardRef(function (_ref204, ref) {
  var className = _ref204.className,
      children = _ref204.children,
      style = _ref204.style,
      tabIndex = _ref204.tabIndex,
      rest = _objectWithoutProperties$2(_ref204, ["className", "children", "style", "tabIndex"]);

  var _getAttributes204 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes204.tabindex,
      props = _objectWithoutProperties$2(_getAttributes204, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm8 0h-4a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm9-2V9.01h-5v2h3V21h-3v2h8v-2h-3z'
  }));
});
QCU124.displayName = 'QCU124';
QCU124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCU124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCU120 = React.forwardRef(function (_ref205, ref) {
  var className = _ref205.className,
      children = _ref205.children,
      style = _ref205.style,
      tabIndex = _ref205.tabIndex,
      rest = _objectWithoutProperties$2(_ref205, ["className", "children", "style", "tabIndex"]);

  var _getAttributes205 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes205.tabindex,
      props = _objectWithoutProperties$2(_getAttributes205, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm8 0h-4a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zm9-2V9.01h-5v2h3V21h-3v2h8v-2h-3z'
  }));
});
QCU120.displayName = 'QCU120';
QCU120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCU120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCU332 = React.forwardRef(function (_ref206, ref) {
  var className = _ref206.className,
      children = _ref206.children,
      style = _ref206.style,
      tabIndex = _ref206.tabIndex,
      rest = _objectWithoutProperties$2(_ref206, ["className", "children", "style", "tabIndex"]);

  var _getAttributes206 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes206.tabindex,
      props = _objectWithoutProperties$2(_getAttributes206, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm8 0h-4a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zM28 9h-6v2h6v4h-5v2h5v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
QCU332.displayName = 'QCU332';
QCU332.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCU332.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCU324 = React.forwardRef(function (_ref207, ref) {
  var className = _ref207.className,
      children = _ref207.children,
      style = _ref207.style,
      tabIndex = _ref207.tabIndex,
      rest = _objectWithoutProperties$2(_ref207, ["className", "children", "style", "tabIndex"]);

  var _getAttributes207 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes207.tabindex,
      props = _objectWithoutProperties$2(_getAttributes207, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm8 0h-4a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zM28 9h-6v2h6v4h-5v2h5v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
QCU324.displayName = 'QCU324';
QCU324.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCU324.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCU320 = React.forwardRef(function (_ref208, ref) {
  var className = _ref208.className,
      children = _ref208.children,
      style = _ref208.style,
      tabIndex = _ref208.tabIndex,
      rest = _objectWithoutProperties$2(_ref208, ["className", "children", "style", "tabIndex"]);

  var _getAttributes208 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes208.tabindex,
      props = _objectWithoutProperties$2(_getAttributes208, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm8 0h-4a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2zM28 9h-6v2h6v4h-5v2h5v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
QCU320.displayName = 'QCU320';
QCU320.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCU320.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCY32 = React.forwardRef(function (_ref209, ref) {
  var className = _ref209.className,
      children = _ref209.children,
      style = _ref209.style,
      tabIndex = _ref209.tabIndex,
      rest = _objectWithoutProperties$2(_ref209, ["className", "children", "style", "tabIndex"]);

  var _getAttributes209 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes209.tabindex,
      props = _objectWithoutProperties$2(_getAttributes209, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 23h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm9-14h-2l-2 7-2-7h-2l3 9v5h2v-5l3-9z'
  }));
});
QCY32.displayName = 'QCY32';
QCY32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCY32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCY24 = React.forwardRef(function (_ref210, ref) {
  var className = _ref210.className,
      children = _ref210.children,
      style = _ref210.style,
      tabIndex = _ref210.tabIndex,
      rest = _objectWithoutProperties$2(_ref210, ["className", "children", "style", "tabIndex"]);

  var _getAttributes210 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes210.tabindex,
      props = _objectWithoutProperties$2(_getAttributes210, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 23h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm9-14h-2l-2 7-2-7h-2l3 9v5h2v-5l3-9z'
  }));
});
QCY24.displayName = 'QCY24';
QCY24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCY24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCY20 = React.forwardRef(function (_ref211, ref) {
  var className = _ref211.className,
      children = _ref211.children,
      style = _ref211.style,
      tabIndex = _ref211.tabIndex,
      rest = _objectWithoutProperties$2(_ref211, ["className", "children", "style", "tabIndex"]);

  var _getAttributes211 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes211.tabindex,
      props = _objectWithoutProperties$2(_getAttributes211, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 23h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm9-14h-2l-2 7-2-7h-2l3 9v5h2v-5l3-9z'
  }));
});
QCY20.displayName = 'QCY20';
QCY20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCY20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCZ32 = React.forwardRef(function (_ref212, ref) {
  var className = _ref212.className,
      children = _ref212.children,
      style = _ref212.style,
      tabIndex = _ref212.tabIndex,
      rest = _objectWithoutProperties$2(_ref212, ["className", "children", "style", "tabIndex"]);

  var _getAttributes212 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes212.tabindex,
      props = _objectWithoutProperties$2(_getAttributes212, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 23H9a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H9v6h5zM24 9h-8v2h6l-6 10v2h8v-2h-6l6-10V9z'
  }));
});
QCZ32.displayName = 'QCZ32';
QCZ32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCZ32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCZ24 = React.forwardRef(function (_ref213, ref) {
  var className = _ref213.className,
      children = _ref213.children,
      style = _ref213.style,
      tabIndex = _ref213.tabIndex,
      rest = _objectWithoutProperties$2(_ref213, ["className", "children", "style", "tabIndex"]);

  var _getAttributes213 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes213.tabindex,
      props = _objectWithoutProperties$2(_getAttributes213, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 23H9a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H9v6h5zM24 9h-8v2h6l-6 10v2h8v-2h-6l6-10V9z'
  }));
});
QCZ24.displayName = 'QCZ24';
QCZ24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCZ24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCZ20 = React.forwardRef(function (_ref214, ref) {
  var className = _ref214.className,
      children = _ref214.children,
      style = _ref214.style,
      tabIndex = _ref214.tabIndex,
      rest = _objectWithoutProperties$2(_ref214, ["className", "children", "style", "tabIndex"]);

  var _getAttributes214 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes214.tabindex,
      props = _objectWithoutProperties$2(_getAttributes214, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 23H9a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H9v6h5zM24 9h-8v2h6l-6 10v2h8v-2h-6l6-10V9z'
  }));
});
QCZ20.displayName = 'QCZ20';
QCZ20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCZ20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCcX32 = React.forwardRef(function (_ref215, ref) {
  var className = _ref215.className,
      children = _ref215.children,
      style = _ref215.style,
      tabIndex = _ref215.tabIndex,
      rest = _objectWithoutProperties$2(_ref215, ["className", "children", "style", "tabIndex"]);

  var _getAttributes215 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes215.tabindex,
      props = _objectWithoutProperties$2(_getAttributes215, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm9 0h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zM29 9h-2l-2 6-2-6h-2l2.75 7L21 23h2l2-6 2 6h2l-2.75-7L29 9z'
  }));
});
QCcX32.displayName = 'QCcX32';
QCcX32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCcX32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCcX24 = React.forwardRef(function (_ref216, ref) {
  var className = _ref216.className,
      children = _ref216.children,
      style = _ref216.style,
      tabIndex = _ref216.tabIndex,
      rest = _objectWithoutProperties$2(_ref216, ["className", "children", "style", "tabIndex"]);

  var _getAttributes216 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes216.tabindex,
      props = _objectWithoutProperties$2(_getAttributes216, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm9 0h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zM29 9h-2l-2 6-2-6h-2l2.75 7L21 23h2l2-6 2 6h2l-2.75-7L29 9z'
  }));
});
QCcX24.displayName = 'QCcX24';
QCcX24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCcX24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QCcX20 = React.forwardRef(function (_ref217, ref) {
  var className = _ref217.className,
      children = _ref217.children,
      style = _ref217.style,
      tabIndex = _ref217.tabIndex,
      rest = _objectWithoutProperties$2(_ref217, ["className", "children", "style", "tabIndex"]);

  var _getAttributes217 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes217.tabindex,
      props = _objectWithoutProperties$2(_getAttributes217, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 23H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2H5v6h5zm9 0h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zM29 9h-2l-2 6-2-6h-2l2.75 7L21 23h2l2-6 2 6h2l-2.75-7L29 9z'
  }));
});
QCcX20.displayName = 'QCcX20';
QCcX20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QCcX20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QComposerEdit32 = React.forwardRef(function (_ref218, ref) {
  var className = _ref218.className,
      children = _ref218.children,
      style = _ref218.style,
      tabIndex = _ref218.tabIndex,
      rest = _objectWithoutProperties$2(_ref218, ["className", "children", "style", "tabIndex"]);

  var _getAttributes218 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes218.tabindex,
      props = _objectWithoutProperties$2(_getAttributes218, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.82 10H30V8h-4.18a3 3 0 0 0-5.64 0H13V5H5v3H2v2h3v3h8v-3h7.18A3 3 0 0 0 22 11.82v7.32A4 4 0 0 0 19.14 22H2v2h17.14a4 4 0 0 0 7.72 0H30v-2h-3.14A4 4 0 0 0 24 19.14v-7.32A3 3 0 0 0 25.82 10zM11 11H7V7h4zm14 12a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
QComposerEdit32.displayName = 'QComposerEdit32';
QComposerEdit32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QComposerEdit32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QComposerEdit24 = React.forwardRef(function (_ref219, ref) {
  var className = _ref219.className,
      children = _ref219.children,
      style = _ref219.style,
      tabIndex = _ref219.tabIndex,
      rest = _objectWithoutProperties$2(_ref219, ["className", "children", "style", "tabIndex"]);

  var _getAttributes219 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes219.tabindex,
      props = _objectWithoutProperties$2(_getAttributes219, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.82 10H30V8h-4.18a3 3 0 0 0-5.64 0H13V5H5v3H2v2h3v3h8v-3h7.18A3 3 0 0 0 22 11.82v7.32A4 4 0 0 0 19.14 22H2v2h17.14a4 4 0 0 0 7.72 0H30v-2h-3.14A4 4 0 0 0 24 19.14v-7.32A3 3 0 0 0 25.82 10zM11 11H7V7h4zm14 12a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
QComposerEdit24.displayName = 'QComposerEdit24';
QComposerEdit24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QComposerEdit24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QComposerEdit20 = React.forwardRef(function (_ref220, ref) {
  var className = _ref220.className,
      children = _ref220.children,
      style = _ref220.style,
      tabIndex = _ref220.tabIndex,
      rest = _objectWithoutProperties$2(_ref220, ["className", "children", "style", "tabIndex"]);

  var _getAttributes220 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes220.tabindex,
      props = _objectWithoutProperties$2(_getAttributes220, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.82 10H30V8h-4.18a3 3 0 0 0-5.64 0H13V5H5v3H2v2h3v3h8v-3h7.18A3 3 0 0 0 22 11.82v7.32A4 4 0 0 0 19.14 22H2v2h17.14a4 4 0 0 0 7.72 0H30v-2h-3.14A4 4 0 0 0 24 19.14v-7.32A3 3 0 0 0 25.82 10zM11 11H7V7h4zm14 12a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
QComposerEdit20.displayName = 'QComposerEdit20';
QComposerEdit20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QComposerEdit20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QHintonPlot32 = React.forwardRef(function (_ref221, ref) {
  var className = _ref221.className,
      children = _ref221.children,
      style = _ref221.style,
      tabIndex = _ref221.tabIndex,
      rest = _objectWithoutProperties$2(_ref221, ["className", "children", "style", "tabIndex"]);

  var _getAttributes221 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes221.tabindex,
      props = _objectWithoutProperties$2(_getAttributes221, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 2h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 10h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 18h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 26h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4z'
  }));
});
QHintonPlot32.displayName = 'QHintonPlot32';
QHintonPlot32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QHintonPlot32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QHintonPlot24 = React.forwardRef(function (_ref222, ref) {
  var className = _ref222.className,
      children = _ref222.children,
      style = _ref222.style,
      tabIndex = _ref222.tabIndex,
      rest = _objectWithoutProperties$2(_ref222, ["className", "children", "style", "tabIndex"]);

  var _getAttributes222 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes222.tabindex,
      props = _objectWithoutProperties$2(_getAttributes222, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 2h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 10h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 18h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 26h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4z'
  }));
});
QHintonPlot24.displayName = 'QHintonPlot24';
QHintonPlot24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QHintonPlot24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QHintonPlot20 = React.forwardRef(function (_ref223, ref) {
  var className = _ref223.className,
      children = _ref223.children,
      style = _ref223.style,
      tabIndex = _ref223.tabIndex,
      rest = _objectWithoutProperties$2(_ref223, ["className", "children", "style", "tabIndex"]);

  var _getAttributes223 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes223.tabindex,
      props = _objectWithoutProperties$2(_getAttributes223, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 2h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 10h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 18h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 26h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4z'
  }));
});
QHintonPlot20.displayName = 'QHintonPlot20';
QHintonPlot20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QHintonPlot20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QID32 = React.forwardRef(function (_ref224, ref) {
  var className = _ref224.className,
      children = _ref224.children,
      style = _ref224.style,
      tabIndex = _ref224.tabIndex,
      rest = _objectWithoutProperties$2(_ref224, ["className", "children", "style", "tabIndex"]);

  var _getAttributes224 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes224.tabindex,
      props = _objectWithoutProperties$2(_getAttributes224, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 9h2v2h-2zm8 14h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zm-6-8h2v10h-2z'
  }));
});
QID32.displayName = 'QID32';
QID32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QID32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QID24 = React.forwardRef(function (_ref225, ref) {
  var className = _ref225.className,
      children = _ref225.children,
      style = _ref225.style,
      tabIndex = _ref225.tabIndex,
      rest = _objectWithoutProperties$2(_ref225, ["className", "children", "style", "tabIndex"]);

  var _getAttributes225 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes225.tabindex,
      props = _objectWithoutProperties$2(_getAttributes225, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 9h2v2h-2zm8 14h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zm-6-8h2v10h-2z'
  }));
});
QID24.displayName = 'QID24';
QID24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QID24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QID20 = React.forwardRef(function (_ref226, ref) {
  var className = _ref226.className,
      children = _ref226.children,
      style = _ref226.style,
      tabIndex = _ref226.tabIndex,
      rest = _objectWithoutProperties$2(_ref226, ["className", "children", "style", "tabIndex"]);

  var _getAttributes226 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes226.tabindex,
      props = _objectWithoutProperties$2(_getAttributes226, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 9h2v2h-2zm8 14h-4V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2zm-6-8h2v10h-2z'
  }));
});
QID20.displayName = 'QID20';
QID20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QID20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QMatrix32 = React.forwardRef(function (_ref227, ref) {
  var className = _ref227.className,
      children = _ref227.children,
      style = _ref227.style,
      tabIndex = _ref227.tabIndex,
      rest = _objectWithoutProperties$2(_ref227, ["className", "children", "style", "tabIndex"]);

  var _getAttributes227 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes227.tabindex,
      props = _objectWithoutProperties$2(_getAttributes227, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zm-1.5 7a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zM8 30H2V2h6v2H4v24h4v2zm22 0h-6v-2h4V4h-4V2h6v28z'
  }));
});
QMatrix32.displayName = 'QMatrix32';
QMatrix32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QMatrix32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QMatrix24 = React.forwardRef(function (_ref228, ref) {
  var className = _ref228.className,
      children = _ref228.children,
      style = _ref228.style,
      tabIndex = _ref228.tabIndex,
      rest = _objectWithoutProperties$2(_ref228, ["className", "children", "style", "tabIndex"]);

  var _getAttributes228 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes228.tabindex,
      props = _objectWithoutProperties$2(_getAttributes228, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zm-1.5 7a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zM8 30H2V2h6v2H4v24h4v2zm22 0h-6v-2h4V4h-4V2h6v28z'
  }));
});
QMatrix24.displayName = 'QMatrix24';
QMatrix24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QMatrix24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QMatrix20 = React.forwardRef(function (_ref229, ref) {
  var className = _ref229.className,
      children = _ref229.children,
      style = _ref229.style,
      tabIndex = _ref229.tabIndex,
      rest = _objectWithoutProperties$2(_ref229, ["className", "children", "style", "tabIndex"]);

  var _getAttributes229 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes229.tabindex,
      props = _objectWithoutProperties$2(_getAttributes229, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zm-1.5 7a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zM8 30H2V2h6v2H4v24h4v2zm22 0h-6v-2h4V4h-4V2h6v28z'
  }));
});
QMatrix20.displayName = 'QMatrix20';
QMatrix20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QMatrix20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperationGauge32 = React.forwardRef(function (_ref230, ref) {
  var className = _ref230.className,
      children = _ref230.children,
      style = _ref230.style,
      tabIndex = _ref230.tabIndex,
      rest = _objectWithoutProperties$2(_ref230, ["className", "children", "style", "tabIndex"]);

  var _getAttributes230 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes230.tabindex,
      props = _objectWithoutProperties$2(_getAttributes230, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 4h-6v2h3.75L24 10v2h6v-2h-3.62L30 6V4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 0 0 2 28h2a10 10 0 0 1 13.16-9.48L14 24a2 2 0 1 0 2 2 2 2 0 0 0-.27-1L19 19.35A10 10 0 0 1 24 28h2a12 12 0 0 0-6-10.38z'
  }));
});
QOperationGauge32.displayName = 'QOperationGauge32';
QOperationGauge32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperationGauge32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperationGauge24 = React.forwardRef(function (_ref231, ref) {
  var className = _ref231.className,
      children = _ref231.children,
      style = _ref231.style,
      tabIndex = _ref231.tabIndex,
      rest = _objectWithoutProperties$2(_ref231, ["className", "children", "style", "tabIndex"]);

  var _getAttributes231 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes231.tabindex,
      props = _objectWithoutProperties$2(_getAttributes231, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 4h-6v2h3.75L24 10v2h6v-2h-3.62L30 6V4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 0 0 2 28h2a10 10 0 0 1 13.16-9.48L14 24a2 2 0 1 0 2 2 2 2 0 0 0-.27-1L19 19.35A10 10 0 0 1 24 28h2a12 12 0 0 0-6-10.38z'
  }));
});
QOperationGauge24.displayName = 'QOperationGauge24';
QOperationGauge24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperationGauge24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperationGauge20 = React.forwardRef(function (_ref232, ref) {
  var className = _ref232.className,
      children = _ref232.children,
      style = _ref232.style,
      tabIndex = _ref232.tabIndex,
      rest = _objectWithoutProperties$2(_ref232, ["className", "children", "style", "tabIndex"]);

  var _getAttributes232 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes232.tabindex,
      props = _objectWithoutProperties$2(_getAttributes232, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 4h-6v2h3.75L24 10v2h6v-2h-3.62L30 6V4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 0 0 2 28h2a10 10 0 0 1 13.16-9.48L14 24a2 2 0 1 0 2 2 2 2 0 0 0-.27-1L19 19.35A10 10 0 0 1 24 28h2a12 12 0 0 0-6-10.38z'
  }));
});
QOperationGauge20.displayName = 'QOperationGauge20';
QOperationGauge20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperationGauge20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperationIf32 = React.forwardRef(function (_ref233, ref) {
  var className = _ref233.className,
      children = _ref233.children,
      style = _ref233.style,
      tabIndex = _ref233.tabIndex,
      rest = _objectWithoutProperties$2(_ref233, ["className", "children", "style", "tabIndex"]);

  var _getAttributes233 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes233.tabindex,
      props = _objectWithoutProperties$2(_getAttributes233, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 13h2v10h-2zm0-4h2v2h-2zm11 2V9h-3a2 2 0 0 0-2 2v2h-2v2h2v8h2v-8h3v-2h-3v-2z'
  }));
});
QOperationIf32.displayName = 'QOperationIf32';
QOperationIf32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperationIf32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperationIf24 = React.forwardRef(function (_ref234, ref) {
  var className = _ref234.className,
      children = _ref234.children,
      style = _ref234.style,
      tabIndex = _ref234.tabIndex,
      rest = _objectWithoutProperties$2(_ref234, ["className", "children", "style", "tabIndex"]);

  var _getAttributes234 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes234.tabindex,
      props = _objectWithoutProperties$2(_getAttributes234, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 13h2v10h-2zm0-4h2v2h-2zm11 2V9h-3a2 2 0 0 0-2 2v2h-2v2h2v8h2v-8h3v-2h-3v-2z'
  }));
});
QOperationIf24.displayName = 'QOperationIf24';
QOperationIf24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperationIf24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperationIf20 = React.forwardRef(function (_ref235, ref) {
  var className = _ref235.className,
      children = _ref235.children,
      style = _ref235.style,
      tabIndex = _ref235.tabIndex,
      rest = _objectWithoutProperties$2(_ref235, ["className", "children", "style", "tabIndex"]);

  var _getAttributes235 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes235.tabindex,
      props = _objectWithoutProperties$2(_getAttributes235, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 13h2v10h-2zm0-4h2v2h-2zm11 2V9h-3a2 2 0 0 0-2 2v2h-2v2h2v8h2v-8h3v-2h-3v-2z'
  }));
});
QOperationIf20.displayName = 'QOperationIf20';
QOperationIf20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperationIf20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperation32 = React.forwardRef(function (_ref236, ref) {
  var className = _ref236.className,
      children = _ref236.children,
      style = _ref236.style,
      tabIndex = _ref236.tabIndex,
      rest = _objectWithoutProperties$2(_ref236, ["className", "children", "style", "tabIndex"]);

  var _getAttributes236 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes236.tabindex,
      props = _objectWithoutProperties$2(_getAttributes236, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 26h-2l5-10-5-10h2l5 10-5 10zM4 6h2v20H4zm12 3h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 12h-4V11h4z'
  }), React.createElement('path', {
    d: 'M13 15h2v2h-2z'
  }));
});
QOperation32.displayName = 'QOperation32';
QOperation32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperation32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperation24 = React.forwardRef(function (_ref237, ref) {
  var className = _ref237.className,
      children = _ref237.children,
      style = _ref237.style,
      tabIndex = _ref237.tabIndex,
      rest = _objectWithoutProperties$2(_ref237, ["className", "children", "style", "tabIndex"]);

  var _getAttributes237 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes237.tabindex,
      props = _objectWithoutProperties$2(_getAttributes237, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 26h-2l5-10-5-10h2l5 10-5 10zM4 6h2v20H4zm12 3h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 12h-4V11h4z'
  }), React.createElement('path', {
    d: 'M13 15h2v2h-2z'
  }));
});
QOperation24.displayName = 'QOperation24';
QOperation24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperation24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QOperation20 = React.forwardRef(function (_ref238, ref) {
  var className = _ref238.className,
      children = _ref238.children,
      style = _ref238.style,
      tabIndex = _ref238.tabIndex,
      rest = _objectWithoutProperties$2(_ref238, ["className", "children", "style", "tabIndex"]);

  var _getAttributes238 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes238.tabindex,
      props = _objectWithoutProperties$2(_getAttributes238, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 26h-2l5-10-5-10h2l5 10-5 10zM4 6h2v20H4zm12 3h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 12h-4V11h4z'
  }), React.createElement('path', {
    d: 'M13 15h2v2h-2z'
  }));
});
QOperation20.displayName = 'QOperation20';
QOperation20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QOperation20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Raw32 = React.forwardRef(function (_ref239, ref) {
  var className = _ref239.className,
      children = _ref239.children,
      style = _ref239.style,
      tabIndex = _ref239.tabIndex,
      rest = _objectWithoutProperties$2(_ref239, ["className", "children", "style", "tabIndex"]);

  var _getAttributes239 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes239.tabindex,
      props = _objectWithoutProperties$2(_getAttributes239, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.2 9l-.34 8-.26 4.54-.41-3.54-.68-5.46h-2.02L24.81 18l-.41 3.54-.26-4.54-.34-8H22l1 14h2.27l.76-4.93.46-4.07.01-.03.01.03.46 4.07.76 4.93H30l1-14h-1.8zM18 9h-4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm-4-1v-4a2 2 0 0 0-2-2H2v14h2v-6h1.48l2.34 6H10l-2.37-6H8a2 2 0 0 0 2-2zm-6-4h4v4H4z'
  }));
});
Raw32.displayName = 'Raw32';
Raw32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Raw32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Raw24 = React.forwardRef(function (_ref240, ref) {
  var className = _ref240.className,
      children = _ref240.children,
      style = _ref240.style,
      tabIndex = _ref240.tabIndex,
      rest = _objectWithoutProperties$2(_ref240, ["className", "children", "style", "tabIndex"]);

  var _getAttributes240 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes240.tabindex,
      props = _objectWithoutProperties$2(_getAttributes240, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.2 9l-.34 8-.26 4.54-.41-3.54-.68-5.46h-2.02L24.81 18l-.41 3.54-.26-4.54-.34-8H22l1 14h2.27l.76-4.93.46-4.07.01-.03.01.03.46 4.07.76 4.93H30l1-14h-1.8zM18 9h-4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm-4-1v-4a2 2 0 0 0-2-2H2v14h2v-6h1.48l2.34 6H10l-2.37-6H8a2 2 0 0 0 2-2zm-6-4h4v4H4z'
  }));
});
Raw24.displayName = 'Raw24';
Raw24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Raw24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Raw20 = React.forwardRef(function (_ref241, ref) {
  var className = _ref241.className,
      children = _ref241.children,
      style = _ref241.style,
      tabIndex = _ref241.tabIndex,
      rest = _objectWithoutProperties$2(_ref241, ["className", "children", "style", "tabIndex"]);

  var _getAttributes241 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes241.tabindex,
      props = _objectWithoutProperties$2(_getAttributes241, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.2 9l-.34 8-.26 4.54-.41-3.54-.68-5.46h-2.02L24.81 18l-.41 3.54-.26-4.54-.34-8H22l1 14h2.27l.76-4.93.46-4.07.01-.03.01.03.46 4.07.76 4.93H30l1-14h-1.8zM18 9h-4a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5zm-4-1v-4a2 2 0 0 0-2-2H2v14h2v-6h1.48l2.34 6H10l-2.37-6H8a2 2 0 0 0 2-2zm-6-4h4v4H4z'
  }));
});
Raw20.displayName = 'Raw20';
Raw20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Raw20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Sql32 = React.forwardRef(function (_ref242, ref) {
  var className = _ref242.className,
      children = _ref242.children,
      style = _ref242.style,
      tabIndex = _ref242.tabIndex,
      rest = _objectWithoutProperties$2(_ref242, ["className", "children", "style", "tabIndex"]);

  var _getAttributes242 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes242.tabindex,
      props = _objectWithoutProperties$2(_getAttributes242, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21V9h-2v14h8v-2h-6zM18 9h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h2v-2h-2v-2h1a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm-4 12V11h4v10zm-6 2H2v-2h6v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H4v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Sql32.displayName = 'Sql32';
Sql32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Sql32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Sql24 = React.forwardRef(function (_ref243, ref) {
  var className = _ref243.className,
      children = _ref243.children,
      style = _ref243.style,
      tabIndex = _ref243.tabIndex,
      rest = _objectWithoutProperties$2(_ref243, ["className", "children", "style", "tabIndex"]);

  var _getAttributes243 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes243.tabindex,
      props = _objectWithoutProperties$2(_getAttributes243, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21V9h-2v14h8v-2h-6zM18 9h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h2v-2h-2v-2h1a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm-4 12V11h4v10zm-6 2H2v-2h6v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H4v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Sql24.displayName = 'Sql24';
Sql24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Sql24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Sql20 = React.forwardRef(function (_ref244, ref) {
  var className = _ref244.className,
      children = _ref244.children,
      style = _ref244.style,
      tabIndex = _ref244.tabIndex,
      rest = _objectWithoutProperties$2(_ref244, ["className", "children", "style", "tabIndex"]);

  var _getAttributes244 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes244.tabindex,
      props = _objectWithoutProperties$2(_getAttributes244, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21V9h-2v14h8v-2h-6zM18 9h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h2v-2h-2v-2h1a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm-4 12V11h4v10zm-6 2H2v-2h6v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H4v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Sql20.displayName = 'Sql20';
Sql20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Sql20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Svg32 = React.forwardRef(function (_ref245, ref) {
  var className = _ref245.className,
      children = _ref245.children,
      style = _ref245.style,
      tabIndex = _ref245.tabIndex,
      rest = _objectWithoutProperties$2(_ref245, ["className", "children", "style", "tabIndex"]);

  var _getAttributes245 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes245.tabindex,
      props = _objectWithoutProperties$2(_getAttributes245, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zM18 9l-2 13-2-13h-2l2.52 14h2.96L20 9h-2zM8 23H2v-2h6v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H4v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Svg32.displayName = 'Svg32';
Svg32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Svg32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Svg24 = React.forwardRef(function (_ref246, ref) {
  var className = _ref246.className,
      children = _ref246.children,
      style = _ref246.style,
      tabIndex = _ref246.tabIndex,
      rest = _objectWithoutProperties$2(_ref246, ["className", "children", "style", "tabIndex"]);

  var _getAttributes246 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes246.tabindex,
      props = _objectWithoutProperties$2(_getAttributes246, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zM18 9l-2 13-2-13h-2l2.52 14h2.96L20 9h-2zM8 23H2v-2h6v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H4v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Svg24.displayName = 'Svg24';
Svg24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Svg24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Svg20 = React.forwardRef(function (_ref247, ref) {
  var className = _ref247.className,
      children = _ref247.children,
      style = _ref247.style,
      tabIndex = _ref247.tabIndex,
      rest = _objectWithoutProperties$2(_ref247, ["className", "children", "style", "tabIndex"]);

  var _getAttributes247 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes247.tabindex,
      props = _objectWithoutProperties$2(_getAttributes247, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 23h-6a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2h-6v10h4v-4h-2v-2h4zM18 9l-2 13-2-13h-2l2.52 14h2.96L20 9h-2zM8 23H2v-2h6v-4H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H4v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Svg20.displayName = 'Svg20';
Svg20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Svg20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tif32 = React.forwardRef(function (_ref248, ref) {
  var className = _ref248.className,
      children = _ref248.children,
      style = _ref248.style,
      tabIndex = _ref248.tabIndex,
      rest = _objectWithoutProperties$2(_ref248, ["className", "children", "style", "tabIndex"]);

  var _getAttributes248 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes248.tabindex,
      props = _objectWithoutProperties$2(_getAttributes248, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 11V9h-8v14h2v-6h5v-2h-5v-4h6zm-18 0h3v10h-3v2h8v-2h-3V11h3V9h-8v2zM2 11h3v12h2V11h3V9H2v2z'
  }));
});
Tif32.displayName = 'Tif32';
Tif32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tif32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tif24 = React.forwardRef(function (_ref249, ref) {
  var className = _ref249.className,
      children = _ref249.children,
      style = _ref249.style,
      tabIndex = _ref249.tabIndex,
      rest = _objectWithoutProperties$2(_ref249, ["className", "children", "style", "tabIndex"]);

  var _getAttributes249 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes249.tabindex,
      props = _objectWithoutProperties$2(_getAttributes249, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 11V9h-8v14h2v-6h5v-2h-5v-4h6zm-18 0h3v10h-3v2h8v-2h-3V11h3V9h-8v2zM2 11h3v12h2V11h3V9H2v2z'
  }));
});
Tif24.displayName = 'Tif24';
Tif24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tif24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tif20 = React.forwardRef(function (_ref250, ref) {
  var className = _ref250.className,
      children = _ref250.children,
      style = _ref250.style,
      tabIndex = _ref250.tabIndex,
      rest = _objectWithoutProperties$2(_ref250, ["className", "children", "style", "tabIndex"]);

  var _getAttributes250 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes250.tabindex,
      props = _objectWithoutProperties$2(_getAttributes250, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 11V9h-8v14h2v-6h5v-2h-5v-4h6zm-18 0h3v10h-3v2h8v-2h-3V11h3V9h-8v2zM2 11h3v12h2V11h3V9H2v2z'
  }));
});
Tif20.displayName = 'Tif20';
Tif20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tif20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Txt32 = React.forwardRef(function (_ref251, ref) {
  var className = _ref251.className,
      children = _ref251.children,
      style = _ref251.style,
      tabIndex = _ref251.tabIndex,
      rest = _objectWithoutProperties$2(_ref251, ["className", "children", "style", "tabIndex"]);

  var _getAttributes251 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes251.tabindex,
      props = _objectWithoutProperties$2(_getAttributes251, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 11h3v12h2V11h3V9h-8v2zm-1-2h-2l-2 6-2-6h-2l2.75 7L12 23h2l2-6 2 6h2l-2.75-7L20 9zM3 11h3v12h2V11h3V9H3v2z'
  }));
});
Txt32.displayName = 'Txt32';
Txt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Txt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Txt24 = React.forwardRef(function (_ref252, ref) {
  var className = _ref252.className,
      children = _ref252.children,
      style = _ref252.style,
      tabIndex = _ref252.tabIndex,
      rest = _objectWithoutProperties$2(_ref252, ["className", "children", "style", "tabIndex"]);

  var _getAttributes252 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes252.tabindex,
      props = _objectWithoutProperties$2(_getAttributes252, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 11h3v12h2V11h3V9h-8v2zm-1-2h-2l-2 6-2-6h-2l2.75 7L12 23h2l2-6 2 6h2l-2.75-7L20 9zM3 11h3v12h2V11h3V9H3v2z'
  }));
});
Txt24.displayName = 'Txt24';
Txt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Txt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Txt20 = React.forwardRef(function (_ref253, ref) {
  var className = _ref253.className,
      children = _ref253.children,
      style = _ref253.style,
      tabIndex = _ref253.tabIndex,
      rest = _objectWithoutProperties$2(_ref253, ["className", "children", "style", "tabIndex"]);

  var _getAttributes253 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes253.tabindex,
      props = _objectWithoutProperties$2(_getAttributes253, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 11h3v12h2V11h3V9h-8v2zm-1-2h-2l-2 6-2-6h-2l2.75 7L12 23h2l2-6 2 6h2l-2.75-7L20 9zM3 11h3v12h2V11h3V9H3v2z'
  }));
});
Txt20.displayName = 'Txt20';
Txt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Txt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Usb32 = React.forwardRef(function (_ref254, ref) {
  var className = _ref254.className,
      children = _ref254.children,
      style = _ref254.style,
      tabIndex = _ref254.tabIndex,
      rest = _objectWithoutProperties$2(_ref254, ["className", "children", "style", "tabIndex"]);

  var _getAttributes254 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes254.tabindex,
      props = _objectWithoutProperties$2(_getAttributes254, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 15V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v9a2 2 0 0 0-2 2v11h2V17h16v11h2V17a2 2 0 0 0-2-2zM10 6h12v9H10z'
  }), React.createElement('path', {
    d: 'M12 10h3v2h-3zm5 0h3v2h-3z'
  }));
});
Usb32.displayName = 'Usb32';
Usb32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Usb32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Usb24 = React.forwardRef(function (_ref255, ref) {
  var className = _ref255.className,
      children = _ref255.children,
      style = _ref255.style,
      tabIndex = _ref255.tabIndex,
      rest = _objectWithoutProperties$2(_ref255, ["className", "children", "style", "tabIndex"]);

  var _getAttributes255 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes255.tabindex,
      props = _objectWithoutProperties$2(_getAttributes255, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 15V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v9a2 2 0 0 0-2 2v11h2V17h16v11h2V17a2 2 0 0 0-2-2zM10 6h12v9H10z'
  }), React.createElement('path', {
    d: 'M12 10h3v2h-3zm5 0h3v2h-3z'
  }));
});
Usb24.displayName = 'Usb24';
Usb24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Usb24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Usb20 = React.forwardRef(function (_ref256, ref) {
  var className = _ref256.className,
      children = _ref256.children,
      style = _ref256.style,
      tabIndex = _ref256.tabIndex,
      rest = _objectWithoutProperties$2(_ref256, ["className", "children", "style", "tabIndex"]);

  var _getAttributes256 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes256.tabindex,
      props = _objectWithoutProperties$2(_getAttributes256, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 15V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v9a2 2 0 0 0-2 2v11h2V17h16v11h2V17a2 2 0 0 0-2-2zM10 6h12v9H10z'
  }), React.createElement('path', {
    d: 'M12 10h3v2h-3zm5 0h3v2h-3z'
  }));
});
Usb20.displayName = 'Usb20';
Usb20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Usb20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Vpn32 = React.forwardRef(function (_ref257, ref) {
  var className = _ref257.className,
      children = _ref257.children,
      style = _ref257.style,
      tabIndex = _ref257.tabIndex,
      rest = _objectWithoutProperties$2(_ref257, ["className", "children", "style", "tabIndex"]);

  var _getAttributes257 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes257.tabindex,
      props = _objectWithoutProperties$2(_getAttributes257, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zm14 3L24.32 9H22v14h2V13l3.68 10H30V9h-2v10zM8 9L6 22 4 9H2l2.52 14h2.96L10 9H8z'
  }));
});
Vpn32.displayName = 'Vpn32';
Vpn32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Vpn32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Vpn24 = React.forwardRef(function (_ref258, ref) {
  var className = _ref258.className,
      children = _ref258.children,
      style = _ref258.style,
      tabIndex = _ref258.tabIndex,
      rest = _objectWithoutProperties$2(_ref258, ["className", "children", "style", "tabIndex"]);

  var _getAttributes258 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes258.tabindex,
      props = _objectWithoutProperties$2(_getAttributes258, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zm14 3L24.32 9H22v14h2V13l3.68 10H30V9h-2v10zM8 9L6 22 4 9H2l2.52 14h2.96L10 9H8z'
  }));
});
Vpn24.displayName = 'Vpn24';
Vpn24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Vpn24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Vpn20 = React.forwardRef(function (_ref259, ref) {
  var className = _ref259.className,
      children = _ref259.children,
      style = _ref259.style,
      tabIndex = _ref259.tabIndex,
      rest = _objectWithoutProperties$2(_ref259, ["className", "children", "style", "tabIndex"]);

  var _getAttributes259 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes259.tabindex,
      props = _objectWithoutProperties$2(_getAttributes259, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 23h-2V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4zm0-7h4v-5h-4zm14 3L24.32 9H22v14h2V13l3.68 10H30V9h-2v10zM8 9L6 22 4 9H2l2.52 14h2.96L10 9H8z'
  }));
});
Vpn20.displayName = 'Vpn20';
Vpn20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Vpn20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wmv32 = React.forwardRef(function (_ref260, ref) {
  var className = _ref260.className,
      children = _ref260.children,
      style = _ref260.style,
      tabIndex = _ref260.tabIndex,
      rest = _objectWithoutProperties$2(_ref260, ["className", "children", "style", "tabIndex"]);

  var _getAttributes260 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes260.tabindex,
      props = _objectWithoutProperties$2(_getAttributes260, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 9l-2 13-2-13h-2l2.52 14h2.96L31 9h-2zM19 9l-1.52 5-.48 1.98-.46-1.98L15 9h-2v14h2v-8l-.16-2 .58 2L17 19.63 18.58 15l.58-2-.16 2v8h2V9h-2zM9.2 9l-.34 8-.26 4.54L8.19 18l-.68-5.46H5.49L4.81 18l-.41 3.54L4.14 17 3.8 9H2l1 14h2.27l.76-4.93.46-4.07.01-.03.01.03.46 4.07.76 4.93H10l1-14H9.2z'
  }));
});
Wmv32.displayName = 'Wmv32';
Wmv32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wmv32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wmv24 = React.forwardRef(function (_ref261, ref) {
  var className = _ref261.className,
      children = _ref261.children,
      style = _ref261.style,
      tabIndex = _ref261.tabIndex,
      rest = _objectWithoutProperties$2(_ref261, ["className", "children", "style", "tabIndex"]);

  var _getAttributes261 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes261.tabindex,
      props = _objectWithoutProperties$2(_getAttributes261, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 9l-2 13-2-13h-2l2.52 14h2.96L31 9h-2zM19 9l-1.52 5-.48 1.98-.46-1.98L15 9h-2v14h2v-8l-.16-2 .58 2L17 19.63 18.58 15l.58-2-.16 2v8h2V9h-2zM9.2 9l-.34 8-.26 4.54L8.19 18l-.68-5.46H5.49L4.81 18l-.41 3.54L4.14 17 3.8 9H2l1 14h2.27l.76-4.93.46-4.07.01-.03.01.03.46 4.07.76 4.93H10l1-14H9.2z'
  }));
});
Wmv24.displayName = 'Wmv24';
Wmv24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wmv24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wmv20 = React.forwardRef(function (_ref262, ref) {
  var className = _ref262.className,
      children = _ref262.children,
      style = _ref262.style,
      tabIndex = _ref262.tabIndex,
      rest = _objectWithoutProperties$2(_ref262, ["className", "children", "style", "tabIndex"]);

  var _getAttributes262 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes262.tabindex,
      props = _objectWithoutProperties$2(_getAttributes262, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 9l-2 13-2-13h-2l2.52 14h2.96L31 9h-2zM19 9l-1.52 5-.48 1.98-.46-1.98L15 9h-2v14h2v-8l-.16-2 .58 2L17 19.63 18.58 15l.58-2-.16 2v8h2V9h-2zM9.2 9l-.34 8-.26 4.54L8.19 18l-.68-5.46H5.49L4.81 18l-.41 3.54L4.14 17 3.8 9H2l1 14h2.27l.76-4.93.46-4.07.01-.03.01.03.46 4.07.76 4.93H10l1-14H9.2z'
  }));
});
Wmv20.displayName = 'Wmv20';
Wmv20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wmv20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Xml32 = React.forwardRef(function (_ref263, ref) {
  var className = _ref263.className,
      children = _ref263.children,
      style = _ref263.style,
      tabIndex = _ref263.tabIndex,
      rest = _objectWithoutProperties$2(_ref263, ["className", "children", "style", "tabIndex"]);

  var _getAttributes263 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes263.tabindex,
      props = _objectWithoutProperties$2(_getAttributes263, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21V9h-2v14h8v-2h-6zM18 9l-1.52 5-.48 1.98-.46-1.98L14 9h-2v14h2v-8l-.16-2 .58 2L16 19.63 17.58 15l.58-2-.16 2v8h2V9h-2zm-8 0H8l-2 6-2-6H2l2.75 7L2 23h2l2-6 2 6h2l-2.75-7L10 9z'
  }));
});
Xml32.displayName = 'Xml32';
Xml32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Xml32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Xml24 = React.forwardRef(function (_ref264, ref) {
  var className = _ref264.className,
      children = _ref264.children,
      style = _ref264.style,
      tabIndex = _ref264.tabIndex,
      rest = _objectWithoutProperties$2(_ref264, ["className", "children", "style", "tabIndex"]);

  var _getAttributes264 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes264.tabindex,
      props = _objectWithoutProperties$2(_getAttributes264, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21V9h-2v14h8v-2h-6zM18 9l-1.52 5-.48 1.98-.46-1.98L14 9h-2v14h2v-8l-.16-2 .58 2L16 19.63 17.58 15l.58-2-.16 2v8h2V9h-2zm-8 0H8l-2 6-2-6H2l2.75 7L2 23h2l2-6 2 6h2l-2.75-7L10 9z'
  }));
});
Xml24.displayName = 'Xml24';
Xml24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Xml24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Xml20 = React.forwardRef(function (_ref265, ref) {
  var className = _ref265.className,
      children = _ref265.children,
      style = _ref265.style,
      tabIndex = _ref265.tabIndex,
      rest = _objectWithoutProperties$2(_ref265, ["className", "children", "style", "tabIndex"]);

  var _getAttributes265 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes265.tabindex,
      props = _objectWithoutProperties$2(_getAttributes265, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 21V9h-2v14h8v-2h-6zM18 9l-1.52 5-.48 1.98-.46-1.98L14 9h-2v14h2v-8l-.16-2 .58 2L16 19.63 17.58 15l.58-2-.16 2v8h2V9h-2zm-8 0H8l-2 6-2-6H2l2.75 7L2 23h2l2-6 2 6h2l-2.75-7L10 9z'
  }));
});
Xml20.displayName = 'Xml20';
Xml20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Xml20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Zip32 = React.forwardRef(function (_ref266, ref) {
  var className = _ref266.className,
      children = _ref266.children,
      style = _ref266.style,
      tabIndex = _ref266.tabIndex,
      rest = _objectWithoutProperties$2(_ref266, ["className", "children", "style", "tabIndex"]);

  var _getAttributes266 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes266.tabindex,
      props = _objectWithoutProperties$2(_getAttributes266, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-6v14h2v-5h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm0 7h-4v-5h4zM12 9v2h3v10h-3v2h8v-2h-3V11h3V9h-8zm-2 0H2v2h6L2 21v2h8v-2H4l6-10V9z'
  }));
});
Zip32.displayName = 'Zip32';
Zip32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Zip32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Zip24 = React.forwardRef(function (_ref267, ref) {
  var className = _ref267.className,
      children = _ref267.children,
      style = _ref267.style,
      tabIndex = _ref267.tabIndex,
      rest = _objectWithoutProperties$2(_ref267, ["className", "children", "style", "tabIndex"]);

  var _getAttributes267 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes267.tabindex,
      props = _objectWithoutProperties$2(_getAttributes267, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-6v14h2v-5h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm0 7h-4v-5h4zM12 9v2h3v10h-3v2h8v-2h-3V11h3V9h-8zm-2 0H2v2h6L2 21v2h8v-2H4l6-10V9z'
  }));
});
Zip24.displayName = 'Zip24';
Zip24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Zip24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Zip20 = React.forwardRef(function (_ref268, ref) {
  var className = _ref268.className,
      children = _ref268.children,
      style = _ref268.style,
      tabIndex = _ref268.tabIndex,
      rest = _objectWithoutProperties$2(_ref268, ["className", "children", "style", "tabIndex"]);

  var _getAttributes268 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes268.tabindex,
      props = _objectWithoutProperties$2(_getAttributes268, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-6v14h2v-5h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm0 7h-4v-5h4zM12 9v2h3v10h-3v2h8v-2h-3V11h3V9h-8zm-2 0H2v2h6L2 21v2h8v-2H4l6-10V9z'
  }));
});
Zip20.displayName = 'Zip20';
Zip20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Zip20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Accessibility32 = React.forwardRef(function (_ref269, ref) {
  var className = _ref269.className,
      children = _ref269.children,
      style = _ref269.style,
      tabIndex = _ref269.tabIndex,
      rest = _objectWithoutProperties$2(_ref269, ["className", "children", "style", "tabIndex"]);

  var _getAttributes269 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes269.tabindex,
      props = _objectWithoutProperties$2(_getAttributes269, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.55 26.11l-3.05 1.52L23.66 21H15a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v4h7v-2h-5v-2a4 4 0 0 0-8 0v1a9 9 0 1 0 8.77 11h-2.06A7 7 0 1 1 11 16v3a4 4 0 0 0 4 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1 1 19 4.5 3.5 3.5 0 0 1 15.5 8zm0-5A1.5 1.5 0 1 0 17 4.5 1.5 1.5 0 0 0 15.5 3z'
  }));
});
Accessibility32.displayName = 'Accessibility32';
Accessibility32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Accessibility32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Accessibility24 = React.forwardRef(function (_ref270, ref) {
  var className = _ref270.className,
      children = _ref270.children,
      style = _ref270.style,
      tabIndex = _ref270.tabIndex,
      rest = _objectWithoutProperties$2(_ref270, ["className", "children", "style", "tabIndex"]);

  var _getAttributes270 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes270.tabindex,
      props = _objectWithoutProperties$2(_getAttributes270, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.55 26.11l-3.05 1.52L23.66 21H15a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v4h7v-2h-5v-2a4 4 0 0 0-8 0v1a9 9 0 1 0 8.77 11h-2.06A7 7 0 1 1 11 16v3a4 4 0 0 0 4 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1 1 19 4.5 3.5 3.5 0 0 1 15.5 8zm0-5A1.5 1.5 0 1 0 17 4.5 1.5 1.5 0 0 0 15.5 3z'
  }));
});
Accessibility24.displayName = 'Accessibility24';
Accessibility24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Accessibility24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Accessibility20 = React.forwardRef(function (_ref271, ref) {
  var className = _ref271.className,
      children = _ref271.children,
      style = _ref271.style,
      tabIndex = _ref271.tabIndex,
      rest = _objectWithoutProperties$2(_ref271, ["className", "children", "style", "tabIndex"]);

  var _getAttributes271 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes271.tabindex,
      props = _objectWithoutProperties$2(_getAttributes271, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.55 26.11l-3.05 1.52L23.66 21H15a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v4h7v-2h-5v-2a4 4 0 0 0-8 0v1a9 9 0 1 0 8.77 11h-2.06A7 7 0 1 1 11 16v3a4 4 0 0 0 4 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1 1 19 4.5 3.5 3.5 0 0 1 15.5 8zm0-5A1.5 1.5 0 1 0 17 4.5 1.5 1.5 0 0 0 15.5 3z'
  }));
});
Accessibility20.displayName = 'Accessibility20';
Accessibility20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Accessibility20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Activity32 = React.forwardRef(function (_ref272, ref) {
  var className = _ref272.className,
      children = _ref272.children,
      style = _ref272.style,
      tabIndex = _ref272.tabIndex,
      rest = _objectWithoutProperties$2(_ref272, ["className", "children", "style", "tabIndex"]);

  var _getAttributes272 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes272.tabindex,
      props = _objectWithoutProperties$2(_getAttributes272, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 29a1 1 0 0 1-.92-.62L6.33 17H2v-2h5a1 1 0 0 1 .92.62L12 25.28l8.06-21.63A1 1 0 0 1 21 3a1 1 0 0 1 .93.68L25.72 15H30v2h-5a1 1 0 0 1-.95-.68L21 7l-8.06 21.35A1 1 0 0 1 12 29z'
  }));
});
Activity32.displayName = 'Activity32';
Activity32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Activity32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Activity24 = React.forwardRef(function (_ref273, ref) {
  var className = _ref273.className,
      children = _ref273.children,
      style = _ref273.style,
      tabIndex = _ref273.tabIndex,
      rest = _objectWithoutProperties$2(_ref273, ["className", "children", "style", "tabIndex"]);

  var _getAttributes273 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes273.tabindex,
      props = _objectWithoutProperties$2(_getAttributes273, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 29a1 1 0 0 1-.92-.62L6.33 17H2v-2h5a1 1 0 0 1 .92.62L12 25.28l8.06-21.63A1 1 0 0 1 21 3a1 1 0 0 1 .93.68L25.72 15H30v2h-5a1 1 0 0 1-.95-.68L21 7l-8.06 21.35A1 1 0 0 1 12 29z'
  }));
});
Activity24.displayName = 'Activity24';
Activity24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Activity24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Activity20 = React.forwardRef(function (_ref274, ref) {
  var className = _ref274.className,
      children = _ref274.children,
      style = _ref274.style,
      tabIndex = _ref274.tabIndex,
      rest = _objectWithoutProperties$2(_ref274, ["className", "children", "style", "tabIndex"]);

  var _getAttributes274 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes274.tabindex,
      props = _objectWithoutProperties$2(_getAttributes274, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 29a1 1 0 0 1-.92-.62L6.33 17H2v-2h5a1 1 0 0 1 .92.62L12 25.28l8.06-21.63A1 1 0 0 1 21 3a1 1 0 0 1 .93.68L25.72 15H30v2h-5a1 1 0 0 1-.95-.68L21 7l-8.06 21.35A1 1 0 0 1 12 29z'
  }));
});
Activity20.displayName = 'Activity20';
Activity20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Activity20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AddAlt32 = React.forwardRef(function (_ref275, ref) {
  var className = _ref275.className,
      children = _ref275.children,
      style = _ref275.style,
      tabIndex = _ref275.tabIndex,
      rest = _objectWithoutProperties$2(_ref275, ["className", "children", "style", "tabIndex"]);

  var _getAttributes275 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes275.tabindex,
      props = _objectWithoutProperties$2(_getAttributes275, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M22 15h-5v-5h-2v5h-5v2h5v5h2v-5h5v-2z'
  }));
});
AddAlt32.displayName = 'AddAlt32';
AddAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AddAlt24 = React.forwardRef(function (_ref276, ref) {
  var className = _ref276.className,
      children = _ref276.children,
      style = _ref276.style,
      tabIndex = _ref276.tabIndex,
      rest = _objectWithoutProperties$2(_ref276, ["className", "children", "style", "tabIndex"]);

  var _getAttributes276 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes276.tabindex,
      props = _objectWithoutProperties$2(_getAttributes276, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M22 15h-5v-5h-2v5h-5v2h5v5h2v-5h5v-2z'
  }));
});
AddAlt24.displayName = 'AddAlt24';
AddAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AddAlt20 = React.forwardRef(function (_ref277, ref) {
  var className = _ref277.className,
      children = _ref277.children,
      style = _ref277.style,
      tabIndex = _ref277.tabIndex,
      rest = _objectWithoutProperties$2(_ref277, ["className", "children", "style", "tabIndex"]);

  var _getAttributes277 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes277.tabindex,
      props = _objectWithoutProperties$2(_getAttributes277, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M22 15h-5v-5h-2v5h-5v2h5v5h2v-5h5v-2z'
  }));
});
AddAlt20.displayName = 'AddAlt20';
AddAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AddComment32 = React.forwardRef(function (_ref278, ref) {
  var className = _ref278.className,
      children = _ref278.children,
      style = _ref278.style,
      tabIndex = _ref278.tabIndex,
      rest = _objectWithoutProperties$2(_ref278, ["className", "children", "style", "tabIndex"]);

  var _getAttributes278 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes278.tabindex,
      props = _objectWithoutProperties$2(_getAttributes278, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.74 30L16 29l4-7h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.84z'
  }), React.createElement('path', {
    d: 'M17 9h-2v4h-4v2h4v4h2v-4h4v-2h-4V9z'
  }));
});
AddComment32.displayName = 'AddComment32';
AddComment32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddComment32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AddComment24 = React.forwardRef(function (_ref279, ref) {
  var className = _ref279.className,
      children = _ref279.children,
      style = _ref279.style,
      tabIndex = _ref279.tabIndex,
      rest = _objectWithoutProperties$2(_ref279, ["className", "children", "style", "tabIndex"]);

  var _getAttributes279 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes279.tabindex,
      props = _objectWithoutProperties$2(_getAttributes279, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.74 30L16 29l4-7h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.84z'
  }), React.createElement('path', {
    d: 'M17 9h-2v4h-4v2h4v4h2v-4h4v-2h-4V9z'
  }));
});
AddComment24.displayName = 'AddComment24';
AddComment24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddComment24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AddComment20 = React.forwardRef(function (_ref280, ref) {
  var className = _ref280.className,
      children = _ref280.children,
      style = _ref280.style,
      tabIndex = _ref280.tabIndex,
      rest = _objectWithoutProperties$2(_ref280, ["className", "children", "style", "tabIndex"]);

  var _getAttributes280 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes280.tabindex,
      props = _objectWithoutProperties$2(_getAttributes280, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.74 30L16 29l4-7h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.84z'
  }), React.createElement('path', {
    d: 'M17 9h-2v4h-4v2h4v4h2v-4h4v-2h-4V9z'
  }));
});
AddComment20.displayName = 'AddComment20';
AddComment20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AddComment20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Add32 = React.forwardRef(function (_ref281, ref) {
  var className = _ref281.className,
      children = _ref281.children,
      style = _ref281.style,
      tabIndex = _ref281.tabIndex,
      rest = _objectWithoutProperties$2(_ref281, ["className", "children", "style", "tabIndex"]);

  var _getAttributes281 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes281.tabindex,
      props = _objectWithoutProperties$2(_getAttributes281, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 15V7h-2v8H7v2h8v8h2v-8h8v-2h-8z'
  }));
});
Add32.displayName = 'Add32';
Add32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Add32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Add24 = React.forwardRef(function (_ref282, ref) {
  var className = _ref282.className,
      children = _ref282.children,
      style = _ref282.style,
      tabIndex = _ref282.tabIndex,
      rest = _objectWithoutProperties$2(_ref282, ["className", "children", "style", "tabIndex"]);

  var _getAttributes282 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes282.tabindex,
      props = _objectWithoutProperties$2(_getAttributes282, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 15V7h-2v8H7v2h8v8h2v-8h8v-2h-8z'
  }));
});
Add24.displayName = 'Add24';
Add24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Add24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Add20 = React.forwardRef(function (_ref283, ref) {
  var className = _ref283.className,
      children = _ref283.children,
      style = _ref283.style,
      tabIndex = _ref283.tabIndex,
      rest = _objectWithoutProperties$2(_ref283, ["className", "children", "style", "tabIndex"]);

  var _getAttributes283 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes283.tabindex,
      props = _objectWithoutProperties$2(_getAttributes283, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 15V7h-2v8H7v2h8v8h2v-8h8v-2h-8z'
  }));
});
Add20.displayName = 'Add20';
Add20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Add20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AlarmAdd32 = React.forwardRef(function (_ref284, ref) {
  var className = _ref284.className,
      children = _ref284.children,
      style = _ref284.style,
      tabIndex = _ref284.tabIndex,
      rest = _objectWithoutProperties$2(_ref284, ["className", "children", "style", "tabIndex"]);

  var _getAttributes284 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes284.tabindex,
      props = _objectWithoutProperties$2(_getAttributes284, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }), React.createElement('path', {
    d: 'M21 16h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2z'
  }));
});
AlarmAdd32.displayName = 'AlarmAdd32';
AlarmAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AlarmAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AlarmAdd24 = React.forwardRef(function (_ref285, ref) {
  var className = _ref285.className,
      children = _ref285.children,
      style = _ref285.style,
      tabIndex = _ref285.tabIndex,
      rest = _objectWithoutProperties$2(_ref285, ["className", "children", "style", "tabIndex"]);

  var _getAttributes285 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes285.tabindex,
      props = _objectWithoutProperties$2(_getAttributes285, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }), React.createElement('path', {
    d: 'M21 16h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2z'
  }));
});
AlarmAdd24.displayName = 'AlarmAdd24';
AlarmAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AlarmAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AlarmAdd20 = React.forwardRef(function (_ref286, ref) {
  var className = _ref286.className,
      children = _ref286.children,
      style = _ref286.style,
      tabIndex = _ref286.tabIndex,
      rest = _objectWithoutProperties$2(_ref286, ["className", "children", "style", "tabIndex"]);

  var _getAttributes286 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes286.tabindex,
      props = _objectWithoutProperties$2(_getAttributes286, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }), React.createElement('path', {
    d: 'M21 16h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2z'
  }));
});
AlarmAdd20.displayName = 'AlarmAdd20';
AlarmAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AlarmAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AlarmSubtract32 = React.forwardRef(function (_ref287, ref) {
  var className = _ref287.className,
      children = _ref287.children,
      style = _ref287.style,
      tabIndex = _ref287.tabIndex,
      rest = _objectWithoutProperties$2(_ref287, ["className", "children", "style", "tabIndex"]);

  var _getAttributes287 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes287.tabindex,
      props = _objectWithoutProperties$2(_getAttributes287, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }), React.createElement('path', {
    d: 'M11 16h10v2H11z'
  }));
});
AlarmSubtract32.displayName = 'AlarmSubtract32';
AlarmSubtract32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AlarmSubtract32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AlarmSubtract24 = React.forwardRef(function (_ref288, ref) {
  var className = _ref288.className,
      children = _ref288.children,
      style = _ref288.style,
      tabIndex = _ref288.tabIndex,
      rest = _objectWithoutProperties$2(_ref288, ["className", "children", "style", "tabIndex"]);

  var _getAttributes288 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes288.tabindex,
      props = _objectWithoutProperties$2(_getAttributes288, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }), React.createElement('path', {
    d: 'M11 16h10v2H11z'
  }));
});
AlarmSubtract24.displayName = 'AlarmSubtract24';
AlarmSubtract24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AlarmSubtract24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AlarmSubtract20 = React.forwardRef(function (_ref289, ref) {
  var className = _ref289.className,
      children = _ref289.children,
      style = _ref289.style,
      tabIndex = _ref289.tabIndex,
      rest = _objectWithoutProperties$2(_ref289, ["className", "children", "style", "tabIndex"]);

  var _getAttributes289 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes289.tabindex,
      props = _objectWithoutProperties$2(_getAttributes289, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }), React.createElement('path', {
    d: 'M11 16h10v2H11z'
  }));
});
AlarmSubtract20.displayName = 'AlarmSubtract20';
AlarmSubtract20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AlarmSubtract20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Alarm32 = React.forwardRef(function (_ref290, ref) {
  var className = _ref290.className,
      children = _ref290.children,
      style = _ref290.style,
      tabIndex = _ref290.tabIndex,
      rest = _objectWithoutProperties$2(_ref290, ["className", "children", "style", "tabIndex"]);

  var _getAttributes290 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes290.tabindex,
      props = _objectWithoutProperties$2(_getAttributes290, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9z'
  }), React.createElement('path', {
    d: 'M18.59 21L15 17.41V11h2v5.58l3 3.01L18.59 21zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }));
});
Alarm32.displayName = 'Alarm32';
Alarm32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Alarm32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Alarm24 = React.forwardRef(function (_ref291, ref) {
  var className = _ref291.className,
      children = _ref291.children,
      style = _ref291.style,
      tabIndex = _ref291.tabIndex,
      rest = _objectWithoutProperties$2(_ref291, ["className", "children", "style", "tabIndex"]);

  var _getAttributes291 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes291.tabindex,
      props = _objectWithoutProperties$2(_getAttributes291, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9z'
  }), React.createElement('path', {
    d: 'M18.59 21L15 17.41V11h2v5.58l3 3.01L18.59 21zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }));
});
Alarm24.displayName = 'Alarm24';
Alarm24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Alarm24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Alarm20 = React.forwardRef(function (_ref292, ref) {
  var className = _ref292.className,
      children = _ref292.children,
      style = _ref292.style,
      tabIndex = _ref292.tabIndex,
      rest = _objectWithoutProperties$2(_ref292, ["className", "children", "style", "tabIndex"]);

  var _getAttributes292 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes292.tabindex,
      props = _objectWithoutProperties$2(_getAttributes292, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9z'
  }), React.createElement('path', {
    d: 'M18.59 21L15 17.41V11h2v5.58l3 3.01L18.59 21zM4 7.592l3.582-3.589 1.416 1.413-3.582 3.589zm19-2.184l1.415-1.413 3.581 3.589-1.415 1.413z'
  }));
});
Alarm20.displayName = 'Alarm20';
Alarm20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Alarm20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Analytics32 = React.forwardRef(function (_ref293, ref) {
  var className = _ref293.className,
      children = _ref293.children,
      style = _ref293.style,
      tabIndex = _ref293.tabIndex,
      rest = _objectWithoutProperties$2(_ref293, ["className", "children", "style", "tabIndex"]);

  var _getAttributes293 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes293.tabindex,
      props = _objectWithoutProperties$2(_getAttributes293, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 2H2v26a2 2 0 0 0 2 2h26v-2H4z'
  }), React.createElement('path', {
    d: 'M30 9h-7v2h3.59L19 18.59l-4.29-4.3a1 1 0 0 0-1.42 0L6 21.59 7.41 23 14 16.41l4.29 4.3a1 1 0 0 0 1.42 0l8.29-8.3V16h2z'
  }));
});
Analytics32.displayName = 'Analytics32';
Analytics32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Analytics32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Analytics24 = React.forwardRef(function (_ref294, ref) {
  var className = _ref294.className,
      children = _ref294.children,
      style = _ref294.style,
      tabIndex = _ref294.tabIndex,
      rest = _objectWithoutProperties$2(_ref294, ["className", "children", "style", "tabIndex"]);

  var _getAttributes294 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes294.tabindex,
      props = _objectWithoutProperties$2(_getAttributes294, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 2H2v26a2 2 0 0 0 2 2h26v-2H4z'
  }), React.createElement('path', {
    d: 'M30 9h-7v2h3.59L19 18.59l-4.29-4.3a1 1 0 0 0-1.42 0L6 21.59 7.41 23 14 16.41l4.29 4.3a1 1 0 0 0 1.42 0l8.29-8.3V16h2z'
  }));
});
Analytics24.displayName = 'Analytics24';
Analytics24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Analytics24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Analytics20 = React.forwardRef(function (_ref295, ref) {
  var className = _ref295.className,
      children = _ref295.children,
      style = _ref295.style,
      tabIndex = _ref295.tabIndex,
      rest = _objectWithoutProperties$2(_ref295, ["className", "children", "style", "tabIndex"]);

  var _getAttributes295 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes295.tabindex,
      props = _objectWithoutProperties$2(_getAttributes295, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 2H2v26a2 2 0 0 0 2 2h26v-2H4z'
  }), React.createElement('path', {
    d: 'M30 9h-7v2h3.59L19 18.59l-4.29-4.3a1 1 0 0 0-1.42 0L6 21.59 7.41 23 14 16.41l4.29 4.3a1 1 0 0 0 1.42 0l8.29-8.3V16h2z'
  }));
});
Analytics20.displayName = 'Analytics20';
Analytics20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Analytics20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Aperture32 = React.forwardRef(function (_ref296, ref) {
  var className = _ref296.className,
      children = _ref296.children,
      style = _ref296.style,
      tabIndex = _ref296.tabIndex,
      rest = _objectWithoutProperties$2(_ref296, ["className", "children", "style", "tabIndex"]);

  var _getAttributes296 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes296.tabindex,
      props = _objectWithoutProperties$2(_getAttributes296, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm11.84 12.14L22 17.52V5.62a12 12 0 0 1 5.84 8.52zM12 18.68v-5.36L16 11l4 2.31v5.36L16 21zm8-14V11l-9.66-5.58A11.9 11.9 0 0 1 20 4.7zm-11.52 2L14 9.85 4 15.62a12 12 0 0 1 4.48-8.96zM4.16 17.85L10 14.47v11.91a12 12 0 0 1-5.84-8.53zM12 27.3V21l9.67 5.58A11.92 11.92 0 0 1 16 28a12.05 12.05 0 0 1-4-.7zm11.52-2L18 22.14l10-5.77a12 12 0 0 1-4.48 8.97z'
  }));
});
Aperture32.displayName = 'Aperture32';
Aperture32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Aperture32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Aperture24 = React.forwardRef(function (_ref297, ref) {
  var className = _ref297.className,
      children = _ref297.children,
      style = _ref297.style,
      tabIndex = _ref297.tabIndex,
      rest = _objectWithoutProperties$2(_ref297, ["className", "children", "style", "tabIndex"]);

  var _getAttributes297 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes297.tabindex,
      props = _objectWithoutProperties$2(_getAttributes297, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm11.84 12.14L22 17.52V5.62a12 12 0 0 1 5.84 8.52zM12 18.68v-5.36L16 11l4 2.31v5.36L16 21zm8-14V11l-9.66-5.58A11.9 11.9 0 0 1 20 4.7zm-11.52 2L14 9.85 4 15.62a12 12 0 0 1 4.48-8.96zM4.16 17.85L10 14.47v11.91a12 12 0 0 1-5.84-8.53zM12 27.3V21l9.67 5.58A11.92 11.92 0 0 1 16 28a12.05 12.05 0 0 1-4-.7zm11.52-2L18 22.14l10-5.77a12 12 0 0 1-4.48 8.97z'
  }));
});
Aperture24.displayName = 'Aperture24';
Aperture24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Aperture24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Aperture20 = React.forwardRef(function (_ref298, ref) {
  var className = _ref298.className,
      children = _ref298.children,
      style = _ref298.style,
      tabIndex = _ref298.tabIndex,
      rest = _objectWithoutProperties$2(_ref298, ["className", "children", "style", "tabIndex"]);

  var _getAttributes298 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes298.tabindex,
      props = _objectWithoutProperties$2(_getAttributes298, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm11.84 12.14L22 17.52V5.62a12 12 0 0 1 5.84 8.52zM12 18.68v-5.36L16 11l4 2.31v5.36L16 21zm8-14V11l-9.66-5.58A11.9 11.9 0 0 1 20 4.7zm-11.52 2L14 9.85 4 15.62a12 12 0 0 1 4.48-8.96zM4.16 17.85L10 14.47v11.91a12 12 0 0 1-5.84-8.53zM12 27.3V21l9.67 5.58A11.92 11.92 0 0 1 16 28a12.05 12.05 0 0 1-4-.7zm11.52-2L18 22.14l10-5.77a12 12 0 0 1-4.48 8.97z'
  }));
});
Aperture20.displayName = 'Aperture20';
Aperture20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Aperture20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Api32 = React.forwardRef(function (_ref299, ref) {
  var className = _ref299.className,
      children = _ref299.children,
      style = _ref299.style,
      tabIndex = _ref299.tabIndex,
      rest = _objectWithoutProperties$2(_ref299, ["className", "children", "style", "tabIndex"]);

  var _getAttributes299 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes299.tabindex,
      props = _objectWithoutProperties$2(_getAttributes299, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 22a3.86 3.86 0 0 0-2 .57l-3.09-3.1a6 6 0 0 0 0-6.94L24 9.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-4-4 3.86 3.86 0 0 0 .57 2l-3.1 3.09a6 6 0 0 0-6.94 0L9.43 8A3.86 3.86 0 0 0 10 6a4 4 0 1 0-4 4 3.86 3.86 0 0 0 2-.57l3.09 3.1a6 6 0 0 0 0 6.94L8 22.57A3.86 3.86 0 0 0 6 22a4 4 0 1 0 4 4 3.86 3.86 0 0 0-.57-2l3.1-3.09a6 6 0 0 0 6.94 0l3.1 3.09a3.86 3.86 0 0 0-.57 2 4 4 0 1 0 4-4zm0-18a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm2 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10-8a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm10 8a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
Api32.displayName = 'Api32';
Api32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Api32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Api24 = React.forwardRef(function (_ref300, ref) {
  var className = _ref300.className,
      children = _ref300.children,
      style = _ref300.style,
      tabIndex = _ref300.tabIndex,
      rest = _objectWithoutProperties$2(_ref300, ["className", "children", "style", "tabIndex"]);

  var _getAttributes300 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes300.tabindex,
      props = _objectWithoutProperties$2(_getAttributes300, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 22a3.86 3.86 0 0 0-2 .57l-3.09-3.1a6 6 0 0 0 0-6.94L24 9.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-4-4 3.86 3.86 0 0 0 .57 2l-3.1 3.09a6 6 0 0 0-6.94 0L9.43 8A3.86 3.86 0 0 0 10 6a4 4 0 1 0-4 4 3.86 3.86 0 0 0 2-.57l3.09 3.1a6 6 0 0 0 0 6.94L8 22.57A3.86 3.86 0 0 0 6 22a4 4 0 1 0 4 4 3.86 3.86 0 0 0-.57-2l3.1-3.09a6 6 0 0 0 6.94 0l3.1 3.09a3.86 3.86 0 0 0-.57 2 4 4 0 1 0 4-4zm0-18a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm2 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10-8a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm10 8a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
Api24.displayName = 'Api24';
Api24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Api24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Api20 = React.forwardRef(function (_ref301, ref) {
  var className = _ref301.className,
      children = _ref301.children,
      style = _ref301.style,
      tabIndex = _ref301.tabIndex,
      rest = _objectWithoutProperties$2(_ref301, ["className", "children", "style", "tabIndex"]);

  var _getAttributes301 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes301.tabindex,
      props = _objectWithoutProperties$2(_getAttributes301, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 22a3.86 3.86 0 0 0-2 .57l-3.09-3.1a6 6 0 0 0 0-6.94L24 9.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-4-4 3.86 3.86 0 0 0 .57 2l-3.1 3.09a6 6 0 0 0-6.94 0L9.43 8A3.86 3.86 0 0 0 10 6a4 4 0 1 0-4 4 3.86 3.86 0 0 0 2-.57l3.09 3.1a6 6 0 0 0 0 6.94L8 22.57A3.86 3.86 0 0 0 6 22a4 4 0 1 0 4 4 3.86 3.86 0 0 0-.57-2l3.1-3.09a6 6 0 0 0 6.94 0l3.1 3.09a3.86 3.86 0 0 0-.57 2 4 4 0 1 0 4-4zm0-18a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm2 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10-8a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm10 8a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
Api20.displayName = 'Api20';
Api20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Api20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AppSwitcher32 = React.forwardRef(function (_ref302, ref) {
  var className = _ref302.className,
      children = _ref302.children,
      style = _ref302.style,
      tabIndex = _ref302.tabIndex,
      rest = _objectWithoutProperties$2(_ref302, ["className", "children", "style", "tabIndex"]);

  var _getAttributes302 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes302.tabindex,
      props = _objectWithoutProperties$2(_getAttributes302, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 5h4v4h-4zM5 5h4v4H5zm18 0h4v4h-4zm-9 9h4v4h-4zm-9 0h4v4H5zm18 0h4v4h-4zm-9 9h4v4h-4zm-9 0h4v4H5zm18 0h4v4h-4z'
  }));
});
AppSwitcher32.displayName = 'AppSwitcher32';
AppSwitcher32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AppSwitcher32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AppSwitcher24 = React.forwardRef(function (_ref303, ref) {
  var className = _ref303.className,
      children = _ref303.children,
      style = _ref303.style,
      tabIndex = _ref303.tabIndex,
      rest = _objectWithoutProperties$2(_ref303, ["className", "children", "style", "tabIndex"]);

  var _getAttributes303 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes303.tabindex,
      props = _objectWithoutProperties$2(_getAttributes303, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 5h4v4h-4zM5 5h4v4H5zm18 0h4v4h-4zm-9 9h4v4h-4zm-9 0h4v4H5zm18 0h4v4h-4zm-9 9h4v4h-4zm-9 0h4v4H5zm18 0h4v4h-4z'
  }));
});
AppSwitcher24.displayName = 'AppSwitcher24';
AppSwitcher24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AppSwitcher24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AppSwitcher20 = React.forwardRef(function (_ref304, ref) {
  var className = _ref304.className,
      children = _ref304.children,
      style = _ref304.style,
      tabIndex = _ref304.tabIndex,
      rest = _objectWithoutProperties$2(_ref304, ["className", "children", "style", "tabIndex"]);

  var _getAttributes304 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes304.tabindex,
      props = _objectWithoutProperties$2(_getAttributes304, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 5h4v4h-4zM5 5h4v4H5zm18 0h4v4h-4zm-9 9h4v4h-4zm-9 0h4v4H5zm18 0h4v4h-4zm-9 9h4v4h-4zm-9 0h4v4H5zm18 0h4v4h-4z'
  }));
});
AppSwitcher20.displayName = 'AppSwitcher20';
AppSwitcher20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AppSwitcher20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Application32 = React.forwardRef(function (_ref305, ref) {
  var className = _ref305.className,
      children = _ref305.children,
      style = _ref305.style,
      tabIndex = _ref305.tabIndex,
      rest = _objectWithoutProperties$2(_ref305, ["className", "children", "style", "tabIndex"]);

  var _getAttributes305 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes305.tabindex,
      props = _objectWithoutProperties$2(_getAttributes305, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 18H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zM6 6v10h10V6zm20 6v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 12v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-10 2v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z'
  }));
});
Application32.displayName = 'Application32';
Application32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Application32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Application24 = React.forwardRef(function (_ref306, ref) {
  var className = _ref306.className,
      children = _ref306.children,
      style = _ref306.style,
      tabIndex = _ref306.tabIndex,
      rest = _objectWithoutProperties$2(_ref306, ["className", "children", "style", "tabIndex"]);

  var _getAttributes306 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes306.tabindex,
      props = _objectWithoutProperties$2(_getAttributes306, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 18H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zM6 6v10h10V6zm20 6v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 12v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-10 2v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z'
  }));
});
Application24.displayName = 'Application24';
Application24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Application24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Application20 = React.forwardRef(function (_ref307, ref) {
  var className = _ref307.className,
      children = _ref307.children,
      style = _ref307.style,
      tabIndex = _ref307.tabIndex,
      rest = _objectWithoutProperties$2(_ref307, ["className", "children", "style", "tabIndex"]);

  var _getAttributes307 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes307.tabindex,
      props = _objectWithoutProperties$2(_getAttributes307, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 18H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zM6 6v10h10V6zm20 6v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 12v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-10 2v4h-4v-4h4m0-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z'
  }));
});
Application20.displayName = 'Application20';
Application20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Application20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Archive32 = React.forwardRef(function (_ref308, ref) {
  var className = _ref308.className,
      children = _ref308.children,
      style = _ref308.style,
      tabIndex = _ref308.tabIndex,
      rest = _objectWithoutProperties$2(_ref308, ["className", "children", "style", "tabIndex"]);

  var _getAttributes308 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes308.tabindex,
      props = _objectWithoutProperties$2(_getAttributes308, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 19h4v2h-4z'
  }), React.createElement('path', {
    d: 'M6 2v26a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2zm18 26H8V16h16zm0-14H8v-4h16zM8 8V4h16v4z'
  }));
});
Archive32.displayName = 'Archive32';
Archive32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Archive32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Archive24 = React.forwardRef(function (_ref309, ref) {
  var className = _ref309.className,
      children = _ref309.children,
      style = _ref309.style,
      tabIndex = _ref309.tabIndex,
      rest = _objectWithoutProperties$2(_ref309, ["className", "children", "style", "tabIndex"]);

  var _getAttributes309 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes309.tabindex,
      props = _objectWithoutProperties$2(_getAttributes309, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 19h4v2h-4z'
  }), React.createElement('path', {
    d: 'M6 2v26a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2zm18 26H8V16h16zm0-14H8v-4h16zM8 8V4h16v4z'
  }));
});
Archive24.displayName = 'Archive24';
Archive24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Archive24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Archive20 = React.forwardRef(function (_ref310, ref) {
  var className = _ref310.className,
      children = _ref310.children,
      style = _ref310.style,
      tabIndex = _ref310.tabIndex,
      rest = _objectWithoutProperties$2(_ref310, ["className", "children", "style", "tabIndex"]);

  var _getAttributes310 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes310.tabindex,
      props = _objectWithoutProperties$2(_getAttributes310, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 19h4v2h-4z'
  }), React.createElement('path', {
    d: 'M6 2v26a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2zm18 26H8V16h16zm0-14H8v-4h16zM8 8V4h16v4z'
  }));
});
Archive20.displayName = 'Archive20';
Archive20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Archive20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Arrival32 = React.forwardRef(function (_ref311, ref) {
  var className = _ref311.className,
      children = _ref311.children,
      style = _ref311.style,
      tabIndex = _ref311.tabIndex,
      rest = _objectWithoutProperties$2(_ref311, ["className", "children", "style", "tabIndex"]);

  var _getAttributes311 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes311.tabindex,
      props = _objectWithoutProperties$2(_getAttributes311, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0 1 27 20.62a1.88 1.88 0 0 1-1.37 1.52 2 2 0 0 1-1 0l-18.7-5a1.89 1.89 0 0 1-1.33-2.3l1.75-6.5 1.44.38.61 5.18 6 1.62 2.81-10.29m-1-2.2a1 1 0 0 0-.68.69L13 13.07l-2.81-.75-.5-4.53A1 1 0 0 0 9 7l-3.13-.86a.94.94 0 0 0-.5 0 1 1 0 0 0-.68.68l-2 7.49a3.87 3.87 0 0 0 2.74 4.74l18.71 5A3.87 3.87 0 0 0 29 21a4 4 0 0 0-3-4.42l-4.52-1.21-.95-10.66a1 1 0 0 0-.72-.85L16.73 3a1.06 1.06 0 0 0-.5 0z'
  }));
});
Arrival32.displayName = 'Arrival32';
Arrival32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Arrival32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Arrival24 = React.forwardRef(function (_ref312, ref) {
  var className = _ref312.className,
      children = _ref312.children,
      style = _ref312.style,
      tabIndex = _ref312.tabIndex,
      rest = _objectWithoutProperties$2(_ref312, ["className", "children", "style", "tabIndex"]);

  var _getAttributes312 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes312.tabindex,
      props = _objectWithoutProperties$2(_getAttributes312, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0 1 27 20.62a1.88 1.88 0 0 1-1.37 1.52 2 2 0 0 1-1 0l-18.7-5a1.89 1.89 0 0 1-1.33-2.3l1.75-6.5 1.44.38.61 5.18 6 1.62 2.81-10.29m-1-2.2a1 1 0 0 0-.68.69L13 13.07l-2.81-.75-.5-4.53A1 1 0 0 0 9 7l-3.13-.86a.94.94 0 0 0-.5 0 1 1 0 0 0-.68.68l-2 7.49a3.87 3.87 0 0 0 2.74 4.74l18.71 5A3.87 3.87 0 0 0 29 21a4 4 0 0 0-3-4.42l-4.52-1.21-.95-10.66a1 1 0 0 0-.72-.85L16.73 3a1.06 1.06 0 0 0-.5 0z'
  }));
});
Arrival24.displayName = 'Arrival24';
Arrival24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Arrival24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Arrival20 = React.forwardRef(function (_ref313, ref) {
  var className = _ref313.className,
      children = _ref313.children,
      style = _ref313.style,
      tabIndex = _ref313.tabIndex,
      rest = _objectWithoutProperties$2(_ref313, ["className", "children", "style", "tabIndex"]);

  var _getAttributes313 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes313.tabindex,
      props = _objectWithoutProperties$2(_getAttributes313, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0 1 27 20.62a1.88 1.88 0 0 1-1.37 1.52 2 2 0 0 1-1 0l-18.7-5a1.89 1.89 0 0 1-1.33-2.3l1.75-6.5 1.44.38.61 5.18 6 1.62 2.81-10.29m-1-2.2a1 1 0 0 0-.68.69L13 13.07l-2.81-.75-.5-4.53A1 1 0 0 0 9 7l-3.13-.86a.94.94 0 0 0-.5 0 1 1 0 0 0-.68.68l-2 7.49a3.87 3.87 0 0 0 2.74 4.74l18.71 5A3.87 3.87 0 0 0 29 21a4 4 0 0 0-3-4.42l-4.52-1.21-.95-10.66a1 1 0 0 0-.72-.85L16.73 3a1.06 1.06 0 0 0-.5 0z'
  }));
});
Arrival20.displayName = 'Arrival20';
Arrival20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Arrival20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDownLeft32 = React.forwardRef(function (_ref314, ref) {
  var className = _ref314.className,
      children = _ref314.children,
      style = _ref314.style,
      tabIndex = _ref314.tabIndex,
      rest = _objectWithoutProperties$2(_ref314, ["className", "children", "style", "tabIndex"]);

  var _getAttributes314 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes314.tabindex,
      props = _objectWithoutProperties$2(_getAttributes314, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26v-2H9.41L26 7.41 24.59 6 8 22.59V10H6v16h16z'
  }));
});
ArrowDownLeft32.displayName = 'ArrowDownLeft32';
ArrowDownLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDownLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDownLeft24 = React.forwardRef(function (_ref315, ref) {
  var className = _ref315.className,
      children = _ref315.children,
      style = _ref315.style,
      tabIndex = _ref315.tabIndex,
      rest = _objectWithoutProperties$2(_ref315, ["className", "children", "style", "tabIndex"]);

  var _getAttributes315 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes315.tabindex,
      props = _objectWithoutProperties$2(_getAttributes315, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26v-2H9.41L26 7.41 24.59 6 8 22.59V10H6v16h16z'
  }));
});
ArrowDownLeft24.displayName = 'ArrowDownLeft24';
ArrowDownLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDownLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDownLeft20 = React.forwardRef(function (_ref316, ref) {
  var className = _ref316.className,
      children = _ref316.children,
      style = _ref316.style,
      tabIndex = _ref316.tabIndex,
      rest = _objectWithoutProperties$2(_ref316, ["className", "children", "style", "tabIndex"]);

  var _getAttributes316 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes316.tabindex,
      props = _objectWithoutProperties$2(_getAttributes316, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26v-2H9.41L26 7.41 24.59 6 8 22.59V10H6v16h16z'
  }));
});
ArrowDownLeft20.displayName = 'ArrowDownLeft20';
ArrowDownLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDownLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDownRight32 = React.forwardRef(function (_ref317, ref) {
  var className = _ref317.className,
      children = _ref317.children,
      style = _ref317.style,
      tabIndex = _ref317.tabIndex,
      rest = _objectWithoutProperties$2(_ref317, ["className", "children", "style", "tabIndex"]);

  var _getAttributes317 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes317.tabindex,
      props = _objectWithoutProperties$2(_getAttributes317, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 26v-2h12.59L6 7.41 7.41 6 24 22.59V10h2v16H10z'
  }));
});
ArrowDownRight32.displayName = 'ArrowDownRight32';
ArrowDownRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDownRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDownRight24 = React.forwardRef(function (_ref318, ref) {
  var className = _ref318.className,
      children = _ref318.children,
      style = _ref318.style,
      tabIndex = _ref318.tabIndex,
      rest = _objectWithoutProperties$2(_ref318, ["className", "children", "style", "tabIndex"]);

  var _getAttributes318 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes318.tabindex,
      props = _objectWithoutProperties$2(_getAttributes318, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 26v-2h12.59L6 7.41 7.41 6 24 22.59V10h2v16H10z'
  }));
});
ArrowDownRight24.displayName = 'ArrowDownRight24';
ArrowDownRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDownRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDownRight20 = React.forwardRef(function (_ref319, ref) {
  var className = _ref319.className,
      children = _ref319.children,
      style = _ref319.style,
      tabIndex = _ref319.tabIndex,
      rest = _objectWithoutProperties$2(_ref319, ["className", "children", "style", "tabIndex"]);

  var _getAttributes319 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes319.tabindex,
      props = _objectWithoutProperties$2(_getAttributes319, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 26v-2h12.59L6 7.41 7.41 6 24 22.59V10h2v16H10z'
  }));
});
ArrowDownRight20.displayName = 'ArrowDownRight20';
ArrowDownRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDownRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDown32 = React.forwardRef(function (_ref320, ref) {
  var className = _ref320.className,
      children = _ref320.children,
      style = _ref320.style,
      tabIndex = _ref320.tabIndex,
      rest = _objectWithoutProperties$2(_ref320, ["className", "children", "style", "tabIndex"]);

  var _getAttributes320 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes320.tabindex,
      props = _objectWithoutProperties$2(_getAttributes320, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24.59 16.59L17 24.17V2h-2v22.17l-7.59-7.58L6 18l10 10 10-10-1.41-1.41z'
  }));
});
ArrowDown32.displayName = 'ArrowDown32';
ArrowDown32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDown32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDown24 = React.forwardRef(function (_ref321, ref) {
  var className = _ref321.className,
      children = _ref321.children,
      style = _ref321.style,
      tabIndex = _ref321.tabIndex,
      rest = _objectWithoutProperties$2(_ref321, ["className", "children", "style", "tabIndex"]);

  var _getAttributes321 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes321.tabindex,
      props = _objectWithoutProperties$2(_getAttributes321, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24.59 16.59L17 24.17V2h-2v22.17l-7.59-7.58L6 18l10 10 10-10-1.41-1.41z'
  }));
});
ArrowDown24.displayName = 'ArrowDown24';
ArrowDown24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDown24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowDown20 = React.forwardRef(function (_ref322, ref) {
  var className = _ref322.className,
      children = _ref322.children,
      style = _ref322.style,
      tabIndex = _ref322.tabIndex,
      rest = _objectWithoutProperties$2(_ref322, ["className", "children", "style", "tabIndex"]);

  var _getAttributes322 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes322.tabindex,
      props = _objectWithoutProperties$2(_getAttributes322, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24.59 16.59L17 24.17V2h-2v22.17l-7.59-7.58L6 18l10 10 10-10-1.41-1.41z'
  }));
});
ArrowDown20.displayName = 'ArrowDown20';
ArrowDown20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowDown20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowLeft32 = React.forwardRef(function (_ref323, ref) {
  var className = _ref323.className,
      children = _ref323.children,
      style = _ref323.style,
      tabIndex = _ref323.tabIndex,
      rest = _objectWithoutProperties$2(_ref323, ["className", "children", "style", "tabIndex"]);

  var _getAttributes323 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes323.tabindex,
      props = _objectWithoutProperties$2(_getAttributes323, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 26l1.41-1.41L6.83 17H29v-2H6.83l7.58-7.59L13 6 3 16l10 10z'
  }));
});
ArrowLeft32.displayName = 'ArrowLeft32';
ArrowLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowLeft24 = React.forwardRef(function (_ref324, ref) {
  var className = _ref324.className,
      children = _ref324.children,
      style = _ref324.style,
      tabIndex = _ref324.tabIndex,
      rest = _objectWithoutProperties$2(_ref324, ["className", "children", "style", "tabIndex"]);

  var _getAttributes324 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes324.tabindex,
      props = _objectWithoutProperties$2(_getAttributes324, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 26l1.41-1.41L6.83 17H29v-2H6.83l7.58-7.59L13 6 3 16l10 10z'
  }));
});
ArrowLeft24.displayName = 'ArrowLeft24';
ArrowLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowLeft20 = React.forwardRef(function (_ref325, ref) {
  var className = _ref325.className,
      children = _ref325.children,
      style = _ref325.style,
      tabIndex = _ref325.tabIndex,
      rest = _objectWithoutProperties$2(_ref325, ["className", "children", "style", "tabIndex"]);

  var _getAttributes325 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes325.tabindex,
      props = _objectWithoutProperties$2(_getAttributes325, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 26l1.41-1.41L6.83 17H29v-2H6.83l7.58-7.59L13 6 3 16l10 10z'
  }));
});
ArrowLeft20.displayName = 'ArrowLeft20';
ArrowLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowRight32 = React.forwardRef(function (_ref326, ref) {
  var className = _ref326.className,
      children = _ref326.children,
      style = _ref326.style,
      tabIndex = _ref326.tabIndex,
      rest = _objectWithoutProperties$2(_ref326, ["className", "children", "style", "tabIndex"]);

  var _getAttributes326 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes326.tabindex,
      props = _objectWithoutProperties$2(_getAttributes326, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 6l-1.43 1.39L24.15 15H3v2h21.15l-7.58 7.57L18 26l10-10L18 6z'
  }));
});
ArrowRight32.displayName = 'ArrowRight32';
ArrowRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowRight24 = React.forwardRef(function (_ref327, ref) {
  var className = _ref327.className,
      children = _ref327.children,
      style = _ref327.style,
      tabIndex = _ref327.tabIndex,
      rest = _objectWithoutProperties$2(_ref327, ["className", "children", "style", "tabIndex"]);

  var _getAttributes327 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes327.tabindex,
      props = _objectWithoutProperties$2(_getAttributes327, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 6l-1.43 1.39L24.15 15H3v2h21.15l-7.58 7.57L18 26l10-10L18 6z'
  }));
});
ArrowRight24.displayName = 'ArrowRight24';
ArrowRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowRight20 = React.forwardRef(function (_ref328, ref) {
  var className = _ref328.className,
      children = _ref328.children,
      style = _ref328.style,
      tabIndex = _ref328.tabIndex,
      rest = _objectWithoutProperties$2(_ref328, ["className", "children", "style", "tabIndex"]);

  var _getAttributes328 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes328.tabindex,
      props = _objectWithoutProperties$2(_getAttributes328, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 6l-1.43 1.39L24.15 15H3v2h21.15l-7.58 7.57L18 26l10-10L18 6z'
  }));
});
ArrowRight20.displayName = 'ArrowRight20';
ArrowRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUpLeft32 = React.forwardRef(function (_ref329, ref) {
  var className = _ref329.className,
      children = _ref329.children,
      style = _ref329.style,
      tabIndex = _ref329.tabIndex,
      rest = _objectWithoutProperties$2(_ref329, ["className", "children", "style", "tabIndex"]);

  var _getAttributes329 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes329.tabindex,
      props = _objectWithoutProperties$2(_getAttributes329, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 6v2H9.41L26 24.59 24.59 26 8 9.41V22H6V6h16z'
  }));
});
ArrowUpLeft32.displayName = 'ArrowUpLeft32';
ArrowUpLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUpLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUpLeft24 = React.forwardRef(function (_ref330, ref) {
  var className = _ref330.className,
      children = _ref330.children,
      style = _ref330.style,
      tabIndex = _ref330.tabIndex,
      rest = _objectWithoutProperties$2(_ref330, ["className", "children", "style", "tabIndex"]);

  var _getAttributes330 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes330.tabindex,
      props = _objectWithoutProperties$2(_getAttributes330, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 6v2H9.41L26 24.59 24.59 26 8 9.41V22H6V6h16z'
  }));
});
ArrowUpLeft24.displayName = 'ArrowUpLeft24';
ArrowUpLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUpLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUpLeft20 = React.forwardRef(function (_ref331, ref) {
  var className = _ref331.className,
      children = _ref331.children,
      style = _ref331.style,
      tabIndex = _ref331.tabIndex,
      rest = _objectWithoutProperties$2(_ref331, ["className", "children", "style", "tabIndex"]);

  var _getAttributes331 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes331.tabindex,
      props = _objectWithoutProperties$2(_getAttributes331, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 6v2H9.41L26 24.59 24.59 26 8 9.41V22H6V6h16z'
  }));
});
ArrowUpLeft20.displayName = 'ArrowUpLeft20';
ArrowUpLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUpLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUpRight32 = React.forwardRef(function (_ref332, ref) {
  var className = _ref332.className,
      children = _ref332.children,
      style = _ref332.style,
      tabIndex = _ref332.tabIndex,
      rest = _objectWithoutProperties$2(_ref332, ["className", "children", "style", "tabIndex"]);

  var _getAttributes332 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes332.tabindex,
      props = _objectWithoutProperties$2(_getAttributes332, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6v2h12.59L6 24.59 7.41 26 24 9.41V22h2V6H10z'
  }));
});
ArrowUpRight32.displayName = 'ArrowUpRight32';
ArrowUpRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUpRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUpRight24 = React.forwardRef(function (_ref333, ref) {
  var className = _ref333.className,
      children = _ref333.children,
      style = _ref333.style,
      tabIndex = _ref333.tabIndex,
      rest = _objectWithoutProperties$2(_ref333, ["className", "children", "style", "tabIndex"]);

  var _getAttributes333 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes333.tabindex,
      props = _objectWithoutProperties$2(_getAttributes333, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6v2h12.59L6 24.59 7.41 26 24 9.41V22h2V6H10z'
  }));
});
ArrowUpRight24.displayName = 'ArrowUpRight24';
ArrowUpRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUpRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUpRight20 = React.forwardRef(function (_ref334, ref) {
  var className = _ref334.className,
      children = _ref334.children,
      style = _ref334.style,
      tabIndex = _ref334.tabIndex,
      rest = _objectWithoutProperties$2(_ref334, ["className", "children", "style", "tabIndex"]);

  var _getAttributes334 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes334.tabindex,
      props = _objectWithoutProperties$2(_getAttributes334, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6v2h12.59L6 24.59 7.41 26 24 9.41V22h2V6H10z'
  }));
});
ArrowUpRight20.displayName = 'ArrowUpRight20';
ArrowUpRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUpRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUp32 = React.forwardRef(function (_ref335, ref) {
  var className = _ref335.className,
      children = _ref335.children,
      style = _ref335.style,
      tabIndex = _ref335.tabIndex,
      rest = _objectWithoutProperties$2(_ref335, ["className", "children", "style", "tabIndex"]);

  var _getAttributes335 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes335.tabindex,
      props = _objectWithoutProperties$2(_getAttributes335, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4L6 14l1.41 1.41L15 7.83V30h2V7.83l7.59 7.58L26 14 16 4z'
  }));
});
ArrowUp32.displayName = 'ArrowUp32';
ArrowUp32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUp32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUp24 = React.forwardRef(function (_ref336, ref) {
  var className = _ref336.className,
      children = _ref336.children,
      style = _ref336.style,
      tabIndex = _ref336.tabIndex,
      rest = _objectWithoutProperties$2(_ref336, ["className", "children", "style", "tabIndex"]);

  var _getAttributes336 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes336.tabindex,
      props = _objectWithoutProperties$2(_getAttributes336, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4L6 14l1.41 1.41L15 7.83V30h2V7.83l7.59 7.58L26 14 16 4z'
  }));
});
ArrowUp24.displayName = 'ArrowUp24';
ArrowUp24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUp24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowUp20 = React.forwardRef(function (_ref337, ref) {
  var className = _ref337.className,
      children = _ref337.children,
      style = _ref337.style,
      tabIndex = _ref337.tabIndex,
      rest = _objectWithoutProperties$2(_ref337, ["className", "children", "style", "tabIndex"]);

  var _getAttributes337 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes337.tabindex,
      props = _objectWithoutProperties$2(_getAttributes337, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4L6 14l1.41 1.41L15 7.83V30h2V7.83l7.59 7.58L26 14 16 4z'
  }));
});
ArrowUp20.displayName = 'ArrowUp20';
ArrowUp20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowUp20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowsHorizontal32 = React.forwardRef(function (_ref338, ref) {
  var className = _ref338.className,
      children = _ref338.children,
      style = _ref338.style,
      tabIndex = _ref338.tabIndex,
      rest = _objectWithoutProperties$2(_ref338, ["className", "children", "style", "tabIndex"]);

  var _getAttributes338 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes338.tabindex,
      props = _objectWithoutProperties$2(_getAttributes338, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.41 26.59L7.83 23H28v-2H7.83l3.58-3.59L10 16l-6 6 6 6 1.41-1.41zM28 10l-6-6-1.41 1.41L24.17 9H4v2h20.17l-3.58 3.59L22 16l6-6z'
  }));
});
ArrowsHorizontal32.displayName = 'ArrowsHorizontal32';
ArrowsHorizontal32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowsHorizontal32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowsHorizontal24 = React.forwardRef(function (_ref339, ref) {
  var className = _ref339.className,
      children = _ref339.children,
      style = _ref339.style,
      tabIndex = _ref339.tabIndex,
      rest = _objectWithoutProperties$2(_ref339, ["className", "children", "style", "tabIndex"]);

  var _getAttributes339 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes339.tabindex,
      props = _objectWithoutProperties$2(_getAttributes339, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.41 26.59L7.83 23H28v-2H7.83l3.58-3.59L10 16l-6 6 6 6 1.41-1.41zM28 10l-6-6-1.41 1.41L24.17 9H4v2h20.17l-3.58 3.59L22 16l6-6z'
  }));
});
ArrowsHorizontal24.displayName = 'ArrowsHorizontal24';
ArrowsHorizontal24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowsHorizontal24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowsHorizontal20 = React.forwardRef(function (_ref340, ref) {
  var className = _ref340.className,
      children = _ref340.children,
      style = _ref340.style,
      tabIndex = _ref340.tabIndex,
      rest = _objectWithoutProperties$2(_ref340, ["className", "children", "style", "tabIndex"]);

  var _getAttributes340 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes340.tabindex,
      props = _objectWithoutProperties$2(_getAttributes340, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.41 26.59L7.83 23H28v-2H7.83l3.58-3.59L10 16l-6 6 6 6 1.41-1.41zM28 10l-6-6-1.41 1.41L24.17 9H4v2h20.17l-3.58 3.59L22 16l6-6z'
  }));
});
ArrowsHorizontal20.displayName = 'ArrowsHorizontal20';
ArrowsHorizontal20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowsHorizontal20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowsVertical32 = React.forwardRef(function (_ref341, ref) {
  var className = _ref341.className,
      children = _ref341.children,
      style = _ref341.style,
      tabIndex = _ref341.tabIndex,
      rest = _objectWithoutProperties$2(_ref341, ["className", "children", "style", "tabIndex"]);

  var _getAttributes341 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes341.tabindex,
      props = _objectWithoutProperties$2(_getAttributes341, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.59 20.59L23 24.17V4h-2v20.17l-3.59-3.58L16 22l6 6 6-6-1.41-1.41zM10 4l-6 6 1.41 1.41L9 7.83V28h2V7.83l3.59 3.58L16 10l-6-6z'
  }));
});
ArrowsVertical32.displayName = 'ArrowsVertical32';
ArrowsVertical32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowsVertical32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowsVertical24 = React.forwardRef(function (_ref342, ref) {
  var className = _ref342.className,
      children = _ref342.children,
      style = _ref342.style,
      tabIndex = _ref342.tabIndex,
      rest = _objectWithoutProperties$2(_ref342, ["className", "children", "style", "tabIndex"]);

  var _getAttributes342 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes342.tabindex,
      props = _objectWithoutProperties$2(_getAttributes342, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.59 20.59L23 24.17V4h-2v20.17l-3.59-3.58L16 22l6 6 6-6-1.41-1.41zM10 4l-6 6 1.41 1.41L9 7.83V28h2V7.83l3.59 3.58L16 10l-6-6z'
  }));
});
ArrowsVertical24.displayName = 'ArrowsVertical24';
ArrowsVertical24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowsVertical24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ArrowsVertical20 = React.forwardRef(function (_ref343, ref) {
  var className = _ref343.className,
      children = _ref343.children,
      style = _ref343.style,
      tabIndex = _ref343.tabIndex,
      rest = _objectWithoutProperties$2(_ref343, ["className", "children", "style", "tabIndex"]);

  var _getAttributes343 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes343.tabindex,
      props = _objectWithoutProperties$2(_getAttributes343, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.59 20.59L23 24.17V4h-2v20.17l-3.59-3.58L16 22l6 6 6-6-1.41-1.41zM10 4l-6 6 1.41 1.41L9 7.83V28h2V7.83l3.59 3.58L16 10l-6-6z'
  }));
});
ArrowsVertical20.displayName = 'ArrowsVertical20';
ArrowsVertical20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ArrowsVertical20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AsleepFilled32 = React.forwardRef(function (_ref344, ref) {
  var className = _ref344.className,
      children = _ref344.children,
      style = _ref344.style,
      tabIndex = _ref344.tabIndex,
      rest = _objectWithoutProperties$2(_ref344, ["className", "children", "style", "tabIndex"]);

  var _getAttributes344 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes344.tabindex,
      props = _objectWithoutProperties$2(_getAttributes344, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 3h-.2a13.09 13.09 0 0 0 1.82 26h.49a13.08 13.08 0 0 0 10.71-5.56 1 1 0 0 0-.82-1.56 13.08 13.08 0 0 1-11.12-17.5A1 1 0 0 0 15 3z'
  }));
});
AsleepFilled32.displayName = 'AsleepFilled32';
AsleepFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AsleepFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AsleepFilled24 = React.forwardRef(function (_ref345, ref) {
  var className = _ref345.className,
      children = _ref345.children,
      style = _ref345.style,
      tabIndex = _ref345.tabIndex,
      rest = _objectWithoutProperties$2(_ref345, ["className", "children", "style", "tabIndex"]);

  var _getAttributes345 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes345.tabindex,
      props = _objectWithoutProperties$2(_getAttributes345, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 3h-.2a13.09 13.09 0 0 0 1.82 26h.49a13.08 13.08 0 0 0 10.71-5.56 1 1 0 0 0-.82-1.56 13.08 13.08 0 0 1-11.12-17.5A1 1 0 0 0 15 3z'
  }));
});
AsleepFilled24.displayName = 'AsleepFilled24';
AsleepFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AsleepFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var AsleepFilled20 = React.forwardRef(function (_ref346, ref) {
  var className = _ref346.className,
      children = _ref346.children,
      style = _ref346.style,
      tabIndex = _ref346.tabIndex,
      rest = _objectWithoutProperties$2(_ref346, ["className", "children", "style", "tabIndex"]);

  var _getAttributes346 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes346.tabindex,
      props = _objectWithoutProperties$2(_getAttributes346, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 3h-.2a13.09 13.09 0 0 0 1.82 26h.49a13.08 13.08 0 0 0 10.71-5.56 1 1 0 0 0-.82-1.56 13.08 13.08 0 0 1-11.12-17.5A1 1 0 0 0 15 3z'
  }));
});
AsleepFilled20.displayName = 'AsleepFilled20';
AsleepFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
AsleepFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Asleep32 = React.forwardRef(function (_ref347, ref) {
  var className = _ref347.className,
      children = _ref347.children,
      style = _ref347.style,
      tabIndex = _ref347.tabIndex,
      rest = _objectWithoutProperties$2(_ref347, ["className", "children", "style", "tabIndex"]);

  var _getAttributes347 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes347.tabindex,
      props = _objectWithoutProperties$2(_getAttributes347, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.49 5.41a15.08 15.08 0 0 0 11.6 18.2 11.09 11.09 0 0 1-8 3.39h-.42a11.1 11.1 0 0 1-3.2-21.59M15 3h-.2a13.09 13.09 0 0 0 1.82 26h.49a13.08 13.08 0 0 0 10.71-5.56 1 1 0 0 0-.82-1.56 13.08 13.08 0 0 1-11.12-17.5A1 1 0 0 0 15 3z'
  }));
});
Asleep32.displayName = 'Asleep32';
Asleep32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Asleep32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Asleep24 = React.forwardRef(function (_ref348, ref) {
  var className = _ref348.className,
      children = _ref348.children,
      style = _ref348.style,
      tabIndex = _ref348.tabIndex,
      rest = _objectWithoutProperties$2(_ref348, ["className", "children", "style", "tabIndex"]);

  var _getAttributes348 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes348.tabindex,
      props = _objectWithoutProperties$2(_getAttributes348, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.49 5.41a15.08 15.08 0 0 0 11.6 18.2 11.09 11.09 0 0 1-8 3.39h-.42a11.1 11.1 0 0 1-3.2-21.59M15 3h-.2a13.09 13.09 0 0 0 1.82 26h.49a13.08 13.08 0 0 0 10.71-5.56 1 1 0 0 0-.82-1.56 13.08 13.08 0 0 1-11.12-17.5A1 1 0 0 0 15 3z'
  }));
});
Asleep24.displayName = 'Asleep24';
Asleep24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Asleep24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Asleep20 = React.forwardRef(function (_ref349, ref) {
  var className = _ref349.className,
      children = _ref349.children,
      style = _ref349.style,
      tabIndex = _ref349.tabIndex,
      rest = _objectWithoutProperties$2(_ref349, ["className", "children", "style", "tabIndex"]);

  var _getAttributes349 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes349.tabindex,
      props = _objectWithoutProperties$2(_getAttributes349, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.49 5.41a15.08 15.08 0 0 0 11.6 18.2 11.09 11.09 0 0 1-8 3.39h-.42a11.1 11.1 0 0 1-3.2-21.59M15 3h-.2a13.09 13.09 0 0 0 1.82 26h.49a13.08 13.08 0 0 0 10.71-5.56 1 1 0 0 0-.82-1.56 13.08 13.08 0 0 1-11.12-17.5A1 1 0 0 0 15 3z'
  }));
});
Asleep20.displayName = 'Asleep20';
Asleep20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Asleep20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var At32 = React.forwardRef(function (_ref350, ref) {
  var className = _ref350.className,
      children = _ref350.children,
      style = _ref350.style,
      tabIndex = _ref350.tabIndex,
      rest = _objectWithoutProperties$2(_ref350, ["className", "children", "style", "tabIndex"]);

  var _getAttributes350 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes350.tabindex,
      props = _objectWithoutProperties$2(_getAttributes350, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 3A12.92 12.92 0 0 0 3 16v1a13 13 0 0 0 13 13h7v-2h-7A11 11 0 0 1 5 17v-1A10.94 10.94 0 0 1 16 5a10.64 10.64 0 0 1 11 11c0 3.59-1.4 5-3.66 5-1.58 0-2.34-1.29-2.34-3v-8h-2v1.94A3.84 3.84 0 0 0 15.5 10a5.48 5.48 0 0 0-5.5 5.44v2.12A5.48 5.48 0 0 0 15.5 23a4.28 4.28 0 0 0 4-2.46A4.35 4.35 0 0 0 23.41 23c3.07 0 5.59-2 5.59-7A12.72 12.72 0 0 0 16 3zm3 14.56a3.5 3.5 0 0 1-7 0v-2.12a3.5 3.5 0 0 1 7 0z'
  }));
});
At32.displayName = 'At32';
At32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
At32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var At24 = React.forwardRef(function (_ref351, ref) {
  var className = _ref351.className,
      children = _ref351.children,
      style = _ref351.style,
      tabIndex = _ref351.tabIndex,
      rest = _objectWithoutProperties$2(_ref351, ["className", "children", "style", "tabIndex"]);

  var _getAttributes351 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes351.tabindex,
      props = _objectWithoutProperties$2(_getAttributes351, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 3A12.92 12.92 0 0 0 3 16v1a13 13 0 0 0 13 13h7v-2h-7A11 11 0 0 1 5 17v-1A10.94 10.94 0 0 1 16 5a10.64 10.64 0 0 1 11 11c0 3.59-1.4 5-3.66 5-1.58 0-2.34-1.29-2.34-3v-8h-2v1.94A3.84 3.84 0 0 0 15.5 10a5.48 5.48 0 0 0-5.5 5.44v2.12A5.48 5.48 0 0 0 15.5 23a4.28 4.28 0 0 0 4-2.46A4.35 4.35 0 0 0 23.41 23c3.07 0 5.59-2 5.59-7A12.72 12.72 0 0 0 16 3zm3 14.56a3.5 3.5 0 0 1-7 0v-2.12a3.5 3.5 0 0 1 7 0z'
  }));
});
At24.displayName = 'At24';
At24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
At24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var At20 = React.forwardRef(function (_ref352, ref) {
  var className = _ref352.className,
      children = _ref352.children,
      style = _ref352.style,
      tabIndex = _ref352.tabIndex,
      rest = _objectWithoutProperties$2(_ref352, ["className", "children", "style", "tabIndex"]);

  var _getAttributes352 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes352.tabindex,
      props = _objectWithoutProperties$2(_getAttributes352, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 3A12.92 12.92 0 0 0 3 16v1a13 13 0 0 0 13 13h7v-2h-7A11 11 0 0 1 5 17v-1A10.94 10.94 0 0 1 16 5a10.64 10.64 0 0 1 11 11c0 3.59-1.4 5-3.66 5-1.58 0-2.34-1.29-2.34-3v-8h-2v1.94A3.84 3.84 0 0 0 15.5 10a5.48 5.48 0 0 0-5.5 5.44v2.12A5.48 5.48 0 0 0 15.5 23a4.28 4.28 0 0 0 4-2.46A4.35 4.35 0 0 0 23.41 23c3.07 0 5.59-2 5.59-7A12.72 12.72 0 0 0 16 3zm3 14.56a3.5 3.5 0 0 1-7 0v-2.12a3.5 3.5 0 0 1 7 0z'
  }));
});
At20.displayName = 'At20';
At20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
At20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Attachment32 = React.forwardRef(function (_ref353, ref) {
  var className = _ref353.className,
      children = _ref353.children,
      style = _ref353.style,
      tabIndex = _ref353.tabIndex,
      rest = _objectWithoutProperties$2(_ref353, ["className", "children", "style", "tabIndex"]);

  var _getAttributes353 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes353.tabindex,
      props = _objectWithoutProperties$2(_getAttributes353, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.1 17.9l-13-13a6.51 6.51 0 0 0-9.2 9.2l3 3 1.41-1.41-3-3a4.5 4.5 0 1 1 6.36-6.36l13 13a4.5 4.5 0 1 1-6.36 6.36l-6.13-6.13A2.5 2.5 0 0 1 16.72 16l3.17 3.17 1.41-1.41s-3.22-3.23-3.25-3.24a4.49 4.49 0 0 0-6.34 6.35l6.19 6.23a6.51 6.51 0 0 0 9.2-9.2z'
  }));
});
Attachment32.displayName = 'Attachment32';
Attachment32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Attachment32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Attachment24 = React.forwardRef(function (_ref354, ref) {
  var className = _ref354.className,
      children = _ref354.children,
      style = _ref354.style,
      tabIndex = _ref354.tabIndex,
      rest = _objectWithoutProperties$2(_ref354, ["className", "children", "style", "tabIndex"]);

  var _getAttributes354 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes354.tabindex,
      props = _objectWithoutProperties$2(_getAttributes354, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.1 17.9l-13-13a6.51 6.51 0 0 0-9.2 9.2l3 3 1.41-1.41-3-3a4.5 4.5 0 1 1 6.36-6.36l13 13a4.5 4.5 0 1 1-6.36 6.36l-6.13-6.13A2.5 2.5 0 0 1 16.72 16l3.17 3.17 1.41-1.41s-3.22-3.23-3.25-3.24a4.49 4.49 0 0 0-6.34 6.35l6.19 6.23a6.51 6.51 0 0 0 9.2-9.2z'
  }));
});
Attachment24.displayName = 'Attachment24';
Attachment24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Attachment24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Attachment20 = React.forwardRef(function (_ref355, ref) {
  var className = _ref355.className,
      children = _ref355.children,
      style = _ref355.style,
      tabIndex = _ref355.tabIndex,
      rest = _objectWithoutProperties$2(_ref355, ["className", "children", "style", "tabIndex"]);

  var _getAttributes355 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes355.tabindex,
      props = _objectWithoutProperties$2(_getAttributes355, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.1 17.9l-13-13a6.51 6.51 0 0 0-9.2 9.2l3 3 1.41-1.41-3-3a4.5 4.5 0 1 1 6.36-6.36l13 13a4.5 4.5 0 1 1-6.36 6.36l-6.13-6.13A2.5 2.5 0 0 1 16.72 16l3.17 3.17 1.41-1.41s-3.22-3.23-3.25-3.24a4.49 4.49 0 0 0-6.34 6.35l6.19 6.23a6.51 6.51 0 0 0 9.2-9.2z'
  }));
});
Attachment20.displayName = 'Attachment20';
Attachment20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Attachment20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryCharging32 = React.forwardRef(function (_ref356, ref) {
  var className = _ref356.className,
      children = _ref356.children,
      style = _ref356.style,
      tabIndex = _ref356.tabIndex,
      rest = _objectWithoutProperties$2(_ref356, ["className", "children", "style", "tabIndex"]);

  var _getAttributes356 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes356.tabindex,
      props = _objectWithoutProperties$2(_getAttributes356, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 11h-1v-1a2 2 0 0 0-2-2h-4v2h4v3h3v6h-3v3h-5v2h5a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM11 22H6V10h6V8H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5z'
  }), React.createElement('path', {
    d: 'M14.81 23.58l-1.62-1.16L17.06 17H9.37l6.85-8.62 1.56 1.24L13.51 15h7.43l-6.13 8.58z'
  }));
});
BatteryCharging32.displayName = 'BatteryCharging32';
BatteryCharging32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryCharging32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryCharging24 = React.forwardRef(function (_ref357, ref) {
  var className = _ref357.className,
      children = _ref357.children,
      style = _ref357.style,
      tabIndex = _ref357.tabIndex,
      rest = _objectWithoutProperties$2(_ref357, ["className", "children", "style", "tabIndex"]);

  var _getAttributes357 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes357.tabindex,
      props = _objectWithoutProperties$2(_getAttributes357, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 11h-1v-1a2 2 0 0 0-2-2h-4v2h4v3h3v6h-3v3h-5v2h5a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM11 22H6V10h6V8H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5z'
  }), React.createElement('path', {
    d: 'M14.81 23.58l-1.62-1.16L17.06 17H9.37l6.85-8.62 1.56 1.24L13.51 15h7.43l-6.13 8.58z'
  }));
});
BatteryCharging24.displayName = 'BatteryCharging24';
BatteryCharging24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryCharging24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryCharging20 = React.forwardRef(function (_ref358, ref) {
  var className = _ref358.className,
      children = _ref358.children,
      style = _ref358.style,
      tabIndex = _ref358.tabIndex,
      rest = _objectWithoutProperties$2(_ref358, ["className", "children", "style", "tabIndex"]);

  var _getAttributes358 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes358.tabindex,
      props = _objectWithoutProperties$2(_getAttributes358, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 11h-1v-1a2 2 0 0 0-2-2h-4v2h4v3h3v6h-3v3h-5v2h5a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM11 22H6V10h6V8H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5z'
  }), React.createElement('path', {
    d: 'M14.81 23.58l-1.62-1.16L17.06 17H9.37l6.85-8.62 1.56 1.24L13.51 15h7.43l-6.13 8.58z'
  }));
});
BatteryCharging20.displayName = 'BatteryCharging20';
BatteryCharging20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryCharging20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryFull32 = React.forwardRef(function (_ref359, ref) {
  var className = _ref359.className,
      children = _ref359.children,
      style = _ref359.style,
      tabIndex = _ref359.tabIndex,
      rest = _objectWithoutProperties$2(_ref359, ["className", "children", "style", "tabIndex"]);

  var _getAttributes359 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes359.tabindex,
      props = _objectWithoutProperties$2(_getAttributes359, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M22 12v8H8v-8z'
  }));
});
BatteryFull32.displayName = 'BatteryFull32';
BatteryFull32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryFull32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryFull24 = React.forwardRef(function (_ref360, ref) {
  var className = _ref360.className,
      children = _ref360.children,
      style = _ref360.style,
      tabIndex = _ref360.tabIndex,
      rest = _objectWithoutProperties$2(_ref360, ["className", "children", "style", "tabIndex"]);

  var _getAttributes360 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes360.tabindex,
      props = _objectWithoutProperties$2(_getAttributes360, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M22 12v8H8v-8z'
  }));
});
BatteryFull24.displayName = 'BatteryFull24';
BatteryFull24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryFull24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryFull20 = React.forwardRef(function (_ref361, ref) {
  var className = _ref361.className,
      children = _ref361.children,
      style = _ref361.style,
      tabIndex = _ref361.tabIndex,
      rest = _objectWithoutProperties$2(_ref361, ["className", "children", "style", "tabIndex"]);

  var _getAttributes361 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes361.tabindex,
      props = _objectWithoutProperties$2(_getAttributes361, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M22 12v8H8v-8z'
  }));
});
BatteryFull20.displayName = 'BatteryFull20';
BatteryFull20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryFull20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryHalf32 = React.forwardRef(function (_ref362, ref) {
  var className = _ref362.className,
      children = _ref362.children,
      style = _ref362.style,
      tabIndex = _ref362.tabIndex,
      rest = _objectWithoutProperties$2(_ref362, ["className", "children", "style", "tabIndex"]);

  var _getAttributes362 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes362.tabindex,
      props = _objectWithoutProperties$2(_getAttributes362, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M16 12v8H8v-8z'
  }));
});
BatteryHalf32.displayName = 'BatteryHalf32';
BatteryHalf32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryHalf32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryHalf24 = React.forwardRef(function (_ref363, ref) {
  var className = _ref363.className,
      children = _ref363.children,
      style = _ref363.style,
      tabIndex = _ref363.tabIndex,
      rest = _objectWithoutProperties$2(_ref363, ["className", "children", "style", "tabIndex"]);

  var _getAttributes363 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes363.tabindex,
      props = _objectWithoutProperties$2(_getAttributes363, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M16 12v8H8v-8z'
  }));
});
BatteryHalf24.displayName = 'BatteryHalf24';
BatteryHalf24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryHalf24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryHalf20 = React.forwardRef(function (_ref364, ref) {
  var className = _ref364.className,
      children = _ref364.children,
      style = _ref364.style,
      tabIndex = _ref364.tabIndex,
      rest = _objectWithoutProperties$2(_ref364, ["className", "children", "style", "tabIndex"]);

  var _getAttributes364 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes364.tabindex,
      props = _objectWithoutProperties$2(_getAttributes364, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M16 12v8H8v-8z'
  }));
});
BatteryHalf20.displayName = 'BatteryHalf20';
BatteryHalf20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryHalf20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryLow32 = React.forwardRef(function (_ref365, ref) {
  var className = _ref365.className,
      children = _ref365.children,
      style = _ref365.style,
      tabIndex = _ref365.tabIndex,
      rest = _objectWithoutProperties$2(_ref365, ["className", "children", "style", "tabIndex"]);

  var _getAttributes365 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes365.tabindex,
      props = _objectWithoutProperties$2(_getAttributes365, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M12 12v8H8v-8z'
  }));
});
BatteryLow32.displayName = 'BatteryLow32';
BatteryLow32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryLow32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryLow24 = React.forwardRef(function (_ref366, ref) {
  var className = _ref366.className,
      children = _ref366.children,
      style = _ref366.style,
      tabIndex = _ref366.tabIndex,
      rest = _objectWithoutProperties$2(_ref366, ["className", "children", "style", "tabIndex"]);

  var _getAttributes366 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes366.tabindex,
      props = _objectWithoutProperties$2(_getAttributes366, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M12 12v8H8v-8z'
  }));
});
BatteryLow24.displayName = 'BatteryLow24';
BatteryLow24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryLow24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BatteryLow20 = React.forwardRef(function (_ref367, ref) {
  var className = _ref367.className,
      children = _ref367.children,
      style = _ref367.style,
      tabIndex = _ref367.tabIndex,
      rest = _objectWithoutProperties$2(_ref367, ["className", "children", "style", "tabIndex"]);

  var _getAttributes367 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes367.tabindex,
      props = _objectWithoutProperties$2(_getAttributes367, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 24H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1v1a2 2 0 0 1-2 2zM6 10v12h18v-3h3v-6h-3v-3z'
  }), React.createElement('path', {
    d: 'M12 12v8H8v-8z'
  }));
});
BatteryLow20.displayName = 'BatteryLow20';
BatteryLow20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BatteryLow20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bee32 = React.forwardRef(function (_ref368, ref) {
  var className = _ref368.className,
      children = _ref368.children,
      style = _ref368.style,
      tabIndex = _ref368.tabIndex,
      rest = _objectWithoutProperties$2(_ref368, ["className", "children", "style", "tabIndex"]);

  var _getAttributes368 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes368.tabindex,
      props = _objectWithoutProperties$2(_getAttributes368, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10a6 6 0 0 0-6 6v8a6 6 0 0 0 12 0v-8a6 6 0 0 0-6-6zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0 1 11.75 24v-.13h8.5V24A4.27 4.27 0 0 1 16 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 0 1 8.5 0zm10.41 3.09L24 13v9.1a4 4 0 0 0 8 0 3.83 3.83 0 0 0-1.34-2.89zM28 24.35a2.25 2.25 0 0 1-2.25-2.25V17l3.72 3.47A2.05 2.05 0 0 1 30.2 22a2.25 2.25 0 0 1-2.2 2.35zM0 22.1a4 4 0 0 0 8 0V13l-6.66 6.21A3.88 3.88 0 0 0 0 22.1zm2.48-1.56L6.25 17v5.1a2.25 2.25 0 0 1-4.5 0 2.05 2.05 0 0 1 .73-1.56zM15 5.5A3.5 3.5 0 1 0 11.5 9 3.5 3.5 0 0 0 15 5.5zm-5.25 0a1.75 1.75 0 1 1 1.75 1.75A1.77 1.77 0 0 1 9.75 5.5zM20.5 2A3.5 3.5 0 1 0 24 5.5 3.5 3.5 0 0 0 20.5 2zm0 5.25a1.75 1.75 0 1 1 1.75-1.75 1.77 1.77 0 0 1-1.75 1.75z'
  }));
});
Bee32.displayName = 'Bee32';
Bee32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bee32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bee24 = React.forwardRef(function (_ref369, ref) {
  var className = _ref369.className,
      children = _ref369.children,
      style = _ref369.style,
      tabIndex = _ref369.tabIndex,
      rest = _objectWithoutProperties$2(_ref369, ["className", "children", "style", "tabIndex"]);

  var _getAttributes369 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes369.tabindex,
      props = _objectWithoutProperties$2(_getAttributes369, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10a6 6 0 0 0-6 6v8a6 6 0 0 0 12 0v-8a6 6 0 0 0-6-6zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0 1 11.75 24v-.13h8.5V24A4.27 4.27 0 0 1 16 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 0 1 8.5 0zm10.41 3.09L24 13v9.1a4 4 0 0 0 8 0 3.83 3.83 0 0 0-1.34-2.89zM28 24.35a2.25 2.25 0 0 1-2.25-2.25V17l3.72 3.47A2.05 2.05 0 0 1 30.2 22a2.25 2.25 0 0 1-2.2 2.35zM0 22.1a4 4 0 0 0 8 0V13l-6.66 6.21A3.88 3.88 0 0 0 0 22.1zm2.48-1.56L6.25 17v5.1a2.25 2.25 0 0 1-4.5 0 2.05 2.05 0 0 1 .73-1.56zM15 5.5A3.5 3.5 0 1 0 11.5 9 3.5 3.5 0 0 0 15 5.5zm-5.25 0a1.75 1.75 0 1 1 1.75 1.75A1.77 1.77 0 0 1 9.75 5.5zM20.5 2A3.5 3.5 0 1 0 24 5.5 3.5 3.5 0 0 0 20.5 2zm0 5.25a1.75 1.75 0 1 1 1.75-1.75 1.77 1.77 0 0 1-1.75 1.75z'
  }));
});
Bee24.displayName = 'Bee24';
Bee24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bee24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bee20 = React.forwardRef(function (_ref370, ref) {
  var className = _ref370.className,
      children = _ref370.children,
      style = _ref370.style,
      tabIndex = _ref370.tabIndex,
      rest = _objectWithoutProperties$2(_ref370, ["className", "children", "style", "tabIndex"]);

  var _getAttributes370 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes370.tabindex,
      props = _objectWithoutProperties$2(_getAttributes370, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10a6 6 0 0 0-6 6v8a6 6 0 0 0 12 0v-8a6 6 0 0 0-6-6zm-4.25 7.87h8.5v4.25h-8.5zM16 28.25A4.27 4.27 0 0 1 11.75 24v-.13h8.5V24A4.27 4.27 0 0 1 16 28.25zm4.25-12.13h-8.5V16a4.25 4.25 0 0 1 8.5 0zm10.41 3.09L24 13v9.1a4 4 0 0 0 8 0 3.83 3.83 0 0 0-1.34-2.89zM28 24.35a2.25 2.25 0 0 1-2.25-2.25V17l3.72 3.47A2.05 2.05 0 0 1 30.2 22a2.25 2.25 0 0 1-2.2 2.35zM0 22.1a4 4 0 0 0 8 0V13l-6.66 6.21A3.88 3.88 0 0 0 0 22.1zm2.48-1.56L6.25 17v5.1a2.25 2.25 0 0 1-4.5 0 2.05 2.05 0 0 1 .73-1.56zM15 5.5A3.5 3.5 0 1 0 11.5 9 3.5 3.5 0 0 0 15 5.5zm-5.25 0a1.75 1.75 0 1 1 1.75 1.75A1.77 1.77 0 0 1 9.75 5.5zM20.5 2A3.5 3.5 0 1 0 24 5.5 3.5 3.5 0 0 0 20.5 2zm0 5.25a1.75 1.75 0 1 1 1.75-1.75 1.77 1.77 0 0 1-1.75 1.75z'
  }));
});
Bee20.displayName = 'Bee20';
Bee20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bee20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bicycle32 = React.forwardRef(function (_ref371, ref) {
  var className = _ref371.className,
      children = _ref371.children,
      style = _ref371.style,
      tabIndex = _ref371.tabIndex,
      rest = _objectWithoutProperties$2(_ref371, ["className", "children", "style", "tabIndex"]);

  var _getAttributes371 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes371.tabindex,
      props = _objectWithoutProperties$2(_getAttributes371, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 16a5.93 5.93 0 0 0-1.75.26l-2.36-4.71a1.07 1.07 0 0 0-.25-.31L22.72 8H25V6h-7v2h2.61l-1 3H9.38L10 8.21A1 1 0 0 0 9 7H4v2h3.76l-1.5 7H6a6 6 0 1 0 2.22.43l.64-3 7.06 8.82a2 2 0 0 0 1.56.75h2.61A6 6 0 1 0 26 16zm-16 6a4 4 0 1 1-4.17-4L5 21.79A1.55 1.55 0 0 0 5 22a1 1 0 0 0 1 1 1 1 0 0 0 1-.79l.81-3.77A4 4 0 0 1 10 22zm1.08-9H19l-2.32 6.94zm9 8h-1.7l2.39-7.19 1.68 3.35A6.05 6.05 0 0 0 20.09 21zM26 26a4 4 0 0 1-2.62-7l1.73 3.45A1 1 0 0 0 27 22a1.06 1.06 0 0 0-.11-.44l-1.73-3.46A3.86 3.86 0 0 1 26 18a4 4 0 0 1 0 8z'
  }));
});
Bicycle32.displayName = 'Bicycle32';
Bicycle32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bicycle32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bicycle24 = React.forwardRef(function (_ref372, ref) {
  var className = _ref372.className,
      children = _ref372.children,
      style = _ref372.style,
      tabIndex = _ref372.tabIndex,
      rest = _objectWithoutProperties$2(_ref372, ["className", "children", "style", "tabIndex"]);

  var _getAttributes372 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes372.tabindex,
      props = _objectWithoutProperties$2(_getAttributes372, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 16a5.93 5.93 0 0 0-1.75.26l-2.36-4.71a1.07 1.07 0 0 0-.25-.31L22.72 8H25V6h-7v2h2.61l-1 3H9.38L10 8.21A1 1 0 0 0 9 7H4v2h3.76l-1.5 7H6a6 6 0 1 0 2.22.43l.64-3 7.06 8.82a2 2 0 0 0 1.56.75h2.61A6 6 0 1 0 26 16zm-16 6a4 4 0 1 1-4.17-4L5 21.79A1.55 1.55 0 0 0 5 22a1 1 0 0 0 1 1 1 1 0 0 0 1-.79l.81-3.77A4 4 0 0 1 10 22zm1.08-9H19l-2.32 6.94zm9 8h-1.7l2.39-7.19 1.68 3.35A6.05 6.05 0 0 0 20.09 21zM26 26a4 4 0 0 1-2.62-7l1.73 3.45A1 1 0 0 0 27 22a1.06 1.06 0 0 0-.11-.44l-1.73-3.46A3.86 3.86 0 0 1 26 18a4 4 0 0 1 0 8z'
  }));
});
Bicycle24.displayName = 'Bicycle24';
Bicycle24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bicycle24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bicycle20 = React.forwardRef(function (_ref373, ref) {
  var className = _ref373.className,
      children = _ref373.children,
      style = _ref373.style,
      tabIndex = _ref373.tabIndex,
      rest = _objectWithoutProperties$2(_ref373, ["className", "children", "style", "tabIndex"]);

  var _getAttributes373 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes373.tabindex,
      props = _objectWithoutProperties$2(_getAttributes373, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 16a5.93 5.93 0 0 0-1.75.26l-2.36-4.71a1.07 1.07 0 0 0-.25-.31L22.72 8H25V6h-7v2h2.61l-1 3H9.38L10 8.21A1 1 0 0 0 9 7H4v2h3.76l-1.5 7H6a6 6 0 1 0 2.22.43l.64-3 7.06 8.82a2 2 0 0 0 1.56.75h2.61A6 6 0 1 0 26 16zm-16 6a4 4 0 1 1-4.17-4L5 21.79A1.55 1.55 0 0 0 5 22a1 1 0 0 0 1 1 1 1 0 0 0 1-.79l.81-3.77A4 4 0 0 1 10 22zm1.08-9H19l-2.32 6.94zm9 8h-1.7l2.39-7.19 1.68 3.35A6.05 6.05 0 0 0 20.09 21zM26 26a4 4 0 0 1-2.62-7l1.73 3.45A1 1 0 0 0 27 22a1.06 1.06 0 0 0-.11-.44l-1.73-3.46A3.86 3.86 0 0 1 26 18a4 4 0 0 1 0 8z'
  }));
});
Bicycle20.displayName = 'Bicycle20';
Bicycle20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bicycle20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Binoculars32 = React.forwardRef(function (_ref374, ref) {
  var className = _ref374.className,
      children = _ref374.children,
      style = _ref374.style,
      tabIndex = _ref374.tabIndex,
      rest = _objectWithoutProperties$2(_ref374, ["className", "children", "style", "tabIndex"]);

  var _getAttributes374 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes374.tabindex,
      props = _objectWithoutProperties$2(_getAttributes374, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 8V5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v3a2 2 0 0 0-2 2v2h-4v-2a2 2 0 0 0-2-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3a2 2 0 0 0-2 2v12a2 2 0 0 0 1 1.72V27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.28A2 2 0 0 0 14 22v-2h4v2a2 2 0 0 0 1 1.72V27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.28A2 2 0 0 0 30 22V10a2 2 0 0 0-2-2zM11 26H5v-2h6zm1-4H4V10h2V6h4v4h2zm2-4v-4h4v4zm13 8h-6v-2h6zm1-4h-8V10h2V6h4v4h2z'
  }));
});
Binoculars32.displayName = 'Binoculars32';
Binoculars32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Binoculars32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Binoculars24 = React.forwardRef(function (_ref375, ref) {
  var className = _ref375.className,
      children = _ref375.children,
      style = _ref375.style,
      tabIndex = _ref375.tabIndex,
      rest = _objectWithoutProperties$2(_ref375, ["className", "children", "style", "tabIndex"]);

  var _getAttributes375 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes375.tabindex,
      props = _objectWithoutProperties$2(_getAttributes375, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 8V5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v3a2 2 0 0 0-2 2v2h-4v-2a2 2 0 0 0-2-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3a2 2 0 0 0-2 2v12a2 2 0 0 0 1 1.72V27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.28A2 2 0 0 0 14 22v-2h4v2a2 2 0 0 0 1 1.72V27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.28A2 2 0 0 0 30 22V10a2 2 0 0 0-2-2zM11 26H5v-2h6zm1-4H4V10h2V6h4v4h2zm2-4v-4h4v4zm13 8h-6v-2h6zm1-4h-8V10h2V6h4v4h2z'
  }));
});
Binoculars24.displayName = 'Binoculars24';
Binoculars24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Binoculars24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Binoculars20 = React.forwardRef(function (_ref376, ref) {
  var className = _ref376.className,
      children = _ref376.children,
      style = _ref376.style,
      tabIndex = _ref376.tabIndex,
      rest = _objectWithoutProperties$2(_ref376, ["className", "children", "style", "tabIndex"]);

  var _getAttributes376 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes376.tabindex,
      props = _objectWithoutProperties$2(_getAttributes376, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 8V5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v3a2 2 0 0 0-2 2v2h-4v-2a2 2 0 0 0-2-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3a2 2 0 0 0-2 2v12a2 2 0 0 0 1 1.72V27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.28A2 2 0 0 0 14 22v-2h4v2a2 2 0 0 0 1 1.72V27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.28A2 2 0 0 0 30 22V10a2 2 0 0 0-2-2zM11 26H5v-2h6zm1-4H4V10h2V6h4v4h2zm2-4v-4h4v4zm13 8h-6v-2h6zm1-4h-8V10h2V6h4v4h2z'
  }));
});
Binoculars20.displayName = 'Binoculars20';
Binoculars20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Binoculars20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Blog32 = React.forwardRef(function (_ref377, ref) {
  var className = _ref377.className,
      children = _ref377.children,
      style = _ref377.style,
      tabIndex = _ref377.tabIndex,
      rest = _objectWithoutProperties$2(_ref377, ["className", "children", "style", "tabIndex"]);

  var _getAttributes377 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes377.tabindex,
      props = _objectWithoutProperties$2(_getAttributes377, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 24h10v2H4zm0-6h10v2H4zm22-4H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zM6 6v6h20V6zm20 22h-6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-6-8v6h6v-6z'
  }));
});
Blog32.displayName = 'Blog32';
Blog32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Blog32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Blog24 = React.forwardRef(function (_ref378, ref) {
  var className = _ref378.className,
      children = _ref378.children,
      style = _ref378.style,
      tabIndex = _ref378.tabIndex,
      rest = _objectWithoutProperties$2(_ref378, ["className", "children", "style", "tabIndex"]);

  var _getAttributes378 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes378.tabindex,
      props = _objectWithoutProperties$2(_getAttributes378, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 24h10v2H4zm0-6h10v2H4zm22-4H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zM6 6v6h20V6zm20 22h-6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-6-8v6h6v-6z'
  }));
});
Blog24.displayName = 'Blog24';
Blog24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Blog24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Blog20 = React.forwardRef(function (_ref379, ref) {
  var className = _ref379.className,
      children = _ref379.children,
      style = _ref379.style,
      tabIndex = _ref379.tabIndex,
      rest = _objectWithoutProperties$2(_ref379, ["className", "children", "style", "tabIndex"]);

  var _getAttributes379 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes379.tabindex,
      props = _objectWithoutProperties$2(_getAttributes379, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 24h10v2H4zm0-6h10v2H4zm22-4H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zM6 6v6h20V6zm20 22h-6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-6-8v6h6v-6z'
  }));
});
Blog20.displayName = 'Blog20';
Blog20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Blog20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BluetoothOff32 = React.forwardRef(function (_ref380, ref) {
  var className = _ref380.className,
      children = _ref380.children,
      style = _ref380.style,
      tabIndex = _ref380.tabIndex,
      rest = _objectWithoutProperties$2(_ref380, ["className", "children", "style", "tabIndex"]);

  var _getAttributes380 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes380.tabindex,
      props = _objectWithoutProperties$2(_getAttributes380, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 0 0 .58.91A1.06 1.06 0 0 0 16 30a1 1 0 0 0 .65-.24l6.3-5.4L26.59 28zm-11 .24v-8.42l4.53 4.53zm0-14.08V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0 0 24 9a1 1 0 0 0-.35-.72l-7-6a1 1 0 0 0-1.07-.15A1 1 0 0 0 15 3v7.75z'
  }));
});
BluetoothOff32.displayName = 'BluetoothOff32';
BluetoothOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BluetoothOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BluetoothOff24 = React.forwardRef(function (_ref381, ref) {
  var className = _ref381.className,
      children = _ref381.children,
      style = _ref381.style,
      tabIndex = _ref381.tabIndex,
      rest = _objectWithoutProperties$2(_ref381, ["className", "children", "style", "tabIndex"]);

  var _getAttributes381 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes381.tabindex,
      props = _objectWithoutProperties$2(_getAttributes381, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 0 0 .58.91A1.06 1.06 0 0 0 16 30a1 1 0 0 0 .65-.24l6.3-5.4L26.59 28zm-11 .24v-8.42l4.53 4.53zm0-14.08V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0 0 24 9a1 1 0 0 0-.35-.72l-7-6a1 1 0 0 0-1.07-.15A1 1 0 0 0 15 3v7.75z'
  }));
});
BluetoothOff24.displayName = 'BluetoothOff24';
BluetoothOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BluetoothOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BluetoothOff20 = React.forwardRef(function (_ref382, ref) {
  var className = _ref382.className,
      children = _ref382.children,
      style = _ref382.style,
      tabIndex = _ref382.tabIndex,
      rest = _objectWithoutProperties$2(_ref382, ["className", "children", "style", "tabIndex"]);

  var _getAttributes382 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes382.tabindex,
      props = _objectWithoutProperties$2(_getAttributes382, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 26.59L5.41 4 4 5.41 14.59 16 7 23.59 8.41 25 15 18.41V29a1 1 0 0 0 .58.91A1.06 1.06 0 0 0 16 30a1 1 0 0 0 .65-.24l6.3-5.4L26.59 28zm-11 .24v-8.42l4.53 4.53zm0-14.08V5.17l4.53 3.89-4.11 4.11 1.41 1.41 4.88-4.87A1 1 0 0 0 24 9a1 1 0 0 0-.35-.72l-7-6a1 1 0 0 0-1.07-.15A1 1 0 0 0 15 3v7.75z'
  }));
});
BluetoothOff20.displayName = 'BluetoothOff20';
BluetoothOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BluetoothOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bluetooth32 = React.forwardRef(function (_ref383, ref) {
  var className = _ref383.className,
      children = _ref383.children,
      style = _ref383.style,
      tabIndex = _ref383.tabIndex,
      rest = _objectWithoutProperties$2(_ref383, ["className", "children", "style", "tabIndex"]);

  var _getAttributes383 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes383.tabindex,
      props = _objectWithoutProperties$2(_getAttributes383, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a1.06 1.06 0 0 1-.42-.09A1 1 0 0 1 15 29V18.41L8.41 25 7 23.59 14.59 16 7 8.41 8.41 7 15 13.59V3a1 1 0 0 1 .58-.91 1 1 0 0 1 1.07.15l7 6A1 1 0 0 1 24 9a1 1 0 0 1-.29.75L17.41 16l6.3 6.29A1 1 0 0 1 24 23a1 1 0 0 1-.35.72l-7 6A1 1 0 0 1 16 30zm1-11.59v8.42l4.53-3.89zm0-13.24v8.42l4.53-4.53z'
  }));
});
Bluetooth32.displayName = 'Bluetooth32';
Bluetooth32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bluetooth32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bluetooth24 = React.forwardRef(function (_ref384, ref) {
  var className = _ref384.className,
      children = _ref384.children,
      style = _ref384.style,
      tabIndex = _ref384.tabIndex,
      rest = _objectWithoutProperties$2(_ref384, ["className", "children", "style", "tabIndex"]);

  var _getAttributes384 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes384.tabindex,
      props = _objectWithoutProperties$2(_getAttributes384, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a1.06 1.06 0 0 1-.42-.09A1 1 0 0 1 15 29V18.41L8.41 25 7 23.59 14.59 16 7 8.41 8.41 7 15 13.59V3a1 1 0 0 1 .58-.91 1 1 0 0 1 1.07.15l7 6A1 1 0 0 1 24 9a1 1 0 0 1-.29.75L17.41 16l6.3 6.29A1 1 0 0 1 24 23a1 1 0 0 1-.35.72l-7 6A1 1 0 0 1 16 30zm1-11.59v8.42l4.53-3.89zm0-13.24v8.42l4.53-4.53z'
  }));
});
Bluetooth24.displayName = 'Bluetooth24';
Bluetooth24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bluetooth24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bluetooth20 = React.forwardRef(function (_ref385, ref) {
  var className = _ref385.className,
      children = _ref385.children,
      style = _ref385.style,
      tabIndex = _ref385.tabIndex,
      rest = _objectWithoutProperties$2(_ref385, ["className", "children", "style", "tabIndex"]);

  var _getAttributes385 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes385.tabindex,
      props = _objectWithoutProperties$2(_getAttributes385, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a1.06 1.06 0 0 1-.42-.09A1 1 0 0 1 15 29V18.41L8.41 25 7 23.59 14.59 16 7 8.41 8.41 7 15 13.59V3a1 1 0 0 1 .58-.91 1 1 0 0 1 1.07.15l7 6A1 1 0 0 1 24 9a1 1 0 0 1-.29.75L17.41 16l6.3 6.29A1 1 0 0 1 24 23a1 1 0 0 1-.35.72l-7 6A1 1 0 0 1 16 30zm1-11.59v8.42l4.53-3.89zm0-13.24v8.42l4.53-4.53z'
  }));
});
Bluetooth20.displayName = 'Bluetooth20';
Bluetooth20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bluetooth20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bookmark32 = React.forwardRef(function (_ref386, ref) {
  var className = _ref386.className,
      children = _ref386.children,
      style = _ref386.style,
      tabIndex = _ref386.tabIndex,
      rest = _objectWithoutProperties$2(_ref386, ["className", "children", "style", "tabIndex"]);

  var _getAttributes386 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes386.tabindex,
      props = _objectWithoutProperties$2(_getAttributes386, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 4v22.75l-7.1-3.59-.9-.45-.9.45L8 26.75V4h16m0-2H8a2 2 0 0 0-2 2v26l10-5 10 5V4a2 2 0 0 0-2-2z'
  }));
});
Bookmark32.displayName = 'Bookmark32';
Bookmark32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bookmark32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bookmark24 = React.forwardRef(function (_ref387, ref) {
  var className = _ref387.className,
      children = _ref387.children,
      style = _ref387.style,
      tabIndex = _ref387.tabIndex,
      rest = _objectWithoutProperties$2(_ref387, ["className", "children", "style", "tabIndex"]);

  var _getAttributes387 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes387.tabindex,
      props = _objectWithoutProperties$2(_getAttributes387, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 4v22.75l-7.1-3.59-.9-.45-.9.45L8 26.75V4h16m0-2H8a2 2 0 0 0-2 2v26l10-5 10 5V4a2 2 0 0 0-2-2z'
  }));
});
Bookmark24.displayName = 'Bookmark24';
Bookmark24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bookmark24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bookmark20 = React.forwardRef(function (_ref388, ref) {
  var className = _ref388.className,
      children = _ref388.children,
      style = _ref388.style,
      tabIndex = _ref388.tabIndex,
      rest = _objectWithoutProperties$2(_ref388, ["className", "children", "style", "tabIndex"]);

  var _getAttributes388 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes388.tabindex,
      props = _objectWithoutProperties$2(_getAttributes388, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 4v22.75l-7.1-3.59-.9-.45-.9.45L8 26.75V4h16m0-2H8a2 2 0 0 0-2 2v26l10-5 10 5V4a2 2 0 0 0-2-2z'
  }));
});
Bookmark20.displayName = 'Bookmark20';
Bookmark20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bookmark20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Box32 = React.forwardRef(function (_ref389, ref) {
  var className = _ref389.className,
      children = _ref389.children,
      style = _ref389.style,
      tabIndex = _ref389.tabIndex,
      rest = _objectWithoutProperties$2(_ref389, ["className", "children", "style", "tabIndex"]);

  var _getAttributes389 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes389.tabindex,
      props = _objectWithoutProperties$2(_getAttributes389, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 21h-8a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-4v2h8v-2z'
  }), React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 24H6V12h20zm2-18H4V6h24v4z'
  }));
});
Box32.displayName = 'Box32';
Box32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Box32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Box24 = React.forwardRef(function (_ref390, ref) {
  var className = _ref390.className,
      children = _ref390.children,
      style = _ref390.style,
      tabIndex = _ref390.tabIndex,
      rest = _objectWithoutProperties$2(_ref390, ["className", "children", "style", "tabIndex"]);

  var _getAttributes390 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes390.tabindex,
      props = _objectWithoutProperties$2(_getAttributes390, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 21h-8a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-4v2h8v-2z'
  }), React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 24H6V12h20zm2-18H4V6h24v4z'
  }));
});
Box24.displayName = 'Box24';
Box24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Box24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Box20 = React.forwardRef(function (_ref391, ref) {
  var className = _ref391.className,
      children = _ref391.children,
      style = _ref391.style,
      tabIndex = _ref391.tabIndex,
      rest = _objectWithoutProperties$2(_ref391, ["className", "children", "style", "tabIndex"]);

  var _getAttributes391 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes391.tabindex,
      props = _objectWithoutProperties$2(_getAttributes391, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 21h-8a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-4v2h8v-2z'
  }), React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 24H6V12h20zm2-18H4V6h24v4z'
  }));
});
Box20.displayName = 'Box20';
Box20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Box20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BrightnessContrast32 = React.forwardRef(function (_ref392, ref) {
  var className = _ref392.className,
      children = _ref392.children,
      style = _ref392.style,
      tabIndex = _ref392.tabIndex,
      rest = _objectWithoutProperties$2(_ref392, ["className", "children", "style", "tabIndex"]);

  var _getAttributes392 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes392.tabindex,
      props = _objectWithoutProperties$2(_getAttributes392, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v3h-2zm12 13h3v2h-3zM15 27h2v3h-2zM2 15h3v2H2zm3.45-8.117L6.864 5.47l2.122 2.12L7.57 9.004zM23 7.581l2.12-2.121 1.414 1.414-2.121 2.122zm.002 16.835l1.414-1.414 2.122 2.122-1.414 1.414zM5.47 25.13L7.59 23 9 24.42l-2.12 2.12-1.41-1.41zM16 8a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14a6 6 0 0 1 0-12z'
  }));
});
BrightnessContrast32.displayName = 'BrightnessContrast32';
BrightnessContrast32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BrightnessContrast32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BrightnessContrast24 = React.forwardRef(function (_ref393, ref) {
  var className = _ref393.className,
      children = _ref393.children,
      style = _ref393.style,
      tabIndex = _ref393.tabIndex,
      rest = _objectWithoutProperties$2(_ref393, ["className", "children", "style", "tabIndex"]);

  var _getAttributes393 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes393.tabindex,
      props = _objectWithoutProperties$2(_getAttributes393, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v3h-2zm12 13h3v2h-3zM15 27h2v3h-2zM2 15h3v2H2zm3.45-8.117L6.864 5.47l2.122 2.12L7.57 9.004zM23 7.581l2.12-2.121 1.414 1.414-2.121 2.122zm.002 16.835l1.414-1.414 2.122 2.122-1.414 1.414zM5.47 25.13L7.59 23 9 24.42l-2.12 2.12-1.41-1.41zM16 8a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14a6 6 0 0 1 0-12z'
  }));
});
BrightnessContrast24.displayName = 'BrightnessContrast24';
BrightnessContrast24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BrightnessContrast24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var BrightnessContrast20 = React.forwardRef(function (_ref394, ref) {
  var className = _ref394.className,
      children = _ref394.children,
      style = _ref394.style,
      tabIndex = _ref394.tabIndex,
      rest = _objectWithoutProperties$2(_ref394, ["className", "children", "style", "tabIndex"]);

  var _getAttributes394 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes394.tabindex,
      props = _objectWithoutProperties$2(_getAttributes394, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v3h-2zm12 13h3v2h-3zM15 27h2v3h-2zM2 15h3v2H2zm3.45-8.117L6.864 5.47l2.122 2.12L7.57 9.004zM23 7.581l2.12-2.121 1.414 1.414-2.121 2.122zm.002 16.835l1.414-1.414 2.122 2.122-1.414 1.414zM5.47 25.13L7.59 23 9 24.42l-2.12 2.12-1.41-1.41zM16 8a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14a6 6 0 0 1 0-12z'
  }));
});
BrightnessContrast20.displayName = 'BrightnessContrast20';
BrightnessContrast20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
BrightnessContrast20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bus32 = React.forwardRef(function (_ref395, ref) {
  var className = _ref395.className,
      children = _ref395.children,
      style = _ref395.style,
      tabIndex = _ref395.tabIndex,
      rest = _objectWithoutProperties$2(_ref395, ["className", "children", "style", "tabIndex"]);

  var _getAttributes395 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes395.tabindex,
      props = _objectWithoutProperties$2(_getAttributes395, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 8h2v6H3zm24 0h2v6h-2zM10 19h2v2h-2zm10 0h2v2h-2z'
  }), React.createElement('path', {
    d: 'M21 2H11a5 5 0 0 0-5 5v16a2 2 0 0 0 2 2v3h2v-3h12v3h2v-3a2 2 0 0 0 2-2V7a5 5 0 0 0-5-5zm3 6v7H8V8zM11 4h10a3 3 0 0 1 2.82 2H8.18A3 3 0 0 1 11 4zM8 23v-6h16v6z'
  }));
});
Bus32.displayName = 'Bus32';
Bus32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bus32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bus24 = React.forwardRef(function (_ref396, ref) {
  var className = _ref396.className,
      children = _ref396.children,
      style = _ref396.style,
      tabIndex = _ref396.tabIndex,
      rest = _objectWithoutProperties$2(_ref396, ["className", "children", "style", "tabIndex"]);

  var _getAttributes396 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes396.tabindex,
      props = _objectWithoutProperties$2(_getAttributes396, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 8h2v6H3zm24 0h2v6h-2zM10 19h2v2h-2zm10 0h2v2h-2z'
  }), React.createElement('path', {
    d: 'M21 2H11a5 5 0 0 0-5 5v16a2 2 0 0 0 2 2v3h2v-3h12v3h2v-3a2 2 0 0 0 2-2V7a5 5 0 0 0-5-5zm3 6v7H8V8zM11 4h10a3 3 0 0 1 2.82 2H8.18A3 3 0 0 1 11 4zM8 23v-6h16v6z'
  }));
});
Bus24.displayName = 'Bus24';
Bus24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bus24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Bus20 = React.forwardRef(function (_ref397, ref) {
  var className = _ref397.className,
      children = _ref397.children,
      style = _ref397.style,
      tabIndex = _ref397.tabIndex,
      rest = _objectWithoutProperties$2(_ref397, ["className", "children", "style", "tabIndex"]);

  var _getAttributes397 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes397.tabindex,
      props = _objectWithoutProperties$2(_getAttributes397, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 8h2v6H3zm24 0h2v6h-2zM10 19h2v2h-2zm10 0h2v2h-2z'
  }), React.createElement('path', {
    d: 'M21 2H11a5 5 0 0 0-5 5v16a2 2 0 0 0 2 2v3h2v-3h12v3h2v-3a2 2 0 0 0 2-2V7a5 5 0 0 0-5-5zm3 6v7H8V8zM11 4h10a3 3 0 0 1 2.82 2H8.18A3 3 0 0 1 11 4zM8 23v-6h16v6z'
  }));
});
Bus20.displayName = 'Bus20';
Bus20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Bus20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calculator32 = React.forwardRef(function (_ref398, ref) {
  var className = _ref398.className,
      children = _ref398.children,
      style = _ref398.style,
      tabIndex = _ref398.tabIndex,
      rest = _objectWithoutProperties$2(_ref398, ["className", "children", "style", "tabIndex"]);

  var _getAttributes398 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes398.tabindex,
      props = _objectWithoutProperties$2(_getAttributes398, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4v24H6V4h20m0-2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M9 23h2v2H9zm12 0h2v2h-2zM9 18h2v2H9zm12 0h2v2h-2zM9 13h2v2H9zm6 10h2v2h-2zm0-5h2v2h-2zm0-5h2v2h-2zm6 0h2v2h-2zM9 7h14v3H9z'
  }));
});
Calculator32.displayName = 'Calculator32';
Calculator32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calculator32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calculator24 = React.forwardRef(function (_ref399, ref) {
  var className = _ref399.className,
      children = _ref399.children,
      style = _ref399.style,
      tabIndex = _ref399.tabIndex,
      rest = _objectWithoutProperties$2(_ref399, ["className", "children", "style", "tabIndex"]);

  var _getAttributes399 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes399.tabindex,
      props = _objectWithoutProperties$2(_getAttributes399, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4v24H6V4h20m0-2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M9 23h2v2H9zm12 0h2v2h-2zM9 18h2v2H9zm12 0h2v2h-2zM9 13h2v2H9zm6 10h2v2h-2zm0-5h2v2h-2zm0-5h2v2h-2zm6 0h2v2h-2zM9 7h14v3H9z'
  }));
});
Calculator24.displayName = 'Calculator24';
Calculator24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calculator24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calculator20 = React.forwardRef(function (_ref400, ref) {
  var className = _ref400.className,
      children = _ref400.children,
      style = _ref400.style,
      tabIndex = _ref400.tabIndex,
      rest = _objectWithoutProperties$2(_ref400, ["className", "children", "style", "tabIndex"]);

  var _getAttributes400 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes400.tabindex,
      props = _objectWithoutProperties$2(_getAttributes400, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4v24H6V4h20m0-2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M9 23h2v2H9zm12 0h2v2h-2zM9 18h2v2H9zm12 0h2v2h-2zM9 13h2v2H9zm6 10h2v2h-2zm0-5h2v2h-2zm0-5h2v2h-2zm6 0h2v2h-2zM9 7h14v3H9z'
  }));
});
Calculator20.displayName = 'Calculator20';
Calculator20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calculator20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calendar32 = React.forwardRef(function (_ref401, ref) {
  var className = _ref401.className,
      children = _ref401.children,
      style = _ref401.style,
      tabIndex = _ref401.tabIndex,
      rest = _objectWithoutProperties$2(_ref401, ["className", "children", "style", "tabIndex"]);

  var _getAttributes401 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes401.tabindex,
      props = _objectWithoutProperties$2(_getAttributes401, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4.03h-4v-2h-2v2h-8v-2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-20a2 2 0 0 0-2-2zm0 22H6v-14h20zm0-16H6v-4h4v2h2v-2h8v2h2v-2h4z'
  }));
});
Calendar32.displayName = 'Calendar32';
Calendar32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calendar32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calendar24 = React.forwardRef(function (_ref402, ref) {
  var className = _ref402.className,
      children = _ref402.children,
      style = _ref402.style,
      tabIndex = _ref402.tabIndex,
      rest = _objectWithoutProperties$2(_ref402, ["className", "children", "style", "tabIndex"]);

  var _getAttributes402 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes402.tabindex,
      props = _objectWithoutProperties$2(_getAttributes402, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4.03h-4v-2h-2v2h-8v-2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-20a2 2 0 0 0-2-2zm0 22H6v-14h20zm0-16H6v-4h4v2h2v-2h8v2h2v-2h4z'
  }));
});
Calendar24.displayName = 'Calendar24';
Calendar24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calendar24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calendar20 = React.forwardRef(function (_ref403, ref) {
  var className = _ref403.className,
      children = _ref403.children,
      style = _ref403.style,
      tabIndex = _ref403.tabIndex,
      rest = _objectWithoutProperties$2(_ref403, ["className", "children", "style", "tabIndex"]);

  var _getAttributes403 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes403.tabindex,
      props = _objectWithoutProperties$2(_getAttributes403, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4.03h-4v-2h-2v2h-8v-2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-20a2 2 0 0 0-2-2zm0 22H6v-14h20zm0-16H6v-4h4v2h2v-2h8v2h2v-2h4z'
  }));
});
Calendar20.displayName = 'Calendar20';
Calendar20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calendar20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calibrate32 = React.forwardRef(function (_ref404, ref) {
  var className = _ref404.className,
      children = _ref404.children,
      style = _ref404.style,
      tabIndex = _ref404.tabIndex,
      rest = _objectWithoutProperties$2(_ref404, ["className", "children", "style", "tabIndex"]);

  var _getAttributes404 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes404.tabindex,
      props = _objectWithoutProperties$2(_getAttributes404, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 21.17L25 17.37l.67-.67a1 1 0 0 0 0-1.41l-6-6a1 1 0 0 0-1.41 0l-.79.79-6.76-6.79a1 1 0 0 0-1.41 0l-4 4-.12.15-4 6a1 1 0 0 0 .12 1.26l3 3a1 1 0 0 0 1.42 0L10 13.41l2.09 2.09-4.8 4.79a1 1 0 0 0 0 1.41l2 2a1 1 0 0 0 .71.3 1 1 0 0 0 .52-.15l4.33-2.6 2.44 2.45a1 1 0 0 0 1.41 0l.67-.7 3.79 3.83a4 4 0 0 0 5.66-5.66zM10 10.58l-5 5-1.71-1.71 3.49-5.24L10 5.41l6.09 6.09-2.59 2.58zm8 11l-2.84-2.84-5 3-.74-.74L19 11.41 23.59 16zm9.42 3.83a2 2 0 0 1-2.83 0l-3.8-3.79 2.83-2.83 3.8 3.79a2 2 0 0 1 0 2.83z'
  }));
});
Calibrate32.displayName = 'Calibrate32';
Calibrate32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calibrate32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calibrate24 = React.forwardRef(function (_ref405, ref) {
  var className = _ref405.className,
      children = _ref405.children,
      style = _ref405.style,
      tabIndex = _ref405.tabIndex,
      rest = _objectWithoutProperties$2(_ref405, ["className", "children", "style", "tabIndex"]);

  var _getAttributes405 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes405.tabindex,
      props = _objectWithoutProperties$2(_getAttributes405, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 21.17L25 17.37l.67-.67a1 1 0 0 0 0-1.41l-6-6a1 1 0 0 0-1.41 0l-.79.79-6.76-6.79a1 1 0 0 0-1.41 0l-4 4-.12.15-4 6a1 1 0 0 0 .12 1.26l3 3a1 1 0 0 0 1.42 0L10 13.41l2.09 2.09-4.8 4.79a1 1 0 0 0 0 1.41l2 2a1 1 0 0 0 .71.3 1 1 0 0 0 .52-.15l4.33-2.6 2.44 2.45a1 1 0 0 0 1.41 0l.67-.7 3.79 3.83a4 4 0 0 0 5.66-5.66zM10 10.58l-5 5-1.71-1.71 3.49-5.24L10 5.41l6.09 6.09-2.59 2.58zm8 11l-2.84-2.84-5 3-.74-.74L19 11.41 23.59 16zm9.42 3.83a2 2 0 0 1-2.83 0l-3.8-3.79 2.83-2.83 3.8 3.79a2 2 0 0 1 0 2.83z'
  }));
});
Calibrate24.displayName = 'Calibrate24';
Calibrate24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calibrate24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Calibrate20 = React.forwardRef(function (_ref406, ref) {
  var className = _ref406.className,
      children = _ref406.children,
      style = _ref406.style,
      tabIndex = _ref406.tabIndex,
      rest = _objectWithoutProperties$2(_ref406, ["className", "children", "style", "tabIndex"]);

  var _getAttributes406 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes406.tabindex,
      props = _objectWithoutProperties$2(_getAttributes406, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 21.17L25 17.37l.67-.67a1 1 0 0 0 0-1.41l-6-6a1 1 0 0 0-1.41 0l-.79.79-6.76-6.79a1 1 0 0 0-1.41 0l-4 4-.12.15-4 6a1 1 0 0 0 .12 1.26l3 3a1 1 0 0 0 1.42 0L10 13.41l2.09 2.09-4.8 4.79a1 1 0 0 0 0 1.41l2 2a1 1 0 0 0 .71.3 1 1 0 0 0 .52-.15l4.33-2.6 2.44 2.45a1 1 0 0 0 1.41 0l.67-.7 3.79 3.83a4 4 0 0 0 5.66-5.66zM10 10.58l-5 5-1.71-1.71 3.49-5.24L10 5.41l6.09 6.09-2.59 2.58zm8 11l-2.84-2.84-5 3-.74-.74L19 11.41 23.59 16zm9.42 3.83a2 2 0 0 1-2.83 0l-3.8-3.79 2.83-2.83 3.8 3.79a2 2 0 0 1 0 2.83z'
  }));
});
Calibrate20.displayName = 'Calibrate20';
Calibrate20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Calibrate20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CameraAction32 = React.forwardRef(function (_ref407, ref) {
  var className = _ref407.className,
      children = _ref407.children,
      style = _ref407.style,
      tabIndex = _ref407.tabIndex,
      rest = _objectWithoutProperties$2(_ref407, ["className", "children", "style", "tabIndex"]);

  var _getAttributes407 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes407.tabindex,
      props = _objectWithoutProperties$2(_getAttributes407, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 23a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('path', {
    d: 'M29 27H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1zM4 25h24V7H4z'
  }), React.createElement('path', {
    d: 'M19 9h7v2h-7z'
  }), React.createElement('circle', {
    cx: '12',
    cy: '17',
    r: '1'
  }));
});
CameraAction32.displayName = 'CameraAction32';
CameraAction32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CameraAction32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CameraAction24 = React.forwardRef(function (_ref408, ref) {
  var className = _ref408.className,
      children = _ref408.children,
      style = _ref408.style,
      tabIndex = _ref408.tabIndex,
      rest = _objectWithoutProperties$2(_ref408, ["className", "children", "style", "tabIndex"]);

  var _getAttributes408 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes408.tabindex,
      props = _objectWithoutProperties$2(_getAttributes408, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 23a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('path', {
    d: 'M29 27H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1zM4 25h24V7H4z'
  }), React.createElement('path', {
    d: 'M19 9h7v2h-7z'
  }), React.createElement('circle', {
    cx: '12',
    cy: '17',
    r: '1'
  }));
});
CameraAction24.displayName = 'CameraAction24';
CameraAction24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CameraAction24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CameraAction20 = React.forwardRef(function (_ref409, ref) {
  var className = _ref409.className,
      children = _ref409.children,
      style = _ref409.style,
      tabIndex = _ref409.tabIndex,
      rest = _objectWithoutProperties$2(_ref409, ["className", "children", "style", "tabIndex"]);

  var _getAttributes409 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes409.tabindex,
      props = _objectWithoutProperties$2(_getAttributes409, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 23a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('path', {
    d: 'M29 27H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1zM4 25h24V7H4z'
  }), React.createElement('path', {
    d: 'M19 9h7v2h-7z'
  }), React.createElement('circle', {
    cx: '12',
    cy: '17',
    r: '1'
  }));
});
CameraAction20.displayName = 'CameraAction20';
CameraAction20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CameraAction20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Camera32 = React.forwardRef(function (_ref410, ref) {
  var className = _ref410.className,
      children = _ref410.children,
      style = _ref410.style,
      tabIndex = _ref410.tabIndex,
      rest = _objectWithoutProperties$2(_ref410, ["className", "children", "style", "tabIndex"]);

  var _getAttributes410 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes410.tabindex,
      props = _objectWithoutProperties$2(_getAttributes410, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 26H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6.46l1.71-2.55A1 1 0 0 1 12 4h8a1 1 0 0 1 .83.45L22.54 7H29a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zM4 24h24V9h-6a1 1 0 0 1-.83-.45L19.46 6h-6.92l-1.71 2.55A1 1 0 0 1 10 9H4z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }));
});
Camera32.displayName = 'Camera32';
Camera32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Camera32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Camera24 = React.forwardRef(function (_ref411, ref) {
  var className = _ref411.className,
      children = _ref411.children,
      style = _ref411.style,
      tabIndex = _ref411.tabIndex,
      rest = _objectWithoutProperties$2(_ref411, ["className", "children", "style", "tabIndex"]);

  var _getAttributes411 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes411.tabindex,
      props = _objectWithoutProperties$2(_getAttributes411, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 26H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6.46l1.71-2.55A1 1 0 0 1 12 4h8a1 1 0 0 1 .83.45L22.54 7H29a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zM4 24h24V9h-6a1 1 0 0 1-.83-.45L19.46 6h-6.92l-1.71 2.55A1 1 0 0 1 10 9H4z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }));
});
Camera24.displayName = 'Camera24';
Camera24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Camera24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Camera20 = React.forwardRef(function (_ref412, ref) {
  var className = _ref412.className,
      children = _ref412.children,
      style = _ref412.style,
      tabIndex = _ref412.tabIndex,
      rest = _objectWithoutProperties$2(_ref412, ["className", "children", "style", "tabIndex"]);

  var _getAttributes412 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes412.tabindex,
      props = _objectWithoutProperties$2(_getAttributes412, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 26H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6.46l1.71-2.55A1 1 0 0 1 12 4h8a1 1 0 0 1 .83.45L22.54 7H29a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zM4 24h24V9h-6a1 1 0 0 1-.83-.45L19.46 6h-6.92l-1.71 2.55A1 1 0 0 1 10 9H4z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }));
});
Camera20.displayName = 'Camera20';
Camera20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Camera20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Car32 = React.forwardRef(function (_ref413, ref) {
  var className = _ref413.className,
      children = _ref413.children,
      style = _ref413.style,
      tabIndex = _ref413.tabIndex,
      rest = _objectWithoutProperties$2(_ref413, ["className", "children", "style", "tabIndex"]);

  var _getAttributes413 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes413.tabindex,
      props = _objectWithoutProperties$2(_getAttributes413, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.34 15.94l-7.73-2.78-3.24-4.06A3 3 0 0 0 16.05 8h-8a3 3 0 0 0-2.47 1.32l-2.71 4A5 5 0 0 0 2 16.11V24a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.12a1 1 0 0 0-.66-.94zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-6.89a3 3 0 0 1 .52-1.69l2.71-4a1 1 0 0 1 .83-.42h8a1 1 0 0 1 .77.36l3.4 4.27a1.09 1.09 0 0 0 .44.32L28 17.58z'
  }));
});
Car32.displayName = 'Car32';
Car32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Car32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Car24 = React.forwardRef(function (_ref414, ref) {
  var className = _ref414.className,
      children = _ref414.children,
      style = _ref414.style,
      tabIndex = _ref414.tabIndex,
      rest = _objectWithoutProperties$2(_ref414, ["className", "children", "style", "tabIndex"]);

  var _getAttributes414 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes414.tabindex,
      props = _objectWithoutProperties$2(_getAttributes414, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.34 15.94l-7.73-2.78-3.24-4.06A3 3 0 0 0 16.05 8h-8a3 3 0 0 0-2.47 1.32l-2.71 4A5 5 0 0 0 2 16.11V24a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.12a1 1 0 0 0-.66-.94zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-6.89a3 3 0 0 1 .52-1.69l2.71-4a1 1 0 0 1 .83-.42h8a1 1 0 0 1 .77.36l3.4 4.27a1.09 1.09 0 0 0 .44.32L28 17.58z'
  }));
});
Car24.displayName = 'Car24';
Car24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Car24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Car20 = React.forwardRef(function (_ref415, ref) {
  var className = _ref415.className,
      children = _ref415.children,
      style = _ref415.style,
      tabIndex = _ref415.tabIndex,
      rest = _objectWithoutProperties$2(_ref415, ["className", "children", "style", "tabIndex"]);

  var _getAttributes415 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes415.tabindex,
      props = _objectWithoutProperties$2(_getAttributes415, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.34 15.94l-7.73-2.78-3.24-4.06A3 3 0 0 0 16.05 8h-8a3 3 0 0 0-2.47 1.32l-2.71 4A5 5 0 0 0 2 16.11V24a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.12a1 1 0 0 0-.66-.94zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-6.89a3 3 0 0 1 .52-1.69l2.71-4a1 1 0 0 1 .83-.42h8a1 1 0 0 1 .77.36l3.4 4.27a1.09 1.09 0 0 0 .44.32L28 17.58z'
  }));
});
Car20.displayName = 'Car20';
Car20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Car20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretDown32 = React.forwardRef(function (_ref416, ref) {
  var className = _ref416.className,
      children = _ref416.children,
      style = _ref416.style,
      tabIndex = _ref416.tabIndex,
      rest = _objectWithoutProperties$2(_ref416, ["className", "children", "style", "tabIndex"]);

  var _getAttributes416 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes416.tabindex,
      props = _objectWithoutProperties$2(_getAttributes416, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 12l-7 8-7-8h14z'
  }));
});
CaretDown32.displayName = 'CaretDown32';
CaretDown32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretDown32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretDown24 = React.forwardRef(function (_ref417, ref) {
  var className = _ref417.className,
      children = _ref417.children,
      style = _ref417.style,
      tabIndex = _ref417.tabIndex,
      rest = _objectWithoutProperties$2(_ref417, ["className", "children", "style", "tabIndex"]);

  var _getAttributes417 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes417.tabindex,
      props = _objectWithoutProperties$2(_getAttributes417, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 12l-7 8-7-8h14z'
  }));
});
CaretDown24.displayName = 'CaretDown24';
CaretDown24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretDown24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretDown20 = React.forwardRef(function (_ref418, ref) {
  var className = _ref418.className,
      children = _ref418.children,
      style = _ref418.style,
      tabIndex = _ref418.tabIndex,
      rest = _objectWithoutProperties$2(_ref418, ["className", "children", "style", "tabIndex"]);

  var _getAttributes418 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes418.tabindex,
      props = _objectWithoutProperties$2(_getAttributes418, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 12l-7 8-7-8h14z'
  }));
});
CaretDown20.displayName = 'CaretDown20';
CaretDown20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretDown20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretLeft32 = React.forwardRef(function (_ref419, ref) {
  var className = _ref419.className,
      children = _ref419.children,
      style = _ref419.style,
      tabIndex = _ref419.tabIndex,
      rest = _objectWithoutProperties$2(_ref419, ["className", "children", "style", "tabIndex"]);

  var _getAttributes419 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes419.tabindex,
      props = _objectWithoutProperties$2(_getAttributes419, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 23l-8-7 8-7v14z'
  }));
});
CaretLeft32.displayName = 'CaretLeft32';
CaretLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretLeft24 = React.forwardRef(function (_ref420, ref) {
  var className = _ref420.className,
      children = _ref420.children,
      style = _ref420.style,
      tabIndex = _ref420.tabIndex,
      rest = _objectWithoutProperties$2(_ref420, ["className", "children", "style", "tabIndex"]);

  var _getAttributes420 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes420.tabindex,
      props = _objectWithoutProperties$2(_getAttributes420, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 23l-8-7 8-7v14z'
  }));
});
CaretLeft24.displayName = 'CaretLeft24';
CaretLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretLeft20 = React.forwardRef(function (_ref421, ref) {
  var className = _ref421.className,
      children = _ref421.children,
      style = _ref421.style,
      tabIndex = _ref421.tabIndex,
      rest = _objectWithoutProperties$2(_ref421, ["className", "children", "style", "tabIndex"]);

  var _getAttributes421 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes421.tabindex,
      props = _objectWithoutProperties$2(_getAttributes421, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 23l-8-7 8-7v14z'
  }));
});
CaretLeft20.displayName = 'CaretLeft20';
CaretLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretRight32 = React.forwardRef(function (_ref422, ref) {
  var className = _ref422.className,
      children = _ref422.children,
      style = _ref422.style,
      tabIndex = _ref422.tabIndex,
      rest = _objectWithoutProperties$2(_ref422, ["className", "children", "style", "tabIndex"]);

  var _getAttributes422 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes422.tabindex,
      props = _objectWithoutProperties$2(_getAttributes422, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 9l8 7-8 7V9z'
  }));
});
CaretRight32.displayName = 'CaretRight32';
CaretRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretRight24 = React.forwardRef(function (_ref423, ref) {
  var className = _ref423.className,
      children = _ref423.children,
      style = _ref423.style,
      tabIndex = _ref423.tabIndex,
      rest = _objectWithoutProperties$2(_ref423, ["className", "children", "style", "tabIndex"]);

  var _getAttributes423 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes423.tabindex,
      props = _objectWithoutProperties$2(_getAttributes423, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 9l8 7-8 7V9z'
  }));
});
CaretRight24.displayName = 'CaretRight24';
CaretRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretRight20 = React.forwardRef(function (_ref424, ref) {
  var className = _ref424.className,
      children = _ref424.children,
      style = _ref424.style,
      tabIndex = _ref424.tabIndex,
      rest = _objectWithoutProperties$2(_ref424, ["className", "children", "style", "tabIndex"]);

  var _getAttributes424 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes424.tabindex,
      props = _objectWithoutProperties$2(_getAttributes424, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 9l8 7-8 7V9z'
  }));
});
CaretRight20.displayName = 'CaretRight20';
CaretRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretSort32 = React.forwardRef(function (_ref425, ref) {
  var className = _ref425.className,
      children = _ref425.children,
      style = _ref425.style,
      tabIndex = _ref425.tabIndex,
      rest = _objectWithoutProperties$2(_ref425, ["className", "children", "style", "tabIndex"]);

  var _getAttributes425 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes425.tabindex,
      props = _objectWithoutProperties$2(_getAttributes425, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 12l7-8 7 8H9zm14 8l-7 8-7-8h14z'
  }));
});
CaretSort32.displayName = 'CaretSort32';
CaretSort32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretSort32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretSort24 = React.forwardRef(function (_ref426, ref) {
  var className = _ref426.className,
      children = _ref426.children,
      style = _ref426.style,
      tabIndex = _ref426.tabIndex,
      rest = _objectWithoutProperties$2(_ref426, ["className", "children", "style", "tabIndex"]);

  var _getAttributes426 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes426.tabindex,
      props = _objectWithoutProperties$2(_getAttributes426, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 12l7-8 7 8H9zm14 8l-7 8-7-8h14z'
  }));
});
CaretSort24.displayName = 'CaretSort24';
CaretSort24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretSort24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretSort20 = React.forwardRef(function (_ref427, ref) {
  var className = _ref427.className,
      children = _ref427.children,
      style = _ref427.style,
      tabIndex = _ref427.tabIndex,
      rest = _objectWithoutProperties$2(_ref427, ["className", "children", "style", "tabIndex"]);

  var _getAttributes427 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes427.tabindex,
      props = _objectWithoutProperties$2(_getAttributes427, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 12l7-8 7 8H9zm14 8l-7 8-7-8h14z'
  }));
});
CaretSort20.displayName = 'CaretSort20';
CaretSort20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretSort20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretUp32 = React.forwardRef(function (_ref428, ref) {
  var className = _ref428.className,
      children = _ref428.children,
      style = _ref428.style,
      tabIndex = _ref428.tabIndex,
      rest = _objectWithoutProperties$2(_ref428, ["className", "children", "style", "tabIndex"]);

  var _getAttributes428 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes428.tabindex,
      props = _objectWithoutProperties$2(_getAttributes428, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 20l7-8 7 8H9z'
  }));
});
CaretUp32.displayName = 'CaretUp32';
CaretUp32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretUp32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretUp24 = React.forwardRef(function (_ref429, ref) {
  var className = _ref429.className,
      children = _ref429.children,
      style = _ref429.style,
      tabIndex = _ref429.tabIndex,
      rest = _objectWithoutProperties$2(_ref429, ["className", "children", "style", "tabIndex"]);

  var _getAttributes429 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes429.tabindex,
      props = _objectWithoutProperties$2(_getAttributes429, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 20l7-8 7 8H9z'
  }));
});
CaretUp24.displayName = 'CaretUp24';
CaretUp24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretUp24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretUp20 = React.forwardRef(function (_ref430, ref) {
  var className = _ref430.className,
      children = _ref430.children,
      style = _ref430.style,
      tabIndex = _ref430.tabIndex,
      rest = _objectWithoutProperties$2(_ref430, ["className", "children", "style", "tabIndex"]);

  var _getAttributes430 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes430.tabindex,
      props = _objectWithoutProperties$2(_getAttributes430, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 20l7-8 7 8H9z'
  }));
});
CaretUp20.displayName = 'CaretUp20';
CaretUp20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretUp20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CarouselHorizontal32 = React.forwardRef(function (_ref431, ref) {
  var className = _ref431.className,
      children = _ref431.children,
      style = _ref431.style,
      tabIndex = _ref431.tabIndex,
      rest = _objectWithoutProperties$2(_ref431, ["className", "children", "style", "tabIndex"]);

  var _getAttributes431 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes431.tabindex,
      props = _objectWithoutProperties$2(_getAttributes431, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26H10a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM10 8v16h12V8zM4 24H0v-2h4V10H0V8h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zm28 0h-4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h4v2h-4v12h4z'
  }));
});
CarouselHorizontal32.displayName = 'CarouselHorizontal32';
CarouselHorizontal32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CarouselHorizontal32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CarouselHorizontal24 = React.forwardRef(function (_ref432, ref) {
  var className = _ref432.className,
      children = _ref432.children,
      style = _ref432.style,
      tabIndex = _ref432.tabIndex,
      rest = _objectWithoutProperties$2(_ref432, ["className", "children", "style", "tabIndex"]);

  var _getAttributes432 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes432.tabindex,
      props = _objectWithoutProperties$2(_getAttributes432, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26H10a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM10 8v16h12V8zM4 24H0v-2h4V10H0V8h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zm28 0h-4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h4v2h-4v12h4z'
  }));
});
CarouselHorizontal24.displayName = 'CarouselHorizontal24';
CarouselHorizontal24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CarouselHorizontal24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CarouselHorizontal20 = React.forwardRef(function (_ref433, ref) {
  var className = _ref433.className,
      children = _ref433.children,
      style = _ref433.style,
      tabIndex = _ref433.tabIndex,
      rest = _objectWithoutProperties$2(_ref433, ["className", "children", "style", "tabIndex"]);

  var _getAttributes433 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes433.tabindex,
      props = _objectWithoutProperties$2(_getAttributes433, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26H10a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM10 8v16h12V8zM4 24H0v-2h4V10H0V8h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zm28 0h-4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h4v2h-4v12h4z'
  }));
});
CarouselHorizontal20.displayName = 'CarouselHorizontal20';
CarouselHorizontal20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CarouselHorizontal20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CarouselVertical32 = React.forwardRef(function (_ref434, ref) {
  var className = _ref434.className,
      children = _ref434.children,
      style = _ref434.style,
      tabIndex = _ref434.tabIndex,
      rest = _objectWithoutProperties$2(_ref434, ["className", "children", "style", "tabIndex"]);

  var _getAttributes434 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes434.tabindex,
      props = _objectWithoutProperties$2(_getAttributes434, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 10v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM8 22h16V10H8zm16 6v4h-2v-4H10v4H8v-4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zm0-28v4a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V0h2v4h12V0z'
  }));
});
CarouselVertical32.displayName = 'CarouselVertical32';
CarouselVertical32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CarouselVertical32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CarouselVertical24 = React.forwardRef(function (_ref435, ref) {
  var className = _ref435.className,
      children = _ref435.children,
      style = _ref435.style,
      tabIndex = _ref435.tabIndex,
      rest = _objectWithoutProperties$2(_ref435, ["className", "children", "style", "tabIndex"]);

  var _getAttributes435 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes435.tabindex,
      props = _objectWithoutProperties$2(_getAttributes435, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 10v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM8 22h16V10H8zm16 6v4h-2v-4H10v4H8v-4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zm0-28v4a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V0h2v4h12V0z'
  }));
});
CarouselVertical24.displayName = 'CarouselVertical24';
CarouselVertical24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CarouselVertical24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CarouselVertical20 = React.forwardRef(function (_ref436, ref) {
  var className = _ref436.className,
      children = _ref436.children,
      style = _ref436.style,
      tabIndex = _ref436.tabIndex,
      rest = _objectWithoutProperties$2(_ref436, ["className", "children", "style", "tabIndex"]);

  var _getAttributes436 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes436.tabindex,
      props = _objectWithoutProperties$2(_getAttributes436, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 10v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM8 22h16V10H8zm16 6v4h-2v-4H10v4H8v-4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zm0-28v4a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V0h2v4h12V0z'
  }));
});
CarouselVertical20.displayName = 'CarouselVertical20';
CarouselVertical20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CarouselVertical20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Catalog32 = React.forwardRef(function (_ref437, ref) {
  var className = _ref437.className,
      children = _ref437.children,
      style = _ref437.style,
      tabIndex = _ref437.tabIndex,
      rest = _objectWithoutProperties$2(_ref437, ["className", "children", "style", "tabIndex"]);

  var _getAttributes437 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes437.tabindex,
      props = _objectWithoutProperties$2(_getAttributes437, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 2H8a2 2 0 0 0-2 2v4H4v2h2v5H4v2h2v5H4v2h2v4a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 26H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18z'
  }), React.createElement('path', {
    d: 'M14 8h8v2h-8zm0 7h8v2h-8zm0 7h8v2h-8z'
  }));
});
Catalog32.displayName = 'Catalog32';
Catalog32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Catalog32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Catalog24 = React.forwardRef(function (_ref438, ref) {
  var className = _ref438.className,
      children = _ref438.children,
      style = _ref438.style,
      tabIndex = _ref438.tabIndex,
      rest = _objectWithoutProperties$2(_ref438, ["className", "children", "style", "tabIndex"]);

  var _getAttributes438 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes438.tabindex,
      props = _objectWithoutProperties$2(_getAttributes438, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 2H8a2 2 0 0 0-2 2v4H4v2h2v5H4v2h2v5H4v2h2v4a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 26H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18z'
  }), React.createElement('path', {
    d: 'M14 8h8v2h-8zm0 7h8v2h-8zm0 7h8v2h-8z'
  }));
});
Catalog24.displayName = 'Catalog24';
Catalog24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Catalog24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Catalog20 = React.forwardRef(function (_ref439, ref) {
  var className = _ref439.className,
      children = _ref439.children,
      style = _ref439.style,
      tabIndex = _ref439.tabIndex,
      rest = _objectWithoutProperties$2(_ref439, ["className", "children", "style", "tabIndex"]);

  var _getAttributes439 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes439.tabindex,
      props = _objectWithoutProperties$2(_getAttributes439, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 2H8a2 2 0 0 0-2 2v4H4v2h2v5H4v2h2v5H4v2h2v4a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 26H8v-4h2v-2H8v-5h2v-2H8v-5h2V8H8V4h18z'
  }), React.createElement('path', {
    d: 'M14 8h8v2h-8zm0 7h8v2h-8zm0 7h8v2h-8z'
  }));
});
Catalog20.displayName = 'Catalog20';
Catalog20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Catalog20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Categories32 = React.forwardRef(function (_ref440, ref) {
  var className = _ref440.className,
      children = _ref440.children,
      style = _ref440.style,
      tabIndex = _ref440.tabIndex,
      rest = _objectWithoutProperties$2(_ref440, ["className", "children", "style", "tabIndex"]);

  var _getAttributes440 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes440.tabindex,
      props = _objectWithoutProperties$2(_getAttributes440, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6.76 6l.45.89L7.76 8H12v5H4V6h2.76m.62-2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H9l-.72-1.45a1 1 0 0 0-.9-.55zm15.38 2l.45.89.55 1.11H28v5h-8V6h2.76m.62-2H19a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-4l-.72-1.45a1 1 0 0 0-.9-.55zM6.76 19l.45.89.55 1.11H12v5H4v-7h2.76m.62-2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H9l-.72-1.45a1 1 0 0 0-.9-.55zm15.38 2l.45.89.55 1.11H28v5h-8v-7h2.76m.62-2H19a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-4l-.72-1.45a1 1 0 0 0-.9-.55z'
  }));
});
Categories32.displayName = 'Categories32';
Categories32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Categories32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Categories24 = React.forwardRef(function (_ref441, ref) {
  var className = _ref441.className,
      children = _ref441.children,
      style = _ref441.style,
      tabIndex = _ref441.tabIndex,
      rest = _objectWithoutProperties$2(_ref441, ["className", "children", "style", "tabIndex"]);

  var _getAttributes441 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes441.tabindex,
      props = _objectWithoutProperties$2(_getAttributes441, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6.76 6l.45.89L7.76 8H12v5H4V6h2.76m.62-2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H9l-.72-1.45a1 1 0 0 0-.9-.55zm15.38 2l.45.89.55 1.11H28v5h-8V6h2.76m.62-2H19a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-4l-.72-1.45a1 1 0 0 0-.9-.55zM6.76 19l.45.89.55 1.11H12v5H4v-7h2.76m.62-2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H9l-.72-1.45a1 1 0 0 0-.9-.55zm15.38 2l.45.89.55 1.11H28v5h-8v-7h2.76m.62-2H19a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-4l-.72-1.45a1 1 0 0 0-.9-.55z'
  }));
});
Categories24.displayName = 'Categories24';
Categories24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Categories24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Categories20 = React.forwardRef(function (_ref442, ref) {
  var className = _ref442.className,
      children = _ref442.children,
      style = _ref442.style,
      tabIndex = _ref442.tabIndex,
      rest = _objectWithoutProperties$2(_ref442, ["className", "children", "style", "tabIndex"]);

  var _getAttributes442 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes442.tabindex,
      props = _objectWithoutProperties$2(_getAttributes442, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6.76 6l.45.89L7.76 8H12v5H4V6h2.76m.62-2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H9l-.72-1.45a1 1 0 0 0-.9-.55zm15.38 2l.45.89.55 1.11H28v5h-8V6h2.76m.62-2H19a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-4l-.72-1.45a1 1 0 0 0-.9-.55zM6.76 19l.45.89.55 1.11H12v5H4v-7h2.76m.62-2H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H9l-.72-1.45a1 1 0 0 0-.9-.55zm15.38 2l.45.89.55 1.11H28v5h-8v-7h2.76m.62-2H19a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-4l-.72-1.45a1 1 0 0 0-.9-.55z'
  }));
});
Categories20.displayName = 'Categories20';
Categories20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Categories20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartBar32 = React.forwardRef(function (_ref443, ref) {
  var className = _ref443.className,
      children = _ref443.children,
      style = _ref443.style,
      tabIndex = _ref443.tabIndex,
      rest = _objectWithoutProperties$2(_ref443, ["className", "children", "style", "tabIndex"]);

  var _getAttributes443 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes443.tabindex,
      props = _objectWithoutProperties$2(_getAttributes443, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 28V6h-8v22h-4V14H7v14H4V2H2v26a2 2 0 0 0 2 2h26v-2zm-14 0H9V16h4zm12 0h-4V8h4z'
  }));
});
ChartBar32.displayName = 'ChartBar32';
ChartBar32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartBar32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartBar24 = React.forwardRef(function (_ref444, ref) {
  var className = _ref444.className,
      children = _ref444.children,
      style = _ref444.style,
      tabIndex = _ref444.tabIndex,
      rest = _objectWithoutProperties$2(_ref444, ["className", "children", "style", "tabIndex"]);

  var _getAttributes444 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes444.tabindex,
      props = _objectWithoutProperties$2(_getAttributes444, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 28V6h-8v22h-4V14H7v14H4V2H2v26a2 2 0 0 0 2 2h26v-2zm-14 0H9V16h4zm12 0h-4V8h4z'
  }));
});
ChartBar24.displayName = 'ChartBar24';
ChartBar24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartBar24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartBar20 = React.forwardRef(function (_ref445, ref) {
  var className = _ref445.className,
      children = _ref445.children,
      style = _ref445.style,
      tabIndex = _ref445.tabIndex,
      rest = _objectWithoutProperties$2(_ref445, ["className", "children", "style", "tabIndex"]);

  var _getAttributes445 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes445.tabindex,
      props = _objectWithoutProperties$2(_getAttributes445, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 28V6h-8v22h-4V14H7v14H4V2H2v26a2 2 0 0 0 2 2h26v-2zm-14 0H9V16h4zm12 0h-4V8h4z'
  }));
});
ChartBar20.displayName = 'ChartBar20';
ChartBar20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartBar20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartBubble32 = React.forwardRef(function (_ref446, ref) {
  var className = _ref446.className,
      children = _ref446.children,
      style = _ref446.style,
      tabIndex = _ref446.tabIndex,
      rest = _objectWithoutProperties$2(_ref446, ["className", "children", "style", "tabIndex"]);

  var _getAttributes446 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes446.tabindex,
      props = _objectWithoutProperties$2(_getAttributes446, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30H4a2 2 0 0 1-2-2V2h2v26h26z'
  }), React.createElement('path', {
    d: 'M10 16a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm11-8a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm3.5 17a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5m0-2a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0-3.5-3.5z'
  }));
});
ChartBubble32.displayName = 'ChartBubble32';
ChartBubble32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartBubble32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartBubble24 = React.forwardRef(function (_ref447, ref) {
  var className = _ref447.className,
      children = _ref447.children,
      style = _ref447.style,
      tabIndex = _ref447.tabIndex,
      rest = _objectWithoutProperties$2(_ref447, ["className", "children", "style", "tabIndex"]);

  var _getAttributes447 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes447.tabindex,
      props = _objectWithoutProperties$2(_getAttributes447, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30H4a2 2 0 0 1-2-2V2h2v26h26z'
  }), React.createElement('path', {
    d: 'M10 16a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm11-8a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm3.5 17a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5m0-2a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0-3.5-3.5z'
  }));
});
ChartBubble24.displayName = 'ChartBubble24';
ChartBubble24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartBubble24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartBubble20 = React.forwardRef(function (_ref448, ref) {
  var className = _ref448.className,
      children = _ref448.children,
      style = _ref448.style,
      tabIndex = _ref448.tabIndex,
      rest = _objectWithoutProperties$2(_ref448, ["className", "children", "style", "tabIndex"]);

  var _getAttributes448 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes448.tabindex,
      props = _objectWithoutProperties$2(_getAttributes448, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30H4a2 2 0 0 1-2-2V2h2v26h26z'
  }), React.createElement('path', {
    d: 'M10 16a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm11-8a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm3.5 17a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5m0-2a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0-3.5-3.5z'
  }));
});
ChartBubble20.displayName = 'ChartBubble20';
ChartBubble20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartBubble20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartLineData32 = React.forwardRef(function (_ref449, ref) {
  var className = _ref449.className,
      children = _ref449.children,
      style = _ref449.style,
      tabIndex = _ref449.tabIndex,
      rest = _objectWithoutProperties$2(_ref449, ["className", "children", "style", "tabIndex"]);

  var _getAttributes449 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes449.tabindex,
      props = _objectWithoutProperties$2(_getAttributes449, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10.06 17.88A4.25 4.25 0 0 0 11 18a4 4 0 0 0 2.23-.68l3.22 2.87a3.88 3.88 0 0 0-.2 3.17A4 4 0 1 0 22.62 19l2.54-5.09a3.78 3.78 0 0 0 2.91-.53 4 4 0 1 0-4.69-.38l-2.54 5.09A3.86 3.86 0 0 0 20 18a4 4 0 0 0-2.23.68l-3.22-2.87a3.88 3.88 0 0 0 .2-3.17 4 4 0 1 0-6.45 4.29L4 25V2H2v26a2 2 0 0 0 2 2h26v-2H4.67zM26 8a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm-4 14a2 2 0 1 1-2-2 2 2 0 0 1 2 2zM11 12a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
ChartLineData32.displayName = 'ChartLineData32';
ChartLineData32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartLineData32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartLineData24 = React.forwardRef(function (_ref450, ref) {
  var className = _ref450.className,
      children = _ref450.children,
      style = _ref450.style,
      tabIndex = _ref450.tabIndex,
      rest = _objectWithoutProperties$2(_ref450, ["className", "children", "style", "tabIndex"]);

  var _getAttributes450 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes450.tabindex,
      props = _objectWithoutProperties$2(_getAttributes450, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10.06 17.88A4.25 4.25 0 0 0 11 18a4 4 0 0 0 2.23-.68l3.22 2.87a3.88 3.88 0 0 0-.2 3.17A4 4 0 1 0 22.62 19l2.54-5.09a3.78 3.78 0 0 0 2.91-.53 4 4 0 1 0-4.69-.38l-2.54 5.09A3.86 3.86 0 0 0 20 18a4 4 0 0 0-2.23.68l-3.22-2.87a3.88 3.88 0 0 0 .2-3.17 4 4 0 1 0-6.45 4.29L4 25V2H2v26a2 2 0 0 0 2 2h26v-2H4.67zM26 8a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm-4 14a2 2 0 1 1-2-2 2 2 0 0 1 2 2zM11 12a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
ChartLineData24.displayName = 'ChartLineData24';
ChartLineData24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartLineData24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartLineData20 = React.forwardRef(function (_ref451, ref) {
  var className = _ref451.className,
      children = _ref451.children,
      style = _ref451.style,
      tabIndex = _ref451.tabIndex,
      rest = _objectWithoutProperties$2(_ref451, ["className", "children", "style", "tabIndex"]);

  var _getAttributes451 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes451.tabindex,
      props = _objectWithoutProperties$2(_getAttributes451, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10.06 17.88A4.25 4.25 0 0 0 11 18a4 4 0 0 0 2.23-.68l3.22 2.87a3.88 3.88 0 0 0-.2 3.17A4 4 0 1 0 22.62 19l2.54-5.09a3.78 3.78 0 0 0 2.91-.53 4 4 0 1 0-4.69-.38l-2.54 5.09A3.86 3.86 0 0 0 20 18a4 4 0 0 0-2.23.68l-3.22-2.87a3.88 3.88 0 0 0 .2-3.17 4 4 0 1 0-6.45 4.29L4 25V2H2v26a2 2 0 0 0 2 2h26v-2H4.67zM26 8a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm-4 14a2 2 0 1 1-2-2 2 2 0 0 1 2 2zM11 12a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
ChartLineData20.displayName = 'ChartLineData20';
ChartLineData20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartLineData20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartLine32 = React.forwardRef(function (_ref452, ref) {
  var className = _ref452.className,
      children = _ref452.children,
      style = _ref452.style,
      tabIndex = _ref452.tabIndex,
      rest = _objectWithoutProperties$2(_ref452, ["className", "children", "style", "tabIndex"]);

  var _getAttributes452 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes452.tabindex,
      props = _objectWithoutProperties$2(_getAttributes452, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4.67 28l6.39-12 7.3 6.49a2 2 0 0 0 1.7.47 2 2 0 0 0 1.42-1.07L27 10.9l-1.82-.9-5.49 11-7.3-6.49a2 2 0 0 0-1.68-.51 2 2 0 0 0-1.42 1L4 25V2H2v26a2 2 0 0 0 2 2h26v-2z'
  }));
});
ChartLine32.displayName = 'ChartLine32';
ChartLine32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartLine32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartLine24 = React.forwardRef(function (_ref453, ref) {
  var className = _ref453.className,
      children = _ref453.children,
      style = _ref453.style,
      tabIndex = _ref453.tabIndex,
      rest = _objectWithoutProperties$2(_ref453, ["className", "children", "style", "tabIndex"]);

  var _getAttributes453 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes453.tabindex,
      props = _objectWithoutProperties$2(_getAttributes453, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4.67 28l6.39-12 7.3 6.49a2 2 0 0 0 1.7.47 2 2 0 0 0 1.42-1.07L27 10.9l-1.82-.9-5.49 11-7.3-6.49a2 2 0 0 0-1.68-.51 2 2 0 0 0-1.42 1L4 25V2H2v26a2 2 0 0 0 2 2h26v-2z'
  }));
});
ChartLine24.displayName = 'ChartLine24';
ChartLine24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartLine24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartLine20 = React.forwardRef(function (_ref454, ref) {
  var className = _ref454.className,
      children = _ref454.children,
      style = _ref454.style,
      tabIndex = _ref454.tabIndex,
      rest = _objectWithoutProperties$2(_ref454, ["className", "children", "style", "tabIndex"]);

  var _getAttributes454 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes454.tabindex,
      props = _objectWithoutProperties$2(_getAttributes454, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4.67 28l6.39-12 7.3 6.49a2 2 0 0 0 1.7.47 2 2 0 0 0 1.42-1.07L27 10.9l-1.82-.9-5.49 11-7.3-6.49a2 2 0 0 0-1.68-.51 2 2 0 0 0-1.42 1L4 25V2H2v26a2 2 0 0 0 2 2h26v-2z'
  }));
});
ChartLine20.displayName = 'ChartLine20';
ChartLine20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartLine20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartNetwork32 = React.forwardRef(function (_ref455, ref) {
  var className = _ref455.className,
      children = _ref455.children,
      style = _ref455.style,
      tabIndex = _ref455.tabIndex,
      rest = _objectWithoutProperties$2(_ref455, ["className", "children", "style", "tabIndex"]);

  var _getAttributes455 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes455.tabindex,
      props = _objectWithoutProperties$2(_getAttributes455, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2v4.1a5 5 0 0 0-3.9 3.9H14v-2a2 2 0 0 0-2-2h-2v-4.1a5 5 0 1 0-2 0V18H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2h4.1a5 5 0 1 0 5.9-5.9V14zM6 9a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm6 17H6v-6h6zm14-3a3 3 0 1 1-3-3 3 3 0 0 1 3 3zM20 6h6v6h-6z'
  }));
});
ChartNetwork32.displayName = 'ChartNetwork32';
ChartNetwork32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartNetwork32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartNetwork24 = React.forwardRef(function (_ref456, ref) {
  var className = _ref456.className,
      children = _ref456.children,
      style = _ref456.style,
      tabIndex = _ref456.tabIndex,
      rest = _objectWithoutProperties$2(_ref456, ["className", "children", "style", "tabIndex"]);

  var _getAttributes456 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes456.tabindex,
      props = _objectWithoutProperties$2(_getAttributes456, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2v4.1a5 5 0 0 0-3.9 3.9H14v-2a2 2 0 0 0-2-2h-2v-4.1a5 5 0 1 0-2 0V18H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2h4.1a5 5 0 1 0 5.9-5.9V14zM6 9a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm6 17H6v-6h6zm14-3a3 3 0 1 1-3-3 3 3 0 0 1 3 3zM20 6h6v6h-6z'
  }));
});
ChartNetwork24.displayName = 'ChartNetwork24';
ChartNetwork24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartNetwork24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartNetwork20 = React.forwardRef(function (_ref457, ref) {
  var className = _ref457.className,
      children = _ref457.children,
      style = _ref457.style,
      tabIndex = _ref457.tabIndex,
      rest = _objectWithoutProperties$2(_ref457, ["className", "children", "style", "tabIndex"]);

  var _getAttributes457 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes457.tabindex,
      props = _objectWithoutProperties$2(_getAttributes457, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2v4.1a5 5 0 0 0-3.9 3.9H14v-2a2 2 0 0 0-2-2h-2v-4.1a5 5 0 1 0-2 0V18H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2h4.1a5 5 0 1 0 5.9-5.9V14zM6 9a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm6 17H6v-6h6zm14-3a3 3 0 1 1-3-3 3 3 0 0 1 3 3zM20 6h6v6h-6z'
  }));
});
ChartNetwork20.displayName = 'ChartNetwork20';
ChartNetwork20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartNetwork20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartPie32 = React.forwardRef(function (_ref458, ref) {
  var className = _ref458.className,
      children = _ref458.children,
      style = _ref458.style,
      tabIndex = _ref458.tabIndex,
      rest = _objectWithoutProperties$2(_ref458, ["className", "children", "style", "tabIndex"]);

  var _getAttributes458 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes458.tabindex,
      props = _objectWithoutProperties$2(_getAttributes458, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4a12 12 0 1 0 12 12A12 12 0 0 0 16 4zm10 11h-9V6.05A10 10 0 0 1 26 15zM15.42 26A10 10 0 0 1 15 6.05v9a2 2 0 0 0 2 2h9A10 10 0 0 1 15.42 26z'
  }));
});
ChartPie32.displayName = 'ChartPie32';
ChartPie32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartPie32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartPie24 = React.forwardRef(function (_ref459, ref) {
  var className = _ref459.className,
      children = _ref459.children,
      style = _ref459.style,
      tabIndex = _ref459.tabIndex,
      rest = _objectWithoutProperties$2(_ref459, ["className", "children", "style", "tabIndex"]);

  var _getAttributes459 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes459.tabindex,
      props = _objectWithoutProperties$2(_getAttributes459, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4a12 12 0 1 0 12 12A12 12 0 0 0 16 4zm10 11h-9V6.05A10 10 0 0 1 26 15zM15.42 26A10 10 0 0 1 15 6.05v9a2 2 0 0 0 2 2h9A10 10 0 0 1 15.42 26z'
  }));
});
ChartPie24.displayName = 'ChartPie24';
ChartPie24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartPie24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartPie20 = React.forwardRef(function (_ref460, ref) {
  var className = _ref460.className,
      children = _ref460.children,
      style = _ref460.style,
      tabIndex = _ref460.tabIndex,
      rest = _objectWithoutProperties$2(_ref460, ["className", "children", "style", "tabIndex"]);

  var _getAttributes460 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes460.tabindex,
      props = _objectWithoutProperties$2(_getAttributes460, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4a12 12 0 1 0 12 12A12 12 0 0 0 16 4zm10 11h-9V6.05A10 10 0 0 1 26 15zM15.42 26A10 10 0 0 1 15 6.05v9a2 2 0 0 0 2 2h9A10 10 0 0 1 15.42 26z'
  }));
});
ChartPie20.displayName = 'ChartPie20';
ChartPie20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartPie20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartScatter32 = React.forwardRef(function (_ref461, ref) {
  var className = _ref461.className,
      children = _ref461.children,
      style = _ref461.style,
      tabIndex = _ref461.tabIndex,
      rest = _objectWithoutProperties$2(_ref461, ["className", "children", "style", "tabIndex"]);

  var _getAttributes461 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes461.tabindex,
      props = _objectWithoutProperties$2(_getAttributes461, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30H4a2 2 0 0 1-2-2V2h2v26h26z'
  }), React.createElement('circle', {
    cx: '10',
    cy: '22',
    r: '2'
  }), React.createElement('circle', {
    cx: '14',
    cy: '15',
    r: '2'
  }), React.createElement('circle', {
    cx: '22',
    cy: '15',
    r: '2'
  }), React.createElement('circle', {
    cx: '26',
    cy: '6',
    r: '2'
  }), React.createElement('circle', {
    cx: '14',
    cy: '8',
    r: '2'
  }));
});
ChartScatter32.displayName = 'ChartScatter32';
ChartScatter32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartScatter32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartScatter24 = React.forwardRef(function (_ref462, ref) {
  var className = _ref462.className,
      children = _ref462.children,
      style = _ref462.style,
      tabIndex = _ref462.tabIndex,
      rest = _objectWithoutProperties$2(_ref462, ["className", "children", "style", "tabIndex"]);

  var _getAttributes462 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes462.tabindex,
      props = _objectWithoutProperties$2(_getAttributes462, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30H4a2 2 0 0 1-2-2V2h2v26h26z'
  }), React.createElement('circle', {
    cx: '10',
    cy: '22',
    r: '2'
  }), React.createElement('circle', {
    cx: '14',
    cy: '15',
    r: '2'
  }), React.createElement('circle', {
    cx: '22',
    cy: '15',
    r: '2'
  }), React.createElement('circle', {
    cx: '26',
    cy: '6',
    r: '2'
  }), React.createElement('circle', {
    cx: '14',
    cy: '8',
    r: '2'
  }));
});
ChartScatter24.displayName = 'ChartScatter24';
ChartScatter24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartScatter24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartScatter20 = React.forwardRef(function (_ref463, ref) {
  var className = _ref463.className,
      children = _ref463.children,
      style = _ref463.style,
      tabIndex = _ref463.tabIndex,
      rest = _objectWithoutProperties$2(_ref463, ["className", "children", "style", "tabIndex"]);

  var _getAttributes463 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes463.tabindex,
      props = _objectWithoutProperties$2(_getAttributes463, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30H4a2 2 0 0 1-2-2V2h2v26h26z'
  }), React.createElement('circle', {
    cx: '10',
    cy: '22',
    r: '2'
  }), React.createElement('circle', {
    cx: '14',
    cy: '15',
    r: '2'
  }), React.createElement('circle', {
    cx: '22',
    cy: '15',
    r: '2'
  }), React.createElement('circle', {
    cx: '26',
    cy: '6',
    r: '2'
  }), React.createElement('circle', {
    cx: '14',
    cy: '8',
    r: '2'
  }));
});
ChartScatter20.displayName = 'ChartScatter20';
ChartScatter20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartScatter20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartVennDiagram32 = React.forwardRef(function (_ref464, ref) {
  var className = _ref464.className,
      children = _ref464.children,
      style = _ref464.style,
      tabIndex = _ref464.tabIndex,
      rest = _objectWithoutProperties$2(_ref464, ["className", "children", "style", "tabIndex"]);

  var _getAttributes464 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes464.tabindex,
      props = _objectWithoutProperties$2(_getAttributes464, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 6a9.92 9.92 0 0 0-4 .84A9.92 9.92 0 0 0 12 6a10 10 0 0 0 0 20 9.92 9.92 0 0 0 4-.84 9.92 9.92 0 0 0 4 .84 10 10 0 0 0 0-20zm-8 18a8 8 0 0 1 0-16 7.91 7.91 0 0 1 1.76.2 10 10 0 0 0 0 15.6A7.91 7.91 0 0 1 12 24zm8-8a8 8 0 0 1-4 6.92 8 8 0 0 1 0-13.84A8 8 0 0 1 20 16zm0 8a7.91 7.91 0 0 1-1.76-.2 10 10 0 0 0 0-15.6A7.91 7.91 0 0 1 20 8a8 8 0 0 1 0 16z'
  }));
});
ChartVennDiagram32.displayName = 'ChartVennDiagram32';
ChartVennDiagram32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartVennDiagram32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartVennDiagram24 = React.forwardRef(function (_ref465, ref) {
  var className = _ref465.className,
      children = _ref465.children,
      style = _ref465.style,
      tabIndex = _ref465.tabIndex,
      rest = _objectWithoutProperties$2(_ref465, ["className", "children", "style", "tabIndex"]);

  var _getAttributes465 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes465.tabindex,
      props = _objectWithoutProperties$2(_getAttributes465, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 6a9.92 9.92 0 0 0-4 .84A9.92 9.92 0 0 0 12 6a10 10 0 0 0 0 20 9.92 9.92 0 0 0 4-.84 9.92 9.92 0 0 0 4 .84 10 10 0 0 0 0-20zm-8 18a8 8 0 0 1 0-16 7.91 7.91 0 0 1 1.76.2 10 10 0 0 0 0 15.6A7.91 7.91 0 0 1 12 24zm8-8a8 8 0 0 1-4 6.92 8 8 0 0 1 0-13.84A8 8 0 0 1 20 16zm0 8a7.91 7.91 0 0 1-1.76-.2 10 10 0 0 0 0-15.6A7.91 7.91 0 0 1 20 8a8 8 0 0 1 0 16z'
  }));
});
ChartVennDiagram24.displayName = 'ChartVennDiagram24';
ChartVennDiagram24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartVennDiagram24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChartVennDiagram20 = React.forwardRef(function (_ref466, ref) {
  var className = _ref466.className,
      children = _ref466.children,
      style = _ref466.style,
      tabIndex = _ref466.tabIndex,
      rest = _objectWithoutProperties$2(_ref466, ["className", "children", "style", "tabIndex"]);

  var _getAttributes466 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes466.tabindex,
      props = _objectWithoutProperties$2(_getAttributes466, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 6a9.92 9.92 0 0 0-4 .84A9.92 9.92 0 0 0 12 6a10 10 0 0 0 0 20 9.92 9.92 0 0 0 4-.84 9.92 9.92 0 0 0 4 .84 10 10 0 0 0 0-20zm-8 18a8 8 0 0 1 0-16 7.91 7.91 0 0 1 1.76.2 10 10 0 0 0 0 15.6A7.91 7.91 0 0 1 12 24zm8-8a8 8 0 0 1-4 6.92 8 8 0 0 1 0-13.84A8 8 0 0 1 20 16zm0 8a7.91 7.91 0 0 1-1.76-.2 10 10 0 0 0 0-15.6A7.91 7.91 0 0 1 20 8a8 8 0 0 1 0 16z'
  }));
});
ChartVennDiagram20.displayName = 'ChartVennDiagram20';
ChartVennDiagram20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChartVennDiagram20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chat32 = React.forwardRef(function (_ref467, ref) {
  var className = _ref467.className,
      children = _ref467.children,
      style = _ref467.style,
      tabIndex = _ref467.tabIndex,
      rest = _objectWithoutProperties$2(_ref467, ["className", "children", "style", "tabIndex"]);

  var _getAttributes467 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes467.tabindex,
      props = _objectWithoutProperties$2(_getAttributes467, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.74 30L16 29l4-7h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.84z'
  }), React.createElement('path', {
    d: 'M8 10h16v2H8zm0 6h10v2H8z'
  }));
});
Chat32.displayName = 'Chat32';
Chat32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chat32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chat24 = React.forwardRef(function (_ref468, ref) {
  var className = _ref468.className,
      children = _ref468.children,
      style = _ref468.style,
      tabIndex = _ref468.tabIndex,
      rest = _objectWithoutProperties$2(_ref468, ["className", "children", "style", "tabIndex"]);

  var _getAttributes468 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes468.tabindex,
      props = _objectWithoutProperties$2(_getAttributes468, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.74 30L16 29l4-7h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.84z'
  }), React.createElement('path', {
    d: 'M8 10h16v2H8zm0 6h10v2H8z'
  }));
});
Chat24.displayName = 'Chat24';
Chat24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chat24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chat20 = React.forwardRef(function (_ref469, ref) {
  var className = _ref469.className,
      children = _ref469.children,
      style = _ref469.style,
      tabIndex = _ref469.tabIndex,
      rest = _objectWithoutProperties$2(_ref469, ["className", "children", "style", "tabIndex"]);

  var _getAttributes469 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes469.tabindex,
      props = _objectWithoutProperties$2(_getAttributes469, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.74 30L16 29l4-7h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.84z'
  }), React.createElement('path', {
    d: 'M8 10h16v2H8zm0 6h10v2H8z'
  }));
});
Chat20.displayName = 'Chat20';
Chat20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chat20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxCheckedFilled32 = React.forwardRef(function (_ref470, ref) {
  var className = _ref470.className,
      children = _ref470.children,
      style = _ref470.style,
      tabIndex = _ref470.tabIndex,
      rest = _objectWithoutProperties$2(_ref470, ["className", "children", "style", "tabIndex"]);

  var _getAttributes470 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes470.tabindex,
      props = _objectWithoutProperties$2(_getAttributes470, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM14 21.5l-5-5 1.59-1.5L14 18.35 21.41 11 23 12.58z'
  }));
});
CheckboxCheckedFilled32.displayName = 'CheckboxCheckedFilled32';
CheckboxCheckedFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxCheckedFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxCheckedFilled24 = React.forwardRef(function (_ref471, ref) {
  var className = _ref471.className,
      children = _ref471.children,
      style = _ref471.style,
      tabIndex = _ref471.tabIndex,
      rest = _objectWithoutProperties$2(_ref471, ["className", "children", "style", "tabIndex"]);

  var _getAttributes471 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes471.tabindex,
      props = _objectWithoutProperties$2(_getAttributes471, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM14 21.5l-5-5 1.59-1.5L14 18.35 21.41 11 23 12.58z'
  }));
});
CheckboxCheckedFilled24.displayName = 'CheckboxCheckedFilled24';
CheckboxCheckedFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxCheckedFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxCheckedFilled20 = React.forwardRef(function (_ref472, ref) {
  var className = _ref472.className,
      children = _ref472.children,
      style = _ref472.style,
      tabIndex = _ref472.tabIndex,
      rest = _objectWithoutProperties$2(_ref472, ["className", "children", "style", "tabIndex"]);

  var _getAttributes472 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes472.tabindex,
      props = _objectWithoutProperties$2(_getAttributes472, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM14 21.5l-5-5 1.59-1.5L14 18.35 21.41 11 23 12.58z'
  }));
});
CheckboxCheckedFilled20.displayName = 'CheckboxCheckedFilled20';
CheckboxCheckedFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxCheckedFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxChecked32 = React.forwardRef(function (_ref473, ref) {
  var className = _ref473.className,
      children = _ref473.children,
      style = _ref473.style,
      tabIndex = _ref473.tabIndex,
      rest = _objectWithoutProperties$2(_ref473, ["className", "children", "style", "tabIndex"]);

  var _getAttributes473 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes473.tabindex,
      props = _objectWithoutProperties$2(_getAttributes473, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }), React.createElement('path', {
    d: 'M14 21.5l-5-4.96L10.59 15 14 18.35 21.41 11 23 12.58l-9 8.92z'
  }));
});
CheckboxChecked32.displayName = 'CheckboxChecked32';
CheckboxChecked32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxChecked32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxChecked24 = React.forwardRef(function (_ref474, ref) {
  var className = _ref474.className,
      children = _ref474.children,
      style = _ref474.style,
      tabIndex = _ref474.tabIndex,
      rest = _objectWithoutProperties$2(_ref474, ["className", "children", "style", "tabIndex"]);

  var _getAttributes474 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes474.tabindex,
      props = _objectWithoutProperties$2(_getAttributes474, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }), React.createElement('path', {
    d: 'M14 21.5l-5-4.96L10.59 15 14 18.35 21.41 11 23 12.58l-9 8.92z'
  }));
});
CheckboxChecked24.displayName = 'CheckboxChecked24';
CheckboxChecked24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxChecked24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxChecked20 = React.forwardRef(function (_ref475, ref) {
  var className = _ref475.className,
      children = _ref475.children,
      style = _ref475.style,
      tabIndex = _ref475.tabIndex,
      rest = _objectWithoutProperties$2(_ref475, ["className", "children", "style", "tabIndex"]);

  var _getAttributes475 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes475.tabindex,
      props = _objectWithoutProperties$2(_getAttributes475, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }), React.createElement('path', {
    d: 'M14 21.5l-5-4.96L10.59 15 14 18.35 21.41 11 23 12.58l-9 8.92z'
  }));
});
CheckboxChecked20.displayName = 'CheckboxChecked20';
CheckboxChecked20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxChecked20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxUndeterminateFilled32 = React.forwardRef(function (_ref476, ref) {
  var className = _ref476.className,
      children = _ref476.children,
      style = _ref476.style,
      tabIndex = _ref476.tabIndex,
      rest = _objectWithoutProperties$2(_ref476, ["className", "children", "style", "tabIndex"]);

  var _getAttributes476 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes476.tabindex,
      props = _objectWithoutProperties$2(_getAttributes476, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-4 14H10v-4h12z'
  }));
});
CheckboxUndeterminateFilled32.displayName = 'CheckboxUndeterminateFilled32';
CheckboxUndeterminateFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxUndeterminateFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxUndeterminateFilled24 = React.forwardRef(function (_ref477, ref) {
  var className = _ref477.className,
      children = _ref477.children,
      style = _ref477.style,
      tabIndex = _ref477.tabIndex,
      rest = _objectWithoutProperties$2(_ref477, ["className", "children", "style", "tabIndex"]);

  var _getAttributes477 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes477.tabindex,
      props = _objectWithoutProperties$2(_getAttributes477, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-4 14H10v-4h12z'
  }));
});
CheckboxUndeterminateFilled24.displayName = 'CheckboxUndeterminateFilled24';
CheckboxUndeterminateFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxUndeterminateFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxUndeterminateFilled20 = React.forwardRef(function (_ref478, ref) {
  var className = _ref478.className,
      children = _ref478.children,
      style = _ref478.style,
      tabIndex = _ref478.tabIndex,
      rest = _objectWithoutProperties$2(_ref478, ["className", "children", "style", "tabIndex"]);

  var _getAttributes478 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes478.tabindex,
      props = _objectWithoutProperties$2(_getAttributes478, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-4 14H10v-4h12z'
  }));
});
CheckboxUndeterminateFilled20.displayName = 'CheckboxUndeterminateFilled20';
CheckboxUndeterminateFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxUndeterminateFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxUndeterminate32 = React.forwardRef(function (_ref479, ref) {
  var className = _ref479.className,
      children = _ref479.children,
      style = _ref479.style,
      tabIndex = _ref479.tabIndex,
      rest = _objectWithoutProperties$2(_ref479, ["className", "children", "style", "tabIndex"]);

  var _getAttributes479 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes479.tabindex,
      props = _objectWithoutProperties$2(_getAttributes479, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 14h12v4H10z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }));
});
CheckboxUndeterminate32.displayName = 'CheckboxUndeterminate32';
CheckboxUndeterminate32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxUndeterminate32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxUndeterminate24 = React.forwardRef(function (_ref480, ref) {
  var className = _ref480.className,
      children = _ref480.children,
      style = _ref480.style,
      tabIndex = _ref480.tabIndex,
      rest = _objectWithoutProperties$2(_ref480, ["className", "children", "style", "tabIndex"]);

  var _getAttributes480 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes480.tabindex,
      props = _objectWithoutProperties$2(_getAttributes480, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 14h12v4H10z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }));
});
CheckboxUndeterminate24.displayName = 'CheckboxUndeterminate24';
CheckboxUndeterminate24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxUndeterminate24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckboxUndeterminate20 = React.forwardRef(function (_ref481, ref) {
  var className = _ref481.className,
      children = _ref481.children,
      style = _ref481.style,
      tabIndex = _ref481.tabIndex,
      rest = _objectWithoutProperties$2(_ref481, ["className", "children", "style", "tabIndex"]);

  var _getAttributes481 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes481.tabindex,
      props = _objectWithoutProperties$2(_getAttributes481, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 14h12v4H10z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }));
});
CheckboxUndeterminate20.displayName = 'CheckboxUndeterminate20';
CheckboxUndeterminate20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckboxUndeterminate20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Checkbox32 = React.forwardRef(function (_ref482, ref) {
  var className = _ref482.className,
      children = _ref482.children,
      style = _ref482.style,
      tabIndex = _ref482.tabIndex,
      rest = _objectWithoutProperties$2(_ref482, ["className", "children", "style", "tabIndex"]);

  var _getAttributes482 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes482.tabindex,
      props = _objectWithoutProperties$2(_getAttributes482, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }));
});
Checkbox32.displayName = 'Checkbox32';
Checkbox32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Checkbox32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Checkbox24 = React.forwardRef(function (_ref483, ref) {
  var className = _ref483.className,
      children = _ref483.children,
      style = _ref483.style,
      tabIndex = _ref483.tabIndex,
      rest = _objectWithoutProperties$2(_ref483, ["className", "children", "style", "tabIndex"]);

  var _getAttributes483 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes483.tabindex,
      props = _objectWithoutProperties$2(_getAttributes483, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }));
});
Checkbox24.displayName = 'Checkbox24';
Checkbox24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Checkbox24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Checkbox20 = React.forwardRef(function (_ref484, ref) {
  var className = _ref484.className,
      children = _ref484.children,
      style = _ref484.style,
      tabIndex = _ref484.tabIndex,
      rest = _objectWithoutProperties$2(_ref484, ["className", "children", "style", "tabIndex"]);

  var _getAttributes484 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes484.tabindex,
      props = _objectWithoutProperties$2(_getAttributes484, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 26V6h20v20z'
  }));
});
Checkbox20.displayName = 'Checkbox20';
Checkbox20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Checkbox20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckmarkFilled32 = React.forwardRef(function (_ref485, ref) {
  var className = _ref485.className,
      children = _ref485.children,
      style = _ref485.style,
      tabIndex = _ref485.tabIndex,
      rest = _objectWithoutProperties$2(_ref485, ["className", "children", "style", "tabIndex"]);

  var _getAttributes485 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes485.tabindex,
      props = _objectWithoutProperties$2(_getAttributes485, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-2 19.5l-5-5 1.59-1.5L14 18.35 21.41 11 23 12.58z'
  }));
});
CheckmarkFilled32.displayName = 'CheckmarkFilled32';
CheckmarkFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckmarkFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckmarkFilled24 = React.forwardRef(function (_ref486, ref) {
  var className = _ref486.className,
      children = _ref486.children,
      style = _ref486.style,
      tabIndex = _ref486.tabIndex,
      rest = _objectWithoutProperties$2(_ref486, ["className", "children", "style", "tabIndex"]);

  var _getAttributes486 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes486.tabindex,
      props = _objectWithoutProperties$2(_getAttributes486, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-2 19.5l-5-5 1.59-1.5L14 18.35 21.41 11 23 12.58z'
  }));
});
CheckmarkFilled24.displayName = 'CheckmarkFilled24';
CheckmarkFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckmarkFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CheckmarkFilled20 = React.forwardRef(function (_ref487, ref) {
  var className = _ref487.className,
      children = _ref487.children,
      style = _ref487.style,
      tabIndex = _ref487.tabIndex,
      rest = _objectWithoutProperties$2(_ref487, ["className", "children", "style", "tabIndex"]);

  var _getAttributes487 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes487.tabindex,
      props = _objectWithoutProperties$2(_getAttributes487, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-2 19.5l-5-5 1.59-1.5L14 18.35 21.41 11 23 12.58z'
  }));
});
CheckmarkFilled20.displayName = 'CheckmarkFilled20';
CheckmarkFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CheckmarkFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Checkmark32 = React.forwardRef(function (_ref488, ref) {
  var className = _ref488.className,
      children = _ref488.children,
      style = _ref488.style,
      tabIndex = _ref488.tabIndex,
      rest = _objectWithoutProperties$2(_ref488, ["className", "children", "style", "tabIndex"]);

  var _getAttributes488 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes488.tabindex,
      props = _objectWithoutProperties$2(_getAttributes488, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M14 21.5l-5-4.96 1.59-1.57L14 18.35 21.41 11 23 12.58l-9 8.92z'
  }));
});
Checkmark32.displayName = 'Checkmark32';
Checkmark32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Checkmark32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Checkmark24 = React.forwardRef(function (_ref489, ref) {
  var className = _ref489.className,
      children = _ref489.children,
      style = _ref489.style,
      tabIndex = _ref489.tabIndex,
      rest = _objectWithoutProperties$2(_ref489, ["className", "children", "style", "tabIndex"]);

  var _getAttributes489 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes489.tabindex,
      props = _objectWithoutProperties$2(_getAttributes489, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M14 21.5l-5-4.96 1.59-1.57L14 18.35 21.41 11 23 12.58l-9 8.92z'
  }));
});
Checkmark24.displayName = 'Checkmark24';
Checkmark24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Checkmark24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Checkmark20 = React.forwardRef(function (_ref490, ref) {
  var className = _ref490.className,
      children = _ref490.children,
      style = _ref490.style,
      tabIndex = _ref490.tabIndex,
      rest = _objectWithoutProperties$2(_ref490, ["className", "children", "style", "tabIndex"]);

  var _getAttributes490 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes490.tabindex,
      props = _objectWithoutProperties$2(_getAttributes490, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M14 21.5l-5-4.96 1.59-1.57L14 18.35 21.41 11 23 12.58l-9 8.92z'
  }));
});
Checkmark20.displayName = 'Checkmark20';
Checkmark20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Checkmark20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chemistry32 = React.forwardRef(function (_ref491, ref) {
  var className = _ref491.className,
      children = _ref491.children,
      style = _ref491.style,
      tabIndex = _ref491.tabIndex,
      rest = _objectWithoutProperties$2(_ref491, ["className", "children", "style", "tabIndex"]);

  var _getAttributes491 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes491.tabindex,
      props = _objectWithoutProperties$2(_getAttributes491, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.23 23.62L20 13.67V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v9.67l-7.23 10A4 4 0 0 0 8 30h16a4 4 0 0 0 3.25-6.38zM14 14.33V4h4v10.33L20.67 18h-9.34zM24 28H8a2 2 0 0 1-2-2 2.06 2.06 0 0 1 .39-1.19L9.87 20h12.26l3.48 4.79A2.06 2.06 0 0 1 26 26a2 2 0 0 1-2 2z'
  }));
});
Chemistry32.displayName = 'Chemistry32';
Chemistry32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chemistry32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chemistry24 = React.forwardRef(function (_ref492, ref) {
  var className = _ref492.className,
      children = _ref492.children,
      style = _ref492.style,
      tabIndex = _ref492.tabIndex,
      rest = _objectWithoutProperties$2(_ref492, ["className", "children", "style", "tabIndex"]);

  var _getAttributes492 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes492.tabindex,
      props = _objectWithoutProperties$2(_getAttributes492, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.23 23.62L20 13.67V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v9.67l-7.23 10A4 4 0 0 0 8 30h16a4 4 0 0 0 3.25-6.38zM14 14.33V4h4v10.33L20.67 18h-9.34zM24 28H8a2 2 0 0 1-2-2 2.06 2.06 0 0 1 .39-1.19L9.87 20h12.26l3.48 4.79A2.06 2.06 0 0 1 26 26a2 2 0 0 1-2 2z'
  }));
});
Chemistry24.displayName = 'Chemistry24';
Chemistry24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chemistry24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chemistry20 = React.forwardRef(function (_ref493, ref) {
  var className = _ref493.className,
      children = _ref493.children,
      style = _ref493.style,
      tabIndex = _ref493.tabIndex,
      rest = _objectWithoutProperties$2(_ref493, ["className", "children", "style", "tabIndex"]);

  var _getAttributes493 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes493.tabindex,
      props = _objectWithoutProperties$2(_getAttributes493, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.23 23.62L20 13.67V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v9.67l-7.23 10A4 4 0 0 0 8 30h16a4 4 0 0 0 3.25-6.38zM14 14.33V4h4v10.33L20.67 18h-9.34zM24 28H8a2 2 0 0 1-2-2 2.06 2.06 0 0 1 .39-1.19L9.87 20h12.26l3.48 4.79A2.06 2.06 0 0 1 26 26a2 2 0 0 1-2 2z'
  }));
});
Chemistry20.displayName = 'Chemistry20';
Chemistry20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chemistry20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronDown32 = React.forwardRef(function (_ref494, ref) {
  var className = _ref494.className,
      children = _ref494.children,
      style = _ref494.style,
      tabIndex = _ref494.tabIndex,
      rest = _objectWithoutProperties$2(_ref494, ["className", "children", "style", "tabIndex"]);

  var _getAttributes494 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes494.tabindex,
      props = _objectWithoutProperties$2(_getAttributes494, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22L6 12l1.4-1.4 8.6 8.6 8.6-8.6L26 12z'
  }));
});
ChevronDown32.displayName = 'ChevronDown32';
ChevronDown32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronDown32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronDown24 = React.forwardRef(function (_ref495, ref) {
  var className = _ref495.className,
      children = _ref495.children,
      style = _ref495.style,
      tabIndex = _ref495.tabIndex,
      rest = _objectWithoutProperties$2(_ref495, ["className", "children", "style", "tabIndex"]);

  var _getAttributes495 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes495.tabindex,
      props = _objectWithoutProperties$2(_getAttributes495, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22L6 12l1.4-1.4 8.6 8.6 8.6-8.6L26 12z'
  }));
});
ChevronDown24.displayName = 'ChevronDown24';
ChevronDown24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronDown24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronDown20 = React.forwardRef(function (_ref496, ref) {
  var className = _ref496.className,
      children = _ref496.children,
      style = _ref496.style,
      tabIndex = _ref496.tabIndex,
      rest = _objectWithoutProperties$2(_ref496, ["className", "children", "style", "tabIndex"]);

  var _getAttributes496 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes496.tabindex,
      props = _objectWithoutProperties$2(_getAttributes496, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22L6 12l1.4-1.4 8.6 8.6 8.6-8.6L26 12z'
  }));
});
ChevronDown20.displayName = 'ChevronDown20';
ChevronDown20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronDown20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronLeft32 = React.forwardRef(function (_ref497, ref) {
  var className = _ref497.className,
      children = _ref497.children,
      style = _ref497.style,
      tabIndex = _ref497.tabIndex,
      rest = _objectWithoutProperties$2(_ref497, ["className", "children", "style", "tabIndex"]);

  var _getAttributes497 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes497.tabindex,
      props = _objectWithoutProperties$2(_getAttributes497, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 16L20 6l1.4 1.4-8.6 8.6 8.6 8.6L20 26z'
  }));
});
ChevronLeft32.displayName = 'ChevronLeft32';
ChevronLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronLeft24 = React.forwardRef(function (_ref498, ref) {
  var className = _ref498.className,
      children = _ref498.children,
      style = _ref498.style,
      tabIndex = _ref498.tabIndex,
      rest = _objectWithoutProperties$2(_ref498, ["className", "children", "style", "tabIndex"]);

  var _getAttributes498 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes498.tabindex,
      props = _objectWithoutProperties$2(_getAttributes498, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 16L20 6l1.4 1.4-8.6 8.6 8.6 8.6L20 26z'
  }));
});
ChevronLeft24.displayName = 'ChevronLeft24';
ChevronLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronLeft20 = React.forwardRef(function (_ref499, ref) {
  var className = _ref499.className,
      children = _ref499.children,
      style = _ref499.style,
      tabIndex = _ref499.tabIndex,
      rest = _objectWithoutProperties$2(_ref499, ["className", "children", "style", "tabIndex"]);

  var _getAttributes499 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes499.tabindex,
      props = _objectWithoutProperties$2(_getAttributes499, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 16L20 6l1.4 1.4-8.6 8.6 8.6 8.6L20 26z'
  }));
});
ChevronLeft20.displayName = 'ChevronLeft20';
ChevronLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronRight32 = React.forwardRef(function (_ref500, ref) {
  var className = _ref500.className,
      children = _ref500.children,
      style = _ref500.style,
      tabIndex = _ref500.tabIndex,
      rest = _objectWithoutProperties$2(_ref500, ["className", "children", "style", "tabIndex"]);

  var _getAttributes500 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes500.tabindex,
      props = _objectWithoutProperties$2(_getAttributes500, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 16L12 26l-1.4-1.4 8.6-8.6-8.6-8.6L12 6z'
  }));
});
ChevronRight32.displayName = 'ChevronRight32';
ChevronRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronRight24 = React.forwardRef(function (_ref501, ref) {
  var className = _ref501.className,
      children = _ref501.children,
      style = _ref501.style,
      tabIndex = _ref501.tabIndex,
      rest = _objectWithoutProperties$2(_ref501, ["className", "children", "style", "tabIndex"]);

  var _getAttributes501 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes501.tabindex,
      props = _objectWithoutProperties$2(_getAttributes501, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 16L12 26l-1.4-1.4 8.6-8.6-8.6-8.6L12 6z'
  }));
});
ChevronRight24.displayName = 'ChevronRight24';
ChevronRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronRight20 = React.forwardRef(function (_ref502, ref) {
  var className = _ref502.className,
      children = _ref502.children,
      style = _ref502.style,
      tabIndex = _ref502.tabIndex,
      rest = _objectWithoutProperties$2(_ref502, ["className", "children", "style", "tabIndex"]);

  var _getAttributes502 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes502.tabindex,
      props = _objectWithoutProperties$2(_getAttributes502, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 16L12 26l-1.4-1.4 8.6-8.6-8.6-8.6L12 6z'
  }));
});
ChevronRight20.displayName = 'ChevronRight20';
ChevronRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronSort32 = React.forwardRef(function (_ref503, ref) {
  var className = _ref503.className,
      children = _ref503.children,
      style = _ref503.style,
      tabIndex = _ref503.tabIndex,
      rest = _objectWithoutProperties$2(_ref503, ["className", "children", "style", "tabIndex"]);

  var _getAttributes503 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes503.tabindex,
      props = _objectWithoutProperties$2(_getAttributes503, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28l-7-7 1.41-1.41L16 25.17l5.59-5.58L23 21l-7 7zm0-24l7 7-1.41 1.41L16 6.83l-5.59 5.58L9 11l7-7z'
  }));
});
ChevronSort32.displayName = 'ChevronSort32';
ChevronSort32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronSort32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronSort24 = React.forwardRef(function (_ref504, ref) {
  var className = _ref504.className,
      children = _ref504.children,
      style = _ref504.style,
      tabIndex = _ref504.tabIndex,
      rest = _objectWithoutProperties$2(_ref504, ["className", "children", "style", "tabIndex"]);

  var _getAttributes504 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes504.tabindex,
      props = _objectWithoutProperties$2(_getAttributes504, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28l-7-7 1.41-1.41L16 25.17l5.59-5.58L23 21l-7 7zm0-24l7 7-1.41 1.41L16 6.83l-5.59 5.58L9 11l7-7z'
  }));
});
ChevronSort24.displayName = 'ChevronSort24';
ChevronSort24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronSort24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronSort20 = React.forwardRef(function (_ref505, ref) {
  var className = _ref505.className,
      children = _ref505.children,
      style = _ref505.style,
      tabIndex = _ref505.tabIndex,
      rest = _objectWithoutProperties$2(_ref505, ["className", "children", "style", "tabIndex"]);

  var _getAttributes505 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes505.tabindex,
      props = _objectWithoutProperties$2(_getAttributes505, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28l-7-7 1.41-1.41L16 25.17l5.59-5.58L23 21l-7 7zm0-24l7 7-1.41 1.41L16 6.83l-5.59 5.58L9 11l7-7z'
  }));
});
ChevronSort20.displayName = 'ChevronSort20';
ChevronSort20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronSort20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronUp32 = React.forwardRef(function (_ref506, ref) {
  var className = _ref506.className,
      children = _ref506.children,
      style = _ref506.style,
      tabIndex = _ref506.tabIndex,
      rest = _objectWithoutProperties$2(_ref506, ["className", "children", "style", "tabIndex"]);

  var _getAttributes506 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes506.tabindex,
      props = _objectWithoutProperties$2(_getAttributes506, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10l10 10-1.4 1.4-8.6-8.6-8.6 8.6L6 20z'
  }));
});
ChevronUp32.displayName = 'ChevronUp32';
ChevronUp32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronUp32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronUp24 = React.forwardRef(function (_ref507, ref) {
  var className = _ref507.className,
      children = _ref507.children,
      style = _ref507.style,
      tabIndex = _ref507.tabIndex,
      rest = _objectWithoutProperties$2(_ref507, ["className", "children", "style", "tabIndex"]);

  var _getAttributes507 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes507.tabindex,
      props = _objectWithoutProperties$2(_getAttributes507, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10l10 10-1.4 1.4-8.6-8.6-8.6 8.6L6 20z'
  }));
});
ChevronUp24.displayName = 'ChevronUp24';
ChevronUp24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronUp24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronUp20 = React.forwardRef(function (_ref508, ref) {
  var className = _ref508.className,
      children = _ref508.children,
      style = _ref508.style,
      tabIndex = _ref508.tabIndex,
      rest = _objectWithoutProperties$2(_ref508, ["className", "children", "style", "tabIndex"]);

  var _getAttributes508 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes508.tabindex,
      props = _objectWithoutProperties$2(_getAttributes508, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10l10 10-1.4 1.4-8.6-8.6-8.6 8.6L6 20z'
  }));
});
ChevronUp20.displayName = 'ChevronUp20';
ChevronUp20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronUp20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chip32 = React.forwardRef(function (_ref509, ref) {
  var className = _ref509.className,
      children = _ref509.children,
      style = _ref509.style,
      tabIndex = _ref509.tabIndex,
      rest = _objectWithoutProperties$2(_ref509, ["className", "children", "style", "tabIndex"]);

  var _getAttributes509 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes509.tabindex,
      props = _objectWithoutProperties$2(_getAttributes509, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 11v10h10V11zm8 8h-6v-6h6z'
  }), React.createElement('path', {
    d: 'M29 13v-2h-3V8a2 2 0 0 0-2-2h-3V3h-2v3h-6V3h-2v3H8a2 2 0 0 0-2 2v3H3v2h3v6H3v2h3v3a2 2 0 0 0 2 2h3v3h2v-3h6v3h2v-3h3a2 2 0 0 0 2-2v-3h3v-2h-3v-6zm-5 11H8V8h16z'
  }));
});
Chip32.displayName = 'Chip32';
Chip32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chip32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chip24 = React.forwardRef(function (_ref510, ref) {
  var className = _ref510.className,
      children = _ref510.children,
      style = _ref510.style,
      tabIndex = _ref510.tabIndex,
      rest = _objectWithoutProperties$2(_ref510, ["className", "children", "style", "tabIndex"]);

  var _getAttributes510 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes510.tabindex,
      props = _objectWithoutProperties$2(_getAttributes510, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 11v10h10V11zm8 8h-6v-6h6z'
  }), React.createElement('path', {
    d: 'M29 13v-2h-3V8a2 2 0 0 0-2-2h-3V3h-2v3h-6V3h-2v3H8a2 2 0 0 0-2 2v3H3v2h3v6H3v2h3v3a2 2 0 0 0 2 2h3v3h2v-3h6v3h2v-3h3a2 2 0 0 0 2-2v-3h3v-2h-3v-6zm-5 11H8V8h16z'
  }));
});
Chip24.displayName = 'Chip24';
Chip24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chip24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Chip20 = React.forwardRef(function (_ref511, ref) {
  var className = _ref511.className,
      children = _ref511.children,
      style = _ref511.style,
      tabIndex = _ref511.tabIndex,
      rest = _objectWithoutProperties$2(_ref511, ["className", "children", "style", "tabIndex"]);

  var _getAttributes511 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes511.tabindex,
      props = _objectWithoutProperties$2(_getAttributes511, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 11v10h10V11zm8 8h-6v-6h6z'
  }), React.createElement('path', {
    d: 'M29 13v-2h-3V8a2 2 0 0 0-2-2h-3V3h-2v3h-6V3h-2v3H8a2 2 0 0 0-2 2v3H3v2h3v6H3v2h3v3a2 2 0 0 0 2 2h3v3h2v-3h6v3h2v-3h3a2 2 0 0 0 2-2v-3h3v-2h-3v-6zm-5 11H8V8h16z'
  }));
});
Chip20.displayName = 'Chip20';
Chip20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Chip20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CircleDash32 = React.forwardRef(function (_ref512, ref) {
  var className = _ref512.className,
      children = _ref512.children,
      style = _ref512.style,
      tabIndex = _ref512.tabIndex,
      rest = _objectWithoutProperties$2(_ref512, ["className", "children", "style", "tabIndex"]);

  var _getAttributes512 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes512.tabindex,
      props = _objectWithoutProperties$2(_getAttributes512, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.7 4.7a14.7 14.7 0 0 0-3 3.1L6.3 9a13.26 13.26 0 0 1 2.6-2.7zm-3.1 7.6l-1.9-.6A12.51 12.51 0 0 0 2 16h2a11.48 11.48 0 0 1 .6-3.7zm-1.9 8.1a14.4 14.4 0 0 0 2 3.9l1.6-1.2a12.89 12.89 0 0 1-1.7-3.3zm5.1 6.9a14.4 14.4 0 0 0 3.9 2l.6-1.9A12.89 12.89 0 0 1 9 25.7zm3.9-24.6l.6 1.9A11.48 11.48 0 0 1 16 4V2a12.51 12.51 0 0 0-4.3.7zm12.5 24.6a15.18 15.18 0 0 0 3.1-3.1L25.7 23a11.53 11.53 0 0 1-2.7 2.7zm3.2-7.6l1.9.6A15.47 15.47 0 0 0 30 16h-2a11.48 11.48 0 0 1-.6 3.7zm1.8-8.1a14.4 14.4 0 0 0-2-3.9l-1.6 1.2a12.89 12.89 0 0 1 1.7 3.3zm-5.1-7a14.4 14.4 0 0 0-3.9-2l-.6 1.9a12.89 12.89 0 0 1 3.3 1.7zm-3.8 24.7l-.6-1.9a11.48 11.48 0 0 1-3.7.6v2a21.42 21.42 0 0 0 4.3-.7z'
  }));
});
CircleDash32.displayName = 'CircleDash32';
CircleDash32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CircleDash32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CircleDash24 = React.forwardRef(function (_ref513, ref) {
  var className = _ref513.className,
      children = _ref513.children,
      style = _ref513.style,
      tabIndex = _ref513.tabIndex,
      rest = _objectWithoutProperties$2(_ref513, ["className", "children", "style", "tabIndex"]);

  var _getAttributes513 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes513.tabindex,
      props = _objectWithoutProperties$2(_getAttributes513, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.7 4.7a14.7 14.7 0 0 0-3 3.1L6.3 9a13.26 13.26 0 0 1 2.6-2.7zm-3.1 7.6l-1.9-.6A12.51 12.51 0 0 0 2 16h2a11.48 11.48 0 0 1 .6-3.7zm-1.9 8.1a14.4 14.4 0 0 0 2 3.9l1.6-1.2a12.89 12.89 0 0 1-1.7-3.3zm5.1 6.9a14.4 14.4 0 0 0 3.9 2l.6-1.9A12.89 12.89 0 0 1 9 25.7zm3.9-24.6l.6 1.9A11.48 11.48 0 0 1 16 4V2a12.51 12.51 0 0 0-4.3.7zm12.5 24.6a15.18 15.18 0 0 0 3.1-3.1L25.7 23a11.53 11.53 0 0 1-2.7 2.7zm3.2-7.6l1.9.6A15.47 15.47 0 0 0 30 16h-2a11.48 11.48 0 0 1-.6 3.7zm1.8-8.1a14.4 14.4 0 0 0-2-3.9l-1.6 1.2a12.89 12.89 0 0 1 1.7 3.3zm-5.1-7a14.4 14.4 0 0 0-3.9-2l-.6 1.9a12.89 12.89 0 0 1 3.3 1.7zm-3.8 24.7l-.6-1.9a11.48 11.48 0 0 1-3.7.6v2a21.42 21.42 0 0 0 4.3-.7z'
  }));
});
CircleDash24.displayName = 'CircleDash24';
CircleDash24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CircleDash24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CircleDash20 = React.forwardRef(function (_ref514, ref) {
  var className = _ref514.className,
      children = _ref514.children,
      style = _ref514.style,
      tabIndex = _ref514.tabIndex,
      rest = _objectWithoutProperties$2(_ref514, ["className", "children", "style", "tabIndex"]);

  var _getAttributes514 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes514.tabindex,
      props = _objectWithoutProperties$2(_getAttributes514, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.7 4.7a14.7 14.7 0 0 0-3 3.1L6.3 9a13.26 13.26 0 0 1 2.6-2.7zm-3.1 7.6l-1.9-.6A12.51 12.51 0 0 0 2 16h2a11.48 11.48 0 0 1 .6-3.7zm-1.9 8.1a14.4 14.4 0 0 0 2 3.9l1.6-1.2a12.89 12.89 0 0 1-1.7-3.3zm5.1 6.9a14.4 14.4 0 0 0 3.9 2l.6-1.9A12.89 12.89 0 0 1 9 25.7zm3.9-24.6l.6 1.9A11.48 11.48 0 0 1 16 4V2a12.51 12.51 0 0 0-4.3.7zm12.5 24.6a15.18 15.18 0 0 0 3.1-3.1L25.7 23a11.53 11.53 0 0 1-2.7 2.7zm3.2-7.6l1.9.6A15.47 15.47 0 0 0 30 16h-2a11.48 11.48 0 0 1-.6 3.7zm1.8-8.1a14.4 14.4 0 0 0-2-3.9l-1.6 1.2a12.89 12.89 0 0 1 1.7 3.3zm-5.1-7a14.4 14.4 0 0 0-3.9-2l-.6 1.9a12.89 12.89 0 0 1 3.3 1.7zm-3.8 24.7l-.6-1.9a11.48 11.48 0 0 1-3.7.6v2a21.42 21.42 0 0 0 4.3-.7z'
  }));
});
CircleDash20.displayName = 'CircleDash20';
CircleDash20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CircleDash20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClassifierLanguage32 = React.forwardRef(function (_ref515, ref) {
  var className = _ref515.className,
      children = _ref515.children,
      style = _ref515.style,
      tabIndex = _ref515.tabIndex,
      rest = _objectWithoutProperties$2(_ref515, ["className", "children", "style", "tabIndex"]);

  var _getAttributes515 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes515.tabindex,
      props = _objectWithoutProperties$2(_getAttributes515, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM7 9.86a4 4 0 1 0-2 0V15H2v2h7v-2H7zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm16 9h-8v2h3v4h2v-4h3v-2zm10-5V2h-8v8h3v5h-2v2h7v-2h-3v-5zm-6-6h4v4h-4z'
  }));
});
ClassifierLanguage32.displayName = 'ClassifierLanguage32';
ClassifierLanguage32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClassifierLanguage32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClassifierLanguage24 = React.forwardRef(function (_ref516, ref) {
  var className = _ref516.className,
      children = _ref516.children,
      style = _ref516.style,
      tabIndex = _ref516.tabIndex,
      rest = _objectWithoutProperties$2(_ref516, ["className", "children", "style", "tabIndex"]);

  var _getAttributes516 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes516.tabindex,
      props = _objectWithoutProperties$2(_getAttributes516, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM7 9.86a4 4 0 1 0-2 0V15H2v2h7v-2H7zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm16 9h-8v2h3v4h2v-4h3v-2zm10-5V2h-8v8h3v5h-2v2h7v-2h-3v-5zm-6-6h4v4h-4z'
  }));
});
ClassifierLanguage24.displayName = 'ClassifierLanguage24';
ClassifierLanguage24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClassifierLanguage24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClassifierLanguage20 = React.forwardRef(function (_ref517, ref) {
  var className = _ref517.className,
      children = _ref517.children,
      style = _ref517.style,
      tabIndex = _ref517.tabIndex,
      rest = _objectWithoutProperties$2(_ref517, ["className", "children", "style", "tabIndex"]);

  var _getAttributes517 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes517.tabindex,
      props = _objectWithoutProperties$2(_getAttributes517, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM7 9.86a4 4 0 1 0-2 0V15H2v2h7v-2H7zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm16 9h-8v2h3v4h2v-4h3v-2zm10-5V2h-8v8h3v5h-2v2h7v-2h-3v-5zm-6-6h4v4h-4z'
  }));
});
ClassifierLanguage20.displayName = 'ClassifierLanguage20';
ClassifierLanguage20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClassifierLanguage20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Close32 = React.forwardRef(function (_ref518, ref) {
  var className = _ref518.className,
      children = _ref518.children,
      style = _ref518.style,
      tabIndex = _ref518.tabIndex,
      rest = _objectWithoutProperties$2(_ref518, ["className", "children", "style", "tabIndex"]);

  var _getAttributes518 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes518.tabindex,
      props = _objectWithoutProperties$2(_getAttributes518, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4l6.6 6.6L8 22.6 9.4 24l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L24 9.4z'
  }));
});
Close32.displayName = 'Close32';
Close32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Close32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Close24 = React.forwardRef(function (_ref519, ref) {
  var className = _ref519.className,
      children = _ref519.children,
      style = _ref519.style,
      tabIndex = _ref519.tabIndex,
      rest = _objectWithoutProperties$2(_ref519, ["className", "children", "style", "tabIndex"]);

  var _getAttributes519 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes519.tabindex,
      props = _objectWithoutProperties$2(_getAttributes519, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4l6.6 6.6L8 22.6 9.4 24l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L24 9.4z'
  }));
});
Close24.displayName = 'Close24';
Close24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Close24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Close20 = React.forwardRef(function (_ref520, ref) {
  var className = _ref520.className,
      children = _ref520.children,
      style = _ref520.style,
      tabIndex = _ref520.tabIndex,
      rest = _objectWithoutProperties$2(_ref520, ["className", "children", "style", "tabIndex"]);

  var _getAttributes520 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes520.tabindex,
      props = _objectWithoutProperties$2(_getAttributes520, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4l6.6 6.6L8 22.6 9.4 24l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L24 9.4z'
  }));
});
Close20.displayName = 'Close20';
Close20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Close20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClosedCaptionFilled32 = React.forwardRef(function (_ref521, ref) {
  var className = _ref521.className,
      children = _ref521.children,
      style = _ref521.style,
      tabIndex = _ref521.tabIndex,
      rest = _objectWithoutProperties$2(_ref521, ["className", "children", "style", "tabIndex"]);

  var _getAttributes521 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes521.tabindex,
      props = _objectWithoutProperties$2(_getAttributes521, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-13 7h-5v6h5v2h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5zm10 0h-5v6h5v2h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5z'
  }));
});
ClosedCaptionFilled32.displayName = 'ClosedCaptionFilled32';
ClosedCaptionFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClosedCaptionFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClosedCaptionFilled24 = React.forwardRef(function (_ref522, ref) {
  var className = _ref522.className,
      children = _ref522.children,
      style = _ref522.style,
      tabIndex = _ref522.tabIndex,
      rest = _objectWithoutProperties$2(_ref522, ["className", "children", "style", "tabIndex"]);

  var _getAttributes522 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes522.tabindex,
      props = _objectWithoutProperties$2(_getAttributes522, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-13 7h-5v6h5v2h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5zm10 0h-5v6h5v2h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5z'
  }));
});
ClosedCaptionFilled24.displayName = 'ClosedCaptionFilled24';
ClosedCaptionFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClosedCaptionFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClosedCaptionFilled20 = React.forwardRef(function (_ref523, ref) {
  var className = _ref523.className,
      children = _ref523.children,
      style = _ref523.style,
      tabIndex = _ref523.tabIndex,
      rest = _objectWithoutProperties$2(_ref523, ["className", "children", "style", "tabIndex"]);

  var _getAttributes523 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes523.tabindex,
      props = _objectWithoutProperties$2(_getAttributes523, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-13 7h-5v6h5v2h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5zm10 0h-5v6h5v2h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5z'
  }));
});
ClosedCaptionFilled20.displayName = 'ClosedCaptionFilled20';
ClosedCaptionFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClosedCaptionFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClosedCaption32 = React.forwardRef(function (_ref524, ref) {
  var className = _ref524.className,
      children = _ref524.children,
      style = _ref524.style,
      tabIndex = _ref524.tabIndex,
      rest = _objectWithoutProperties$2(_ref524, ["className", "children", "style", "tabIndex"]);

  var _getAttributes524 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes524.tabindex,
      props = _objectWithoutProperties$2(_getAttributes524, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 21h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm10 0h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5z'
  }), React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM4 8v16h24V8z'
  }));
});
ClosedCaption32.displayName = 'ClosedCaption32';
ClosedCaption32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClosedCaption32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClosedCaption24 = React.forwardRef(function (_ref525, ref) {
  var className = _ref525.className,
      children = _ref525.children,
      style = _ref525.style,
      tabIndex = _ref525.tabIndex,
      rest = _objectWithoutProperties$2(_ref525, ["className", "children", "style", "tabIndex"]);

  var _getAttributes525 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes525.tabindex,
      props = _objectWithoutProperties$2(_getAttributes525, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 21h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm10 0h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5z'
  }), React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM4 8v16h24V8z'
  }));
});
ClosedCaption24.displayName = 'ClosedCaption24';
ClosedCaption24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClosedCaption24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ClosedCaption20 = React.forwardRef(function (_ref526, ref) {
  var className = _ref526.className,
      children = _ref526.children,
      style = _ref526.style,
      tabIndex = _ref526.tabIndex,
      rest = _objectWithoutProperties$2(_ref526, ["className", "children", "style", "tabIndex"]);

  var _getAttributes526 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes526.tabindex,
      props = _objectWithoutProperties$2(_getAttributes526, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 21h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm10 0h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5z'
  }), React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM4 8v16h24V8z'
  }));
});
ClosedCaption20.displayName = 'ClosedCaption20';
ClosedCaption20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ClosedCaption20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudDownload32 = React.forwardRef(function (_ref527, ref) {
  var className = _ref527.className,
      children = _ref527.children,
      style = _ref527.style,
      tabIndex = _ref527.tabIndex,
      rest = _objectWithoutProperties$2(_ref527, ["className", "children", "style", "tabIndex"]);

  var _getAttributes527 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes527.tabindex,
      props = _objectWithoutProperties$2(_getAttributes527, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }), React.createElement('path', {
    d: 'M17 26.17V14h-2v12.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17z'
  }));
});
CloudDownload32.displayName = 'CloudDownload32';
CloudDownload32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudDownload32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudDownload24 = React.forwardRef(function (_ref528, ref) {
  var className = _ref528.className,
      children = _ref528.children,
      style = _ref528.style,
      tabIndex = _ref528.tabIndex,
      rest = _objectWithoutProperties$2(_ref528, ["className", "children", "style", "tabIndex"]);

  var _getAttributes528 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes528.tabindex,
      props = _objectWithoutProperties$2(_getAttributes528, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }), React.createElement('path', {
    d: 'M17 26.17V14h-2v12.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17z'
  }));
});
CloudDownload24.displayName = 'CloudDownload24';
CloudDownload24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudDownload24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudDownload20 = React.forwardRef(function (_ref529, ref) {
  var className = _ref529.className,
      children = _ref529.children,
      style = _ref529.style,
      tabIndex = _ref529.tabIndex,
      rest = _objectWithoutProperties$2(_ref529, ["className", "children", "style", "tabIndex"]);

  var _getAttributes529 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes529.tabindex,
      props = _objectWithoutProperties$2(_getAttributes529, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }), React.createElement('path', {
    d: 'M17 26.17V14h-2v12.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17z'
  }));
});
CloudDownload20.displayName = 'CloudDownload20';
CloudDownload20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudDownload20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudLightning32 = React.forwardRef(function (_ref530, ref) {
  var className = _ref530.className,
      children = _ref530.children,
      style = _ref530.style,
      tabIndex = _ref530.tabIndex,
      rest = _objectWithoutProperties$2(_ref530, ["className", "children", "style", "tabIndex"]);

  var _getAttributes530 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes530.tabindex,
      props = _objectWithoutProperties$2(_getAttributes530, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }), React.createElement('path', {
    d: 'M15.87 30.5l-1.74-1 3.15-5.5h-6l4.85-8.5 1.74 1-3.15 5.5h6l-4.85 8.5z'
  }));
});
CloudLightning32.displayName = 'CloudLightning32';
CloudLightning32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudLightning32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudLightning24 = React.forwardRef(function (_ref531, ref) {
  var className = _ref531.className,
      children = _ref531.children,
      style = _ref531.style,
      tabIndex = _ref531.tabIndex,
      rest = _objectWithoutProperties$2(_ref531, ["className", "children", "style", "tabIndex"]);

  var _getAttributes531 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes531.tabindex,
      props = _objectWithoutProperties$2(_getAttributes531, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }), React.createElement('path', {
    d: 'M15.87 30.5l-1.74-1 3.15-5.5h-6l4.85-8.5 1.74 1-3.15 5.5h6l-4.85 8.5z'
  }));
});
CloudLightning24.displayName = 'CloudLightning24';
CloudLightning24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudLightning24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudLightning20 = React.forwardRef(function (_ref532, ref) {
  var className = _ref532.className,
      children = _ref532.children,
      style = _ref532.style,
      tabIndex = _ref532.tabIndex,
      rest = _objectWithoutProperties$2(_ref532, ["className", "children", "style", "tabIndex"]);

  var _getAttributes532 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes532.tabindex,
      props = _objectWithoutProperties$2(_getAttributes532, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }), React.createElement('path', {
    d: 'M15.87 30.5l-1.74-1 3.15-5.5h-6l4.85-8.5 1.74 1-3.15 5.5h6l-4.85 8.5z'
  }));
});
CloudLightning20.displayName = 'CloudLightning20';
CloudLightning20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudLightning20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudRain32 = React.forwardRef(function (_ref533, ref) {
  var className = _ref533.className,
      children = _ref533.children,
      style = _ref533.style,
      tabIndex = _ref533.tabIndex,
      rest = _objectWithoutProperties$2(_ref533, ["className", "children", "style", "tabIndex"]);

  var _getAttributes533 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes533.tabindex,
      props = _objectWithoutProperties$2(_getAttributes533, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22h-15A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22zM16 4a7 7 0 0 0-6.94 6.14L9 11h-.86a4.5 4.5 0 0 0 .36 9h15a4.5 4.5 0 0 0 .36-9H23l-.1-.82A7 7 0 0 0 16 4zm-2 26a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 14 30zm6 0a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 20 30zM8 30a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 8 30z'
  }));
});
CloudRain32.displayName = 'CloudRain32';
CloudRain32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudRain32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudRain24 = React.forwardRef(function (_ref534, ref) {
  var className = _ref534.className,
      children = _ref534.children,
      style = _ref534.style,
      tabIndex = _ref534.tabIndex,
      rest = _objectWithoutProperties$2(_ref534, ["className", "children", "style", "tabIndex"]);

  var _getAttributes534 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes534.tabindex,
      props = _objectWithoutProperties$2(_getAttributes534, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22h-15A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22zM16 4a7 7 0 0 0-6.94 6.14L9 11h-.86a4.5 4.5 0 0 0 .36 9h15a4.5 4.5 0 0 0 .36-9H23l-.1-.82A7 7 0 0 0 16 4zm-2 26a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 14 30zm6 0a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 20 30zM8 30a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 8 30z'
  }));
});
CloudRain24.displayName = 'CloudRain24';
CloudRain24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudRain24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudRain20 = React.forwardRef(function (_ref535, ref) {
  var className = _ref535.className,
      children = _ref535.children,
      style = _ref535.style,
      tabIndex = _ref535.tabIndex,
      rest = _objectWithoutProperties$2(_ref535, ["className", "children", "style", "tabIndex"]);

  var _getAttributes535 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes535.tabindex,
      props = _objectWithoutProperties$2(_getAttributes535, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22h-15A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22zM16 4a7 7 0 0 0-6.94 6.14L9 11h-.86a4.5 4.5 0 0 0 .36 9h15a4.5 4.5 0 0 0 .36-9H23l-.1-.82A7 7 0 0 0 16 4zm-2 26a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 14 30zm6 0a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 20 30zM8 30a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 8 30z'
  }));
});
CloudRain20.displayName = 'CloudRain20';
CloudRain20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudRain20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudSnow32 = React.forwardRef(function (_ref536, ref) {
  var className = _ref536.className,
      children = _ref536.children,
      style = _ref536.style,
      tabIndex = _ref536.tabIndex,
      rest = _objectWithoutProperties$2(_ref536, ["className", "children", "style", "tabIndex"]);

  var _getAttributes536 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes536.tabindex,
      props = _objectWithoutProperties$2(_getAttributes536, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22h-15A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22zM16 4a7 7 0 0 0-6.94 6.14L9 11h-.86a4.5 4.5 0 0 0 .36 9h15a4.5 4.5 0 0 0 .36-9H23l-.1-.82A7 7 0 0 0 16 4zm-4 21.05L10.95 24 9.5 25.45 8.05 24 7 25.05l1.45 1.45L7 27.95 8.05 29l1.45-1.45L10.95 29 12 27.95l-1.45-1.45L12 25.05zm14 0L24.95 24l-1.45 1.45L22.05 24 21 25.05l1.45 1.45L21 27.95 22.05 29l1.45-1.45L24.95 29 26 27.95l-1.45-1.45L26 25.05zm-7 2L17.95 26l-1.45 1.45L15.05 26 14 27.05l1.45 1.45L14 29.95 15.05 31l1.45-1.45L17.95 31 19 29.95l-1.45-1.45L19 27.05z'
  }));
});
CloudSnow32.displayName = 'CloudSnow32';
CloudSnow32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudSnow32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudSnow24 = React.forwardRef(function (_ref537, ref) {
  var className = _ref537.className,
      children = _ref537.children,
      style = _ref537.style,
      tabIndex = _ref537.tabIndex,
      rest = _objectWithoutProperties$2(_ref537, ["className", "children", "style", "tabIndex"]);

  var _getAttributes537 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes537.tabindex,
      props = _objectWithoutProperties$2(_getAttributes537, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22h-15A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22zM16 4a7 7 0 0 0-6.94 6.14L9 11h-.86a4.5 4.5 0 0 0 .36 9h15a4.5 4.5 0 0 0 .36-9H23l-.1-.82A7 7 0 0 0 16 4zm-4 21.05L10.95 24 9.5 25.45 8.05 24 7 25.05l1.45 1.45L7 27.95 8.05 29l1.45-1.45L10.95 29 12 27.95l-1.45-1.45L12 25.05zm14 0L24.95 24l-1.45 1.45L22.05 24 21 25.05l1.45 1.45L21 27.95 22.05 29l1.45-1.45L24.95 29 26 27.95l-1.45-1.45L26 25.05zm-7 2L17.95 26l-1.45 1.45L15.05 26 14 27.05l1.45 1.45L14 29.95 15.05 31l1.45-1.45L17.95 31 19 29.95l-1.45-1.45L19 27.05z'
  }));
});
CloudSnow24.displayName = 'CloudSnow24';
CloudSnow24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudSnow24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudSnow20 = React.forwardRef(function (_ref538, ref) {
  var className = _ref538.className,
      children = _ref538.children,
      style = _ref538.style,
      tabIndex = _ref538.tabIndex,
      rest = _objectWithoutProperties$2(_ref538, ["className", "children", "style", "tabIndex"]);

  var _getAttributes538 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes538.tabindex,
      props = _objectWithoutProperties$2(_getAttributes538, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.5 22h-15A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22zM16 4a7 7 0 0 0-6.94 6.14L9 11h-.86a4.5 4.5 0 0 0 .36 9h15a4.5 4.5 0 0 0 .36-9H23l-.1-.82A7 7 0 0 0 16 4zm-4 21.05L10.95 24 9.5 25.45 8.05 24 7 25.05l1.45 1.45L7 27.95 8.05 29l1.45-1.45L10.95 29 12 27.95l-1.45-1.45L12 25.05zm14 0L24.95 24l-1.45 1.45L22.05 24 21 25.05l1.45 1.45L21 27.95 22.05 29l1.45-1.45L24.95 29 26 27.95l-1.45-1.45L26 25.05zm-7 2L17.95 26l-1.45 1.45L15.05 26 14 27.05l1.45 1.45L14 29.95 15.05 31l1.45-1.45L17.95 31 19 29.95l-1.45-1.45L19 27.05z'
  }));
});
CloudSnow20.displayName = 'CloudSnow20';
CloudSnow20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudSnow20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudUpload32 = React.forwardRef(function (_ref539, ref) {
  var className = _ref539.className,
      children = _ref539.children,
      style = _ref539.style,
      tabIndex = _ref539.tabIndex,
      rest = _objectWithoutProperties$2(_ref539, ["className", "children", "style", "tabIndex"]);

  var _getAttributes539 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes539.tabindex,
      props = _objectWithoutProperties$2(_getAttributes539, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 18l1.41 1.41L15 16.83V29h2V16.83l2.59 2.58L21 18l-5-5-5 5z'
  }), React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }));
});
CloudUpload32.displayName = 'CloudUpload32';
CloudUpload32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudUpload32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudUpload24 = React.forwardRef(function (_ref540, ref) {
  var className = _ref540.className,
      children = _ref540.children,
      style = _ref540.style,
      tabIndex = _ref540.tabIndex,
      rest = _objectWithoutProperties$2(_ref540, ["className", "children", "style", "tabIndex"]);

  var _getAttributes540 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes540.tabindex,
      props = _objectWithoutProperties$2(_getAttributes540, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 18l1.41 1.41L15 16.83V29h2V16.83l2.59 2.58L21 18l-5-5-5 5z'
  }), React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }));
});
CloudUpload24.displayName = 'CloudUpload24';
CloudUpload24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudUpload24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudUpload20 = React.forwardRef(function (_ref541, ref) {
  var className = _ref541.className,
      children = _ref541.children,
      style = _ref541.style,
      tabIndex = _ref541.tabIndex,
      rest = _objectWithoutProperties$2(_ref541, ["className", "children", "style", "tabIndex"]);

  var _getAttributes541 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes541.tabindex,
      props = _objectWithoutProperties$2(_getAttributes541, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 18l1.41 1.41L15 16.83V29h2V16.83l2.59 2.58L21 18l-5-5-5 5z'
  }), React.createElement('path', {
    d: 'M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22z'
  }));
});
CloudUpload20.displayName = 'CloudUpload20';
CloudUpload20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudUpload20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudFoundry_132 = React.forwardRef(function (_ref542, ref) {
  var className = _ref542.className,
      children = _ref542.children,
      style = _ref542.style,
      tabIndex = _ref542.tabIndex,
      rest = _objectWithoutProperties$2(_ref542, ["className", "children", "style", "tabIndex"]);

  var _getAttributes542 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes542.tabindex,
      props = _objectWithoutProperties$2(_getAttributes542, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 7a7.66 7.66 0 0 1 1.51.15 8 8 0 0 1 6.35 6.34l.26 1.35 1.35.24a5.5 5.5 0 0 1-1 10.92H7.5a5.5 5.5 0 0 1-1-10.92l1.34-.24.26-1.35A8 8 0 0 1 16 7m0-2a10 10 0 0 0-9.83 8.12A7.5 7.5 0 0 0 7.49 28h17a7.5 7.5 0 0 0 1.32-14.88 10 10 0 0 0-7.94-7.94A10.27 10.27 0 0 0 16 5z'
  }), React.createElement('path', {
    d: 'M14 24h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3v2h-3v3h3zm7-9v-2h-2a2 2 0 0 0-2 2v2h-1v2h1v5h2v-5h2v-2h-2v-2z'
  }));
});
CloudFoundry_132.displayName = 'CloudFoundry_132';
CloudFoundry_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudFoundry_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudFoundry_124 = React.forwardRef(function (_ref543, ref) {
  var className = _ref543.className,
      children = _ref543.children,
      style = _ref543.style,
      tabIndex = _ref543.tabIndex,
      rest = _objectWithoutProperties$2(_ref543, ["className", "children", "style", "tabIndex"]);

  var _getAttributes543 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes543.tabindex,
      props = _objectWithoutProperties$2(_getAttributes543, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 7a7.66 7.66 0 0 1 1.51.15 8 8 0 0 1 6.35 6.34l.26 1.35 1.35.24a5.5 5.5 0 0 1-1 10.92H7.5a5.5 5.5 0 0 1-1-10.92l1.34-.24.26-1.35A8 8 0 0 1 16 7m0-2a10 10 0 0 0-9.83 8.12A7.5 7.5 0 0 0 7.49 28h17a7.5 7.5 0 0 0 1.32-14.88 10 10 0 0 0-7.94-7.94A10.27 10.27 0 0 0 16 5z'
  }), React.createElement('path', {
    d: 'M14 24h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3v2h-3v3h3zm7-9v-2h-2a2 2 0 0 0-2 2v2h-1v2h1v5h2v-5h2v-2h-2v-2z'
  }));
});
CloudFoundry_124.displayName = 'CloudFoundry_124';
CloudFoundry_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudFoundry_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudFoundry_120 = React.forwardRef(function (_ref544, ref) {
  var className = _ref544.className,
      children = _ref544.children,
      style = _ref544.style,
      tabIndex = _ref544.tabIndex,
      rest = _objectWithoutProperties$2(_ref544, ["className", "children", "style", "tabIndex"]);

  var _getAttributes544 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes544.tabindex,
      props = _objectWithoutProperties$2(_getAttributes544, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 7a7.66 7.66 0 0 1 1.51.15 8 8 0 0 1 6.35 6.34l.26 1.35 1.35.24a5.5 5.5 0 0 1-1 10.92H7.5a5.5 5.5 0 0 1-1-10.92l1.34-.24.26-1.35A8 8 0 0 1 16 7m0-2a10 10 0 0 0-9.83 8.12A7.5 7.5 0 0 0 7.49 28h17a7.5 7.5 0 0 0 1.32-14.88 10 10 0 0 0-7.94-7.94A10.27 10.27 0 0 0 16 5z'
  }), React.createElement('path', {
    d: 'M14 24h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3v2h-3v3h3zm7-9v-2h-2a2 2 0 0 0-2 2v2h-1v2h1v5h2v-5h2v-2h-2v-2z'
  }));
});
CloudFoundry_120.displayName = 'CloudFoundry_120';
CloudFoundry_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudFoundry_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudFoundry_232 = React.forwardRef(function (_ref545, ref) {
  var className = _ref545.className,
      children = _ref545.children,
      style = _ref545.style,
      tabIndex = _ref545.tabIndex,
      rest = _objectWithoutProperties$2(_ref545, ["className", "children", "style", "tabIndex"]);

  var _getAttributes545 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes545.tabindex,
      props = _objectWithoutProperties$2(_getAttributes545, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 11V9h-8v14h2v-6h5v-2h-5v-4h6zM15 23H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h6z'
  }));
});
CloudFoundry_232.displayName = 'CloudFoundry_232';
CloudFoundry_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudFoundry_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudFoundry_224 = React.forwardRef(function (_ref546, ref) {
  var className = _ref546.className,
      children = _ref546.children,
      style = _ref546.style,
      tabIndex = _ref546.tabIndex,
      rest = _objectWithoutProperties$2(_ref546, ["className", "children", "style", "tabIndex"]);

  var _getAttributes546 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes546.tabindex,
      props = _objectWithoutProperties$2(_getAttributes546, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 11V9h-8v14h2v-6h5v-2h-5v-4h6zM15 23H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h6z'
  }));
});
CloudFoundry_224.displayName = 'CloudFoundry_224';
CloudFoundry_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudFoundry_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CloudFoundry_220 = React.forwardRef(function (_ref547, ref) {
  var className = _ref547.className,
      children = _ref547.children,
      style = _ref547.style,
      tabIndex = _ref547.tabIndex,
      rest = _objectWithoutProperties$2(_ref547, ["className", "children", "style", "tabIndex"]);

  var _getAttributes547 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes547.tabindex,
      props = _objectWithoutProperties$2(_getAttributes547, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 11V9h-8v14h2v-6h5v-2h-5v-4h6zM15 23H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h6z'
  }));
});
CloudFoundry_220.displayName = 'CloudFoundry_220';
CloudFoundry_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CloudFoundry_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cloud32 = React.forwardRef(function (_ref548, ref) {
  var className = _ref548.className,
      children = _ref548.children,
      style = _ref548.style,
      tabIndex = _ref548.tabIndex,
      rest = _objectWithoutProperties$2(_ref548, ["className", "children", "style", "tabIndex"]);

  var _getAttributes548 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes548.tabindex,
      props = _objectWithoutProperties$2(_getAttributes548, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 7a7.66 7.66 0 0 1 1.51.15 8 8 0 0 1 6.35 6.34l.26 1.35 1.35.24a5.5 5.5 0 0 1-1 10.92H7.5a5.5 5.5 0 0 1-1-10.92l1.34-.24.26-1.35A8 8 0 0 1 16 7m0-2a10 10 0 0 0-9.83 8.12A7.5 7.5 0 0 0 7.49 28h17a7.5 7.5 0 0 0 1.32-14.88 10 10 0 0 0-7.94-7.94A10.27 10.27 0 0 0 16 5z'
  }));
});
Cloud32.displayName = 'Cloud32';
Cloud32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cloud32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cloud24 = React.forwardRef(function (_ref549, ref) {
  var className = _ref549.className,
      children = _ref549.children,
      style = _ref549.style,
      tabIndex = _ref549.tabIndex,
      rest = _objectWithoutProperties$2(_ref549, ["className", "children", "style", "tabIndex"]);

  var _getAttributes549 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes549.tabindex,
      props = _objectWithoutProperties$2(_getAttributes549, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 7a7.66 7.66 0 0 1 1.51.15 8 8 0 0 1 6.35 6.34l.26 1.35 1.35.24a5.5 5.5 0 0 1-1 10.92H7.5a5.5 5.5 0 0 1-1-10.92l1.34-.24.26-1.35A8 8 0 0 1 16 7m0-2a10 10 0 0 0-9.83 8.12A7.5 7.5 0 0 0 7.49 28h17a7.5 7.5 0 0 0 1.32-14.88 10 10 0 0 0-7.94-7.94A10.27 10.27 0 0 0 16 5z'
  }));
});
Cloud24.displayName = 'Cloud24';
Cloud24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cloud24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cloud20 = React.forwardRef(function (_ref550, ref) {
  var className = _ref550.className,
      children = _ref550.children,
      style = _ref550.style,
      tabIndex = _ref550.tabIndex,
      rest = _objectWithoutProperties$2(_ref550, ["className", "children", "style", "tabIndex"]);

  var _getAttributes550 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes550.tabindex,
      props = _objectWithoutProperties$2(_getAttributes550, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 7a7.66 7.66 0 0 1 1.51.15 8 8 0 0 1 6.35 6.34l.26 1.35 1.35.24a5.5 5.5 0 0 1-1 10.92H7.5a5.5 5.5 0 0 1-1-10.92l1.34-.24.26-1.35A8 8 0 0 1 16 7m0-2a10 10 0 0 0-9.83 8.12A7.5 7.5 0 0 0 7.49 28h17a7.5 7.5 0 0 0 1.32-14.88 10 10 0 0 0-7.94-7.94A10.27 10.27 0 0 0 16 5z'
  }));
});
Cloud20.displayName = 'Cloud20';
Cloud20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cloud20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Code32 = React.forwardRef(function (_ref551, ref) {
  var className = _ref551.className,
      children = _ref551.children,
      style = _ref551.style,
      tabIndex = _ref551.tabIndex,
      rest = _objectWithoutProperties$2(_ref551, ["className", "children", "style", "tabIndex"]);

  var _getAttributes551 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes551.tabindex,
      props = _objectWithoutProperties$2(_getAttributes551, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 16l-7 7-1.41-1.41L28.17 16l-5.58-5.59L24 9l7 7zM1 16l7-7 1.41 1.41L3.83 16l5.58 5.59L8 23l-7-7zm11.42 9.484L17.64 6l1.932.517L14.352 26z'
  }));
});
Code32.displayName = 'Code32';
Code32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Code32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Code24 = React.forwardRef(function (_ref552, ref) {
  var className = _ref552.className,
      children = _ref552.children,
      style = _ref552.style,
      tabIndex = _ref552.tabIndex,
      rest = _objectWithoutProperties$2(_ref552, ["className", "children", "style", "tabIndex"]);

  var _getAttributes552 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes552.tabindex,
      props = _objectWithoutProperties$2(_getAttributes552, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 16l-7 7-1.41-1.41L28.17 16l-5.58-5.59L24 9l7 7zM1 16l7-7 1.41 1.41L3.83 16l5.58 5.59L8 23l-7-7zm11.42 9.484L17.64 6l1.932.517L14.352 26z'
  }));
});
Code24.displayName = 'Code24';
Code24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Code24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Code20 = React.forwardRef(function (_ref553, ref) {
  var className = _ref553.className,
      children = _ref553.children,
      style = _ref553.style,
      tabIndex = _ref553.tabIndex,
      rest = _objectWithoutProperties$2(_ref553, ["className", "children", "style", "tabIndex"]);

  var _getAttributes553 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes553.tabindex,
      props = _objectWithoutProperties$2(_getAttributes553, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 16l-7 7-1.41-1.41L28.17 16l-5.58-5.59L24 9l7 7zM1 16l7-7 1.41 1.41L3.83 16l5.58 5.59L8 23l-7-7zm11.42 9.484L17.64 6l1.932.517L14.352 26z'
  }));
});
Code20.displayName = 'Code20';
Code20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Code20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cognitive32 = React.forwardRef(function (_ref554, ref) {
  var className = _ref554.className,
      children = _ref554.children,
      style = _ref554.style,
      tabIndex = _ref554.tabIndex,
      rest = _objectWithoutProperties$2(_ref554, ["className", "children", "style", "tabIndex"]);

  var _getAttributes554 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes554.tabindex,
      props = _objectWithoutProperties$2(_getAttributes554, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 13A11 11 0 0 0 19 2h-8a9 9 0 0 0-9 9v3a5 5 0 0 0 5 5h1.1a5 5 0 0 0 4.9 4h1.38l4 7 1.73-1-4-6.89A2 2 0 0 0 14.38 21H13a3 3 0 0 1 0-6h1v-2h-1a5 5 0 0 0-4.9 4H7a3 3 0 0 1-3-3v-2h2a3 3 0 0 0 3-3V8H7v1a1 1 0 0 1-1 1H4.08A7 7 0 0 1 11 4h6v2a1 1 0 0 1-1 1h-2v2h2a3 3 0 0 0 3-3V4a9 9 0 0 1 8.05 5H26a3 3 0 0 0-3 3v1h2v-1a1 1 0 0 1 1-1h1.77a8.76 8.76 0 0 1 .23 2v1a5 5 0 0 1-5 5h-3v2h3a7 7 0 0 0 3-.68V21a3 3 0 0 1-3 3h-1v2h1a5 5 0 0 0 5-5v-2.11A7 7 0 0 0 30 14z'
  }));
});
Cognitive32.displayName = 'Cognitive32';
Cognitive32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cognitive32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cognitive24 = React.forwardRef(function (_ref555, ref) {
  var className = _ref555.className,
      children = _ref555.children,
      style = _ref555.style,
      tabIndex = _ref555.tabIndex,
      rest = _objectWithoutProperties$2(_ref555, ["className", "children", "style", "tabIndex"]);

  var _getAttributes555 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes555.tabindex,
      props = _objectWithoutProperties$2(_getAttributes555, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 13A11 11 0 0 0 19 2h-8a9 9 0 0 0-9 9v3a5 5 0 0 0 5 5h1.1a5 5 0 0 0 4.9 4h1.38l4 7 1.73-1-4-6.89A2 2 0 0 0 14.38 21H13a3 3 0 0 1 0-6h1v-2h-1a5 5 0 0 0-4.9 4H7a3 3 0 0 1-3-3v-2h2a3 3 0 0 0 3-3V8H7v1a1 1 0 0 1-1 1H4.08A7 7 0 0 1 11 4h6v2a1 1 0 0 1-1 1h-2v2h2a3 3 0 0 0 3-3V4a9 9 0 0 1 8.05 5H26a3 3 0 0 0-3 3v1h2v-1a1 1 0 0 1 1-1h1.77a8.76 8.76 0 0 1 .23 2v1a5 5 0 0 1-5 5h-3v2h3a7 7 0 0 0 3-.68V21a3 3 0 0 1-3 3h-1v2h1a5 5 0 0 0 5-5v-2.11A7 7 0 0 0 30 14z'
  }));
});
Cognitive24.displayName = 'Cognitive24';
Cognitive24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cognitive24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cognitive20 = React.forwardRef(function (_ref556, ref) {
  var className = _ref556.className,
      children = _ref556.children,
      style = _ref556.style,
      tabIndex = _ref556.tabIndex,
      rest = _objectWithoutProperties$2(_ref556, ["className", "children", "style", "tabIndex"]);

  var _getAttributes556 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes556.tabindex,
      props = _objectWithoutProperties$2(_getAttributes556, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 13A11 11 0 0 0 19 2h-8a9 9 0 0 0-9 9v3a5 5 0 0 0 5 5h1.1a5 5 0 0 0 4.9 4h1.38l4 7 1.73-1-4-6.89A2 2 0 0 0 14.38 21H13a3 3 0 0 1 0-6h1v-2h-1a5 5 0 0 0-4.9 4H7a3 3 0 0 1-3-3v-2h2a3 3 0 0 0 3-3V8H7v1a1 1 0 0 1-1 1H4.08A7 7 0 0 1 11 4h6v2a1 1 0 0 1-1 1h-2v2h2a3 3 0 0 0 3-3V4a9 9 0 0 1 8.05 5H26a3 3 0 0 0-3 3v1h2v-1a1 1 0 0 1 1-1h1.77a8.76 8.76 0 0 1 .23 2v1a5 5 0 0 1-5 5h-3v2h3a7 7 0 0 0 3-.68V21a3 3 0 0 1-3 3h-1v2h1a5 5 0 0 0 5-5v-2.11A7 7 0 0 0 30 14z'
  }));
});
Cognitive20.displayName = 'Cognitive20';
Cognitive20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cognitive20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Collaborate32 = React.forwardRef(function (_ref557, ref) {
  var className = _ref557.className,
      children = _ref557.children,
      style = _ref557.style,
      tabIndex = _ref557.tabIndex,
      rest = _objectWithoutProperties$2(_ref557, ["className", "children", "style", "tabIndex"]);

  var _getAttributes557 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes557.tabindex,
      props = _objectWithoutProperties$2(_getAttributes557, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 21v-1H4v1a7 7 0 0 0 7 7h3v-2h-3a5 5 0 0 1-5-5zm18-10v1h2v-1a7 7 0 0 0-7-7h-3v2h3a5 5 0 0 1 5 5zm-13 0H5a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm19 21h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-7-5a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
Collaborate32.displayName = 'Collaborate32';
Collaborate32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Collaborate32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Collaborate24 = React.forwardRef(function (_ref558, ref) {
  var className = _ref558.className,
      children = _ref558.children,
      style = _ref558.style,
      tabIndex = _ref558.tabIndex,
      rest = _objectWithoutProperties$2(_ref558, ["className", "children", "style", "tabIndex"]);

  var _getAttributes558 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes558.tabindex,
      props = _objectWithoutProperties$2(_getAttributes558, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 21v-1H4v1a7 7 0 0 0 7 7h3v-2h-3a5 5 0 0 1-5-5zm18-10v1h2v-1a7 7 0 0 0-7-7h-3v2h3a5 5 0 0 1 5 5zm-13 0H5a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm19 21h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-7-5a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
Collaborate24.displayName = 'Collaborate24';
Collaborate24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Collaborate24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Collaborate20 = React.forwardRef(function (_ref559, ref) {
  var className = _ref559.className,
      children = _ref559.children,
      style = _ref559.style,
      tabIndex = _ref559.tabIndex,
      rest = _objectWithoutProperties$2(_ref559, ["className", "children", "style", "tabIndex"]);

  var _getAttributes559 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes559.tabindex,
      props = _objectWithoutProperties$2(_getAttributes559, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 21v-1H4v1a7 7 0 0 0 7 7h3v-2h-3a5 5 0 0 1-5-5zm18-10v1h2v-1a7 7 0 0 0-7-7h-3v2h3a5 5 0 0 1 5 5zm-13 0H5a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm19 21h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-7-5a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
Collaborate20.displayName = 'Collaborate20';
Collaborate20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Collaborate20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ColorPalette32 = React.forwardRef(function (_ref560, ref) {
  var className = _ref560.className,
      children = _ref560.children,
      style = _ref560.style,
      tabIndex = _ref560.tabIndex,
      rest = _objectWithoutProperties$2(_ref560, ["className", "children", "style", "tabIndex"]);

  var _getAttributes560 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes560.tabindex,
      props = _objectWithoutProperties$2(_getAttributes560, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '12',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '9',
    r: '2'
  }), React.createElement('circle', {
    cx: '22',
    cy: '12',
    r: '2'
  }), React.createElement('circle', {
    cx: '23',
    cy: '18',
    r: '2'
  }), React.createElement('circle', {
    cx: '19',
    cy: '23',
    r: '2'
  }), React.createElement('path', {
    d: 'M16.54 2A14 14 0 0 0 2 16a4.82 4.82 0 0 0 6.09 4.65l1.12-.31a3 3 0 0 1 3.79 2.9V27a3 3 0 0 0 3 3 14 14 0 0 0 14-14.54A14.05 14.05 0 0 0 16.54 2zm8.11 22.31A11.93 11.93 0 0 1 16 28a1 1 0 0 1-1-1v-3.76a5 5 0 0 0-5-5 5.07 5.07 0 0 0-1.33.18l-1.12.31A2.82 2.82 0 0 1 4 16 12 12 0 0 1 16.47 4 12.18 12.18 0 0 1 28 15.53a11.89 11.89 0 0 1-3.35 8.79z'
  }));
});
ColorPalette32.displayName = 'ColorPalette32';
ColorPalette32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ColorPalette32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ColorPalette24 = React.forwardRef(function (_ref561, ref) {
  var className = _ref561.className,
      children = _ref561.children,
      style = _ref561.style,
      tabIndex = _ref561.tabIndex,
      rest = _objectWithoutProperties$2(_ref561, ["className", "children", "style", "tabIndex"]);

  var _getAttributes561 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes561.tabindex,
      props = _objectWithoutProperties$2(_getAttributes561, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '12',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '9',
    r: '2'
  }), React.createElement('circle', {
    cx: '22',
    cy: '12',
    r: '2'
  }), React.createElement('circle', {
    cx: '23',
    cy: '18',
    r: '2'
  }), React.createElement('circle', {
    cx: '19',
    cy: '23',
    r: '2'
  }), React.createElement('path', {
    d: 'M16.54 2A14 14 0 0 0 2 16a4.82 4.82 0 0 0 6.09 4.65l1.12-.31a3 3 0 0 1 3.79 2.9V27a3 3 0 0 0 3 3 14 14 0 0 0 14-14.54A14.05 14.05 0 0 0 16.54 2zm8.11 22.31A11.93 11.93 0 0 1 16 28a1 1 0 0 1-1-1v-3.76a5 5 0 0 0-5-5 5.07 5.07 0 0 0-1.33.18l-1.12.31A2.82 2.82 0 0 1 4 16 12 12 0 0 1 16.47 4 12.18 12.18 0 0 1 28 15.53a11.89 11.89 0 0 1-3.35 8.79z'
  }));
});
ColorPalette24.displayName = 'ColorPalette24';
ColorPalette24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ColorPalette24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ColorPalette20 = React.forwardRef(function (_ref562, ref) {
  var className = _ref562.className,
      children = _ref562.children,
      style = _ref562.style,
      tabIndex = _ref562.tabIndex,
      rest = _objectWithoutProperties$2(_ref562, ["className", "children", "style", "tabIndex"]);

  var _getAttributes562 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes562.tabindex,
      props = _objectWithoutProperties$2(_getAttributes562, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '12',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '9',
    r: '2'
  }), React.createElement('circle', {
    cx: '22',
    cy: '12',
    r: '2'
  }), React.createElement('circle', {
    cx: '23',
    cy: '18',
    r: '2'
  }), React.createElement('circle', {
    cx: '19',
    cy: '23',
    r: '2'
  }), React.createElement('path', {
    d: 'M16.54 2A14 14 0 0 0 2 16a4.82 4.82 0 0 0 6.09 4.65l1.12-.31a3 3 0 0 1 3.79 2.9V27a3 3 0 0 0 3 3 14 14 0 0 0 14-14.54A14.05 14.05 0 0 0 16.54 2zm8.11 22.31A11.93 11.93 0 0 1 16 28a1 1 0 0 1-1-1v-3.76a5 5 0 0 0-5-5 5.07 5.07 0 0 0-1.33.18l-1.12.31A2.82 2.82 0 0 1 4 16 12 12 0 0 1 16.47 4 12.18 12.18 0 0 1 28 15.53a11.89 11.89 0 0 1-3.35 8.79z'
  }));
});
ColorPalette20.displayName = 'ColorPalette20';
ColorPalette20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ColorPalette20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Column32 = React.forwardRef(function (_ref563, ref) {
  var className = _ref563.className,
      children = _ref563.children,
      style = _ref563.style,
      tabIndex = _ref563.tabIndex,
      rest = _objectWithoutProperties$2(_ref563, ["className", "children", "style", "tabIndex"]);

  var _getAttributes563 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes563.tabindex,
      props = _objectWithoutProperties$2(_getAttributes563, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 4h2v24h-2zm-6 2v20h-4V6h4m0-2h-4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 4h2v24H6z'
  }));
});
Column32.displayName = 'Column32';
Column32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Column32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Column24 = React.forwardRef(function (_ref564, ref) {
  var className = _ref564.className,
      children = _ref564.children,
      style = _ref564.style,
      tabIndex = _ref564.tabIndex,
      rest = _objectWithoutProperties$2(_ref564, ["className", "children", "style", "tabIndex"]);

  var _getAttributes564 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes564.tabindex,
      props = _objectWithoutProperties$2(_getAttributes564, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 4h2v24h-2zm-6 2v20h-4V6h4m0-2h-4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 4h2v24H6z'
  }));
});
Column24.displayName = 'Column24';
Column24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Column24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Column20 = React.forwardRef(function (_ref565, ref) {
  var className = _ref565.className,
      children = _ref565.children,
      style = _ref565.style,
      tabIndex = _ref565.tabIndex,
      rest = _objectWithoutProperties$2(_ref565, ["className", "children", "style", "tabIndex"]);

  var _getAttributes565 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes565.tabindex,
      props = _objectWithoutProperties$2(_getAttributes565, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 4h2v24h-2zm-6 2v20h-4V6h4m0-2h-4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 4h2v24H6z'
  }));
});
Column20.displayName = 'Column20';
Column20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Column20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Compare32 = React.forwardRef(function (_ref566, ref) {
  var className = _ref566.className,
      children = _ref566.children,
      style = _ref566.style,
      tabIndex = _ref566.tabIndex,
      rest = _objectWithoutProperties$2(_ref566, ["className", "children", "style", "tabIndex"]);

  var _getAttributes566 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes566.tabindex,
      props = _objectWithoutProperties$2(_getAttributes566, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H18V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 15h6.17l-2.58 2.59L9 19l5-5-5-5-1.41 1.41L10.17 13H4V4h12v20H4zm12 13v-2a2 2 0 0 0 2-2V8h10v9h-6.17l2.58-2.59L23 13l-5 5 5 5 1.41-1.41L21.83 19H28v9z'
  }));
});
Compare32.displayName = 'Compare32';
Compare32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Compare32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Compare24 = React.forwardRef(function (_ref567, ref) {
  var className = _ref567.className,
      children = _ref567.children,
      style = _ref567.style,
      tabIndex = _ref567.tabIndex,
      rest = _objectWithoutProperties$2(_ref567, ["className", "children", "style", "tabIndex"]);

  var _getAttributes567 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes567.tabindex,
      props = _objectWithoutProperties$2(_getAttributes567, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H18V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 15h6.17l-2.58 2.59L9 19l5-5-5-5-1.41 1.41L10.17 13H4V4h12v20H4zm12 13v-2a2 2 0 0 0 2-2V8h10v9h-6.17l2.58-2.59L23 13l-5 5 5 5 1.41-1.41L21.83 19H28v9z'
  }));
});
Compare24.displayName = 'Compare24';
Compare24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Compare24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Compare20 = React.forwardRef(function (_ref568, ref) {
  var className = _ref568.className,
      children = _ref568.children,
      style = _ref568.style,
      tabIndex = _ref568.tabIndex,
      rest = _objectWithoutProperties$2(_ref568, ["className", "children", "style", "tabIndex"]);

  var _getAttributes568 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes568.tabindex,
      props = _objectWithoutProperties$2(_getAttributes568, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H18V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM4 15h6.17l-2.58 2.59L9 19l5-5-5-5-1.41 1.41L10.17 13H4V4h12v20H4zm12 13v-2a2 2 0 0 0 2-2V8h10v9h-6.17l2.58-2.59L23 13l-5 5 5 5 1.41-1.41L21.83 19H28v9z'
  }));
});
Compare20.displayName = 'Compare20';
Compare20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Compare20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Compass32 = React.forwardRef(function (_ref569, ref) {
  var className = _ref569.className,
      children = _ref569.children,
      style = _ref569.style,
      tabIndex = _ref569.tabIndex,
      rest = _objectWithoutProperties$2(_ref569, ["className", "children", "style", "tabIndex"]);

  var _getAttributes569 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes569.tabindex,
      props = _objectWithoutProperties$2(_getAttributes569, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M23 10.41L21.59 9l-4.3 4.3a3 3 0 0 0-4 4L9 21.59 10.41 23l4.3-4.3a3 3 0 0 0 4-4zM17 16a1 1 0 1 1-1-1 1 1 0 0 1 1 1z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '7.5',
    r: '1.5'
  }));
});
Compass32.displayName = 'Compass32';
Compass32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Compass32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Compass24 = React.forwardRef(function (_ref570, ref) {
  var className = _ref570.className,
      children = _ref570.children,
      style = _ref570.style,
      tabIndex = _ref570.tabIndex,
      rest = _objectWithoutProperties$2(_ref570, ["className", "children", "style", "tabIndex"]);

  var _getAttributes570 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes570.tabindex,
      props = _objectWithoutProperties$2(_getAttributes570, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M23 10.41L21.59 9l-4.3 4.3a3 3 0 0 0-4 4L9 21.59 10.41 23l4.3-4.3a3 3 0 0 0 4-4zM17 16a1 1 0 1 1-1-1 1 1 0 0 1 1 1z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '7.5',
    r: '1.5'
  }));
});
Compass24.displayName = 'Compass24';
Compass24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Compass24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Compass20 = React.forwardRef(function (_ref571, ref) {
  var className = _ref571.className,
      children = _ref571.children,
      style = _ref571.style,
      tabIndex = _ref571.tabIndex,
      rest = _objectWithoutProperties$2(_ref571, ["className", "children", "style", "tabIndex"]);

  var _getAttributes571 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes571.tabindex,
      props = _objectWithoutProperties$2(_getAttributes571, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M23 10.41L21.59 9l-4.3 4.3a3 3 0 0 0-4 4L9 21.59 10.41 23l4.3-4.3a3 3 0 0 0 4-4zM17 16a1 1 0 1 1-1-1 1 1 0 0 1 1 1z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '7.5',
    r: '1.5'
  }));
});
Compass20.displayName = 'Compass20';
Compass20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Compass20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ComposerEdit32 = React.forwardRef(function (_ref572, ref) {
  var className = _ref572.className,
      children = _ref572.children,
      style = _ref572.style,
      tabIndex = _ref572.tabIndex,
      rest = _objectWithoutProperties$2(_ref572, ["className", "children", "style", "tabIndex"]);

  var _getAttributes572 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes572.tabindex,
      props = _objectWithoutProperties$2(_getAttributes572, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.82 10H30V8h-4.18a3 3 0 0 0-5.64 0H13V5H5v3H2v2h3v3h8v-3h7.18A3 3 0 0 0 22 11.82v7.32A4 4 0 0 0 19.14 22H2v2h17.14a4 4 0 0 0 7.72 0H30v-2h-3.14A4 4 0 0 0 24 19.14v-7.32A3 3 0 0 0 25.82 10zM11 11H7V7h4zm14 12a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
ComposerEdit32.displayName = 'ComposerEdit32';
ComposerEdit32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ComposerEdit32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ComposerEdit24 = React.forwardRef(function (_ref573, ref) {
  var className = _ref573.className,
      children = _ref573.children,
      style = _ref573.style,
      tabIndex = _ref573.tabIndex,
      rest = _objectWithoutProperties$2(_ref573, ["className", "children", "style", "tabIndex"]);

  var _getAttributes573 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes573.tabindex,
      props = _objectWithoutProperties$2(_getAttributes573, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.82 10H30V8h-4.18a3 3 0 0 0-5.64 0H13V5H5v3H2v2h3v3h8v-3h7.18A3 3 0 0 0 22 11.82v7.32A4 4 0 0 0 19.14 22H2v2h17.14a4 4 0 0 0 7.72 0H30v-2h-3.14A4 4 0 0 0 24 19.14v-7.32A3 3 0 0 0 25.82 10zM11 11H7V7h4zm14 12a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
ComposerEdit24.displayName = 'ComposerEdit24';
ComposerEdit24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ComposerEdit24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ComposerEdit20 = React.forwardRef(function (_ref574, ref) {
  var className = _ref574.className,
      children = _ref574.children,
      style = _ref574.style,
      tabIndex = _ref574.tabIndex,
      rest = _objectWithoutProperties$2(_ref574, ["className", "children", "style", "tabIndex"]);

  var _getAttributes574 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes574.tabindex,
      props = _objectWithoutProperties$2(_getAttributes574, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.82 10H30V8h-4.18a3 3 0 0 0-5.64 0H13V5H5v3H2v2h3v3h8v-3h7.18A3 3 0 0 0 22 11.82v7.32A4 4 0 0 0 19.14 22H2v2h17.14a4 4 0 0 0 7.72 0H30v-2h-3.14A4 4 0 0 0 24 19.14v-7.32A3 3 0 0 0 25.82 10zM11 11H7V7h4zm14 12a2 2 0 1 1-2-2 2 2 0 0 1 2 2z'
  }));
});
ComposerEdit20.displayName = 'ComposerEdit20';
ComposerEdit20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ComposerEdit20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Connect32 = React.forwardRef(function (_ref575, ref) {
  var className = _ref575.className,
      children = _ref575.children,
      style = _ref575.style,
      tabIndex = _ref575.tabIndex,
      rest = _objectWithoutProperties$2(_ref575, ["className", "children", "style", "tabIndex"]);

  var _getAttributes575 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes575.tabindex,
      props = _objectWithoutProperties$2(_getAttributes575, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 16.01a7 7 0 0 0-4.18 1.39l-4.22-4.22A6.86 6.86 0 0 0 16 9.01a7 7 0 1 0-2.81 5.59l4.21 4.22a7 7 0 1 0 5.6-2.81zm-19-7a5 5 0 1 1 5 5 5 5 0 0 1-5-5z'
  }));
});
Connect32.displayName = 'Connect32';
Connect32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Connect32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Connect24 = React.forwardRef(function (_ref576, ref) {
  var className = _ref576.className,
      children = _ref576.children,
      style = _ref576.style,
      tabIndex = _ref576.tabIndex,
      rest = _objectWithoutProperties$2(_ref576, ["className", "children", "style", "tabIndex"]);

  var _getAttributes576 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes576.tabindex,
      props = _objectWithoutProperties$2(_getAttributes576, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 16.01a7 7 0 0 0-4.18 1.39l-4.22-4.22A6.86 6.86 0 0 0 16 9.01a7 7 0 1 0-2.81 5.59l4.21 4.22a7 7 0 1 0 5.6-2.81zm-19-7a5 5 0 1 1 5 5 5 5 0 0 1-5-5z'
  }));
});
Connect24.displayName = 'Connect24';
Connect24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Connect24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Connect20 = React.forwardRef(function (_ref577, ref) {
  var className = _ref577.className,
      children = _ref577.children,
      style = _ref577.style,
      tabIndex = _ref577.tabIndex,
      rest = _objectWithoutProperties$2(_ref577, ["className", "children", "style", "tabIndex"]);

  var _getAttributes577 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes577.tabindex,
      props = _objectWithoutProperties$2(_getAttributes577, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 16.01a7 7 0 0 0-4.18 1.39l-4.22-4.22A6.86 6.86 0 0 0 16 9.01a7 7 0 1 0-2.81 5.59l4.21 4.22a7 7 0 1 0 5.6-2.81zm-19-7a5 5 0 1 1 5 5 5 5 0 0 1-5-5z'
  }));
});
Connect20.displayName = 'Connect20';
Connect20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Connect20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ConnectionSignal32 = React.forwardRef(function (_ref578, ref) {
  var className = _ref578.className,
      children = _ref578.children,
      style = _ref578.style,
      tabIndex = _ref578.tabIndex,
      rest = _objectWithoutProperties$2(_ref578, ["className", "children", "style", "tabIndex"]);

  var _getAttributes578 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes578.tabindex,
      props = _objectWithoutProperties$2(_getAttributes578, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 12h2v18h-2zm-3.67 6.22a7 7 0 0 1 0-10.44l1.34 1.49a5 5 0 0 0 0 7.46zm9.34 0l-1.34-1.49a5 5 0 0 0 0-7.46l1.34-1.49a7 7 0 0 1 0 10.44z'
  }), React.createElement('path', {
    d: 'M8.4 21.8a11 11 0 0 1 0-17.6l1.2 1.6a9 9 0 0 0 0 14.4zm15.2 0l-1.2-1.6a9 9 0 0 0 0-14.4l1.2-1.6a11 11 0 0 1 0 17.6z'
  }));
});
ConnectionSignal32.displayName = 'ConnectionSignal32';
ConnectionSignal32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ConnectionSignal32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ConnectionSignal24 = React.forwardRef(function (_ref579, ref) {
  var className = _ref579.className,
      children = _ref579.children,
      style = _ref579.style,
      tabIndex = _ref579.tabIndex,
      rest = _objectWithoutProperties$2(_ref579, ["className", "children", "style", "tabIndex"]);

  var _getAttributes579 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes579.tabindex,
      props = _objectWithoutProperties$2(_getAttributes579, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 12h2v18h-2zm-3.67 6.22a7 7 0 0 1 0-10.44l1.34 1.49a5 5 0 0 0 0 7.46zm9.34 0l-1.34-1.49a5 5 0 0 0 0-7.46l1.34-1.49a7 7 0 0 1 0 10.44z'
  }), React.createElement('path', {
    d: 'M8.4 21.8a11 11 0 0 1 0-17.6l1.2 1.6a9 9 0 0 0 0 14.4zm15.2 0l-1.2-1.6a9 9 0 0 0 0-14.4l1.2-1.6a11 11 0 0 1 0 17.6z'
  }));
});
ConnectionSignal24.displayName = 'ConnectionSignal24';
ConnectionSignal24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ConnectionSignal24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ConnectionSignal20 = React.forwardRef(function (_ref580, ref) {
  var className = _ref580.className,
      children = _ref580.children,
      style = _ref580.style,
      tabIndex = _ref580.tabIndex,
      rest = _objectWithoutProperties$2(_ref580, ["className", "children", "style", "tabIndex"]);

  var _getAttributes580 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes580.tabindex,
      props = _objectWithoutProperties$2(_getAttributes580, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 12h2v18h-2zm-3.67 6.22a7 7 0 0 1 0-10.44l1.34 1.49a5 5 0 0 0 0 7.46zm9.34 0l-1.34-1.49a5 5 0 0 0 0-7.46l1.34-1.49a7 7 0 0 1 0 10.44z'
  }), React.createElement('path', {
    d: 'M8.4 21.8a11 11 0 0 1 0-17.6l1.2 1.6a9 9 0 0 0 0 14.4zm15.2 0l-1.2-1.6a9 9 0 0 0 0-14.4l1.2-1.6a11 11 0 0 1 0 17.6z'
  }));
});
ConnectionSignal20.displayName = 'ConnectionSignal20';
ConnectionSignal20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ConnectionSignal20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Contrast32 = React.forwardRef(function (_ref581, ref) {
  var className = _ref581.className,
      children = _ref581.children,
      style = _ref581.style,
      tabIndex = _ref581.tabIndex,
      rest = _objectWithoutProperties$2(_ref581, ["className", "children", "style", "tabIndex"]);

  var _getAttributes581 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes581.tabindex,
      props = _objectWithoutProperties$2(_getAttributes581, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.37 11.84a13.6 13.6 0 0 0-1.06-2.51A14.17 14.17 0 0 0 25.9 6.1a14 14 0 1 0 0 19.8 14.17 14.17 0 0 0 2.41-3.23 13.6 13.6 0 0 0 1.06-2.51 14 14 0 0 0 0-8.32zM4 16A12 12 0 0 1 16 4v24A12 12 0 0 1 4 16z'
  }));
});
Contrast32.displayName = 'Contrast32';
Contrast32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Contrast32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Contrast24 = React.forwardRef(function (_ref582, ref) {
  var className = _ref582.className,
      children = _ref582.children,
      style = _ref582.style,
      tabIndex = _ref582.tabIndex,
      rest = _objectWithoutProperties$2(_ref582, ["className", "children", "style", "tabIndex"]);

  var _getAttributes582 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes582.tabindex,
      props = _objectWithoutProperties$2(_getAttributes582, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.37 11.84a13.6 13.6 0 0 0-1.06-2.51A14.17 14.17 0 0 0 25.9 6.1a14 14 0 1 0 0 19.8 14.17 14.17 0 0 0 2.41-3.23 13.6 13.6 0 0 0 1.06-2.51 14 14 0 0 0 0-8.32zM4 16A12 12 0 0 1 16 4v24A12 12 0 0 1 4 16z'
  }));
});
Contrast24.displayName = 'Contrast24';
Contrast24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Contrast24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Contrast20 = React.forwardRef(function (_ref583, ref) {
  var className = _ref583.className,
      children = _ref583.children,
      style = _ref583.style,
      tabIndex = _ref583.tabIndex,
      rest = _objectWithoutProperties$2(_ref583, ["className", "children", "style", "tabIndex"]);

  var _getAttributes583 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes583.tabindex,
      props = _objectWithoutProperties$2(_getAttributes583, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.37 11.84a13.6 13.6 0 0 0-1.06-2.51A14.17 14.17 0 0 0 25.9 6.1a14 14 0 1 0 0 19.8 14.17 14.17 0 0 0 2.41-3.23 13.6 13.6 0 0 0 1.06-2.51 14 14 0 0 0 0-8.32zM4 16A12 12 0 0 1 16 4v24A12 12 0 0 1 4 16z'
  }));
});
Contrast20.displayName = 'Contrast20';
Contrast20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Contrast20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CopyFile32 = React.forwardRef(function (_ref584, ref) {
  var className = _ref584.className,
      children = _ref584.children,
      style = _ref584.style,
      tabIndex = _ref584.tabIndex,
      rest = _objectWithoutProperties$2(_ref584, ["className", "children", "style", "tabIndex"]);

  var _getAttributes584 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes584.tabindex,
      props = _objectWithoutProperties$2(_getAttributes584, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.43 14.7l-6.05-6.12A2 2 0 0 0 22 8H9.94A2 2 0 0 0 8 10v18.1A2 2 0 0 0 9.94 30h18.12A2 2 0 0 0 30 28.05v-12a2 2 0 0 0-.57-1.35zM22 10l5.92 6H22zM10 28V10h10v6a2 2 0 0 0 2 2h6v10z'
  }), React.createElement('path', {
    d: 'M4 18H2V4a2 2 0 0 1 2-2h14v2H4z'
  }));
});
CopyFile32.displayName = 'CopyFile32';
CopyFile32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CopyFile32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CopyFile24 = React.forwardRef(function (_ref585, ref) {
  var className = _ref585.className,
      children = _ref585.children,
      style = _ref585.style,
      tabIndex = _ref585.tabIndex,
      rest = _objectWithoutProperties$2(_ref585, ["className", "children", "style", "tabIndex"]);

  var _getAttributes585 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes585.tabindex,
      props = _objectWithoutProperties$2(_getAttributes585, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.43 14.7l-6.05-6.12A2 2 0 0 0 22 8H9.94A2 2 0 0 0 8 10v18.1A2 2 0 0 0 9.94 30h18.12A2 2 0 0 0 30 28.05v-12a2 2 0 0 0-.57-1.35zM22 10l5.92 6H22zM10 28V10h10v6a2 2 0 0 0 2 2h6v10z'
  }), React.createElement('path', {
    d: 'M4 18H2V4a2 2 0 0 1 2-2h14v2H4z'
  }));
});
CopyFile24.displayName = 'CopyFile24';
CopyFile24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CopyFile24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CopyFile20 = React.forwardRef(function (_ref586, ref) {
  var className = _ref586.className,
      children = _ref586.children,
      style = _ref586.style,
      tabIndex = _ref586.tabIndex,
      rest = _objectWithoutProperties$2(_ref586, ["className", "children", "style", "tabIndex"]);

  var _getAttributes586 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes586.tabindex,
      props = _objectWithoutProperties$2(_getAttributes586, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.43 14.7l-6.05-6.12A2 2 0 0 0 22 8H9.94A2 2 0 0 0 8 10v18.1A2 2 0 0 0 9.94 30h18.12A2 2 0 0 0 30 28.05v-12a2 2 0 0 0-.57-1.35zM22 10l5.92 6H22zM10 28V10h10v6a2 2 0 0 0 2 2h6v10z'
  }), React.createElement('path', {
    d: 'M4 18H2V4a2 2 0 0 1 2-2h14v2H4z'
  }));
});
CopyFile20.displayName = 'CopyFile20';
CopyFile20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CopyFile20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Copy32 = React.forwardRef(function (_ref587, ref) {
  var className = _ref587.className,
      children = _ref587.children,
      style = _ref587.style,
      tabIndex = _ref587.tabIndex,
      rest = _objectWithoutProperties$2(_ref587, ["className", "children", "style", "tabIndex"]);

  var _getAttributes587 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes587.tabindex,
      props = _objectWithoutProperties$2(_getAttributes587, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10v18H10V10h18m0-2H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M4 18H2V4a2 2 0 0 1 2-2h14v2H4z'
  }));
});
Copy32.displayName = 'Copy32';
Copy32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Copy32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Copy24 = React.forwardRef(function (_ref588, ref) {
  var className = _ref588.className,
      children = _ref588.children,
      style = _ref588.style,
      tabIndex = _ref588.tabIndex,
      rest = _objectWithoutProperties$2(_ref588, ["className", "children", "style", "tabIndex"]);

  var _getAttributes588 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes588.tabindex,
      props = _objectWithoutProperties$2(_getAttributes588, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10v18H10V10h18m0-2H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M4 18H2V4a2 2 0 0 1 2-2h14v2H4z'
  }));
});
Copy24.displayName = 'Copy24';
Copy24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Copy24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Copy20 = React.forwardRef(function (_ref589, ref) {
  var className = _ref589.className,
      children = _ref589.children,
      style = _ref589.style,
      tabIndex = _ref589.tabIndex,
      rest = _objectWithoutProperties$2(_ref589, ["className", "children", "style", "tabIndex"]);

  var _getAttributes589 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes589.tabindex,
      props = _objectWithoutProperties$2(_getAttributes589, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10v18H10V10h18m0-2H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M4 18H2V4a2 2 0 0 1 2-2h14v2H4z'
  }));
});
Copy20.displayName = 'Copy20';
Copy20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Copy20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Corner32 = React.forwardRef(function (_ref590, ref) {
  var className = _ref590.className,
      children = _ref590.children,
      style = _ref590.style,
      tabIndex = _ref590.tabIndex,
      rest = _objectWithoutProperties$2(_ref590, ["className", "children", "style", "tabIndex"]);

  var _getAttributes590 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes590.tabindex,
      props = _objectWithoutProperties$2(_getAttributes590, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9H14V6H6v8h3v14h2V14h3v-3h14zm-16 3H8V8h4z'
  }));
});
Corner32.displayName = 'Corner32';
Corner32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Corner32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Corner24 = React.forwardRef(function (_ref591, ref) {
  var className = _ref591.className,
      children = _ref591.children,
      style = _ref591.style,
      tabIndex = _ref591.tabIndex,
      rest = _objectWithoutProperties$2(_ref591, ["className", "children", "style", "tabIndex"]);

  var _getAttributes591 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes591.tabindex,
      props = _objectWithoutProperties$2(_getAttributes591, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9H14V6H6v8h3v14h2V14h3v-3h14zm-16 3H8V8h4z'
  }));
});
Corner24.displayName = 'Corner24';
Corner24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Corner24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Corner20 = React.forwardRef(function (_ref592, ref) {
  var className = _ref592.className,
      children = _ref592.children,
      style = _ref592.style,
      tabIndex = _ref592.tabIndex,
      rest = _objectWithoutProperties$2(_ref592, ["className", "children", "style", "tabIndex"]);

  var _getAttributes592 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes592.tabindex,
      props = _objectWithoutProperties$2(_getAttributes592, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9H14V6H6v8h3v14h2V14h3v-3h14zm-16 3H8V8h4z'
  }));
});
Corner20.displayName = 'Corner20';
Corner20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Corner20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Crop32 = React.forwardRef(function (_ref593, ref) {
  var className = _ref593.className,
      children = _ref593.children,
      style = _ref593.style,
      tabIndex = _ref593.tabIndex,
      rest = _objectWithoutProperties$2(_ref593, ["className", "children", "style", "tabIndex"]);

  var _getAttributes593 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes593.tabindex,
      props = _objectWithoutProperties$2(_getAttributes593, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 20h-2V9H12V7h11a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M9 23V2H7v5H2v2h5v14a2 2 0 0 0 2 2h14v5h2v-5h5v-2z'
  }));
});
Crop32.displayName = 'Crop32';
Crop32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Crop32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Crop24 = React.forwardRef(function (_ref594, ref) {
  var className = _ref594.className,
      children = _ref594.children,
      style = _ref594.style,
      tabIndex = _ref594.tabIndex,
      rest = _objectWithoutProperties$2(_ref594, ["className", "children", "style", "tabIndex"]);

  var _getAttributes594 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes594.tabindex,
      props = _objectWithoutProperties$2(_getAttributes594, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 20h-2V9H12V7h11a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M9 23V2H7v5H2v2h5v14a2 2 0 0 0 2 2h14v5h2v-5h5v-2z'
  }));
});
Crop24.displayName = 'Crop24';
Crop24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Crop24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Crop20 = React.forwardRef(function (_ref595, ref) {
  var className = _ref595.className,
      children = _ref595.children,
      style = _ref595.style,
      tabIndex = _ref595.tabIndex,
      rest = _objectWithoutProperties$2(_ref595, ["className", "children", "style", "tabIndex"]);

  var _getAttributes595 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes595.tabindex,
      props = _objectWithoutProperties$2(_getAttributes595, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 20h-2V9H12V7h11a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M9 23V2H7v5H2v2h5v14a2 2 0 0 0 2 2h14v5h2v-5h5v-2z'
  }));
});
Crop20.displayName = 'Crop20';
Crop20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Crop20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cursor_132 = React.forwardRef(function (_ref596, ref) {
  var className = _ref596.className,
      children = _ref596.children,
      style = _ref596.style,
      tabIndex = _ref596.tabIndex,
      rest = _objectWithoutProperties$2(_ref596, ["className", "children", "style", "tabIndex"]);

  var _getAttributes596 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes596.tabindex,
      props = _objectWithoutProperties$2(_getAttributes596, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 28a1 1 0 0 1-.71-.29l-6.13-6.14-3.33 5a1 1 0 0 1-1 .44 1 1 0 0 1-.81-.7l-6-20A1 1 0 0 1 6.29 5l20 6a1 1 0 0 1 .7.81 1 1 0 0 1-.44 1l-5 3.33 6.14 6.13a1 1 0 0 1 0 1.42l-4 4A1 1 0 0 1 23 28zm0-2.41L25.59 23l-7.16-7.15 5.25-3.5L7.49 7.49l4.86 16.19 3.5-5.25z'
  }));
});
Cursor_132.displayName = 'Cursor_132';
Cursor_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cursor_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cursor_124 = React.forwardRef(function (_ref597, ref) {
  var className = _ref597.className,
      children = _ref597.children,
      style = _ref597.style,
      tabIndex = _ref597.tabIndex,
      rest = _objectWithoutProperties$2(_ref597, ["className", "children", "style", "tabIndex"]);

  var _getAttributes597 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes597.tabindex,
      props = _objectWithoutProperties$2(_getAttributes597, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 28a1 1 0 0 1-.71-.29l-6.13-6.14-3.33 5a1 1 0 0 1-1 .44 1 1 0 0 1-.81-.7l-6-20A1 1 0 0 1 6.29 5l20 6a1 1 0 0 1 .7.81 1 1 0 0 1-.44 1l-5 3.33 6.14 6.13a1 1 0 0 1 0 1.42l-4 4A1 1 0 0 1 23 28zm0-2.41L25.59 23l-7.16-7.15 5.25-3.5L7.49 7.49l4.86 16.19 3.5-5.25z'
  }));
});
Cursor_124.displayName = 'Cursor_124';
Cursor_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cursor_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cursor_120 = React.forwardRef(function (_ref598, ref) {
  var className = _ref598.className,
      children = _ref598.children,
      style = _ref598.style,
      tabIndex = _ref598.tabIndex,
      rest = _objectWithoutProperties$2(_ref598, ["className", "children", "style", "tabIndex"]);

  var _getAttributes598 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes598.tabindex,
      props = _objectWithoutProperties$2(_getAttributes598, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 28a1 1 0 0 1-.71-.29l-6.13-6.14-3.33 5a1 1 0 0 1-1 .44 1 1 0 0 1-.81-.7l-6-20A1 1 0 0 1 6.29 5l20 6a1 1 0 0 1 .7.81 1 1 0 0 1-.44 1l-5 3.33 6.14 6.13a1 1 0 0 1 0 1.42l-4 4A1 1 0 0 1 23 28zm0-2.41L25.59 23l-7.16-7.15 5.25-3.5L7.49 7.49l4.86 16.19 3.5-5.25z'
  }));
});
Cursor_120.displayName = 'Cursor_120';
Cursor_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cursor_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cursor_232 = React.forwardRef(function (_ref599, ref) {
  var className = _ref599.className,
      children = _ref599.children,
      style = _ref599.style,
      tabIndex = _ref599.tabIndex,
      rest = _objectWithoutProperties$2(_ref599, ["className", "children", "style", "tabIndex"]);

  var _getAttributes599 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes599.tabindex,
      props = _objectWithoutProperties$2(_getAttributes599, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.34 12.06l-22-8a1 1 0 0 0-1.28 1.28l8 22A1 1 0 0 0 13 28a1 1 0 0 0 .93-.63l3.84-9.6 9.6-3.84a1 1 0 0 0 0-1.87zm-10.71 4l-.4.16-.16.4L13 24.2 6.67 6.67 24.2 13z'
  }));
});
Cursor_232.displayName = 'Cursor_232';
Cursor_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cursor_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cursor_224 = React.forwardRef(function (_ref600, ref) {
  var className = _ref600.className,
      children = _ref600.children,
      style = _ref600.style,
      tabIndex = _ref600.tabIndex,
      rest = _objectWithoutProperties$2(_ref600, ["className", "children", "style", "tabIndex"]);

  var _getAttributes600 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes600.tabindex,
      props = _objectWithoutProperties$2(_getAttributes600, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.34 12.06l-22-8a1 1 0 0 0-1.28 1.28l8 22A1 1 0 0 0 13 28a1 1 0 0 0 .93-.63l3.84-9.6 9.6-3.84a1 1 0 0 0 0-1.87zm-10.71 4l-.4.16-.16.4L13 24.2 6.67 6.67 24.2 13z'
  }));
});
Cursor_224.displayName = 'Cursor_224';
Cursor_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cursor_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cursor_220 = React.forwardRef(function (_ref601, ref) {
  var className = _ref601.className,
      children = _ref601.children,
      style = _ref601.style,
      tabIndex = _ref601.tabIndex,
      rest = _objectWithoutProperties$2(_ref601, ["className", "children", "style", "tabIndex"]);

  var _getAttributes601 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes601.tabindex,
      props = _objectWithoutProperties$2(_getAttributes601, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.34 12.06l-22-8a1 1 0 0 0-1.28 1.28l8 22A1 1 0 0 0 13 28a1 1 0 0 0 .93-.63l3.84-9.6 9.6-3.84a1 1 0 0 0 0-1.87zm-10.71 4l-.4.16-.16.4L13 24.2 6.67 6.67 24.2 13z'
  }));
});
Cursor_220.displayName = 'Cursor_220';
Cursor_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cursor_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cut32 = React.forwardRef(function (_ref602, ref) {
  var className = _ref602.className,
      children = _ref602.children,
      style = _ref602.style,
      tabIndex = _ref602.tabIndex,
      rest = _objectWithoutProperties$2(_ref602, ["className", "children", "style", "tabIndex"]);

  var _getAttributes602 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes602.tabindex,
      props = _objectWithoutProperties$2(_getAttributes602, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.5 19.63L20.24 16l6.26-3.63a5 5 0 0 0-1.21-9.2A5.19 5.19 0 0 0 24 3a5 5 0 0 0-4.33 7.53 5 5 0 0 0 2.39 2.1l-3.82 2.21L4 6.6 3 8.34 16.24 16 3 23.68l1 1.74 14.24-8.26 3.82 2.21a5 5 0 0 0-2.39 2.1A5 5 0 0 0 24 29a5.19 5.19 0 0 0 1.29-.17 5 5 0 0 0 1.21-9.2zm-5.1-10.1a3 3 0 0 1 1.1-4.12 3 3 0 0 1 4.1 1.11 3 3 0 0 1-1.1 4.11 3 3 0 0 1-4.1-1.1zm5.2 16a3 3 0 0 1-4.1 1.11 3 3 0 0 1-1.1-4.12 3 3 0 0 1 4.1-1.1 3 3 0 0 1 1.1 4.06z'
  }));
});
Cut32.displayName = 'Cut32';
Cut32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cut32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cut24 = React.forwardRef(function (_ref603, ref) {
  var className = _ref603.className,
      children = _ref603.children,
      style = _ref603.style,
      tabIndex = _ref603.tabIndex,
      rest = _objectWithoutProperties$2(_ref603, ["className", "children", "style", "tabIndex"]);

  var _getAttributes603 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes603.tabindex,
      props = _objectWithoutProperties$2(_getAttributes603, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.5 19.63L20.24 16l6.26-3.63a5 5 0 0 0-1.21-9.2A5.19 5.19 0 0 0 24 3a5 5 0 0 0-4.33 7.53 5 5 0 0 0 2.39 2.1l-3.82 2.21L4 6.6 3 8.34 16.24 16 3 23.68l1 1.74 14.24-8.26 3.82 2.21a5 5 0 0 0-2.39 2.1A5 5 0 0 0 24 29a5.19 5.19 0 0 0 1.29-.17 5 5 0 0 0 1.21-9.2zm-5.1-10.1a3 3 0 0 1 1.1-4.12 3 3 0 0 1 4.1 1.11 3 3 0 0 1-1.1 4.11 3 3 0 0 1-4.1-1.1zm5.2 16a3 3 0 0 1-4.1 1.11 3 3 0 0 1-1.1-4.12 3 3 0 0 1 4.1-1.1 3 3 0 0 1 1.1 4.06z'
  }));
});
Cut24.displayName = 'Cut24';
Cut24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cut24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Cut20 = React.forwardRef(function (_ref604, ref) {
  var className = _ref604.className,
      children = _ref604.children,
      style = _ref604.style,
      tabIndex = _ref604.tabIndex,
      rest = _objectWithoutProperties$2(_ref604, ["className", "children", "style", "tabIndex"]);

  var _getAttributes604 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes604.tabindex,
      props = _objectWithoutProperties$2(_getAttributes604, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.5 19.63L20.24 16l6.26-3.63a5 5 0 0 0-1.21-9.2A5.19 5.19 0 0 0 24 3a5 5 0 0 0-4.33 7.53 5 5 0 0 0 2.39 2.1l-3.82 2.21L4 6.6 3 8.34 16.24 16 3 23.68l1 1.74 14.24-8.26 3.82 2.21a5 5 0 0 0-2.39 2.1A5 5 0 0 0 24 29a5.19 5.19 0 0 0 1.29-.17 5 5 0 0 0 1.21-9.2zm-5.1-10.1a3 3 0 0 1 1.1-4.12 3 3 0 0 1 4.1 1.11 3 3 0 0 1-1.1 4.11 3 3 0 0 1-4.1-1.1zm5.2 16a3 3 0 0 1-4.1 1.11 3 3 0 0 1-1.1-4.12 3 3 0 0 1 4.1-1.1 3 3 0 0 1 1.1 4.06z'
  }));
});
Cut20.displayName = 'Cut20';
Cut20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Cut20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Data_132 = React.forwardRef(function (_ref605, ref) {
  var className = _ref605.className,
      children = _ref605.children,
      style = _ref605.style,
      tabIndex = _ref605.tabIndex,
      rest = _objectWithoutProperties$2(_ref605, ["className", "children", "style", "tabIndex"]);

  var _getAttributes605 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes605.tabindex,
      props = _objectWithoutProperties$2(_getAttributes605, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 6h13v2H15zm0 18h13v2H15zM4 15h13v2H4zm3-4a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm0 24a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm18-3a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Data_132.displayName = 'Data_132';
Data_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Data_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Data_124 = React.forwardRef(function (_ref606, ref) {
  var className = _ref606.className,
      children = _ref606.children,
      style = _ref606.style,
      tabIndex = _ref606.tabIndex,
      rest = _objectWithoutProperties$2(_ref606, ["className", "children", "style", "tabIndex"]);

  var _getAttributes606 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes606.tabindex,
      props = _objectWithoutProperties$2(_getAttributes606, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 6h13v2H15zm0 18h13v2H15zM4 15h13v2H4zm3-4a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm0 24a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm18-3a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Data_124.displayName = 'Data_124';
Data_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Data_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Data_120 = React.forwardRef(function (_ref607, ref) {
  var className = _ref607.className,
      children = _ref607.children,
      style = _ref607.style,
      tabIndex = _ref607.tabIndex,
      rest = _objectWithoutProperties$2(_ref607, ["className", "children", "style", "tabIndex"]);

  var _getAttributes607 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes607.tabindex,
      props = _objectWithoutProperties$2(_getAttributes607, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 6h13v2H15zm0 18h13v2H15zM4 15h13v2H4zm3-4a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm0 24a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm18-3a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Data_120.displayName = 'Data_120';
Data_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Data_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Data_232 = React.forwardRef(function (_ref608, ref) {
  var className = _ref608.className,
      children = _ref608.children,
      style = _ref608.style,
      tabIndex = _ref608.tabIndex,
      rest = _objectWithoutProperties$2(_ref608, ["className", "children", "style", "tabIndex"]);

  var _getAttributes608 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes608.tabindex,
      props = _objectWithoutProperties$2(_getAttributes608, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h11v2H4zm14 0h10v2H18zm3 6h7v2h-7zm-10 0h7v2h-7zm-7 0h4v2H4zm0 6h24v2H4zm0 6h17v2H4zm20 0h4v2h-4z'
  }));
});
Data_232.displayName = 'Data_232';
Data_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Data_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Data_224 = React.forwardRef(function (_ref609, ref) {
  var className = _ref609.className,
      children = _ref609.children,
      style = _ref609.style,
      tabIndex = _ref609.tabIndex,
      rest = _objectWithoutProperties$2(_ref609, ["className", "children", "style", "tabIndex"]);

  var _getAttributes609 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes609.tabindex,
      props = _objectWithoutProperties$2(_getAttributes609, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h11v2H4zm14 0h10v2H18zm3 6h7v2h-7zm-10 0h7v2h-7zm-7 0h4v2H4zm0 6h24v2H4zm0 6h17v2H4zm20 0h4v2h-4z'
  }));
});
Data_224.displayName = 'Data_224';
Data_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Data_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Data_220 = React.forwardRef(function (_ref610, ref) {
  var className = _ref610.className,
      children = _ref610.children,
      style = _ref610.style,
      tabIndex = _ref610.tabIndex,
      rest = _objectWithoutProperties$2(_ref610, ["className", "children", "style", "tabIndex"]);

  var _getAttributes610 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes610.tabindex,
      props = _objectWithoutProperties$2(_getAttributes610, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h11v2H4zm14 0h10v2H18zm3 6h7v2h-7zm-10 0h7v2h-7zm-7 0h4v2H4zm0 6h24v2H4zm0 6h17v2H4zm20 0h4v2h-4z'
  }));
});
Data_220.displayName = 'Data_220';
Data_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Data_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataBase32 = React.forwardRef(function (_ref611, ref) {
  var className = _ref611.className,
      children = _ref611.children,
      style = _ref611.style,
      tabIndex = _ref611.tabIndex,
      rest = _objectWithoutProperties$2(_ref611, ["className", "children", "style", "tabIndex"]);

  var _getAttributes611 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes611.tabindex,
      props = _objectWithoutProperties$2(_getAttributes611, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v6H8V5zM8 19v-6h16v6zm0 8v-6h16v6z'
  }), React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }));
});
DataBase32.displayName = 'DataBase32';
DataBase32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataBase32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataBase24 = React.forwardRef(function (_ref612, ref) {
  var className = _ref612.className,
      children = _ref612.children,
      style = _ref612.style,
      tabIndex = _ref612.tabIndex,
      rest = _objectWithoutProperties$2(_ref612, ["className", "children", "style", "tabIndex"]);

  var _getAttributes612 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes612.tabindex,
      props = _objectWithoutProperties$2(_getAttributes612, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v6H8V5zM8 19v-6h16v6zm0 8v-6h16v6z'
  }), React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }));
});
DataBase24.displayName = 'DataBase24';
DataBase24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataBase24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataBase20 = React.forwardRef(function (_ref613, ref) {
  var className = _ref613.className,
      children = _ref613.children,
      style = _ref613.style,
      tabIndex = _ref613.tabIndex,
      rest = _objectWithoutProperties$2(_ref613, ["className", "children", "style", "tabIndex"]);

  var _getAttributes613 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes613.tabindex,
      props = _objectWithoutProperties$2(_getAttributes613, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v6H8V5zM8 19v-6h16v6zm0 8v-6h16v6z'
  }), React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }));
});
DataBase20.displayName = 'DataBase20';
DataBase20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataBase20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataCheck32 = React.forwardRef(function (_ref614, ref) {
  var className = _ref614.className,
      children = _ref614.children,
      style = _ref614.style,
      tabIndex = _ref614.tabIndex,
      rest = _objectWithoutProperties$2(_ref614, ["className", "children", "style", "tabIndex"]);

  var _getAttributes614 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes614.tabindex,
      props = _objectWithoutProperties$2(_getAttributes614, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 27.18l-2.59-2.59L19 26l4 4 7-7-1.41-1.41L23 27.18z'
  }), React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }), React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h8v-2H8v-6h18V5a2 2 0 0 0-2-2zm0 16H8v-6h16zm0-8H8V5h16z'
  }));
});
DataCheck32.displayName = 'DataCheck32';
DataCheck32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataCheck32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataCheck24 = React.forwardRef(function (_ref615, ref) {
  var className = _ref615.className,
      children = _ref615.children,
      style = _ref615.style,
      tabIndex = _ref615.tabIndex,
      rest = _objectWithoutProperties$2(_ref615, ["className", "children", "style", "tabIndex"]);

  var _getAttributes615 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes615.tabindex,
      props = _objectWithoutProperties$2(_getAttributes615, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 27.18l-2.59-2.59L19 26l4 4 7-7-1.41-1.41L23 27.18z'
  }), React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }), React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h8v-2H8v-6h18V5a2 2 0 0 0-2-2zm0 16H8v-6h16zm0-8H8V5h16z'
  }));
});
DataCheck24.displayName = 'DataCheck24';
DataCheck24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataCheck24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataCheck20 = React.forwardRef(function (_ref616, ref) {
  var className = _ref616.className,
      children = _ref616.children,
      style = _ref616.style,
      tabIndex = _ref616.tabIndex,
      rest = _objectWithoutProperties$2(_ref616, ["className", "children", "style", "tabIndex"]);

  var _getAttributes616 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes616.tabindex,
      props = _objectWithoutProperties$2(_getAttributes616, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 27.18l-2.59-2.59L19 26l4 4 7-7-1.41-1.41L23 27.18z'
  }), React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }), React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h8v-2H8v-6h18V5a2 2 0 0 0-2-2zm0 16H8v-6h16zm0-8H8V5h16z'
  }));
});
DataCheck20.displayName = 'DataCheck20';
DataCheck20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataCheck20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataConnected32 = React.forwardRef(function (_ref617, ref) {
  var className = _ref617.className,
      children = _ref617.children,
      style = _ref617.style,
      tabIndex = _ref617.tabIndex,
      rest = _objectWithoutProperties$2(_ref617, ["className", "children", "style", "tabIndex"]);

  var _getAttributes617 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes617.tabindex,
      props = _objectWithoutProperties$2(_getAttributes617, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30h-6v-2h4V4h-4V2h6v28z'
  }), React.createElement('path', {
    d: 'M24.91 19.59a4.51 4.51 0 0 0-2.66-3.24 4.55 4.55 0 0 0-3.5 0 4.94 4.94 0 0 0-.64.35l-2.81-2.81a4.53 4.53 0 1 0-1.41 1.41l2.81 2.81a4.48 4.48 0 0 0-.61 3.3 4.51 4.51 0 0 0 2.66 3.24 4.55 4.55 0 0 0 3.5 0 4.51 4.51 0 0 0 2.66-3.24 4.65 4.65 0 0 0 0-1.82zM11.5 14a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z'
  }), React.createElement('path', {
    d: 'M8 30H2V2h6v2H4v24h4v2z'
  }));
});
DataConnected32.displayName = 'DataConnected32';
DataConnected32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataConnected32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataConnected24 = React.forwardRef(function (_ref618, ref) {
  var className = _ref618.className,
      children = _ref618.children,
      style = _ref618.style,
      tabIndex = _ref618.tabIndex,
      rest = _objectWithoutProperties$2(_ref618, ["className", "children", "style", "tabIndex"]);

  var _getAttributes618 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes618.tabindex,
      props = _objectWithoutProperties$2(_getAttributes618, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30h-6v-2h4V4h-4V2h6v28z'
  }), React.createElement('path', {
    d: 'M24.91 19.59a4.51 4.51 0 0 0-2.66-3.24 4.55 4.55 0 0 0-3.5 0 4.94 4.94 0 0 0-.64.35l-2.81-2.81a4.53 4.53 0 1 0-1.41 1.41l2.81 2.81a4.48 4.48 0 0 0-.61 3.3 4.51 4.51 0 0 0 2.66 3.24 4.55 4.55 0 0 0 3.5 0 4.51 4.51 0 0 0 2.66-3.24 4.65 4.65 0 0 0 0-1.82zM11.5 14a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z'
  }), React.createElement('path', {
    d: 'M8 30H2V2h6v2H4v24h4v2z'
  }));
});
DataConnected24.displayName = 'DataConnected24';
DataConnected24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataConnected24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataConnected20 = React.forwardRef(function (_ref619, ref) {
  var className = _ref619.className,
      children = _ref619.children,
      style = _ref619.style,
      tabIndex = _ref619.tabIndex,
      rest = _objectWithoutProperties$2(_ref619, ["className", "children", "style", "tabIndex"]);

  var _getAttributes619 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes619.tabindex,
      props = _objectWithoutProperties$2(_getAttributes619, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 30h-6v-2h4V4h-4V2h6v28z'
  }), React.createElement('path', {
    d: 'M24.91 19.59a4.51 4.51 0 0 0-2.66-3.24 4.55 4.55 0 0 0-3.5 0 4.94 4.94 0 0 0-.64.35l-2.81-2.81a4.53 4.53 0 1 0-1.41 1.41l2.81 2.81a4.48 4.48 0 0 0-.61 3.3 4.51 4.51 0 0 0 2.66 3.24 4.55 4.55 0 0 0 3.5 0 4.51 4.51 0 0 0 2.66-3.24 4.65 4.65 0 0 0 0-1.82zM11.5 14a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z'
  }), React.createElement('path', {
    d: 'M8 30H2V2h6v2H4v24h4v2z'
  }));
});
DataConnected20.displayName = 'DataConnected20';
DataConnected20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataConnected20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataError32 = React.forwardRef(function (_ref620, ref) {
  var className = _ref620.className,
      children = _ref620.children,
      style = _ref620.style,
      tabIndex = _ref620.tabIndex,
      rest = _objectWithoutProperties$2(_ref620, ["className", "children", "style", "tabIndex"]);

  var _getAttributes620 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes620.tabindex,
      props = _objectWithoutProperties$2(_getAttributes620, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }), React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h8v-2H8v-6h18V5a2 2 0 0 0-2-2zm0 16H8v-6h16zm0-8H8V5h16z'
  }), React.createElement('path', {
    d: 'M29.24 29.58l-2.83-2.83 2.83-2.83-1.41-1.41L25 25.33l-2.83-2.82-1.41 1.41 2.83 2.83-2.83 2.83 1.41 1.41L25 28.16l2.83 2.83 1.41-1.41z'
  }));
});
DataError32.displayName = 'DataError32';
DataError32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataError32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataError24 = React.forwardRef(function (_ref621, ref) {
  var className = _ref621.className,
      children = _ref621.children,
      style = _ref621.style,
      tabIndex = _ref621.tabIndex,
      rest = _objectWithoutProperties$2(_ref621, ["className", "children", "style", "tabIndex"]);

  var _getAttributes621 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes621.tabindex,
      props = _objectWithoutProperties$2(_getAttributes621, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }), React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h8v-2H8v-6h18V5a2 2 0 0 0-2-2zm0 16H8v-6h16zm0-8H8V5h16z'
  }), React.createElement('path', {
    d: 'M29.24 29.58l-2.83-2.83 2.83-2.83-1.41-1.41L25 25.33l-2.83-2.82-1.41 1.41 2.83 2.83-2.83 2.83 1.41 1.41L25 28.16l2.83 2.83 1.41-1.41z'
  }));
});
DataError24.displayName = 'DataError24';
DataError24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataError24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataError20 = React.forwardRef(function (_ref622, ref) {
  var className = _ref622.className,
      children = _ref622.children,
      style = _ref622.style,
      tabIndex = _ref622.tabIndex,
      rest = _objectWithoutProperties$2(_ref622, ["className", "children", "style", "tabIndex"]);

  var _getAttributes622 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes622.tabindex,
      props = _objectWithoutProperties$2(_getAttributes622, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '11',
    cy: '8',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '11',
    cy: '24',
    r: '1'
  }), React.createElement('path', {
    d: 'M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h8v-2H8v-6h18V5a2 2 0 0 0-2-2zm0 16H8v-6h16zm0-8H8V5h16z'
  }), React.createElement('path', {
    d: 'M29.24 29.58l-2.83-2.83 2.83-2.83-1.41-1.41L25 25.33l-2.83-2.82-1.41 1.41 2.83 2.83-2.83 2.83 1.41 1.41L25 28.16l2.83 2.83 1.41-1.41z'
  }));
});
DataError20.displayName = 'DataError20';
DataError20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataError20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataSet32 = React.forwardRef(function (_ref623, ref) {
  var className = _ref623.className,
      children = _ref623.children,
      style = _ref623.style,
      tabIndex = _ref623.tabIndex,
      rest = _objectWithoutProperties$2(_ref623, ["className", "children", "style", "tabIndex"]);

  var _getAttributes623 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes623.tabindex,
      props = _objectWithoutProperties$2(_getAttributes623, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zM8.5 6A3.5 3.5 0 1 1 5 9.5 3.5 3.5 0 0 1 8.5 6m0-2A5.5 5.5 0 1 0 14 9.5 5.5 5.5 0 0 0 8.5 4zm0 16A3.5 3.5 0 1 1 5 23.5 3.5 3.5 0 0 1 8.5 20m0-2a5.5 5.5 0 1 0 5.5 5.5A5.5 5.5 0 0 0 8.5 18zm15 2a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5z'
  }));
});
DataSet32.displayName = 'DataSet32';
DataSet32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataSet32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataSet24 = React.forwardRef(function (_ref624, ref) {
  var className = _ref624.className,
      children = _ref624.children,
      style = _ref624.style,
      tabIndex = _ref624.tabIndex,
      rest = _objectWithoutProperties$2(_ref624, ["className", "children", "style", "tabIndex"]);

  var _getAttributes624 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes624.tabindex,
      props = _objectWithoutProperties$2(_getAttributes624, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zM8.5 6A3.5 3.5 0 1 1 5 9.5 3.5 3.5 0 0 1 8.5 6m0-2A5.5 5.5 0 1 0 14 9.5 5.5 5.5 0 0 0 8.5 4zm0 16A3.5 3.5 0 1 1 5 23.5 3.5 3.5 0 0 1 8.5 20m0-2a5.5 5.5 0 1 0 5.5 5.5A5.5 5.5 0 0 0 8.5 18zm15 2a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5z'
  }));
});
DataSet24.displayName = 'DataSet24';
DataSet24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataSet24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataSet20 = React.forwardRef(function (_ref625, ref) {
  var className = _ref625.className,
      children = _ref625.children,
      style = _ref625.style,
      tabIndex = _ref625.tabIndex,
      rest = _objectWithoutProperties$2(_ref625, ["className", "children", "style", "tabIndex"]);

  var _getAttributes625 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes625.tabindex,
      props = _objectWithoutProperties$2(_getAttributes625, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zM8.5 6A3.5 3.5 0 1 1 5 9.5 3.5 3.5 0 0 1 8.5 6m0-2A5.5 5.5 0 1 0 14 9.5 5.5 5.5 0 0 0 8.5 4zm0 16A3.5 3.5 0 1 1 5 23.5 3.5 3.5 0 0 1 8.5 20m0-2a5.5 5.5 0 1 0 5.5 5.5A5.5 5.5 0 0 0 8.5 18zm15 2a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5z'
  }));
});
DataSet20.displayName = 'DataSet20';
DataSet20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataSet20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataStructured32 = React.forwardRef(function (_ref626, ref) {
  var className = _ref626.className,
      children = _ref626.children,
      style = _ref626.style,
      tabIndex = _ref626.tabIndex,
      rest = _objectWithoutProperties$2(_ref626, ["className", "children", "style", "tabIndex"]);

  var _getAttributes626 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes626.tabindex,
      props = _objectWithoutProperties$2(_getAttributes626, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '9',
    cy: '7',
    r: '1'
  }), React.createElement('path', {
    d: 'M27 22.14V18a2 2 0 0 0-2-2h-8v-4h9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v4H7a2 2 0 0 0-2 2v4.14a4 4 0 1 0 2 0V18h8v4h-3v8h8v-8h-3v-4h8v4.14a4 4 0 1 0 2 0zM8 26a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm10-2v4h-4v-4zM6 10V4h20v6zm20 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
DataStructured32.displayName = 'DataStructured32';
DataStructured32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataStructured32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataStructured24 = React.forwardRef(function (_ref627, ref) {
  var className = _ref627.className,
      children = _ref627.children,
      style = _ref627.style,
      tabIndex = _ref627.tabIndex,
      rest = _objectWithoutProperties$2(_ref627, ["className", "children", "style", "tabIndex"]);

  var _getAttributes627 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes627.tabindex,
      props = _objectWithoutProperties$2(_getAttributes627, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '9',
    cy: '7',
    r: '1'
  }), React.createElement('path', {
    d: 'M27 22.14V18a2 2 0 0 0-2-2h-8v-4h9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v4H7a2 2 0 0 0-2 2v4.14a4 4 0 1 0 2 0V18h8v4h-3v8h8v-8h-3v-4h8v4.14a4 4 0 1 0 2 0zM8 26a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm10-2v4h-4v-4zM6 10V4h20v6zm20 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
DataStructured24.displayName = 'DataStructured24';
DataStructured24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataStructured24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataStructured20 = React.forwardRef(function (_ref628, ref) {
  var className = _ref628.className,
      children = _ref628.children,
      style = _ref628.style,
      tabIndex = _ref628.tabIndex,
      rest = _objectWithoutProperties$2(_ref628, ["className", "children", "style", "tabIndex"]);

  var _getAttributes628 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes628.tabindex,
      props = _objectWithoutProperties$2(_getAttributes628, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '9',
    cy: '7',
    r: '1'
  }), React.createElement('path', {
    d: 'M27 22.14V18a2 2 0 0 0-2-2h-8v-4h9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v4H7a2 2 0 0 0-2 2v4.14a4 4 0 1 0 2 0V18h8v4h-3v8h8v-8h-3v-4h8v4.14a4 4 0 1 0 2 0zM8 26a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm10-2v4h-4v-4zM6 10V4h20v6zm20 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
DataStructured20.displayName = 'DataStructured20';
DataStructured20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataStructured20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataUnstructured32 = React.forwardRef(function (_ref629, ref) {
  var className = _ref629.className,
      children = _ref629.children,
      style = _ref629.style,
      tabIndex = _ref629.tabIndex,
      rest = _objectWithoutProperties$2(_ref629, ["className", "children", "style", "tabIndex"]);

  var _getAttributes629 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes629.tabindex,
      props = _objectWithoutProperties$2(_getAttributes629, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 24a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zM16 4a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm10 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm-8 22v4h-4v-4h4m2-2h-8v8h8z'
  }), React.createElement('path', {
    d: 'M27 22.14V17a2 2 0 0 0-2-2H7v-5h3V2H2v8h3v5a2 2 0 0 0 2 2h18v5.14a4 4 0 1 0 2 0zM4 4h4v4H4zm22 24a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
DataUnstructured32.displayName = 'DataUnstructured32';
DataUnstructured32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataUnstructured32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataUnstructured24 = React.forwardRef(function (_ref630, ref) {
  var className = _ref630.className,
      children = _ref630.children,
      style = _ref630.style,
      tabIndex = _ref630.tabIndex,
      rest = _objectWithoutProperties$2(_ref630, ["className", "children", "style", "tabIndex"]);

  var _getAttributes630 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes630.tabindex,
      props = _objectWithoutProperties$2(_getAttributes630, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 24a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zM16 4a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm10 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm-8 22v4h-4v-4h4m2-2h-8v8h8z'
  }), React.createElement('path', {
    d: 'M27 22.14V17a2 2 0 0 0-2-2H7v-5h3V2H2v8h3v5a2 2 0 0 0 2 2h18v5.14a4 4 0 1 0 2 0zM4 4h4v4H4zm22 24a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
DataUnstructured24.displayName = 'DataUnstructured24';
DataUnstructured24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataUnstructured24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DataUnstructured20 = React.forwardRef(function (_ref631, ref) {
  var className = _ref631.className,
      children = _ref631.children,
      style = _ref631.style,
      tabIndex = _ref631.tabIndex,
      rest = _objectWithoutProperties$2(_ref631, ["className", "children", "style", "tabIndex"]);

  var _getAttributes631 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes631.tabindex,
      props = _objectWithoutProperties$2(_getAttributes631, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 24a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zM16 4a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm10 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm-8 22v4h-4v-4h4m2-2h-8v8h8z'
  }), React.createElement('path', {
    d: 'M27 22.14V17a2 2 0 0 0-2-2H7v-5h3V2H2v8h3v5a2 2 0 0 0 2 2h18v5.14a4 4 0 1 0 2 0zM4 4h4v4H4zm22 24a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
DataUnstructured20.displayName = 'DataUnstructured20';
DataUnstructured20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DataUnstructured20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Debug32 = React.forwardRef(function (_ref632, ref) {
  var className = _ref632.className,
      children = _ref632.children,
      style = _ref632.style,
      tabIndex = _ref632.tabIndex,
      rest = _objectWithoutProperties$2(_ref632, ["className", "children", "style", "tabIndex"]);

  var _getAttributes632 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes632.tabindex,
      props = _objectWithoutProperties$2(_getAttributes632, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.83 20l.34-2-5.17-.85v-4.38l5.06-1.36-.51-1.93-4.83 1.29A9 9 0 0 0 20 5V2h-2v2.23a8.81 8.81 0 0 0-4 0V2h-2v3a9 9 0 0 0-4.71 5.82L2.46 9.48 2 11.41l5 1.36v4.38L1.84 18l.32 2L7 19.18a8.9 8.9 0 0 0 .82 3.57l-4.53 4.54 1.42 1.42 4.19-4.2a9 9 0 0 0 14.2 0l4.19 4.2 1.42-1.42-4.54-4.54a8.9 8.9 0 0 0 .83-3.57zM15 25.92A7 7 0 0 1 9 19v-6h6zM9.29 11a7 7 0 0 1 13.42 0zM23 19a7 7 0 0 1-6 6.92V13h6z'
  }));
});
Debug32.displayName = 'Debug32';
Debug32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Debug32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Debug24 = React.forwardRef(function (_ref633, ref) {
  var className = _ref633.className,
      children = _ref633.children,
      style = _ref633.style,
      tabIndex = _ref633.tabIndex,
      rest = _objectWithoutProperties$2(_ref633, ["className", "children", "style", "tabIndex"]);

  var _getAttributes633 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes633.tabindex,
      props = _objectWithoutProperties$2(_getAttributes633, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.83 20l.34-2-5.17-.85v-4.38l5.06-1.36-.51-1.93-4.83 1.29A9 9 0 0 0 20 5V2h-2v2.23a8.81 8.81 0 0 0-4 0V2h-2v3a9 9 0 0 0-4.71 5.82L2.46 9.48 2 11.41l5 1.36v4.38L1.84 18l.32 2L7 19.18a8.9 8.9 0 0 0 .82 3.57l-4.53 4.54 1.42 1.42 4.19-4.2a9 9 0 0 0 14.2 0l4.19 4.2 1.42-1.42-4.54-4.54a8.9 8.9 0 0 0 .83-3.57zM15 25.92A7 7 0 0 1 9 19v-6h6zM9.29 11a7 7 0 0 1 13.42 0zM23 19a7 7 0 0 1-6 6.92V13h6z'
  }));
});
Debug24.displayName = 'Debug24';
Debug24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Debug24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Debug20 = React.forwardRef(function (_ref634, ref) {
  var className = _ref634.className,
      children = _ref634.children,
      style = _ref634.style,
      tabIndex = _ref634.tabIndex,
      rest = _objectWithoutProperties$2(_ref634, ["className", "children", "style", "tabIndex"]);

  var _getAttributes634 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes634.tabindex,
      props = _objectWithoutProperties$2(_getAttributes634, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.83 20l.34-2-5.17-.85v-4.38l5.06-1.36-.51-1.93-4.83 1.29A9 9 0 0 0 20 5V2h-2v2.23a8.81 8.81 0 0 0-4 0V2h-2v3a9 9 0 0 0-4.71 5.82L2.46 9.48 2 11.41l5 1.36v4.38L1.84 18l.32 2L7 19.18a8.9 8.9 0 0 0 .82 3.57l-4.53 4.54 1.42 1.42 4.19-4.2a9 9 0 0 0 14.2 0l4.19 4.2 1.42-1.42-4.54-4.54a8.9 8.9 0 0 0 .83-3.57zM15 25.92A7 7 0 0 1 9 19v-6h6zM9.29 11a7 7 0 0 1 13.42 0zM23 19a7 7 0 0 1-6 6.92V13h6z'
  }));
});
Debug20.displayName = 'Debug20';
Debug20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Debug20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DeliveryTruck32 = React.forwardRef(function (_ref635, ref) {
  var className = _ref635.className,
      children = _ref635.children,
      style = _ref635.style,
      tabIndex = _ref635.tabIndex,
      rest = _objectWithoutProperties$2(_ref635, ["className", "children", "style", "tabIndex"]);

  var _getAttributes635 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes635.tabindex,
      props = _objectWithoutProperties$2(_getAttributes635, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.92 16.61l-3-7A1 1 0 0 0 26 9h-3V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7a1 1 0 0 0-.08-.39zM23 11h2.34l2.14 5H23zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10.14-3h-6.28a4 4 0 0 0-7.72 0H4V8h17v12.56A4 4 0 0 0 19.14 23zM23 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14A4 4 0 0 0 23 20v-2h5z'
  }));
});
DeliveryTruck32.displayName = 'DeliveryTruck32';
DeliveryTruck32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DeliveryTruck32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DeliveryTruck24 = React.forwardRef(function (_ref636, ref) {
  var className = _ref636.className,
      children = _ref636.children,
      style = _ref636.style,
      tabIndex = _ref636.tabIndex,
      rest = _objectWithoutProperties$2(_ref636, ["className", "children", "style", "tabIndex"]);

  var _getAttributes636 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes636.tabindex,
      props = _objectWithoutProperties$2(_getAttributes636, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.92 16.61l-3-7A1 1 0 0 0 26 9h-3V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7a1 1 0 0 0-.08-.39zM23 11h2.34l2.14 5H23zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10.14-3h-6.28a4 4 0 0 0-7.72 0H4V8h17v12.56A4 4 0 0 0 19.14 23zM23 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14A4 4 0 0 0 23 20v-2h5z'
  }));
});
DeliveryTruck24.displayName = 'DeliveryTruck24';
DeliveryTruck24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DeliveryTruck24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DeliveryTruck20 = React.forwardRef(function (_ref637, ref) {
  var className = _ref637.className,
      children = _ref637.children,
      style = _ref637.style,
      tabIndex = _ref637.tabIndex,
      rest = _objectWithoutProperties$2(_ref637, ["className", "children", "style", "tabIndex"]);

  var _getAttributes637 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes637.tabindex,
      props = _objectWithoutProperties$2(_getAttributes637, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.92 16.61l-3-7A1 1 0 0 0 26 9h-3V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7a1 1 0 0 0-.08-.39zM23 11h2.34l2.14 5H23zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10.14-3h-6.28a4 4 0 0 0-7.72 0H4V8h17v12.56A4 4 0 0 0 19.14 23zM23 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14A4 4 0 0 0 23 20v-2h5z'
  }));
});
DeliveryTruck20.displayName = 'DeliveryTruck20';
DeliveryTruck20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DeliveryTruck20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Departure32 = React.forwardRef(function (_ref638, ref) {
  var className = _ref638.className,
      children = _ref638.children,
      style = _ref638.style,
      tabIndex = _ref638.tabIndex,
      rest = _objectWithoutProperties$2(_ref638, ["className", "children", "style", "tabIndex"]);

  var _getAttributes638 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes638.tabindex,
      props = _objectWithoutProperties$2(_getAttributes638, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 0 1 1.12 0A1.84 1.84 0 0 1 28.23 14 1.87 1.87 0 0 1 27 16.45l-18.71 5a1.78 1.78 0 0 1-1 0A1.87 1.87 0 0 1 6 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39 2.3 3.1.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93-2.26-8.36 1.4-.37M14.16 3a1.06 1.06 0 0 0-.5 0l-3.09.83A1 1 0 0 0 9.89 5l2.5 9.36-2.81.75-2.73-3.61a1 1 0 0 0-.52-.36 1.06 1.06 0 0 0-.5 0L2.72 12A1 1 0 0 0 2 13.16l1 3.74.75 2.8.25.94a3.87 3.87 0 0 0 2.74 2.74 3.91 3.91 0 0 0 2 0l18.7-5a3.84 3.84 0 0 0 0-7.44 4.27 4.27 0 0 0-2.16 0l-4.51 1.21-6.07-8.74a1 1 0 0 0-.54-.41z'
  }));
});
Departure32.displayName = 'Departure32';
Departure32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Departure32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Departure24 = React.forwardRef(function (_ref639, ref) {
  var className = _ref639.className,
      children = _ref639.children,
      style = _ref639.style,
      tabIndex = _ref639.tabIndex,
      rest = _objectWithoutProperties$2(_ref639, ["className", "children", "style", "tabIndex"]);

  var _getAttributes639 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes639.tabindex,
      props = _objectWithoutProperties$2(_getAttributes639, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 0 1 1.12 0A1.84 1.84 0 0 1 28.23 14 1.87 1.87 0 0 1 27 16.45l-18.71 5a1.78 1.78 0 0 1-1 0A1.87 1.87 0 0 1 6 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39 2.3 3.1.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93-2.26-8.36 1.4-.37M14.16 3a1.06 1.06 0 0 0-.5 0l-3.09.83A1 1 0 0 0 9.89 5l2.5 9.36-2.81.75-2.73-3.61a1 1 0 0 0-.52-.36 1.06 1.06 0 0 0-.5 0L2.72 12A1 1 0 0 0 2 13.16l1 3.74.75 2.8.25.94a3.87 3.87 0 0 0 2.74 2.74 3.91 3.91 0 0 0 2 0l18.7-5a3.84 3.84 0 0 0 0-7.44 4.27 4.27 0 0 0-2.16 0l-4.51 1.21-6.07-8.74a1 1 0 0 0-.54-.41z'
  }));
});
Departure24.displayName = 'Departure24';
Departure24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Departure24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Departure20 = React.forwardRef(function (_ref640, ref) {
  var className = _ref640.className,
      children = _ref640.children,
      style = _ref640.style,
      tabIndex = _ref640.tabIndex,
      rest = _objectWithoutProperties$2(_ref640, ["className", "children", "style", "tabIndex"]);

  var _getAttributes640 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes640.tabindex,
      props = _objectWithoutProperties$2(_getAttributes640, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 0 1 1.12 0A1.84 1.84 0 0 1 28.23 14 1.87 1.87 0 0 1 27 16.45l-18.71 5a1.78 1.78 0 0 1-1 0A1.87 1.87 0 0 1 6 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39 2.3 3.1.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93-2.26-8.36 1.4-.37M14.16 3a1.06 1.06 0 0 0-.5 0l-3.09.83A1 1 0 0 0 9.89 5l2.5 9.36-2.81.75-2.73-3.61a1 1 0 0 0-.52-.36 1.06 1.06 0 0 0-.5 0L2.72 12A1 1 0 0 0 2 13.16l1 3.74.75 2.8.25.94a3.87 3.87 0 0 0 2.74 2.74 3.91 3.91 0 0 0 2 0l18.7-5a3.84 3.84 0 0 0 0-7.44 4.27 4.27 0 0 0-2.16 0l-4.51 1.21-6.07-8.74a1 1 0 0 0-.54-.41z'
  }));
});
Departure20.displayName = 'Departure20';
Departure20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Departure20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DeployRules32 = React.forwardRef(function (_ref641, ref) {
  var className = _ref641.className,
      children = _ref641.children,
      style = _ref641.style,
      tabIndex = _ref641.tabIndex,
      rest = _objectWithoutProperties$2(_ref641, ["className", "children", "style", "tabIndex"]);

  var _getAttributes641 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes641.tabindex,
      props = _objectWithoutProperties$2(_getAttributes641, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 4l-6 6 1.41 1.41L17 7.83V20h2V7.83l3.59 3.58L24 10l-6-6zM8 18h7v2H8zm0 4h16v2H8zm0 4h16v2H8z'
  }));
});
DeployRules32.displayName = 'DeployRules32';
DeployRules32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DeployRules32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DeployRules24 = React.forwardRef(function (_ref642, ref) {
  var className = _ref642.className,
      children = _ref642.children,
      style = _ref642.style,
      tabIndex = _ref642.tabIndex,
      rest = _objectWithoutProperties$2(_ref642, ["className", "children", "style", "tabIndex"]);

  var _getAttributes642 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes642.tabindex,
      props = _objectWithoutProperties$2(_getAttributes642, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 4l-6 6 1.41 1.41L17 7.83V20h2V7.83l3.59 3.58L24 10l-6-6zM8 18h7v2H8zm0 4h16v2H8zm0 4h16v2H8z'
  }));
});
DeployRules24.displayName = 'DeployRules24';
DeployRules24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DeployRules24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DeployRules20 = React.forwardRef(function (_ref643, ref) {
  var className = _ref643.className,
      children = _ref643.children,
      style = _ref643.style,
      tabIndex = _ref643.tabIndex,
      rest = _objectWithoutProperties$2(_ref643, ["className", "children", "style", "tabIndex"]);

  var _getAttributes643 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes643.tabindex,
      props = _objectWithoutProperties$2(_getAttributes643, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 4l-6 6 1.41 1.41L17 7.83V20h2V7.83l3.59 3.58L24 10l-6-6zM8 18h7v2H8zm0 4h16v2H8zm0 4h16v2H8z'
  }));
});
DeployRules20.displayName = 'DeployRules20';
DeployRules20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DeployRules20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Development32 = React.forwardRef(function (_ref644, ref) {
  var className = _ref644.className,
      children = _ref644.children,
      style = _ref644.style,
      tabIndex = _ref644.tabIndex,
      rest = _objectWithoutProperties$2(_ref644, ["className", "children", "style", "tabIndex"]);

  var _getAttributes644 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes644.tabindex,
      props = _objectWithoutProperties$2(_getAttributes644, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 4v4H4V4h4m2-2H2v8h8V2zm8 5v4h-4V7h4m2-2h-8v8h8V5zM8 16v4H4v-4h4m2-2H2v8h8v-8z'
  }), React.createElement('path', {
    d: 'M22 10v6h-6v6h-6v8h20V10zm-4 8h4v4h-4zm-2 10h-4v-4h4zm6 0h-4v-4h4zm6 0h-4v-4h4zm0-6h-4v-4h4zm-4-6v-4h4v4z'
  }));
});
Development32.displayName = 'Development32';
Development32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Development32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Development24 = React.forwardRef(function (_ref645, ref) {
  var className = _ref645.className,
      children = _ref645.children,
      style = _ref645.style,
      tabIndex = _ref645.tabIndex,
      rest = _objectWithoutProperties$2(_ref645, ["className", "children", "style", "tabIndex"]);

  var _getAttributes645 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes645.tabindex,
      props = _objectWithoutProperties$2(_getAttributes645, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 4v4H4V4h4m2-2H2v8h8V2zm8 5v4h-4V7h4m2-2h-8v8h8V5zM8 16v4H4v-4h4m2-2H2v8h8v-8z'
  }), React.createElement('path', {
    d: 'M22 10v6h-6v6h-6v8h20V10zm-4 8h4v4h-4zm-2 10h-4v-4h4zm6 0h-4v-4h4zm6 0h-4v-4h4zm0-6h-4v-4h4zm-4-6v-4h4v4z'
  }));
});
Development24.displayName = 'Development24';
Development24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Development24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Development20 = React.forwardRef(function (_ref646, ref) {
  var className = _ref646.className,
      children = _ref646.children,
      style = _ref646.style,
      tabIndex = _ref646.tabIndex,
      rest = _objectWithoutProperties$2(_ref646, ["className", "children", "style", "tabIndex"]);

  var _getAttributes646 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes646.tabindex,
      props = _objectWithoutProperties$2(_getAttributes646, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 4v4H4V4h4m2-2H2v8h8V2zm8 5v4h-4V7h4m2-2h-8v8h8V5zM8 16v4H4v-4h4m2-2H2v8h8v-8z'
  }), React.createElement('path', {
    d: 'M22 10v6h-6v6h-6v8h20V10zm-4 8h4v4h-4zm-2 10h-4v-4h4zm6 0h-4v-4h4zm6 0h-4v-4h4zm0-6h-4v-4h4zm-4-6v-4h4v4z'
  }));
});
Development20.displayName = 'Development20';
Development20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Development20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Devices32 = React.forwardRef(function (_ref647, ref) {
  var className = _ref647.className,
      children = _ref647.children,
      style = _ref647.style,
      tabIndex = _ref647.tabIndex,
      rest = _objectWithoutProperties$2(_ref647, ["className", "children", "style", "tabIndex"]);

  var _getAttributes647 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes647.tabindex,
      props = _objectWithoutProperties$2(_getAttributes647, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 30H4a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zM4 16v12h6V16z'
  }), React.createElement('path', {
    d: 'M28 4H6a2 2 0 0 0-2 2v6h2V6h22v14H14v2h2v4h-2v2h9v-2h-5v-4h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
Devices32.displayName = 'Devices32';
Devices32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Devices32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Devices24 = React.forwardRef(function (_ref648, ref) {
  var className = _ref648.className,
      children = _ref648.children,
      style = _ref648.style,
      tabIndex = _ref648.tabIndex,
      rest = _objectWithoutProperties$2(_ref648, ["className", "children", "style", "tabIndex"]);

  var _getAttributes648 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes648.tabindex,
      props = _objectWithoutProperties$2(_getAttributes648, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 30H4a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zM4 16v12h6V16z'
  }), React.createElement('path', {
    d: 'M28 4H6a2 2 0 0 0-2 2v6h2V6h22v14H14v2h2v4h-2v2h9v-2h-5v-4h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
Devices24.displayName = 'Devices24';
Devices24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Devices24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Devices20 = React.forwardRef(function (_ref649, ref) {
  var className = _ref649.className,
      children = _ref649.children,
      style = _ref649.style,
      tabIndex = _ref649.tabIndex,
      rest = _objectWithoutProperties$2(_ref649, ["className", "children", "style", "tabIndex"]);

  var _getAttributes649 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes649.tabindex,
      props = _objectWithoutProperties$2(_getAttributes649, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 30H4a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zM4 16v12h6V16z'
  }), React.createElement('path', {
    d: 'M28 4H6a2 2 0 0 0-2 2v6h2V6h22v14H14v2h2v4h-2v2h9v-2h-5v-4h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
Devices20.displayName = 'Devices20';
Devices20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Devices20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Diagram32 = React.forwardRef(function (_ref650, ref) {
  var className = _ref650.className,
      children = _ref650.children,
      style = _ref650.style,
      tabIndex = _ref650.tabIndex,
      rest = _objectWithoutProperties$2(_ref650, ["className", "children", "style", "tabIndex"]);

  var _getAttributes650 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes650.tabindex,
      props = _objectWithoutProperties$2(_getAttributes650, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 30a11 11 0 0 1 0-22 1 1 0 0 1 1 1v9h9a1 1 0 0 1 1 1 11 11 0 0 1-11 11zm-1-19.94A9 9 0 1 0 21.94 20H14a2 2 0 0 1-2-2z'
  }), React.createElement('path', {
    d: 'M28 14h-9a2 2 0 0 1-2-2V3a1 1 0 0 1 1-1 11 11 0 0 1 11 11 1 1 0 0 1-1 1zm-9-2h7.94A9 9 0 0 0 19 4.06z'
  }));
});
Diagram32.displayName = 'Diagram32';
Diagram32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Diagram32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Diagram24 = React.forwardRef(function (_ref651, ref) {
  var className = _ref651.className,
      children = _ref651.children,
      style = _ref651.style,
      tabIndex = _ref651.tabIndex,
      rest = _objectWithoutProperties$2(_ref651, ["className", "children", "style", "tabIndex"]);

  var _getAttributes651 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes651.tabindex,
      props = _objectWithoutProperties$2(_getAttributes651, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 30a11 11 0 0 1 0-22 1 1 0 0 1 1 1v9h9a1 1 0 0 1 1 1 11 11 0 0 1-11 11zm-1-19.94A9 9 0 1 0 21.94 20H14a2 2 0 0 1-2-2z'
  }), React.createElement('path', {
    d: 'M28 14h-9a2 2 0 0 1-2-2V3a1 1 0 0 1 1-1 11 11 0 0 1 11 11 1 1 0 0 1-1 1zm-9-2h7.94A9 9 0 0 0 19 4.06z'
  }));
});
Diagram24.displayName = 'Diagram24';
Diagram24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Diagram24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Diagram20 = React.forwardRef(function (_ref652, ref) {
  var className = _ref652.className,
      children = _ref652.children,
      style = _ref652.style,
      tabIndex = _ref652.tabIndex,
      rest = _objectWithoutProperties$2(_ref652, ["className", "children", "style", "tabIndex"]);

  var _getAttributes652 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes652.tabindex,
      props = _objectWithoutProperties$2(_getAttributes652, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 30a11 11 0 0 1 0-22 1 1 0 0 1 1 1v9h9a1 1 0 0 1 1 1 11 11 0 0 1-11 11zm-1-19.94A9 9 0 1 0 21.94 20H14a2 2 0 0 1-2-2z'
  }), React.createElement('path', {
    d: 'M28 14h-9a2 2 0 0 1-2-2V3a1 1 0 0 1 1-1 11 11 0 0 1 11 11 1 1 0 0 1-1 1zm-9-2h7.94A9 9 0 0 0 19 4.06z'
  }));
});
Diagram20.displayName = 'Diagram20';
Diagram20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Diagram20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentAdd32 = React.forwardRef(function (_ref653, ref) {
  var className = _ref653.className,
      children = _ref653.children,
      style = _ref653.style,
      tabIndex = _ref653.tabIndex,
      rest = _objectWithoutProperties$2(_ref653, ["className", "children", "style", "tabIndex"]);

  var _getAttributes653 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes653.tabindex,
      props = _objectWithoutProperties$2(_getAttributes653, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M21 19h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2z'
  }));
});
DocumentAdd32.displayName = 'DocumentAdd32';
DocumentAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentAdd24 = React.forwardRef(function (_ref654, ref) {
  var className = _ref654.className,
      children = _ref654.children,
      style = _ref654.style,
      tabIndex = _ref654.tabIndex,
      rest = _objectWithoutProperties$2(_ref654, ["className", "children", "style", "tabIndex"]);

  var _getAttributes654 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes654.tabindex,
      props = _objectWithoutProperties$2(_getAttributes654, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M21 19h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2z'
  }));
});
DocumentAdd24.displayName = 'DocumentAdd24';
DocumentAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentAdd20 = React.forwardRef(function (_ref655, ref) {
  var className = _ref655.className,
      children = _ref655.children,
      style = _ref655.style,
      tabIndex = _ref655.tabIndex,
      rest = _objectWithoutProperties$2(_ref655, ["className", "children", "style", "tabIndex"]);

  var _getAttributes655 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes655.tabindex,
      props = _objectWithoutProperties$2(_getAttributes655, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M21 19h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2z'
  }));
});
DocumentAdd20.displayName = 'DocumentAdd20';
DocumentAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentExport32 = React.forwardRef(function (_ref656, ref) {
  var className = _ref656.className,
      children = _ref656.children,
      style = _ref656.style,
      tabIndex = _ref656.tabIndex,
      rest = _objectWithoutProperties$2(_ref656, ["className", "children", "style", "tabIndex"]);

  var _getAttributes656 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes656.tabindex,
      props = _objectWithoutProperties$2(_getAttributes656, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 21h13.17l-2.58 2.59L25 25l5-5-5-5-1.41 1.41L26.17 19H13v2z'
  }), React.createElement('path', {
    d: 'M22 14v-4a1 1 0 0 0-.29-.71l-7-7A1 1 0 0 0 14 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2v2H4V4h8v6a2 2 0 0 0 2 2h6v2zm-8-4V4.41L19.59 10z'
  }));
});
DocumentExport32.displayName = 'DocumentExport32';
DocumentExport32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentExport32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentExport24 = React.forwardRef(function (_ref657, ref) {
  var className = _ref657.className,
      children = _ref657.children,
      style = _ref657.style,
      tabIndex = _ref657.tabIndex,
      rest = _objectWithoutProperties$2(_ref657, ["className", "children", "style", "tabIndex"]);

  var _getAttributes657 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes657.tabindex,
      props = _objectWithoutProperties$2(_getAttributes657, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 21h13.17l-2.58 2.59L25 25l5-5-5-5-1.41 1.41L26.17 19H13v2z'
  }), React.createElement('path', {
    d: 'M22 14v-4a1 1 0 0 0-.29-.71l-7-7A1 1 0 0 0 14 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2v2H4V4h8v6a2 2 0 0 0 2 2h6v2zm-8-4V4.41L19.59 10z'
  }));
});
DocumentExport24.displayName = 'DocumentExport24';
DocumentExport24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentExport24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentExport20 = React.forwardRef(function (_ref658, ref) {
  var className = _ref658.className,
      children = _ref658.children,
      style = _ref658.style,
      tabIndex = _ref658.tabIndex,
      rest = _objectWithoutProperties$2(_ref658, ["className", "children", "style", "tabIndex"]);

  var _getAttributes658 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes658.tabindex,
      props = _objectWithoutProperties$2(_getAttributes658, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 21h13.17l-2.58 2.59L25 25l5-5-5-5-1.41 1.41L26.17 19H13v2z'
  }), React.createElement('path', {
    d: 'M22 14v-4a1 1 0 0 0-.29-.71l-7-7A1 1 0 0 0 14 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2v2H4V4h8v6a2 2 0 0 0 2 2h6v2zm-8-4V4.41L19.59 10z'
  }));
});
DocumentExport20.displayName = 'DocumentExport20';
DocumentExport20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentExport20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentImport32 = React.forwardRef(function (_ref659, ref) {
  var className = _ref659.className,
      children = _ref659.children,
      style = _ref659.style,
      tabIndex = _ref659.tabIndex,
      rest = _objectWithoutProperties$2(_ref659, ["className", "children", "style", "tabIndex"]);

  var _getAttributes659 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes659.tabindex,
      props = _objectWithoutProperties$2(_getAttributes659, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 19H14.83l2.58-2.59L16 15l-5 5 5 5 1.41-1.41L14.83 21H28v-2z'
  }), React.createElement('path', {
    d: 'M24 14v-4a1 1 0 0 0-.29-.71l-7-7A1 1 0 0 0 16 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2v2H6V4h8v6a2 2 0 0 0 2 2h6v2zm-8-4V4.41L21.59 10z'
  }));
});
DocumentImport32.displayName = 'DocumentImport32';
DocumentImport32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentImport32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentImport24 = React.forwardRef(function (_ref660, ref) {
  var className = _ref660.className,
      children = _ref660.children,
      style = _ref660.style,
      tabIndex = _ref660.tabIndex,
      rest = _objectWithoutProperties$2(_ref660, ["className", "children", "style", "tabIndex"]);

  var _getAttributes660 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes660.tabindex,
      props = _objectWithoutProperties$2(_getAttributes660, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 19H14.83l2.58-2.59L16 15l-5 5 5 5 1.41-1.41L14.83 21H28v-2z'
  }), React.createElement('path', {
    d: 'M24 14v-4a1 1 0 0 0-.29-.71l-7-7A1 1 0 0 0 16 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2v2H6V4h8v6a2 2 0 0 0 2 2h6v2zm-8-4V4.41L21.59 10z'
  }));
});
DocumentImport24.displayName = 'DocumentImport24';
DocumentImport24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentImport24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentImport20 = React.forwardRef(function (_ref661, ref) {
  var className = _ref661.className,
      children = _ref661.children,
      style = _ref661.style,
      tabIndex = _ref661.tabIndex,
      rest = _objectWithoutProperties$2(_ref661, ["className", "children", "style", "tabIndex"]);

  var _getAttributes661 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes661.tabindex,
      props = _objectWithoutProperties$2(_getAttributes661, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 19H14.83l2.58-2.59L16 15l-5 5 5 5 1.41-1.41L14.83 21H28v-2z'
  }), React.createElement('path', {
    d: 'M24 14v-4a1 1 0 0 0-.29-.71l-7-7A1 1 0 0 0 16 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2v2H6V4h8v6a2 2 0 0 0 2 2h6v2zm-8-4V4.41L21.59 10z'
  }));
});
DocumentImport20.displayName = 'DocumentImport20';
DocumentImport20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentImport20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentSubtract32 = React.forwardRef(function (_ref662, ref) {
  var className = _ref662.className,
      children = _ref662.children,
      style = _ref662.style,
      tabIndex = _ref662.tabIndex,
      rest = _objectWithoutProperties$2(_ref662, ["className", "children", "style", "tabIndex"]);

  var _getAttributes662 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes662.tabindex,
      props = _objectWithoutProperties$2(_getAttributes662, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M11 19h10v2H11z'
  }));
});
DocumentSubtract32.displayName = 'DocumentSubtract32';
DocumentSubtract32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentSubtract32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentSubtract24 = React.forwardRef(function (_ref663, ref) {
  var className = _ref663.className,
      children = _ref663.children,
      style = _ref663.style,
      tabIndex = _ref663.tabIndex,
      rest = _objectWithoutProperties$2(_ref663, ["className", "children", "style", "tabIndex"]);

  var _getAttributes663 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes663.tabindex,
      props = _objectWithoutProperties$2(_getAttributes663, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M11 19h10v2H11z'
  }));
});
DocumentSubtract24.displayName = 'DocumentSubtract24';
DocumentSubtract24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentSubtract24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentSubtract20 = React.forwardRef(function (_ref664, ref) {
  var className = _ref664.className,
      children = _ref664.children,
      style = _ref664.style,
      tabIndex = _ref664.tabIndex,
      rest = _objectWithoutProperties$2(_ref664, ["className", "children", "style", "tabIndex"]);

  var _getAttributes664 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes664.tabindex,
      props = _objectWithoutProperties$2(_getAttributes664, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M11 19h10v2H11z'
  }));
});
DocumentSubtract20.displayName = 'DocumentSubtract20';
DocumentSubtract20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentSubtract20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentTasks32 = React.forwardRef(function (_ref665, ref) {
  var className = _ref665.className,
      children = _ref665.children,
      style = _ref665.style,
      tabIndex = _ref665.tabIndex,
      rest = _objectWithoutProperties$2(_ref665, ["className", "children", "style", "tabIndex"]);

  var _getAttributes665 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes665.tabindex,
      props = _objectWithoutProperties$2(_getAttributes665, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M14 22.18l-2.59-2.59L10 21l4 4 8-8-1.41-1.41L14 22.18z'
  }));
});
DocumentTasks32.displayName = 'DocumentTasks32';
DocumentTasks32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentTasks32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentTasks24 = React.forwardRef(function (_ref666, ref) {
  var className = _ref666.className,
      children = _ref666.children,
      style = _ref666.style,
      tabIndex = _ref666.tabIndex,
      rest = _objectWithoutProperties$2(_ref666, ["className", "children", "style", "tabIndex"]);

  var _getAttributes666 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes666.tabindex,
      props = _objectWithoutProperties$2(_getAttributes666, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M14 22.18l-2.59-2.59L10 21l4 4 8-8-1.41-1.41L14 22.18z'
  }));
});
DocumentTasks24.displayName = 'DocumentTasks24';
DocumentTasks24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentTasks24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DocumentTasks20 = React.forwardRef(function (_ref667, ref) {
  var className = _ref667.className,
      children = _ref667.children,
      style = _ref667.style,
      tabIndex = _ref667.tabIndex,
      rest = _objectWithoutProperties$2(_ref667, ["className", "children", "style", "tabIndex"]);

  var _getAttributes667 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes667.tabindex,
      props = _objectWithoutProperties$2(_getAttributes667, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M14 22.18l-2.59-2.59L10 21l4 4 8-8-1.41-1.41L14 22.18z'
  }));
});
DocumentTasks20.displayName = 'DocumentTasks20';
DocumentTasks20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DocumentTasks20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Document32 = React.forwardRef(function (_ref668, ref) {
  var className = _ref668.className,
      children = _ref668.children,
      style = _ref668.style,
      tabIndex = _ref668.tabIndex,
      rest = _objectWithoutProperties$2(_ref668, ["className", "children", "style", "tabIndex"]);

  var _getAttributes668 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes668.tabindex,
      props = _objectWithoutProperties$2(_getAttributes668, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M11 22h10v2H11zm0-6h10v2H11z'
  }));
});
Document32.displayName = 'Document32';
Document32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Document32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Document24 = React.forwardRef(function (_ref669, ref) {
  var className = _ref669.className,
      children = _ref669.children,
      style = _ref669.style,
      tabIndex = _ref669.tabIndex,
      rest = _objectWithoutProperties$2(_ref669, ["className", "children", "style", "tabIndex"]);

  var _getAttributes669 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes669.tabindex,
      props = _objectWithoutProperties$2(_getAttributes669, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M11 22h10v2H11zm0-6h10v2H11z'
  }));
});
Document24.displayName = 'Document24';
Document24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Document24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Document20 = React.forwardRef(function (_ref670, ref) {
  var className = _ref670.className,
      children = _ref670.children,
      style = _ref670.style,
      tabIndex = _ref670.tabIndex,
      rest = _objectWithoutProperties$2(_ref670, ["className", "children", "style", "tabIndex"]);

  var _getAttributes670 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes670.tabindex,
      props = _objectWithoutProperties$2(_getAttributes670, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.7 9.3l-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7zM18 4.4l5.6 5.6H18zM24 28H8V4h8v6a2 2 0 0 0 2 2h6z'
  }), React.createElement('path', {
    d: 'M11 22h10v2H11zm0-6h10v2H11z'
  }));
});
Document20.displayName = 'Document20';
Document20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Document20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DownToBottom32 = React.forwardRef(function (_ref671, ref) {
  var className = _ref671.className,
      children = _ref671.children,
      style = _ref671.style,
      tabIndex = _ref671.tabIndex,
      rest = _objectWithoutProperties$2(_ref671, ["className", "children", "style", "tabIndex"]);

  var _getAttributes671 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes671.tabindex,
      props = _objectWithoutProperties$2(_getAttributes671, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 19L6 9l1.41-1.41L16 16.17l8.59-8.58L26 9 16 19zM4 23h24v2H4z'
  }));
});
DownToBottom32.displayName = 'DownToBottom32';
DownToBottom32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DownToBottom32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DownToBottom24 = React.forwardRef(function (_ref672, ref) {
  var className = _ref672.className,
      children = _ref672.children,
      style = _ref672.style,
      tabIndex = _ref672.tabIndex,
      rest = _objectWithoutProperties$2(_ref672, ["className", "children", "style", "tabIndex"]);

  var _getAttributes672 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes672.tabindex,
      props = _objectWithoutProperties$2(_getAttributes672, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 19L6 9l1.41-1.41L16 16.17l8.59-8.58L26 9 16 19zM4 23h24v2H4z'
  }));
});
DownToBottom24.displayName = 'DownToBottom24';
DownToBottom24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DownToBottom24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DownToBottom20 = React.forwardRef(function (_ref673, ref) {
  var className = _ref673.className,
      children = _ref673.children,
      style = _ref673.style,
      tabIndex = _ref673.tabIndex,
      rest = _objectWithoutProperties$2(_ref673, ["className", "children", "style", "tabIndex"]);

  var _getAttributes673 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes673.tabindex,
      props = _objectWithoutProperties$2(_getAttributes673, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 19L6 9l1.41-1.41L16 16.17l8.59-8.58L26 9 16 19zM4 23h24v2H4z'
  }));
});
DownToBottom20.displayName = 'DownToBottom20';
DownToBottom20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DownToBottom20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Download32 = React.forwardRef(function (_ref674, ref) {
  var className = _ref674.className,
      children = _ref674.children,
      style = _ref674.style,
      tabIndex = _ref674.tabIndex,
      rest = _objectWithoutProperties$2(_ref674, ["className", "children", "style", "tabIndex"]);

  var _getAttributes674 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes674.tabindex,
      props = _objectWithoutProperties$2(_getAttributes674, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 15l-1.41-1.41L17 21.17V2h-2v19.17l-7.59-7.58L6 15l10 10 10-10z'
  }), React.createElement('path', {
    d: 'M26 24v4H6v-4H4v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4z'
  }));
});
Download32.displayName = 'Download32';
Download32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Download32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Download24 = React.forwardRef(function (_ref675, ref) {
  var className = _ref675.className,
      children = _ref675.children,
      style = _ref675.style,
      tabIndex = _ref675.tabIndex,
      rest = _objectWithoutProperties$2(_ref675, ["className", "children", "style", "tabIndex"]);

  var _getAttributes675 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes675.tabindex,
      props = _objectWithoutProperties$2(_getAttributes675, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 15l-1.41-1.41L17 21.17V2h-2v19.17l-7.59-7.58L6 15l10 10 10-10z'
  }), React.createElement('path', {
    d: 'M26 24v4H6v-4H4v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4z'
  }));
});
Download24.displayName = 'Download24';
Download24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Download24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Download20 = React.forwardRef(function (_ref676, ref) {
  var className = _ref676.className,
      children = _ref676.children,
      style = _ref676.style,
      tabIndex = _ref676.tabIndex,
      rest = _objectWithoutProperties$2(_ref676, ["className", "children", "style", "tabIndex"]);

  var _getAttributes676 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes676.tabindex,
      props = _objectWithoutProperties$2(_getAttributes676, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 15l-1.41-1.41L17 21.17V2h-2v19.17l-7.59-7.58L6 15l10 10 10-10z'
  }), React.createElement('path', {
    d: 'M26 24v4H6v-4H4v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4z'
  }));
});
Download20.displayName = 'Download20';
Download20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Download20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DragHorizontal32 = React.forwardRef(function (_ref677, ref) {
  var className = _ref677.className,
      children = _ref677.children,
      style = _ref677.style,
      tabIndex = _ref677.tabIndex,
      rest = _objectWithoutProperties$2(_ref677, ["className", "children", "style", "tabIndex"]);

  var _getAttributes677 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes677.tabindex,
      props = _objectWithoutProperties$2(_getAttributes677, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4v11H5.83l2.58-2.59L7 11l-5 5 5 5 1.41-1.41L5.83 17H12v11h2V4h-2zm13 7l-1.41 1.41L26.17 15H20V4h-2v24h2V17h6.17l-2.58 2.59L25 21l5-5-5-5z'
  }));
});
DragHorizontal32.displayName = 'DragHorizontal32';
DragHorizontal32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DragHorizontal32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DragHorizontal24 = React.forwardRef(function (_ref678, ref) {
  var className = _ref678.className,
      children = _ref678.children,
      style = _ref678.style,
      tabIndex = _ref678.tabIndex,
      rest = _objectWithoutProperties$2(_ref678, ["className", "children", "style", "tabIndex"]);

  var _getAttributes678 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes678.tabindex,
      props = _objectWithoutProperties$2(_getAttributes678, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4v11H5.83l2.58-2.59L7 11l-5 5 5 5 1.41-1.41L5.83 17H12v11h2V4h-2zm13 7l-1.41 1.41L26.17 15H20V4h-2v24h2V17h6.17l-2.58 2.59L25 21l5-5-5-5z'
  }));
});
DragHorizontal24.displayName = 'DragHorizontal24';
DragHorizontal24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DragHorizontal24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DragHorizontal20 = React.forwardRef(function (_ref679, ref) {
  var className = _ref679.className,
      children = _ref679.children,
      style = _ref679.style,
      tabIndex = _ref679.tabIndex,
      rest = _objectWithoutProperties$2(_ref679, ["className", "children", "style", "tabIndex"]);

  var _getAttributes679 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes679.tabindex,
      props = _objectWithoutProperties$2(_getAttributes679, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4v11H5.83l2.58-2.59L7 11l-5 5 5 5 1.41-1.41L5.83 17H12v11h2V4h-2zm13 7l-1.41 1.41L26.17 15H20V4h-2v24h2V17h6.17l-2.58 2.59L25 21l5-5-5-5z'
  }));
});
DragHorizontal20.displayName = 'DragHorizontal20';
DragHorizontal20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DragHorizontal20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DragVertical32 = React.forwardRef(function (_ref680, ref) {
  var className = _ref680.className,
      children = _ref680.children,
      style = _ref680.style,
      tabIndex = _ref680.tabIndex,
      rest = _objectWithoutProperties$2(_ref680, ["className", "children", "style", "tabIndex"]);

  var _getAttributes680 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes680.tabindex,
      props = _objectWithoutProperties$2(_getAttributes680, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 20h11v6.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17V20h11v-2H4v2zm7-13l1.41 1.41L15 5.83V12H4v2h24v-2H17V5.83l2.59 2.58L21 7l-5-5-5 5z'
  }));
});
DragVertical32.displayName = 'DragVertical32';
DragVertical32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DragVertical32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DragVertical24 = React.forwardRef(function (_ref681, ref) {
  var className = _ref681.className,
      children = _ref681.children,
      style = _ref681.style,
      tabIndex = _ref681.tabIndex,
      rest = _objectWithoutProperties$2(_ref681, ["className", "children", "style", "tabIndex"]);

  var _getAttributes681 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes681.tabindex,
      props = _objectWithoutProperties$2(_getAttributes681, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 20h11v6.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17V20h11v-2H4v2zm7-13l1.41 1.41L15 5.83V12H4v2h24v-2H17V5.83l2.59 2.58L21 7l-5-5-5 5z'
  }));
});
DragVertical24.displayName = 'DragVertical24';
DragVertical24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DragVertical24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var DragVertical20 = React.forwardRef(function (_ref682, ref) {
  var className = _ref682.className,
      children = _ref682.children,
      style = _ref682.style,
      tabIndex = _ref682.tabIndex,
      rest = _objectWithoutProperties$2(_ref682, ["className", "children", "style", "tabIndex"]);

  var _getAttributes682 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes682.tabindex,
      props = _objectWithoutProperties$2(_getAttributes682, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 20h11v6.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17V20h11v-2H4v2zm7-13l1.41 1.41L15 5.83V12H4v2h24v-2H17V5.83l2.59 2.58L21 7l-5-5-5 5z'
  }));
});
DragVertical20.displayName = 'DragVertical20';
DragVertical20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
DragVertical20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Draggable32 = React.forwardRef(function (_ref683, ref) {
  var className = _ref683.className,
      children = _ref683.children,
      style = _ref683.style,
      tabIndex = _ref683.tabIndex,
      rest = _objectWithoutProperties$2(_ref683, ["className", "children", "style", "tabIndex"]);

  var _getAttributes683 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes683.tabindex,
      props = _objectWithoutProperties$2(_getAttributes683, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 5h4v4h-4zm8 0h4v4h-4zm-8 9h4v4h-4zm8 0h4v4h-4zm-8 9h4v4h-4zm8 0h4v4h-4z'
  }));
});
Draggable32.displayName = 'Draggable32';
Draggable32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Draggable32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Draggable24 = React.forwardRef(function (_ref684, ref) {
  var className = _ref684.className,
      children = _ref684.children,
      style = _ref684.style,
      tabIndex = _ref684.tabIndex,
      rest = _objectWithoutProperties$2(_ref684, ["className", "children", "style", "tabIndex"]);

  var _getAttributes684 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes684.tabindex,
      props = _objectWithoutProperties$2(_getAttributes684, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 5h4v4h-4zm8 0h4v4h-4zm-8 9h4v4h-4zm8 0h4v4h-4zm-8 9h4v4h-4zm8 0h4v4h-4z'
  }));
});
Draggable24.displayName = 'Draggable24';
Draggable24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Draggable24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Draggable20 = React.forwardRef(function (_ref685, ref) {
  var className = _ref685.className,
      children = _ref685.children,
      style = _ref685.style,
      tabIndex = _ref685.tabIndex,
      rest = _objectWithoutProperties$2(_ref685, ["className", "children", "style", "tabIndex"]);

  var _getAttributes685 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes685.tabindex,
      props = _objectWithoutProperties$2(_getAttributes685, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 5h4v4h-4zm8 0h4v4h-4zm-8 9h4v4h-4zm8 0h4v4h-4zm-8 9h4v4h-4zm8 0h4v4h-4z'
  }));
});
Draggable20.displayName = 'Draggable20';
Draggable20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Draggable20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Draw32 = React.forwardRef(function (_ref686, ref) {
  var className = _ref686.className,
      children = _ref686.children,
      style = _ref686.style,
      tabIndex = _ref686.tabIndex,
      rest = _objectWithoutProperties$2(_ref686, ["className", "children", "style", "tabIndex"]);

  var _getAttributes686 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes686.tabindex,
      props = _objectWithoutProperties$2(_getAttributes686, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19.14 28a3.42 3.42 0 0 1-2.42-5.85L21.86 17a1.42 1.42 0 1 0-2-2L13 21.85a3.5 3.5 0 0 1-4.85 0 3.43 3.43 0 0 1 0-4.84l8.58-8.58a1.42 1.42 0 1 0-2-2L6.41 14.7 5 13.3 13.29 5a3.43 3.43 0 0 1 4.84 4.85l-8.57 8.57a1.42 1.42 0 0 0 0 2 1.45 1.45 0 0 0 2 0l6.86-6.86a3.43 3.43 0 1 1 4.85 4.84l-5.15 5.15a1.42 1.42 0 0 0 2 2l4.44-4.43L26 22.56 21.56 27a3.38 3.38 0 0 1-2.42 1z'
  }));
});
Draw32.displayName = 'Draw32';
Draw32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Draw32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Draw24 = React.forwardRef(function (_ref687, ref) {
  var className = _ref687.className,
      children = _ref687.children,
      style = _ref687.style,
      tabIndex = _ref687.tabIndex,
      rest = _objectWithoutProperties$2(_ref687, ["className", "children", "style", "tabIndex"]);

  var _getAttributes687 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes687.tabindex,
      props = _objectWithoutProperties$2(_getAttributes687, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19.14 28a3.42 3.42 0 0 1-2.42-5.85L21.86 17a1.42 1.42 0 1 0-2-2L13 21.85a3.5 3.5 0 0 1-4.85 0 3.43 3.43 0 0 1 0-4.84l8.58-8.58a1.42 1.42 0 1 0-2-2L6.41 14.7 5 13.3 13.29 5a3.43 3.43 0 0 1 4.84 4.85l-8.57 8.57a1.42 1.42 0 0 0 0 2 1.45 1.45 0 0 0 2 0l6.86-6.86a3.43 3.43 0 1 1 4.85 4.84l-5.15 5.15a1.42 1.42 0 0 0 2 2l4.44-4.43L26 22.56 21.56 27a3.38 3.38 0 0 1-2.42 1z'
  }));
});
Draw24.displayName = 'Draw24';
Draw24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Draw24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Draw20 = React.forwardRef(function (_ref688, ref) {
  var className = _ref688.className,
      children = _ref688.children,
      style = _ref688.style,
      tabIndex = _ref688.tabIndex,
      rest = _objectWithoutProperties$2(_ref688, ["className", "children", "style", "tabIndex"]);

  var _getAttributes688 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes688.tabindex,
      props = _objectWithoutProperties$2(_getAttributes688, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19.14 28a3.42 3.42 0 0 1-2.42-5.85L21.86 17a1.42 1.42 0 1 0-2-2L13 21.85a3.5 3.5 0 0 1-4.85 0 3.43 3.43 0 0 1 0-4.84l8.58-8.58a1.42 1.42 0 1 0-2-2L6.41 14.7 5 13.3 13.29 5a3.43 3.43 0 0 1 4.84 4.85l-8.57 8.57a1.42 1.42 0 0 0 0 2 1.45 1.45 0 0 0 2 0l6.86-6.86a3.43 3.43 0 1 1 4.85 4.84l-5.15 5.15a1.42 1.42 0 0 0 2 2l4.44-4.43L26 22.56 21.56 27a3.38 3.38 0 0 1-2.42 1z'
  }));
});
Draw20.displayName = 'Draw20';
Draw20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Draw20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Edit32 = React.forwardRef(function (_ref689, ref) {
  var className = _ref689.className,
      children = _ref689.children,
      style = _ref689.style,
      tabIndex = _ref689.tabIndex,
      rest = _objectWithoutProperties$2(_ref689, ["className", "children", "style", "tabIndex"]);

  var _getAttributes689 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes689.tabindex,
      props = _objectWithoutProperties$2(_getAttributes689, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 27h28v2H2zM25.41 9a2 2 0 0 0 0-2.83l-3.58-3.58a2 2 0 0 0-2.83 0l-15 15V24h6.41zm-5-5L24 7.59l-3 3L17.41 7zM6 22v-3.59l10-10L19.59 12l-10 10z'
  }));
});
Edit32.displayName = 'Edit32';
Edit32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Edit32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Edit24 = React.forwardRef(function (_ref690, ref) {
  var className = _ref690.className,
      children = _ref690.children,
      style = _ref690.style,
      tabIndex = _ref690.tabIndex,
      rest = _objectWithoutProperties$2(_ref690, ["className", "children", "style", "tabIndex"]);

  var _getAttributes690 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes690.tabindex,
      props = _objectWithoutProperties$2(_getAttributes690, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 27h28v2H2zM25.41 9a2 2 0 0 0 0-2.83l-3.58-3.58a2 2 0 0 0-2.83 0l-15 15V24h6.41zm-5-5L24 7.59l-3 3L17.41 7zM6 22v-3.59l10-10L19.59 12l-10 10z'
  }));
});
Edit24.displayName = 'Edit24';
Edit24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Edit24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Edit20 = React.forwardRef(function (_ref691, ref) {
  var className = _ref691.className,
      children = _ref691.children,
      style = _ref691.style,
      tabIndex = _ref691.tabIndex,
      rest = _objectWithoutProperties$2(_ref691, ["className", "children", "style", "tabIndex"]);

  var _getAttributes691 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes691.tabindex,
      props = _objectWithoutProperties$2(_getAttributes691, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 27h28v2H2zM25.41 9a2 2 0 0 0 0-2.83l-3.58-3.58a2 2 0 0 0-2.83 0l-15 15V24h6.41zm-5-5L24 7.59l-3 3L17.41 7zM6 22v-3.59l10-10L19.59 12l-10 10z'
  }));
});
Edit20.displayName = 'Edit20';
Edit20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Edit20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Email32 = React.forwardRef(function (_ref692, ref) {
  var className = _ref692.className,
      children = _ref692.children,
      style = _ref692.style,
      tabIndex = _ref692.tabIndex,
      rest = _objectWithoutProperties$2(_ref692, ["className", "children", "style", "tabIndex"]);

  var _getAttributes692 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes692.tabindex,
      props = _objectWithoutProperties$2(_getAttributes692, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-2.2 2L16 14.78 6.2 8zM4 24V8.91l11.43 7.91a1 1 0 0 0 1.14 0L28 8.91V24z'
  }));
});
Email32.displayName = 'Email32';
Email32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Email32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Email24 = React.forwardRef(function (_ref693, ref) {
  var className = _ref693.className,
      children = _ref693.children,
      style = _ref693.style,
      tabIndex = _ref693.tabIndex,
      rest = _objectWithoutProperties$2(_ref693, ["className", "children", "style", "tabIndex"]);

  var _getAttributes693 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes693.tabindex,
      props = _objectWithoutProperties$2(_getAttributes693, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-2.2 2L16 14.78 6.2 8zM4 24V8.91l11.43 7.91a1 1 0 0 0 1.14 0L28 8.91V24z'
  }));
});
Email24.displayName = 'Email24';
Email24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Email24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Email20 = React.forwardRef(function (_ref694, ref) {
  var className = _ref694.className,
      children = _ref694.children,
      style = _ref694.style,
      tabIndex = _ref694.tabIndex,
      rest = _objectWithoutProperties$2(_ref694, ["className", "children", "style", "tabIndex"]);

  var _getAttributes694 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes694.tabindex,
      props = _objectWithoutProperties$2(_getAttributes694, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-2.2 2L16 14.78 6.2 8zM4 24V8.91l11.43 7.91a1 1 0 0 0 1.14 0L28 8.91V24z'
  }));
});
Email20.displayName = 'Email20';
Email20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Email20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Erase32 = React.forwardRef(function (_ref695, ref) {
  var className = _ref695.className,
      children = _ref695.children,
      style = _ref695.style,
      tabIndex = _ref695.tabIndex,
      rest = _objectWithoutProperties$2(_ref695, ["className", "children", "style", "tabIndex"]);

  var _getAttributes695 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes695.tabindex,
      props = _objectWithoutProperties$2(_getAttributes695, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 27h23v2H7zm20.38-16.49l-7.93-7.92a2 2 0 0 0-2.83 0l-14 14a2 2 0 0 0 0 2.83L7.13 24h9.59l10.66-10.66a2 2 0 0 0 0-2.83zM15.89 22H8l-4-4 6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4l8 7.93z'
  }));
});
Erase32.displayName = 'Erase32';
Erase32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Erase32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Erase24 = React.forwardRef(function (_ref696, ref) {
  var className = _ref696.className,
      children = _ref696.children,
      style = _ref696.style,
      tabIndex = _ref696.tabIndex,
      rest = _objectWithoutProperties$2(_ref696, ["className", "children", "style", "tabIndex"]);

  var _getAttributes696 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes696.tabindex,
      props = _objectWithoutProperties$2(_getAttributes696, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 27h23v2H7zm20.38-16.49l-7.93-7.92a2 2 0 0 0-2.83 0l-14 14a2 2 0 0 0 0 2.83L7.13 24h9.59l10.66-10.66a2 2 0 0 0 0-2.83zM15.89 22H8l-4-4 6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4l8 7.93z'
  }));
});
Erase24.displayName = 'Erase24';
Erase24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Erase24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Erase20 = React.forwardRef(function (_ref697, ref) {
  var className = _ref697.className,
      children = _ref697.children,
      style = _ref697.style,
      tabIndex = _ref697.tabIndex,
      rest = _objectWithoutProperties$2(_ref697, ["className", "children", "style", "tabIndex"]);

  var _getAttributes697 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes697.tabindex,
      props = _objectWithoutProperties$2(_getAttributes697, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 27h23v2H7zm20.38-16.49l-7.93-7.92a2 2 0 0 0-2.83 0l-14 14a2 2 0 0 0 0 2.83L7.13 24h9.59l10.66-10.66a2 2 0 0 0 0-2.83zM15.89 22H8l-4-4 6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4l8 7.93z'
  }));
});
Erase20.displayName = 'Erase20';
Erase20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Erase20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ErrorFilled32 = React.forwardRef(function (_ref698, ref) {
  var className = _ref698.className,
      children = _ref698.children,
      style = _ref698.style,
      tabIndex = _ref698.tabIndex,
      rest = _objectWithoutProperties$2(_ref698, ["className", "children", "style", "tabIndex"]);

  var _getAttributes698 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes698.tabindex,
      props = _objectWithoutProperties$2(_getAttributes698, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm5.41 21L9 10.59 10.59 9 23 21.41z'
  }));
});
ErrorFilled32.displayName = 'ErrorFilled32';
ErrorFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ErrorFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ErrorFilled24 = React.forwardRef(function (_ref699, ref) {
  var className = _ref699.className,
      children = _ref699.children,
      style = _ref699.style,
      tabIndex = _ref699.tabIndex,
      rest = _objectWithoutProperties$2(_ref699, ["className", "children", "style", "tabIndex"]);

  var _getAttributes699 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes699.tabindex,
      props = _objectWithoutProperties$2(_getAttributes699, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm5.41 21L9 10.59 10.59 9 23 21.41z'
  }));
});
ErrorFilled24.displayName = 'ErrorFilled24';
ErrorFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ErrorFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ErrorFilled20 = React.forwardRef(function (_ref700, ref) {
  var className = _ref700.className,
      children = _ref700.children,
      style = _ref700.style,
      tabIndex = _ref700.tabIndex,
      rest = _objectWithoutProperties$2(_ref700, ["className", "children", "style", "tabIndex"]);

  var _getAttributes700 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes700.tabindex,
      props = _objectWithoutProperties$2(_getAttributes700, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm5.41 21L9 10.59 10.59 9 23 21.41z'
  }));
});
ErrorFilled20.displayName = 'ErrorFilled20';
ErrorFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ErrorFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Error32 = React.forwardRef(function (_ref701, ref) {
  var className = _ref701.className,
      children = _ref701.children,
      style = _ref701.style,
      tabIndex = _ref701.tabIndex,
      rest = _objectWithoutProperties$2(_ref701, ["className", "children", "style", "tabIndex"]);

  var _getAttributes701 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes701.tabindex,
      props = _objectWithoutProperties$2(_getAttributes701, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 16A14 14 0 1 0 16 2 14 14 0 0 0 2 16zm23.15 7.75L8.25 6.85a12 12 0 0 1 16.9 16.9zM8.24 25.16a12 12 0 0 1-1.4-16.89l16.89 16.89a12 12 0 0 1-15.49 0z'
  }));
});
Error32.displayName = 'Error32';
Error32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Error32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Error24 = React.forwardRef(function (_ref702, ref) {
  var className = _ref702.className,
      children = _ref702.children,
      style = _ref702.style,
      tabIndex = _ref702.tabIndex,
      rest = _objectWithoutProperties$2(_ref702, ["className", "children", "style", "tabIndex"]);

  var _getAttributes702 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes702.tabindex,
      props = _objectWithoutProperties$2(_getAttributes702, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 16A14 14 0 1 0 16 2 14 14 0 0 0 2 16zm23.15 7.75L8.25 6.85a12 12 0 0 1 16.9 16.9zM8.24 25.16a12 12 0 0 1-1.4-16.89l16.89 16.89a12 12 0 0 1-15.49 0z'
  }));
});
Error24.displayName = 'Error24';
Error24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Error24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Error20 = React.forwardRef(function (_ref703, ref) {
  var className = _ref703.className,
      children = _ref703.children,
      style = _ref703.style,
      tabIndex = _ref703.tabIndex,
      rest = _objectWithoutProperties$2(_ref703, ["className", "children", "style", "tabIndex"]);

  var _getAttributes703 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes703.tabindex,
      props = _objectWithoutProperties$2(_getAttributes703, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 16A14 14 0 1 0 16 2 14 14 0 0 0 2 16zm23.15 7.75L8.25 6.85a12 12 0 0 1 16.9 16.9zM8.24 25.16a12 12 0 0 1-1.4-16.89l16.89 16.89a12 12 0 0 1-15.49 0z'
  }));
});
Error20.displayName = 'Error20';
Error20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Error20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var EventSchedule32 = React.forwardRef(function (_ref704, ref) {
  var className = _ref704.className,
      children = _ref704.children,
      style = _ref704.style,
      tabIndex = _ref704.tabIndex,
      rest = _objectWithoutProperties$2(_ref704, ["className", "children", "style", "tabIndex"]);

  var _getAttributes704 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes704.tabindex,
      props = _objectWithoutProperties$2(_getAttributes704, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 30a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }), React.createElement('path', {
    d: 'M22.59 25L20 22.41V18h2v3.59l2 2L22.59 25z'
  }), React.createElement('path', {
    d: 'M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2z'
  }));
});
EventSchedule32.displayName = 'EventSchedule32';
EventSchedule32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
EventSchedule32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var EventSchedule24 = React.forwardRef(function (_ref705, ref) {
  var className = _ref705.className,
      children = _ref705.children,
      style = _ref705.style,
      tabIndex = _ref705.tabIndex,
      rest = _objectWithoutProperties$2(_ref705, ["className", "children", "style", "tabIndex"]);

  var _getAttributes705 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes705.tabindex,
      props = _objectWithoutProperties$2(_getAttributes705, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 30a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }), React.createElement('path', {
    d: 'M22.59 25L20 22.41V18h2v3.59l2 2L22.59 25z'
  }), React.createElement('path', {
    d: 'M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2z'
  }));
});
EventSchedule24.displayName = 'EventSchedule24';
EventSchedule24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
EventSchedule24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var EventSchedule20 = React.forwardRef(function (_ref706, ref) {
  var className = _ref706.className,
      children = _ref706.children,
      style = _ref706.style,
      tabIndex = _ref706.tabIndex,
      rest = _objectWithoutProperties$2(_ref706, ["className", "children", "style", "tabIndex"]);

  var _getAttributes706 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes706.tabindex,
      props = _objectWithoutProperties$2(_getAttributes706, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 30a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }), React.createElement('path', {
    d: 'M22.59 25L20 22.41V18h2v3.59l2 2L22.59 25z'
  }), React.createElement('path', {
    d: 'M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2z'
  }));
});
EventSchedule20.displayName = 'EventSchedule20';
EventSchedule20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
EventSchedule20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Event32 = React.forwardRef(function (_ref707, ref) {
  var className = _ref707.className,
      children = _ref707.children,
      style = _ref707.style,
      tabIndex = _ref707.tabIndex,
      rest = _objectWithoutProperties$2(_ref707, ["className", "children", "style", "tabIndex"]);

  var _getAttributes707 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes707.tabindex,
      props = _objectWithoutProperties$2(_getAttributes707, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2z'
  }), React.createElement('path', {
    d: 'M21 15l2.55 4.94 5.45.79-4 3.84.99 5.43-4.88-2.56L16 30l1-5.43-4-3.84 5.6-.79L21 15z'
  }));
});
Event32.displayName = 'Event32';
Event32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Event32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Event24 = React.forwardRef(function (_ref708, ref) {
  var className = _ref708.className,
      children = _ref708.children,
      style = _ref708.style,
      tabIndex = _ref708.tabIndex,
      rest = _objectWithoutProperties$2(_ref708, ["className", "children", "style", "tabIndex"]);

  var _getAttributes708 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes708.tabindex,
      props = _objectWithoutProperties$2(_getAttributes708, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2z'
  }), React.createElement('path', {
    d: 'M21 15l2.55 4.94 5.45.79-4 3.84.99 5.43-4.88-2.56L16 30l1-5.43-4-3.84 5.6-.79L21 15z'
  }));
});
Event24.displayName = 'Event24';
Event24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Event24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Event20 = React.forwardRef(function (_ref709, ref) {
  var className = _ref709.className,
      children = _ref709.children,
      style = _ref709.style,
      tabIndex = _ref709.tabIndex,
      rest = _objectWithoutProperties$2(_ref709, ["className", "children", "style", "tabIndex"]);

  var _getAttributes709 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes709.tabindex,
      props = _objectWithoutProperties$2(_getAttributes709, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6a2 2 0 0 0-2-2h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V6h4v2h2V6h8v2h2V6h4v6h2z'
  }), React.createElement('path', {
    d: 'M21 15l2.55 4.94 5.45.79-4 3.84.99 5.43-4.88-2.56L16 30l1-5.43-4-3.84 5.6-.79L21 15z'
  }));
});
Event20.displayName = 'Event20';
Event20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Event20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ExamMode32 = React.forwardRef(function (_ref710, ref) {
  var className = _ref710.className,
      children = _ref710.children,
      style = _ref710.style,
      tabIndex = _ref710.tabIndex,
      rest = _objectWithoutProperties$2(_ref710, ["className", "children", "style", "tabIndex"]);

  var _getAttributes710 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes710.tabindex,
      props = _objectWithoutProperties$2(_getAttributes710, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 23v3H7v-9.17l3.59 3.58L12 19l-6-6-6 6 1.41 1.41L5 16.83V26a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-3zm2-16v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5h12a2 2 0 0 1 2 2zM8 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM4 4v4h4V4z'
  }));
});
ExamMode32.displayName = 'ExamMode32';
ExamMode32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ExamMode32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ExamMode24 = React.forwardRef(function (_ref711, ref) {
  var className = _ref711.className,
      children = _ref711.children,
      style = _ref711.style,
      tabIndex = _ref711.tabIndex,
      rest = _objectWithoutProperties$2(_ref711, ["className", "children", "style", "tabIndex"]);

  var _getAttributes711 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes711.tabindex,
      props = _objectWithoutProperties$2(_getAttributes711, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 23v3H7v-9.17l3.59 3.58L12 19l-6-6-6 6 1.41 1.41L5 16.83V26a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-3zm2-16v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5h12a2 2 0 0 1 2 2zM8 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM4 4v4h4V4z'
  }));
});
ExamMode24.displayName = 'ExamMode24';
ExamMode24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ExamMode24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ExamMode20 = React.forwardRef(function (_ref712, ref) {
  var className = _ref712.className,
      children = _ref712.children,
      style = _ref712.style,
      tabIndex = _ref712.tabIndex,
      rest = _objectWithoutProperties$2(_ref712, ["className", "children", "style", "tabIndex"]);

  var _getAttributes712 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes712.tabindex,
      props = _objectWithoutProperties$2(_getAttributes712, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 23v3H7v-9.17l3.59 3.58L12 19l-6-6-6 6 1.41 1.41L5 16.83V26a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-3zm2-16v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5h12a2 2 0 0 1 2 2zM8 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM4 4v4h4V4z'
  }));
});
ExamMode20.displayName = 'ExamMode20';
ExamMode20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ExamMode20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Export32 = React.forwardRef(function (_ref713, ref) {
  var className = _ref713.className,
      children = _ref713.children,
      style = _ref713.style,
      tabIndex = _ref713.tabIndex,
      rest = _objectWithoutProperties$2(_ref713, ["className", "children", "style", "tabIndex"]);

  var _getAttributes713 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes713.tabindex,
      props = _objectWithoutProperties$2(_getAttributes713, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 24v4H6v-4H4v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4z'
  }), React.createElement('path', {
    d: 'M6 12l1.41 1.4L15 5.83V25h2V5.83l7.59 7.57L26 12 16 2 6 12z'
  }));
});
Export32.displayName = 'Export32';
Export32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Export32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Export24 = React.forwardRef(function (_ref714, ref) {
  var className = _ref714.className,
      children = _ref714.children,
      style = _ref714.style,
      tabIndex = _ref714.tabIndex,
      rest = _objectWithoutProperties$2(_ref714, ["className", "children", "style", "tabIndex"]);

  var _getAttributes714 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes714.tabindex,
      props = _objectWithoutProperties$2(_getAttributes714, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 24v4H6v-4H4v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4z'
  }), React.createElement('path', {
    d: 'M6 12l1.41 1.4L15 5.83V25h2V5.83l7.59 7.57L26 12 16 2 6 12z'
  }));
});
Export24.displayName = 'Export24';
Export24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Export24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Export20 = React.forwardRef(function (_ref715, ref) {
  var className = _ref715.className,
      children = _ref715.children,
      style = _ref715.style,
      tabIndex = _ref715.tabIndex,
      rest = _objectWithoutProperties$2(_ref715, ["className", "children", "style", "tabIndex"]);

  var _getAttributes715 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes715.tabindex,
      props = _objectWithoutProperties$2(_getAttributes715, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 24v4H6v-4H4v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4z'
  }), React.createElement('path', {
    d: 'M6 12l1.41 1.4L15 5.83V25h2V5.83l7.59 7.57L26 12 16 2 6 12z'
  }));
});
Export20.displayName = 'Export20';
Export20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Export20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Eyedropper32 = React.forwardRef(function (_ref716, ref) {
  var className = _ref716.className,
      children = _ref716.children,
      style = _ref716.style,
      tabIndex = _ref716.tabIndex,
      rest = _objectWithoutProperties$2(_ref716, ["className", "children", "style", "tabIndex"]);

  var _getAttributes716 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes716.tabindex,
      props = _objectWithoutProperties$2(_getAttributes716, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 27h3v3H2zM29.71 7.29l-5-5a1 1 0 0 0-1.41 0L20 5.59l-1.29-1.3-1.42 1.42L18.59 7 8.29 17.29A1 1 0 0 0 8 18v1.59l-2.71 2.7a1 1 0 0 0 0 1.41l3 3a1 1 0 0 0 1.41 0l2.71-2.7H14a1 1 0 0 0 .71-.29L25 13.41l1.29 1.3 1.42-1.42-1.3-1.29 3.3-3.29a1 1 0 0 0 0-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z'
  }));
});
Eyedropper32.displayName = 'Eyedropper32';
Eyedropper32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Eyedropper32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Eyedropper24 = React.forwardRef(function (_ref717, ref) {
  var className = _ref717.className,
      children = _ref717.children,
      style = _ref717.style,
      tabIndex = _ref717.tabIndex,
      rest = _objectWithoutProperties$2(_ref717, ["className", "children", "style", "tabIndex"]);

  var _getAttributes717 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes717.tabindex,
      props = _objectWithoutProperties$2(_getAttributes717, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 27h3v3H2zM29.71 7.29l-5-5a1 1 0 0 0-1.41 0L20 5.59l-1.29-1.3-1.42 1.42L18.59 7 8.29 17.29A1 1 0 0 0 8 18v1.59l-2.71 2.7a1 1 0 0 0 0 1.41l3 3a1 1 0 0 0 1.41 0l2.71-2.7H14a1 1 0 0 0 .71-.29L25 13.41l1.29 1.3 1.42-1.42-1.3-1.29 3.3-3.29a1 1 0 0 0 0-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z'
  }));
});
Eyedropper24.displayName = 'Eyedropper24';
Eyedropper24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Eyedropper24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Eyedropper20 = React.forwardRef(function (_ref718, ref) {
  var className = _ref718.className,
      children = _ref718.children,
      style = _ref718.style,
      tabIndex = _ref718.tabIndex,
      rest = _objectWithoutProperties$2(_ref718, ["className", "children", "style", "tabIndex"]);

  var _getAttributes718 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes718.tabindex,
      props = _objectWithoutProperties$2(_getAttributes718, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 27h3v3H2zM29.71 7.29l-5-5a1 1 0 0 0-1.41 0L20 5.59l-1.29-1.3-1.42 1.42L18.59 7 8.29 17.29A1 1 0 0 0 8 18v1.59l-2.71 2.7a1 1 0 0 0 0 1.41l3 3a1 1 0 0 0 1.41 0l2.71-2.7H14a1 1 0 0 0 .71-.29L25 13.41l1.29 1.3 1.42-1.42-1.3-1.29 3.3-3.29a1 1 0 0 0 0-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z'
  }));
});
Eyedropper20.displayName = 'Eyedropper20';
Eyedropper20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Eyedropper20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivatedAdd32 = React.forwardRef(function (_ref719, ref) {
  var className = _ref719.className,
      children = _ref719.children,
      style = _ref719.style,
      tabIndex = _ref719.tabIndex,
      rest = _objectWithoutProperties$2(_ref719, ["className", "children", "style", "tabIndex"]);

  var _getAttributes719 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes719.tabindex,
      props = _objectWithoutProperties$2(_getAttributes719, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 4h-4V0h-2v4h-4v2h4v4h2V6h4V4zm-18.5 7a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM9 20a8.13 8.13 0 0 0 14 0z'
  }), React.createElement('path', {
    d: 'M27.82 14A12 12 0 1 1 16 4V2a14 14 0 1 0 14 14 14.71 14.71 0 0 0-.16-2z'
  }));
});
FaceActivatedAdd32.displayName = 'FaceActivatedAdd32';
FaceActivatedAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivatedAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivatedAdd24 = React.forwardRef(function (_ref720, ref) {
  var className = _ref720.className,
      children = _ref720.children,
      style = _ref720.style,
      tabIndex = _ref720.tabIndex,
      rest = _objectWithoutProperties$2(_ref720, ["className", "children", "style", "tabIndex"]);

  var _getAttributes720 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes720.tabindex,
      props = _objectWithoutProperties$2(_getAttributes720, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 4h-4V0h-2v4h-4v2h4v4h2V6h4V4zm-18.5 7a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM9 20a8.13 8.13 0 0 0 14 0z'
  }), React.createElement('path', {
    d: 'M27.82 14A12 12 0 1 1 16 4V2a14 14 0 1 0 14 14 14.71 14.71 0 0 0-.16-2z'
  }));
});
FaceActivatedAdd24.displayName = 'FaceActivatedAdd24';
FaceActivatedAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivatedAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivatedAdd20 = React.forwardRef(function (_ref721, ref) {
  var className = _ref721.className,
      children = _ref721.children,
      style = _ref721.style,
      tabIndex = _ref721.tabIndex,
      rest = _objectWithoutProperties$2(_ref721, ["className", "children", "style", "tabIndex"]);

  var _getAttributes721 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes721.tabindex,
      props = _objectWithoutProperties$2(_getAttributes721, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 4h-4V0h-2v4h-4v2h4v4h2V6h4V4zm-18.5 7a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM9 20a8.13 8.13 0 0 0 14 0z'
  }), React.createElement('path', {
    d: 'M27.82 14A12 12 0 1 1 16 4V2a14 14 0 1 0 14 14 14.71 14.71 0 0 0-.16-2z'
  }));
});
FaceActivatedAdd20.displayName = 'FaceActivatedAdd20';
FaceActivatedAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivatedAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivatedFilled32 = React.forwardRef(function (_ref722, ref) {
  var className = _ref722.className,
      children = _ref722.children,
      style = _ref722.style,
      tabIndex = _ref722.tabIndex,
      rest = _objectWithoutProperties$2(_ref722, ["className", "children", "style", "tabIndex"]);

  var _getAttributes722 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes722.tabindex,
      props = _objectWithoutProperties$2(_getAttributes722, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.5-2.5zM16 24a8.11 8.11 0 0 1-7-4h14a8.11 8.11 0 0 1-7 4zm4.5-8a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FaceActivatedFilled32.displayName = 'FaceActivatedFilled32';
FaceActivatedFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivatedFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivatedFilled24 = React.forwardRef(function (_ref723, ref) {
  var className = _ref723.className,
      children = _ref723.children,
      style = _ref723.style,
      tabIndex = _ref723.tabIndex,
      rest = _objectWithoutProperties$2(_ref723, ["className", "children", "style", "tabIndex"]);

  var _getAttributes723 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes723.tabindex,
      props = _objectWithoutProperties$2(_getAttributes723, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.5-2.5zM16 24a8.11 8.11 0 0 1-7-4h14a8.11 8.11 0 0 1-7 4zm4.5-8a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FaceActivatedFilled24.displayName = 'FaceActivatedFilled24';
FaceActivatedFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivatedFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivatedFilled20 = React.forwardRef(function (_ref724, ref) {
  var className = _ref724.className,
      children = _ref724.children,
      style = _ref724.style,
      tabIndex = _ref724.tabIndex,
      rest = _objectWithoutProperties$2(_ref724, ["className", "children", "style", "tabIndex"]);

  var _getAttributes724 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes724.tabindex,
      props = _objectWithoutProperties$2(_getAttributes724, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.5-2.5zM16 24a8.11 8.11 0 0 1-7-4h14a8.11 8.11 0 0 1-7 4zm4.5-8a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FaceActivatedFilled20.displayName = 'FaceActivatedFilled20';
FaceActivatedFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivatedFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivated32 = React.forwardRef(function (_ref725, ref) {
  var className = _ref725.className,
      children = _ref725.children,
      style = _ref725.style,
      tabIndex = _ref725.tabIndex,
      rest = _objectWithoutProperties$2(_ref725, ["className", "children", "style", "tabIndex"]);

  var _getAttributes725 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes725.tabindex,
      props = _objectWithoutProperties$2(_getAttributes725, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM9 20a8.13 8.13 0 0 0 14 0z'
  }));
});
FaceActivated32.displayName = 'FaceActivated32';
FaceActivated32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivated32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivated24 = React.forwardRef(function (_ref726, ref) {
  var className = _ref726.className,
      children = _ref726.children,
      style = _ref726.style,
      tabIndex = _ref726.tabIndex,
      rest = _objectWithoutProperties$2(_ref726, ["className", "children", "style", "tabIndex"]);

  var _getAttributes726 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes726.tabindex,
      props = _objectWithoutProperties$2(_getAttributes726, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM9 20a8.13 8.13 0 0 0 14 0z'
  }));
});
FaceActivated24.displayName = 'FaceActivated24';
FaceActivated24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivated24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceActivated20 = React.forwardRef(function (_ref727, ref) {
  var className = _ref727.className,
      children = _ref727.children,
      style = _ref727.style,
      tabIndex = _ref727.tabIndex,
      rest = _objectWithoutProperties$2(_ref727, ["className", "children", "style", "tabIndex"]);

  var _getAttributes727 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes727.tabindex,
      props = _objectWithoutProperties$2(_getAttributes727, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM9 20a8.13 8.13 0 0 0 14 0z'
  }));
});
FaceActivated20.displayName = 'FaceActivated20';
FaceActivated20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceActivated20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceAdd32 = React.forwardRef(function (_ref728, ref) {
  var className = _ref728.className,
      children = _ref728.children,
      style = _ref728.style,
      tabIndex = _ref728.tabIndex,
      rest = _objectWithoutProperties$2(_ref728, ["className", "children", "style", "tabIndex"]);

  var _getAttributes728 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes728.tabindex,
      props = _objectWithoutProperties$2(_getAttributes728, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22a6 6 0 0 1-5.14-2.92l-1.71 1a8 8 0 0 0 13.7 0l-1.71-1A6 6 0 0 1 16 22zM30 4h-4V0h-2v4h-4v2h4v4h2V6h4V4zm-18.5 7a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5z'
  }), React.createElement('path', {
    d: 'M27.61 13a12.33 12.33 0 0 1 .39 3A12 12 0 1 1 16 4V2a14 14 0 1 0 13.67 11z'
  }));
});
FaceAdd32.displayName = 'FaceAdd32';
FaceAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceAdd24 = React.forwardRef(function (_ref729, ref) {
  var className = _ref729.className,
      children = _ref729.children,
      style = _ref729.style,
      tabIndex = _ref729.tabIndex,
      rest = _objectWithoutProperties$2(_ref729, ["className", "children", "style", "tabIndex"]);

  var _getAttributes729 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes729.tabindex,
      props = _objectWithoutProperties$2(_getAttributes729, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22a6 6 0 0 1-5.14-2.92l-1.71 1a8 8 0 0 0 13.7 0l-1.71-1A6 6 0 0 1 16 22zM30 4h-4V0h-2v4h-4v2h4v4h2V6h4V4zm-18.5 7a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5z'
  }), React.createElement('path', {
    d: 'M27.61 13a12.33 12.33 0 0 1 .39 3A12 12 0 1 1 16 4V2a14 14 0 1 0 13.67 11z'
  }));
});
FaceAdd24.displayName = 'FaceAdd24';
FaceAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceAdd20 = React.forwardRef(function (_ref730, ref) {
  var className = _ref730.className,
      children = _ref730.children,
      style = _ref730.style,
      tabIndex = _ref730.tabIndex,
      rest = _objectWithoutProperties$2(_ref730, ["className", "children", "style", "tabIndex"]);

  var _getAttributes730 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes730.tabindex,
      props = _objectWithoutProperties$2(_getAttributes730, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22a6 6 0 0 1-5.14-2.92l-1.71 1a8 8 0 0 0 13.7 0l-1.71-1A6 6 0 0 1 16 22zM30 4h-4V0h-2v4h-4v2h4v4h2V6h4V4zm-18.5 7a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5z'
  }), React.createElement('path', {
    d: 'M27.61 13a12.33 12.33 0 0 1 .39 3A12 12 0 1 1 16 4V2a14 14 0 1 0 13.67 11z'
  }));
});
FaceAdd20.displayName = 'FaceAdd20';
FaceAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceCool32 = React.forwardRef(function (_ref731, ref) {
  var className = _ref731.className,
      children = _ref731.children,
      style = _ref731.style,
      tabIndex = _ref731.tabIndex,
      rest = _objectWithoutProperties$2(_ref731, ["className", "children", "style", "tabIndex"]);

  var _getAttributes731 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes731.tabindex,
      props = _objectWithoutProperties$2(_getAttributes731, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 24a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 10.89 7H25a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5.11A12 12 0 0 1 16 4zm0 24A12 12 0 0 1 4 16a11.86 11.86 0 0 1 .4-3H7v2a2 2 0 0 0 2 2h3.31a2 2 0 0 0 2-1.67l.52-3.33h2.34l.55 3.33a2 2 0 0 0 2 1.67H23a2 2 0 0 0 2-2v-2h2.6a11.86 11.86 0 0 1 .4 3 12 12 0 0 1-12 12z'
  }));
});
FaceCool32.displayName = 'FaceCool32';
FaceCool32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceCool32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceCool24 = React.forwardRef(function (_ref732, ref) {
  var className = _ref732.className,
      children = _ref732.children,
      style = _ref732.style,
      tabIndex = _ref732.tabIndex,
      rest = _objectWithoutProperties$2(_ref732, ["className", "children", "style", "tabIndex"]);

  var _getAttributes732 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes732.tabindex,
      props = _objectWithoutProperties$2(_getAttributes732, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 24a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 10.89 7H25a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5.11A12 12 0 0 1 16 4zm0 24A12 12 0 0 1 4 16a11.86 11.86 0 0 1 .4-3H7v2a2 2 0 0 0 2 2h3.31a2 2 0 0 0 2-1.67l.52-3.33h2.34l.55 3.33a2 2 0 0 0 2 1.67H23a2 2 0 0 0 2-2v-2h2.6a11.86 11.86 0 0 1 .4 3 12 12 0 0 1-12 12z'
  }));
});
FaceCool24.displayName = 'FaceCool24';
FaceCool24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceCool24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceCool20 = React.forwardRef(function (_ref733, ref) {
  var className = _ref733.className,
      children = _ref733.children,
      style = _ref733.style,
      tabIndex = _ref733.tabIndex,
      rest = _objectWithoutProperties$2(_ref733, ["className", "children", "style", "tabIndex"]);

  var _getAttributes733 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes733.tabindex,
      props = _objectWithoutProperties$2(_getAttributes733, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 24a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 10.89 7H25a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5.11A12 12 0 0 1 16 4zm0 24A12 12 0 0 1 4 16a11.86 11.86 0 0 1 .4-3H7v2a2 2 0 0 0 2 2h3.31a2 2 0 0 0 2-1.67l.52-3.33h2.34l.55 3.33a2 2 0 0 0 2 1.67H23a2 2 0 0 0 2-2v-2h2.6a11.86 11.86 0 0 1 .4 3 12 12 0 0 1-12 12z'
  }));
});
FaceCool20.displayName = 'FaceCool20';
FaceCool20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceCool20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDissatisfiedFilled32 = React.forwardRef(function (_ref734, ref) {
  var className = _ref734.className,
      children = _ref734.children,
      style = _ref734.style,
      tabIndex = _ref734.tabIndex,
      rest = _objectWithoutProperties$2(_ref734, ["className", "children", "style", "tabIndex"]);

  var _getAttributes734 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes734.tabindex,
      props = _objectWithoutProperties$2(_getAttributes734, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.54-2.5zm9.64 12.92a6 6 0 0 0-10.28 0l-1.71-1a8 8 0 0 1 13.7 0zM20.5 16a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
  }));
});
FaceDissatisfiedFilled32.displayName = 'FaceDissatisfiedFilled32';
FaceDissatisfiedFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDissatisfiedFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDissatisfiedFilled24 = React.forwardRef(function (_ref735, ref) {
  var className = _ref735.className,
      children = _ref735.children,
      style = _ref735.style,
      tabIndex = _ref735.tabIndex,
      rest = _objectWithoutProperties$2(_ref735, ["className", "children", "style", "tabIndex"]);

  var _getAttributes735 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes735.tabindex,
      props = _objectWithoutProperties$2(_getAttributes735, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.54-2.5zm9.64 12.92a6 6 0 0 0-10.28 0l-1.71-1a8 8 0 0 1 13.7 0zM20.5 16a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
  }));
});
FaceDissatisfiedFilled24.displayName = 'FaceDissatisfiedFilled24';
FaceDissatisfiedFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDissatisfiedFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDissatisfiedFilled20 = React.forwardRef(function (_ref736, ref) {
  var className = _ref736.className,
      children = _ref736.children,
      style = _ref736.style,
      tabIndex = _ref736.tabIndex,
      rest = _objectWithoutProperties$2(_ref736, ["className", "children", "style", "tabIndex"]);

  var _getAttributes736 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes736.tabindex,
      props = _objectWithoutProperties$2(_getAttributes736, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.54-2.5zm9.64 12.92a6 6 0 0 0-10.28 0l-1.71-1a8 8 0 0 1 13.7 0zM20.5 16a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
  }));
});
FaceDissatisfiedFilled20.displayName = 'FaceDissatisfiedFilled20';
FaceDissatisfiedFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDissatisfiedFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDissatisfied32 = React.forwardRef(function (_ref737, ref) {
  var className = _ref737.className,
      children = _ref737.children,
      style = _ref737.style,
      tabIndex = _ref737.tabIndex,
      rest = _objectWithoutProperties$2(_ref737, ["className", "children", "style", "tabIndex"]);

  var _getAttributes737 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes737.tabindex,
      props = _objectWithoutProperties$2(_getAttributes737, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM16 19a8 8 0 0 0-6.85 3.89l1.71 1a6 6 0 0 1 10.28 0l1.71-1A8 8 0 0 0 16 19z'
  }));
});
FaceDissatisfied32.displayName = 'FaceDissatisfied32';
FaceDissatisfied32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDissatisfied32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDissatisfied24 = React.forwardRef(function (_ref738, ref) {
  var className = _ref738.className,
      children = _ref738.children,
      style = _ref738.style,
      tabIndex = _ref738.tabIndex,
      rest = _objectWithoutProperties$2(_ref738, ["className", "children", "style", "tabIndex"]);

  var _getAttributes738 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes738.tabindex,
      props = _objectWithoutProperties$2(_getAttributes738, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM16 19a8 8 0 0 0-6.85 3.89l1.71 1a6 6 0 0 1 10.28 0l1.71-1A8 8 0 0 0 16 19z'
  }));
});
FaceDissatisfied24.displayName = 'FaceDissatisfied24';
FaceDissatisfied24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDissatisfied24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDissatisfied20 = React.forwardRef(function (_ref739, ref) {
  var className = _ref739.className,
      children = _ref739.children,
      style = _ref739.style,
      tabIndex = _ref739.tabIndex,
      rest = _objectWithoutProperties$2(_ref739, ["className", "children", "style", "tabIndex"]);

  var _getAttributes739 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes739.tabindex,
      props = _objectWithoutProperties$2(_getAttributes739, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM16 19a8 8 0 0 0-6.85 3.89l1.71 1a6 6 0 0 1 10.28 0l1.71-1A8 8 0 0 0 16 19z'
  }));
});
FaceDissatisfied20.displayName = 'FaceDissatisfied20';
FaceDissatisfied20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDissatisfied20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDizzyFilled32 = React.forwardRef(function (_ref740, ref) {
  var className = _ref740.className,
      children = _ref740.children,
      style = _ref740.style,
      tabIndex = _ref740.tabIndex,
      rest = _objectWithoutProperties$2(_ref740, ["className", "children", "style", "tabIndex"]);

  var _getAttributes740 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes740.tabindex,
      props = _objectWithoutProperties$2(_getAttributes740, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM9 16.41L7.59 15l2-2-2-2L9 9.59l2 2 2-2L14.41 11l-2 2 2 2L13 16.41l-2-2zM16 25a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm8.41-10L23 16.41l-2-2-2 2L17.59 15l2-2-2-2L19 9.59l2 2 2-2L24.41 11l-2 2z'
  }));
});
FaceDizzyFilled32.displayName = 'FaceDizzyFilled32';
FaceDizzyFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDizzyFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDizzyFilled24 = React.forwardRef(function (_ref741, ref) {
  var className = _ref741.className,
      children = _ref741.children,
      style = _ref741.style,
      tabIndex = _ref741.tabIndex,
      rest = _objectWithoutProperties$2(_ref741, ["className", "children", "style", "tabIndex"]);

  var _getAttributes741 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes741.tabindex,
      props = _objectWithoutProperties$2(_getAttributes741, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM9 16.41L7.59 15l2-2-2-2L9 9.59l2 2 2-2L14.41 11l-2 2 2 2L13 16.41l-2-2zM16 25a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm8.41-10L23 16.41l-2-2-2 2L17.59 15l2-2-2-2L19 9.59l2 2 2-2L24.41 11l-2 2z'
  }));
});
FaceDizzyFilled24.displayName = 'FaceDizzyFilled24';
FaceDizzyFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDizzyFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDizzyFilled20 = React.forwardRef(function (_ref742, ref) {
  var className = _ref742.className,
      children = _ref742.children,
      style = _ref742.style,
      tabIndex = _ref742.tabIndex,
      rest = _objectWithoutProperties$2(_ref742, ["className", "children", "style", "tabIndex"]);

  var _getAttributes742 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes742.tabindex,
      props = _objectWithoutProperties$2(_getAttributes742, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM9 16.41L7.59 15l2-2-2-2L9 9.59l2 2 2-2L14.41 11l-2 2 2 2L13 16.41l-2-2zM16 25a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm8.41-10L23 16.41l-2-2-2 2L17.59 15l2-2-2-2L19 9.59l2 2 2-2L24.41 11l-2 2z'
  }));
});
FaceDizzyFilled20.displayName = 'FaceDizzyFilled20';
FaceDizzyFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDizzyFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDizzy32 = React.forwardRef(function (_ref743, ref) {
  var className = _ref743.className,
      children = _ref743.children,
      style = _ref743.style,
      tabIndex = _ref743.tabIndex,
      rest = _objectWithoutProperties$2(_ref743, ["className", "children", "style", "tabIndex"]);

  var _getAttributes743 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes743.tabindex,
      props = _objectWithoutProperties$2(_getAttributes743, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M24.41 11L23 9.59l-2 2-2-2L17.59 11l2 2-2 2L19 16.41l2-2 2 2L24.41 15l-2-2 2-2zm-10 0L13 9.59l-2 2-2-2L7.59 11l2 2-2 2L9 16.41l2-2 2 2L14.41 15l-2-2 2-2zM16 19a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'
  }));
});
FaceDizzy32.displayName = 'FaceDizzy32';
FaceDizzy32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDizzy32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDizzy24 = React.forwardRef(function (_ref744, ref) {
  var className = _ref744.className,
      children = _ref744.children,
      style = _ref744.style,
      tabIndex = _ref744.tabIndex,
      rest = _objectWithoutProperties$2(_ref744, ["className", "children", "style", "tabIndex"]);

  var _getAttributes744 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes744.tabindex,
      props = _objectWithoutProperties$2(_getAttributes744, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M24.41 11L23 9.59l-2 2-2-2L17.59 11l2 2-2 2L19 16.41l2-2 2 2L24.41 15l-2-2 2-2zm-10 0L13 9.59l-2 2-2-2L7.59 11l2 2-2 2L9 16.41l2-2 2 2L14.41 15l-2-2 2-2zM16 19a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'
  }));
});
FaceDizzy24.displayName = 'FaceDizzy24';
FaceDizzy24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDizzy24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceDizzy20 = React.forwardRef(function (_ref745, ref) {
  var className = _ref745.className,
      children = _ref745.children,
      style = _ref745.style,
      tabIndex = _ref745.tabIndex,
      rest = _objectWithoutProperties$2(_ref745, ["className", "children", "style", "tabIndex"]);

  var _getAttributes745 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes745.tabindex,
      props = _objectWithoutProperties$2(_getAttributes745, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M24.41 11L23 9.59l-2 2-2-2L17.59 11l2 2-2 2L19 16.41l2-2 2 2L24.41 15l-2-2 2-2zm-10 0L13 9.59l-2 2-2-2L7.59 11l2 2-2 2L9 16.41l2-2 2 2L14.41 15l-2-2 2-2zM16 19a3 3 0 1 0 3 3 3 3 0 0 0-3-3z'
  }));
});
FaceDizzy20.displayName = 'FaceDizzy20';
FaceDizzy20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceDizzy20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceNeutralFilled32 = React.forwardRef(function (_ref746, ref) {
  var className = _ref746.className,
      children = _ref746.children,
      style = _ref746.style,
      tabIndex = _ref746.tabIndex,
      rest = _objectWithoutProperties$2(_ref746, ["className", "children", "style", "tabIndex"]);

  var _getAttributes746 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes746.tabindex,
      props = _objectWithoutProperties$2(_getAttributes746, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM9 13.5a2.5 2.5 0 1 1 2.5 2.5A2.5 2.5 0 0 1 9 13.5zM22 22H10v-2h12zm-1.5-6a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z'
  }));
});
FaceNeutralFilled32.displayName = 'FaceNeutralFilled32';
FaceNeutralFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceNeutralFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceNeutralFilled24 = React.forwardRef(function (_ref747, ref) {
  var className = _ref747.className,
      children = _ref747.children,
      style = _ref747.style,
      tabIndex = _ref747.tabIndex,
      rest = _objectWithoutProperties$2(_ref747, ["className", "children", "style", "tabIndex"]);

  var _getAttributes747 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes747.tabindex,
      props = _objectWithoutProperties$2(_getAttributes747, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM9 13.5a2.5 2.5 0 1 1 2.5 2.5A2.5 2.5 0 0 1 9 13.5zM22 22H10v-2h12zm-1.5-6a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z'
  }));
});
FaceNeutralFilled24.displayName = 'FaceNeutralFilled24';
FaceNeutralFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceNeutralFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceNeutralFilled20 = React.forwardRef(function (_ref748, ref) {
  var className = _ref748.className,
      children = _ref748.children,
      style = _ref748.style,
      tabIndex = _ref748.tabIndex,
      rest = _objectWithoutProperties$2(_ref748, ["className", "children", "style", "tabIndex"]);

  var _getAttributes748 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes748.tabindex,
      props = _objectWithoutProperties$2(_getAttributes748, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM9 13.5a2.5 2.5 0 1 1 2.5 2.5A2.5 2.5 0 0 1 9 13.5zM22 22H10v-2h12zm-1.5-6a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z'
  }));
});
FaceNeutralFilled20.displayName = 'FaceNeutralFilled20';
FaceNeutralFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceNeutralFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceNeutral32 = React.forwardRef(function (_ref749, ref) {
  var className = _ref749.className,
      children = _ref749.children,
      style = _ref749.style,
      tabIndex = _ref749.tabIndex,
      rest = _objectWithoutProperties$2(_ref749, ["className", "children", "style", "tabIndex"]);

  var _getAttributes749 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes749.tabindex,
      props = _objectWithoutProperties$2(_getAttributes749, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM10 20h12v2H10z'
  }));
});
FaceNeutral32.displayName = 'FaceNeutral32';
FaceNeutral32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceNeutral32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceNeutral24 = React.forwardRef(function (_ref750, ref) {
  var className = _ref750.className,
      children = _ref750.children,
      style = _ref750.style,
      tabIndex = _ref750.tabIndex,
      rest = _objectWithoutProperties$2(_ref750, ["className", "children", "style", "tabIndex"]);

  var _getAttributes750 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes750.tabindex,
      props = _objectWithoutProperties$2(_getAttributes750, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM10 20h12v2H10z'
  }));
});
FaceNeutral24.displayName = 'FaceNeutral24';
FaceNeutral24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceNeutral24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceNeutral20 = React.forwardRef(function (_ref751, ref) {
  var className = _ref751.className,
      children = _ref751.children,
      style = _ref751.style,
      tabIndex = _ref751.tabIndex,
      rest = _objectWithoutProperties$2(_ref751, ["className", "children", "style", "tabIndex"]);

  var _getAttributes751 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes751.tabindex,
      props = _objectWithoutProperties$2(_getAttributes751, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM10 20h12v2H10z'
  }));
});
FaceNeutral20.displayName = 'FaceNeutral20';
FaceNeutral20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceNeutral20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FacePendingFilled32 = React.forwardRef(function (_ref752, ref) {
  var className = _ref752.className,
      children = _ref752.children,
      style = _ref752.style,
      tabIndex = _ref752.tabIndex,
      rest = _objectWithoutProperties$2(_ref752, ["className", "children", "style", "tabIndex"]);

  var _getAttributes752 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes752.tabindex,
      props = _objectWithoutProperties$2(_getAttributes752, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 14a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5zm9 0a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FacePendingFilled32.displayName = 'FacePendingFilled32';
FacePendingFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FacePendingFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FacePendingFilled24 = React.forwardRef(function (_ref753, ref) {
  var className = _ref753.className,
      children = _ref753.children,
      style = _ref753.style,
      tabIndex = _ref753.tabIndex,
      rest = _objectWithoutProperties$2(_ref753, ["className", "children", "style", "tabIndex"]);

  var _getAttributes753 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes753.tabindex,
      props = _objectWithoutProperties$2(_getAttributes753, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 14a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5zm9 0a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FacePendingFilled24.displayName = 'FacePendingFilled24';
FacePendingFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FacePendingFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FacePendingFilled20 = React.forwardRef(function (_ref754, ref) {
  var className = _ref754.className,
      children = _ref754.children,
      style = _ref754.style,
      tabIndex = _ref754.tabIndex,
      rest = _objectWithoutProperties$2(_ref754, ["className", "children", "style", "tabIndex"]);

  var _getAttributes754 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes754.tabindex,
      props = _objectWithoutProperties$2(_getAttributes754, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 14a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5zm9 0a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FacePendingFilled20.displayName = 'FacePendingFilled20';
FacePendingFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FacePendingFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FacePending32 = React.forwardRef(function (_ref755, ref) {
  var className = _ref755.className,
      children = _ref755.children,
      style = _ref755.style,
      tabIndex = _ref755.tabIndex,
      rest = _objectWithoutProperties$2(_ref755, ["className", "children", "style", "tabIndex"]);

  var _getAttributes755 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes755.tabindex,
      props = _objectWithoutProperties$2(_getAttributes755, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5z'
  }));
});
FacePending32.displayName = 'FacePending32';
FacePending32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FacePending32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FacePending24 = React.forwardRef(function (_ref756, ref) {
  var className = _ref756.className,
      children = _ref756.children,
      style = _ref756.style,
      tabIndex = _ref756.tabIndex,
      rest = _objectWithoutProperties$2(_ref756, ["className", "children", "style", "tabIndex"]);

  var _getAttributes756 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes756.tabindex,
      props = _objectWithoutProperties$2(_getAttributes756, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5z'
  }));
});
FacePending24.displayName = 'FacePending24';
FacePending24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FacePending24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FacePending20 = React.forwardRef(function (_ref757, ref) {
  var className = _ref757.className,
      children = _ref757.children,
      style = _ref757.style,
      tabIndex = _ref757.tabIndex,
      rest = _objectWithoutProperties$2(_ref757, ["className", "children", "style", "tabIndex"]);

  var _getAttributes757 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes757.tabindex,
      props = _objectWithoutProperties$2(_getAttributes757, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5z'
  }));
});
FacePending20.displayName = 'FacePending20';
FacePending20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FacePending20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceSatisfiedFilled32 = React.forwardRef(function (_ref758, ref) {
  var className = _ref758.className,
      children = _ref758.children,
      style = _ref758.style,
      tabIndex = _ref758.tabIndex,
      rest = _objectWithoutProperties$2(_ref758, ["className", "children", "style", "tabIndex"]);

  var _getAttributes758 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes758.tabindex,
      props = _objectWithoutProperties$2(_getAttributes758, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.5-2.5zM16 24a8 8 0 0 1-6.85-3.89l1.71-1a6 6 0 0 0 10.28 0l1.71 1A8 8 0 0 1 16 24zm4.5-8a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FaceSatisfiedFilled32.displayName = 'FaceSatisfiedFilled32';
FaceSatisfiedFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceSatisfiedFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceSatisfiedFilled24 = React.forwardRef(function (_ref759, ref) {
  var className = _ref759.className,
      children = _ref759.children,
      style = _ref759.style,
      tabIndex = _ref759.tabIndex,
      rest = _objectWithoutProperties$2(_ref759, ["className", "children", "style", "tabIndex"]);

  var _getAttributes759 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes759.tabindex,
      props = _objectWithoutProperties$2(_getAttributes759, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.5-2.5zM16 24a8 8 0 0 1-6.85-3.89l1.71-1a6 6 0 0 0 10.28 0l1.71 1A8 8 0 0 1 16 24zm4.5-8a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FaceSatisfiedFilled24.displayName = 'FaceSatisfiedFilled24';
FaceSatisfiedFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceSatisfiedFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceSatisfiedFilled20 = React.forwardRef(function (_ref760, ref) {
  var className = _ref760.className,
      children = _ref760.children,
      style = _ref760.style,
      tabIndex = _ref760.tabIndex,
      rest = _objectWithoutProperties$2(_ref760, ["className", "children", "style", "tabIndex"]);

  var _getAttributes760 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes760.tabindex,
      props = _objectWithoutProperties$2(_getAttributes760, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-4.5 9A2.5 2.5 0 1 1 9 13.5a2.48 2.48 0 0 1 2.5-2.5zM16 24a8 8 0 0 1-6.85-3.89l1.71-1a6 6 0 0 0 10.28 0l1.71 1A8 8 0 0 1 16 24zm4.5-8a2.5 2.5 0 1 1 2.5-2.5 2.48 2.48 0 0 1-2.5 2.5z'
  }));
});
FaceSatisfiedFilled20.displayName = 'FaceSatisfiedFilled20';
FaceSatisfiedFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceSatisfiedFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceSatisfied32 = React.forwardRef(function (_ref761, ref) {
  var className = _ref761.className,
      children = _ref761.children,
      style = _ref761.style,
      tabIndex = _ref761.tabIndex,
      rest = _objectWithoutProperties$2(_ref761, ["className", "children", "style", "tabIndex"]);

  var _getAttributes761 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes761.tabindex,
      props = _objectWithoutProperties$2(_getAttributes761, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM16 24a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }));
});
FaceSatisfied32.displayName = 'FaceSatisfied32';
FaceSatisfied32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceSatisfied32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceSatisfied24 = React.forwardRef(function (_ref762, ref) {
  var className = _ref762.className,
      children = _ref762.children,
      style = _ref762.style,
      tabIndex = _ref762.tabIndex,
      rest = _objectWithoutProperties$2(_ref762, ["className", "children", "style", "tabIndex"]);

  var _getAttributes762 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes762.tabindex,
      props = _objectWithoutProperties$2(_getAttributes762, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM16 24a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }));
});
FaceSatisfied24.displayName = 'FaceSatisfied24';
FaceSatisfied24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceSatisfied24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceSatisfied20 = React.forwardRef(function (_ref763, ref) {
  var className = _ref763.className,
      children = _ref763.children,
      style = _ref763.style,
      tabIndex = _ref763.tabIndex,
      rest = _objectWithoutProperties$2(_ref763, ["className", "children", "style", "tabIndex"]);

  var _getAttributes763 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes763.tabindex,
      props = _objectWithoutProperties$2(_getAttributes763, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M11.5 11a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zm9 0a2.5 2.5 0 1 0 2.5 2.5 2.48 2.48 0 0 0-2.5-2.5zM16 24a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }));
});
FaceSatisfied20.displayName = 'FaceSatisfied20';
FaceSatisfied20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceSatisfied20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceWinkFilled32 = React.forwardRef(function (_ref764, ref) {
  var className = _ref764.className,
      children = _ref764.children,
      style = _ref764.style,
      tabIndex = _ref764.tabIndex,
      rest = _objectWithoutProperties$2(_ref764, ["className", "children", "style", "tabIndex"]);

  var _getAttributes764 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes764.tabindex,
      props = _objectWithoutProperties$2(_getAttributes764, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM8 13h6v2H8zm8 11a8 8 0 0 1-6.85-3.89l1.71-1a6 6 0 0 0 10.28 0l1.71 1A8 8 0 0 1 16 24zm4.5-8a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
  }));
});
FaceWinkFilled32.displayName = 'FaceWinkFilled32';
FaceWinkFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceWinkFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceWinkFilled24 = React.forwardRef(function (_ref765, ref) {
  var className = _ref765.className,
      children = _ref765.children,
      style = _ref765.style,
      tabIndex = _ref765.tabIndex,
      rest = _objectWithoutProperties$2(_ref765, ["className", "children", "style", "tabIndex"]);

  var _getAttributes765 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes765.tabindex,
      props = _objectWithoutProperties$2(_getAttributes765, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM8 13h6v2H8zm8 11a8 8 0 0 1-6.85-3.89l1.71-1a6 6 0 0 0 10.28 0l1.71 1A8 8 0 0 1 16 24zm4.5-8a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
  }));
});
FaceWinkFilled24.displayName = 'FaceWinkFilled24';
FaceWinkFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceWinkFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceWinkFilled20 = React.forwardRef(function (_ref766, ref) {
  var className = _ref766.className,
      children = _ref766.children,
      style = _ref766.style,
      tabIndex = _ref766.tabIndex,
      rest = _objectWithoutProperties$2(_ref766, ["className", "children", "style", "tabIndex"]);

  var _getAttributes766 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes766.tabindex,
      props = _objectWithoutProperties$2(_getAttributes766, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zM8 13h6v2H8zm8 11a8 8 0 0 1-6.85-3.89l1.71-1a6 6 0 0 0 10.28 0l1.71 1A8 8 0 0 1 16 24zm4.5-8a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
  }));
});
FaceWinkFilled20.displayName = 'FaceWinkFilled20';
FaceWinkFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceWinkFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceWink32 = React.forwardRef(function (_ref767, ref) {
  var className = _ref767.className,
      children = _ref767.children,
      style = _ref767.style,
      tabIndex = _ref767.tabIndex,
      rest = _objectWithoutProperties$2(_ref767, ["className", "children", "style", "tabIndex"]);

  var _getAttributes767 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes767.tabindex,
      props = _objectWithoutProperties$2(_getAttributes767, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M20.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM8 13h6v2H8zm8 11a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }));
});
FaceWink32.displayName = 'FaceWink32';
FaceWink32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceWink32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceWink24 = React.forwardRef(function (_ref768, ref) {
  var className = _ref768.className,
      children = _ref768.children,
      style = _ref768.style,
      tabIndex = _ref768.tabIndex,
      rest = _objectWithoutProperties$2(_ref768, ["className", "children", "style", "tabIndex"]);

  var _getAttributes768 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes768.tabindex,
      props = _objectWithoutProperties$2(_getAttributes768, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M20.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM8 13h6v2H8zm8 11a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }));
});
FaceWink24.displayName = 'FaceWink24';
FaceWink24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceWink24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FaceWink20 = React.forwardRef(function (_ref769, ref) {
  var className = _ref769.className,
      children = _ref769.children,
      style = _ref769.style,
      tabIndex = _ref769.tabIndex,
      rest = _objectWithoutProperties$2(_ref769, ["className", "children", "style", "tabIndex"]);

  var _getAttributes769 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes769.tabindex,
      props = _objectWithoutProperties$2(_getAttributes769, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M20.5 11a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5zM8 13h6v2H8zm8 11a8 8 0 0 0 6.85-3.89l-1.71-1a6 6 0 0 1-10.28 0l-1.71 1A8 8 0 0 0 16 24z'
  }));
});
FaceWink20.displayName = 'FaceWink20';
FaceWink20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FaceWink20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Fade32 = React.forwardRef(function (_ref770, ref) {
  var className = _ref770.className,
      children = _ref770.children,
      style = _ref770.style,
      tabIndex = _ref770.tabIndex,
      rest = _objectWithoutProperties$2(_ref770, ["className", "children", "style", "tabIndex"]);

  var _getAttributes770 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes770.tabindex,
      props = _objectWithoutProperties$2(_getAttributes770, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.24 25.14L7 26.67a13.79 13.79 0 0 0 4.18 2.44l.69-1.87a12 12 0 0 1-3.63-2.1zM4.19 18l-2 .41A14.09 14.09 0 0 0 3.86 23l1.73-1a12.44 12.44 0 0 1-1.4-4zm7.63-13.24l-.69-1.87A13.79 13.79 0 0 0 7 5.33l1.24 1.53a12 12 0 0 1 3.58-2.1zM5.59 10L3.86 9a14.37 14.37 0 0 0-1.64 4.59l2 .34A12.05 12.05 0 0 1 5.59 10zM16 2v2a12 12 0 0 1 0 24v2a14 14 0 0 0 0-28z'
  }));
});
Fade32.displayName = 'Fade32';
Fade32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Fade32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Fade24 = React.forwardRef(function (_ref771, ref) {
  var className = _ref771.className,
      children = _ref771.children,
      style = _ref771.style,
      tabIndex = _ref771.tabIndex,
      rest = _objectWithoutProperties$2(_ref771, ["className", "children", "style", "tabIndex"]);

  var _getAttributes771 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes771.tabindex,
      props = _objectWithoutProperties$2(_getAttributes771, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.24 25.14L7 26.67a13.79 13.79 0 0 0 4.18 2.44l.69-1.87a12 12 0 0 1-3.63-2.1zM4.19 18l-2 .41A14.09 14.09 0 0 0 3.86 23l1.73-1a12.44 12.44 0 0 1-1.4-4zm7.63-13.24l-.69-1.87A13.79 13.79 0 0 0 7 5.33l1.24 1.53a12 12 0 0 1 3.58-2.1zM5.59 10L3.86 9a14.37 14.37 0 0 0-1.64 4.59l2 .34A12.05 12.05 0 0 1 5.59 10zM16 2v2a12 12 0 0 1 0 24v2a14 14 0 0 0 0-28z'
  }));
});
Fade24.displayName = 'Fade24';
Fade24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Fade24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Fade20 = React.forwardRef(function (_ref772, ref) {
  var className = _ref772.className,
      children = _ref772.children,
      style = _ref772.style,
      tabIndex = _ref772.tabIndex,
      rest = _objectWithoutProperties$2(_ref772, ["className", "children", "style", "tabIndex"]);

  var _getAttributes772 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes772.tabindex,
      props = _objectWithoutProperties$2(_getAttributes772, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.24 25.14L7 26.67a13.79 13.79 0 0 0 4.18 2.44l.69-1.87a12 12 0 0 1-3.63-2.1zM4.19 18l-2 .41A14.09 14.09 0 0 0 3.86 23l1.73-1a12.44 12.44 0 0 1-1.4-4zm7.63-13.24l-.69-1.87A13.79 13.79 0 0 0 7 5.33l1.24 1.53a12 12 0 0 1 3.58-2.1zM5.59 10L3.86 9a14.37 14.37 0 0 0-1.64 4.59l2 .34A12.05 12.05 0 0 1 5.59 10zM16 2v2a12 12 0 0 1 0 24v2a14 14 0 0 0 0-28z'
  }));
});
Fade20.displayName = 'Fade20';
Fade20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Fade20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FavoriteFilled32 = React.forwardRef(function (_ref773, ref) {
  var className = _ref773.className,
      children = _ref773.children,
      style = _ref773.style,
      tabIndex = _ref773.tabIndex,
      rest = _objectWithoutProperties$2(_ref773, ["className", "children", "style", "tabIndex"]);

  var _getAttributes773 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes773.tabindex,
      props = _objectWithoutProperties$2(_getAttributes773, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.45 4a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0 7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z'
  }));
});
FavoriteFilled32.displayName = 'FavoriteFilled32';
FavoriteFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FavoriteFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FavoriteFilled24 = React.forwardRef(function (_ref774, ref) {
  var className = _ref774.className,
      children = _ref774.children,
      style = _ref774.style,
      tabIndex = _ref774.tabIndex,
      rest = _objectWithoutProperties$2(_ref774, ["className", "children", "style", "tabIndex"]);

  var _getAttributes774 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes774.tabindex,
      props = _objectWithoutProperties$2(_getAttributes774, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.45 4a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0 7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z'
  }));
});
FavoriteFilled24.displayName = 'FavoriteFilled24';
FavoriteFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FavoriteFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FavoriteFilled20 = React.forwardRef(function (_ref775, ref) {
  var className = _ref775.className,
      children = _ref775.children,
      style = _ref775.style,
      tabIndex = _ref775.tabIndex,
      rest = _objectWithoutProperties$2(_ref775, ["className", "children", "style", "tabIndex"]);

  var _getAttributes775 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes775.tabindex,
      props = _objectWithoutProperties$2(_getAttributes775, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.45 4a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0 7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z'
  }));
});
FavoriteFilled20.displayName = 'FavoriteFilled20';
FavoriteFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FavoriteFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Favorite32 = React.forwardRef(function (_ref776, ref) {
  var className = _ref776.className,
      children = _ref776.children,
      style = _ref776.style,
      tabIndex = _ref776.tabIndex,
      rest = _objectWithoutProperties$2(_ref776, ["className", "children", "style", "tabIndex"]);

  var _getAttributes776 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes776.tabindex,
      props = _objectWithoutProperties$2(_getAttributes776, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.45 6a5.47 5.47 0 0 1 3.91 1.64 5.7 5.7 0 0 1 0 8L16 26.13 5.64 15.64a5.7 5.7 0 0 1 0-8 5.48 5.48 0 0 1 7.82 0l2.54 2.6 2.53-2.58A5.44 5.44 0 0 1 22.45 6m0-2a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0 7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z'
  }));
});
Favorite32.displayName = 'Favorite32';
Favorite32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Favorite32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Favorite24 = React.forwardRef(function (_ref777, ref) {
  var className = _ref777.className,
      children = _ref777.children,
      style = _ref777.style,
      tabIndex = _ref777.tabIndex,
      rest = _objectWithoutProperties$2(_ref777, ["className", "children", "style", "tabIndex"]);

  var _getAttributes777 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes777.tabindex,
      props = _objectWithoutProperties$2(_getAttributes777, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.45 6a5.47 5.47 0 0 1 3.91 1.64 5.7 5.7 0 0 1 0 8L16 26.13 5.64 15.64a5.7 5.7 0 0 1 0-8 5.48 5.48 0 0 1 7.82 0l2.54 2.6 2.53-2.58A5.44 5.44 0 0 1 22.45 6m0-2a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0 7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z'
  }));
});
Favorite24.displayName = 'Favorite24';
Favorite24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Favorite24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Favorite20 = React.forwardRef(function (_ref778, ref) {
  var className = _ref778.className,
      children = _ref778.children,
      style = _ref778.style,
      tabIndex = _ref778.tabIndex,
      rest = _objectWithoutProperties$2(_ref778, ["className", "children", "style", "tabIndex"]);

  var _getAttributes778 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes778.tabindex,
      props = _objectWithoutProperties$2(_getAttributes778, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.45 6a5.47 5.47 0 0 1 3.91 1.64 5.7 5.7 0 0 1 0 8L16 26.13 5.64 15.64a5.7 5.7 0 0 1 0-8 5.48 5.48 0 0 1 7.82 0l2.54 2.6 2.53-2.58A5.44 5.44 0 0 1 22.45 6m0-2a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0 7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z'
  }));
});
Favorite20.displayName = 'Favorite20';
Favorite20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Favorite20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FilterEdit32 = React.forwardRef(function (_ref779, ref) {
  var className = _ref779.className,
      children = _ref779.children,
      style = _ref779.style,
      tabIndex = _ref779.tabIndex,
      rest = _objectWithoutProperties$2(_ref779, ["className", "children", "style", "tabIndex"]);

  var _getAttributes779 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes779.tabindex,
      props = _objectWithoutProperties$2(_getAttributes779, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H4v3.17l7.41 7.42.59.58V26h4v-2h2v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8l-7.41-7.41A2 2 0 0 1 2 9.17V6a2 2 0 0 1 2-2h22z'
  }), React.createElement('path', {
    d: 'M29.71 11.29l-3-3a1 1 0 0 0-1.42 0L16 17.59V22h4.41l9.3-9.29a1 1 0 0 0 0-1.42zM19.59 20H18v-1.59l5-5L24.59 15zM26 13.59L24.41 12 26 10.41 27.59 12z'
  }));
});
FilterEdit32.displayName = 'FilterEdit32';
FilterEdit32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FilterEdit32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FilterEdit24 = React.forwardRef(function (_ref780, ref) {
  var className = _ref780.className,
      children = _ref780.children,
      style = _ref780.style,
      tabIndex = _ref780.tabIndex,
      rest = _objectWithoutProperties$2(_ref780, ["className", "children", "style", "tabIndex"]);

  var _getAttributes780 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes780.tabindex,
      props = _objectWithoutProperties$2(_getAttributes780, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H4v3.17l7.41 7.42.59.58V26h4v-2h2v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8l-7.41-7.41A2 2 0 0 1 2 9.17V6a2 2 0 0 1 2-2h22z'
  }), React.createElement('path', {
    d: 'M29.71 11.29l-3-3a1 1 0 0 0-1.42 0L16 17.59V22h4.41l9.3-9.29a1 1 0 0 0 0-1.42zM19.59 20H18v-1.59l5-5L24.59 15zM26 13.59L24.41 12 26 10.41 27.59 12z'
  }));
});
FilterEdit24.displayName = 'FilterEdit24';
FilterEdit24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FilterEdit24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FilterEdit20 = React.forwardRef(function (_ref781, ref) {
  var className = _ref781.className,
      children = _ref781.children,
      style = _ref781.style,
      tabIndex = _ref781.tabIndex,
      rest = _objectWithoutProperties$2(_ref781, ["className", "children", "style", "tabIndex"]);

  var _getAttributes781 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes781.tabindex,
      props = _objectWithoutProperties$2(_getAttributes781, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H4v3.17l7.41 7.42.59.58V26h4v-2h2v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8l-7.41-7.41A2 2 0 0 1 2 9.17V6a2 2 0 0 1 2-2h22z'
  }), React.createElement('path', {
    d: 'M29.71 11.29l-3-3a1 1 0 0 0-1.42 0L16 17.59V22h4.41l9.3-9.29a1 1 0 0 0 0-1.42zM19.59 20H18v-1.59l5-5L24.59 15zM26 13.59L24.41 12 26 10.41 27.59 12z'
  }));
});
FilterEdit20.displayName = 'FilterEdit20';
FilterEdit20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FilterEdit20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Filter32 = React.forwardRef(function (_ref782, ref) {
  var className = _ref782.className,
      children = _ref782.children,
      style = _ref782.style,
      tabIndex = _ref782.tabIndex,
      rest = _objectWithoutProperties$2(_ref782, ["className", "children", "style", "tabIndex"]);

  var _getAttributes782 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes782.tabindex,
      props = _objectWithoutProperties$2(_getAttributes782, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28h-4a2 2 0 0 1-2-2v-7.59L4.59 11A2 2 0 0 1 4 9.59V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v3.59a2 2 0 0 1-.59 1.41L20 18.41V26a2 2 0 0 1-2 2zM6 6v3.59l8 8V26h4v-8.41l8-8V6z'
  }));
});
Filter32.displayName = 'Filter32';
Filter32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Filter32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Filter24 = React.forwardRef(function (_ref783, ref) {
  var className = _ref783.className,
      children = _ref783.children,
      style = _ref783.style,
      tabIndex = _ref783.tabIndex,
      rest = _objectWithoutProperties$2(_ref783, ["className", "children", "style", "tabIndex"]);

  var _getAttributes783 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes783.tabindex,
      props = _objectWithoutProperties$2(_getAttributes783, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28h-4a2 2 0 0 1-2-2v-7.59L4.59 11A2 2 0 0 1 4 9.59V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v3.59a2 2 0 0 1-.59 1.41L20 18.41V26a2 2 0 0 1-2 2zM6 6v3.59l8 8V26h4v-8.41l8-8V6z'
  }));
});
Filter24.displayName = 'Filter24';
Filter24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Filter24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Filter20 = React.forwardRef(function (_ref784, ref) {
  var className = _ref784.className,
      children = _ref784.children,
      style = _ref784.style,
      tabIndex = _ref784.tabIndex,
      rest = _objectWithoutProperties$2(_ref784, ["className", "children", "style", "tabIndex"]);

  var _getAttributes784 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes784.tabindex,
      props = _objectWithoutProperties$2(_getAttributes784, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28h-4a2 2 0 0 1-2-2v-7.59L4.59 11A2 2 0 0 1 4 9.59V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v3.59a2 2 0 0 1-.59 1.41L20 18.41V26a2 2 0 0 1-2 2zM6 6v3.59l8 8V26h4v-8.41l8-8V6z'
  }));
});
Filter20.displayName = 'Filter20';
Filter20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Filter20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Finance32 = React.forwardRef(function (_ref785, ref) {
  var className = _ref785.className,
      children = _ref785.children,
      style = _ref785.style,
      tabIndex = _ref785.tabIndex,
      rest = _objectWithoutProperties$2(_ref785, ["className", "children", "style", "tabIndex"]);

  var _getAttributes785 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes785.tabindex,
      props = _objectWithoutProperties$2(_getAttributes785, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zm25-17a1 1 0 0 0 1-1V7a1 1 0 0 0-.66-.94l-11-4a1 1 0 0 0-.68 0l-11 4A1 1 0 0 0 4 7v3a1 1 0 0 0 1 1h1v13H4v2h24v-2h-2V11zM6 7.7l10-3.64L26 7.7V9H6zM18 24h-4V11h4zM8 11h4v13H8zm16 13h-4V11h4z'
  }));
});
Finance32.displayName = 'Finance32';
Finance32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Finance32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Finance24 = React.forwardRef(function (_ref786, ref) {
  var className = _ref786.className,
      children = _ref786.children,
      style = _ref786.style,
      tabIndex = _ref786.tabIndex,
      rest = _objectWithoutProperties$2(_ref786, ["className", "children", "style", "tabIndex"]);

  var _getAttributes786 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes786.tabindex,
      props = _objectWithoutProperties$2(_getAttributes786, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zm25-17a1 1 0 0 0 1-1V7a1 1 0 0 0-.66-.94l-11-4a1 1 0 0 0-.68 0l-11 4A1 1 0 0 0 4 7v3a1 1 0 0 0 1 1h1v13H4v2h24v-2h-2V11zM6 7.7l10-3.64L26 7.7V9H6zM18 24h-4V11h4zM8 11h4v13H8zm16 13h-4V11h4z'
  }));
});
Finance24.displayName = 'Finance24';
Finance24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Finance24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Finance20 = React.forwardRef(function (_ref787, ref) {
  var className = _ref787.className,
      children = _ref787.children,
      style = _ref787.style,
      tabIndex = _ref787.tabIndex,
      rest = _objectWithoutProperties$2(_ref787, ["className", "children", "style", "tabIndex"]);

  var _getAttributes787 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes787.tabindex,
      props = _objectWithoutProperties$2(_getAttributes787, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 28h28v2H2zm25-17a1 1 0 0 0 1-1V7a1 1 0 0 0-.66-.94l-11-4a1 1 0 0 0-.68 0l-11 4A1 1 0 0 0 4 7v3a1 1 0 0 0 1 1h1v13H4v2h24v-2h-2V11zM6 7.7l10-3.64L26 7.7V9H6zM18 24h-4V11h4zM8 11h4v13H8zm16 13h-4V11h4z'
  }));
});
Finance20.displayName = 'Finance20';
Finance20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Finance20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FingerprintRecognition32 = React.forwardRef(function (_ref788, ref) {
  var className = _ref788.className,
      children = _ref788.children,
      style = _ref788.style,
      tabIndex = _ref788.tabIndex,
      rest = _objectWithoutProperties$2(_ref788, ["className", "children", "style", "tabIndex"]);

  var _getAttributes788 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes788.tabindex,
      props = _objectWithoutProperties$2(_getAttributes788, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 5.21a.77.77 0 0 1-.46-1.38A15.46 15.46 0 0 1 16 1c2.66 0 6.48.45 9.5 2.62a.77.77 0 0 1 .18 1.07.78.78 0 0 1-1.08.17A15 15 0 0 0 16 2.53a14 14 0 0 0-8.5 2.52.74.74 0 0 1-.5.16z'
  }), React.createElement('path', {
    d: 'M28.23 12.26a.78.78 0 0 1-.63-.33C25.87 9.49 22.78 6.24 16 6.24a14 14 0 0 0-11.63 5.7.77.77 0 0 1-1.07.17.76.76 0 0 1-.15-1.11A15.54 15.54 0 0 1 16 4.71c5.61 0 9.81 2.08 12.84 6.34a.77.77 0 0 1-.19 1.07.79.79 0 0 1-.42.14z'
  }), React.createElement('path', {
    d: 'M12.28 31a.78.78 0 0 1-.72-.49.75.75 0 0 1 .44-1c4.37-1.68 7-5.12 7-9.21a2.8 2.8 0 0 0-3-3c-1.86 0-2.76 1-3 3.35a4.27 4.27 0 0 1-4.52 3.83 4.27 4.27 0 0 1-4.32-4.59A11.71 11.71 0 0 1 16 8.39a12 12 0 0 1 12 11.93 18.66 18.66 0 0 1-1.39 6.5.78.78 0 0 1-1 .41.76.76 0 0 1-.41-1 17.25 17.25 0 0 0 1.27-5.91A10.45 10.45 0 0 0 16 9.92a10.18 10.18 0 0 0-10.38 10 2.77 2.77 0 0 0 2.79 3.06 2.74 2.74 0 0 0 3-2.48c.36-3.11 1.89-4.69 4.56-4.69a4.31 4.31 0 0 1 4.52 4.56c0 4.74-3 8.72-8 10.63a.92.92 0 0 1-.21 0z'
  }), React.createElement('path', {
    d: 'M19.77 30.28a.81.81 0 0 1-.52-.2.76.76 0 0 1 0-1.08 12.63 12.63 0 0 0 3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83 6.83 0 0 0-4.94 1.87A6.17 6.17 0 0 0 9.32 20a.77.77 0 0 1-.77.76.76.76 0 0 1-.77-.76A7.73 7.73 0 0 1 10 14.46a8.34 8.34 0 0 1 6-2.32c6.08 0 8.24 4.4 8.24 8.18a14.09 14.09 0 0 1-3.9 9.68.75.75 0 0 1-.57.28z'
  }), React.createElement('path', {
    d: 'M8.66 27.74a14.14 14.14 0 0 1-1.56-.09.76.76 0 1 1 .17-1.52c2.49.28 4.45-.16 5.84-1.32a6.37 6.37 0 0 0 2.12-4.53.75.75 0 0 1 .82-.71.78.78 0 0 1 .72.81A7.89 7.89 0 0 1 14.09 26a8.2 8.2 0 0 1-5.43 1.74z'
  }));
});
FingerprintRecognition32.displayName = 'FingerprintRecognition32';
FingerprintRecognition32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FingerprintRecognition32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FingerprintRecognition24 = React.forwardRef(function (_ref789, ref) {
  var className = _ref789.className,
      children = _ref789.children,
      style = _ref789.style,
      tabIndex = _ref789.tabIndex,
      rest = _objectWithoutProperties$2(_ref789, ["className", "children", "style", "tabIndex"]);

  var _getAttributes789 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes789.tabindex,
      props = _objectWithoutProperties$2(_getAttributes789, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 5.21a.77.77 0 0 1-.46-1.38A15.46 15.46 0 0 1 16 1c2.66 0 6.48.45 9.5 2.62a.77.77 0 0 1 .18 1.07.78.78 0 0 1-1.08.17A15 15 0 0 0 16 2.53a14 14 0 0 0-8.5 2.52.74.74 0 0 1-.5.16z'
  }), React.createElement('path', {
    d: 'M28.23 12.26a.78.78 0 0 1-.63-.33C25.87 9.49 22.78 6.24 16 6.24a14 14 0 0 0-11.63 5.7.77.77 0 0 1-1.07.17.76.76 0 0 1-.15-1.11A15.54 15.54 0 0 1 16 4.71c5.61 0 9.81 2.08 12.84 6.34a.77.77 0 0 1-.19 1.07.79.79 0 0 1-.42.14z'
  }), React.createElement('path', {
    d: 'M12.28 31a.78.78 0 0 1-.72-.49.75.75 0 0 1 .44-1c4.37-1.68 7-5.12 7-9.21a2.8 2.8 0 0 0-3-3c-1.86 0-2.76 1-3 3.35a4.27 4.27 0 0 1-4.52 3.83 4.27 4.27 0 0 1-4.32-4.59A11.71 11.71 0 0 1 16 8.39a12 12 0 0 1 12 11.93 18.66 18.66 0 0 1-1.39 6.5.78.78 0 0 1-1 .41.76.76 0 0 1-.41-1 17.25 17.25 0 0 0 1.27-5.91A10.45 10.45 0 0 0 16 9.92a10.18 10.18 0 0 0-10.38 10 2.77 2.77 0 0 0 2.79 3.06 2.74 2.74 0 0 0 3-2.48c.36-3.11 1.89-4.69 4.56-4.69a4.31 4.31 0 0 1 4.52 4.56c0 4.74-3 8.72-8 10.63a.92.92 0 0 1-.21 0z'
  }), React.createElement('path', {
    d: 'M19.77 30.28a.81.81 0 0 1-.52-.2.76.76 0 0 1 0-1.08 12.63 12.63 0 0 0 3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83 6.83 0 0 0-4.94 1.87A6.17 6.17 0 0 0 9.32 20a.77.77 0 0 1-.77.76.76.76 0 0 1-.77-.76A7.73 7.73 0 0 1 10 14.46a8.34 8.34 0 0 1 6-2.32c6.08 0 8.24 4.4 8.24 8.18a14.09 14.09 0 0 1-3.9 9.68.75.75 0 0 1-.57.28z'
  }), React.createElement('path', {
    d: 'M8.66 27.74a14.14 14.14 0 0 1-1.56-.09.76.76 0 1 1 .17-1.52c2.49.28 4.45-.16 5.84-1.32a6.37 6.37 0 0 0 2.12-4.53.75.75 0 0 1 .82-.71.78.78 0 0 1 .72.81A7.89 7.89 0 0 1 14.09 26a8.2 8.2 0 0 1-5.43 1.74z'
  }));
});
FingerprintRecognition24.displayName = 'FingerprintRecognition24';
FingerprintRecognition24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FingerprintRecognition24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FingerprintRecognition20 = React.forwardRef(function (_ref790, ref) {
  var className = _ref790.className,
      children = _ref790.children,
      style = _ref790.style,
      tabIndex = _ref790.tabIndex,
      rest = _objectWithoutProperties$2(_ref790, ["className", "children", "style", "tabIndex"]);

  var _getAttributes790 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes790.tabindex,
      props = _objectWithoutProperties$2(_getAttributes790, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 5.21a.77.77 0 0 1-.46-1.38A15.46 15.46 0 0 1 16 1c2.66 0 6.48.45 9.5 2.62a.77.77 0 0 1 .18 1.07.78.78 0 0 1-1.08.17A15 15 0 0 0 16 2.53a14 14 0 0 0-8.5 2.52.74.74 0 0 1-.5.16z'
  }), React.createElement('path', {
    d: 'M28.23 12.26a.78.78 0 0 1-.63-.33C25.87 9.49 22.78 6.24 16 6.24a14 14 0 0 0-11.63 5.7.77.77 0 0 1-1.07.17.76.76 0 0 1-.15-1.11A15.54 15.54 0 0 1 16 4.71c5.61 0 9.81 2.08 12.84 6.34a.77.77 0 0 1-.19 1.07.79.79 0 0 1-.42.14z'
  }), React.createElement('path', {
    d: 'M12.28 31a.78.78 0 0 1-.72-.49.75.75 0 0 1 .44-1c4.37-1.68 7-5.12 7-9.21a2.8 2.8 0 0 0-3-3c-1.86 0-2.76 1-3 3.35a4.27 4.27 0 0 1-4.52 3.83 4.27 4.27 0 0 1-4.32-4.59A11.71 11.71 0 0 1 16 8.39a12 12 0 0 1 12 11.93 18.66 18.66 0 0 1-1.39 6.5.78.78 0 0 1-1 .41.76.76 0 0 1-.41-1 17.25 17.25 0 0 0 1.27-5.91A10.45 10.45 0 0 0 16 9.92a10.18 10.18 0 0 0-10.38 10 2.77 2.77 0 0 0 2.79 3.06 2.74 2.74 0 0 0 3-2.48c.36-3.11 1.89-4.69 4.56-4.69a4.31 4.31 0 0 1 4.52 4.56c0 4.74-3 8.72-8 10.63a.92.92 0 0 1-.21 0z'
  }), React.createElement('path', {
    d: 'M19.77 30.28a.81.81 0 0 1-.52-.2.76.76 0 0 1 0-1.08 12.63 12.63 0 0 0 3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83 6.83 0 0 0-4.94 1.87A6.17 6.17 0 0 0 9.32 20a.77.77 0 0 1-.77.76.76.76 0 0 1-.77-.76A7.73 7.73 0 0 1 10 14.46a8.34 8.34 0 0 1 6-2.32c6.08 0 8.24 4.4 8.24 8.18a14.09 14.09 0 0 1-3.9 9.68.75.75 0 0 1-.57.28z'
  }), React.createElement('path', {
    d: 'M8.66 27.74a14.14 14.14 0 0 1-1.56-.09.76.76 0 1 1 .17-1.52c2.49.28 4.45-.16 5.84-1.32a6.37 6.37 0 0 0 2.12-4.53.75.75 0 0 1 .82-.71.78.78 0 0 1 .72.81A7.89 7.89 0 0 1 14.09 26a8.2 8.2 0 0 1-5.43 1.74z'
  }));
});
FingerprintRecognition20.displayName = 'FingerprintRecognition20';
FingerprintRecognition20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FingerprintRecognition20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flag32 = React.forwardRef(function (_ref791, ref) {
  var className = _ref791.className,
      children = _ref791.children,
      style = _ref791.style,
      tabIndex = _ref791.tabIndex,
      rest = _objectWithoutProperties$2(_ref791, ["className", "children", "style", "tabIndex"]);

  var _getAttributes791 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes791.tabindex,
      props = _objectWithoutProperties$2(_getAttributes791, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 30H4V2h24l-5.8 9 5.8 9H6zm0-12h18.33l-4.53-7 4.53-7H6z'
  }));
});
Flag32.displayName = 'Flag32';
Flag32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flag32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flag24 = React.forwardRef(function (_ref792, ref) {
  var className = _ref792.className,
      children = _ref792.children,
      style = _ref792.style,
      tabIndex = _ref792.tabIndex,
      rest = _objectWithoutProperties$2(_ref792, ["className", "children", "style", "tabIndex"]);

  var _getAttributes792 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes792.tabindex,
      props = _objectWithoutProperties$2(_getAttributes792, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 30H4V2h24l-5.8 9 5.8 9H6zm0-12h18.33l-4.53-7 4.53-7H6z'
  }));
});
Flag24.displayName = 'Flag24';
Flag24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flag24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flag20 = React.forwardRef(function (_ref793, ref) {
  var className = _ref793.className,
      children = _ref793.children,
      style = _ref793.style,
      tabIndex = _ref793.tabIndex,
      rest = _objectWithoutProperties$2(_ref793, ["className", "children", "style", "tabIndex"]);

  var _getAttributes793 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes793.tabindex,
      props = _objectWithoutProperties$2(_getAttributes793, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 30H4V2h24l-5.8 9 5.8 9H6zm0-12h18.33l-4.53-7 4.53-7H6z'
  }));
});
Flag20.displayName = 'Flag20';
Flag20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flag20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashFilled32 = React.forwardRef(function (_ref794, ref) {
  var className = _ref794.className,
      children = _ref794.children,
      style = _ref794.style,
      tabIndex = _ref794.tabIndex,
      rest = _objectWithoutProperties$2(_ref794, ["className", "children", "style", "tabIndex"]);

  var _getAttributes794 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes794.tabindex,
      props = _objectWithoutProperties$2(_getAttributes794, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.61 29.92a1 1 0 0 1-.6-1.07L12.83 17H8a1 1 0 0 1-1-1.23l3-13A1 1 0 0 1 11 2h10a1 1 0 0 1 .78.37 1 1 0 0 1 .2.85L20.25 11H25a1 1 0 0 1 .9.56 1 1 0 0 1-.11 1l-13 17A1 1 0 0 1 12 30a1.09 1.09 0 0 1-.39-.08z'
  }));
});
FlashFilled32.displayName = 'FlashFilled32';
FlashFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashFilled24 = React.forwardRef(function (_ref795, ref) {
  var className = _ref795.className,
      children = _ref795.children,
      style = _ref795.style,
      tabIndex = _ref795.tabIndex,
      rest = _objectWithoutProperties$2(_ref795, ["className", "children", "style", "tabIndex"]);

  var _getAttributes795 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes795.tabindex,
      props = _objectWithoutProperties$2(_getAttributes795, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.61 29.92a1 1 0 0 1-.6-1.07L12.83 17H8a1 1 0 0 1-1-1.23l3-13A1 1 0 0 1 11 2h10a1 1 0 0 1 .78.37 1 1 0 0 1 .2.85L20.25 11H25a1 1 0 0 1 .9.56 1 1 0 0 1-.11 1l-13 17A1 1 0 0 1 12 30a1.09 1.09 0 0 1-.39-.08z'
  }));
});
FlashFilled24.displayName = 'FlashFilled24';
FlashFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashFilled20 = React.forwardRef(function (_ref796, ref) {
  var className = _ref796.className,
      children = _ref796.children,
      style = _ref796.style,
      tabIndex = _ref796.tabIndex,
      rest = _objectWithoutProperties$2(_ref796, ["className", "children", "style", "tabIndex"]);

  var _getAttributes796 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes796.tabindex,
      props = _objectWithoutProperties$2(_getAttributes796, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.61 29.92a1 1 0 0 1-.6-1.07L12.83 17H8a1 1 0 0 1-1-1.23l3-13A1 1 0 0 1 11 2h10a1 1 0 0 1 .78.37 1 1 0 0 1 .2.85L20.25 11H25a1 1 0 0 1 .9.56 1 1 0 0 1-.11 1l-13 17A1 1 0 0 1 12 30a1.09 1.09 0 0 1-.39-.08z'
  }));
});
FlashFilled20.displayName = 'FlashFilled20';
FlashFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashOffFilled32 = React.forwardRef(function (_ref797, ref) {
  var className = _ref797.className,
      children = _ref797.children,
      style = _ref797.style,
      tabIndex = _ref797.tabIndex,
      rest = _objectWithoutProperties$2(_ref797, ["className", "children", "style", "tabIndex"]);

  var _getAttributes797 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes797.tabindex,
      props = _objectWithoutProperties$2(_getAttributes797, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 28.59L3.41 2 2 3.41l6.4 6.41L7 15.77A1 1 0 0 0 8 17h4.83L11 28.85a1 1 0 0 0 .6 1.07 1.09 1.09 0 0 0 .4.08 1 1 0 0 0 .79-.39l6.68-8.73L28.59 30zm-7.47-11.72l3.26-4.26a1 1 0 0 0 .11-1A1 1 0 0 0 25 11h-4.75L22 3.22a1 1 0 0 0-.2-.85A1 1 0 0 0 21 2H11a1 1 0 0 0-1 .77l-.3 1.3z'
  }));
});
FlashOffFilled32.displayName = 'FlashOffFilled32';
FlashOffFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashOffFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashOffFilled24 = React.forwardRef(function (_ref798, ref) {
  var className = _ref798.className,
      children = _ref798.children,
      style = _ref798.style,
      tabIndex = _ref798.tabIndex,
      rest = _objectWithoutProperties$2(_ref798, ["className", "children", "style", "tabIndex"]);

  var _getAttributes798 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes798.tabindex,
      props = _objectWithoutProperties$2(_getAttributes798, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 28.59L3.41 2 2 3.41l6.4 6.41L7 15.77A1 1 0 0 0 8 17h4.83L11 28.85a1 1 0 0 0 .6 1.07 1.09 1.09 0 0 0 .4.08 1 1 0 0 0 .79-.39l6.68-8.73L28.59 30zm-7.47-11.72l3.26-4.26a1 1 0 0 0 .11-1A1 1 0 0 0 25 11h-4.75L22 3.22a1 1 0 0 0-.2-.85A1 1 0 0 0 21 2H11a1 1 0 0 0-1 .77l-.3 1.3z'
  }));
});
FlashOffFilled24.displayName = 'FlashOffFilled24';
FlashOffFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashOffFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashOffFilled20 = React.forwardRef(function (_ref799, ref) {
  var className = _ref799.className,
      children = _ref799.children,
      style = _ref799.style,
      tabIndex = _ref799.tabIndex,
      rest = _objectWithoutProperties$2(_ref799, ["className", "children", "style", "tabIndex"]);

  var _getAttributes799 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes799.tabindex,
      props = _objectWithoutProperties$2(_getAttributes799, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 28.59L3.41 2 2 3.41l6.4 6.41L7 15.77A1 1 0 0 0 8 17h4.83L11 28.85a1 1 0 0 0 .6 1.07 1.09 1.09 0 0 0 .4.08 1 1 0 0 0 .79-.39l6.68-8.73L28.59 30zm-7.47-11.72l3.26-4.26a1 1 0 0 0 .11-1A1 1 0 0 0 25 11h-4.75L22 3.22a1 1 0 0 0-.2-.85A1 1 0 0 0 21 2H11a1 1 0 0 0-1 .77l-.3 1.3z'
  }));
});
FlashOffFilled20.displayName = 'FlashOffFilled20';
FlashOffFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashOffFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashOff32 = React.forwardRef(function (_ref800, ref) {
  var className = _ref800.className,
      children = _ref800.children,
      style = _ref800.style,
      tabIndex = _ref800.tabIndex,
      rest = _objectWithoutProperties$2(_ref800, ["className", "children", "style", "tabIndex"]);

  var _getAttributes800 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes800.tabindex,
      props = _objectWithoutProperties$2(_getAttributes800, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 0 0 .11-1A1 1 0 0 0 25 11h-4.75L22 3.22a1 1 0 0 0-.2-.85A1 1 0 0 0 21 2H11a1 1 0 0 0-1 .77l-.54 2.45zM30 28.59l-9.31-9.31-1.42-1.43-8.67-8.66-1.67-1.67L3.41 2 2 3.41l6.4 6.41L7 15.77A1 1 0 0 0 8 17h4.83L11 28.85a1 1 0 0 0 .6 1.07 1.09 1.09 0 0 0 .4.08 1 1 0 0 0 .79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37l3 3.08z'
  }));
});
FlashOff32.displayName = 'FlashOff32';
FlashOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashOff24 = React.forwardRef(function (_ref801, ref) {
  var className = _ref801.className,
      children = _ref801.children,
      style = _ref801.style,
      tabIndex = _ref801.tabIndex,
      rest = _objectWithoutProperties$2(_ref801, ["className", "children", "style", "tabIndex"]);

  var _getAttributes801 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes801.tabindex,
      props = _objectWithoutProperties$2(_getAttributes801, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 0 0 .11-1A1 1 0 0 0 25 11h-4.75L22 3.22a1 1 0 0 0-.2-.85A1 1 0 0 0 21 2H11a1 1 0 0 0-1 .77l-.54 2.45zM30 28.59l-9.31-9.31-1.42-1.43-8.67-8.66-1.67-1.67L3.41 2 2 3.41l6.4 6.41L7 15.77A1 1 0 0 0 8 17h4.83L11 28.85a1 1 0 0 0 .6 1.07 1.09 1.09 0 0 0 .4.08 1 1 0 0 0 .79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37l3 3.08z'
  }));
});
FlashOff24.displayName = 'FlashOff24';
FlashOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlashOff20 = React.forwardRef(function (_ref802, ref) {
  var className = _ref802.className,
      children = _ref802.children,
      style = _ref802.style,
      tabIndex = _ref802.tabIndex,
      rest = _objectWithoutProperties$2(_ref802, ["className", "children", "style", "tabIndex"]);

  var _getAttributes802 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes802.tabindex,
      props = _objectWithoutProperties$2(_getAttributes802, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 0 0 .11-1A1 1 0 0 0 25 11h-4.75L22 3.22a1 1 0 0 0-.2-.85A1 1 0 0 0 21 2H11a1 1 0 0 0-1 .77l-.54 2.45zM30 28.59l-9.31-9.31-1.42-1.43-8.67-8.66-1.67-1.67L3.41 2 2 3.41l6.4 6.41L7 15.77A1 1 0 0 0 8 17h4.83L11 28.85a1 1 0 0 0 .6 1.07 1.09 1.09 0 0 0 .4.08 1 1 0 0 0 .79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37l3 3.08z'
  }));
});
FlashOff20.displayName = 'FlashOff20';
FlashOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlashOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flash32 = React.forwardRef(function (_ref803, ref) {
  var className = _ref803.className,
      children = _ref803.children,
      style = _ref803.style,
      tabIndex = _ref803.tabIndex,
      rest = _objectWithoutProperties$2(_ref803, ["className", "children", "style", "tabIndex"]);

  var _getAttributes803 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes803.tabindex,
      props = _objectWithoutProperties$2(_getAttributes803, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.61 29.92a1 1 0 0 1-.6-1.07L12.83 17H8a1 1 0 0 1-1-1.23l3-13A1 1 0 0 1 11 2h10a1 1 0 0 1 .78.37 1 1 0 0 1 .2.85L20.25 11H25a1 1 0 0 1 .9.56 1 1 0 0 1-.11 1l-13 17A1 1 0 0 1 12 30a1.09 1.09 0 0 1-.39-.08zM17.75 13l2-9H11.8L9.26 15h5.91l-1.59 10.28L23 13z'
  }));
});
Flash32.displayName = 'Flash32';
Flash32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flash32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flash24 = React.forwardRef(function (_ref804, ref) {
  var className = _ref804.className,
      children = _ref804.children,
      style = _ref804.style,
      tabIndex = _ref804.tabIndex,
      rest = _objectWithoutProperties$2(_ref804, ["className", "children", "style", "tabIndex"]);

  var _getAttributes804 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes804.tabindex,
      props = _objectWithoutProperties$2(_getAttributes804, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.61 29.92a1 1 0 0 1-.6-1.07L12.83 17H8a1 1 0 0 1-1-1.23l3-13A1 1 0 0 1 11 2h10a1 1 0 0 1 .78.37 1 1 0 0 1 .2.85L20.25 11H25a1 1 0 0 1 .9.56 1 1 0 0 1-.11 1l-13 17A1 1 0 0 1 12 30a1.09 1.09 0 0 1-.39-.08zM17.75 13l2-9H11.8L9.26 15h5.91l-1.59 10.28L23 13z'
  }));
});
Flash24.displayName = 'Flash24';
Flash24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flash24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flash20 = React.forwardRef(function (_ref805, ref) {
  var className = _ref805.className,
      children = _ref805.children,
      style = _ref805.style,
      tabIndex = _ref805.tabIndex,
      rest = _objectWithoutProperties$2(_ref805, ["className", "children", "style", "tabIndex"]);

  var _getAttributes805 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes805.tabindex,
      props = _objectWithoutProperties$2(_getAttributes805, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.61 29.92a1 1 0 0 1-.6-1.07L12.83 17H8a1 1 0 0 1-1-1.23l3-13A1 1 0 0 1 11 2h10a1 1 0 0 1 .78.37 1 1 0 0 1 .2.85L20.25 11H25a1 1 0 0 1 .9.56 1 1 0 0 1-.11 1l-13 17A1 1 0 0 1 12 30a1.09 1.09 0 0 1-.39-.08zM17.75 13l2-9H11.8L9.26 15h5.91l-1.59 10.28L23 13z'
  }));
});
Flash20.displayName = 'Flash20';
Flash20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flash20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlowData32 = React.forwardRef(function (_ref806, ref) {
  var className = _ref806.className,
      children = _ref806.children,
      style = _ref806.style,
      tabIndex = _ref806.tabIndex,
      rest = _objectWithoutProperties$2(_ref806, ["className", "children", "style", "tabIndex"]);

  var _getAttributes806 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes806.tabindex,
      props = _objectWithoutProperties$2(_getAttributes806, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23h-8.14a4.17 4.17 0 0 0-.43-1L22 11.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-3.86-5h-8.28a4 4 0 1 0 0 2h8.28a4.17 4.17 0 0 0 .43 1L10 20.57A3.86 3.86 0 0 0 8 20a4 4 0 1 0 3.86 5H20v3h8v-8h-8zM8 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm16-4a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM8 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14-4h4v4h-4z'
  }));
});
FlowData32.displayName = 'FlowData32';
FlowData32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlowData32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlowData24 = React.forwardRef(function (_ref807, ref) {
  var className = _ref807.className,
      children = _ref807.children,
      style = _ref807.style,
      tabIndex = _ref807.tabIndex,
      rest = _objectWithoutProperties$2(_ref807, ["className", "children", "style", "tabIndex"]);

  var _getAttributes807 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes807.tabindex,
      props = _objectWithoutProperties$2(_getAttributes807, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23h-8.14a4.17 4.17 0 0 0-.43-1L22 11.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-3.86-5h-8.28a4 4 0 1 0 0 2h8.28a4.17 4.17 0 0 0 .43 1L10 20.57A3.86 3.86 0 0 0 8 20a4 4 0 1 0 3.86 5H20v3h8v-8h-8zM8 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm16-4a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM8 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14-4h4v4h-4z'
  }));
});
FlowData24.displayName = 'FlowData24';
FlowData24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlowData24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlowData20 = React.forwardRef(function (_ref808, ref) {
  var className = _ref808.className,
      children = _ref808.children,
      style = _ref808.style,
      tabIndex = _ref808.tabIndex,
      rest = _objectWithoutProperties$2(_ref808, ["className", "children", "style", "tabIndex"]);

  var _getAttributes808 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes808.tabindex,
      props = _objectWithoutProperties$2(_getAttributes808, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23h-8.14a4.17 4.17 0 0 0-.43-1L22 11.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-3.86-5h-8.28a4 4 0 1 0 0 2h8.28a4.17 4.17 0 0 0 .43 1L10 20.57A3.86 3.86 0 0 0 8 20a4 4 0 1 0 3.86 5H20v3h8v-8h-8zM8 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm16-4a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM8 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14-4h4v4h-4z'
  }));
});
FlowData20.displayName = 'FlowData20';
FlowData20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlowData20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlowStream32 = React.forwardRef(function (_ref809, ref) {
  var className = _ref809.className,
      children = _ref809.children,
      style = _ref809.style,
      tabIndex = _ref809.tabIndex,
      rest = _objectWithoutProperties$2(_ref809, ["className", "children", "style", "tabIndex"]);

  var _getAttributes809 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes809.tabindex,
      props = _objectWithoutProperties$2(_getAttributes809, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 24h-8.14a4.17 4.17 0 0 0-.43-1L22 12.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-3.86-5H14v2h6.14a4.17 4.17 0 0 0 .43 1L10 21.57A3.86 3.86 0 0 0 8 21a4 4 0 1 0 3.86 5H20v3h8v-8h-8zm4-17a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM8 27a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14-4h4v4h-4zM7.05 15.75a9 9 0 0 1 0-13.5l1.32 1.5a7 7 0 0 0 0 10.5z'
  }), React.createElement('path', {
    d: 'M9.69 12.75a5 5 0 0 1 0-7.5L11 6.75a3 3 0 0 0 0 4.5z'
  }));
});
FlowStream32.displayName = 'FlowStream32';
FlowStream32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlowStream32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlowStream24 = React.forwardRef(function (_ref810, ref) {
  var className = _ref810.className,
      children = _ref810.children,
      style = _ref810.style,
      tabIndex = _ref810.tabIndex,
      rest = _objectWithoutProperties$2(_ref810, ["className", "children", "style", "tabIndex"]);

  var _getAttributes810 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes810.tabindex,
      props = _objectWithoutProperties$2(_getAttributes810, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 24h-8.14a4.17 4.17 0 0 0-.43-1L22 12.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-3.86-5H14v2h6.14a4.17 4.17 0 0 0 .43 1L10 21.57A3.86 3.86 0 0 0 8 21a4 4 0 1 0 3.86 5H20v3h8v-8h-8zm4-17a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM8 27a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14-4h4v4h-4zM7.05 15.75a9 9 0 0 1 0-13.5l1.32 1.5a7 7 0 0 0 0 10.5z'
  }), React.createElement('path', {
    d: 'M9.69 12.75a5 5 0 0 1 0-7.5L11 6.75a3 3 0 0 0 0 4.5z'
  }));
});
FlowStream24.displayName = 'FlowStream24';
FlowStream24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlowStream24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FlowStream20 = React.forwardRef(function (_ref811, ref) {
  var className = _ref811.className,
      children = _ref811.children,
      style = _ref811.style,
      tabIndex = _ref811.tabIndex,
      rest = _objectWithoutProperties$2(_ref811, ["className", "children", "style", "tabIndex"]);

  var _getAttributes811 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes811.tabindex,
      props = _objectWithoutProperties$2(_getAttributes811, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 24h-8.14a4.17 4.17 0 0 0-.43-1L22 12.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-3.86-5H14v2h6.14a4.17 4.17 0 0 0 .43 1L10 21.57A3.86 3.86 0 0 0 8 21a4 4 0 1 0 3.86 5H20v3h8v-8h-8zm4-17a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM8 27a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14-4h4v4h-4zM7.05 15.75a9 9 0 0 1 0-13.5l1.32 1.5a7 7 0 0 0 0 10.5z'
  }), React.createElement('path', {
    d: 'M9.69 12.75a5 5 0 0 1 0-7.5L11 6.75a3 3 0 0 0 0 4.5z'
  }));
});
FlowStream20.displayName = 'FlowStream20';
FlowStream20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FlowStream20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flow32 = React.forwardRef(function (_ref812, ref) {
  var className = _ref812.className,
      children = _ref812.children,
      style = _ref812.style,
      tabIndex = _ref812.tabIndex,
      rest = _objectWithoutProperties$2(_ref812, ["className", "children", "style", "tabIndex"]);

  var _getAttributes812 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes812.tabindex,
      props = _objectWithoutProperties$2(_getAttributes812, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 22.14V17a2 2 0 0 0-2-2h-8V9.86a4 4 0 1 0-2 0V15H7a2 2 0 0 0-2 2v5.14a4 4 0 1 0 2 0V17h18v5.14a4 4 0 1 0 2 0zM8 26a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm6-20a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm12 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
Flow32.displayName = 'Flow32';
Flow32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flow32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flow24 = React.forwardRef(function (_ref813, ref) {
  var className = _ref813.className,
      children = _ref813.children,
      style = _ref813.style,
      tabIndex = _ref813.tabIndex,
      rest = _objectWithoutProperties$2(_ref813, ["className", "children", "style", "tabIndex"]);

  var _getAttributes813 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes813.tabindex,
      props = _objectWithoutProperties$2(_getAttributes813, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 22.14V17a2 2 0 0 0-2-2h-8V9.86a4 4 0 1 0-2 0V15H7a2 2 0 0 0-2 2v5.14a4 4 0 1 0 2 0V17h18v5.14a4 4 0 1 0 2 0zM8 26a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm6-20a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm12 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
Flow24.displayName = 'Flow24';
Flow24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flow24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Flow20 = React.forwardRef(function (_ref814, ref) {
  var className = _ref814.className,
      children = _ref814.children,
      style = _ref814.style,
      tabIndex = _ref814.tabIndex,
      rest = _objectWithoutProperties$2(_ref814, ["className", "children", "style", "tabIndex"]);

  var _getAttributes814 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes814.tabindex,
      props = _objectWithoutProperties$2(_getAttributes814, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 22.14V17a2 2 0 0 0-2-2h-8V9.86a4 4 0 1 0-2 0V15H7a2 2 0 0 0-2 2v5.14a4 4 0 1 0 2 0V17h18v5.14a4 4 0 1 0 2 0zM8 26a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm6-20a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm12 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }));
});
Flow20.displayName = 'Flow20';
Flow20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Flow20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderAdd32 = React.forwardRef(function (_ref815, ref) {
  var className = _ref815.className,
      children = _ref815.children,
      style = _ref815.style,
      tabIndex = _ref815.tabIndex,
      rest = _objectWithoutProperties$2(_ref815, ["className", "children", "style", "tabIndex"]);

  var _getAttributes815 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes815.tabindex,
      props = _objectWithoutProperties$2(_getAttributes815, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 20h-2v4h-4v2h4v4h2v-4h4v-2h-4v-4z'
  }), React.createElement('path', {
    d: 'M28 8H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h12v-2H4V6h7.17l3.42 3.41.58.59H28v7h2v-7a2 2 0 0 0-2-2z'
  }));
});
FolderAdd32.displayName = 'FolderAdd32';
FolderAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderAdd24 = React.forwardRef(function (_ref816, ref) {
  var className = _ref816.className,
      children = _ref816.children,
      style = _ref816.style,
      tabIndex = _ref816.tabIndex,
      rest = _objectWithoutProperties$2(_ref816, ["className", "children", "style", "tabIndex"]);

  var _getAttributes816 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes816.tabindex,
      props = _objectWithoutProperties$2(_getAttributes816, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 20h-2v4h-4v2h4v4h2v-4h4v-2h-4v-4z'
  }), React.createElement('path', {
    d: 'M28 8H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h12v-2H4V6h7.17l3.42 3.41.58.59H28v7h2v-7a2 2 0 0 0-2-2z'
  }));
});
FolderAdd24.displayName = 'FolderAdd24';
FolderAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderAdd20 = React.forwardRef(function (_ref817, ref) {
  var className = _ref817.className,
      children = _ref817.children,
      style = _ref817.style,
      tabIndex = _ref817.tabIndex,
      rest = _objectWithoutProperties$2(_ref817, ["className", "children", "style", "tabIndex"]);

  var _getAttributes817 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes817.tabindex,
      props = _objectWithoutProperties$2(_getAttributes817, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 20h-2v4h-4v2h4v4h2v-4h4v-2h-4v-4z'
  }), React.createElement('path', {
    d: 'M28 8H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h12v-2H4V6h7.17l3.42 3.41.58.59H28v7h2v-7a2 2 0 0 0-2-2z'
  }));
});
FolderAdd20.displayName = 'FolderAdd20';
FolderAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderDetails32 = React.forwardRef(function (_ref818, ref) {
  var className = _ref818.className,
      children = _ref818.children,
      style = _ref818.style,
      tabIndex = _ref818.tabIndex,
      rest = _objectWithoutProperties$2(_ref818, ["className", "children", "style", "tabIndex"]);

  var _getAttributes818 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes818.tabindex,
      props = _objectWithoutProperties$2(_getAttributes818, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 20h14v2H16zm0 4h14v2H16zm0 4h7v2h-7z'
  }), React.createElement('path', {
    d: 'M14 26H4V6h7.17l3.42 3.41.58.59H28v8h2v-8a2 2 0 0 0-2-2H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10z'
  }));
});
FolderDetails32.displayName = 'FolderDetails32';
FolderDetails32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderDetails32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderDetails24 = React.forwardRef(function (_ref819, ref) {
  var className = _ref819.className,
      children = _ref819.children,
      style = _ref819.style,
      tabIndex = _ref819.tabIndex,
      rest = _objectWithoutProperties$2(_ref819, ["className", "children", "style", "tabIndex"]);

  var _getAttributes819 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes819.tabindex,
      props = _objectWithoutProperties$2(_getAttributes819, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 20h14v2H16zm0 4h14v2H16zm0 4h7v2h-7z'
  }), React.createElement('path', {
    d: 'M14 26H4V6h7.17l3.42 3.41.58.59H28v8h2v-8a2 2 0 0 0-2-2H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10z'
  }));
});
FolderDetails24.displayName = 'FolderDetails24';
FolderDetails24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderDetails24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderDetails20 = React.forwardRef(function (_ref820, ref) {
  var className = _ref820.className,
      children = _ref820.children,
      style = _ref820.style,
      tabIndex = _ref820.tabIndex,
      rest = _objectWithoutProperties$2(_ref820, ["className", "children", "style", "tabIndex"]);

  var _getAttributes820 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes820.tabindex,
      props = _objectWithoutProperties$2(_getAttributes820, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 20h14v2H16zm0 4h14v2H16zm0 4h7v2h-7z'
  }), React.createElement('path', {
    d: 'M14 26H4V6h7.17l3.42 3.41.58.59H28v8h2v-8a2 2 0 0 0-2-2H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10z'
  }));
});
FolderDetails20.displayName = 'FolderDetails20';
FolderDetails20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderDetails20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderShared32 = React.forwardRef(function (_ref821, ref) {
  var className = _ref821.className,
      children = _ref821.children,
      style = _ref821.style,
      tabIndex = _ref821.tabIndex,
      rest = _objectWithoutProperties$2(_ref821, ["className", "children", "style", "tabIndex"]);

  var _getAttributes821 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes821.tabindex,
      props = _objectWithoutProperties$2(_getAttributes821, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 8H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-6 18h-8v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm6 0h-4v-1a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v1H4V6h7.17l3.42 3.41.58.59H28z'
  }), React.createElement('path', {
    d: 'M14 17a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm4-2a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
FolderShared32.displayName = 'FolderShared32';
FolderShared32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderShared32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderShared24 = React.forwardRef(function (_ref822, ref) {
  var className = _ref822.className,
      children = _ref822.children,
      style = _ref822.style,
      tabIndex = _ref822.tabIndex,
      rest = _objectWithoutProperties$2(_ref822, ["className", "children", "style", "tabIndex"]);

  var _getAttributes822 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes822.tabindex,
      props = _objectWithoutProperties$2(_getAttributes822, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 8H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-6 18h-8v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm6 0h-4v-1a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v1H4V6h7.17l3.42 3.41.58.59H28z'
  }), React.createElement('path', {
    d: 'M14 17a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm4-2a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
FolderShared24.displayName = 'FolderShared24';
FolderShared24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderShared24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var FolderShared20 = React.forwardRef(function (_ref823, ref) {
  var className = _ref823.className,
      children = _ref823.children,
      style = _ref823.style,
      tabIndex = _ref823.tabIndex,
      rest = _objectWithoutProperties$2(_ref823, ["className", "children", "style", "tabIndex"]);

  var _getAttributes823 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes823.tabindex,
      props = _objectWithoutProperties$2(_getAttributes823, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 8H16l-3.41-3.41A2 2 0 0 0 11.17 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-6 18h-8v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm6 0h-4v-1a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v1H4V6h7.17l3.42 3.41.58.59H28z'
  }), React.createElement('path', {
    d: 'M14 17a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm4-2a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
FolderShared20.displayName = 'FolderShared20';
FolderShared20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
FolderShared20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Folder32 = React.forwardRef(function (_ref824, ref) {
  var className = _ref824.className,
      children = _ref824.children,
      style = _ref824.style,
      tabIndex = _ref824.tabIndex,
      rest = _objectWithoutProperties$2(_ref824, ["className", "children", "style", "tabIndex"]);

  var _getAttributes824 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes824.tabindex,
      props = _objectWithoutProperties$2(_getAttributes824, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.17 6l3.42 3.41.58.59H28v16H4V6h7.17m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2H16l-3.41-3.41A2 2 0 0 0 11.17 4z'
  }));
});
Folder32.displayName = 'Folder32';
Folder32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Folder32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Folder24 = React.forwardRef(function (_ref825, ref) {
  var className = _ref825.className,
      children = _ref825.children,
      style = _ref825.style,
      tabIndex = _ref825.tabIndex,
      rest = _objectWithoutProperties$2(_ref825, ["className", "children", "style", "tabIndex"]);

  var _getAttributes825 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes825.tabindex,
      props = _objectWithoutProperties$2(_getAttributes825, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.17 6l3.42 3.41.58.59H28v16H4V6h7.17m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2H16l-3.41-3.41A2 2 0 0 0 11.17 4z'
  }));
});
Folder24.displayName = 'Folder24';
Folder24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Folder24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Folder20 = React.forwardRef(function (_ref826, ref) {
  var className = _ref826.className,
      children = _ref826.children,
      style = _ref826.style,
      tabIndex = _ref826.tabIndex,
      rest = _objectWithoutProperties$2(_ref826, ["className", "children", "style", "tabIndex"]);

  var _getAttributes826 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes826.tabindex,
      props = _objectWithoutProperties$2(_getAttributes826, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.17 6l3.42 3.41.58.59H28v16H4V6h7.17m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2H16l-3.41-3.41A2 2 0 0 0 11.17 4z'
  }));
});
Folder20.displayName = 'Folder20';
Folder20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Folder20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forum32 = React.forwardRef(function (_ref827, ref) {
  var className = _ref827.className,
      children = _ref827.children,
      style = _ref827.style,
      tabIndex = _ref827.tabIndex,
      rest = _objectWithoutProperties$2(_ref827, ["className", "children", "style", "tabIndex"]);

  var _getAttributes827 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes827.tabindex,
      props = _objectWithoutProperties$2(_getAttributes827, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18H2V5a3 3 0 0 1 3-3h13v2H5a1 1 0 0 0-1 1z'
  }), React.createElement('path', {
    d: 'M27 7H10a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h6v-2h-6a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-5.2L17 28.85 18.64 30l4.2-6H27a3 3 0 0 0 3-3V10a3 3 0 0 0-3-3z'
  }));
});
Forum32.displayName = 'Forum32';
Forum32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forum32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forum24 = React.forwardRef(function (_ref828, ref) {
  var className = _ref828.className,
      children = _ref828.children,
      style = _ref828.style,
      tabIndex = _ref828.tabIndex,
      rest = _objectWithoutProperties$2(_ref828, ["className", "children", "style", "tabIndex"]);

  var _getAttributes828 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes828.tabindex,
      props = _objectWithoutProperties$2(_getAttributes828, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18H2V5a3 3 0 0 1 3-3h13v2H5a1 1 0 0 0-1 1z'
  }), React.createElement('path', {
    d: 'M27 7H10a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h6v-2h-6a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-5.2L17 28.85 18.64 30l4.2-6H27a3 3 0 0 0 3-3V10a3 3 0 0 0-3-3z'
  }));
});
Forum24.displayName = 'Forum24';
Forum24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forum24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forum20 = React.forwardRef(function (_ref829, ref) {
  var className = _ref829.className,
      children = _ref829.children,
      style = _ref829.style,
      tabIndex = _ref829.tabIndex,
      rest = _objectWithoutProperties$2(_ref829, ["className", "children", "style", "tabIndex"]);

  var _getAttributes829 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes829.tabindex,
      props = _objectWithoutProperties$2(_getAttributes829, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18H2V5a3 3 0 0 1 3-3h13v2H5a1 1 0 0 0-1 1z'
  }), React.createElement('path', {
    d: 'M27 7H10a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h6v-2h-6a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-5.2L17 28.85 18.64 30l4.2-6H27a3 3 0 0 0 3-3V10a3 3 0 0 0-3-3z'
  }));
});
Forum20.displayName = 'Forum20';
Forum20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forum20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_1032 = React.forwardRef(function (_ref830, ref) {
  var className = _ref830.className,
      children = _ref830.children,
      style = _ref830.style,
      tabIndex = _ref830.tabIndex,
      rest = _objectWithoutProperties$2(_ref830, ["className", "children", "style", "tabIndex"]);

  var _getAttributes830 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes830.tabindex,
      props = _objectWithoutProperties$2(_getAttributes830, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M19.63 22.13a2.84 2.84 0 0 1-1.28-.27 2.44 2.44 0 0 1-.89-.77 3.57 3.57 0 0 1-.52-1.25 7.69 7.69 0 0 1-.17-1.68 7.83 7.83 0 0 1 .17-1.68 3.65 3.65 0 0 1 .52-1.25 2.44 2.44 0 0 1 .89-.77 2.84 2.84 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.23 5.23 0 0 1 .7 2.93 5.23 5.23 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.16 1.08zm0-1.22a1.07 1.07 0 0 0 1-.55 3.38 3.38 0 0 0 .37-1.51v-1.38a3.31 3.31 0 0 0-.29-1.5 1.23 1.23 0 0 0-2.06 0 3.31 3.31 0 0 0-.29 1.5v1.38a3.38 3.38 0 0 0 .29 1.51 1.06 1.06 0 0 0 .98.55zm-9 1.09v-1.18h2v-5.19l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z'
  }));
});
Forward_1032.displayName = 'Forward_1032';
Forward_1032.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_1032.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_1024 = React.forwardRef(function (_ref831, ref) {
  var className = _ref831.className,
      children = _ref831.children,
      style = _ref831.style,
      tabIndex = _ref831.tabIndex,
      rest = _objectWithoutProperties$2(_ref831, ["className", "children", "style", "tabIndex"]);

  var _getAttributes831 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes831.tabindex,
      props = _objectWithoutProperties$2(_getAttributes831, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M19.63 22.13a2.84 2.84 0 0 1-1.28-.27 2.44 2.44 0 0 1-.89-.77 3.57 3.57 0 0 1-.52-1.25 7.69 7.69 0 0 1-.17-1.68 7.83 7.83 0 0 1 .17-1.68 3.65 3.65 0 0 1 .52-1.25 2.44 2.44 0 0 1 .89-.77 2.84 2.84 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.23 5.23 0 0 1 .7 2.93 5.23 5.23 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.16 1.08zm0-1.22a1.07 1.07 0 0 0 1-.55 3.38 3.38 0 0 0 .37-1.51v-1.38a3.31 3.31 0 0 0-.29-1.5 1.23 1.23 0 0 0-2.06 0 3.31 3.31 0 0 0-.29 1.5v1.38a3.38 3.38 0 0 0 .29 1.51 1.06 1.06 0 0 0 .98.55zm-9 1.09v-1.18h2v-5.19l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z'
  }));
});
Forward_1024.displayName = 'Forward_1024';
Forward_1024.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_1024.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_1020 = React.forwardRef(function (_ref832, ref) {
  var className = _ref832.className,
      children = _ref832.children,
      style = _ref832.style,
      tabIndex = _ref832.tabIndex,
      rest = _objectWithoutProperties$2(_ref832, ["className", "children", "style", "tabIndex"]);

  var _getAttributes832 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes832.tabindex,
      props = _objectWithoutProperties$2(_getAttributes832, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M19.63 22.13a2.84 2.84 0 0 1-1.28-.27 2.44 2.44 0 0 1-.89-.77 3.57 3.57 0 0 1-.52-1.25 7.69 7.69 0 0 1-.17-1.68 7.83 7.83 0 0 1 .17-1.68 3.65 3.65 0 0 1 .52-1.25 2.44 2.44 0 0 1 .89-.77 2.84 2.84 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.23 5.23 0 0 1 .7 2.93 5.23 5.23 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.16 1.08zm0-1.22a1.07 1.07 0 0 0 1-.55 3.38 3.38 0 0 0 .37-1.51v-1.38a3.31 3.31 0 0 0-.29-1.5 1.23 1.23 0 0 0-2.06 0 3.31 3.31 0 0 0-.29 1.5v1.38a3.38 3.38 0 0 0 .29 1.51 1.06 1.06 0 0 0 .98.55zm-9 1.09v-1.18h2v-5.19l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z'
  }));
});
Forward_1020.displayName = 'Forward_1020';
Forward_1020.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_1020.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_3032 = React.forwardRef(function (_ref833, ref) {
  var className = _ref833.className,
      children = _ref833.children,
      style = _ref833.style,
      tabIndex = _ref833.tabIndex,
      rest = _objectWithoutProperties$2(_ref833, ["className", "children", "style", "tabIndex"]);

  var _getAttributes833 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes833.tabindex,
      props = _objectWithoutProperties$2(_getAttributes833, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M19.64 22.13a2.81 2.81 0 0 1-1.28-.27 2.36 2.36 0 0 1-.89-.77 3.39 3.39 0 0 1-.47-1.25 7.12 7.12 0 0 1-.17-1.68 7.24 7.24 0 0 1 .17-1.68 3.46 3.46 0 0 1 .52-1.25 2.36 2.36 0 0 1 .89-.77 2.81 2.81 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.31 5.31 0 0 1 .7 2.93 5.31 5.31 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.21 1.08zm0-1.22a1 1 0 0 0 1-.55 3.24 3.24 0 0 0 .3-1.51v-1.38a3.17 3.17 0 0 0-.3-1.5 1.22 1.22 0 0 0-2.05 0 3.18 3.18 0 0 0-.29 1.5v1.38a3.25 3.25 0 0 0 .29 1.51 1 1 0 0 0 1.05.55zm-7.02-3.49a1.46 1.46 0 0 0 1-.27.84.84 0 0 0 .31-.68v-.08a.94.94 0 0 0-.3-.74 1.2 1.2 0 0 0-.83-.27 1.65 1.65 0 0 0-.89.24 2.1 2.1 0 0 0-.68.68l-.93-.83a5.37 5.37 0 0 1 .44-.51 2.7 2.7 0 0 1 .54-.4 2.55 2.55 0 0 1 .7-.27 3.25 3.25 0 0 1 .87-.1 3.94 3.94 0 0 1 1.06.14 2.33 2.33 0 0 1 .82.4 1.91 1.91 0 0 1 .54.63 1.87 1.87 0 0 1 .18.83 2 2 0 0 1-.11.67 1.82 1.82 0 0 1-.32.52 1.79 1.79 0 0 1-.47.36 2.27 2.27 0 0 1-.57.2V18a2.34 2.34 0 0 1 .63.21 1.7 1.7 0 0 1 .51.38 1.89 1.89 0 0 1 .34.55 2.07 2.07 0 0 1 .12.73 2 2 0 0 1-.2.92 2 2 0 0 1-.58.72 2.66 2.66 0 0 1-.89.45 3.76 3.76 0 0 1-1.15.16 4.1 4.1 0 0 1-1-.11 3.1 3.1 0 0 1-.76-.31 2.76 2.76 0 0 1-.56-.45 4.22 4.22 0 0 1-.44-.55l1.07-.81a3.07 3.07 0 0 0 .28.42 1.94 1.94 0 0 0 .36.34 1.57 1.57 0 0 0 .45.22 2 2 0 0 0 .57.07 1.45 1.45 0 0 0 1-.3 1.12 1.12 0 0 0 .34-.85v-.08a1 1 0 0 0-.37-.8 1.78 1.78 0 0 0-1.06-.28h-.76v-1.21z'
  }));
});
Forward_3032.displayName = 'Forward_3032';
Forward_3032.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_3032.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_3024 = React.forwardRef(function (_ref834, ref) {
  var className = _ref834.className,
      children = _ref834.children,
      style = _ref834.style,
      tabIndex = _ref834.tabIndex,
      rest = _objectWithoutProperties$2(_ref834, ["className", "children", "style", "tabIndex"]);

  var _getAttributes834 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes834.tabindex,
      props = _objectWithoutProperties$2(_getAttributes834, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M19.64 22.13a2.81 2.81 0 0 1-1.28-.27 2.36 2.36 0 0 1-.89-.77 3.39 3.39 0 0 1-.47-1.25 7.12 7.12 0 0 1-.17-1.68 7.24 7.24 0 0 1 .17-1.68 3.46 3.46 0 0 1 .52-1.25 2.36 2.36 0 0 1 .89-.77 2.81 2.81 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.31 5.31 0 0 1 .7 2.93 5.31 5.31 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.21 1.08zm0-1.22a1 1 0 0 0 1-.55 3.24 3.24 0 0 0 .3-1.51v-1.38a3.17 3.17 0 0 0-.3-1.5 1.22 1.22 0 0 0-2.05 0 3.18 3.18 0 0 0-.29 1.5v1.38a3.25 3.25 0 0 0 .29 1.51 1 1 0 0 0 1.05.55zm-7.02-3.49a1.46 1.46 0 0 0 1-.27.84.84 0 0 0 .31-.68v-.08a.94.94 0 0 0-.3-.74 1.2 1.2 0 0 0-.83-.27 1.65 1.65 0 0 0-.89.24 2.1 2.1 0 0 0-.68.68l-.93-.83a5.37 5.37 0 0 1 .44-.51 2.7 2.7 0 0 1 .54-.4 2.55 2.55 0 0 1 .7-.27 3.25 3.25 0 0 1 .87-.1 3.94 3.94 0 0 1 1.06.14 2.33 2.33 0 0 1 .82.4 1.91 1.91 0 0 1 .54.63 1.87 1.87 0 0 1 .18.83 2 2 0 0 1-.11.67 1.82 1.82 0 0 1-.32.52 1.79 1.79 0 0 1-.47.36 2.27 2.27 0 0 1-.57.2V18a2.34 2.34 0 0 1 .63.21 1.7 1.7 0 0 1 .51.38 1.89 1.89 0 0 1 .34.55 2.07 2.07 0 0 1 .12.73 2 2 0 0 1-.2.92 2 2 0 0 1-.58.72 2.66 2.66 0 0 1-.89.45 3.76 3.76 0 0 1-1.15.16 4.1 4.1 0 0 1-1-.11 3.1 3.1 0 0 1-.76-.31 2.76 2.76 0 0 1-.56-.45 4.22 4.22 0 0 1-.44-.55l1.07-.81a3.07 3.07 0 0 0 .28.42 1.94 1.94 0 0 0 .36.34 1.57 1.57 0 0 0 .45.22 2 2 0 0 0 .57.07 1.45 1.45 0 0 0 1-.3 1.12 1.12 0 0 0 .34-.85v-.08a1 1 0 0 0-.37-.8 1.78 1.78 0 0 0-1.06-.28h-.76v-1.21z'
  }));
});
Forward_3024.displayName = 'Forward_3024';
Forward_3024.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_3024.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_3020 = React.forwardRef(function (_ref835, ref) {
  var className = _ref835.className,
      children = _ref835.children,
      style = _ref835.style,
      tabIndex = _ref835.tabIndex,
      rest = _objectWithoutProperties$2(_ref835, ["className", "children", "style", "tabIndex"]);

  var _getAttributes835 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes835.tabindex,
      props = _objectWithoutProperties$2(_getAttributes835, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M19.64 22.13a2.81 2.81 0 0 1-1.28-.27 2.36 2.36 0 0 1-.89-.77 3.39 3.39 0 0 1-.47-1.25 7.12 7.12 0 0 1-.17-1.68 7.24 7.24 0 0 1 .17-1.68 3.46 3.46 0 0 1 .52-1.25 2.36 2.36 0 0 1 .89-.77 2.81 2.81 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.31 5.31 0 0 1 .7 2.93 5.31 5.31 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.21 1.08zm0-1.22a1 1 0 0 0 1-.55 3.24 3.24 0 0 0 .3-1.51v-1.38a3.17 3.17 0 0 0-.3-1.5 1.22 1.22 0 0 0-2.05 0 3.18 3.18 0 0 0-.29 1.5v1.38a3.25 3.25 0 0 0 .29 1.51 1 1 0 0 0 1.05.55zm-7.02-3.49a1.46 1.46 0 0 0 1-.27.84.84 0 0 0 .31-.68v-.08a.94.94 0 0 0-.3-.74 1.2 1.2 0 0 0-.83-.27 1.65 1.65 0 0 0-.89.24 2.1 2.1 0 0 0-.68.68l-.93-.83a5.37 5.37 0 0 1 .44-.51 2.7 2.7 0 0 1 .54-.4 2.55 2.55 0 0 1 .7-.27 3.25 3.25 0 0 1 .87-.1 3.94 3.94 0 0 1 1.06.14 2.33 2.33 0 0 1 .82.4 1.91 1.91 0 0 1 .54.63 1.87 1.87 0 0 1 .18.83 2 2 0 0 1-.11.67 1.82 1.82 0 0 1-.32.52 1.79 1.79 0 0 1-.47.36 2.27 2.27 0 0 1-.57.2V18a2.34 2.34 0 0 1 .63.21 1.7 1.7 0 0 1 .51.38 1.89 1.89 0 0 1 .34.55 2.07 2.07 0 0 1 .12.73 2 2 0 0 1-.2.92 2 2 0 0 1-.58.72 2.66 2.66 0 0 1-.89.45 3.76 3.76 0 0 1-1.15.16 4.1 4.1 0 0 1-1-.11 3.1 3.1 0 0 1-.76-.31 2.76 2.76 0 0 1-.56-.45 4.22 4.22 0 0 1-.44-.55l1.07-.81a3.07 3.07 0 0 0 .28.42 1.94 1.94 0 0 0 .36.34 1.57 1.57 0 0 0 .45.22 2 2 0 0 0 .57.07 1.45 1.45 0 0 0 1-.3 1.12 1.12 0 0 0 .34-.85v-.08a1 1 0 0 0-.37-.8 1.78 1.78 0 0 0-1.06-.28h-.76v-1.21z'
  }));
});
Forward_3020.displayName = 'Forward_3020';
Forward_3020.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_3020.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_532 = React.forwardRef(function (_ref836, ref) {
  var className = _ref836.className,
      children = _ref836.children,
      style = _ref836.style,
      tabIndex = _ref836.tabIndex,
      rest = _objectWithoutProperties$2(_ref836, ["className", "children", "style", "tabIndex"]);

  var _getAttributes836 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes836.tabindex,
      props = _objectWithoutProperties$2(_getAttributes836, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M18.58 15.58h-3.45L15 18.15a4.83 4.83 0 0 1 .26-.45 1.59 1.59 0 0 1 .33-.35 1.53 1.53 0 0 1 .44-.23 2 2 0 0 1 .6-.08 2.54 2.54 0 0 1 .92.16 2.06 2.06 0 0 1 .74.48 2.28 2.28 0 0 1 .5.77 2.73 2.73 0 0 1 .18 1 2.87 2.87 0 0 1-.19 1.07 2.36 2.36 0 0 1-.55.84 2.44 2.44 0 0 1-.89.55 3.23 3.23 0 0 1-1.21.2 3.79 3.79 0 0 1-.94-.11 3 3 0 0 1-.74-.32 2.45 2.45 0 0 1-.55-.45 4.13 4.13 0 0 1-.41-.55l1.06-.81.27.41a1.82 1.82 0 0 0 .34.34 1.59 1.59 0 0 0 .43.22 1.52 1.52 0 0 0 .55.08 1.29 1.29 0 0 0 1-.36 1.41 1.41 0 0 0 .33-1v-.06a1.18 1.18 0 0 0-1.28-1.27 1.44 1.44 0 0 0-.77.18 1.94 1.94 0 0 0-.48.39l-1.19-.17.29-4.31h4.52z'
  }));
});
Forward_532.displayName = 'Forward_532';
Forward_532.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_532.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_524 = React.forwardRef(function (_ref837, ref) {
  var className = _ref837.className,
      children = _ref837.children,
      style = _ref837.style,
      tabIndex = _ref837.tabIndex,
      rest = _objectWithoutProperties$2(_ref837, ["className", "children", "style", "tabIndex"]);

  var _getAttributes837 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes837.tabindex,
      props = _objectWithoutProperties$2(_getAttributes837, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M18.58 15.58h-3.45L15 18.15a4.83 4.83 0 0 1 .26-.45 1.59 1.59 0 0 1 .33-.35 1.53 1.53 0 0 1 .44-.23 2 2 0 0 1 .6-.08 2.54 2.54 0 0 1 .92.16 2.06 2.06 0 0 1 .74.48 2.28 2.28 0 0 1 .5.77 2.73 2.73 0 0 1 .18 1 2.87 2.87 0 0 1-.19 1.07 2.36 2.36 0 0 1-.55.84 2.44 2.44 0 0 1-.89.55 3.23 3.23 0 0 1-1.21.2 3.79 3.79 0 0 1-.94-.11 3 3 0 0 1-.74-.32 2.45 2.45 0 0 1-.55-.45 4.13 4.13 0 0 1-.41-.55l1.06-.81.27.41a1.82 1.82 0 0 0 .34.34 1.59 1.59 0 0 0 .43.22 1.52 1.52 0 0 0 .55.08 1.29 1.29 0 0 0 1-.36 1.41 1.41 0 0 0 .33-1v-.06a1.18 1.18 0 0 0-1.28-1.27 1.44 1.44 0 0 0-.77.18 1.94 1.94 0 0 0-.48.39l-1.19-.17.29-4.31h4.52z'
  }));
});
Forward_524.displayName = 'Forward_524';
Forward_524.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_524.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Forward_520 = React.forwardRef(function (_ref838, ref) {
  var className = _ref838.className,
      children = _ref838.children,
      style = _ref838.style,
      tabIndex = _ref838.tabIndex,
      rest = _objectWithoutProperties$2(_ref838, ["className", "children", "style", "tabIndex"]);

  var _getAttributes838 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes838.tabindex,
      props = _objectWithoutProperties$2(_getAttributes838, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 18A10 10 0 1 1 16 8h4v5l6-6-6-6v5h-4a12 12 0 1 0 12 12z'
  }), React.createElement('path', {
    d: 'M18.58 15.58h-3.45L15 18.15a4.83 4.83 0 0 1 .26-.45 1.59 1.59 0 0 1 .33-.35 1.53 1.53 0 0 1 .44-.23 2 2 0 0 1 .6-.08 2.54 2.54 0 0 1 .92.16 2.06 2.06 0 0 1 .74.48 2.28 2.28 0 0 1 .5.77 2.73 2.73 0 0 1 .18 1 2.87 2.87 0 0 1-.19 1.07 2.36 2.36 0 0 1-.55.84 2.44 2.44 0 0 1-.89.55 3.23 3.23 0 0 1-1.21.2 3.79 3.79 0 0 1-.94-.11 3 3 0 0 1-.74-.32 2.45 2.45 0 0 1-.55-.45 4.13 4.13 0 0 1-.41-.55l1.06-.81.27.41a1.82 1.82 0 0 0 .34.34 1.59 1.59 0 0 0 .43.22 1.52 1.52 0 0 0 .55.08 1.29 1.29 0 0 0 1-.36 1.41 1.41 0 0 0 .33-1v-.06a1.18 1.18 0 0 0-1.28-1.27 1.44 1.44 0 0 0-.77.18 1.94 1.94 0 0 0-.48.39l-1.19-.17.29-4.31h4.52z'
  }));
});
Forward_520.displayName = 'Forward_520';
Forward_520.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Forward_520.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Function32 = React.forwardRef(function (_ref839, ref) {
  var className = _ref839.className,
      children = _ref839.children,
      style = _ref839.style,
      tabIndex = _ref839.tabIndex,
      rest = _objectWithoutProperties$2(_ref839, ["className", "children", "style", "tabIndex"]);

  var _getAttributes839 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes839.tabindex,
      props = _objectWithoutProperties$2(_getAttributes839, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.5 30a2.5 2.5 0 0 1 0-5c.63-.07 2.35-1.53 2.49-7.22l-1.78-.45a2.92 2.92 0 0 1 0-5.66l1.79-.46C11.55 4 19.32 2 23.5 2a2.5 2.5 0 0 1 0 5c-.08 0-2.23.15-2.48 4.22l1.77.45a2.92 2.92 0 0 1 0 5.66l-1.79.46C20.49 29.86 8.62 30 8.5 30zm15-26c-.43 0-10.5.11-10.5 8v.78l-3.3.83a.92.92 0 0 0 0 1.78l3.3.83V17c0 9.72-4 10-4.5 10a.5.5 0 0 0 0 1c.43 0 10.5-.17 10.5-11v-.78l3.3-.83a.92.92 0 0 0 0-1.78l-3.3-.83V12c0-6.92 4.46-7 4.5-7a.5.5 0 0 0 0-1z'
  }), React.createElement('path', {
    d: 'M4.15 23.46a14 14 0 0 1 6.46-20.38l.77 1.84A12 12 0 0 0 5.85 22.4zm17.24 5.46l-.77-1.84a12 12 0 0 0 5.49-17.54l1.69-1.08a14 14 0 0 1-6.41 20.46z'
  }));
});
Function32.displayName = 'Function32';
Function32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Function32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Function24 = React.forwardRef(function (_ref840, ref) {
  var className = _ref840.className,
      children = _ref840.children,
      style = _ref840.style,
      tabIndex = _ref840.tabIndex,
      rest = _objectWithoutProperties$2(_ref840, ["className", "children", "style", "tabIndex"]);

  var _getAttributes840 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes840.tabindex,
      props = _objectWithoutProperties$2(_getAttributes840, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.5 30a2.5 2.5 0 0 1 0-5c.63-.07 2.35-1.53 2.49-7.22l-1.78-.45a2.92 2.92 0 0 1 0-5.66l1.79-.46C11.55 4 19.32 2 23.5 2a2.5 2.5 0 0 1 0 5c-.08 0-2.23.15-2.48 4.22l1.77.45a2.92 2.92 0 0 1 0 5.66l-1.79.46C20.49 29.86 8.62 30 8.5 30zm15-26c-.43 0-10.5.11-10.5 8v.78l-3.3.83a.92.92 0 0 0 0 1.78l3.3.83V17c0 9.72-4 10-4.5 10a.5.5 0 0 0 0 1c.43 0 10.5-.17 10.5-11v-.78l3.3-.83a.92.92 0 0 0 0-1.78l-3.3-.83V12c0-6.92 4.46-7 4.5-7a.5.5 0 0 0 0-1z'
  }), React.createElement('path', {
    d: 'M4.15 23.46a14 14 0 0 1 6.46-20.38l.77 1.84A12 12 0 0 0 5.85 22.4zm17.24 5.46l-.77-1.84a12 12 0 0 0 5.49-17.54l1.69-1.08a14 14 0 0 1-6.41 20.46z'
  }));
});
Function24.displayName = 'Function24';
Function24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Function24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Function20 = React.forwardRef(function (_ref841, ref) {
  var className = _ref841.className,
      children = _ref841.children,
      style = _ref841.style,
      tabIndex = _ref841.tabIndex,
      rest = _objectWithoutProperties$2(_ref841, ["className", "children", "style", "tabIndex"]);

  var _getAttributes841 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes841.tabindex,
      props = _objectWithoutProperties$2(_getAttributes841, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.5 30a2.5 2.5 0 0 1 0-5c.63-.07 2.35-1.53 2.49-7.22l-1.78-.45a2.92 2.92 0 0 1 0-5.66l1.79-.46C11.55 4 19.32 2 23.5 2a2.5 2.5 0 0 1 0 5c-.08 0-2.23.15-2.48 4.22l1.77.45a2.92 2.92 0 0 1 0 5.66l-1.79.46C20.49 29.86 8.62 30 8.5 30zm15-26c-.43 0-10.5.11-10.5 8v.78l-3.3.83a.92.92 0 0 0 0 1.78l3.3.83V17c0 9.72-4 10-4.5 10a.5.5 0 0 0 0 1c.43 0 10.5-.17 10.5-11v-.78l3.3-.83a.92.92 0 0 0 0-1.78l-3.3-.83V12c0-6.92 4.46-7 4.5-7a.5.5 0 0 0 0-1z'
  }), React.createElement('path', {
    d: 'M4.15 23.46a14 14 0 0 1 6.46-20.38l.77 1.84A12 12 0 0 0 5.85 22.4zm17.24 5.46l-.77-1.84a12 12 0 0 0 5.49-17.54l1.69-1.08a14 14 0 0 1-6.41 20.46z'
  }));
});
Function20.displayName = 'Function20';
Function20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Function20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var GameConsole32 = React.forwardRef(function (_ref842, ref) {
  var className = _ref842.className,
      children = _ref842.children,
      style = _ref842.style,
      tabIndex = _ref842.tabIndex,
      rest = _objectWithoutProperties$2(_ref842, ["className", "children", "style", "tabIndex"]);

  var _getAttributes842 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes842.tabindex,
      props = _objectWithoutProperties$2(_getAttributes842, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.51 26a5.48 5.48 0 0 1-1.44-.19A5.6 5.6 0 0 1 2.19 19l2.33-8.84a5.54 5.54 0 0 1 2.59-3.43 5.43 5.43 0 0 1 4.15-.54A5.52 5.52 0 0 1 14.7 9h2.6a5.49 5.49 0 0 1 3.44-2.81 5.43 5.43 0 0 1 4.15.54 5.57 5.57 0 0 1 2.59 3.41L29.81 19a5.6 5.6 0 0 1-3.89 6.83 5.43 5.43 0 0 1-4.15-.54 5.54 5.54 0 0 1-2.59-3.41L19 21h-6l-.23.86a5.54 5.54 0 0 1-2.59 3.41 5.46 5.46 0 0 1-2.67.73zM9.83 8a3.49 3.49 0 0 0-1.72.46 3.6 3.6 0 0 0-1.66 2.19l-2.33 8.84a3.6 3.6 0 0 0 2.48 4.39 3.43 3.43 0 0 0 2.62-.34 3.54 3.54 0 0 0 1.66-2.19L11.5 19h9l.61 2.35a3.58 3.58 0 0 0 1.66 2.19 3.46 3.46 0 0 0 2.63.34 3.58 3.58 0 0 0 2.47-4.39l-2.33-8.84a3.55 3.55 0 0 0-1.65-2.19 3.46 3.46 0 0 0-2.63-.34 3.55 3.55 0 0 0-2.37 2.22l-.24.66h-5.3l-.24-.66a3.56 3.56 0 0 0-2.38-2.22 3.48 3.48 0 0 0-.9-.12z'
  }), React.createElement('path', {
    d: 'M10 16a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-2z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '12',
    r: '1'
  }), React.createElement('circle', {
    cx: '22',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '20',
    cy: '14',
    r: '1'
  }), React.createElement('circle', {
    cx: '24',
    cy: '14',
    r: '1'
  }));
});
GameConsole32.displayName = 'GameConsole32';
GameConsole32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
GameConsole32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var GameConsole24 = React.forwardRef(function (_ref843, ref) {
  var className = _ref843.className,
      children = _ref843.children,
      style = _ref843.style,
      tabIndex = _ref843.tabIndex,
      rest = _objectWithoutProperties$2(_ref843, ["className", "children", "style", "tabIndex"]);

  var _getAttributes843 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes843.tabindex,
      props = _objectWithoutProperties$2(_getAttributes843, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.51 26a5.48 5.48 0 0 1-1.44-.19A5.6 5.6 0 0 1 2.19 19l2.33-8.84a5.54 5.54 0 0 1 2.59-3.43 5.43 5.43 0 0 1 4.15-.54A5.52 5.52 0 0 1 14.7 9h2.6a5.49 5.49 0 0 1 3.44-2.81 5.43 5.43 0 0 1 4.15.54 5.57 5.57 0 0 1 2.59 3.41L29.81 19a5.6 5.6 0 0 1-3.89 6.83 5.43 5.43 0 0 1-4.15-.54 5.54 5.54 0 0 1-2.59-3.41L19 21h-6l-.23.86a5.54 5.54 0 0 1-2.59 3.41 5.46 5.46 0 0 1-2.67.73zM9.83 8a3.49 3.49 0 0 0-1.72.46 3.6 3.6 0 0 0-1.66 2.19l-2.33 8.84a3.6 3.6 0 0 0 2.48 4.39 3.43 3.43 0 0 0 2.62-.34 3.54 3.54 0 0 0 1.66-2.19L11.5 19h9l.61 2.35a3.58 3.58 0 0 0 1.66 2.19 3.46 3.46 0 0 0 2.63.34 3.58 3.58 0 0 0 2.47-4.39l-2.33-8.84a3.55 3.55 0 0 0-1.65-2.19 3.46 3.46 0 0 0-2.63-.34 3.55 3.55 0 0 0-2.37 2.22l-.24.66h-5.3l-.24-.66a3.56 3.56 0 0 0-2.38-2.22 3.48 3.48 0 0 0-.9-.12z'
  }), React.createElement('path', {
    d: 'M10 16a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-2z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '12',
    r: '1'
  }), React.createElement('circle', {
    cx: '22',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '20',
    cy: '14',
    r: '1'
  }), React.createElement('circle', {
    cx: '24',
    cy: '14',
    r: '1'
  }));
});
GameConsole24.displayName = 'GameConsole24';
GameConsole24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
GameConsole24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var GameConsole20 = React.forwardRef(function (_ref844, ref) {
  var className = _ref844.className,
      children = _ref844.children,
      style = _ref844.style,
      tabIndex = _ref844.tabIndex,
      rest = _objectWithoutProperties$2(_ref844, ["className", "children", "style", "tabIndex"]);

  var _getAttributes844 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes844.tabindex,
      props = _objectWithoutProperties$2(_getAttributes844, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.51 26a5.48 5.48 0 0 1-1.44-.19A5.6 5.6 0 0 1 2.19 19l2.33-8.84a5.54 5.54 0 0 1 2.59-3.43 5.43 5.43 0 0 1 4.15-.54A5.52 5.52 0 0 1 14.7 9h2.6a5.49 5.49 0 0 1 3.44-2.81 5.43 5.43 0 0 1 4.15.54 5.57 5.57 0 0 1 2.59 3.41L29.81 19a5.6 5.6 0 0 1-3.89 6.83 5.43 5.43 0 0 1-4.15-.54 5.54 5.54 0 0 1-2.59-3.41L19 21h-6l-.23.86a5.54 5.54 0 0 1-2.59 3.41 5.46 5.46 0 0 1-2.67.73zM9.83 8a3.49 3.49 0 0 0-1.72.46 3.6 3.6 0 0 0-1.66 2.19l-2.33 8.84a3.6 3.6 0 0 0 2.48 4.39 3.43 3.43 0 0 0 2.62-.34 3.54 3.54 0 0 0 1.66-2.19L11.5 19h9l.61 2.35a3.58 3.58 0 0 0 1.66 2.19 3.46 3.46 0 0 0 2.63.34 3.58 3.58 0 0 0 2.47-4.39l-2.33-8.84a3.55 3.55 0 0 0-1.65-2.19 3.46 3.46 0 0 0-2.63-.34 3.55 3.55 0 0 0-2.37 2.22l-.24.66h-5.3l-.24-.66a3.56 3.56 0 0 0-2.38-2.22 3.48 3.48 0 0 0-.9-.12z'
  }), React.createElement('path', {
    d: 'M10 16a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-2z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '12',
    r: '1'
  }), React.createElement('circle', {
    cx: '22',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '20',
    cy: '14',
    r: '1'
  }), React.createElement('circle', {
    cx: '24',
    cy: '14',
    r: '1'
  }));
});
GameConsole20.displayName = 'GameConsole20';
GameConsole20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
GameConsole20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var GameWireless32 = React.forwardRef(function (_ref845, ref) {
  var className = _ref845.className,
      children = _ref845.children,
      style = _ref845.style,
      tabIndex = _ref845.tabIndex,
      rest = _objectWithoutProperties$2(_ref845, ["className", "children", "style", "tabIndex"]);

  var _getAttributes845 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes845.tabindex,
      props = _objectWithoutProperties$2(_getAttributes845, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.51 30a5.48 5.48 0 0 1-1.44-.19A5.6 5.6 0 0 1 2.19 23l2.33-8.84a5.54 5.54 0 0 1 2.59-3.41 5.43 5.43 0 0 1 4.15-.54A5.52 5.52 0 0 1 14.7 13h2.6a5.49 5.49 0 0 1 3.44-2.81 5.43 5.43 0 0 1 4.15.54 5.55 5.55 0 0 1 2.59 3.41L29.81 23a5.6 5.6 0 0 1-3.89 6.83 5.43 5.43 0 0 1-4.15-.54 5.54 5.54 0 0 1-2.59-3.41L19 25h-6l-.23.86a5.54 5.54 0 0 1-2.59 3.41 5.46 5.46 0 0 1-2.67.73zm2.32-18a3.49 3.49 0 0 0-1.72.46 3.58 3.58 0 0 0-1.66 2.19l-2.33 8.84a3.6 3.6 0 0 0 2.48 4.39 3.43 3.43 0 0 0 2.62-.34 3.57 3.57 0 0 0 1.66-2.19L11.5 23h9l.61 2.35a3.6 3.6 0 0 0 1.66 2.19 3.46 3.46 0 0 0 2.63.34 3.58 3.58 0 0 0 2.47-4.39l-2.33-8.84a3.53 3.53 0 0 0-1.65-2.19 3.46 3.46 0 0 0-2.63-.34 3.55 3.55 0 0 0-2.37 2.22l-.24.66h-5.3l-.24-.66a3.56 3.56 0 0 0-2.38-2.22 3.48 3.48 0 0 0-.9-.12z'
  }), React.createElement('path', {
    d: 'M10 20a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-2z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '22',
    cy: '20',
    r: '1'
  }), React.createElement('circle', {
    cx: '20',
    cy: '18',
    r: '1'
  }), React.createElement('circle', {
    cx: '24',
    cy: '18',
    r: '1'
  }), React.createElement('path', {
    d: 'M13.75 9l-1.5-1.33a5 5 0 0 1 7.5 0L18.25 9a3 3 0 0 0-4.5 0z'
  }), React.createElement('path', {
    d: 'M21.25 6.37a7 7 0 0 0-10.5 0l-1.5-1.32a9 9 0 0 1 13.5 0z'
  }));
});
GameWireless32.displayName = 'GameWireless32';
GameWireless32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
GameWireless32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var GameWireless24 = React.forwardRef(function (_ref846, ref) {
  var className = _ref846.className,
      children = _ref846.children,
      style = _ref846.style,
      tabIndex = _ref846.tabIndex,
      rest = _objectWithoutProperties$2(_ref846, ["className", "children", "style", "tabIndex"]);

  var _getAttributes846 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes846.tabindex,
      props = _objectWithoutProperties$2(_getAttributes846, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.51 30a5.48 5.48 0 0 1-1.44-.19A5.6 5.6 0 0 1 2.19 23l2.33-8.84a5.54 5.54 0 0 1 2.59-3.41 5.43 5.43 0 0 1 4.15-.54A5.52 5.52 0 0 1 14.7 13h2.6a5.49 5.49 0 0 1 3.44-2.81 5.43 5.43 0 0 1 4.15.54 5.55 5.55 0 0 1 2.59 3.41L29.81 23a5.6 5.6 0 0 1-3.89 6.83 5.43 5.43 0 0 1-4.15-.54 5.54 5.54 0 0 1-2.59-3.41L19 25h-6l-.23.86a5.54 5.54 0 0 1-2.59 3.41 5.46 5.46 0 0 1-2.67.73zm2.32-18a3.49 3.49 0 0 0-1.72.46 3.58 3.58 0 0 0-1.66 2.19l-2.33 8.84a3.6 3.6 0 0 0 2.48 4.39 3.43 3.43 0 0 0 2.62-.34 3.57 3.57 0 0 0 1.66-2.19L11.5 23h9l.61 2.35a3.6 3.6 0 0 0 1.66 2.19 3.46 3.46 0 0 0 2.63.34 3.58 3.58 0 0 0 2.47-4.39l-2.33-8.84a3.53 3.53 0 0 0-1.65-2.19 3.46 3.46 0 0 0-2.63-.34 3.55 3.55 0 0 0-2.37 2.22l-.24.66h-5.3l-.24-.66a3.56 3.56 0 0 0-2.38-2.22 3.48 3.48 0 0 0-.9-.12z'
  }), React.createElement('path', {
    d: 'M10 20a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-2z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '22',
    cy: '20',
    r: '1'
  }), React.createElement('circle', {
    cx: '20',
    cy: '18',
    r: '1'
  }), React.createElement('circle', {
    cx: '24',
    cy: '18',
    r: '1'
  }), React.createElement('path', {
    d: 'M13.75 9l-1.5-1.33a5 5 0 0 1 7.5 0L18.25 9a3 3 0 0 0-4.5 0z'
  }), React.createElement('path', {
    d: 'M21.25 6.37a7 7 0 0 0-10.5 0l-1.5-1.32a9 9 0 0 1 13.5 0z'
  }));
});
GameWireless24.displayName = 'GameWireless24';
GameWireless24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
GameWireless24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var GameWireless20 = React.forwardRef(function (_ref847, ref) {
  var className = _ref847.className,
      children = _ref847.children,
      style = _ref847.style,
      tabIndex = _ref847.tabIndex,
      rest = _objectWithoutProperties$2(_ref847, ["className", "children", "style", "tabIndex"]);

  var _getAttributes847 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes847.tabindex,
      props = _objectWithoutProperties$2(_getAttributes847, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.51 30a5.48 5.48 0 0 1-1.44-.19A5.6 5.6 0 0 1 2.19 23l2.33-8.84a5.54 5.54 0 0 1 2.59-3.41 5.43 5.43 0 0 1 4.15-.54A5.52 5.52 0 0 1 14.7 13h2.6a5.49 5.49 0 0 1 3.44-2.81 5.43 5.43 0 0 1 4.15.54 5.55 5.55 0 0 1 2.59 3.41L29.81 23a5.6 5.6 0 0 1-3.89 6.83 5.43 5.43 0 0 1-4.15-.54 5.54 5.54 0 0 1-2.59-3.41L19 25h-6l-.23.86a5.54 5.54 0 0 1-2.59 3.41 5.46 5.46 0 0 1-2.67.73zm2.32-18a3.49 3.49 0 0 0-1.72.46 3.58 3.58 0 0 0-1.66 2.19l-2.33 8.84a3.6 3.6 0 0 0 2.48 4.39 3.43 3.43 0 0 0 2.62-.34 3.57 3.57 0 0 0 1.66-2.19L11.5 23h9l.61 2.35a3.6 3.6 0 0 0 1.66 2.19 3.46 3.46 0 0 0 2.63.34 3.58 3.58 0 0 0 2.47-4.39l-2.33-8.84a3.53 3.53 0 0 0-1.65-2.19 3.46 3.46 0 0 0-2.63-.34 3.55 3.55 0 0 0-2.37 2.22l-.24.66h-5.3l-.24-.66a3.56 3.56 0 0 0-2.38-2.22 3.48 3.48 0 0 0-.9-.12z'
  }), React.createElement('path', {
    d: 'M10 20a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-2z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '16',
    r: '1'
  }), React.createElement('circle', {
    cx: '22',
    cy: '20',
    r: '1'
  }), React.createElement('circle', {
    cx: '20',
    cy: '18',
    r: '1'
  }), React.createElement('circle', {
    cx: '24',
    cy: '18',
    r: '1'
  }), React.createElement('path', {
    d: 'M13.75 9l-1.5-1.33a5 5 0 0 1 7.5 0L18.25 9a3 3 0 0 0-4.5 0z'
  }), React.createElement('path', {
    d: 'M21.25 6.37a7 7 0 0 0-10.5 0l-1.5-1.32a9 9 0 0 1 13.5 0z'
  }));
});
GameWireless20.displayName = 'GameWireless20';
GameWireless20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
GameWireless20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Globe32 = React.forwardRef(function (_ref848, ref) {
  var className = _ref848.className,
      children = _ref848.children,
      style = _ref848.style,
      tabIndex = _ref848.tabIndex,
      rest = _objectWithoutProperties$2(_ref848, ["className", "children", "style", "tabIndex"]);

  var _getAttributes848 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes848.tabindex,
      props = _objectWithoutProperties$2(_getAttributes848, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 4a7 7 0 1 1-7 7 7 7 0 0 1 7-7m0-2a9 9 0 1 0 9 9 9 9 0 0 0-9-9z'
  }), React.createElement('path', {
    d: 'M28 11a13.92 13.92 0 0 0-4.11-9.89l-1.41 1.41a12 12 0 0 1-16.92 17l-1.45 1.37A13.92 13.92 0 0 0 14 25v3h-4v2h10v-2h-4v-3.16A14 14 0 0 0 28 11z'
  }));
});
Globe32.displayName = 'Globe32';
Globe32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Globe32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Globe24 = React.forwardRef(function (_ref849, ref) {
  var className = _ref849.className,
      children = _ref849.children,
      style = _ref849.style,
      tabIndex = _ref849.tabIndex,
      rest = _objectWithoutProperties$2(_ref849, ["className", "children", "style", "tabIndex"]);

  var _getAttributes849 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes849.tabindex,
      props = _objectWithoutProperties$2(_getAttributes849, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 4a7 7 0 1 1-7 7 7 7 0 0 1 7-7m0-2a9 9 0 1 0 9 9 9 9 0 0 0-9-9z'
  }), React.createElement('path', {
    d: 'M28 11a13.92 13.92 0 0 0-4.11-9.89l-1.41 1.41a12 12 0 0 1-16.92 17l-1.45 1.37A13.92 13.92 0 0 0 14 25v3h-4v2h10v-2h-4v-3.16A14 14 0 0 0 28 11z'
  }));
});
Globe24.displayName = 'Globe24';
Globe24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Globe24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Globe20 = React.forwardRef(function (_ref850, ref) {
  var className = _ref850.className,
      children = _ref850.children,
      style = _ref850.style,
      tabIndex = _ref850.tabIndex,
      rest = _objectWithoutProperties$2(_ref850, ["className", "children", "style", "tabIndex"]);

  var _getAttributes850 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes850.tabindex,
      props = _objectWithoutProperties$2(_getAttributes850, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 4a7 7 0 1 1-7 7 7 7 0 0 1 7-7m0-2a9 9 0 1 0 9 9 9 9 0 0 0-9-9z'
  }), React.createElement('path', {
    d: 'M28 11a13.92 13.92 0 0 0-4.11-9.89l-1.41 1.41a12 12 0 0 1-16.92 17l-1.45 1.37A13.92 13.92 0 0 0 14 25v3h-4v2h10v-2h-4v-3.16A14 14 0 0 0 28 11z'
  }));
});
Globe20.displayName = 'Globe20';
Globe20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Globe20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Grid32 = React.forwardRef(function (_ref851, ref) {
  var className = _ref851.className,
      children = _ref851.children,
      style = _ref851.style,
      tabIndex = _ref851.tabIndex,
      rest = _objectWithoutProperties$2(_ref851, ["className", "children", "style", "tabIndex"]);

  var _getAttributes851 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes851.tabindex,
      props = _objectWithoutProperties$2(_getAttributes851, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 8H6V6h6zm14-8h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 8h-6V6h6zm-14 6H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 8H6v-6h6zm14-8h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 8h-6v-6h6z'
  }));
});
Grid32.displayName = 'Grid32';
Grid32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Grid32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Grid24 = React.forwardRef(function (_ref852, ref) {
  var className = _ref852.className,
      children = _ref852.children,
      style = _ref852.style,
      tabIndex = _ref852.tabIndex,
      rest = _objectWithoutProperties$2(_ref852, ["className", "children", "style", "tabIndex"]);

  var _getAttributes852 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes852.tabindex,
      props = _objectWithoutProperties$2(_getAttributes852, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 8H6V6h6zm14-8h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 8h-6V6h6zm-14 6H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 8H6v-6h6zm14-8h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 8h-6v-6h6z'
  }));
});
Grid24.displayName = 'Grid24';
Grid24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Grid24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Grid20 = React.forwardRef(function (_ref853, ref) {
  var className = _ref853.className,
      children = _ref853.children,
      style = _ref853.style,
      tabIndex = _ref853.tabIndex,
      rest = _objectWithoutProperties$2(_ref853, ["className", "children", "style", "tabIndex"]);

  var _getAttributes853 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes853.tabindex,
      props = _objectWithoutProperties$2(_getAttributes853, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 8H6V6h6zm14-8h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 8h-6V6h6zm-14 6H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 8H6v-6h6zm14-8h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 8h-6v-6h6z'
  }));
});
Grid20.displayName = 'Grid20';
Grid20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Grid20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Group32 = React.forwardRef(function (_ref854, ref) {
  var className = _ref854.className,
      children = _ref854.children,
      style = _ref854.style,
      tabIndex = _ref854.tabIndex,
      rest = _objectWithoutProperties$2(_ref854, ["className", "children", "style", "tabIndex"]);

  var _getAttributes854 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes854.tabindex,
      props = _objectWithoutProperties$2(_getAttributes854, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 30h-2v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3h-2v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5zm-7-18a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm-9 12h-2v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v3H1v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5zM8 4a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z'
  }));
});
Group32.displayName = 'Group32';
Group32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Group32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Group24 = React.forwardRef(function (_ref855, ref) {
  var className = _ref855.className,
      children = _ref855.children,
      style = _ref855.style,
      tabIndex = _ref855.tabIndex,
      rest = _objectWithoutProperties$2(_ref855, ["className", "children", "style", "tabIndex"]);

  var _getAttributes855 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes855.tabindex,
      props = _objectWithoutProperties$2(_getAttributes855, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 30h-2v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3h-2v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5zm-7-18a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm-9 12h-2v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v3H1v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5zM8 4a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z'
  }));
});
Group24.displayName = 'Group24';
Group24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Group24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Group20 = React.forwardRef(function (_ref856, ref) {
  var className = _ref856.className,
      children = _ref856.children,
      style = _ref856.style,
      tabIndex = _ref856.tabIndex,
      rest = _objectWithoutProperties$2(_ref856, ["className", "children", "style", "tabIndex"]);

  var _getAttributes856 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes856.tabindex,
      props = _objectWithoutProperties$2(_getAttributes856, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 30h-2v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3h-2v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5zm-7-18a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm-9 12h-2v-3a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v3H1v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5zM8 4a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z'
  }));
});
Group20.displayName = 'Group20';
Group20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Group20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Headphones32 = React.forwardRef(function (_ref857, ref) {
  var className = _ref857.className,
      children = _ref857.children,
      style = _ref857.style,
      tabIndex = _ref857.tabIndex,
      rest = _objectWithoutProperties$2(_ref857, ["className", "children", "style", "tabIndex"]);

  var _getAttributes857 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes857.tabindex,
      props = _objectWithoutProperties$2(_getAttributes857, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 16v-1a9 9 0 0 0-18 0v1a5 5 0 0 0 0 10h2V15a7 7 0 0 1 14 0v11h2a5 5 0 0 0 0-10zM4 21a3 3 0 0 1 3-3v6a3 3 0 0 1-3-3zm21 3v-6a3 3 0 0 1 0 6z'
  }));
});
Headphones32.displayName = 'Headphones32';
Headphones32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Headphones32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Headphones24 = React.forwardRef(function (_ref858, ref) {
  var className = _ref858.className,
      children = _ref858.children,
      style = _ref858.style,
      tabIndex = _ref858.tabIndex,
      rest = _objectWithoutProperties$2(_ref858, ["className", "children", "style", "tabIndex"]);

  var _getAttributes858 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes858.tabindex,
      props = _objectWithoutProperties$2(_getAttributes858, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 16v-1a9 9 0 0 0-18 0v1a5 5 0 0 0 0 10h2V15a7 7 0 0 1 14 0v11h2a5 5 0 0 0 0-10zM4 21a3 3 0 0 1 3-3v6a3 3 0 0 1-3-3zm21 3v-6a3 3 0 0 1 0 6z'
  }));
});
Headphones24.displayName = 'Headphones24';
Headphones24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Headphones24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Headphones20 = React.forwardRef(function (_ref859, ref) {
  var className = _ref859.className,
      children = _ref859.children,
      style = _ref859.style,
      tabIndex = _ref859.tabIndex,
      rest = _objectWithoutProperties$2(_ref859, ["className", "children", "style", "tabIndex"]);

  var _getAttributes859 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes859.tabindex,
      props = _objectWithoutProperties$2(_getAttributes859, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 16v-1a9 9 0 0 0-18 0v1a5 5 0 0 0 0 10h2V15a7 7 0 0 1 14 0v11h2a5 5 0 0 0 0-10zM4 21a3 3 0 0 1 3-3v6a3 3 0 0 1-3-3zm21 3v-6a3 3 0 0 1 0 6z'
  }));
});
Headphones20.displayName = 'Headphones20';
Headphones20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Headphones20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Headset32 = React.forwardRef(function (_ref860, ref) {
  var className = _ref860.className,
      children = _ref860.children,
      style = _ref860.style,
      tabIndex = _ref860.tabIndex,
      rest = _objectWithoutProperties$2(_ref860, ["className", "children", "style", "tabIndex"]);

  var _getAttributes860 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes860.tabindex,
      props = _objectWithoutProperties$2(_getAttributes860, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 10h-.06a9 9 0 0 0-17.88 0H7a5 5 0 0 0 0 10h2v-9a7 7 0 0 1 14 0v10a4 4 0 0 1-3.17 3.91 4 4 0 1 0 .05 2A6 6 0 0 0 25 21v-1a5 5 0 0 0 0-10zM4 15a3 3 0 0 1 3-3v6a3 3 0 0 1-3-3zm12 13a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm9-10v-6a3 3 0 0 1 0 6z'
  }));
});
Headset32.displayName = 'Headset32';
Headset32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Headset32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Headset24 = React.forwardRef(function (_ref861, ref) {
  var className = _ref861.className,
      children = _ref861.children,
      style = _ref861.style,
      tabIndex = _ref861.tabIndex,
      rest = _objectWithoutProperties$2(_ref861, ["className", "children", "style", "tabIndex"]);

  var _getAttributes861 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes861.tabindex,
      props = _objectWithoutProperties$2(_getAttributes861, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 10h-.06a9 9 0 0 0-17.88 0H7a5 5 0 0 0 0 10h2v-9a7 7 0 0 1 14 0v10a4 4 0 0 1-3.17 3.91 4 4 0 1 0 .05 2A6 6 0 0 0 25 21v-1a5 5 0 0 0 0-10zM4 15a3 3 0 0 1 3-3v6a3 3 0 0 1-3-3zm12 13a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm9-10v-6a3 3 0 0 1 0 6z'
  }));
});
Headset24.displayName = 'Headset24';
Headset24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Headset24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Headset20 = React.forwardRef(function (_ref862, ref) {
  var className = _ref862.className,
      children = _ref862.children,
      style = _ref862.style,
      tabIndex = _ref862.tabIndex,
      rest = _objectWithoutProperties$2(_ref862, ["className", "children", "style", "tabIndex"]);

  var _getAttributes862 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes862.tabindex,
      props = _objectWithoutProperties$2(_getAttributes862, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 10h-.06a9 9 0 0 0-17.88 0H7a5 5 0 0 0 0 10h2v-9a7 7 0 0 1 14 0v10a4 4 0 0 1-3.17 3.91 4 4 0 1 0 .05 2A6 6 0 0 0 25 21v-1a5 5 0 0 0 0-10zM4 15a3 3 0 0 1 3-3v6a3 3 0 0 1-3-3zm12 13a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm9-10v-6a3 3 0 0 1 0 6z'
  }));
});
Headset20.displayName = 'Headset20';
Headset20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Headset20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hearing32 = React.forwardRef(function (_ref863, ref) {
  var className = _ref863.className,
      children = _ref863.children,
      style = _ref863.style,
      tabIndex = _ref863.tabIndex,
      rest = _objectWithoutProperties$2(_ref863, ["className", "children", "style", "tabIndex"]);

  var _getAttributes863 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes863.tabindex,
      props = _objectWithoutProperties$2(_getAttributes863, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 2a9 9 0 0 0-9 9h2a7 7 0 1 1 10.5 6.13l-.5.29v3.08a3 3 0 0 1-.9 2.15 4.19 4.19 0 0 1-4.63 1A4.09 4.09 0 0 1 5 20H3a6.1 6.1 0 0 0 3.67 5.51A5.71 5.71 0 0 0 9 26a6.58 6.58 0 0 0 4.48-1.89A4.93 4.93 0 0 0 15 20.5v-1.95A9 9 0 0 0 10 2z'
  }), React.createElement('path', {
    d: 'M9.28 8.08A3 3 0 0 1 13 11h2a5 5 0 0 0-1.88-3.91 5.06 5.06 0 0 0-4.29-1 5 5 0 0 0-3.7 3.7 5 5 0 0 0 2.31 5.46A3.08 3.08 0 0 1 9 17.92V20h2v-2.08a5.05 5.05 0 0 0-2.54-4.34 3 3 0 0 1 .82-5.5zM20 22h-1v-2h1a1 1 0 0 0 1-1v-1h2v1a3 3 0 0 1-3 3z'
  }), React.createElement('path', {
    d: 'M20 26h-1v-2h1a5 5 0 0 0 5-5v-1h2v1a7 7 0 0 1-7 7z'
  }), React.createElement('path', {
    d: 'M20 30h-1v-2h1a9 9 0 0 0 9-9v-1h2v1a11 11 0 0 1-11 11z'
  }));
});
Hearing32.displayName = 'Hearing32';
Hearing32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hearing32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hearing24 = React.forwardRef(function (_ref864, ref) {
  var className = _ref864.className,
      children = _ref864.children,
      style = _ref864.style,
      tabIndex = _ref864.tabIndex,
      rest = _objectWithoutProperties$2(_ref864, ["className", "children", "style", "tabIndex"]);

  var _getAttributes864 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes864.tabindex,
      props = _objectWithoutProperties$2(_getAttributes864, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 2a9 9 0 0 0-9 9h2a7 7 0 1 1 10.5 6.13l-.5.29v3.08a3 3 0 0 1-.9 2.15 4.19 4.19 0 0 1-4.63 1A4.09 4.09 0 0 1 5 20H3a6.1 6.1 0 0 0 3.67 5.51A5.71 5.71 0 0 0 9 26a6.58 6.58 0 0 0 4.48-1.89A4.93 4.93 0 0 0 15 20.5v-1.95A9 9 0 0 0 10 2z'
  }), React.createElement('path', {
    d: 'M9.28 8.08A3 3 0 0 1 13 11h2a5 5 0 0 0-1.88-3.91 5.06 5.06 0 0 0-4.29-1 5 5 0 0 0-3.7 3.7 5 5 0 0 0 2.31 5.46A3.08 3.08 0 0 1 9 17.92V20h2v-2.08a5.05 5.05 0 0 0-2.54-4.34 3 3 0 0 1 .82-5.5zM20 22h-1v-2h1a1 1 0 0 0 1-1v-1h2v1a3 3 0 0 1-3 3z'
  }), React.createElement('path', {
    d: 'M20 26h-1v-2h1a5 5 0 0 0 5-5v-1h2v1a7 7 0 0 1-7 7z'
  }), React.createElement('path', {
    d: 'M20 30h-1v-2h1a9 9 0 0 0 9-9v-1h2v1a11 11 0 0 1-11 11z'
  }));
});
Hearing24.displayName = 'Hearing24';
Hearing24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hearing24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hearing20 = React.forwardRef(function (_ref865, ref) {
  var className = _ref865.className,
      children = _ref865.children,
      style = _ref865.style,
      tabIndex = _ref865.tabIndex,
      rest = _objectWithoutProperties$2(_ref865, ["className", "children", "style", "tabIndex"]);

  var _getAttributes865 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes865.tabindex,
      props = _objectWithoutProperties$2(_getAttributes865, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 2a9 9 0 0 0-9 9h2a7 7 0 1 1 10.5 6.13l-.5.29v3.08a3 3 0 0 1-.9 2.15 4.19 4.19 0 0 1-4.63 1A4.09 4.09 0 0 1 5 20H3a6.1 6.1 0 0 0 3.67 5.51A5.71 5.71 0 0 0 9 26a6.58 6.58 0 0 0 4.48-1.89A4.93 4.93 0 0 0 15 20.5v-1.95A9 9 0 0 0 10 2z'
  }), React.createElement('path', {
    d: 'M9.28 8.08A3 3 0 0 1 13 11h2a5 5 0 0 0-1.88-3.91 5.06 5.06 0 0 0-4.29-1 5 5 0 0 0-3.7 3.7 5 5 0 0 0 2.31 5.46A3.08 3.08 0 0 1 9 17.92V20h2v-2.08a5.05 5.05 0 0 0-2.54-4.34 3 3 0 0 1 .82-5.5zM20 22h-1v-2h1a1 1 0 0 0 1-1v-1h2v1a3 3 0 0 1-3 3z'
  }), React.createElement('path', {
    d: 'M20 26h-1v-2h1a5 5 0 0 0 5-5v-1h2v1a7 7 0 0 1-7 7z'
  }), React.createElement('path', {
    d: 'M20 30h-1v-2h1a9 9 0 0 0 9-9v-1h2v1a11 11 0 0 1-11 11z'
  }));
});
Hearing20.displayName = 'Hearing20';
Hearing20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hearing20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var HelpFilled32 = React.forwardRef(function (_ref866, ref) {
  var className = _ref866.className,
      children = _ref866.children,
      style = _ref866.style,
      tabIndex = _ref866.tabIndex,
      rest = _objectWithoutProperties$2(_ref866, ["className", "children", "style", "tabIndex"]);

  var _getAttributes866 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes866.tabindex,
      props = _objectWithoutProperties$2(_getAttributes866, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 23a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 25zm1.14-7.75v2.5h-2.25V15H17a2.38 2.38 0 0 0 0-4.75h-1.5a2.38 2.38 0 0 0-2.38 2.37v.64h-2.23v-.64A4.63 4.63 0 0 1 15.52 8H17a4.63 4.63 0 0 1 .12 9.25z'
  }));
});
HelpFilled32.displayName = 'HelpFilled32';
HelpFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
HelpFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var HelpFilled24 = React.forwardRef(function (_ref867, ref) {
  var className = _ref867.className,
      children = _ref867.children,
      style = _ref867.style,
      tabIndex = _ref867.tabIndex,
      rest = _objectWithoutProperties$2(_ref867, ["className", "children", "style", "tabIndex"]);

  var _getAttributes867 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes867.tabindex,
      props = _objectWithoutProperties$2(_getAttributes867, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 23a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 25zm1.14-7.75v2.5h-2.25V15H17a2.38 2.38 0 0 0 0-4.75h-1.5a2.38 2.38 0 0 0-2.38 2.37v.64h-2.23v-.64A4.63 4.63 0 0 1 15.52 8H17a4.63 4.63 0 0 1 .12 9.25z'
  }));
});
HelpFilled24.displayName = 'HelpFilled24';
HelpFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
HelpFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var HelpFilled20 = React.forwardRef(function (_ref868, ref) {
  var className = _ref868.className,
      children = _ref868.children,
      style = _ref868.style,
      tabIndex = _ref868.tabIndex,
      rest = _objectWithoutProperties$2(_ref868, ["className", "children", "style", "tabIndex"]);

  var _getAttributes868 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes868.tabindex,
      props = _objectWithoutProperties$2(_getAttributes868, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 23a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 25zm1.14-7.75v2.5h-2.25V15H17a2.38 2.38 0 0 0 0-4.75h-1.5a2.38 2.38 0 0 0-2.38 2.37v.64h-2.23v-.64A4.63 4.63 0 0 1 15.52 8H17a4.63 4.63 0 0 1 .12 9.25z'
  }));
});
HelpFilled20.displayName = 'HelpFilled20';
HelpFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
HelpFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Help32 = React.forwardRef(function (_ref869, ref) {
  var className = _ref869.className,
      children = _ref869.children,
      style = _ref869.style,
      tabIndex = _ref869.tabIndex,
      rest = _objectWithoutProperties$2(_ref869, ["className", "children", "style", "tabIndex"]);

  var _getAttributes869 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes869.tabindex,
      props = _objectWithoutProperties$2(_getAttributes869, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '23.5',
    r: '1.5'
  }), React.createElement('path', {
    d: 'M17 8h-1.5a4.49 4.49 0 0 0-4.5 4.5v.5h2v-.5a2.5 2.5 0 0 1 2.5-2.5H17a2.5 2.5 0 0 1 0 5h-2v4.5h2V17a4.5 4.5 0 0 0 0-9z'
  }));
});
Help32.displayName = 'Help32';
Help32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Help32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Help24 = React.forwardRef(function (_ref870, ref) {
  var className = _ref870.className,
      children = _ref870.children,
      style = _ref870.style,
      tabIndex = _ref870.tabIndex,
      rest = _objectWithoutProperties$2(_ref870, ["className", "children", "style", "tabIndex"]);

  var _getAttributes870 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes870.tabindex,
      props = _objectWithoutProperties$2(_getAttributes870, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '23.5',
    r: '1.5'
  }), React.createElement('path', {
    d: 'M17 8h-1.5a4.49 4.49 0 0 0-4.5 4.5v.5h2v-.5a2.5 2.5 0 0 1 2.5-2.5H17a2.5 2.5 0 0 1 0 5h-2v4.5h2V17a4.5 4.5 0 0 0 0-9z'
  }));
});
Help24.displayName = 'Help24';
Help24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Help24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Help20 = React.forwardRef(function (_ref871, ref) {
  var className = _ref871.className,
      children = _ref871.children,
      style = _ref871.style,
      tabIndex = _ref871.tabIndex,
      rest = _objectWithoutProperties$2(_ref871, ["className", "children", "style", "tabIndex"]);

  var _getAttributes871 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes871.tabindex,
      props = _objectWithoutProperties$2(_getAttributes871, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '23.5',
    r: '1.5'
  }), React.createElement('path', {
    d: 'M17 8h-1.5a4.49 4.49 0 0 0-4.5 4.5v.5h2v-.5a2.5 2.5 0 0 1 2.5-2.5H17a2.5 2.5 0 0 1 0 5h-2v4.5h2V17a4.5 4.5 0 0 0 0-9z'
  }));
});
Help20.displayName = 'Help20';
Help20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Help20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Home32 = React.forwardRef(function (_ref872, ref) {
  var className = _ref872.className,
      children = _ref872.children,
      style = _ref872.style,
      tabIndex = _ref872.tabIndex,
      rest = _objectWithoutProperties$2(_ref872, ["className", "children", "style", "tabIndex"]);

  var _getAttributes872 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes872.tabindex,
      props = _objectWithoutProperties$2(_getAttributes872, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.61 2.21a1 1 0 0 0-1.24 0L1 13.42 2.24 15 4 13.62V26a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V13.63L29.76 15 31 13.43zM18 26h-4v-8h4zm2 0v-8a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v8H6V12.06l10-7.79 10 7.8V26z'
  }));
});
Home32.displayName = 'Home32';
Home32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Home32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Home24 = React.forwardRef(function (_ref873, ref) {
  var className = _ref873.className,
      children = _ref873.children,
      style = _ref873.style,
      tabIndex = _ref873.tabIndex,
      rest = _objectWithoutProperties$2(_ref873, ["className", "children", "style", "tabIndex"]);

  var _getAttributes873 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes873.tabindex,
      props = _objectWithoutProperties$2(_getAttributes873, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.61 2.21a1 1 0 0 0-1.24 0L1 13.42 2.24 15 4 13.62V26a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V13.63L29.76 15 31 13.43zM18 26h-4v-8h4zm2 0v-8a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v8H6V12.06l10-7.79 10 7.8V26z'
  }));
});
Home24.displayName = 'Home24';
Home24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Home24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Home20 = React.forwardRef(function (_ref874, ref) {
  var className = _ref874.className,
      children = _ref874.children,
      style = _ref874.style,
      tabIndex = _ref874.tabIndex,
      rest = _objectWithoutProperties$2(_ref874, ["className", "children", "style", "tabIndex"]);

  var _getAttributes874 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes874.tabindex,
      props = _objectWithoutProperties$2(_getAttributes874, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.61 2.21a1 1 0 0 0-1.24 0L1 13.42 2.24 15 4 13.62V26a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V13.63L29.76 15 31 13.43zM18 26h-4v-8h4zm2 0v-8a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v8H6V12.06l10-7.79 10 7.8V26z'
  }));
});
Home20.displayName = 'Home20';
Home20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Home20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hotel32 = React.forwardRef(function (_ref875, ref) {
  var className = _ref875.className,
      children = _ref875.children,
      style = _ref875.style,
      tabIndex = _ref875.tabIndex,
      rest = _objectWithoutProperties$2(_ref875, ["className", "children", "style", "tabIndex"]);

  var _getAttributes875 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes875.tabindex,
      props = _objectWithoutProperties$2(_getAttributes875, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.5 15A1.5 1.5 0 1 1 8 16.5 1.5 1.5 0 0 1 9.5 15m0-2a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 9.5 13z'
  }), React.createElement('path', {
    d: 'M25 14h-8a2 2 0 0 0-2 2v6H4V10.6l12-6.46 12.53 6.74.94-1.76-13-7a1 1 0 0 0-.94 0l-13 7A1 1 0 0 0 2 10v20h2v-6h24v6h2V19a5 5 0 0 0-5-5zm-8 8v-6h8a3 3 0 0 1 3 3v3z'
  }));
});
Hotel32.displayName = 'Hotel32';
Hotel32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hotel32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hotel24 = React.forwardRef(function (_ref876, ref) {
  var className = _ref876.className,
      children = _ref876.children,
      style = _ref876.style,
      tabIndex = _ref876.tabIndex,
      rest = _objectWithoutProperties$2(_ref876, ["className", "children", "style", "tabIndex"]);

  var _getAttributes876 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes876.tabindex,
      props = _objectWithoutProperties$2(_getAttributes876, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.5 15A1.5 1.5 0 1 1 8 16.5 1.5 1.5 0 0 1 9.5 15m0-2a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 9.5 13z'
  }), React.createElement('path', {
    d: 'M25 14h-8a2 2 0 0 0-2 2v6H4V10.6l12-6.46 12.53 6.74.94-1.76-13-7a1 1 0 0 0-.94 0l-13 7A1 1 0 0 0 2 10v20h2v-6h24v6h2V19a5 5 0 0 0-5-5zm-8 8v-6h8a3 3 0 0 1 3 3v3z'
  }));
});
Hotel24.displayName = 'Hotel24';
Hotel24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hotel24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hotel20 = React.forwardRef(function (_ref877, ref) {
  var className = _ref877.className,
      children = _ref877.children,
      style = _ref877.style,
      tabIndex = _ref877.tabIndex,
      rest = _objectWithoutProperties$2(_ref877, ["className", "children", "style", "tabIndex"]);

  var _getAttributes877 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes877.tabindex,
      props = _objectWithoutProperties$2(_getAttributes877, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.5 15A1.5 1.5 0 1 1 8 16.5 1.5 1.5 0 0 1 9.5 15m0-2a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 9.5 13z'
  }), React.createElement('path', {
    d: 'M25 14h-8a2 2 0 0 0-2 2v6H4V10.6l12-6.46 12.53 6.74.94-1.76-13-7a1 1 0 0 0-.94 0l-13 7A1 1 0 0 0 2 10v20h2v-6h24v6h2V19a5 5 0 0 0-5-5zm-8 8v-6h8a3 3 0 0 1 3 3v3z'
  }));
});
Hotel20.displayName = 'Hotel20';
Hotel20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hotel20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hourglass32 = React.forwardRef(function (_ref878, ref) {
  var className = _ref878.className,
      children = _ref878.children,
      style = _ref878.style,
      tabIndex = _ref878.tabIndex,
      rest = _objectWithoutProperties$2(_ref878, ["className", "children", "style", "tabIndex"]);

  var _getAttributes878 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes878.tabindex,
      props = _objectWithoutProperties$2(_getAttributes878, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 19h2v2h-2zm0 4h2v2h-2z'
  }), React.createElement('path', {
    d: 'M23 11.67V4h3V2H6v2h3v7.67a2 2 0 0 0 .4 1.2L11.75 16 9.4 19.13a2 2 0 0 0-.4 1.2V28H6v2h20v-2h-3v-7.67a2 2 0 0 0-.4-1.2L20.25 16l2.35-3.13a2 2 0 0 0 .4-1.2zM21 4v7H11V4zm0 16.33V28H11v-7.67L14.25 16 12 13h8l-2.25 3z'
  }));
});
Hourglass32.displayName = 'Hourglass32';
Hourglass32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hourglass32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hourglass24 = React.forwardRef(function (_ref879, ref) {
  var className = _ref879.className,
      children = _ref879.children,
      style = _ref879.style,
      tabIndex = _ref879.tabIndex,
      rest = _objectWithoutProperties$2(_ref879, ["className", "children", "style", "tabIndex"]);

  var _getAttributes879 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes879.tabindex,
      props = _objectWithoutProperties$2(_getAttributes879, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 19h2v2h-2zm0 4h2v2h-2z'
  }), React.createElement('path', {
    d: 'M23 11.67V4h3V2H6v2h3v7.67a2 2 0 0 0 .4 1.2L11.75 16 9.4 19.13a2 2 0 0 0-.4 1.2V28H6v2h20v-2h-3v-7.67a2 2 0 0 0-.4-1.2L20.25 16l2.35-3.13a2 2 0 0 0 .4-1.2zM21 4v7H11V4zm0 16.33V28H11v-7.67L14.25 16 12 13h8l-2.25 3z'
  }));
});
Hourglass24.displayName = 'Hourglass24';
Hourglass24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hourglass24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Hourglass20 = React.forwardRef(function (_ref880, ref) {
  var className = _ref880.className,
      children = _ref880.children,
      style = _ref880.style,
      tabIndex = _ref880.tabIndex,
      rest = _objectWithoutProperties$2(_ref880, ["className", "children", "style", "tabIndex"]);

  var _getAttributes880 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes880.tabindex,
      props = _objectWithoutProperties$2(_getAttributes880, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 19h2v2h-2zm0 4h2v2h-2z'
  }), React.createElement('path', {
    d: 'M23 11.67V4h3V2H6v2h3v7.67a2 2 0 0 0 .4 1.2L11.75 16 9.4 19.13a2 2 0 0 0-.4 1.2V28H6v2h20v-2h-3v-7.67a2 2 0 0 0-.4-1.2L20.25 16l2.35-3.13a2 2 0 0 0 .4-1.2zM21 4v7H11V4zm0 16.33V28H11v-7.67L14.25 16 12 13h8l-2.25 3z'
  }));
});
Hourglass20.displayName = 'Hourglass20';
Hourglass20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Hourglass20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IbmSecurity32 = React.forwardRef(function (_ref881, ref) {
  var className = _ref881.className,
      children = _ref881.children,
      style = _ref881.style,
      tabIndex = _ref881.tabIndex,
      rest = _objectWithoutProperties$2(_ref881, ["className", "children", "style", "tabIndex"]);

  var _getAttributes881 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes881.tabindex,
      props = _objectWithoutProperties$2(_getAttributes881, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 31A11 11 0 0 1 5 20V6.91l11-6 11 6V20a11 11 0 0 1-11 11zM7 8.09V20a9 9 0 0 0 18 0V8.09l-9-4.95z'
  }));
});
IbmSecurity32.displayName = 'IbmSecurity32';
IbmSecurity32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IbmSecurity32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IbmSecurity24 = React.forwardRef(function (_ref882, ref) {
  var className = _ref882.className,
      children = _ref882.children,
      style = _ref882.style,
      tabIndex = _ref882.tabIndex,
      rest = _objectWithoutProperties$2(_ref882, ["className", "children", "style", "tabIndex"]);

  var _getAttributes882 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes882.tabindex,
      props = _objectWithoutProperties$2(_getAttributes882, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 31A11 11 0 0 1 5 20V6.91l11-6 11 6V20a11 11 0 0 1-11 11zM7 8.09V20a9 9 0 0 0 18 0V8.09l-9-4.95z'
  }));
});
IbmSecurity24.displayName = 'IbmSecurity24';
IbmSecurity24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IbmSecurity24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var IbmSecurity20 = React.forwardRef(function (_ref883, ref) {
  var className = _ref883.className,
      children = _ref883.children,
      style = _ref883.style,
      tabIndex = _ref883.tabIndex,
      rest = _objectWithoutProperties$2(_ref883, ["className", "children", "style", "tabIndex"]);

  var _getAttributes883 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes883.tabindex,
      props = _objectWithoutProperties$2(_getAttributes883, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 31A11 11 0 0 1 5 20V6.91l11-6 11 6V20a11 11 0 0 1-11 11zM7 8.09V20a9 9 0 0 0 18 0V8.09l-9-4.95z'
  }));
});
IbmSecurity20.displayName = 'IbmSecurity20';
IbmSecurity20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
IbmSecurity20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Idea32 = React.forwardRef(function (_ref884, ref) {
  var className = _ref884.className,
      children = _ref884.children,
      style = _ref884.style,
      tabIndex = _ref884.tabIndex,
      rest = _objectWithoutProperties$2(_ref884, ["className", "children", "style", "tabIndex"]);

  var _getAttributes884 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes884.tabindex,
      props = _objectWithoutProperties$2(_getAttributes884, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 24h10v2H11zm2 4h6v2h-6zm3-26A10 10 0 0 0 6 12a9.19 9.19 0 0 0 3.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 0 1 8 12a8 8 0 0 1 16 0 7.2 7.2 0 0 1-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0 0 26 12 10 10 0 0 0 16 2z'
  }));
});
Idea32.displayName = 'Idea32';
Idea32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Idea32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Idea24 = React.forwardRef(function (_ref885, ref) {
  var className = _ref885.className,
      children = _ref885.children,
      style = _ref885.style,
      tabIndex = _ref885.tabIndex,
      rest = _objectWithoutProperties$2(_ref885, ["className", "children", "style", "tabIndex"]);

  var _getAttributes885 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes885.tabindex,
      props = _objectWithoutProperties$2(_getAttributes885, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 24h10v2H11zm2 4h6v2h-6zm3-26A10 10 0 0 0 6 12a9.19 9.19 0 0 0 3.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 0 1 8 12a8 8 0 0 1 16 0 7.2 7.2 0 0 1-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0 0 26 12 10 10 0 0 0 16 2z'
  }));
});
Idea24.displayName = 'Idea24';
Idea24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Idea24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Idea20 = React.forwardRef(function (_ref886, ref) {
  var className = _ref886.className,
      children = _ref886.children,
      style = _ref886.style,
      tabIndex = _ref886.tabIndex,
      rest = _objectWithoutProperties$2(_ref886, ["className", "children", "style", "tabIndex"]);

  var _getAttributes886 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes886.tabindex,
      props = _objectWithoutProperties$2(_getAttributes886, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 24h10v2H11zm2 4h6v2h-6zm3-26A10 10 0 0 0 6 12a9.19 9.19 0 0 0 3.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 0 1 8 12a8 8 0 0 1 16 0 7.2 7.2 0 0 1-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0 0 26 12 10 10 0 0 0 16 2z'
  }));
});
Idea20.displayName = 'Idea20';
Idea20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Idea20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Identification32 = React.forwardRef(function (_ref887, ref) {
  var className = _ref887.className,
      children = _ref887.children,
      style = _ref887.style,
      tabIndex = _ref887.tabIndex,
      rest = _objectWithoutProperties$2(_ref887, ["className", "children", "style", "tabIndex"]);

  var _getAttributes887 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes887.tabindex,
      props = _objectWithoutProperties$2(_getAttributes887, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6v20H4V6h24m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M6 10h7v2H6zm0 4h4v2H6zm17 4h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
Identification32.displayName = 'Identification32';
Identification32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Identification32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Identification24 = React.forwardRef(function (_ref888, ref) {
  var className = _ref888.className,
      children = _ref888.children,
      style = _ref888.style,
      tabIndex = _ref888.tabIndex,
      rest = _objectWithoutProperties$2(_ref888, ["className", "children", "style", "tabIndex"]);

  var _getAttributes888 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes888.tabindex,
      props = _objectWithoutProperties$2(_getAttributes888, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6v20H4V6h24m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M6 10h7v2H6zm0 4h4v2H6zm17 4h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
Identification24.displayName = 'Identification24';
Identification24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Identification24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Identification20 = React.forwardRef(function (_ref889, ref) {
  var className = _ref889.className,
      children = _ref889.children,
      style = _ref889.style,
      tabIndex = _ref889.tabIndex,
      rest = _objectWithoutProperties$2(_ref889, ["className", "children", "style", "tabIndex"]);

  var _getAttributes889 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes889.tabindex,
      props = _objectWithoutProperties$2(_getAttributes889, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6v20H4V6h24m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M6 10h7v2H6zm0 4h4v2H6zm17 4h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z'
  }));
});
Identification20.displayName = 'Identification20';
Identification20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Identification20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ImageMedical32 = React.forwardRef(function (_ref890, ref) {
  var className = _ref890.className,
      children = _ref890.children,
      style = _ref890.style,
      tabIndex = _ref890.tabIndex,
      rest = _objectWithoutProperties$2(_ref890, ["className", "children", "style", "tabIndex"]);

  var _getAttributes890 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes890.tabindex,
      props = _objectWithoutProperties$2(_getAttributes890, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6v20H6V6h20m0-2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M22 16v-2h-5v-2h3v-2h-3V8h-2v2h-3v2h3v2h-5v2h5v2h-5v2h5v2h-3v2h8v-2h-3v-2h5v-2h-5v-2h5z'
  }));
});
ImageMedical32.displayName = 'ImageMedical32';
ImageMedical32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ImageMedical32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ImageMedical24 = React.forwardRef(function (_ref891, ref) {
  var className = _ref891.className,
      children = _ref891.children,
      style = _ref891.style,
      tabIndex = _ref891.tabIndex,
      rest = _objectWithoutProperties$2(_ref891, ["className", "children", "style", "tabIndex"]);

  var _getAttributes891 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes891.tabindex,
      props = _objectWithoutProperties$2(_getAttributes891, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6v20H6V6h20m0-2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M22 16v-2h-5v-2h3v-2h-3V8h-2v2h-3v2h3v2h-5v2h5v2h-5v2h5v2h-3v2h8v-2h-3v-2h5v-2h-5v-2h5z'
  }));
});
ImageMedical24.displayName = 'ImageMedical24';
ImageMedical24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ImageMedical24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ImageMedical20 = React.forwardRef(function (_ref892, ref) {
  var className = _ref892.className,
      children = _ref892.children,
      style = _ref892.style,
      tabIndex = _ref892.tabIndex,
      rest = _objectWithoutProperties$2(_ref892, ["className", "children", "style", "tabIndex"]);

  var _getAttributes892 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes892.tabindex,
      props = _objectWithoutProperties$2(_getAttributes892, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6v20H6V6h20m0-2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M22 16v-2h-5v-2h3v-2h-3V8h-2v2h-3v2h3v2h-5v2h5v2h-5v2h5v2h-3v2h8v-2h-3v-2h5v-2h-5v-2h5z'
  }));
});
ImageMedical20.displayName = 'ImageMedical20';
ImageMedical20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ImageMedical20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Image32 = React.forwardRef(function (_ref893, ref) {
  var className = _ref893.className,
      children = _ref893.children,
      style = _ref893.style,
      tabIndex = _ref893.tabIndex,
      rest = _objectWithoutProperties$2(_ref893, ["className", "children", "style", "tabIndex"]);

  var _getAttributes893 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes893.tabindex,
      props = _objectWithoutProperties$2(_getAttributes893, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 14a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H6v-6l5-5 5.59 5.59a2 2 0 0 0 2.82 0L21 19l5 5zm0-4.83l-3.59-3.59a2 2 0 0 0-2.82 0L18 19.17l-5.59-5.59a2 2 0 0 0-2.82 0L6 17.17V6h20z'
  }));
});
Image32.displayName = 'Image32';
Image32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Image32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Image24 = React.forwardRef(function (_ref894, ref) {
  var className = _ref894.className,
      children = _ref894.children,
      style = _ref894.style,
      tabIndex = _ref894.tabIndex,
      rest = _objectWithoutProperties$2(_ref894, ["className", "children", "style", "tabIndex"]);

  var _getAttributes894 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes894.tabindex,
      props = _objectWithoutProperties$2(_getAttributes894, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 14a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H6v-6l5-5 5.59 5.59a2 2 0 0 0 2.82 0L21 19l5 5zm0-4.83l-3.59-3.59a2 2 0 0 0-2.82 0L18 19.17l-5.59-5.59a2 2 0 0 0-2.82 0L6 17.17V6h20z'
  }));
});
Image24.displayName = 'Image24';
Image24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Image24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Image20 = React.forwardRef(function (_ref895, ref) {
  var className = _ref895.className,
      children = _ref895.children,
      style = _ref895.style,
      tabIndex = _ref895.tabIndex,
      rest = _objectWithoutProperties$2(_ref895, ["className", "children", "style", "tabIndex"]);

  var _getAttributes895 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes895.tabindex,
      props = _objectWithoutProperties$2(_getAttributes895, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 14a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H6v-6l5-5 5.59 5.59a2 2 0 0 0 2.82 0L21 19l5 5zm0-4.83l-3.59-3.59a2 2 0 0 0-2.82 0L18 19.17l-5.59-5.59a2 2 0 0 0-2.82 0L6 17.17V6h20z'
  }));
});
Image20.displayName = 'Image20';
Image20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Image20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Industry32 = React.forwardRef(function (_ref896, ref) {
  var className = _ref896.className,
      children = _ref896.children,
      style = _ref896.style,
      tabIndex = _ref896.tabIndex,
      rest = _objectWithoutProperties$2(_ref896, ["className", "children", "style", "tabIndex"]);

  var _getAttributes896 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes896.tabindex,
      props = _objectWithoutProperties$2(_getAttributes896, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.53 6.15a1 1 0 0 0-1 0L20 10.38V7a1 1 0 0 0-1.45-.89L10 10.38V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v25h28V7a1 1 0 0 0-.47-.85zM22 26h-4v-7h4zm6 0h-4v-8a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v8H4V4h4v9.62l10-5v5l10-5z'
  }));
});
Industry32.displayName = 'Industry32';
Industry32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Industry32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Industry24 = React.forwardRef(function (_ref897, ref) {
  var className = _ref897.className,
      children = _ref897.children,
      style = _ref897.style,
      tabIndex = _ref897.tabIndex,
      rest = _objectWithoutProperties$2(_ref897, ["className", "children", "style", "tabIndex"]);

  var _getAttributes897 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes897.tabindex,
      props = _objectWithoutProperties$2(_getAttributes897, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.53 6.15a1 1 0 0 0-1 0L20 10.38V7a1 1 0 0 0-1.45-.89L10 10.38V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v25h28V7a1 1 0 0 0-.47-.85zM22 26h-4v-7h4zm6 0h-4v-8a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v8H4V4h4v9.62l10-5v5l10-5z'
  }));
});
Industry24.displayName = 'Industry24';
Industry24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Industry24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Industry20 = React.forwardRef(function (_ref898, ref) {
  var className = _ref898.className,
      children = _ref898.children,
      style = _ref898.style,
      tabIndex = _ref898.tabIndex,
      rest = _objectWithoutProperties$2(_ref898, ["className", "children", "style", "tabIndex"]);

  var _getAttributes898 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes898.tabindex,
      props = _objectWithoutProperties$2(_getAttributes898, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.53 6.15a1 1 0 0 0-1 0L20 10.38V7a1 1 0 0 0-1.45-.89L10 10.38V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v25h28V7a1 1 0 0 0-.47-.85zM22 26h-4v-7h4zm6 0h-4v-8a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v8H4V4h4v9.62l10-5v5l10-5z'
  }));
});
Industry20.displayName = 'Industry20';
Industry20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Industry20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var InformationFilled32 = React.forwardRef(function (_ref899, ref) {
  var className = _ref899.className,
      children = _ref899.children,
      style = _ref899.style,
      tabIndex = _ref899.tabIndex,
      rest = _objectWithoutProperties$2(_ref899, ["className", "children", "style", "tabIndex"]);

  var _getAttributes899 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes899.tabindex,
      props = _objectWithoutProperties$2(_getAttributes899, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 5a1.5 1.5 0 1 1-1.5 1.5A1.5 1.5 0 0 1 16 7zm4 17.12h-8v-2.24h2.88v-6.76H13v-2.24h4.13v9H20z'
  }));
});
InformationFilled32.displayName = 'InformationFilled32';
InformationFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
InformationFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var InformationFilled24 = React.forwardRef(function (_ref900, ref) {
  var className = _ref900.className,
      children = _ref900.children,
      style = _ref900.style,
      tabIndex = _ref900.tabIndex,
      rest = _objectWithoutProperties$2(_ref900, ["className", "children", "style", "tabIndex"]);

  var _getAttributes900 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes900.tabindex,
      props = _objectWithoutProperties$2(_getAttributes900, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 5a1.5 1.5 0 1 1-1.5 1.5A1.5 1.5 0 0 1 16 7zm4 17.12h-8v-2.24h2.88v-6.76H13v-2.24h4.13v9H20z'
  }));
});
InformationFilled24.displayName = 'InformationFilled24';
InformationFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
InformationFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var InformationFilled20 = React.forwardRef(function (_ref901, ref) {
  var className = _ref901.className,
      children = _ref901.children,
      style = _ref901.style,
      tabIndex = _ref901.tabIndex,
      rest = _objectWithoutProperties$2(_ref901, ["className", "children", "style", "tabIndex"]);

  var _getAttributes901 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes901.tabindex,
      props = _objectWithoutProperties$2(_getAttributes901, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 5a1.5 1.5 0 1 1-1.5 1.5A1.5 1.5 0 0 1 16 7zm4 17.12h-8v-2.24h2.88v-6.76H13v-2.24h4.13v9H20z'
  }));
});
InformationFilled20.displayName = 'InformationFilled20';
InformationFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
InformationFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Information32 = React.forwardRef(function (_ref902, ref) {
  var className = _ref902.className,
      children = _ref902.children,
      style = _ref902.style,
      tabIndex = _ref902.tabIndex,
      rest = _objectWithoutProperties$2(_ref902, ["className", "children", "style", "tabIndex"]);

  var _getAttributes902 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes902.tabindex,
      props = _objectWithoutProperties$2(_getAttributes902, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 22v-9h-4v2h2v7h-3v2h8v-2h-3zM16 7a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 7z'
  }), React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }));
});
Information32.displayName = 'Information32';
Information32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Information32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Information24 = React.forwardRef(function (_ref903, ref) {
  var className = _ref903.className,
      children = _ref903.children,
      style = _ref903.style,
      tabIndex = _ref903.tabIndex,
      rest = _objectWithoutProperties$2(_ref903, ["className", "children", "style", "tabIndex"]);

  var _getAttributes903 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes903.tabindex,
      props = _objectWithoutProperties$2(_getAttributes903, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 22v-9h-4v2h2v7h-3v2h8v-2h-3zM16 7a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 7z'
  }), React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }));
});
Information24.displayName = 'Information24';
Information24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Information24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Information20 = React.forwardRef(function (_ref904, ref) {
  var className = _ref904.className,
      children = _ref904.children,
      style = _ref904.style,
      tabIndex = _ref904.tabIndex,
      rest = _objectWithoutProperties$2(_ref904, ["className", "children", "style", "tabIndex"]);

  var _getAttributes904 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes904.tabindex,
      props = _objectWithoutProperties$2(_getAttributes904, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 22v-9h-4v2h2v7h-3v2h8v-2h-3zM16 7a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 7z'
  }), React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }));
});
Information20.displayName = 'Information20';
Information20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Information20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Insert32 = React.forwardRef(function (_ref905, ref) {
  var className = _ref905.className,
      children = _ref905.children,
      style = _ref905.style,
      tabIndex = _ref905.tabIndex,
      rest = _objectWithoutProperties$2(_ref905, ["className", "children", "style", "tabIndex"]);

  var _getAttributes905 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes905.tabindex,
      props = _objectWithoutProperties$2(_getAttributes905, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 9h9V2H2zm2-5h5v3H4zM2 19h9v-7H2zm2-5h5v3H4zM2 29h9v-7H2zm2-5h5v3H4zM27 9h-9l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H15v2h12a3 3 0 0 0 3-3V12a3 3 0 0 0-3-3z'
  }));
});
Insert32.displayName = 'Insert32';
Insert32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Insert32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Insert24 = React.forwardRef(function (_ref906, ref) {
  var className = _ref906.className,
      children = _ref906.children,
      style = _ref906.style,
      tabIndex = _ref906.tabIndex,
      rest = _objectWithoutProperties$2(_ref906, ["className", "children", "style", "tabIndex"]);

  var _getAttributes906 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes906.tabindex,
      props = _objectWithoutProperties$2(_getAttributes906, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 9h9V2H2zm2-5h5v3H4zM2 19h9v-7H2zm2-5h5v3H4zM2 29h9v-7H2zm2-5h5v3H4zM27 9h-9l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H15v2h12a3 3 0 0 0 3-3V12a3 3 0 0 0-3-3z'
  }));
});
Insert24.displayName = 'Insert24';
Insert24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Insert24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Insert20 = React.forwardRef(function (_ref907, ref) {
  var className = _ref907.className,
      children = _ref907.children,
      style = _ref907.style,
      tabIndex = _ref907.tabIndex,
      rest = _objectWithoutProperties$2(_ref907, ["className", "children", "style", "tabIndex"]);

  var _getAttributes907 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes907.tabindex,
      props = _objectWithoutProperties$2(_getAttributes907, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 9h9V2H2zm2-5h5v3H4zM2 19h9v-7H2zm2-5h5v3H4zM2 29h9v-7H2zm2-5h5v3H4zM27 9h-9l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H15v2h12a3 3 0 0 0 3-3V12a3 3 0 0 0-3-3z'
  }));
});
Insert20.displayName = 'Insert20';
Insert20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Insert20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Integration32 = React.forwardRef(function (_ref908, ref) {
  var className = _ref908.className,
      children = _ref908.children,
      style = _ref908.style,
      tabIndex = _ref908.tabIndex,
      rest = _objectWithoutProperties$2(_ref908, ["className", "children", "style", "tabIndex"]);

  var _getAttributes908 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes908.tabindex,
      props = _objectWithoutProperties$2(_getAttributes908, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.88 15.52l-6-11A1 1 0 0 0 23 4H9a1 1 0 0 0-.88.52l-6 11a1 1 0 0 0 0 1l6 11A1 1 0 0 0 9 28h14a1 1 0 0 0 .88-.52l6-11a1 1 0 0 0 0-.96zM22.93 7l4.39 8h-9.5zM16 14.14L10.82 6h10.36zM9.07 7l5.11 8h-9.5zM4.68 17h9.5l-5.11 8zm11.32.86L21.18 26H10.82zM22.93 25l-5.11-8h9.5z'
  }));
});
Integration32.displayName = 'Integration32';
Integration32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Integration32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Integration24 = React.forwardRef(function (_ref909, ref) {
  var className = _ref909.className,
      children = _ref909.children,
      style = _ref909.style,
      tabIndex = _ref909.tabIndex,
      rest = _objectWithoutProperties$2(_ref909, ["className", "children", "style", "tabIndex"]);

  var _getAttributes909 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes909.tabindex,
      props = _objectWithoutProperties$2(_getAttributes909, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.88 15.52l-6-11A1 1 0 0 0 23 4H9a1 1 0 0 0-.88.52l-6 11a1 1 0 0 0 0 1l6 11A1 1 0 0 0 9 28h14a1 1 0 0 0 .88-.52l6-11a1 1 0 0 0 0-.96zM22.93 7l4.39 8h-9.5zM16 14.14L10.82 6h10.36zM9.07 7l5.11 8h-9.5zM4.68 17h9.5l-5.11 8zm11.32.86L21.18 26H10.82zM22.93 25l-5.11-8h9.5z'
  }));
});
Integration24.displayName = 'Integration24';
Integration24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Integration24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Integration20 = React.forwardRef(function (_ref910, ref) {
  var className = _ref910.className,
      children = _ref910.children,
      style = _ref910.style,
      tabIndex = _ref910.tabIndex,
      rest = _objectWithoutProperties$2(_ref910, ["className", "children", "style", "tabIndex"]);

  var _getAttributes910 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes910.tabindex,
      props = _objectWithoutProperties$2(_getAttributes910, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.88 15.52l-6-11A1 1 0 0 0 23 4H9a1 1 0 0 0-.88.52l-6 11a1 1 0 0 0 0 1l6 11A1 1 0 0 0 9 28h14a1 1 0 0 0 .88-.52l6-11a1 1 0 0 0 0-.96zM22.93 7l4.39 8h-9.5zM16 14.14L10.82 6h10.36zM9.07 7l5.11 8h-9.5zM4.68 17h9.5l-5.11 8zm11.32.86L21.18 26H10.82zM22.93 25l-5.11-8h9.5z'
  }));
});
Integration20.displayName = 'Integration20';
Integration20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Integration20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Keyboard32 = React.forwardRef(function (_ref911, ref) {
  var className = _ref911.className,
      children = _ref911.children,
      style = _ref911.style,
      tabIndex = _ref911.tabIndex,
      rest = _objectWithoutProperties$2(_ref911, ["className", "children", "style", "tabIndex"]);

  var _getAttributes911 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes911.tabindex,
      props = _objectWithoutProperties$2(_getAttributes911, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 10v14h24V10z'
  }), React.createElement('path', {
    d: 'M10 20h11v2H10zm-4-8h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zM6 20h2v2H6zm0-4h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm8-4h4v2h-4zm0 4h4v2h-4zm-4 0h2v2h-2zm5 4h3v2h-3z'
  }));
});
Keyboard32.displayName = 'Keyboard32';
Keyboard32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Keyboard32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Keyboard24 = React.forwardRef(function (_ref912, ref) {
  var className = _ref912.className,
      children = _ref912.children,
      style = _ref912.style,
      tabIndex = _ref912.tabIndex,
      rest = _objectWithoutProperties$2(_ref912, ["className", "children", "style", "tabIndex"]);

  var _getAttributes912 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes912.tabindex,
      props = _objectWithoutProperties$2(_getAttributes912, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 10v14h24V10z'
  }), React.createElement('path', {
    d: 'M10 20h11v2H10zm-4-8h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zM6 20h2v2H6zm0-4h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm8-4h4v2h-4zm0 4h4v2h-4zm-4 0h2v2h-2zm5 4h3v2h-3z'
  }));
});
Keyboard24.displayName = 'Keyboard24';
Keyboard24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Keyboard24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Keyboard20 = React.forwardRef(function (_ref913, ref) {
  var className = _ref913.className,
      children = _ref913.children,
      style = _ref913.style,
      tabIndex = _ref913.tabIndex,
      rest = _objectWithoutProperties$2(_ref913, ["className", "children", "style", "tabIndex"]);

  var _getAttributes913 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes913.tabindex,
      props = _objectWithoutProperties$2(_getAttributes913, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 26H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 10v14h24V10z'
  }), React.createElement('path', {
    d: 'M10 20h11v2H10zm-4-8h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zM6 20h2v2H6zm0-4h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm8-4h4v2h-4zm0 4h4v2h-4zm-4 0h2v2h-2zm5 4h3v2h-3z'
  }));
});
Keyboard20.displayName = 'Keyboard20';
Keyboard20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Keyboard20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Launch32 = React.forwardRef(function (_ref914, ref) {
  var className = _ref914.className,
      children = _ref914.children,
      style = _ref914.style,
      tabIndex = _ref914.tabIndex,
      rest = _objectWithoutProperties$2(_ref914, ["className", "children", "style", "tabIndex"]);

  var _getAttributes914 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes914.tabindex,
      props = _objectWithoutProperties$2(_getAttributes914, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9v2H6v20h20v-9h2v9a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M21 2v2h5.59L18 12.59 19.41 14 28 5.41V11h2V2h-9z'
  }));
});
Launch32.displayName = 'Launch32';
Launch32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Launch32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Launch24 = React.forwardRef(function (_ref915, ref) {
  var className = _ref915.className,
      children = _ref915.children,
      style = _ref915.style,
      tabIndex = _ref915.tabIndex,
      rest = _objectWithoutProperties$2(_ref915, ["className", "children", "style", "tabIndex"]);

  var _getAttributes915 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes915.tabindex,
      props = _objectWithoutProperties$2(_getAttributes915, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9v2H6v20h20v-9h2v9a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M21 2v2h5.59L18 12.59 19.41 14 28 5.41V11h2V2h-9z'
  }));
});
Launch24.displayName = 'Launch24';
Launch24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Launch24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Launch20 = React.forwardRef(function (_ref916, ref) {
  var className = _ref916.className,
      children = _ref916.children,
      style = _ref916.style,
      tabIndex = _ref916.tabIndex,
      rest = _objectWithoutProperties$2(_ref916, ["className", "children", "style", "tabIndex"]);

  var _getAttributes916 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes916.tabindex,
      props = _objectWithoutProperties$2(_getAttributes916, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9v2H6v20h20v-9h2v9a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M21 2v2h5.59L18 12.59 19.41 14 28 5.41V11h2V2h-9z'
  }));
});
Launch20.displayName = 'Launch20';
Launch20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Launch20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterAa32 = React.forwardRef(function (_ref917, ref) {
  var className = _ref917.className,
      children = _ref917.children,
      style = _ref917.style,
      tabIndex = _ref917.tabIndex,
      rest = _objectWithoutProperties$2(_ref917, ["className", "children", "style", "tabIndex"]);

  var _getAttributes917 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes917.tabindex,
      props = _objectWithoutProperties$2(_getAttributes917, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-5v2h5v2h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v-8a2 2 0 0 0-2-2zm0 8h-4v-2h4zM13 9H9a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5z'
  }));
});
LetterAa32.displayName = 'LetterAa32';
LetterAa32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterAa32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterAa24 = React.forwardRef(function (_ref918, ref) {
  var className = _ref918.className,
      children = _ref918.children,
      style = _ref918.style,
      tabIndex = _ref918.tabIndex,
      rest = _objectWithoutProperties$2(_ref918, ["className", "children", "style", "tabIndex"]);

  var _getAttributes918 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes918.tabindex,
      props = _objectWithoutProperties$2(_getAttributes918, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-5v2h5v2h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v-8a2 2 0 0 0-2-2zm0 8h-4v-2h4zM13 9H9a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5z'
  }));
});
LetterAa24.displayName = 'LetterAa24';
LetterAa24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterAa24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterAa20 = React.forwardRef(function (_ref919, ref) {
  var className = _ref919.className,
      children = _ref919.children,
      style = _ref919.style,
      tabIndex = _ref919.tabIndex,
      rest = _objectWithoutProperties$2(_ref919, ["className", "children", "style", "tabIndex"]);

  var _getAttributes919 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes919.tabindex,
      props = _objectWithoutProperties$2(_getAttributes919, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-5v2h5v2h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v-8a2 2 0 0 0-2-2zm0 8h-4v-2h4zM13 9H9a2 2 0 0 0-2 2v12h2v-5h4v5h2V11a2 2 0 0 0-2-2zm-4 7v-5h4v5z'
  }));
});
LetterAa20.displayName = 'LetterAa20';
LetterAa20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterAa20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterBb32 = React.forwardRef(function (_ref920, ref) {
  var className = _ref920.className,
      children = _ref920.children,
      style = _ref920.style,
      tabIndex = _ref920.tabIndex,
      rest = _objectWithoutProperties$2(_ref920, ["className", "children", "style", "tabIndex"]);

  var _getAttributes920 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes920.tabindex,
      props = _objectWithoutProperties$2(_getAttributes920, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-4V9h-2v14h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-4 8v-6h4v6zm-4-9a3 3 0 0 0-3-3H7v14h5a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2zm-6-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9zm4 9a1 1 0 0 1-1 1H9v-4h3a1 1 0 0 1 1 1z'
  }));
});
LetterBb32.displayName = 'LetterBb32';
LetterBb32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterBb32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterBb24 = React.forwardRef(function (_ref921, ref) {
  var className = _ref921.className,
      children = _ref921.children,
      style = _ref921.style,
      tabIndex = _ref921.tabIndex,
      rest = _objectWithoutProperties$2(_ref921, ["className", "children", "style", "tabIndex"]);

  var _getAttributes921 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes921.tabindex,
      props = _objectWithoutProperties$2(_getAttributes921, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-4V9h-2v14h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-4 8v-6h4v6zm-4-9a3 3 0 0 0-3-3H7v14h5a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2zm-6-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9zm4 9a1 1 0 0 1-1 1H9v-4h3a1 1 0 0 1 1 1z'
  }));
});
LetterBb24.displayName = 'LetterBb24';
LetterBb24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterBb24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterBb20 = React.forwardRef(function (_ref922, ref) {
  var className = _ref922.className,
      children = _ref922.children,
      style = _ref922.style,
      tabIndex = _ref922.tabIndex,
      rest = _objectWithoutProperties$2(_ref922, ["className", "children", "style", "tabIndex"]);

  var _getAttributes922 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes922.tabindex,
      props = _objectWithoutProperties$2(_getAttributes922, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-4V9h-2v14h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-4 8v-6h4v6zm-4-9a3 3 0 0 0-3-3H7v14h5a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2 3 3 0 0 0 .78-2zm-6-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9zm4 9a1 1 0 0 1-1 1H9v-4h3a1 1 0 0 1 1 1z'
  }));
});
LetterBb20.displayName = 'LetterBb20';
LetterBb20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterBb20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterCc32 = React.forwardRef(function (_ref923, ref) {
  var className = _ref923.className,
      children = _ref923.children,
      style = _ref923.style,
      tabIndex = _ref923.tabIndex,
      rest = _objectWithoutProperties$2(_ref923, ["className", "children", "style", "tabIndex"]);

  var _getAttributes923 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes923.tabindex,
      props = _objectWithoutProperties$2(_getAttributes923, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 23h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm-9 0H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h6z'
  }));
});
LetterCc32.displayName = 'LetterCc32';
LetterCc32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterCc32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterCc24 = React.forwardRef(function (_ref924, ref) {
  var className = _ref924.className,
      children = _ref924.children,
      style = _ref924.style,
      tabIndex = _ref924.tabIndex,
      rest = _objectWithoutProperties$2(_ref924, ["className", "children", "style", "tabIndex"]);

  var _getAttributes924 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes924.tabindex,
      props = _objectWithoutProperties$2(_getAttributes924, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 23h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm-9 0H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h6z'
  }));
});
LetterCc24.displayName = 'LetterCc24';
LetterCc24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterCc24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterCc20 = React.forwardRef(function (_ref925, ref) {
  var className = _ref925.className,
      children = _ref925.children,
      style = _ref925.style,
      tabIndex = _ref925.tabIndex,
      rest = _objectWithoutProperties$2(_ref925, ["className", "children", "style", "tabIndex"]);

  var _getAttributes925 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes925.tabindex,
      props = _objectWithoutProperties$2(_getAttributes925, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 23h-5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h5v2h-5v6h5zm-9 0H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h6z'
  }));
});
LetterCc20.displayName = 'LetterCc20';
LetterCc20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterCc20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterDd32 = React.forwardRef(function (_ref926, ref) {
  var className = _ref926.className,
      children = _ref926.children,
      style = _ref926.style,
      tabIndex = _ref926.tabIndex,
      rest = _objectWithoutProperties$2(_ref926, ["className", "children", "style", "tabIndex"]);

  var _getAttributes926 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes926.tabindex,
      props = _objectWithoutProperties$2(_getAttributes926, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 9v4h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6V9zm-4 6h4v6h-4zm-8 8H7V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H9z'
  }));
});
LetterDd32.displayName = 'LetterDd32';
LetterDd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterDd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterDd24 = React.forwardRef(function (_ref927, ref) {
  var className = _ref927.className,
      children = _ref927.children,
      style = _ref927.style,
      tabIndex = _ref927.tabIndex,
      rest = _objectWithoutProperties$2(_ref927, ["className", "children", "style", "tabIndex"]);

  var _getAttributes927 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes927.tabindex,
      props = _objectWithoutProperties$2(_getAttributes927, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 9v4h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6V9zm-4 6h4v6h-4zm-8 8H7V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H9z'
  }));
});
LetterDd24.displayName = 'LetterDd24';
LetterDd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterDd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterDd20 = React.forwardRef(function (_ref928, ref) {
  var className = _ref928.className,
      children = _ref928.children,
      style = _ref928.style,
      tabIndex = _ref928.tabIndex,
      rest = _objectWithoutProperties$2(_ref928, ["className", "children", "style", "tabIndex"]);

  var _getAttributes928 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes928.tabindex,
      props = _objectWithoutProperties$2(_getAttributes928, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 9v4h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6V9zm-4 6h4v6h-4zm-8 8H7V9h4a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-2-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H9z'
  }));
});
LetterDd20.displayName = 'LetterDd20';
LetterDd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterDd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterEe32 = React.forwardRef(function (_ref929, ref) {
  var className = _ref929.className,
      children = _ref929.children,
      style = _ref929.style,
      tabIndex = _ref929.tabIndex,
      rest = _objectWithoutProperties$2(_ref929, ["className", "children", "style", "tabIndex"]);

  var _getAttributes929 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes929.tabindex,
      props = _objectWithoutProperties$2(_getAttributes929, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 11V9.02H7V23h8v-2H9v-4h5v-2H9v-4h6zm10 8v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h5v-2h-5v-2zm-6-4h4v2h-4z'
  }));
});
LetterEe32.displayName = 'LetterEe32';
LetterEe32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterEe32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterEe24 = React.forwardRef(function (_ref930, ref) {
  var className = _ref930.className,
      children = _ref930.children,
      style = _ref930.style,
      tabIndex = _ref930.tabIndex,
      rest = _objectWithoutProperties$2(_ref930, ["className", "children", "style", "tabIndex"]);

  var _getAttributes930 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes930.tabindex,
      props = _objectWithoutProperties$2(_getAttributes930, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 11V9.02H7V23h8v-2H9v-4h5v-2H9v-4h6zm10 8v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h5v-2h-5v-2zm-6-4h4v2h-4z'
  }));
});
LetterEe24.displayName = 'LetterEe24';
LetterEe24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterEe24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterEe20 = React.forwardRef(function (_ref931, ref) {
  var className = _ref931.className,
      children = _ref931.children,
      style = _ref931.style,
      tabIndex = _ref931.tabIndex,
      rest = _objectWithoutProperties$2(_ref931, ["className", "children", "style", "tabIndex"]);

  var _getAttributes931 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes931.tabindex,
      props = _objectWithoutProperties$2(_getAttributes931, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 11V9.02H7V23h8v-2H9v-4h5v-2H9v-4h6zm10 8v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h5v-2h-5v-2zm-6-4h4v2h-4z'
  }));
});
LetterEe20.displayName = 'LetterEe20';
LetterEe20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterEe20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterFf32 = React.forwardRef(function (_ref932, ref) {
  var className = _ref932.className,
      children = _ref932.children,
      style = _ref932.style,
      tabIndex = _ref932.tabIndex,
      rest = _objectWithoutProperties$2(_ref932, ["className", "children", "style", "tabIndex"]);

  var _getAttributes932 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes932.tabindex,
      props = _objectWithoutProperties$2(_getAttributes932, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 11V9H8v14h2v-6h5v-2h-5v-4h6zm8 0V9h-3a2 2 0 0 0-2 2v2h-2v2h2v8h2v-8h3v-2h-3v-2z'
  }));
});
LetterFf32.displayName = 'LetterFf32';
LetterFf32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterFf32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterFf24 = React.forwardRef(function (_ref933, ref) {
  var className = _ref933.className,
      children = _ref933.children,
      style = _ref933.style,
      tabIndex = _ref933.tabIndex,
      rest = _objectWithoutProperties$2(_ref933, ["className", "children", "style", "tabIndex"]);

  var _getAttributes933 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes933.tabindex,
      props = _objectWithoutProperties$2(_getAttributes933, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 11V9H8v14h2v-6h5v-2h-5v-4h6zm8 0V9h-3a2 2 0 0 0-2 2v2h-2v2h2v8h2v-8h3v-2h-3v-2z'
  }));
});
LetterFf24.displayName = 'LetterFf24';
LetterFf24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterFf24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterFf20 = React.forwardRef(function (_ref934, ref) {
  var className = _ref934.className,
      children = _ref934.children,
      style = _ref934.style,
      tabIndex = _ref934.tabIndex,
      rest = _objectWithoutProperties$2(_ref934, ["className", "children", "style", "tabIndex"]);

  var _getAttributes934 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes934.tabindex,
      props = _objectWithoutProperties$2(_getAttributes934, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 11V9H8v14h2v-6h5v-2h-5v-4h6zm8 0V9h-3a2 2 0 0 0-2 2v2h-2v2h2v8h2v-8h3v-2h-3v-2z'
  }));
});
LetterFf20.displayName = 'LetterFf20';
LetterFf20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterFf20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterGg32 = React.forwardRef(function (_ref935, ref) {
  var className = _ref935.className,
      children = _ref935.children,
      style = _ref935.style,
      tabIndex = _ref935.tabIndex,
      rest = _objectWithoutProperties$2(_ref935, ["className", "children", "style", "tabIndex"]);

  var _getAttributes935 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes935.tabindex,
      props = _objectWithoutProperties$2(_getAttributes935, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4v2h-5v2h5a2 2 0 0 0 2-2V13zm4 8h-4v-6h4zm-8 2H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h4v-4h-2v-2h4z'
  }));
});
LetterGg32.displayName = 'LetterGg32';
LetterGg32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterGg32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterGg24 = React.forwardRef(function (_ref936, ref) {
  var className = _ref936.className,
      children = _ref936.children,
      style = _ref936.style,
      tabIndex = _ref936.tabIndex,
      rest = _objectWithoutProperties$2(_ref936, ["className", "children", "style", "tabIndex"]);

  var _getAttributes936 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes936.tabindex,
      props = _objectWithoutProperties$2(_getAttributes936, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4v2h-5v2h5a2 2 0 0 0 2-2V13zm4 8h-4v-6h4zm-8 2H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h4v-4h-2v-2h4z'
  }));
});
LetterGg24.displayName = 'LetterGg24';
LetterGg24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterGg24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterGg20 = React.forwardRef(function (_ref937, ref) {
  var className = _ref937.className,
      children = _ref937.children,
      style = _ref937.style,
      tabIndex = _ref937.tabIndex,
      rest = _objectWithoutProperties$2(_ref937, ["className", "children", "style", "tabIndex"]);

  var _getAttributes937 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes937.tabindex,
      props = _objectWithoutProperties$2(_getAttributes937, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4v2h-5v2h5a2 2 0 0 0 2-2V13zm4 8h-4v-6h4zm-8 2H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h6v2H9v10h4v-4h-2v-2h4z'
  }));
});
LetterGg20.displayName = 'LetterGg20';
LetterGg20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterGg20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterHh32 = React.forwardRef(function (_ref938, ref) {
  var className = _ref938.className,
      children = _ref938.children,
      style = _ref938.style,
      tabIndex = _ref938.tabIndex,
      rest = _objectWithoutProperties$2(_ref938, ["className", "children", "style", "tabIndex"]);

  var _getAttributes938 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes938.tabindex,
      props = _objectWithoutProperties$2(_getAttributes938, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 9v6H9V9H7v14h2v-6h4v6h2V9h-2zm10 4h-4V9h-2v14h2v-8h4v8h2v-8a2 2 0 0 0-2-2z'
  }));
});
LetterHh32.displayName = 'LetterHh32';
LetterHh32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterHh32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterHh24 = React.forwardRef(function (_ref939, ref) {
  var className = _ref939.className,
      children = _ref939.children,
      style = _ref939.style,
      tabIndex = _ref939.tabIndex,
      rest = _objectWithoutProperties$2(_ref939, ["className", "children", "style", "tabIndex"]);

  var _getAttributes939 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes939.tabindex,
      props = _objectWithoutProperties$2(_getAttributes939, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 9v6H9V9H7v14h2v-6h4v6h2V9h-2zm10 4h-4V9h-2v14h2v-8h4v8h2v-8a2 2 0 0 0-2-2z'
  }));
});
LetterHh24.displayName = 'LetterHh24';
LetterHh24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterHh24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterHh20 = React.forwardRef(function (_ref940, ref) {
  var className = _ref940.className,
      children = _ref940.children,
      style = _ref940.style,
      tabIndex = _ref940.tabIndex,
      rest = _objectWithoutProperties$2(_ref940, ["className", "children", "style", "tabIndex"]);

  var _getAttributes940 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes940.tabindex,
      props = _objectWithoutProperties$2(_getAttributes940, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 9v6H9V9H7v14h2v-6h4v6h2V9h-2zm10 4h-4V9h-2v14h2v-8h4v8h2v-8a2 2 0 0 0-2-2z'
  }));
});
LetterHh20.displayName = 'LetterHh20';
LetterHh20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterHh20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterIi32 = React.forwardRef(function (_ref941, ref) {
  var className = _ref941.className,
      children = _ref941.children,
      style = _ref941.style,
      tabIndex = _ref941.tabIndex,
      rest = _objectWithoutProperties$2(_ref941, ["className", "children", "style", "tabIndex"]);

  var _getAttributes941 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes941.tabindex,
      props = _objectWithoutProperties$2(_getAttributes941, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 11h3v10h-3v2h8v-2h-3V11h3V9h-8v2zm10 2h2v10h-2zm0-4h2v2h-2z'
  }));
});
LetterIi32.displayName = 'LetterIi32';
LetterIi32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterIi32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterIi24 = React.forwardRef(function (_ref942, ref) {
  var className = _ref942.className,
      children = _ref942.children,
      style = _ref942.style,
      tabIndex = _ref942.tabIndex,
      rest = _objectWithoutProperties$2(_ref942, ["className", "children", "style", "tabIndex"]);

  var _getAttributes942 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes942.tabindex,
      props = _objectWithoutProperties$2(_getAttributes942, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 11h3v10h-3v2h8v-2h-3V11h3V9h-8v2zm10 2h2v10h-2zm0-4h2v2h-2z'
  }));
});
LetterIi24.displayName = 'LetterIi24';
LetterIi24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterIi24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterIi20 = React.forwardRef(function (_ref943, ref) {
  var className = _ref943.className,
      children = _ref943.children,
      style = _ref943.style,
      tabIndex = _ref943.tabIndex,
      rest = _objectWithoutProperties$2(_ref943, ["className", "children", "style", "tabIndex"]);

  var _getAttributes943 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes943.tabindex,
      props = _objectWithoutProperties$2(_getAttributes943, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 11h3v10h-3v2h8v-2h-3V11h3V9h-8v2zm10 2h2v10h-2zm0-4h2v2h-2z'
  }));
});
LetterIi20.displayName = 'LetterIi20';
LetterIi20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterIi20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterJj32 = React.forwardRef(function (_ref944, ref) {
  var className = _ref944.className,
      children = _ref944.children,
      style = _ref944.style,
      tabIndex = _ref944.tabIndex,
      rest = _objectWithoutProperties$2(_ref944, ["className", "children", "style", "tabIndex"]);

  var _getAttributes944 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes944.tabindex,
      props = _objectWithoutProperties$2(_getAttributes944, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h2v2h-2zm0 16h-3v2h3a2 2 0 0 0 2-2V13h-2zm-6-2h-4a2 2 0 0 1-2-2v-2h2v2h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
LetterJj32.displayName = 'LetterJj32';
LetterJj32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterJj32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterJj24 = React.forwardRef(function (_ref945, ref) {
  var className = _ref945.className,
      children = _ref945.children,
      style = _ref945.style,
      tabIndex = _ref945.tabIndex,
      rest = _objectWithoutProperties$2(_ref945, ["className", "children", "style", "tabIndex"]);

  var _getAttributes945 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes945.tabindex,
      props = _objectWithoutProperties$2(_getAttributes945, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h2v2h-2zm0 16h-3v2h3a2 2 0 0 0 2-2V13h-2zm-6-2h-4a2 2 0 0 1-2-2v-2h2v2h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
LetterJj24.displayName = 'LetterJj24';
LetterJj24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterJj24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterJj20 = React.forwardRef(function (_ref946, ref) {
  var className = _ref946.className,
      children = _ref946.children,
      style = _ref946.style,
      tabIndex = _ref946.tabIndex,
      rest = _objectWithoutProperties$2(_ref946, ["className", "children", "style", "tabIndex"]);

  var _getAttributes946 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes946.tabindex,
      props = _objectWithoutProperties$2(_getAttributes946, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h2v2h-2zm0 16h-3v2h3a2 2 0 0 0 2-2V13h-2zm-6-2h-4a2 2 0 0 1-2-2v-2h2v2h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
LetterJj20.displayName = 'LetterJj20';
LetterJj20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterJj20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterKk32 = React.forwardRef(function (_ref947, ref) {
  var className = _ref947.className,
      children = _ref947.children,
      style = _ref947.style,
      tabIndex = _ref947.tabIndex,
      rest = _objectWithoutProperties$2(_ref947, ["className", "children", "style", "tabIndex"]);

  var _getAttributes947 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes947.tabindex,
      props = _objectWithoutProperties$2(_getAttributes947, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2.11L9 15.55V9H7v14h2v-4.29l.93-1.49L12.89 23H15l-3.89-7.57L15 9zm7.78 14H25l-3.78-6L25 13h-2.24L19 17.17V9h-2v14h2v-3.75l.96-1.04L22.78 23z'
  }));
});
LetterKk32.displayName = 'LetterKk32';
LetterKk32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterKk32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterKk24 = React.forwardRef(function (_ref948, ref) {
  var className = _ref948.className,
      children = _ref948.children,
      style = _ref948.style,
      tabIndex = _ref948.tabIndex,
      rest = _objectWithoutProperties$2(_ref948, ["className", "children", "style", "tabIndex"]);

  var _getAttributes948 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes948.tabindex,
      props = _objectWithoutProperties$2(_getAttributes948, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2.11L9 15.55V9H7v14h2v-4.29l.93-1.49L12.89 23H15l-3.89-7.57L15 9zm7.78 14H25l-3.78-6L25 13h-2.24L19 17.17V9h-2v14h2v-3.75l.96-1.04L22.78 23z'
  }));
});
LetterKk24.displayName = 'LetterKk24';
LetterKk24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterKk24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterKk20 = React.forwardRef(function (_ref949, ref) {
  var className = _ref949.className,
      children = _ref949.children,
      style = _ref949.style,
      tabIndex = _ref949.tabIndex,
      rest = _objectWithoutProperties$2(_ref949, ["className", "children", "style", "tabIndex"]);

  var _getAttributes949 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes949.tabindex,
      props = _objectWithoutProperties$2(_getAttributes949, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2.11L9 15.55V9H7v14h2v-4.29l.93-1.49L12.89 23H15l-3.89-7.57L15 9zm7.78 14H25l-3.78-6L25 13h-2.24L19 17.17V9h-2v14h2v-3.75l.96-1.04L22.78 23z'
  }));
});
LetterKk20.displayName = 'LetterKk20';
LetterKk20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterKk20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterLl32 = React.forwardRef(function (_ref950, ref) {
  var className = _ref950.className,
      children = _ref950.children,
      style = _ref950.style,
      tabIndex = _ref950.tabIndex,
      rest = _objectWithoutProperties$2(_ref950, ["className", "children", "style", "tabIndex"]);

  var _getAttributes950 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes950.tabindex,
      props = _objectWithoutProperties$2(_getAttributes950, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 21V9H9v14h8v-2h-6zm12 2h-2a2 2 0 0 1-2-2V9h2v12h2z'
  }));
});
LetterLl32.displayName = 'LetterLl32';
LetterLl32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterLl32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterLl24 = React.forwardRef(function (_ref951, ref) {
  var className = _ref951.className,
      children = _ref951.children,
      style = _ref951.style,
      tabIndex = _ref951.tabIndex,
      rest = _objectWithoutProperties$2(_ref951, ["className", "children", "style", "tabIndex"]);

  var _getAttributes951 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes951.tabindex,
      props = _objectWithoutProperties$2(_getAttributes951, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 21V9H9v14h8v-2h-6zm12 2h-2a2 2 0 0 1-2-2V9h2v12h2z'
  }));
});
LetterLl24.displayName = 'LetterLl24';
LetterLl24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterLl24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterLl20 = React.forwardRef(function (_ref952, ref) {
  var className = _ref952.className,
      children = _ref952.children,
      style = _ref952.style,
      tabIndex = _ref952.tabIndex,
      rest = _objectWithoutProperties$2(_ref952, ["className", "children", "style", "tabIndex"]);

  var _getAttributes952 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes952.tabindex,
      props = _objectWithoutProperties$2(_getAttributes952, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 21V9H9v14h8v-2h-6zm12 2h-2a2 2 0 0 1-2-2V9h2v12h2z'
  }));
});
LetterLl20.displayName = 'LetterLl20';
LetterLl20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterLl20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterMm32 = React.forwardRef(function (_ref953, ref) {
  var className = _ref953.className,
      children = _ref953.children,
      style = _ref953.style,
      tabIndex = _ref953.tabIndex,
      rest = _objectWithoutProperties$2(_ref953, ["className", "children", "style", "tabIndex"]);

  var _getAttributes953 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes953.tabindex,
      props = _objectWithoutProperties$2(_getAttributes953, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 13h-8v10h2v-8h2v8h2v-8h2v8h2v-8a2 2 0 0 0-2-2zM12 9l-1.52 5-.48 1.98L9.54 14 8 9H6v14h2v-8l-.16-2 .58 2L10 19.63 11.58 15l.58-2-.16 2v8h2V9h-2z'
  }));
});
LetterMm32.displayName = 'LetterMm32';
LetterMm32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterMm32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterMm24 = React.forwardRef(function (_ref954, ref) {
  var className = _ref954.className,
      children = _ref954.children,
      style = _ref954.style,
      tabIndex = _ref954.tabIndex,
      rest = _objectWithoutProperties$2(_ref954, ["className", "children", "style", "tabIndex"]);

  var _getAttributes954 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes954.tabindex,
      props = _objectWithoutProperties$2(_getAttributes954, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 13h-8v10h2v-8h2v8h2v-8h2v8h2v-8a2 2 0 0 0-2-2zM12 9l-1.52 5-.48 1.98L9.54 14 8 9H6v14h2v-8l-.16-2 .58 2L10 19.63 11.58 15l.58-2-.16 2v8h2V9h-2z'
  }));
});
LetterMm24.displayName = 'LetterMm24';
LetterMm24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterMm24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterMm20 = React.forwardRef(function (_ref955, ref) {
  var className = _ref955.className,
      children = _ref955.children,
      style = _ref955.style,
      tabIndex = _ref955.tabIndex,
      rest = _objectWithoutProperties$2(_ref955, ["className", "children", "style", "tabIndex"]);

  var _getAttributes955 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes955.tabindex,
      props = _objectWithoutProperties$2(_getAttributes955, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 13h-8v10h2v-8h2v8h2v-8h2v8h2v-8a2 2 0 0 0-2-2zM12 9l-1.52 5-.48 1.98L9.54 14 8 9H6v14h2v-8l-.16-2 .58 2L10 19.63 11.58 15l.58-2-.16 2v8h2V9h-2z'
  }));
});
LetterMm20.displayName = 'LetterMm20';
LetterMm20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterMm20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterNn32 = React.forwardRef(function (_ref956, ref) {
  var className = _ref956.className,
      children = _ref956.children,
      style = _ref956.style,
      tabIndex = _ref956.tabIndex,
      rest = _objectWithoutProperties$2(_ref956, ["className", "children", "style", "tabIndex"]);

  var _getAttributes956 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes956.tabindex,
      props = _objectWithoutProperties$2(_getAttributes956, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 23h-2v-8h-4v8h-2V13h6a2 2 0 0 1 2 2zm-12-4L9.32 9H7v14h2V13l3.68 10H15V9h-2v10z'
  }));
});
LetterNn32.displayName = 'LetterNn32';
LetterNn32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterNn32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterNn24 = React.forwardRef(function (_ref957, ref) {
  var className = _ref957.className,
      children = _ref957.children,
      style = _ref957.style,
      tabIndex = _ref957.tabIndex,
      rest = _objectWithoutProperties$2(_ref957, ["className", "children", "style", "tabIndex"]);

  var _getAttributes957 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes957.tabindex,
      props = _objectWithoutProperties$2(_getAttributes957, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 23h-2v-8h-4v8h-2V13h6a2 2 0 0 1 2 2zm-12-4L9.32 9H7v14h2V13l3.68 10H15V9h-2v10z'
  }));
});
LetterNn24.displayName = 'LetterNn24';
LetterNn24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterNn24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterNn20 = React.forwardRef(function (_ref958, ref) {
  var className = _ref958.className,
      children = _ref958.children,
      style = _ref958.style,
      tabIndex = _ref958.tabIndex,
      rest = _objectWithoutProperties$2(_ref958, ["className", "children", "style", "tabIndex"]);

  var _getAttributes958 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes958.tabindex,
      props = _objectWithoutProperties$2(_getAttributes958, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 23h-2v-8h-4v8h-2V13h6a2 2 0 0 1 2 2zm-12-4L9.32 9H7v14h2V13l3.68 10H15V9h-2v10z'
  }));
});
LetterNn20.displayName = 'LetterNn20';
LetterNn20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterNn20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterOo32 = React.forwardRef(function (_ref959, ref) {
  var className = _ref959.className,
      children = _ref959.children,
      style = _ref959.style,
      tabIndex = _ref959.tabIndex,
      rest = _objectWithoutProperties$2(_ref959, ["className", "children", "style", "tabIndex"]);

  var _getAttributes959 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes959.tabindex,
      props = _objectWithoutProperties$2(_getAttributes959, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 23h-4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-4-8v6h4v-6zm-6 8H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zM9 11v10h4V11z'
  }));
});
LetterOo32.displayName = 'LetterOo32';
LetterOo32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterOo32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterOo24 = React.forwardRef(function (_ref960, ref) {
  var className = _ref960.className,
      children = _ref960.children,
      style = _ref960.style,
      tabIndex = _ref960.tabIndex,
      rest = _objectWithoutProperties$2(_ref960, ["className", "children", "style", "tabIndex"]);

  var _getAttributes960 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes960.tabindex,
      props = _objectWithoutProperties$2(_getAttributes960, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 23h-4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-4-8v6h4v-6zm-6 8H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zM9 11v10h4V11z'
  }));
});
LetterOo24.displayName = 'LetterOo24';
LetterOo24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterOo24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterOo20 = React.forwardRef(function (_ref961, ref) {
  var className = _ref961.className,
      children = _ref961.children,
      style = _ref961.style,
      tabIndex = _ref961.tabIndex,
      rest = _objectWithoutProperties$2(_ref961, ["className", "children", "style", "tabIndex"]);

  var _getAttributes961 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes961.tabindex,
      props = _objectWithoutProperties$2(_getAttributes961, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 23h-4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-4-8v6h4v-6zm-6 8H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zM9 11v10h4V11z'
  }));
});
LetterOo20.displayName = 'LetterOo20';
LetterOo20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterOo20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterPp32 = React.forwardRef(function (_ref962, ref) {
  var className = _ref962.className,
      children = _ref962.children,
      style = _ref962.style,
      tabIndex = _ref962.tabIndex,
      rest = _objectWithoutProperties$2(_ref962, ["className", "children", "style", "tabIndex"]);

  var _getAttributes962 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes962.tabindex,
      props = _objectWithoutProperties$2(_getAttributes962, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-6v14h2v-4h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-4 8v-6h4v6zM9 23H7V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9zm0-7h4v-5H9z'
  }));
});
LetterPp32.displayName = 'LetterPp32';
LetterPp32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterPp32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterPp24 = React.forwardRef(function (_ref963, ref) {
  var className = _ref963.className,
      children = _ref963.children,
      style = _ref963.style,
      tabIndex = _ref963.tabIndex,
      rest = _objectWithoutProperties$2(_ref963, ["className", "children", "style", "tabIndex"]);

  var _getAttributes963 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes963.tabindex,
      props = _objectWithoutProperties$2(_getAttributes963, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-6v14h2v-4h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-4 8v-6h4v6zM9 23H7V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9zm0-7h4v-5H9z'
  }));
});
LetterPp24.displayName = 'LetterPp24';
LetterPp24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterPp24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterPp20 = React.forwardRef(function (_ref964, ref) {
  var className = _ref964.className,
      children = _ref964.children,
      style = _ref964.style,
      tabIndex = _ref964.tabIndex,
      rest = _objectWithoutProperties$2(_ref964, ["className", "children", "style", "tabIndex"]);

  var _getAttributes964 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes964.tabindex,
      props = _objectWithoutProperties$2(_getAttributes964, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 13h-6v14h2v-4h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-4 8v-6h4v6zM9 23H7V9h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9zm0-7h4v-5H9z'
  }));
});
LetterPp20.displayName = 'LetterPp20';
LetterPp20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterPp20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterQq32 = React.forwardRef(function (_ref965, ref) {
  var className = _ref965.className,
      children = _ref965.children,
      style = _ref965.style,
      tabIndex = _ref965.tabIndex,
      rest = _objectWithoutProperties$2(_ref965, ["className", "children", "style", "tabIndex"]);

  var _getAttributes965 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes965.tabindex,
      props = _objectWithoutProperties$2(_getAttributes965, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4v4h2V13zm4 8h-4v-6h4zM13 9H9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h2v-2h-2v-2h1a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM9 21V11h4v10z'
  }));
});
LetterQq32.displayName = 'LetterQq32';
LetterQq32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterQq32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterQq24 = React.forwardRef(function (_ref966, ref) {
  var className = _ref966.className,
      children = _ref966.children,
      style = _ref966.style,
      tabIndex = _ref966.tabIndex,
      rest = _objectWithoutProperties$2(_ref966, ["className", "children", "style", "tabIndex"]);

  var _getAttributes966 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes966.tabindex,
      props = _objectWithoutProperties$2(_getAttributes966, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4v4h2V13zm4 8h-4v-6h4zM13 9H9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h2v-2h-2v-2h1a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM9 21V11h4v10z'
  }));
});
LetterQq24.displayName = 'LetterQq24';
LetterQq24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterQq24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterQq20 = React.forwardRef(function (_ref967, ref) {
  var className = _ref967.className,
      children = _ref967.children,
      style = _ref967.style,
      tabIndex = _ref967.tabIndex,
      rest = _objectWithoutProperties$2(_ref967, ["className", "children", "style", "tabIndex"]);

  var _getAttributes967 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes967.tabindex,
      props = _objectWithoutProperties$2(_getAttributes967, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4v4h2V13zm4 8h-4v-6h4zM13 9H9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h2v-2h-2v-2h1a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM9 21V11h4v10z'
  }));
});
LetterQq20.displayName = 'LetterQq20';
LetterQq20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterQq20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterRr32 = React.forwardRef(function (_ref968, ref) {
  var className = _ref968.className,
      children = _ref968.children,
      style = _ref968.style,
      tabIndex = _ref968.tabIndex,
      rest = _objectWithoutProperties$2(_ref968, ["className", "children", "style", "tabIndex"]);

  var _getAttributes968 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes968.tabindex,
      props = _objectWithoutProperties$2(_getAttributes968, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 15v-4a2 2 0 0 0-2-2H8v14h2v-6h1.48l2.34 6H16l-2.33-6H14a2 2 0 0 0 2-2zm-6-4h4v4h-4zm14 2h-6v10h2v-8h4v-2z'
  }));
});
LetterRr32.displayName = 'LetterRr32';
LetterRr32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterRr32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterRr24 = React.forwardRef(function (_ref969, ref) {
  var className = _ref969.className,
      children = _ref969.children,
      style = _ref969.style,
      tabIndex = _ref969.tabIndex,
      rest = _objectWithoutProperties$2(_ref969, ["className", "children", "style", "tabIndex"]);

  var _getAttributes969 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes969.tabindex,
      props = _objectWithoutProperties$2(_getAttributes969, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 15v-4a2 2 0 0 0-2-2H8v14h2v-6h1.48l2.34 6H16l-2.33-6H14a2 2 0 0 0 2-2zm-6-4h4v4h-4zm14 2h-6v10h2v-8h4v-2z'
  }));
});
LetterRr24.displayName = 'LetterRr24';
LetterRr24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterRr24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterRr20 = React.forwardRef(function (_ref970, ref) {
  var className = _ref970.className,
      children = _ref970.children,
      style = _ref970.style,
      tabIndex = _ref970.tabIndex,
      rest = _objectWithoutProperties$2(_ref970, ["className", "children", "style", "tabIndex"]);

  var _getAttributes970 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes970.tabindex,
      props = _objectWithoutProperties$2(_getAttributes970, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 15v-4a2 2 0 0 0-2-2H8v14h2v-6h1.48l2.34 6H16l-2.33-6H14a2 2 0 0 0 2-2zm-6-4h4v4h-4zm14 2h-6v10h2v-8h4v-2z'
  }));
});
LetterRr20.displayName = 'LetterRr20';
LetterRr20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterRr20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterSs32 = React.forwardRef(function (_ref971, ref) {
  var className = _ref971.className,
      children = _ref971.children,
      style = _ref971.style,
      tabIndex = _ref971.tabIndex,
      rest = _objectWithoutProperties$2(_ref971, ["className", "children", "style", "tabIndex"]);

  var _getAttributes971 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes971.tabindex,
      props = _objectWithoutProperties$2(_getAttributes971, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 23h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5v2h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-9 0H7v-2h6v-4H9a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H9v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
LetterSs32.displayName = 'LetterSs32';
LetterSs32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterSs32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterSs24 = React.forwardRef(function (_ref972, ref) {
  var className = _ref972.className,
      children = _ref972.children,
      style = _ref972.style,
      tabIndex = _ref972.tabIndex,
      rest = _objectWithoutProperties$2(_ref972, ["className", "children", "style", "tabIndex"]);

  var _getAttributes972 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes972.tabindex,
      props = _objectWithoutProperties$2(_getAttributes972, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 23h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5v2h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-9 0H7v-2h6v-4H9a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H9v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
LetterSs24.displayName = 'LetterSs24';
LetterSs24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterSs24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterSs20 = React.forwardRef(function (_ref973, ref) {
  var className = _ref973.className,
      children = _ref973.children,
      style = _ref973.style,
      tabIndex = _ref973.tabIndex,
      rest = _objectWithoutProperties$2(_ref973, ["className", "children", "style", "tabIndex"]);

  var _getAttributes973 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes973.tabindex,
      props = _objectWithoutProperties$2(_getAttributes973, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 23h-5v-2h5v-2h-3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h5v2h-5v2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-9 0H7v-2h6v-4H9a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6v2H9v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
LetterSs20.displayName = 'LetterSs20';
LetterSs20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterSs20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterTt32 = React.forwardRef(function (_ref974, ref) {
  var className = _ref974.className,
      children = _ref974.children,
      style = _ref974.style,
      tabIndex = _ref974.tabIndex,
      rest = _objectWithoutProperties$2(_ref974, ["className", "children", "style", "tabIndex"]);

  var _getAttributes974 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes974.tabindex,
      props = _objectWithoutProperties$2(_getAttributes974, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 11h3v12h2V11h3V9H8v2zm15 4v-2h-3v-2h-2v2h-2v2h2v6a2 2 0 0 0 2 2h3v-2h-3v-6z'
  }));
});
LetterTt32.displayName = 'LetterTt32';
LetterTt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterTt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterTt24 = React.forwardRef(function (_ref975, ref) {
  var className = _ref975.className,
      children = _ref975.children,
      style = _ref975.style,
      tabIndex = _ref975.tabIndex,
      rest = _objectWithoutProperties$2(_ref975, ["className", "children", "style", "tabIndex"]);

  var _getAttributes975 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes975.tabindex,
      props = _objectWithoutProperties$2(_getAttributes975, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 11h3v12h2V11h3V9H8v2zm15 4v-2h-3v-2h-2v2h-2v2h2v6a2 2 0 0 0 2 2h3v-2h-3v-6z'
  }));
});
LetterTt24.displayName = 'LetterTt24';
LetterTt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterTt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterTt20 = React.forwardRef(function (_ref976, ref) {
  var className = _ref976.className,
      children = _ref976.children,
      style = _ref976.style,
      tabIndex = _ref976.tabIndex,
      rest = _objectWithoutProperties$2(_ref976, ["className", "children", "style", "tabIndex"]);

  var _getAttributes976 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes976.tabindex,
      props = _objectWithoutProperties$2(_getAttributes976, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 11h3v12h2V11h3V9H8v2zm15 4v-2h-3v-2h-2v2h-2v2h2v6a2 2 0 0 0 2 2h3v-2h-3v-6z'
  }));
});
LetterTt20.displayName = 'LetterTt20';
LetterTt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterTt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterUu32 = React.forwardRef(function (_ref977, ref) {
  var className = _ref977.className,
      children = _ref977.children,
      style = _ref977.style,
      tabIndex = _ref977.tabIndex,
      rest = _objectWithoutProperties$2(_ref977, ["className", "children", "style", "tabIndex"]);

  var _getAttributes977 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes977.tabindex,
      props = _objectWithoutProperties$2(_getAttributes977, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 23h-4a2 2 0 0 1-2-2v-8h2v8h4v-8h2v8a2 2 0 0 1-2 2zm-10 0H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
LetterUu32.displayName = 'LetterUu32';
LetterUu32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterUu32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterUu24 = React.forwardRef(function (_ref978, ref) {
  var className = _ref978.className,
      children = _ref978.children,
      style = _ref978.style,
      tabIndex = _ref978.tabIndex,
      rest = _objectWithoutProperties$2(_ref978, ["className", "children", "style", "tabIndex"]);

  var _getAttributes978 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes978.tabindex,
      props = _objectWithoutProperties$2(_getAttributes978, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 23h-4a2 2 0 0 1-2-2v-8h2v8h4v-8h2v8a2 2 0 0 1-2 2zm-10 0H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
LetterUu24.displayName = 'LetterUu24';
LetterUu24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterUu24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterUu20 = React.forwardRef(function (_ref979, ref) {
  var className = _ref979.className,
      children = _ref979.children,
      style = _ref979.style,
      tabIndex = _ref979.tabIndex,
      rest = _objectWithoutProperties$2(_ref979, ["className", "children", "style", "tabIndex"]);

  var _getAttributes979 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes979.tabindex,
      props = _objectWithoutProperties$2(_getAttributes979, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 23h-4a2 2 0 0 1-2-2v-8h2v8h4v-8h2v8a2 2 0 0 1-2 2zm-10 0H9a2 2 0 0 1-2-2V9h2v12h4V9h2v12a2 2 0 0 1-2 2z'
  }));
});
LetterUu20.displayName = 'LetterUu20';
LetterUu20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterUu20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterVv32 = React.forwardRef(function (_ref980, ref) {
  var className = _ref980.className,
      children = _ref980.children,
      style = _ref980.style,
      tabIndex = _ref980.tabIndex,
      rest = _objectWithoutProperties$2(_ref980, ["className", "children", "style", "tabIndex"]);

  var _getAttributes980 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes980.tabindex,
      props = _objectWithoutProperties$2(_getAttributes980, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 13h-1.75L21 22.03 18.79 13H17l2.5 10h3L25 13zM13 9l-2 13L9 9H7l2.52 14h2.96L15 9h-2z'
  }));
});
LetterVv32.displayName = 'LetterVv32';
LetterVv32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterVv32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterVv24 = React.forwardRef(function (_ref981, ref) {
  var className = _ref981.className,
      children = _ref981.children,
      style = _ref981.style,
      tabIndex = _ref981.tabIndex,
      rest = _objectWithoutProperties$2(_ref981, ["className", "children", "style", "tabIndex"]);

  var _getAttributes981 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes981.tabindex,
      props = _objectWithoutProperties$2(_getAttributes981, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 13h-1.75L21 22.03 18.79 13H17l2.5 10h3L25 13zM13 9l-2 13L9 9H7l2.52 14h2.96L15 9h-2z'
  }));
});
LetterVv24.displayName = 'LetterVv24';
LetterVv24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterVv24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterVv20 = React.forwardRef(function (_ref982, ref) {
  var className = _ref982.className,
      children = _ref982.children,
      style = _ref982.style,
      tabIndex = _ref982.tabIndex,
      rest = _objectWithoutProperties$2(_ref982, ["className", "children", "style", "tabIndex"]);

  var _getAttributes982 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes982.tabindex,
      props = _objectWithoutProperties$2(_getAttributes982, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 13h-1.75L21 22.03 18.79 13H17l2.5 10h3L25 13zM13 9l-2 13L9 9H7l2.52 14h2.96L15 9h-2z'
  }));
});
LetterVv20.displayName = 'LetterVv20';
LetterVv20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterVv20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterWw32 = React.forwardRef(function (_ref983, ref) {
  var className = _ref983.className,
      children = _ref983.children,
      style = _ref983.style,
      tabIndex = _ref983.tabIndex,
      rest = _objectWithoutProperties$2(_ref983, ["className", "children", "style", "tabIndex"]);

  var _getAttributes983 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes983.tabindex,
      props = _objectWithoutProperties$2(_getAttributes983, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24.3 13l-.91 8.61L22 13h-2l-1.39 8.61L17.7 13H16l1.36 10h2.28L21 14.63 22.36 23h2.28L26 13h-1.7zM12.21 9l-.34 8-.26 4.54L11.2 18l-.68-5.46H8.5L7.82 18l-.41 3.54L7.16 17l-.35-8h-1.8l1 14h2.27l.76-4.93L9.5 14l.01-.03.01.03.46 4.07.76 4.93h2.27l1-14h-1.8z'
  }));
});
LetterWw32.displayName = 'LetterWw32';
LetterWw32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterWw32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterWw24 = React.forwardRef(function (_ref984, ref) {
  var className = _ref984.className,
      children = _ref984.children,
      style = _ref984.style,
      tabIndex = _ref984.tabIndex,
      rest = _objectWithoutProperties$2(_ref984, ["className", "children", "style", "tabIndex"]);

  var _getAttributes984 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes984.tabindex,
      props = _objectWithoutProperties$2(_getAttributes984, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24.3 13l-.91 8.61L22 13h-2l-1.39 8.61L17.7 13H16l1.36 10h2.28L21 14.63 22.36 23h2.28L26 13h-1.7zM12.21 9l-.34 8-.26 4.54L11.2 18l-.68-5.46H8.5L7.82 18l-.41 3.54L7.16 17l-.35-8h-1.8l1 14h2.27l.76-4.93L9.5 14l.01-.03.01.03.46 4.07.76 4.93h2.27l1-14h-1.8z'
  }));
});
LetterWw24.displayName = 'LetterWw24';
LetterWw24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterWw24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterWw20 = React.forwardRef(function (_ref985, ref) {
  var className = _ref985.className,
      children = _ref985.children,
      style = _ref985.style,
      tabIndex = _ref985.tabIndex,
      rest = _objectWithoutProperties$2(_ref985, ["className", "children", "style", "tabIndex"]);

  var _getAttributes985 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes985.tabindex,
      props = _objectWithoutProperties$2(_getAttributes985, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24.3 13l-.91 8.61L22 13h-2l-1.39 8.61L17.7 13H16l1.36 10h2.28L21 14.63 22.36 23h2.28L26 13h-1.7zM12.21 9l-.34 8-.26 4.54L11.2 18l-.68-5.46H8.5L7.82 18l-.41 3.54L7.16 17l-.35-8h-1.8l1 14h2.27l.76-4.93L9.5 14l.01-.03.01.03.46 4.07.76 4.93h2.27l1-14h-1.8z'
  }));
});
LetterWw20.displayName = 'LetterWw20';
LetterWw20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterWw20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterXx32 = React.forwardRef(function (_ref986, ref) {
  var className = _ref986.className,
      children = _ref986.children,
      style = _ref986.style,
      tabIndex = _ref986.tabIndex,
      rest = _objectWithoutProperties$2(_ref986, ["className", "children", "style", "tabIndex"]);

  var _getAttributes986 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes986.tabindex,
      props = _objectWithoutProperties$2(_getAttributes986, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2l-2 6-2-6H7l2.75 7L7 23h2l2-6 2 6h2l-2.76-7L15 9zm10 4h-2l-2 3.9-2-3.9h-2l2.91 5L17 23h2l2-3.8 2 3.8h2l-2.9-5 2.9-5z'
  }));
});
LetterXx32.displayName = 'LetterXx32';
LetterXx32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterXx32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterXx24 = React.forwardRef(function (_ref987, ref) {
  var className = _ref987.className,
      children = _ref987.children,
      style = _ref987.style,
      tabIndex = _ref987.tabIndex,
      rest = _objectWithoutProperties$2(_ref987, ["className", "children", "style", "tabIndex"]);

  var _getAttributes987 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes987.tabindex,
      props = _objectWithoutProperties$2(_getAttributes987, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2l-2 6-2-6H7l2.75 7L7 23h2l2-6 2 6h2l-2.76-7L15 9zm10 4h-2l-2 3.9-2-3.9h-2l2.91 5L17 23h2l2-3.8 2 3.8h2l-2.9-5 2.9-5z'
  }));
});
LetterXx24.displayName = 'LetterXx24';
LetterXx24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterXx24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterXx20 = React.forwardRef(function (_ref988, ref) {
  var className = _ref988.className,
      children = _ref988.children,
      style = _ref988.style,
      tabIndex = _ref988.tabIndex,
      rest = _objectWithoutProperties$2(_ref988, ["className", "children", "style", "tabIndex"]);

  var _getAttributes988 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes988.tabindex,
      props = _objectWithoutProperties$2(_getAttributes988, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2l-2 6-2-6H7l2.75 7L7 23h2l2-6 2 6h2l-2.76-7L15 9zm10 4h-2l-2 3.9-2-3.9h-2l2.91 5L17 23h2l2-3.8 2 3.8h2l-2.9-5 2.9-5z'
  }));
});
LetterXx20.displayName = 'LetterXx20';
LetterXx20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterXx20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterYy32 = React.forwardRef(function (_ref989, ref) {
  var className = _ref989.className,
      children = _ref989.children,
      style = _ref989.style,
      tabIndex = _ref989.tabIndex,
      rest = _objectWithoutProperties$2(_ref989, ["className", "children", "style", "tabIndex"]);

  var _getAttributes989 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes989.tabindex,
      props = _objectWithoutProperties$2(_getAttributes989, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2l-2 7-2-7H7l3 9v5h2v-5l3-9zm8 4l-2 7.52L19.08 13H17l3.15 9.87-.62 2.13H17v2h2.26a2 2 0 0 0 1.91-1.42L25 13z'
  }));
});
LetterYy32.displayName = 'LetterYy32';
LetterYy32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterYy32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterYy24 = React.forwardRef(function (_ref990, ref) {
  var className = _ref990.className,
      children = _ref990.children,
      style = _ref990.style,
      tabIndex = _ref990.tabIndex,
      rest = _objectWithoutProperties$2(_ref990, ["className", "children", "style", "tabIndex"]);

  var _getAttributes990 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes990.tabindex,
      props = _objectWithoutProperties$2(_getAttributes990, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2l-2 7-2-7H7l3 9v5h2v-5l3-9zm8 4l-2 7.52L19.08 13H17l3.15 9.87-.62 2.13H17v2h2.26a2 2 0 0 0 1.91-1.42L25 13z'
  }));
});
LetterYy24.displayName = 'LetterYy24';
LetterYy24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterYy24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterYy20 = React.forwardRef(function (_ref991, ref) {
  var className = _ref991.className,
      children = _ref991.children,
      style = _ref991.style,
      tabIndex = _ref991.tabIndex,
      rest = _objectWithoutProperties$2(_ref991, ["className", "children", "style", "tabIndex"]);

  var _getAttributes991 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes991.tabindex,
      props = _objectWithoutProperties$2(_getAttributes991, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 9h-2l-2 7-2-7H7l3 9v5h2v-5l3-9zm8 4l-2 7.52L19.08 13H17l3.15 9.87-.62 2.13H17v2h2.26a2 2 0 0 0 1.91-1.42L25 13z'
  }));
});
LetterYy20.displayName = 'LetterYy20';
LetterYy20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterYy20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterZz32 = React.forwardRef(function (_ref992, ref) {
  var className = _ref992.className,
      children = _ref992.children,
      style = _ref992.style,
      tabIndex = _ref992.tabIndex,
      rest = _objectWithoutProperties$2(_ref992, ["className", "children", "style", "tabIndex"]);

  var _getAttributes992 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes992.tabindex,
      props = _objectWithoutProperties$2(_getAttributes992, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 15v-2h-8v2h5.5L17 21v2h8v-2h-5.49L25 15zM15 9H7v2h6L7 21v2h8v-2H9l6-10V9z'
  }));
});
LetterZz32.displayName = 'LetterZz32';
LetterZz32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterZz32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterZz24 = React.forwardRef(function (_ref993, ref) {
  var className = _ref993.className,
      children = _ref993.children,
      style = _ref993.style,
      tabIndex = _ref993.tabIndex,
      rest = _objectWithoutProperties$2(_ref993, ["className", "children", "style", "tabIndex"]);

  var _getAttributes993 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes993.tabindex,
      props = _objectWithoutProperties$2(_getAttributes993, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 15v-2h-8v2h5.5L17 21v2h8v-2h-5.49L25 15zM15 9H7v2h6L7 21v2h8v-2H9l6-10V9z'
  }));
});
LetterZz24.displayName = 'LetterZz24';
LetterZz24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterZz24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LetterZz20 = React.forwardRef(function (_ref994, ref) {
  var className = _ref994.className,
      children = _ref994.children,
      style = _ref994.style,
      tabIndex = _ref994.tabIndex,
      rest = _objectWithoutProperties$2(_ref994, ["className", "children", "style", "tabIndex"]);

  var _getAttributes994 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes994.tabindex,
      props = _objectWithoutProperties$2(_getAttributes994, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 15v-2h-8v2h5.5L17 21v2h8v-2h-5.49L25 15zM15 9H7v2h6L7 21v2h8v-2H9l6-10V9z'
  }));
});
LetterZz20.displayName = 'LetterZz20';
LetterZz20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LetterZz20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LightFilled32 = React.forwardRef(function (_ref995, ref) {
  var className = _ref995.className,
      children = _ref995.children,
      style = _ref995.style,
      tabIndex = _ref995.tabIndex,
      rest = _objectWithoutProperties$2(_ref995, ["className", "children", "style", "tabIndex"]);

  var _getAttributes995 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes995.tabindex,
      props = _objectWithoutProperties$2(_getAttributes995, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v4.96h-2zm6.687 6.89l3.507-3.506 1.414 1.414-3.507 3.507zM25.04 15H30v2h-4.96zm-3.347 8.104l1.414-1.414 3.507 3.507L25.2 26.61zM15 25.04h2V30h-2zm-9.604.162l3.508-3.507 1.414 1.414-3.507 3.507zM2 15h4.96v2H2zm3.39-8.197l1.415-1.414 3.507 3.507-1.414 1.414zM16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
LightFilled32.displayName = 'LightFilled32';
LightFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LightFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LightFilled24 = React.forwardRef(function (_ref996, ref) {
  var className = _ref996.className,
      children = _ref996.children,
      style = _ref996.style,
      tabIndex = _ref996.tabIndex,
      rest = _objectWithoutProperties$2(_ref996, ["className", "children", "style", "tabIndex"]);

  var _getAttributes996 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes996.tabindex,
      props = _objectWithoutProperties$2(_getAttributes996, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v4.96h-2zm6.687 6.89l3.507-3.506 1.414 1.414-3.507 3.507zM25.04 15H30v2h-4.96zm-3.347 8.104l1.414-1.414 3.507 3.507L25.2 26.61zM15 25.04h2V30h-2zm-9.604.162l3.508-3.507 1.414 1.414-3.507 3.507zM2 15h4.96v2H2zm3.39-8.197l1.415-1.414 3.507 3.507-1.414 1.414zM16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
LightFilled24.displayName = 'LightFilled24';
LightFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LightFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LightFilled20 = React.forwardRef(function (_ref997, ref) {
  var className = _ref997.className,
      children = _ref997.children,
      style = _ref997.style,
      tabIndex = _ref997.tabIndex,
      rest = _objectWithoutProperties$2(_ref997, ["className", "children", "style", "tabIndex"]);

  var _getAttributes997 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes997.tabindex,
      props = _objectWithoutProperties$2(_getAttributes997, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v4.96h-2zm6.687 6.89l3.507-3.506 1.414 1.414-3.507 3.507zM25.04 15H30v2h-4.96zm-3.347 8.104l1.414-1.414 3.507 3.507L25.2 26.61zM15 25.04h2V30h-2zm-9.604.162l3.508-3.507 1.414 1.414-3.507 3.507zM2 15h4.96v2H2zm3.39-8.197l1.415-1.414 3.507 3.507-1.414 1.414zM16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
LightFilled20.displayName = 'LightFilled20';
LightFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LightFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Light32 = React.forwardRef(function (_ref998, ref) {
  var className = _ref998.className,
      children = _ref998.children,
      style = _ref998.style,
      tabIndex = _ref998.tabIndex,
      rest = _objectWithoutProperties$2(_ref998, ["className", "children", "style", "tabIndex"]);

  var _getAttributes998 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes998.tabindex,
      props = _objectWithoutProperties$2(_getAttributes998, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v4.96h-2zm6.687 6.89l3.507-3.506 1.414 1.414-3.507 3.507zM25.04 15H30v2h-4.96zm-3.347 8.104l1.414-1.414 3.507 3.507L25.2 26.61zM15 25.04h2V30h-2zm-9.604.162l3.508-3.507 1.414 1.414-3.507 3.507zM2 15h4.96v2H2zm3.39-8.197l1.415-1.414 3.507 3.507-1.414 1.414zM16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
Light32.displayName = 'Light32';
Light32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Light32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Light24 = React.forwardRef(function (_ref999, ref) {
  var className = _ref999.className,
      children = _ref999.children,
      style = _ref999.style,
      tabIndex = _ref999.tabIndex,
      rest = _objectWithoutProperties$2(_ref999, ["className", "children", "style", "tabIndex"]);

  var _getAttributes999 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes999.tabindex,
      props = _objectWithoutProperties$2(_getAttributes999, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v4.96h-2zm6.687 6.89l3.507-3.506 1.414 1.414-3.507 3.507zM25.04 15H30v2h-4.96zm-3.347 8.104l1.414-1.414 3.507 3.507L25.2 26.61zM15 25.04h2V30h-2zm-9.604.162l3.508-3.507 1.414 1.414-3.507 3.507zM2 15h4.96v2H2zm3.39-8.197l1.415-1.414 3.507 3.507-1.414 1.414zM16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
Light24.displayName = 'Light24';
Light24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Light24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Light20 = React.forwardRef(function (_ref1000, ref) {
  var className = _ref1000.className,
      children = _ref1000.children,
      style = _ref1000.style,
      tabIndex = _ref1000.tabIndex,
      rest = _objectWithoutProperties$2(_ref1000, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1000 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1000.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1000, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v4.96h-2zm6.687 6.89l3.507-3.506 1.414 1.414-3.507 3.507zM25.04 15H30v2h-4.96zm-3.347 8.104l1.414-1.414 3.507 3.507L25.2 26.61zM15 25.04h2V30h-2zm-9.604.162l3.508-3.507 1.414 1.414-3.507 3.507zM2 15h4.96v2H2zm3.39-8.197l1.415-1.414 3.507 3.507-1.414 1.414zM16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
Light20.displayName = 'Light20';
Light20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Light20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Link32 = React.forwardRef(function (_ref1001, ref) {
  var className = _ref1001.className,
      children = _ref1001.children,
      style = _ref1001.style,
      tabIndex = _ref1001.tabIndex,
      rest = _objectWithoutProperties$2(_ref1001, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1001 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1001.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1001, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.25 6.76a6 6 0 0 0-8.5 0l1.42 1.42a4 4 0 1 1 5.67 5.67l-8 8a4 4 0 1 1-5.67-5.66l1.41-1.42-1.41-1.42-1.42 1.42a6 6 0 0 0 0 8.5A6 6 0 0 0 17 25a6 6 0 0 0 4.27-1.76l8-8a6 6 0 0 0-.02-8.48z'
  }), React.createElement('path', {
    d: 'M4.19 24.82a4 4 0 0 1 0-5.67l8-8a4 4 0 0 1 5.67 0A3.94 3.94 0 0 1 19 14a4 4 0 0 1-1.17 2.85L15.71 19l1.42 1.42 2.12-2.12a6 6 0 0 0-8.51-8.51l-8 8a6 6 0 0 0 0 8.51A6 6 0 0 0 7 28a6.07 6.07 0 0 0 4.28-1.76l-1.42-1.42a4 4 0 0 1-5.67 0z'
  }));
});
Link32.displayName = 'Link32';
Link32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Link32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Link24 = React.forwardRef(function (_ref1002, ref) {
  var className = _ref1002.className,
      children = _ref1002.children,
      style = _ref1002.style,
      tabIndex = _ref1002.tabIndex,
      rest = _objectWithoutProperties$2(_ref1002, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1002 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1002.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1002, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.25 6.76a6 6 0 0 0-8.5 0l1.42 1.42a4 4 0 1 1 5.67 5.67l-8 8a4 4 0 1 1-5.67-5.66l1.41-1.42-1.41-1.42-1.42 1.42a6 6 0 0 0 0 8.5A6 6 0 0 0 17 25a6 6 0 0 0 4.27-1.76l8-8a6 6 0 0 0-.02-8.48z'
  }), React.createElement('path', {
    d: 'M4.19 24.82a4 4 0 0 1 0-5.67l8-8a4 4 0 0 1 5.67 0A3.94 3.94 0 0 1 19 14a4 4 0 0 1-1.17 2.85L15.71 19l1.42 1.42 2.12-2.12a6 6 0 0 0-8.51-8.51l-8 8a6 6 0 0 0 0 8.51A6 6 0 0 0 7 28a6.07 6.07 0 0 0 4.28-1.76l-1.42-1.42a4 4 0 0 1-5.67 0z'
  }));
});
Link24.displayName = 'Link24';
Link24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Link24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Link20 = React.forwardRef(function (_ref1003, ref) {
  var className = _ref1003.className,
      children = _ref1003.children,
      style = _ref1003.style,
      tabIndex = _ref1003.tabIndex,
      rest = _objectWithoutProperties$2(_ref1003, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1003 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1003.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1003, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.25 6.76a6 6 0 0 0-8.5 0l1.42 1.42a4 4 0 1 1 5.67 5.67l-8 8a4 4 0 1 1-5.67-5.66l1.41-1.42-1.41-1.42-1.42 1.42a6 6 0 0 0 0 8.5A6 6 0 0 0 17 25a6 6 0 0 0 4.27-1.76l8-8a6 6 0 0 0-.02-8.48z'
  }), React.createElement('path', {
    d: 'M4.19 24.82a4 4 0 0 1 0-5.67l8-8a4 4 0 0 1 5.67 0A3.94 3.94 0 0 1 19 14a4 4 0 0 1-1.17 2.85L15.71 19l1.42 1.42 2.12-2.12a6 6 0 0 0-8.51-8.51l-8 8a6 6 0 0 0 0 8.51A6 6 0 0 0 7 28a6.07 6.07 0 0 0 4.28-1.76l-1.42-1.42a4 4 0 0 1-5.67 0z'
  }));
});
Link20.displayName = 'Link20';
Link20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Link20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListBulleted32 = React.forwardRef(function (_ref1004, ref) {
  var className = _ref1004.className,
      children = _ref1004.children,
      style = _ref1004.style,
      tabIndex = _ref1004.tabIndex,
      rest = _objectWithoutProperties$2(_ref1004, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1004 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1004.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1004, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '7',
    cy: '9',
    r: '3'
  }), React.createElement('circle', {
    cx: '7',
    cy: '23',
    r: '3'
  }), React.createElement('path', {
    d: 'M16 22h14v2H16zm0-14h14v2H16z'
  }));
});
ListBulleted32.displayName = 'ListBulleted32';
ListBulleted32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListBulleted32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListBulleted24 = React.forwardRef(function (_ref1005, ref) {
  var className = _ref1005.className,
      children = _ref1005.children,
      style = _ref1005.style,
      tabIndex = _ref1005.tabIndex,
      rest = _objectWithoutProperties$2(_ref1005, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1005 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1005.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1005, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '7',
    cy: '9',
    r: '3'
  }), React.createElement('circle', {
    cx: '7',
    cy: '23',
    r: '3'
  }), React.createElement('path', {
    d: 'M16 22h14v2H16zm0-14h14v2H16z'
  }));
});
ListBulleted24.displayName = 'ListBulleted24';
ListBulleted24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListBulleted24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListBulleted20 = React.forwardRef(function (_ref1006, ref) {
  var className = _ref1006.className,
      children = _ref1006.children,
      style = _ref1006.style,
      tabIndex = _ref1006.tabIndex,
      rest = _objectWithoutProperties$2(_ref1006, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1006 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1006.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1006, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '7',
    cy: '9',
    r: '3'
  }), React.createElement('circle', {
    cx: '7',
    cy: '23',
    r: '3'
  }), React.createElement('path', {
    d: 'M16 22h14v2H16zm0-14h14v2H16z'
  }));
});
ListBulleted20.displayName = 'ListBulleted20';
ListBulleted20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListBulleted20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListChecked32 = React.forwardRef(function (_ref1007, ref) {
  var className = _ref1007.className,
      children = _ref1007.children,
      style = _ref1007.style,
      tabIndex = _ref1007.tabIndex,
      rest = _objectWithoutProperties$2(_ref1007, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1007 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1007.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1007, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 8h14v2H16zM6 10.59L3.41 8 2 9.41l4 4 8-8L12.59 4 6 10.59zM16 22h14v2H16zM6 24.59L3.41 22 2 23.41l4 4 8-8L12.59 18 6 24.59z'
  }));
});
ListChecked32.displayName = 'ListChecked32';
ListChecked32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListChecked32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListChecked24 = React.forwardRef(function (_ref1008, ref) {
  var className = _ref1008.className,
      children = _ref1008.children,
      style = _ref1008.style,
      tabIndex = _ref1008.tabIndex,
      rest = _objectWithoutProperties$2(_ref1008, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1008 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1008.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1008, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 8h14v2H16zM6 10.59L3.41 8 2 9.41l4 4 8-8L12.59 4 6 10.59zM16 22h14v2H16zM6 24.59L3.41 22 2 23.41l4 4 8-8L12.59 18 6 24.59z'
  }));
});
ListChecked24.displayName = 'ListChecked24';
ListChecked24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListChecked24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListChecked20 = React.forwardRef(function (_ref1009, ref) {
  var className = _ref1009.className,
      children = _ref1009.children,
      style = _ref1009.style,
      tabIndex = _ref1009.tabIndex,
      rest = _objectWithoutProperties$2(_ref1009, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1009 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1009.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1009, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 8h14v2H16zM6 10.59L3.41 8 2 9.41l4 4 8-8L12.59 4 6 10.59zM16 22h14v2H16zM6 24.59L3.41 22 2 23.41l4 4 8-8L12.59 18 6 24.59z'
  }));
});
ListChecked20.displayName = 'ListChecked20';
ListChecked20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListChecked20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListDropdown32 = React.forwardRef(function (_ref1010, ref) {
  var className = _ref1010.className,
      children = _ref1010.children,
      style = _ref1010.style,
      tabIndex = _ref1010.tabIndex,
      rest = _objectWithoutProperties$2(_ref1010, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1010 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1010.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1010, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6V2H2v10h9v18h19V6zM4 10V4h20v2H11v4zm24 18H13V8h15z'
  }), React.createElement('path', {
    d: 'M15 11h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7z'
  }));
});
ListDropdown32.displayName = 'ListDropdown32';
ListDropdown32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListDropdown32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListDropdown24 = React.forwardRef(function (_ref1011, ref) {
  var className = _ref1011.className,
      children = _ref1011.children,
      style = _ref1011.style,
      tabIndex = _ref1011.tabIndex,
      rest = _objectWithoutProperties$2(_ref1011, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1011 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1011.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1011, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6V2H2v10h9v18h19V6zM4 10V4h20v2H11v4zm24 18H13V8h15z'
  }), React.createElement('path', {
    d: 'M15 11h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7z'
  }));
});
ListDropdown24.displayName = 'ListDropdown24';
ListDropdown24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListDropdown24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListDropdown20 = React.forwardRef(function (_ref1012, ref) {
  var className = _ref1012.className,
      children = _ref1012.children,
      style = _ref1012.style,
      tabIndex = _ref1012.tabIndex,
      rest = _objectWithoutProperties$2(_ref1012, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1012 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1012.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1012, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6V2H2v10h9v18h19V6zM4 10V4h20v2H11v4zm24 18H13V8h15z'
  }), React.createElement('path', {
    d: 'M15 11h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7z'
  }));
});
ListDropdown20.displayName = 'ListDropdown20';
ListDropdown20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListDropdown20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListNumbered32 = React.forwardRef(function (_ref1013, ref) {
  var className = _ref1013.className,
      children = _ref1013.children,
      style = _ref1013.style,
      tabIndex = _ref1013.tabIndex,
      rest = _objectWithoutProperties$2(_ref1013, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1013 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1013.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1013, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22h14v2H16zm0-14h14v2H16zm-8 4V4H6v1H4v2h2v5H4v2h6v-2H8zm2 16H4v-4a2 2 0 0 1 2-2h2v-2H4v-2h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6v2h4z'
  }));
});
ListNumbered32.displayName = 'ListNumbered32';
ListNumbered32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListNumbered32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListNumbered24 = React.forwardRef(function (_ref1014, ref) {
  var className = _ref1014.className,
      children = _ref1014.children,
      style = _ref1014.style,
      tabIndex = _ref1014.tabIndex,
      rest = _objectWithoutProperties$2(_ref1014, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1014 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1014.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1014, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22h14v2H16zm0-14h14v2H16zm-8 4V4H6v1H4v2h2v5H4v2h6v-2H8zm2 16H4v-4a2 2 0 0 1 2-2h2v-2H4v-2h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6v2h4z'
  }));
});
ListNumbered24.displayName = 'ListNumbered24';
ListNumbered24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListNumbered24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ListNumbered20 = React.forwardRef(function (_ref1015, ref) {
  var className = _ref1015.className,
      children = _ref1015.children,
      style = _ref1015.style,
      tabIndex = _ref1015.tabIndex,
      rest = _objectWithoutProperties$2(_ref1015, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1015 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1015.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1015, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22h14v2H16zm0-14h14v2H16zm-8 4V4H6v1H4v2h2v5H4v2h6v-2H8zm2 16H4v-4a2 2 0 0 1 2-2h2v-2H4v-2h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6v2h4z'
  }));
});
ListNumbered20.displayName = 'ListNumbered20';
ListNumbered20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ListNumbered20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var List32 = React.forwardRef(function (_ref1016, ref) {
  var className = _ref1016.className,
      children = _ref1016.children,
      style = _ref1016.style,
      tabIndex = _ref1016.tabIndex,
      rest = _objectWithoutProperties$2(_ref1016, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1016 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1016.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1016, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6h18v2H10zm0 18h18v2H10zm0-9h18v2H10zm-6 0h2v2H4zm0-9h2v2H4zm0 18h2v2H4z'
  }));
});
List32.displayName = 'List32';
List32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
List32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var List24 = React.forwardRef(function (_ref1017, ref) {
  var className = _ref1017.className,
      children = _ref1017.children,
      style = _ref1017.style,
      tabIndex = _ref1017.tabIndex,
      rest = _objectWithoutProperties$2(_ref1017, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1017 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1017.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1017, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6h18v2H10zm0 18h18v2H10zm0-9h18v2H10zm-6 0h2v2H4zm0-9h2v2H4zm0 18h2v2H4z'
  }));
});
List24.displayName = 'List24';
List24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
List24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var List20 = React.forwardRef(function (_ref1018, ref) {
  var className = _ref1018.className,
      children = _ref1018.children,
      style = _ref1018.style,
      tabIndex = _ref1018.tabIndex,
      rest = _objectWithoutProperties$2(_ref1018, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1018 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1018.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1018, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6h18v2H10zm0 18h18v2H10zm0-9h18v2H10zm-6 0h2v2H4zm0-9h2v2H4zm0 18h2v2H4z'
  }));
});
List20.displayName = 'List20';
List20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
List20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Location32 = React.forwardRef(function (_ref1019, ref) {
  var className = _ref1019.className,
      children = _ref1019.children,
      style = _ref1019.style,
      tabIndex = _ref1019.tabIndex,
      rest = _objectWithoutProperties$2(_ref1019, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1019 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1019.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1019, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z'
  }), React.createElement('path', {
    d: 'M16 4a8.88 8.88 0 0 1 9 8.71 8.47 8.47 0 0 1-1.79 5.21L16 28.46 8.85 18A8.47 8.47 0 0 1 7 12.71 8.88 8.88 0 0 1 16 4m0-2A10.86 10.86 0 0 0 5 12.71a10.53 10.53 0 0 0 2.2 6.43L16 32l8.8-12.86a10.53 10.53 0 0 0 2.2-6.43A10.86 10.86 0 0 0 16 2z'
  }));
});
Location32.displayName = 'Location32';
Location32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Location32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Location24 = React.forwardRef(function (_ref1020, ref) {
  var className = _ref1020.className,
      children = _ref1020.children,
      style = _ref1020.style,
      tabIndex = _ref1020.tabIndex,
      rest = _objectWithoutProperties$2(_ref1020, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1020 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1020.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1020, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z'
  }), React.createElement('path', {
    d: 'M16 4a8.88 8.88 0 0 1 9 8.71 8.47 8.47 0 0 1-1.79 5.21L16 28.46 8.85 18A8.47 8.47 0 0 1 7 12.71 8.88 8.88 0 0 1 16 4m0-2A10.86 10.86 0 0 0 5 12.71a10.53 10.53 0 0 0 2.2 6.43L16 32l8.8-12.86a10.53 10.53 0 0 0 2.2-6.43A10.86 10.86 0 0 0 16 2z'
  }));
});
Location24.displayName = 'Location24';
Location24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Location24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Location20 = React.forwardRef(function (_ref1021, ref) {
  var className = _ref1021.className,
      children = _ref1021.children,
      style = _ref1021.style,
      tabIndex = _ref1021.tabIndex,
      rest = _objectWithoutProperties$2(_ref1021, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1021 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1021.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1021, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 10a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5z'
  }), React.createElement('path', {
    d: 'M16 4a8.88 8.88 0 0 1 9 8.71 8.47 8.47 0 0 1-1.79 5.21L16 28.46 8.85 18A8.47 8.47 0 0 1 7 12.71 8.88 8.88 0 0 1 16 4m0-2A10.86 10.86 0 0 0 5 12.71a10.53 10.53 0 0 0 2.2 6.43L16 32l8.8-12.86a10.53 10.53 0 0 0 2.2-6.43A10.86 10.86 0 0 0 16 2z'
  }));
});
Location20.displayName = 'Location20';
Location20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Location20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Locked32 = React.forwardRef(function (_ref1022, ref) {
  var className = _ref1022.className,
      children = _ref1022.children,
      style = _ref1022.style,
      tabIndex = _ref1022.tabIndex,
      rest = _objectWithoutProperties$2(_ref1022, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1022 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1022.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1022, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 14h-2V8a6 6 0 0 0-12 0v6H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zM12 8a4 4 0 0 1 8 0v6h-8zm12 20H8V16h16z'
  }));
});
Locked32.displayName = 'Locked32';
Locked32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Locked32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Locked24 = React.forwardRef(function (_ref1023, ref) {
  var className = _ref1023.className,
      children = _ref1023.children,
      style = _ref1023.style,
      tabIndex = _ref1023.tabIndex,
      rest = _objectWithoutProperties$2(_ref1023, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1023 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1023.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1023, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 14h-2V8a6 6 0 0 0-12 0v6H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zM12 8a4 4 0 0 1 8 0v6h-8zm12 20H8V16h16z'
  }));
});
Locked24.displayName = 'Locked24';
Locked24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Locked24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Locked20 = React.forwardRef(function (_ref1024, ref) {
  var className = _ref1024.className,
      children = _ref1024.children,
      style = _ref1024.style,
      tabIndex = _ref1024.tabIndex,
      rest = _objectWithoutProperties$2(_ref1024, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1024 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1024.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1024, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 14h-2V8a6 6 0 0 0-12 0v6H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zM12 8a4 4 0 0 1 8 0v6h-8zm12 20H8V16h16z'
  }));
});
Locked20.displayName = 'Locked20';
Locked20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Locked20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoDelicious32 = React.forwardRef(function (_ref1025, ref) {
  var className = _ref1025.className,
      children = _ref1025.children,
      style = _ref1025.style,
      tabIndex = _ref1025.tabIndex,
      rest = _objectWithoutProperties$2(_ref1025, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1025 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1025.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1025, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 16h12v12H4zM16 4h12v12H16z'
  }));
});
LogoDelicious32.displayName = 'LogoDelicious32';
LogoDelicious32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoDelicious32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoDelicious24 = React.forwardRef(function (_ref1026, ref) {
  var className = _ref1026.className,
      children = _ref1026.children,
      style = _ref1026.style,
      tabIndex = _ref1026.tabIndex,
      rest = _objectWithoutProperties$2(_ref1026, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1026 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1026.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1026, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 16h12v12H4zM16 4h12v12H16z'
  }));
});
LogoDelicious24.displayName = 'LogoDelicious24';
LogoDelicious24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoDelicious24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoDelicious20 = React.forwardRef(function (_ref1027, ref) {
  var className = _ref1027.className,
      children = _ref1027.children,
      style = _ref1027.style,
      tabIndex = _ref1027.tabIndex,
      rest = _objectWithoutProperties$2(_ref1027, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1027 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1027.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1027, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 16h12v12H4zM16 4h12v12H16z'
  }));
});
LogoDelicious20.displayName = 'LogoDelicious20';
LogoDelicious20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoDelicious20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoDigg32 = React.forwardRef(function (_ref1028, ref) {
  var className = _ref1028.className,
      children = _ref1028.children,
      style = _ref1028.style,
      tabIndex = _ref1028.tabIndex,
      rest = _objectWithoutProperties$2(_ref1028, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1028 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1028.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1028, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6.48 7.6v3.92H2V21h7.28V7.6zm0 11.2H4.8v-5h1.68zm3.92-7.28h2.8v9.52h-2.8zm0-3.92h2.8v2.8h-2.8zm3.92 3.92V21h4.48v1.12h-4.48v2.28h7.28V11.52zm4.48 7.28h-1.68v-5h1.68zm3.92-7.28V21h4.48v1.12h-4.48v2.28H30V11.52zm4.48 7.28h-1.68v-5h1.68z'
  }));
});
LogoDigg32.displayName = 'LogoDigg32';
LogoDigg32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoDigg32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoDigg24 = React.forwardRef(function (_ref1029, ref) {
  var className = _ref1029.className,
      children = _ref1029.children,
      style = _ref1029.style,
      tabIndex = _ref1029.tabIndex,
      rest = _objectWithoutProperties$2(_ref1029, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1029 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1029.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1029, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6.48 7.6v3.92H2V21h7.28V7.6zm0 11.2H4.8v-5h1.68zm3.92-7.28h2.8v9.52h-2.8zm0-3.92h2.8v2.8h-2.8zm3.92 3.92V21h4.48v1.12h-4.48v2.28h7.28V11.52zm4.48 7.28h-1.68v-5h1.68zm3.92-7.28V21h4.48v1.12h-4.48v2.28H30V11.52zm4.48 7.28h-1.68v-5h1.68z'
  }));
});
LogoDigg24.displayName = 'LogoDigg24';
LogoDigg24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoDigg24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoDigg20 = React.forwardRef(function (_ref1030, ref) {
  var className = _ref1030.className,
      children = _ref1030.children,
      style = _ref1030.style,
      tabIndex = _ref1030.tabIndex,
      rest = _objectWithoutProperties$2(_ref1030, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1030 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1030.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1030, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6.48 7.6v3.92H2V21h7.28V7.6zm0 11.2H4.8v-5h1.68zm3.92-7.28h2.8v9.52h-2.8zm0-3.92h2.8v2.8h-2.8zm3.92 3.92V21h4.48v1.12h-4.48v2.28h7.28V11.52zm4.48 7.28h-1.68v-5h1.68zm3.92-7.28V21h4.48v1.12h-4.48v2.28H30V11.52zm4.48 7.28h-1.68v-5h1.68z'
  }));
});
LogoDigg20.displayName = 'LogoDigg20';
LogoDigg20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoDigg20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoFacebook32 = React.forwardRef(function (_ref1031, ref) {
  var className = _ref1031.className,
      children = _ref1031.children,
      style = _ref1031.style,
      tabIndex = _ref1031.tabIndex,
      rest = _objectWithoutProperties$2(_ref1031, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1031 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1031.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1031, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.67 4H5.33A1.34 1.34 0 0 0 4 5.33v21.34A1.34 1.34 0 0 0 5.33 28h11.49v-9.28H13.7v-3.63h3.12v-2.67c0-3.1 1.89-4.79 4.67-4.79.93 0 1.86 0 2.79.14V11h-1.91c-1.51 0-1.8.72-1.8 1.77v2.31h3.6l-.47 3.63h-3.13V28h6.1A1.34 1.34 0 0 0 28 26.67V5.33A1.34 1.34 0 0 0 26.67 4z'
  }));
});
LogoFacebook32.displayName = 'LogoFacebook32';
LogoFacebook32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoFacebook32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoFacebook24 = React.forwardRef(function (_ref1032, ref) {
  var className = _ref1032.className,
      children = _ref1032.children,
      style = _ref1032.style,
      tabIndex = _ref1032.tabIndex,
      rest = _objectWithoutProperties$2(_ref1032, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1032 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1032.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1032, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.67 4H5.33A1.34 1.34 0 0 0 4 5.33v21.34A1.34 1.34 0 0 0 5.33 28h11.49v-9.28H13.7v-3.63h3.12v-2.67c0-3.1 1.89-4.79 4.67-4.79.93 0 1.86 0 2.79.14V11h-1.91c-1.51 0-1.8.72-1.8 1.77v2.31h3.6l-.47 3.63h-3.13V28h6.1A1.34 1.34 0 0 0 28 26.67V5.33A1.34 1.34 0 0 0 26.67 4z'
  }));
});
LogoFacebook24.displayName = 'LogoFacebook24';
LogoFacebook24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoFacebook24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoFacebook20 = React.forwardRef(function (_ref1033, ref) {
  var className = _ref1033.className,
      children = _ref1033.children,
      style = _ref1033.style,
      tabIndex = _ref1033.tabIndex,
      rest = _objectWithoutProperties$2(_ref1033, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1033 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1033.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1033, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.67 4H5.33A1.34 1.34 0 0 0 4 5.33v21.34A1.34 1.34 0 0 0 5.33 28h11.49v-9.28H13.7v-3.63h3.12v-2.67c0-3.1 1.89-4.79 4.67-4.79.93 0 1.86 0 2.79.14V11h-1.91c-1.51 0-1.8.72-1.8 1.77v2.31h3.6l-.47 3.63h-3.13V28h6.1A1.34 1.34 0 0 0 28 26.67V5.33A1.34 1.34 0 0 0 26.67 4z'
  }));
});
LogoFacebook20.displayName = 'LogoFacebook20';
LogoFacebook20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoFacebook20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoFlickr32 = React.forwardRef(function (_ref1034, ref) {
  var className = _ref1034.className,
      children = _ref1034.children,
      style = _ref1034.style,
      tabIndex = _ref1034.tabIndex,
      rest = _objectWithoutProperties$2(_ref1034, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1034 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1034.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1034, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '8',
    cy: '16',
    r: '6'
  }), React.createElement('circle', {
    cx: '24',
    cy: '16',
    r: '6'
  }));
});
LogoFlickr32.displayName = 'LogoFlickr32';
LogoFlickr32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoFlickr32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoFlickr24 = React.forwardRef(function (_ref1035, ref) {
  var className = _ref1035.className,
      children = _ref1035.children,
      style = _ref1035.style,
      tabIndex = _ref1035.tabIndex,
      rest = _objectWithoutProperties$2(_ref1035, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1035 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1035.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1035, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '8',
    cy: '16',
    r: '6'
  }), React.createElement('circle', {
    cx: '24',
    cy: '16',
    r: '6'
  }));
});
LogoFlickr24.displayName = 'LogoFlickr24';
LogoFlickr24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoFlickr24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoFlickr20 = React.forwardRef(function (_ref1036, ref) {
  var className = _ref1036.className,
      children = _ref1036.children,
      style = _ref1036.style,
      tabIndex = _ref1036.tabIndex,
      rest = _objectWithoutProperties$2(_ref1036, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1036 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1036.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1036, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '8',
    cy: '16',
    r: '6'
  }), React.createElement('circle', {
    cx: '24',
    cy: '16',
    r: '6'
  }));
});
LogoFlickr20.displayName = 'LogoFlickr20';
LogoFlickr20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoFlickr20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoGithub32 = React.forwardRef(function (_ref1037, ref) {
  var className = _ref1037.className,
      children = _ref1037.children,
      style = _ref1037.style,
      tabIndex = _ref1037.tabIndex,
      rest = _objectWithoutProperties$2(_ref1037, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1037 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1037.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1037, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    fillRule: 'evenodd',
    d: 'M16 2a14 14 0 0 0-4.43 27.28c.7.13 1-.3 1-.67v-2.38c-3.89.84-4.71-1.88-4.71-1.88a3.71 3.71 0 0 0-1.62-2.05c-1.27-.86.1-.85.1-.85a2.94 2.94 0 0 1 2.14 1.45 3 3 0 0 0 4.08 1.16 2.93 2.93 0 0 1 .88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4 5.4 0 0 1 1.44-3.76 5 5 0 0 1 .14-3.7s1.17-.38 3.85 1.43a13.3 13.3 0 0 1 7 0c2.67-1.81 3.84-1.43 3.84-1.43a5 5 0 0 1 .14 3.7 5.4 5.4 0 0 1 1.44 3.76c0 5.38-3.27 6.56-6.39 6.91a3.33 3.33 0 0 1 .95 2.59v3.84c0 .46.25.81 1 .67A14 14 0 0 0 16 2z'
  }));
});
LogoGithub32.displayName = 'LogoGithub32';
LogoGithub32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoGithub32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoGithub24 = React.forwardRef(function (_ref1038, ref) {
  var className = _ref1038.className,
      children = _ref1038.children,
      style = _ref1038.style,
      tabIndex = _ref1038.tabIndex,
      rest = _objectWithoutProperties$2(_ref1038, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1038 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1038.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1038, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    fillRule: 'evenodd',
    d: 'M16 2a14 14 0 0 0-4.43 27.28c.7.13 1-.3 1-.67v-2.38c-3.89.84-4.71-1.88-4.71-1.88a3.71 3.71 0 0 0-1.62-2.05c-1.27-.86.1-.85.1-.85a2.94 2.94 0 0 1 2.14 1.45 3 3 0 0 0 4.08 1.16 2.93 2.93 0 0 1 .88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4 5.4 0 0 1 1.44-3.76 5 5 0 0 1 .14-3.7s1.17-.38 3.85 1.43a13.3 13.3 0 0 1 7 0c2.67-1.81 3.84-1.43 3.84-1.43a5 5 0 0 1 .14 3.7 5.4 5.4 0 0 1 1.44 3.76c0 5.38-3.27 6.56-6.39 6.91a3.33 3.33 0 0 1 .95 2.59v3.84c0 .46.25.81 1 .67A14 14 0 0 0 16 2z'
  }));
});
LogoGithub24.displayName = 'LogoGithub24';
LogoGithub24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoGithub24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoGithub20 = React.forwardRef(function (_ref1039, ref) {
  var className = _ref1039.className,
      children = _ref1039.children,
      style = _ref1039.style,
      tabIndex = _ref1039.tabIndex,
      rest = _objectWithoutProperties$2(_ref1039, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1039 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1039.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1039, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    fillRule: 'evenodd',
    d: 'M16 2a14 14 0 0 0-4.43 27.28c.7.13 1-.3 1-.67v-2.38c-3.89.84-4.71-1.88-4.71-1.88a3.71 3.71 0 0 0-1.62-2.05c-1.27-.86.1-.85.1-.85a2.94 2.94 0 0 1 2.14 1.45 3 3 0 0 0 4.08 1.16 2.93 2.93 0 0 1 .88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4 5.4 0 0 1 1.44-3.76 5 5 0 0 1 .14-3.7s1.17-.38 3.85 1.43a13.3 13.3 0 0 1 7 0c2.67-1.81 3.84-1.43 3.84-1.43a5 5 0 0 1 .14 3.7 5.4 5.4 0 0 1 1.44 3.76c0 5.38-3.27 6.56-6.39 6.91a3.33 3.33 0 0 1 .95 2.59v3.84c0 .46.25.81 1 .67A14 14 0 0 0 16 2z'
  }));
});
LogoGithub20.displayName = 'LogoGithub20';
LogoGithub20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoGithub20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoGoogle32 = React.forwardRef(function (_ref1040, ref) {
  var className = _ref1040.className,
      children = _ref1040.children,
      style = _ref1040.style,
      tabIndex = _ref1040.tabIndex,
      rest = _objectWithoutProperties$2(_ref1040, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1040 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1040.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1040, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.39 13.82H16.21v4.63h6.44c-.6 2.95-3.11 4.64-6.44 4.64a7.09 7.09 0 0 1 0-14.18 7 7 0 0 1 4.42 1.58L24.12 7a12 12 0 1 0-7.91 21c6 0 11.45-4.36 11.45-12a9.56 9.56 0 0 0-.27-2.18z'
  }));
});
LogoGoogle32.displayName = 'LogoGoogle32';
LogoGoogle32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoGoogle32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoGoogle24 = React.forwardRef(function (_ref1041, ref) {
  var className = _ref1041.className,
      children = _ref1041.children,
      style = _ref1041.style,
      tabIndex = _ref1041.tabIndex,
      rest = _objectWithoutProperties$2(_ref1041, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1041 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1041.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1041, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.39 13.82H16.21v4.63h6.44c-.6 2.95-3.11 4.64-6.44 4.64a7.09 7.09 0 0 1 0-14.18 7 7 0 0 1 4.42 1.58L24.12 7a12 12 0 1 0-7.91 21c6 0 11.45-4.36 11.45-12a9.56 9.56 0 0 0-.27-2.18z'
  }));
});
LogoGoogle24.displayName = 'LogoGoogle24';
LogoGoogle24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoGoogle24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoGoogle20 = React.forwardRef(function (_ref1042, ref) {
  var className = _ref1042.className,
      children = _ref1042.children,
      style = _ref1042.style,
      tabIndex = _ref1042.tabIndex,
      rest = _objectWithoutProperties$2(_ref1042, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1042 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1042.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1042, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.39 13.82H16.21v4.63h6.44c-.6 2.95-3.11 4.64-6.44 4.64a7.09 7.09 0 0 1 0-14.18 7 7 0 0 1 4.42 1.58L24.12 7a12 12 0 1 0-7.91 21c6 0 11.45-4.36 11.45-12a9.56 9.56 0 0 0-.27-2.18z'
  }));
});
LogoGoogle20.displayName = 'LogoGoogle20';
LogoGoogle20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoGoogle20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoLinkedin32 = React.forwardRef(function (_ref1043, ref) {
  var className = _ref1043.className,
      children = _ref1043.children,
      style = _ref1043.style,
      tabIndex = _ref1043.tabIndex,
      rest = _objectWithoutProperties$2(_ref1043, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1043 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1043.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1043, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.21 4H5.79A1.78 1.78 0 0 0 4 5.73V26.2a1.77 1.77 0 0 0 1.79 1.73h20.42A1.77 1.77 0 0 0 28 26.2V5.73A1.78 1.78 0 0 0 26.21 4zm-15.1 20.41H7.59V13h3.52zm-1.72-13a2.07 2.07 0 0 1-2.07-2.02 2 2 0 0 1 2.07-2.07 2.07 2.07 0 0 1 0 4.13zm15.09 12.93H21v-5.58c0-1.33 0-3.06-1.86-3.06S17 17.16 17 18.63v5.65h-3.56V13h3.32v1.5h.07a3.72 3.72 0 0 1 3.39-1.86c3.59 0 4.26 2.4 4.26 5.45z'
  }));
});
LogoLinkedin32.displayName = 'LogoLinkedin32';
LogoLinkedin32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoLinkedin32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoLinkedin24 = React.forwardRef(function (_ref1044, ref) {
  var className = _ref1044.className,
      children = _ref1044.children,
      style = _ref1044.style,
      tabIndex = _ref1044.tabIndex,
      rest = _objectWithoutProperties$2(_ref1044, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1044 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1044.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1044, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.21 4H5.79A1.78 1.78 0 0 0 4 5.73V26.2a1.77 1.77 0 0 0 1.79 1.73h20.42A1.77 1.77 0 0 0 28 26.2V5.73A1.78 1.78 0 0 0 26.21 4zm-15.1 20.41H7.59V13h3.52zm-1.72-13a2.07 2.07 0 0 1-2.07-2.02 2 2 0 0 1 2.07-2.07 2.07 2.07 0 0 1 0 4.13zm15.09 12.93H21v-5.58c0-1.33 0-3.06-1.86-3.06S17 17.16 17 18.63v5.65h-3.56V13h3.32v1.5h.07a3.72 3.72 0 0 1 3.39-1.86c3.59 0 4.26 2.4 4.26 5.45z'
  }));
});
LogoLinkedin24.displayName = 'LogoLinkedin24';
LogoLinkedin24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoLinkedin24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoLinkedin20 = React.forwardRef(function (_ref1045, ref) {
  var className = _ref1045.className,
      children = _ref1045.children,
      style = _ref1045.style,
      tabIndex = _ref1045.tabIndex,
      rest = _objectWithoutProperties$2(_ref1045, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1045 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1045.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1045, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.21 4H5.79A1.78 1.78 0 0 0 4 5.73V26.2a1.77 1.77 0 0 0 1.79 1.73h20.42A1.77 1.77 0 0 0 28 26.2V5.73A1.78 1.78 0 0 0 26.21 4zm-15.1 20.41H7.59V13h3.52zm-1.72-13a2.07 2.07 0 0 1-2.07-2.02 2 2 0 0 1 2.07-2.07 2.07 2.07 0 0 1 0 4.13zm15.09 12.93H21v-5.58c0-1.33 0-3.06-1.86-3.06S17 17.16 17 18.63v5.65h-3.56V13h3.32v1.5h.07a3.72 3.72 0 0 1 3.39-1.86c3.59 0 4.26 2.4 4.26 5.45z'
  }));
});
LogoLinkedin20.displayName = 'LogoLinkedin20';
LogoLinkedin20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoLinkedin20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoLivestream32 = React.forwardRef(function (_ref1046, ref) {
  var className = _ref1046.className,
      children = _ref1046.children,
      style = _ref1046.style,
      tabIndex = _ref1046.tabIndex,
      rest = _objectWithoutProperties$2(_ref1046, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1046 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1046.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1046, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.49 23.71h-7.54a3.12 3.12 0 0 1-2.41-1A14.91 14.91 0 0 1 10 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 0 0 2 5.6h3.57a45.63 45.63 0 0 1 7 .61 8.09 8.09 0 0 1 6.34 5.09 48.51 48.51 0 0 1 2.17 7.36 26 26 0 0 0 1.41 5.05zm5.61 2.67a2.93 2.93 0 0 1-2.74-2.64 42.08 42.08 0 0 1-.14-4.9 48 48 0 0 0-.61-7.58 3.75 3.75 0 0 0-.83-2h2.65c.54 0 .73.37.89.78a12.1 12.1 0 0 1 .68 3.24c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 0 0 0 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69a8.62 8.62 0 0 1-1.9.06z'
  }));
});
LogoLivestream32.displayName = 'LogoLivestream32';
LogoLivestream32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoLivestream32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoLivestream24 = React.forwardRef(function (_ref1047, ref) {
  var className = _ref1047.className,
      children = _ref1047.children,
      style = _ref1047.style,
      tabIndex = _ref1047.tabIndex,
      rest = _objectWithoutProperties$2(_ref1047, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1047 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1047.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1047, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.49 23.71h-7.54a3.12 3.12 0 0 1-2.41-1A14.91 14.91 0 0 1 10 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 0 0 2 5.6h3.57a45.63 45.63 0 0 1 7 .61 8.09 8.09 0 0 1 6.34 5.09 48.51 48.51 0 0 1 2.17 7.36 26 26 0 0 0 1.41 5.05zm5.61 2.67a2.93 2.93 0 0 1-2.74-2.64 42.08 42.08 0 0 1-.14-4.9 48 48 0 0 0-.61-7.58 3.75 3.75 0 0 0-.83-2h2.65c.54 0 .73.37.89.78a12.1 12.1 0 0 1 .68 3.24c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 0 0 0 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69a8.62 8.62 0 0 1-1.9.06z'
  }));
});
LogoLivestream24.displayName = 'LogoLivestream24';
LogoLivestream24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoLivestream24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoLivestream20 = React.forwardRef(function (_ref1048, ref) {
  var className = _ref1048.className,
      children = _ref1048.children,
      style = _ref1048.style,
      tabIndex = _ref1048.tabIndex,
      rest = _objectWithoutProperties$2(_ref1048, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1048 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1048.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1048, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.49 23.71h-7.54a3.12 3.12 0 0 1-2.41-1A14.91 14.91 0 0 1 10 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 0 0 2 5.6h3.57a45.63 45.63 0 0 1 7 .61 8.09 8.09 0 0 1 6.34 5.09 48.51 48.51 0 0 1 2.17 7.36 26 26 0 0 0 1.41 5.05zm5.61 2.67a2.93 2.93 0 0 1-2.74-2.64 42.08 42.08 0 0 1-.14-4.9 48 48 0 0 0-.61-7.58 3.75 3.75 0 0 0-.83-2h2.65c.54 0 .73.37.89.78a12.1 12.1 0 0 1 .68 3.24c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 0 0 0 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69a8.62 8.62 0 0 1-1.9.06z'
  }));
});
LogoLivestream20.displayName = 'LogoLivestream20';
LogoLivestream20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoLivestream20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoPinterest32 = React.forwardRef(function (_ref1049, ref) {
  var className = _ref1049.className,
      children = _ref1049.children,
      style = _ref1049.style,
      tabIndex = _ref1049.tabIndex,
      rest = _objectWithoutProperties$2(_ref1049, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1049 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1049.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1049, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 0 0-5.1 27 13.24 13.24 0 0 1 0-4l1.65-7a5.05 5.05 0 0 1-.38-2c0-1.94 1.13-3.4 2.53-3.4a1.76 1.76 0 0 1 1.77 2c0 1.2-.76 3-1.16 4.66a2 2 0 0 0 2.08 2.53c2.48 0 4.4-2.63 4.4-6.41a5.53 5.53 0 0 0-5.85-5.7 6.06 6.06 0 0 0-6.32 6.08 5.42 5.42 0 0 0 1 3.19.44.44 0 0 1 .1.4c-.11.44-.35 1.4-.39 1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43 0-4.41 3.21-8.47 9.25-8.47 4.85 0 8.63 3.46 8.63 8.09 0 4.82-3 8.7-7.27 8.7a3.76 3.76 0 0 1-3.21-1.6l-.87 3.33a15.55 15.55 0 0 1-1.74 3.67A14.17 14.17 0 0 0 16 30a14 14 0 0 0 0-28'
  }));
});
LogoPinterest32.displayName = 'LogoPinterest32';
LogoPinterest32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoPinterest32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoPinterest24 = React.forwardRef(function (_ref1050, ref) {
  var className = _ref1050.className,
      children = _ref1050.children,
      style = _ref1050.style,
      tabIndex = _ref1050.tabIndex,
      rest = _objectWithoutProperties$2(_ref1050, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1050 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1050.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1050, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 0 0-5.1 27 13.24 13.24 0 0 1 0-4l1.65-7a5.05 5.05 0 0 1-.38-2c0-1.94 1.13-3.4 2.53-3.4a1.76 1.76 0 0 1 1.77 2c0 1.2-.76 3-1.16 4.66a2 2 0 0 0 2.08 2.53c2.48 0 4.4-2.63 4.4-6.41a5.53 5.53 0 0 0-5.85-5.7 6.06 6.06 0 0 0-6.32 6.08 5.42 5.42 0 0 0 1 3.19.44.44 0 0 1 .1.4c-.11.44-.35 1.4-.39 1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43 0-4.41 3.21-8.47 9.25-8.47 4.85 0 8.63 3.46 8.63 8.09 0 4.82-3 8.7-7.27 8.7a3.76 3.76 0 0 1-3.21-1.6l-.87 3.33a15.55 15.55 0 0 1-1.74 3.67A14.17 14.17 0 0 0 16 30a14 14 0 0 0 0-28'
  }));
});
LogoPinterest24.displayName = 'LogoPinterest24';
LogoPinterest24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoPinterest24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoPinterest20 = React.forwardRef(function (_ref1051, ref) {
  var className = _ref1051.className,
      children = _ref1051.children,
      style = _ref1051.style,
      tabIndex = _ref1051.tabIndex,
      rest = _objectWithoutProperties$2(_ref1051, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1051 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1051.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1051, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 0 0-5.1 27 13.24 13.24 0 0 1 0-4l1.65-7a5.05 5.05 0 0 1-.38-2c0-1.94 1.13-3.4 2.53-3.4a1.76 1.76 0 0 1 1.77 2c0 1.2-.76 3-1.16 4.66a2 2 0 0 0 2.08 2.53c2.48 0 4.4-2.63 4.4-6.41a5.53 5.53 0 0 0-5.85-5.7 6.06 6.06 0 0 0-6.32 6.08 5.42 5.42 0 0 0 1 3.19.44.44 0 0 1 .1.4c-.11.44-.35 1.4-.39 1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43 0-4.41 3.21-8.47 9.25-8.47 4.85 0 8.63 3.46 8.63 8.09 0 4.82-3 8.7-7.27 8.7a3.76 3.76 0 0 1-3.21-1.6l-.87 3.33a15.55 15.55 0 0 1-1.74 3.67A14.17 14.17 0 0 0 16 30a14 14 0 0 0 0-28'
  }));
});
LogoPinterest20.displayName = 'LogoPinterest20';
LogoPinterest20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoPinterest20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoQuora32 = React.forwardRef(function (_ref1052, ref) {
  var className = _ref1052.className,
      children = _ref1052.children,
      style = _ref1052.style,
      tabIndex = _ref1052.tabIndex,
      rest = _objectWithoutProperties$2(_ref1052, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1052 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1052.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1052, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 23.86h-2a1.72 1.72 0 0 1-1.73 1.72c-1.15 0-1.82-.86-2.58-2a11 11 0 0 0 4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3 7.37 3 14.37s6 11.79 12.17 11.79a10.71 10.71 0 0 0 3.07-.48c1.15 2.11 2.59 3.74 5.46 3.74a5 5 0 0 0 5.3-5.56zm-8.14-3.45a6.31 6.31 0 0 0-5.56-3.16 6 6 0 0 0-3.74 1.15l.64 1.6a2.56 2.56 0 0 1 .86-.1c1.82 0 3 1.53 4.12 3.64a7.58 7.58 0 0 1-1.91.19C10.86 23.76 9 20.6 9 14.47s1.91-9.3 6.23-9.3 6.32 3.16 6.32 9.3a20.68 20.68 0 0 1-.72 5.94z'
  }));
});
LogoQuora32.displayName = 'LogoQuora32';
LogoQuora32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoQuora32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoQuora24 = React.forwardRef(function (_ref1053, ref) {
  var className = _ref1053.className,
      children = _ref1053.children,
      style = _ref1053.style,
      tabIndex = _ref1053.tabIndex,
      rest = _objectWithoutProperties$2(_ref1053, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1053 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1053.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1053, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 23.86h-2a1.72 1.72 0 0 1-1.73 1.72c-1.15 0-1.82-.86-2.58-2a11 11 0 0 0 4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3 7.37 3 14.37s6 11.79 12.17 11.79a10.71 10.71 0 0 0 3.07-.48c1.15 2.11 2.59 3.74 5.46 3.74a5 5 0 0 0 5.3-5.56zm-8.14-3.45a6.31 6.31 0 0 0-5.56-3.16 6 6 0 0 0-3.74 1.15l.64 1.6a2.56 2.56 0 0 1 .86-.1c1.82 0 3 1.53 4.12 3.64a7.58 7.58 0 0 1-1.91.19C10.86 23.76 9 20.6 9 14.47s1.91-9.3 6.23-9.3 6.32 3.16 6.32 9.3a20.68 20.68 0 0 1-.72 5.94z'
  }));
});
LogoQuora24.displayName = 'LogoQuora24';
LogoQuora24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoQuora24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoQuora20 = React.forwardRef(function (_ref1054, ref) {
  var className = _ref1054.className,
      children = _ref1054.children,
      style = _ref1054.style,
      tabIndex = _ref1054.tabIndex,
      rest = _objectWithoutProperties$2(_ref1054, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1054 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1054.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1054, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 23.86h-2a1.72 1.72 0 0 1-1.73 1.72c-1.15 0-1.82-.86-2.58-2a11 11 0 0 0 4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3 7.37 3 14.37s6 11.79 12.17 11.79a10.71 10.71 0 0 0 3.07-.48c1.15 2.11 2.59 3.74 5.46 3.74a5 5 0 0 0 5.3-5.56zm-8.14-3.45a6.31 6.31 0 0 0-5.56-3.16 6 6 0 0 0-3.74 1.15l.64 1.6a2.56 2.56 0 0 1 .86-.1c1.82 0 3 1.53 4.12 3.64a7.58 7.58 0 0 1-1.91.19C10.86 23.76 9 20.6 9 14.47s1.91-9.3 6.23-9.3 6.32 3.16 6.32 9.3a20.68 20.68 0 0 1-.72 5.94z'
  }));
});
LogoQuora20.displayName = 'LogoQuora20';
LogoQuora20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoQuora20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSkype32 = React.forwardRef(function (_ref1055, ref) {
  var className = _ref1055.className,
      children = _ref1055.children,
      style = _ref1055.style,
      tabIndex = _ref1055.tabIndex,
      rest = _objectWithoutProperties$2(_ref1055, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1055 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1055.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1055, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.91 17.88a11.63 11.63 0 0 0 .15-1.88A12.06 12.06 0 0 0 16 3.94a11.63 11.63 0 0 0-1.88.15 7.29 7.29 0 0 0-10 10A11.63 11.63 0 0 0 3.94 16 12.06 12.06 0 0 0 16 28.06a11.63 11.63 0 0 0 1.88-.15 7.29 7.29 0 0 0 10-10zm-6.18 3.6a5 5 0 0 1-2.24 1.73 9 9 0 0 1-3.48.62A8.41 8.41 0 0 1 12 23a5.2 5.2 0 0 1-1.82-1.63 3.59 3.59 0 0 1-.7-2 1.36 1.36 0 0 1 .43-1A1.56 1.56 0 0 1 11 18a1.38 1.38 0 0 1 .91.32 2.5 2.5 0 0 1 .63.94 5.83 5.83 0 0 0 .66 1.18 2.61 2.61 0 0 0 1 .78 3.87 3.87 0 0 0 1.69.31 4 4 0 0 0 2.34-.62 1.8 1.8 0 0 0 .89-1.53 1.54 1.54 0 0 0-.47-1.17 3.09 3.09 0 0 0-1.25-.7c-.52-.17-1.21-.34-2.08-.53a16 16 0 0 1-2.91-.98 4.78 4.78 0 0 1-1.89-1.4 3.5 3.5 0 0 1-.7-2.21 3.65 3.65 0 0 1 .74-2.24 4.7 4.7 0 0 1 2.14-1.5 9.51 9.51 0 0 1 3.3-.48 8.63 8.63 0 0 1 2.59.35 5.81 5.81 0 0 1 1.83.92 3.91 3.91 0 0 1 1.06 1.21 2.62 2.62 0 0 1 .34 1.25 1.4 1.4 0 0 1-.43 1 1.43 1.43 0 0 1-1.07.46 1.25 1.25 0 0 1-.89-.28 3.36 3.36 0 0 1-.65-.87 3.79 3.79 0 0 0-1.05-1.31 3.13 3.13 0 0 0-1.95-.46 3.64 3.64 0 0 0-2 .5 1.44 1.44 0 0 0-.76 1.2 1.15 1.15 0 0 0 .25.75 2.21 2.21 0 0 0 .72.55 4.74 4.74 0 0 0 .92.36c.32.09.84.22 1.57.39.92.2 1.74.42 2.49.66a7.61 7.61 0 0 1 1.9.88 3.59 3.59 0 0 1 1.23 1.31 4 4 0 0 1 .4 1.96 4.24 4.24 0 0 1-.77 2.48z'
  }));
});
LogoSkype32.displayName = 'LogoSkype32';
LogoSkype32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSkype32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSkype24 = React.forwardRef(function (_ref1056, ref) {
  var className = _ref1056.className,
      children = _ref1056.children,
      style = _ref1056.style,
      tabIndex = _ref1056.tabIndex,
      rest = _objectWithoutProperties$2(_ref1056, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1056 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1056.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1056, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.91 17.88a11.63 11.63 0 0 0 .15-1.88A12.06 12.06 0 0 0 16 3.94a11.63 11.63 0 0 0-1.88.15 7.29 7.29 0 0 0-10 10A11.63 11.63 0 0 0 3.94 16 12.06 12.06 0 0 0 16 28.06a11.63 11.63 0 0 0 1.88-.15 7.29 7.29 0 0 0 10-10zm-6.18 3.6a5 5 0 0 1-2.24 1.73 9 9 0 0 1-3.48.62A8.41 8.41 0 0 1 12 23a5.2 5.2 0 0 1-1.82-1.63 3.59 3.59 0 0 1-.7-2 1.36 1.36 0 0 1 .43-1A1.56 1.56 0 0 1 11 18a1.38 1.38 0 0 1 .91.32 2.5 2.5 0 0 1 .63.94 5.83 5.83 0 0 0 .66 1.18 2.61 2.61 0 0 0 1 .78 3.87 3.87 0 0 0 1.69.31 4 4 0 0 0 2.34-.62 1.8 1.8 0 0 0 .89-1.53 1.54 1.54 0 0 0-.47-1.17 3.09 3.09 0 0 0-1.25-.7c-.52-.17-1.21-.34-2.08-.53a16 16 0 0 1-2.91-.98 4.78 4.78 0 0 1-1.89-1.4 3.5 3.5 0 0 1-.7-2.21 3.65 3.65 0 0 1 .74-2.24 4.7 4.7 0 0 1 2.14-1.5 9.51 9.51 0 0 1 3.3-.48 8.63 8.63 0 0 1 2.59.35 5.81 5.81 0 0 1 1.83.92 3.91 3.91 0 0 1 1.06 1.21 2.62 2.62 0 0 1 .34 1.25 1.4 1.4 0 0 1-.43 1 1.43 1.43 0 0 1-1.07.46 1.25 1.25 0 0 1-.89-.28 3.36 3.36 0 0 1-.65-.87 3.79 3.79 0 0 0-1.05-1.31 3.13 3.13 0 0 0-1.95-.46 3.64 3.64 0 0 0-2 .5 1.44 1.44 0 0 0-.76 1.2 1.15 1.15 0 0 0 .25.75 2.21 2.21 0 0 0 .72.55 4.74 4.74 0 0 0 .92.36c.32.09.84.22 1.57.39.92.2 1.74.42 2.49.66a7.61 7.61 0 0 1 1.9.88 3.59 3.59 0 0 1 1.23 1.31 4 4 0 0 1 .4 1.96 4.24 4.24 0 0 1-.77 2.48z'
  }));
});
LogoSkype24.displayName = 'LogoSkype24';
LogoSkype24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSkype24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSkype20 = React.forwardRef(function (_ref1057, ref) {
  var className = _ref1057.className,
      children = _ref1057.children,
      style = _ref1057.style,
      tabIndex = _ref1057.tabIndex,
      rest = _objectWithoutProperties$2(_ref1057, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1057 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1057.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1057, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.91 17.88a11.63 11.63 0 0 0 .15-1.88A12.06 12.06 0 0 0 16 3.94a11.63 11.63 0 0 0-1.88.15 7.29 7.29 0 0 0-10 10A11.63 11.63 0 0 0 3.94 16 12.06 12.06 0 0 0 16 28.06a11.63 11.63 0 0 0 1.88-.15 7.29 7.29 0 0 0 10-10zm-6.18 3.6a5 5 0 0 1-2.24 1.73 9 9 0 0 1-3.48.62A8.41 8.41 0 0 1 12 23a5.2 5.2 0 0 1-1.82-1.63 3.59 3.59 0 0 1-.7-2 1.36 1.36 0 0 1 .43-1A1.56 1.56 0 0 1 11 18a1.38 1.38 0 0 1 .91.32 2.5 2.5 0 0 1 .63.94 5.83 5.83 0 0 0 .66 1.18 2.61 2.61 0 0 0 1 .78 3.87 3.87 0 0 0 1.69.31 4 4 0 0 0 2.34-.62 1.8 1.8 0 0 0 .89-1.53 1.54 1.54 0 0 0-.47-1.17 3.09 3.09 0 0 0-1.25-.7c-.52-.17-1.21-.34-2.08-.53a16 16 0 0 1-2.91-.98 4.78 4.78 0 0 1-1.89-1.4 3.5 3.5 0 0 1-.7-2.21 3.65 3.65 0 0 1 .74-2.24 4.7 4.7 0 0 1 2.14-1.5 9.51 9.51 0 0 1 3.3-.48 8.63 8.63 0 0 1 2.59.35 5.81 5.81 0 0 1 1.83.92 3.91 3.91 0 0 1 1.06 1.21 2.62 2.62 0 0 1 .34 1.25 1.4 1.4 0 0 1-.43 1 1.43 1.43 0 0 1-1.07.46 1.25 1.25 0 0 1-.89-.28 3.36 3.36 0 0 1-.65-.87 3.79 3.79 0 0 0-1.05-1.31 3.13 3.13 0 0 0-1.95-.46 3.64 3.64 0 0 0-2 .5 1.44 1.44 0 0 0-.76 1.2 1.15 1.15 0 0 0 .25.75 2.21 2.21 0 0 0 .72.55 4.74 4.74 0 0 0 .92.36c.32.09.84.22 1.57.39.92.2 1.74.42 2.49.66a7.61 7.61 0 0 1 1.9.88 3.59 3.59 0 0 1 1.23 1.31 4 4 0 0 1 .4 1.96 4.24 4.24 0 0 1-.77 2.48z'
  }));
});
LogoSkype20.displayName = 'LogoSkype20';
LogoSkype20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSkype20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSlack32 = React.forwardRef(function (_ref1058, ref) {
  var className = _ref1058.className,
      children = _ref1058.children,
      style = _ref1058.style,
      tabIndex = _ref1058.tabIndex,
      rest = _objectWithoutProperties$2(_ref1058, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1058 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1058.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1058, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 12.7c-2.48-8.25-6-10.17-14.3-7.72S2.53 11.05 5 19.3s6 10.17 14.29 7.69S29.47 20.98 27 12.7z'
  }), React.createElement('path', {
    d: 'M22 15.7l-1.55.52-1-3.09 1.55-.52a1.244 1.244 0 0 0-.79-2.36l-1.55.52-.54-1.61a1.243 1.243 0 0 0-2.36.78l.54 1.61-3.21 1.08-.53-1.65a1.26 1.26 0 0 0-1.56-.75 1.23 1.23 0 0 0-.78 1.57l.53 1.62-1.57.56a1.25 1.25 0 0 0-.79 1.58 1.28 1.28 0 0 0 1.15.84 1.07 1.07 0 0 0 .43-.06l1.55-.51 1 3.08-1.52.47a1.24 1.24 0 0 0-.78 1.6 1.27 1.27 0 0 0 1.15.84 1 1 0 0 0 .42-.06l1.55-.52.54 1.62a1.27 1.27 0 0 0 1.12.82 1 1 0 0 0 .42-.06 1.24 1.24 0 0 0 .79-1.57l-.54-1.61 3.21-1.08.56 1.62a1.31 1.31 0 0 0 1.16.84 1 1 0 0 0 .42-.06 1.23 1.23 0 0 0 .78-1.57l-.53-1.61 1.55-.52A1.25 1.25 0 1 0 22 15.7zm-7.12 2.41l-1-3.1 3.19-1.03 1 3.09z'
  }));
});
LogoSlack32.displayName = 'LogoSlack32';
LogoSlack32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSlack32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSlack24 = React.forwardRef(function (_ref1059, ref) {
  var className = _ref1059.className,
      children = _ref1059.children,
      style = _ref1059.style,
      tabIndex = _ref1059.tabIndex,
      rest = _objectWithoutProperties$2(_ref1059, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1059 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1059.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1059, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 12.7c-2.48-8.25-6-10.17-14.3-7.72S2.53 11.05 5 19.3s6 10.17 14.29 7.69S29.47 20.98 27 12.7z'
  }), React.createElement('path', {
    d: 'M22 15.7l-1.55.52-1-3.09 1.55-.52a1.244 1.244 0 0 0-.79-2.36l-1.55.52-.54-1.61a1.243 1.243 0 0 0-2.36.78l.54 1.61-3.21 1.08-.53-1.65a1.26 1.26 0 0 0-1.56-.75 1.23 1.23 0 0 0-.78 1.57l.53 1.62-1.57.56a1.25 1.25 0 0 0-.79 1.58 1.28 1.28 0 0 0 1.15.84 1.07 1.07 0 0 0 .43-.06l1.55-.51 1 3.08-1.52.47a1.24 1.24 0 0 0-.78 1.6 1.27 1.27 0 0 0 1.15.84 1 1 0 0 0 .42-.06l1.55-.52.54 1.62a1.27 1.27 0 0 0 1.12.82 1 1 0 0 0 .42-.06 1.24 1.24 0 0 0 .79-1.57l-.54-1.61 3.21-1.08.56 1.62a1.31 1.31 0 0 0 1.16.84 1 1 0 0 0 .42-.06 1.23 1.23 0 0 0 .78-1.57l-.53-1.61 1.55-.52A1.25 1.25 0 1 0 22 15.7zm-7.12 2.41l-1-3.1 3.19-1.03 1 3.09z'
  }));
});
LogoSlack24.displayName = 'LogoSlack24';
LogoSlack24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSlack24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSlack20 = React.forwardRef(function (_ref1060, ref) {
  var className = _ref1060.className,
      children = _ref1060.children,
      style = _ref1060.style,
      tabIndex = _ref1060.tabIndex,
      rest = _objectWithoutProperties$2(_ref1060, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1060 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1060.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1060, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 12.7c-2.48-8.25-6-10.17-14.3-7.72S2.53 11.05 5 19.3s6 10.17 14.29 7.69S29.47 20.98 27 12.7z'
  }), React.createElement('path', {
    d: 'M22 15.7l-1.55.52-1-3.09 1.55-.52a1.244 1.244 0 0 0-.79-2.36l-1.55.52-.54-1.61a1.243 1.243 0 0 0-2.36.78l.54 1.61-3.21 1.08-.53-1.65a1.26 1.26 0 0 0-1.56-.75 1.23 1.23 0 0 0-.78 1.57l.53 1.62-1.57.56a1.25 1.25 0 0 0-.79 1.58 1.28 1.28 0 0 0 1.15.84 1.07 1.07 0 0 0 .43-.06l1.55-.51 1 3.08-1.52.47a1.24 1.24 0 0 0-.78 1.6 1.27 1.27 0 0 0 1.15.84 1 1 0 0 0 .42-.06l1.55-.52.54 1.62a1.27 1.27 0 0 0 1.12.82 1 1 0 0 0 .42-.06 1.24 1.24 0 0 0 .79-1.57l-.54-1.61 3.21-1.08.56 1.62a1.31 1.31 0 0 0 1.16.84 1 1 0 0 0 .42-.06 1.23 1.23 0 0 0 .78-1.57l-.53-1.61 1.55-.52A1.25 1.25 0 1 0 22 15.7zm-7.12 2.41l-1-3.1 3.19-1.03 1 3.09z'
  }));
});
LogoSlack20.displayName = 'LogoSlack20';
LogoSlack20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSlack20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSnapchat32 = React.forwardRef(function (_ref1061, ref) {
  var className = _ref1061.className,
      children = _ref1061.children,
      style = _ref1061.style,
      tabIndex = _ref1061.tabIndex,
      rest = _objectWithoutProperties$2(_ref1061, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1061 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1061.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1061, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 8.56a8.44 8.44 0 0 0-.13-1.5 6.13 6.13 0 0 0-.57-1.74 6.13 6.13 0 0 0-1.2-1.56 5.88 5.88 0 0 0-2.54-1.45A10.66 10.66 0 0 0 22.87 2H9.13c-.51 0-1 0-1.54.07a7.73 7.73 0 0 0-1.65.37A5.89 5.89 0 0 0 3.76 3.9 5.78 5.78 0 0 0 2.3 6.45 10 10 0 0 0 2 9.12v13.77a16.2 16.2 0 0 0 .13 1.86 6.46 6.46 0 0 0 .57 1.89 6 6 0 0 0 1.68 2 5.45 5.45 0 0 0 1.69.92 9 9 0 0 0 2.77.4h14.57a9.59 9.59 0 0 0 1.68-.18 5.74 5.74 0 0 0 2.81-1.36 5.85 5.85 0 0 0 1.86-3.1 11.25 11.25 0 0 0 .24-2.43V8.56zm-3.75 13c-.18.42-1.08.77-2.61 1-.15 0-.21.26-.29.64a4.05 4.05 0 0 1-.12.47.28.28 0 0 1-.3.23 2.15 2.15 0 0 1-.44-.06 5.3 5.3 0 0 0-2-.05 3.94 3.94 0 0 0-1.57.81 4.56 4.56 0 0 1-2.76 1.08h-.26a4.56 4.56 0 0 1-2.76-1.08 4 4 0 0 0-1.58-.81 5.92 5.92 0 0 0-.82-.07 6 6 0 0 0-1.15.13 2.07 2.07 0 0 1-.44.06.3.3 0 0 1-.33-.23 4.15 4.15 0 0 1-.11-.48c-.09-.38-.15-.61-.29-.63-1.53-.24-2.44-.59-2.62-1a.31.31 0 0 1 0-.13.24.24 0 0 1 .2-.26 5.35 5.35 0 0 0 3.22-1.91 7.37 7.37 0 0 0 1.1-1.71 1.08 1.08 0 0 0 .11-.92c-.2-.47-.85-.67-1.29-.81l-.29-.1c-.38-.15-1-.47-.93-.91a.85.85 0 0 1 .84-.55.66.66 0 0 1 .25 0 2.58 2.58 0 0 0 1 .28.89.89 0 0 0 .6-.19v-.61a10.24 10.24 0 0 1 .19-4.15 5.38 5.38 0 0 1 5-3.22h.41a5.38 5.38 0 0 1 5 3.22 10.61 10.61 0 0 1 .25 4.14v.61a.82.82 0 0 0 .54.18 2.55 2.55 0 0 0 1-.27.84.84 0 0 1 .32-.06.9.9 0 0 1 .37.07.68.68 0 0 1 .51.56c0 .21-.16.53-.94.84l-.29.1c-.43.14-1.09.34-1.28.81a1.11 1.11 0 0 0 .1.92c.05.13 1.37 3.13 4.31 3.62a.26.26 0 0 1 .21.26.65.65 0 0 1-.09.14z'
  }));
});
LogoSnapchat32.displayName = 'LogoSnapchat32';
LogoSnapchat32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSnapchat32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSnapchat24 = React.forwardRef(function (_ref1062, ref) {
  var className = _ref1062.className,
      children = _ref1062.children,
      style = _ref1062.style,
      tabIndex = _ref1062.tabIndex,
      rest = _objectWithoutProperties$2(_ref1062, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1062 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1062.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1062, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 8.56a8.44 8.44 0 0 0-.13-1.5 6.13 6.13 0 0 0-.57-1.74 6.13 6.13 0 0 0-1.2-1.56 5.88 5.88 0 0 0-2.54-1.45A10.66 10.66 0 0 0 22.87 2H9.13c-.51 0-1 0-1.54.07a7.73 7.73 0 0 0-1.65.37A5.89 5.89 0 0 0 3.76 3.9 5.78 5.78 0 0 0 2.3 6.45 10 10 0 0 0 2 9.12v13.77a16.2 16.2 0 0 0 .13 1.86 6.46 6.46 0 0 0 .57 1.89 6 6 0 0 0 1.68 2 5.45 5.45 0 0 0 1.69.92 9 9 0 0 0 2.77.4h14.57a9.59 9.59 0 0 0 1.68-.18 5.74 5.74 0 0 0 2.81-1.36 5.85 5.85 0 0 0 1.86-3.1 11.25 11.25 0 0 0 .24-2.43V8.56zm-3.75 13c-.18.42-1.08.77-2.61 1-.15 0-.21.26-.29.64a4.05 4.05 0 0 1-.12.47.28.28 0 0 1-.3.23 2.15 2.15 0 0 1-.44-.06 5.3 5.3 0 0 0-2-.05 3.94 3.94 0 0 0-1.57.81 4.56 4.56 0 0 1-2.76 1.08h-.26a4.56 4.56 0 0 1-2.76-1.08 4 4 0 0 0-1.58-.81 5.92 5.92 0 0 0-.82-.07 6 6 0 0 0-1.15.13 2.07 2.07 0 0 1-.44.06.3.3 0 0 1-.33-.23 4.15 4.15 0 0 1-.11-.48c-.09-.38-.15-.61-.29-.63-1.53-.24-2.44-.59-2.62-1a.31.31 0 0 1 0-.13.24.24 0 0 1 .2-.26 5.35 5.35 0 0 0 3.22-1.91 7.37 7.37 0 0 0 1.1-1.71 1.08 1.08 0 0 0 .11-.92c-.2-.47-.85-.67-1.29-.81l-.29-.1c-.38-.15-1-.47-.93-.91a.85.85 0 0 1 .84-.55.66.66 0 0 1 .25 0 2.58 2.58 0 0 0 1 .28.89.89 0 0 0 .6-.19v-.61a10.24 10.24 0 0 1 .19-4.15 5.38 5.38 0 0 1 5-3.22h.41a5.38 5.38 0 0 1 5 3.22 10.61 10.61 0 0 1 .25 4.14v.61a.82.82 0 0 0 .54.18 2.55 2.55 0 0 0 1-.27.84.84 0 0 1 .32-.06.9.9 0 0 1 .37.07.68.68 0 0 1 .51.56c0 .21-.16.53-.94.84l-.29.1c-.43.14-1.09.34-1.28.81a1.11 1.11 0 0 0 .1.92c.05.13 1.37 3.13 4.31 3.62a.26.26 0 0 1 .21.26.65.65 0 0 1-.09.14z'
  }));
});
LogoSnapchat24.displayName = 'LogoSnapchat24';
LogoSnapchat24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSnapchat24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoSnapchat20 = React.forwardRef(function (_ref1063, ref) {
  var className = _ref1063.className,
      children = _ref1063.children,
      style = _ref1063.style,
      tabIndex = _ref1063.tabIndex,
      rest = _objectWithoutProperties$2(_ref1063, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1063 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1063.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1063, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 8.56a8.44 8.44 0 0 0-.13-1.5 6.13 6.13 0 0 0-.57-1.74 6.13 6.13 0 0 0-1.2-1.56 5.88 5.88 0 0 0-2.54-1.45A10.66 10.66 0 0 0 22.87 2H9.13c-.51 0-1 0-1.54.07a7.73 7.73 0 0 0-1.65.37A5.89 5.89 0 0 0 3.76 3.9 5.78 5.78 0 0 0 2.3 6.45 10 10 0 0 0 2 9.12v13.77a16.2 16.2 0 0 0 .13 1.86 6.46 6.46 0 0 0 .57 1.89 6 6 0 0 0 1.68 2 5.45 5.45 0 0 0 1.69.92 9 9 0 0 0 2.77.4h14.57a9.59 9.59 0 0 0 1.68-.18 5.74 5.74 0 0 0 2.81-1.36 5.85 5.85 0 0 0 1.86-3.1 11.25 11.25 0 0 0 .24-2.43V8.56zm-3.75 13c-.18.42-1.08.77-2.61 1-.15 0-.21.26-.29.64a4.05 4.05 0 0 1-.12.47.28.28 0 0 1-.3.23 2.15 2.15 0 0 1-.44-.06 5.3 5.3 0 0 0-2-.05 3.94 3.94 0 0 0-1.57.81 4.56 4.56 0 0 1-2.76 1.08h-.26a4.56 4.56 0 0 1-2.76-1.08 4 4 0 0 0-1.58-.81 5.92 5.92 0 0 0-.82-.07 6 6 0 0 0-1.15.13 2.07 2.07 0 0 1-.44.06.3.3 0 0 1-.33-.23 4.15 4.15 0 0 1-.11-.48c-.09-.38-.15-.61-.29-.63-1.53-.24-2.44-.59-2.62-1a.31.31 0 0 1 0-.13.24.24 0 0 1 .2-.26 5.35 5.35 0 0 0 3.22-1.91 7.37 7.37 0 0 0 1.1-1.71 1.08 1.08 0 0 0 .11-.92c-.2-.47-.85-.67-1.29-.81l-.29-.1c-.38-.15-1-.47-.93-.91a.85.85 0 0 1 .84-.55.66.66 0 0 1 .25 0 2.58 2.58 0 0 0 1 .28.89.89 0 0 0 .6-.19v-.61a10.24 10.24 0 0 1 .19-4.15 5.38 5.38 0 0 1 5-3.22h.41a5.38 5.38 0 0 1 5 3.22 10.61 10.61 0 0 1 .25 4.14v.61a.82.82 0 0 0 .54.18 2.55 2.55 0 0 0 1-.27.84.84 0 0 1 .32-.06.9.9 0 0 1 .37.07.68.68 0 0 1 .51.56c0 .21-.16.53-.94.84l-.29.1c-.43.14-1.09.34-1.28.81a1.11 1.11 0 0 0 .1.92c.05.13 1.37 3.13 4.31 3.62a.26.26 0 0 1 .21.26.65.65 0 0 1-.09.14z'
  }));
});
LogoSnapchat20.displayName = 'LogoSnapchat20';
LogoSnapchat20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoSnapchat20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoStumbleupon32 = React.forwardRef(function (_ref1064, ref) {
  var className = _ref1064.className,
      children = _ref1064.children,
      style = _ref1064.style,
      tabIndex = _ref1064.tabIndex,
      rest = _objectWithoutProperties$2(_ref1064, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1064 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1064.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1064, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-.09 10.45a.84.84 0 0 0-.84.84v5.14a3.55 3.55 0 0 1-7.1 0v-2.34h2.71v2.24a.84.84 0 0 0 1.68 0v-5a3.55 3.55 0 0 1 7.09 0v1l-1.58.51-1.12-.51v-1a.85.85 0 0 0-.84-.88zm7.93 6a3.55 3.55 0 0 1-7.09 0v-2.31l1.12.51 1.58-.51v2.29a.84.84 0 0 0 1.68 0v-2.24h2.71z'
  }));
});
LogoStumbleupon32.displayName = 'LogoStumbleupon32';
LogoStumbleupon32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoStumbleupon32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoStumbleupon24 = React.forwardRef(function (_ref1065, ref) {
  var className = _ref1065.className,
      children = _ref1065.children,
      style = _ref1065.style,
      tabIndex = _ref1065.tabIndex,
      rest = _objectWithoutProperties$2(_ref1065, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1065 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1065.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1065, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-.09 10.45a.84.84 0 0 0-.84.84v5.14a3.55 3.55 0 0 1-7.1 0v-2.34h2.71v2.24a.84.84 0 0 0 1.68 0v-5a3.55 3.55 0 0 1 7.09 0v1l-1.58.51-1.12-.51v-1a.85.85 0 0 0-.84-.88zm7.93 6a3.55 3.55 0 0 1-7.09 0v-2.31l1.12.51 1.58-.51v2.29a.84.84 0 0 0 1.68 0v-2.24h2.71z'
  }));
});
LogoStumbleupon24.displayName = 'LogoStumbleupon24';
LogoStumbleupon24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoStumbleupon24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoStumbleupon20 = React.forwardRef(function (_ref1066, ref) {
  var className = _ref1066.className,
      children = _ref1066.children,
      style = _ref1066.style,
      tabIndex = _ref1066.tabIndex,
      rest = _objectWithoutProperties$2(_ref1066, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1066 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1066.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1066, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-.09 10.45a.84.84 0 0 0-.84.84v5.14a3.55 3.55 0 0 1-7.1 0v-2.34h2.71v2.24a.84.84 0 0 0 1.68 0v-5a3.55 3.55 0 0 1 7.09 0v1l-1.58.51-1.12-.51v-1a.85.85 0 0 0-.84-.88zm7.93 6a3.55 3.55 0 0 1-7.09 0v-2.31l1.12.51 1.58-.51v2.29a.84.84 0 0 0 1.68 0v-2.24h2.71z'
  }));
});
LogoStumbleupon20.displayName = 'LogoStumbleupon20';
LogoStumbleupon20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoStumbleupon20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoTumblr32 = React.forwardRef(function (_ref1067, ref) {
  var className = _ref1067.className,
      children = _ref1067.children,
      style = _ref1067.style,
      tabIndex = _ref1067.tabIndex,
      rest = _objectWithoutProperties$2(_ref1067, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1067 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1067.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1067, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.6 28h-4c-3.59 0-6.3-1.86-6.3-6.3v-7.12H9v-3.86A7.17 7.17 0 0 0 14.3 4h3.76v6.12h4.36v4.46h-4.36v6.2c0 1.86.94 2.49 2.42 2.49h2.12z'
  }));
});
LogoTumblr32.displayName = 'LogoTumblr32';
LogoTumblr32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoTumblr32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoTumblr24 = React.forwardRef(function (_ref1068, ref) {
  var className = _ref1068.className,
      children = _ref1068.children,
      style = _ref1068.style,
      tabIndex = _ref1068.tabIndex,
      rest = _objectWithoutProperties$2(_ref1068, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1068 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1068.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1068, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.6 28h-4c-3.59 0-6.3-1.86-6.3-6.3v-7.12H9v-3.86A7.17 7.17 0 0 0 14.3 4h3.76v6.12h4.36v4.46h-4.36v6.2c0 1.86.94 2.49 2.42 2.49h2.12z'
  }));
});
LogoTumblr24.displayName = 'LogoTumblr24';
LogoTumblr24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoTumblr24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoTumblr20 = React.forwardRef(function (_ref1069, ref) {
  var className = _ref1069.className,
      children = _ref1069.children,
      style = _ref1069.style,
      tabIndex = _ref1069.tabIndex,
      rest = _objectWithoutProperties$2(_ref1069, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1069 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1069.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1069, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.6 28h-4c-3.59 0-6.3-1.86-6.3-6.3v-7.12H9v-3.86A7.17 7.17 0 0 0 14.3 4h3.76v6.12h4.36v4.46h-4.36v6.2c0 1.86.94 2.49 2.42 2.49h2.12z'
  }));
});
LogoTumblr20.displayName = 'LogoTumblr20';
LogoTumblr20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoTumblr20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoTwitter32 = React.forwardRef(function (_ref1070, ref) {
  var className = _ref1070.className,
      children = _ref1070.children,
      style = _ref1070.style,
      tabIndex = _ref1070.tabIndex,
      rest = _objectWithoutProperties$2(_ref1070, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1070 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1070.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1070, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.92 24.94A12.76 12.76 0 0 0 24.76 12.1v-.59A9.4 9.4 0 0 0 27 9.18a9.31 9.31 0 0 1-2.59.71 4.56 4.56 0 0 0 2-2.5 8.89 8.89 0 0 1-2.86 1.1 4.52 4.52 0 0 0-7.7 4.11 12.79 12.79 0 0 1-9.3-4.71 4.51 4.51 0 0 0 1.4 6 4.47 4.47 0 0 1-2-.56v.05a4.53 4.53 0 0 0 3.55 4.45 4.53 4.53 0 0 1-2 .08A4.51 4.51 0 0 0 11.68 21a9.05 9.05 0 0 1-5.61 2A9.77 9.77 0 0 1 5 22.91a12.77 12.77 0 0 0 6.92 2'
  }));
});
LogoTwitter32.displayName = 'LogoTwitter32';
LogoTwitter32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoTwitter32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoTwitter24 = React.forwardRef(function (_ref1071, ref) {
  var className = _ref1071.className,
      children = _ref1071.children,
      style = _ref1071.style,
      tabIndex = _ref1071.tabIndex,
      rest = _objectWithoutProperties$2(_ref1071, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1071 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1071.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1071, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.92 24.94A12.76 12.76 0 0 0 24.76 12.1v-.59A9.4 9.4 0 0 0 27 9.18a9.31 9.31 0 0 1-2.59.71 4.56 4.56 0 0 0 2-2.5 8.89 8.89 0 0 1-2.86 1.1 4.52 4.52 0 0 0-7.7 4.11 12.79 12.79 0 0 1-9.3-4.71 4.51 4.51 0 0 0 1.4 6 4.47 4.47 0 0 1-2-.56v.05a4.53 4.53 0 0 0 3.55 4.45 4.53 4.53 0 0 1-2 .08A4.51 4.51 0 0 0 11.68 21a9.05 9.05 0 0 1-5.61 2A9.77 9.77 0 0 1 5 22.91a12.77 12.77 0 0 0 6.92 2'
  }));
});
LogoTwitter24.displayName = 'LogoTwitter24';
LogoTwitter24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoTwitter24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoTwitter20 = React.forwardRef(function (_ref1072, ref) {
  var className = _ref1072.className,
      children = _ref1072.children,
      style = _ref1072.style,
      tabIndex = _ref1072.tabIndex,
      rest = _objectWithoutProperties$2(_ref1072, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1072 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1072.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1072, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.92 24.94A12.76 12.76 0 0 0 24.76 12.1v-.59A9.4 9.4 0 0 0 27 9.18a9.31 9.31 0 0 1-2.59.71 4.56 4.56 0 0 0 2-2.5 8.89 8.89 0 0 1-2.86 1.1 4.52 4.52 0 0 0-7.7 4.11 12.79 12.79 0 0 1-9.3-4.71 4.51 4.51 0 0 0 1.4 6 4.47 4.47 0 0 1-2-.56v.05a4.53 4.53 0 0 0 3.55 4.45 4.53 4.53 0 0 1-2 .08A4.51 4.51 0 0 0 11.68 21a9.05 9.05 0 0 1-5.61 2A9.77 9.77 0 0 1 5 22.91a12.77 12.77 0 0 0 6.92 2'
  }));
});
LogoTwitter20.displayName = 'LogoTwitter20';
LogoTwitter20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoTwitter20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoXing32 = React.forwardRef(function (_ref1073, ref) {
  var className = _ref1073.className,
      children = _ref1073.children,
      style = _ref1073.style,
      tabIndex = _ref1073.tabIndex,
      rest = _objectWithoutProperties$2(_ref1073, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1073 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1073.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1073, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.42 8.29a1.25 1.25 0 0 0-1.13-.76h-4a.65.65 0 0 0-.55.25.63.63 0 0 0 0 .62l2.73 4.73-4.3 7.59a.6.6 0 0 0 0 .62.58.58 0 0 0 .52.28h4a1.22 1.22 0 0 0 1.1-.78l4.36-7.71-2.73-4.84zm16.41-5.41a.65.65 0 0 0 0-.62.61.61 0 0 0-.53-.26h-4.08a1.19 1.19 0 0 0-1.08.77s-8.7 15.43-9 15.93l5.74 10.53A1.26 1.26 0 0 0 20 30h4a.59.59 0 0 0 .54-.26.62.62 0 0 0 0-.62l-5.69-10.4z'
  }));
});
LogoXing32.displayName = 'LogoXing32';
LogoXing32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoXing32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoXing24 = React.forwardRef(function (_ref1074, ref) {
  var className = _ref1074.className,
      children = _ref1074.children,
      style = _ref1074.style,
      tabIndex = _ref1074.tabIndex,
      rest = _objectWithoutProperties$2(_ref1074, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1074 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1074.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1074, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.42 8.29a1.25 1.25 0 0 0-1.13-.76h-4a.65.65 0 0 0-.55.25.63.63 0 0 0 0 .62l2.73 4.73-4.3 7.59a.6.6 0 0 0 0 .62.58.58 0 0 0 .52.28h4a1.22 1.22 0 0 0 1.1-.78l4.36-7.71-2.73-4.84zm16.41-5.41a.65.65 0 0 0 0-.62.61.61 0 0 0-.53-.26h-4.08a1.19 1.19 0 0 0-1.08.77s-8.7 15.43-9 15.93l5.74 10.53A1.26 1.26 0 0 0 20 30h4a.59.59 0 0 0 .54-.26.62.62 0 0 0 0-.62l-5.69-10.4z'
  }));
});
LogoXing24.displayName = 'LogoXing24';
LogoXing24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoXing24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoXing20 = React.forwardRef(function (_ref1075, ref) {
  var className = _ref1075.className,
      children = _ref1075.children,
      style = _ref1075.style,
      tabIndex = _ref1075.tabIndex,
      rest = _objectWithoutProperties$2(_ref1075, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1075 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1075.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1075, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.42 8.29a1.25 1.25 0 0 0-1.13-.76h-4a.65.65 0 0 0-.55.25.63.63 0 0 0 0 .62l2.73 4.73-4.3 7.59a.6.6 0 0 0 0 .62.58.58 0 0 0 .52.28h4a1.22 1.22 0 0 0 1.1-.78l4.36-7.71-2.73-4.84zm16.41-5.41a.65.65 0 0 0 0-.62.61.61 0 0 0-.53-.26h-4.08a1.19 1.19 0 0 0-1.08.77s-8.7 15.43-9 15.93l5.74 10.53A1.26 1.26 0 0 0 20 30h4a.59.59 0 0 0 .54-.26.62.62 0 0 0 0-.62l-5.69-10.4z'
  }));
});
LogoXing20.displayName = 'LogoXing20';
LogoXing20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoXing20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoYoutube32 = React.forwardRef(function (_ref1076, ref) {
  var className = _ref1076.className,
      children = _ref1076.children,
      style = _ref1076.style,
      tabIndex = _ref1076.tabIndex,
      rest = _objectWithoutProperties$2(_ref1076, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1076 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1076.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1076, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36.13 36.13 0 0 0 2 16a36.13 36.13 0 0 0 .59 6.74 3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36.13 36.13 0 0 0 30 16a36.13 36.13 0 0 0-.59-6.74zM13.2 20.2v-8.4l7.27 4.2z'
  }));
});
LogoYoutube32.displayName = 'LogoYoutube32';
LogoYoutube32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoYoutube32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoYoutube24 = React.forwardRef(function (_ref1077, ref) {
  var className = _ref1077.className,
      children = _ref1077.children,
      style = _ref1077.style,
      tabIndex = _ref1077.tabIndex,
      rest = _objectWithoutProperties$2(_ref1077, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1077 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1077.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1077, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36.13 36.13 0 0 0 2 16a36.13 36.13 0 0 0 .59 6.74 3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36.13 36.13 0 0 0 30 16a36.13 36.13 0 0 0-.59-6.74zM13.2 20.2v-8.4l7.27 4.2z'
  }));
});
LogoYoutube24.displayName = 'LogoYoutube24';
LogoYoutube24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoYoutube24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var LogoYoutube20 = React.forwardRef(function (_ref1078, ref) {
  var className = _ref1078.className,
      children = _ref1078.children,
      style = _ref1078.style,
      tabIndex = _ref1078.tabIndex,
      rest = _objectWithoutProperties$2(_ref1078, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1078 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1078.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1078, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36.13 36.13 0 0 0 2 16a36.13 36.13 0 0 0 .59 6.74 3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36.13 36.13 0 0 0 30 16a36.13 36.13 0 0 0-.59-6.74zM13.2 20.2v-8.4l7.27 4.2z'
  }));
});
LogoYoutube20.displayName = 'LogoYoutube20';
LogoYoutube20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
LogoYoutube20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Loop32 = React.forwardRef(function (_ref1079, ref) {
  var className = _ref1079.className,
      children = _ref1079.children,
      style = _ref1079.style,
      tabIndex = _ref1079.tabIndex,
      rest = _objectWithoutProperties$2(_ref1079, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1079 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1079.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1079, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.59 19.41L26 22h-5v2h5l-2.41 2.59L25 28l5-5-5-5-1.41 1.41zM13 6a9 9 0 0 0-7.48 14l1.66-1.11A7 7 0 1 1 13 22H2v2h11a9 9 0 0 0 0-18z'
  }));
});
Loop32.displayName = 'Loop32';
Loop32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Loop32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Loop24 = React.forwardRef(function (_ref1080, ref) {
  var className = _ref1080.className,
      children = _ref1080.children,
      style = _ref1080.style,
      tabIndex = _ref1080.tabIndex,
      rest = _objectWithoutProperties$2(_ref1080, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1080 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1080.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1080, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.59 19.41L26 22h-5v2h5l-2.41 2.59L25 28l5-5-5-5-1.41 1.41zM13 6a9 9 0 0 0-7.48 14l1.66-1.11A7 7 0 1 1 13 22H2v2h11a9 9 0 0 0 0-18z'
  }));
});
Loop24.displayName = 'Loop24';
Loop24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Loop24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Loop20 = React.forwardRef(function (_ref1081, ref) {
  var className = _ref1081.className,
      children = _ref1081.children,
      style = _ref1081.style,
      tabIndex = _ref1081.tabIndex,
      rest = _objectWithoutProperties$2(_ref1081, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1081 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1081.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1081, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.59 19.41L26 22h-5v2h5l-2.41 2.59L25 28l5-5-5-5-1.41 1.41zM13 6a9 9 0 0 0-7.48 14l1.66-1.11A7 7 0 1 1 13 22H2v2h11a9 9 0 0 0 0-18z'
  }));
});
Loop20.displayName = 'Loop20';
Loop20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Loop20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacCommand32 = React.forwardRef(function (_ref1082, ref) {
  var className = _ref1082.className,
      children = _ref1082.children,
      style = _ref1082.style,
      tabIndex = _ref1082.tabIndex,
      rest = _objectWithoutProperties$2(_ref1082, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1082 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1082.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1082, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 13a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4h-1a4 4 0 0 0-4 4v3h-6V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h3v6H8a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4v-3h6v3a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4v-1a4 4 0 0 0-4-4h-3v-6zm-3-5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-3zM8 11a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v3H8zm3 13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h3zm8-5h-6v-6h6zm2 2h3a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z'
  }));
});
MacCommand32.displayName = 'MacCommand32';
MacCommand32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacCommand32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacCommand24 = React.forwardRef(function (_ref1083, ref) {
  var className = _ref1083.className,
      children = _ref1083.children,
      style = _ref1083.style,
      tabIndex = _ref1083.tabIndex,
      rest = _objectWithoutProperties$2(_ref1083, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1083 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1083.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1083, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 13a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4h-1a4 4 0 0 0-4 4v3h-6V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h3v6H8a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4v-3h6v3a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4v-1a4 4 0 0 0-4-4h-3v-6zm-3-5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-3zM8 11a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v3H8zm3 13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h3zm8-5h-6v-6h6zm2 2h3a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z'
  }));
});
MacCommand24.displayName = 'MacCommand24';
MacCommand24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacCommand24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacCommand20 = React.forwardRef(function (_ref1084, ref) {
  var className = _ref1084.className,
      children = _ref1084.children,
      style = _ref1084.style,
      tabIndex = _ref1084.tabIndex,
      rest = _objectWithoutProperties$2(_ref1084, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1084 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1084.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1084, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 13a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4h-1a4 4 0 0 0-4 4v3h-6V8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h3v6H8a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4v-3h6v3a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4v-1a4 4 0 0 0-4-4h-3v-6zm-3-5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-3zM8 11a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v3H8zm3 13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h3zm8-5h-6v-6h6zm2 2h3a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z'
  }));
});
MacCommand20.displayName = 'MacCommand20';
MacCommand20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacCommand20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacOption32 = React.forwardRef(function (_ref1085, ref) {
  var className = _ref1085.className,
      children = _ref1085.children,
      style = _ref1085.style,
      tabIndex = _ref1085.tabIndex,
      rest = _objectWithoutProperties$2(_ref1085, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1085 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1085.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1085, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 5h10v2H18zm-7.4 0H4v2h5.4l9 20H28v-2h-8.4z'
  }));
});
MacOption32.displayName = 'MacOption32';
MacOption32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacOption32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacOption24 = React.forwardRef(function (_ref1086, ref) {
  var className = _ref1086.className,
      children = _ref1086.children,
      style = _ref1086.style,
      tabIndex = _ref1086.tabIndex,
      rest = _objectWithoutProperties$2(_ref1086, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1086 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1086.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1086, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 5h10v2H18zm-7.4 0H4v2h5.4l9 20H28v-2h-8.4z'
  }));
});
MacOption24.displayName = 'MacOption24';
MacOption24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacOption24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacOption20 = React.forwardRef(function (_ref1087, ref) {
  var className = _ref1087.className,
      children = _ref1087.children,
      style = _ref1087.style,
      tabIndex = _ref1087.tabIndex,
      rest = _objectWithoutProperties$2(_ref1087, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1087 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1087.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1087, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 5h10v2H18zm-7.4 0H4v2h5.4l9 20H28v-2h-8.4z'
  }));
});
MacOption20.displayName = 'MacOption20';
MacOption20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacOption20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacShift32 = React.forwardRef(function (_ref1088, ref) {
  var className = _ref1088.className,
      children = _ref1088.children,
      style = _ref1088.style,
      tabIndex = _ref1088.tabIndex,
      rest = _objectWithoutProperties$2(_ref1088, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1088 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1088.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1088, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 28H11a2 2 0 0 1-2-2V16H4a1 1 0 0 1-.92-.62 1 1 0 0 1 .21-1.09l12-12a1 1 0 0 1 1.42 0l12 12a1 1 0 0 1 .21 1.09A1 1 0 0 1 28 16h-5v10a2 2 0 0 1-2 2zM6.41 14H10a1 1 0 0 1 1 1v11h10V15a1 1 0 0 1 1-1h3.59L16 4.41z'
  }));
});
MacShift32.displayName = 'MacShift32';
MacShift32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacShift32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacShift24 = React.forwardRef(function (_ref1089, ref) {
  var className = _ref1089.className,
      children = _ref1089.children,
      style = _ref1089.style,
      tabIndex = _ref1089.tabIndex,
      rest = _objectWithoutProperties$2(_ref1089, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1089 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1089.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1089, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 28H11a2 2 0 0 1-2-2V16H4a1 1 0 0 1-.92-.62 1 1 0 0 1 .21-1.09l12-12a1 1 0 0 1 1.42 0l12 12a1 1 0 0 1 .21 1.09A1 1 0 0 1 28 16h-5v10a2 2 0 0 1-2 2zM6.41 14H10a1 1 0 0 1 1 1v11h10V15a1 1 0 0 1 1-1h3.59L16 4.41z'
  }));
});
MacShift24.displayName = 'MacShift24';
MacShift24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacShift24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MacShift20 = React.forwardRef(function (_ref1090, ref) {
  var className = _ref1090.className,
      children = _ref1090.children,
      style = _ref1090.style,
      tabIndex = _ref1090.tabIndex,
      rest = _objectWithoutProperties$2(_ref1090, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1090 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1090.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1090, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 28H11a2 2 0 0 1-2-2V16H4a1 1 0 0 1-.92-.62 1 1 0 0 1 .21-1.09l12-12a1 1 0 0 1 1.42 0l12 12a1 1 0 0 1 .21 1.09A1 1 0 0 1 28 16h-5v10a2 2 0 0 1-2 2zM6.41 14H10a1 1 0 0 1 1 1v11h10V15a1 1 0 0 1 1-1h3.59L16 4.41z'
  }));
});
MacShift20.displayName = 'MacShift20';
MacShift20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MacShift20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MailAll32 = React.forwardRef(function (_ref1091, ref) {
  var className = _ref1091.className,
      children = _ref1091.children,
      style = _ref1091.style,
      tabIndex = _ref1091.tabIndex,
      rest = _objectWithoutProperties$2(_ref1091, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1091 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1091.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1091, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.59 20.41L20.17 24l-3.59 3.59L18 29l5-5-5-5-1.41 1.41zm7 0L27.17 24l-3.59 3.59L25 29l5-5-5-5-1.41 1.41z'
  }), React.createElement('path', {
    d: 'M14 23H4V7.91l11.43 7.91a1 1 0 0 0 1.14 0L28 7.91V17h2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10zM25.8 7L16 13.78 6.2 7z'
  }));
});
MailAll32.displayName = 'MailAll32';
MailAll32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MailAll32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MailAll24 = React.forwardRef(function (_ref1092, ref) {
  var className = _ref1092.className,
      children = _ref1092.children,
      style = _ref1092.style,
      tabIndex = _ref1092.tabIndex,
      rest = _objectWithoutProperties$2(_ref1092, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1092 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1092.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1092, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.59 20.41L20.17 24l-3.59 3.59L18 29l5-5-5-5-1.41 1.41zm7 0L27.17 24l-3.59 3.59L25 29l5-5-5-5-1.41 1.41z'
  }), React.createElement('path', {
    d: 'M14 23H4V7.91l11.43 7.91a1 1 0 0 0 1.14 0L28 7.91V17h2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10zM25.8 7L16 13.78 6.2 7z'
  }));
});
MailAll24.displayName = 'MailAll24';
MailAll24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MailAll24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MailAll20 = React.forwardRef(function (_ref1093, ref) {
  var className = _ref1093.className,
      children = _ref1093.children,
      style = _ref1093.style,
      tabIndex = _ref1093.tabIndex,
      rest = _objectWithoutProperties$2(_ref1093, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1093 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1093.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1093, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.59 20.41L20.17 24l-3.59 3.59L18 29l5-5-5-5-1.41 1.41zm7 0L27.17 24l-3.59 3.59L25 29l5-5-5-5-1.41 1.41z'
  }), React.createElement('path', {
    d: 'M14 23H4V7.91l11.43 7.91a1 1 0 0 0 1.14 0L28 7.91V17h2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10zM25.8 7L16 13.78 6.2 7z'
  }));
});
MailAll20.displayName = 'MailAll20';
MailAll20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MailAll20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Map32 = React.forwardRef(function (_ref1094, ref) {
  var className = _ref1094.className,
      children = _ref1094.children,
      style = _ref1094.style,
      tabIndex = _ref1094.tabIndex,
      rest = _objectWithoutProperties$2(_ref1094, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1094 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1094.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1094, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 24l-6.09-8.6A8.14 8.14 0 0 1 16 2a8.08 8.08 0 0 1 8 8.13 8.2 8.2 0 0 1-1.8 5.13zm0-20a6.07 6.07 0 0 0-6 6.13 6.19 6.19 0 0 0 1.49 4L16 20.52 20.63 14A6.24 6.24 0 0 0 22 10.13 6.07 6.07 0 0 0 16 4z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '9',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 12h-2v2h2v14H4V14h2v-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2z'
  }));
});
Map32.displayName = 'Map32';
Map32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Map32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Map24 = React.forwardRef(function (_ref1095, ref) {
  var className = _ref1095.className,
      children = _ref1095.children,
      style = _ref1095.style,
      tabIndex = _ref1095.tabIndex,
      rest = _objectWithoutProperties$2(_ref1095, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1095 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1095.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1095, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 24l-6.09-8.6A8.14 8.14 0 0 1 16 2a8.08 8.08 0 0 1 8 8.13 8.2 8.2 0 0 1-1.8 5.13zm0-20a6.07 6.07 0 0 0-6 6.13 6.19 6.19 0 0 0 1.49 4L16 20.52 20.63 14A6.24 6.24 0 0 0 22 10.13 6.07 6.07 0 0 0 16 4z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '9',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 12h-2v2h2v14H4V14h2v-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2z'
  }));
});
Map24.displayName = 'Map24';
Map24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Map24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Map20 = React.forwardRef(function (_ref1096, ref) {
  var className = _ref1096.className,
      children = _ref1096.children,
      style = _ref1096.style,
      tabIndex = _ref1096.tabIndex,
      rest = _objectWithoutProperties$2(_ref1096, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1096 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1096.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1096, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 24l-6.09-8.6A8.14 8.14 0 0 1 16 2a8.08 8.08 0 0 1 8 8.13 8.2 8.2 0 0 1-1.8 5.13zm0-20a6.07 6.07 0 0 0-6 6.13 6.19 6.19 0 0 0 1.49 4L16 20.52 20.63 14A6.24 6.24 0 0 0 22 10.13 6.07 6.07 0 0 0 16 4z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '9',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 12h-2v2h2v14H4V14h2v-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2z'
  }));
});
Map20.displayName = 'Map20';
Map20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Map20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Maximize32 = React.forwardRef(function (_ref1097, ref) {
  var className = _ref1097.className,
      children = _ref1097.children,
      style = _ref1097.style,
      tabIndex = _ref1097.tabIndex,
      rest = _objectWithoutProperties$2(_ref1097, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1097 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1097.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1097, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2v2h5.59L17 13.58 18.41 15 28 5.41V11h2V2h-9zm-6 16.42L13.59 17 4 26.59V21H2v9h9v-2H5.41L15 18.42z'
  }));
});
Maximize32.displayName = 'Maximize32';
Maximize32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Maximize32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Maximize24 = React.forwardRef(function (_ref1098, ref) {
  var className = _ref1098.className,
      children = _ref1098.children,
      style = _ref1098.style,
      tabIndex = _ref1098.tabIndex,
      rest = _objectWithoutProperties$2(_ref1098, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1098 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1098.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1098, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2v2h5.59L17 13.58 18.41 15 28 5.41V11h2V2h-9zm-6 16.42L13.59 17 4 26.59V21H2v9h9v-2H5.41L15 18.42z'
  }));
});
Maximize24.displayName = 'Maximize24';
Maximize24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Maximize24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Maximize20 = React.forwardRef(function (_ref1099, ref) {
  var className = _ref1099.className,
      children = _ref1099.children,
      style = _ref1099.style,
      tabIndex = _ref1099.tabIndex,
      rest = _objectWithoutProperties$2(_ref1099, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1099 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1099.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1099, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2v2h5.59L17 13.58 18.41 15 28 5.41V11h2V2h-9zm-6 16.42L13.59 17 4 26.59V21H2v9h9v-2H5.41L15 18.42z'
  }));
});
Maximize20.displayName = 'Maximize20';
Maximize20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Maximize20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MedicationAlert32 = React.forwardRef(function (_ref1100, ref) {
  var className = _ref1100.className,
      children = _ref1100.children,
      style = _ref1100.style,
      tabIndex = _ref1100.tabIndex,
      rest = _objectWithoutProperties$2(_ref1100, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1100 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1100.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1100, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 19h2v5h-2z'
  }), React.createElement('path', {
    d: 'M23 31a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }), React.createElement('circle', {
    cx: '23',
    cy: '26',
    r: '1'
  }), React.createElement('path', {
    d: 'M20 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h8v-2H6v-2h5V12H6v-2h12v3h2v-3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM9 14v10H6V14zM4 8V4h16v4z'
  }));
});
MedicationAlert32.displayName = 'MedicationAlert32';
MedicationAlert32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MedicationAlert32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MedicationAlert24 = React.forwardRef(function (_ref1101, ref) {
  var className = _ref1101.className,
      children = _ref1101.children,
      style = _ref1101.style,
      tabIndex = _ref1101.tabIndex,
      rest = _objectWithoutProperties$2(_ref1101, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1101 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1101.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1101, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 19h2v5h-2z'
  }), React.createElement('path', {
    d: 'M23 31a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }), React.createElement('circle', {
    cx: '23',
    cy: '26',
    r: '1'
  }), React.createElement('path', {
    d: 'M20 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h8v-2H6v-2h5V12H6v-2h12v3h2v-3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM9 14v10H6V14zM4 8V4h16v4z'
  }));
});
MedicationAlert24.displayName = 'MedicationAlert24';
MedicationAlert24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MedicationAlert24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MedicationAlert20 = React.forwardRef(function (_ref1102, ref) {
  var className = _ref1102.className,
      children = _ref1102.children,
      style = _ref1102.style,
      tabIndex = _ref1102.tabIndex,
      rest = _objectWithoutProperties$2(_ref1102, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1102 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1102.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1102, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 19h2v5h-2z'
  }), React.createElement('path', {
    d: 'M23 31a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }), React.createElement('circle', {
    cx: '23',
    cy: '26',
    r: '1'
  }), React.createElement('path', {
    d: 'M20 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h8v-2H6v-2h5V12H6v-2h12v3h2v-3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM9 14v10H6V14zM4 8V4h16v4z'
  }));
});
MedicationAlert20.displayName = 'MedicationAlert20';
MedicationAlert20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MedicationAlert20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MedicationReminder32 = React.forwardRef(function (_ref1103, ref) {
  var className = _ref1103.className,
      children = _ref1103.children,
      style = _ref1103.style,
      tabIndex = _ref1103.tabIndex,
      rest = _objectWithoutProperties$2(_ref1103, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1103 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1103.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1103, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 14h3v10H6zm12 14H6v-2h5V12H6v-2h12zM4 8V4h16v4z'
  }), React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '4'
  }));
});
MedicationReminder32.displayName = 'MedicationReminder32';
MedicationReminder32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MedicationReminder32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MedicationReminder24 = React.forwardRef(function (_ref1104, ref) {
  var className = _ref1104.className,
      children = _ref1104.children,
      style = _ref1104.style,
      tabIndex = _ref1104.tabIndex,
      rest = _objectWithoutProperties$2(_ref1104, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1104 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1104.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1104, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 14h3v10H6zm12 14H6v-2h5V12H6v-2h12zM4 8V4h16v4z'
  }), React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '4'
  }));
});
MedicationReminder24.displayName = 'MedicationReminder24';
MedicationReminder24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MedicationReminder24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MedicationReminder20 = React.forwardRef(function (_ref1105, ref) {
  var className = _ref1105.className,
      children = _ref1105.children,
      style = _ref1105.style,
      tabIndex = _ref1105.tabIndex,
      rest = _objectWithoutProperties$2(_ref1105, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1105 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1105.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1105, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 14h3v10H6zm12 14H6v-2h5V12H6v-2h12zM4 8V4h16v4z'
  }), React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '4'
  }));
});
MedicationReminder20.displayName = 'MedicationReminder20';
MedicationReminder20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MedicationReminder20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Medication32 = React.forwardRef(function (_ref1106, ref) {
  var className = _ref1106.className,
      children = _ref1106.children,
      style = _ref1106.style,
      tabIndex = _ref1106.tabIndex,
      rest = _objectWithoutProperties$2(_ref1106, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1106 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1106.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1106, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM10 14h3v10h-3zm12 14H10v-2h5V12h-5v-2h12zM8 8V4h16v4z'
  }));
});
Medication32.displayName = 'Medication32';
Medication32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Medication32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Medication24 = React.forwardRef(function (_ref1107, ref) {
  var className = _ref1107.className,
      children = _ref1107.children,
      style = _ref1107.style,
      tabIndex = _ref1107.tabIndex,
      rest = _objectWithoutProperties$2(_ref1107, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1107 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1107.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1107, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM10 14h3v10h-3zm12 14H10v-2h5V12h-5v-2h12zM8 8V4h16v4z'
  }));
});
Medication24.displayName = 'Medication24';
Medication24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Medication24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Medication20 = React.forwardRef(function (_ref1108, ref) {
  var className = _ref1108.className,
      children = _ref1108.children,
      style = _ref1108.style,
      tabIndex = _ref1108.tabIndex,
      rest = _objectWithoutProperties$2(_ref1108, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1108 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1108.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1108, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM10 14h3v10h-3zm12 14H10v-2h5V12h-5v-2h12zM8 8V4h16v4z'
  }));
});
Medication20.displayName = 'Medication20';
Medication20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Medication20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Menu32 = React.forwardRef(function (_ref1109, ref) {
  var className = _ref1109.className,
      children = _ref1109.children,
      style = _ref1109.style,
      tabIndex = _ref1109.tabIndex,
      rest = _objectWithoutProperties$2(_ref1109, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1109 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1109.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1109, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 24h24v2H4zm0-12h24v2H4zm0 6h24v2H4zM4 6h24v2H4z'
  }));
});
Menu32.displayName = 'Menu32';
Menu32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Menu32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneFilled32 = React.forwardRef(function (_ref1110, ref) {
  var className = _ref1110.className,
      children = _ref1110.children,
      style = _ref1110.style,
      tabIndex = _ref1110.tabIndex,
      rest = _objectWithoutProperties$2(_ref1110, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1110 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1110.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1110, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 14v3a7 7 0 0 1-14 0v-3H7v3a9 9 0 0 0 8 8.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3z'
  }), React.createElement('path', {
    d: 'M16 22a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v10a5 5 0 0 0 5 5z'
  }));
});
MicrophoneFilled32.displayName = 'MicrophoneFilled32';
MicrophoneFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneFilled24 = React.forwardRef(function (_ref1111, ref) {
  var className = _ref1111.className,
      children = _ref1111.children,
      style = _ref1111.style,
      tabIndex = _ref1111.tabIndex,
      rest = _objectWithoutProperties$2(_ref1111, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1111 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1111.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1111, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 14v3a7 7 0 0 1-14 0v-3H7v3a9 9 0 0 0 8 8.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3z'
  }), React.createElement('path', {
    d: 'M16 22a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v10a5 5 0 0 0 5 5z'
  }));
});
MicrophoneFilled24.displayName = 'MicrophoneFilled24';
MicrophoneFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneFilled20 = React.forwardRef(function (_ref1112, ref) {
  var className = _ref1112.className,
      children = _ref1112.children,
      style = _ref1112.style,
      tabIndex = _ref1112.tabIndex,
      rest = _objectWithoutProperties$2(_ref1112, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1112 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1112.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1112, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 14v3a7 7 0 0 1-14 0v-3H7v3a9 9 0 0 0 8 8.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3z'
  }), React.createElement('path', {
    d: 'M16 22a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v10a5 5 0 0 0 5 5z'
  }));
});
MicrophoneFilled20.displayName = 'MicrophoneFilled20';
MicrophoneFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneOffFilled32 = React.forwardRef(function (_ref1113, ref) {
  var className = _ref1113.className,
      children = _ref1113.children,
      style = _ref1113.style,
      tabIndex = _ref1113.tabIndex,
      rest = _objectWithoutProperties$2(_ref1113, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1113 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1113.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1113, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 17a7 7 0 0 1-11.73 5.14l1.42-1.41A5 5 0 0 0 21 17v-4.58l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0 0 15 25.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3h-2zm-14 .32V14H7v3a9 9 0 0 0 .25 2.09zM20.76 5.58A5 5 0 0 0 11 7v8.34z'
  }));
});
MicrophoneOffFilled32.displayName = 'MicrophoneOffFilled32';
MicrophoneOffFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneOffFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneOffFilled24 = React.forwardRef(function (_ref1114, ref) {
  var className = _ref1114.className,
      children = _ref1114.children,
      style = _ref1114.style,
      tabIndex = _ref1114.tabIndex,
      rest = _objectWithoutProperties$2(_ref1114, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1114 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1114.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1114, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 17a7 7 0 0 1-11.73 5.14l1.42-1.41A5 5 0 0 0 21 17v-4.58l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0 0 15 25.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3h-2zm-14 .32V14H7v3a9 9 0 0 0 .25 2.09zM20.76 5.58A5 5 0 0 0 11 7v8.34z'
  }));
});
MicrophoneOffFilled24.displayName = 'MicrophoneOffFilled24';
MicrophoneOffFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneOffFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneOffFilled20 = React.forwardRef(function (_ref1115, ref) {
  var className = _ref1115.className,
      children = _ref1115.children,
      style = _ref1115.style,
      tabIndex = _ref1115.tabIndex,
      rest = _objectWithoutProperties$2(_ref1115, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1115 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1115.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1115, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 17a7 7 0 0 1-11.73 5.14l1.42-1.41A5 5 0 0 0 21 17v-4.58l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0 0 15 25.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3h-2zm-14 .32V14H7v3a9 9 0 0 0 .25 2.09zM20.76 5.58A5 5 0 0 0 11 7v8.34z'
  }));
});
MicrophoneOffFilled20.displayName = 'MicrophoneOffFilled20';
MicrophoneOffFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneOffFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneOff32 = React.forwardRef(function (_ref1116, ref) {
  var className = _ref1116.className,
      children = _ref1116.children,
      style = _ref1116.style,
      tabIndex = _ref1116.tabIndex,
      rest = _objectWithoutProperties$2(_ref1116, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1116 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1116.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1116, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.18 18.57A7.41 7.41 0 0 1 9 17v-3H7v3a8.84 8.84 0 0 0 .58 3.18zM13 15V7a3 3 0 0 1 6 0v1.75l2-2A5 5 0 0 0 11 7v8zm10 2a7 7 0 0 1-11.73 5.14l1.42-1.41A5 5 0 0 0 21 17v-4.58l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0 0 15 25.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3h-2zm-4 0a3 3 0 0 1-4.9 2.31l4.9-4.89z'
  }));
});
MicrophoneOff32.displayName = 'MicrophoneOff32';
MicrophoneOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneOff24 = React.forwardRef(function (_ref1117, ref) {
  var className = _ref1117.className,
      children = _ref1117.children,
      style = _ref1117.style,
      tabIndex = _ref1117.tabIndex,
      rest = _objectWithoutProperties$2(_ref1117, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1117 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1117.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1117, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.18 18.57A7.41 7.41 0 0 1 9 17v-3H7v3a8.84 8.84 0 0 0 .58 3.18zM13 15V7a3 3 0 0 1 6 0v1.75l2-2A5 5 0 0 0 11 7v8zm10 2a7 7 0 0 1-11.73 5.14l1.42-1.41A5 5 0 0 0 21 17v-4.58l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0 0 15 25.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3h-2zm-4 0a3 3 0 0 1-4.9 2.31l4.9-4.89z'
  }));
});
MicrophoneOff24.displayName = 'MicrophoneOff24';
MicrophoneOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MicrophoneOff20 = React.forwardRef(function (_ref1118, ref) {
  var className = _ref1118.className,
      children = _ref1118.children,
      style = _ref1118.style,
      tabIndex = _ref1118.tabIndex,
      rest = _objectWithoutProperties$2(_ref1118, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1118 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1118.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1118, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.18 18.57A7.41 7.41 0 0 1 9 17v-3H7v3a8.84 8.84 0 0 0 .58 3.18zM13 15V7a3 3 0 0 1 6 0v1.75l2-2A5 5 0 0 0 11 7v8zm10 2a7 7 0 0 1-11.73 5.14l1.42-1.41A5 5 0 0 0 21 17v-4.58l9-9L28.59 2 2 28.59 3.41 30l6.44-6.44A8.91 8.91 0 0 0 15 25.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3h-2zm-4 0a3 3 0 0 1-4.9 2.31l4.9-4.89z'
  }));
});
MicrophoneOff20.displayName = 'MicrophoneOff20';
MicrophoneOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MicrophoneOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Microphone32 = React.forwardRef(function (_ref1119, ref) {
  var className = _ref1119.className,
      children = _ref1119.children,
      style = _ref1119.style,
      tabIndex = _ref1119.tabIndex,
      rest = _objectWithoutProperties$2(_ref1119, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1119 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1119.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1119, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 14v3a7 7 0 0 1-14 0v-3H7v3a9 9 0 0 0 8 8.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3z'
  }), React.createElement('path', {
    d: 'M16 22a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v10a5 5 0 0 0 5 5zM13 7a3 3 0 0 1 6 0v10a3 3 0 0 1-6 0z'
  }));
});
Microphone32.displayName = 'Microphone32';
Microphone32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Microphone32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Microphone24 = React.forwardRef(function (_ref1120, ref) {
  var className = _ref1120.className,
      children = _ref1120.children,
      style = _ref1120.style,
      tabIndex = _ref1120.tabIndex,
      rest = _objectWithoutProperties$2(_ref1120, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1120 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1120.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1120, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 14v3a7 7 0 0 1-14 0v-3H7v3a9 9 0 0 0 8 8.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3z'
  }), React.createElement('path', {
    d: 'M16 22a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v10a5 5 0 0 0 5 5zM13 7a3 3 0 0 1 6 0v10a3 3 0 0 1-6 0z'
  }));
});
Microphone24.displayName = 'Microphone24';
Microphone24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Microphone24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Microphone20 = React.forwardRef(function (_ref1121, ref) {
  var className = _ref1121.className,
      children = _ref1121.children,
      style = _ref1121.style,
      tabIndex = _ref1121.tabIndex,
      rest = _objectWithoutProperties$2(_ref1121, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1121 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1121.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1121, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 14v3a7 7 0 0 1-14 0v-3H7v3a9 9 0 0 0 8 8.94V28h-4v2h10v-2h-4v-2.06A9 9 0 0 0 25 17v-3z'
  }), React.createElement('path', {
    d: 'M16 22a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v10a5 5 0 0 0 5 5zM13 7a3 3 0 0 1 6 0v10a3 3 0 0 1-6 0z'
  }));
});
Microphone20.displayName = 'Microphone20';
Microphone20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Microphone20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Migrate32 = React.forwardRef(function (_ref1122, ref) {
  var className = _ref1122.className,
      children = _ref1122.children,
      style = _ref1122.style,
      tabIndex = _ref1122.tabIndex,
      rest = _objectWithoutProperties$2(_ref1122, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1122 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1122.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1122, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4h4v4H6zm20 4H12V4h14zm0 14H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM6 24h14v4H6zm20 4h-4v-4h4z'
  }));
});
Migrate32.displayName = 'Migrate32';
Migrate32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Migrate32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Migrate24 = React.forwardRef(function (_ref1123, ref) {
  var className = _ref1123.className,
      children = _ref1123.children,
      style = _ref1123.style,
      tabIndex = _ref1123.tabIndex,
      rest = _objectWithoutProperties$2(_ref1123, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1123 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1123.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1123, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4h4v4H6zm20 4H12V4h14zm0 14H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM6 24h14v4H6zm20 4h-4v-4h4z'
  }));
});
Migrate24.displayName = 'Migrate24';
Migrate24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Migrate24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Migrate20 = React.forwardRef(function (_ref1124, ref) {
  var className = _ref1124.className,
      children = _ref1124.children,
      style = _ref1124.style,
      tabIndex = _ref1124.tabIndex,
      rest = _objectWithoutProperties$2(_ref1124, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1124 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1124.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1124, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h9v6.17l-2.59-2.58L11 15l5 5 5-5-1.41-1.41L17 16.17V10h9a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 4h4v4H6zm20 4H12V4h14zm0 14H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM6 24h14v4H6zm20 4h-4v-4h4z'
  }));
});
Migrate20.displayName = 'Migrate20';
Migrate20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Migrate20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Minimize32 = React.forwardRef(function (_ref1125, ref) {
  var className = _ref1125.className,
      children = _ref1125.children,
      style = _ref1125.style,
      tabIndex = _ref1125.tabIndex,
      rest = _objectWithoutProperties$2(_ref1125, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1125 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1125.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1125, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 17v2h5.59L2 28.58 3.41 30 13 20.41V26h2v-9H6zM30 3.42L28.59 2 19 11.59V6h-2v9h9v-2h-5.59L30 3.42z'
  }));
});
Minimize32.displayName = 'Minimize32';
Minimize32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Minimize32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Minimize24 = React.forwardRef(function (_ref1126, ref) {
  var className = _ref1126.className,
      children = _ref1126.children,
      style = _ref1126.style,
      tabIndex = _ref1126.tabIndex,
      rest = _objectWithoutProperties$2(_ref1126, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1126 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1126.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1126, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 17v2h5.59L2 28.58 3.41 30 13 20.41V26h2v-9H6zM30 3.42L28.59 2 19 11.59V6h-2v9h9v-2h-5.59L30 3.42z'
  }));
});
Minimize24.displayName = 'Minimize24';
Minimize24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Minimize24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Minimize20 = React.forwardRef(function (_ref1127, ref) {
  var className = _ref1127.className,
      children = _ref1127.children,
      style = _ref1127.style,
      tabIndex = _ref1127.tabIndex,
      rest = _objectWithoutProperties$2(_ref1127, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1127 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1127.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1127, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 17v2h5.59L2 28.58 3.41 30 13 20.41V26h2v-9H6zM30 3.42L28.59 2 19 11.59V6h-2v9h9v-2h-5.59L30 3.42z'
  }));
});
Minimize20.displayName = 'Minimize20';
Minimize20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Minimize20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Misuse32 = React.forwardRef(function (_ref1128, ref) {
  var className = _ref1128.className,
      children = _ref1128.children,
      style = _ref1128.style,
      tabIndex = _ref1128.tabIndex,
      rest = _objectWithoutProperties$2(_ref1128, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1128 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1128.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1128, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm5.41 21L16 17.59 10.59 23 9 21.41 14.41 16 9 10.59 10.59 9 16 14.41 21.41 9 23 10.59 17.59 16 23 21.41z'
  }));
});
Misuse32.displayName = 'Misuse32';
Misuse32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Misuse32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Misuse24 = React.forwardRef(function (_ref1129, ref) {
  var className = _ref1129.className,
      children = _ref1129.children,
      style = _ref1129.style,
      tabIndex = _ref1129.tabIndex,
      rest = _objectWithoutProperties$2(_ref1129, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1129 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1129.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1129, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm5.41 21L16 17.59 10.59 23 9 21.41 14.41 16 9 10.59 10.59 9 16 14.41 21.41 9 23 10.59 17.59 16 23 21.41z'
  }));
});
Misuse24.displayName = 'Misuse24';
Misuse24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Misuse24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Misuse20 = React.forwardRef(function (_ref1130, ref) {
  var className = _ref1130.className,
      children = _ref1130.children,
      style = _ref1130.style,
      tabIndex = _ref1130.tabIndex,
      rest = _objectWithoutProperties$2(_ref1130, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1130 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1130.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1130, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm5.41 21L16 17.59 10.59 23 9 21.41 14.41 16 9 10.59 10.59 9 16 14.41 21.41 9 23 10.59 17.59 16 23 21.41z'
  }));
});
Misuse20.displayName = 'Misuse20';
Misuse20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Misuse20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileAdd32 = React.forwardRef(function (_ref1131, ref) {
  var className = _ref1131.className,
      children = _ref1131.children,
      style = _ref1131.style,
      tabIndex = _ref1131.tabIndex,
      rest = _objectWithoutProperties$2(_ref1131, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1131 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1131.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1131, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v2H8V4h16zm0 4v16H8V8h16zM8 28v-2h16v2H8z'
  }), React.createElement('path', {
    d: 'M21 15h-4v-4h-2v4h-4v2h4v4h2v-4h4z'
  }));
});
MobileAdd32.displayName = 'MobileAdd32';
MobileAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileAdd24 = React.forwardRef(function (_ref1132, ref) {
  var className = _ref1132.className,
      children = _ref1132.children,
      style = _ref1132.style,
      tabIndex = _ref1132.tabIndex,
      rest = _objectWithoutProperties$2(_ref1132, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1132 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1132.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1132, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v2H8V4h16zm0 4v16H8V8h16zM8 28v-2h16v2H8z'
  }), React.createElement('path', {
    d: 'M21 15h-4v-4h-2v4h-4v2h4v4h2v-4h4z'
  }));
});
MobileAdd24.displayName = 'MobileAdd24';
MobileAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileAdd20 = React.forwardRef(function (_ref1133, ref) {
  var className = _ref1133.className,
      children = _ref1133.children,
      style = _ref1133.style,
      tabIndex = _ref1133.tabIndex,
      rest = _objectWithoutProperties$2(_ref1133, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1133 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1133.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1133, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v2H8V4h16zm0 4v16H8V8h16zM8 28v-2h16v2H8z'
  }), React.createElement('path', {
    d: 'M21 15h-4v-4h-2v4h-4v2h4v4h2v-4h4z'
  }));
});
MobileAdd20.displayName = 'MobileAdd20';
MobileAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileCheck32 = React.forwardRef(function (_ref1134, ref) {
  var className = _ref1134.className,
      children = _ref1134.children,
      style = _ref1134.style,
      tabIndex = _ref1134.tabIndex,
      rest = _objectWithoutProperties$2(_ref1134, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1134 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1134.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1134, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }), React.createElement('path', {
    d: 'M14 18.18l-2.59-2.59L10 17l4 4 8-8-1.41-1.41L14 18.18z'
  }));
});
MobileCheck32.displayName = 'MobileCheck32';
MobileCheck32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileCheck32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileCheck24 = React.forwardRef(function (_ref1135, ref) {
  var className = _ref1135.className,
      children = _ref1135.children,
      style = _ref1135.style,
      tabIndex = _ref1135.tabIndex,
      rest = _objectWithoutProperties$2(_ref1135, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1135 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1135.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1135, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }), React.createElement('path', {
    d: 'M14 18.18l-2.59-2.59L10 17l4 4 8-8-1.41-1.41L14 18.18z'
  }));
});
MobileCheck24.displayName = 'MobileCheck24';
MobileCheck24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileCheck24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileCheck20 = React.forwardRef(function (_ref1136, ref) {
  var className = _ref1136.className,
      children = _ref1136.children,
      style = _ref1136.style,
      tabIndex = _ref1136.tabIndex,
      rest = _objectWithoutProperties$2(_ref1136, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1136 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1136.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1136, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }), React.createElement('path', {
    d: 'M14 18.18l-2.59-2.59L10 17l4 4 8-8-1.41-1.41L14 18.18z'
  }));
});
MobileCheck20.displayName = 'MobileCheck20';
MobileCheck20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileCheck20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileDownload32 = React.forwardRef(function (_ref1137, ref) {
  var className = _ref1137.className,
      children = _ref1137.children,
      style = _ref1137.style,
      tabIndex = _ref1137.tabIndex,
      rest = _objectWithoutProperties$2(_ref1137, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1137 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1137.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1137, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }), React.createElement('path', {
    d: 'M21 17l-1.41-1.41L17 18.17V10h-2v8.17l-2.59-2.58L11 17l5 5 5-5z'
  }));
});
MobileDownload32.displayName = 'MobileDownload32';
MobileDownload32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileDownload32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileDownload24 = React.forwardRef(function (_ref1138, ref) {
  var className = _ref1138.className,
      children = _ref1138.children,
      style = _ref1138.style,
      tabIndex = _ref1138.tabIndex,
      rest = _objectWithoutProperties$2(_ref1138, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1138 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1138.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1138, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }), React.createElement('path', {
    d: 'M21 17l-1.41-1.41L17 18.17V10h-2v8.17l-2.59-2.58L11 17l5 5 5-5z'
  }));
});
MobileDownload24.displayName = 'MobileDownload24';
MobileDownload24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileDownload24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var MobileDownload20 = React.forwardRef(function (_ref1139, ref) {
  var className = _ref1139.className,
      children = _ref1139.children,
      style = _ref1139.style,
      tabIndex = _ref1139.tabIndex,
      rest = _objectWithoutProperties$2(_ref1139, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1139 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1139.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1139, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }), React.createElement('path', {
    d: 'M21 17l-1.41-1.41L17 18.17V10h-2v8.17l-2.59-2.58L11 17l5 5 5-5z'
  }));
});
MobileDownload20.displayName = 'MobileDownload20';
MobileDownload20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
MobileDownload20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mobile32 = React.forwardRef(function (_ref1140, ref) {
  var className = _ref1140.className,
      children = _ref1140.children,
      style = _ref1140.style,
      tabIndex = _ref1140.tabIndex,
      rest = _objectWithoutProperties$2(_ref1140, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1140 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1140.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1140, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }));
});
Mobile32.displayName = 'Mobile32';
Mobile32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mobile32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mobile24 = React.forwardRef(function (_ref1141, ref) {
  var className = _ref1141.className,
      children = _ref1141.children,
      style = _ref1141.style,
      tabIndex = _ref1141.tabIndex,
      rest = _objectWithoutProperties$2(_ref1141, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1141 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1141.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1141, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }));
});
Mobile24.displayName = 'Mobile24';
Mobile24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mobile24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Mobile20 = React.forwardRef(function (_ref1142, ref) {
  var className = _ref1142.className,
      children = _ref1142.children,
      style = _ref1142.style,
      tabIndex = _ref1142.tabIndex,
      rest = _objectWithoutProperties$2(_ref1142, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1142 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1142.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1142, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2v2H8V4zm0 4v16H8V8zM8 28v-2h16v2z'
  }));
});
Mobile20.displayName = 'Mobile20';
Mobile20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Mobile20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Move32 = React.forwardRef(function (_ref1143, ref) {
  var className = _ref1143.className,
      children = _ref1143.children,
      style = _ref1143.style,
      tabIndex = _ref1143.tabIndex,
      rest = _objectWithoutProperties$2(_ref1143, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1143 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1143.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1143, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 11l-1.41 1.41L26.17 15H17V5.83l2.59 2.58L21 7l-5-5-5 5 1.41 1.41L15 5.83V15H5.83l2.58-2.59L7 11l-5 5 5 5 1.41-1.41L5.83 17H15v9.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17V17h9.17l-2.58 2.59L25 21l5-5-5-5z'
  }));
});
Move32.displayName = 'Move32';
Move32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Move32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Move24 = React.forwardRef(function (_ref1144, ref) {
  var className = _ref1144.className,
      children = _ref1144.children,
      style = _ref1144.style,
      tabIndex = _ref1144.tabIndex,
      rest = _objectWithoutProperties$2(_ref1144, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1144 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1144.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1144, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 11l-1.41 1.41L26.17 15H17V5.83l2.59 2.58L21 7l-5-5-5 5 1.41 1.41L15 5.83V15H5.83l2.58-2.59L7 11l-5 5 5 5 1.41-1.41L5.83 17H15v9.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17V17h9.17l-2.58 2.59L25 21l5-5-5-5z'
  }));
});
Move24.displayName = 'Move24';
Move24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Move24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Move20 = React.forwardRef(function (_ref1145, ref) {
  var className = _ref1145.className,
      children = _ref1145.children,
      style = _ref1145.style,
      tabIndex = _ref1145.tabIndex,
      rest = _objectWithoutProperties$2(_ref1145, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1145 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1145.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1145, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 11l-1.41 1.41L26.17 15H17V5.83l2.59 2.58L21 7l-5-5-5 5 1.41 1.41L15 5.83V15H5.83l2.58-2.59L7 11l-5 5 5 5 1.41-1.41L5.83 17H15v9.17l-2.59-2.58L11 25l5 5 5-5-1.41-1.41L17 26.17V17h9.17l-2.58 2.59L25 21l5-5-5-5z'
  }));
});
Move20.displayName = 'Move20';
Move20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Move20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Movement32 = React.forwardRef(function (_ref1146, ref) {
  var className = _ref1146.className,
      children = _ref1146.children,
      style = _ref1146.style,
      tabIndex = _ref1146.tabIndex,
      rest = _objectWithoutProperties$2(_ref1146, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1146 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1146.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1146, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 20l-1.41 1.41L26.17 25H10a4 4 0 0 1 0-8h12a6 6 0 0 0 0-12H5.83l3.58-3.59L8 0 2 6l6 6 1.41-1.41L5.83 7H22a4 4 0 0 1 0 8H10a6 6 0 0 0 0 12h16.17l-3.58 3.59L24 32l6-6z'
  }));
});
Movement32.displayName = 'Movement32';
Movement32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Movement32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Movement24 = React.forwardRef(function (_ref1147, ref) {
  var className = _ref1147.className,
      children = _ref1147.children,
      style = _ref1147.style,
      tabIndex = _ref1147.tabIndex,
      rest = _objectWithoutProperties$2(_ref1147, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1147 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1147.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1147, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 20l-1.41 1.41L26.17 25H10a4 4 0 0 1 0-8h12a6 6 0 0 0 0-12H5.83l3.58-3.59L8 0 2 6l6 6 1.41-1.41L5.83 7H22a4 4 0 0 1 0 8H10a6 6 0 0 0 0 12h16.17l-3.58 3.59L24 32l6-6z'
  }));
});
Movement24.displayName = 'Movement24';
Movement24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Movement24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Movement20 = React.forwardRef(function (_ref1148, ref) {
  var className = _ref1148.className,
      children = _ref1148.children,
      style = _ref1148.style,
      tabIndex = _ref1148.tabIndex,
      rest = _objectWithoutProperties$2(_ref1148, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1148 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1148.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1148, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 20l-1.41 1.41L26.17 25H10a4 4 0 0 1 0-8h12a6 6 0 0 0 0-12H5.83l3.58-3.59L8 0 2 6l6 6 1.41-1.41L5.83 7H22a4 4 0 0 1 0 8H10a6 6 0 0 0 0 12h16.17l-3.58 3.59L24 32l6-6z'
  }));
});
Movement20.displayName = 'Movement20';
Movement20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Movement20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NewTab32 = React.forwardRef(function (_ref1149, ref) {
  var className = _ref1149.className,
      children = _ref1149.children,
      style = _ref1149.style,
      tabIndex = _ref1149.tabIndex,
      rest = _objectWithoutProperties$2(_ref1149, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1149 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1149.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1149, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 26H6V6h9V4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-9h-2zm0-20V2h-2v4h-4v2h4v4h2V8h4V6h-4z'
  }));
});
NewTab32.displayName = 'NewTab32';
NewTab32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NewTab32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NewTab24 = React.forwardRef(function (_ref1150, ref) {
  var className = _ref1150.className,
      children = _ref1150.children,
      style = _ref1150.style,
      tabIndex = _ref1150.tabIndex,
      rest = _objectWithoutProperties$2(_ref1150, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1150 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1150.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1150, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 26H6V6h9V4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-9h-2zm0-20V2h-2v4h-4v2h4v4h2V8h4V6h-4z'
  }));
});
NewTab24.displayName = 'NewTab24';
NewTab24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NewTab24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NewTab20 = React.forwardRef(function (_ref1151, ref) {
  var className = _ref1151.className,
      children = _ref1151.children,
      style = _ref1151.style,
      tabIndex = _ref1151.tabIndex,
      rest = _objectWithoutProperties$2(_ref1151, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1151 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1151.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1151, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 26H6V6h9V4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-9h-2zm0-20V2h-2v4h-4v2h4v4h2V8h4V6h-4z'
  }));
});
NewTab20.displayName = 'NewTab20';
NewTab20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NewTab20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationFilled32 = React.forwardRef(function (_ref1152, ref) {
  var className = _ref1152.className,
      children = _ref1152.children,
      style = _ref1152.style,
      tabIndex = _ref1152.tabIndex,
      rest = _objectWithoutProperties$2(_ref1152, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1152 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1152.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1152, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.7 20.3L26 17.6V13a10.07 10.07 0 0 0-9-10V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z'
  }));
});
NotificationFilled32.displayName = 'NotificationFilled32';
NotificationFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationFilled24 = React.forwardRef(function (_ref1153, ref) {
  var className = _ref1153.className,
      children = _ref1153.children,
      style = _ref1153.style,
      tabIndex = _ref1153.tabIndex,
      rest = _objectWithoutProperties$2(_ref1153, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1153 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1153.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1153, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.7 20.3L26 17.6V13a10.07 10.07 0 0 0-9-10V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z'
  }));
});
NotificationFilled24.displayName = 'NotificationFilled24';
NotificationFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationFilled20 = React.forwardRef(function (_ref1154, ref) {
  var className = _ref1154.className,
      children = _ref1154.children,
      style = _ref1154.style,
      tabIndex = _ref1154.tabIndex,
      rest = _objectWithoutProperties$2(_ref1154, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1154 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1154.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1154, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.7 20.3L26 17.6V13a10.07 10.07 0 0 0-9-10V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z'
  }));
});
NotificationFilled20.displayName = 'NotificationFilled20';
NotificationFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationNew32 = React.forwardRef(function (_ref1155, ref) {
  var className = _ref1155.className,
      children = _ref1155.children,
      style = _ref1155.style,
      tabIndex = _ref1155.tabIndex,
      rest = _objectWithoutProperties$2(_ref1155, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1155 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1155.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1155, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 17.6V15h-2v3a.91.91 0 0 0 .3.7l2.7 2.7V23H5v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 8-8 7.89 7.89 0 0 1 4 1.09V3.8a9.71 9.71 0 0 0-3-.8V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z'
  }), React.createElement('circle', {
    cx: '26',
    cy: '8',
    r: '4'
  }));
});
NotificationNew32.displayName = 'NotificationNew32';
NotificationNew32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationNew32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationNew24 = React.forwardRef(function (_ref1156, ref) {
  var className = _ref1156.className,
      children = _ref1156.children,
      style = _ref1156.style,
      tabIndex = _ref1156.tabIndex,
      rest = _objectWithoutProperties$2(_ref1156, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1156 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1156.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1156, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 17.6V15h-2v3a.91.91 0 0 0 .3.7l2.7 2.7V23H5v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 8-8 7.89 7.89 0 0 1 4 1.09V3.8a9.71 9.71 0 0 0-3-.8V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z'
  }), React.createElement('circle', {
    cx: '26',
    cy: '8',
    r: '4'
  }));
});
NotificationNew24.displayName = 'NotificationNew24';
NotificationNew24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationNew24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationNew20 = React.forwardRef(function (_ref1157, ref) {
  var className = _ref1157.className,
      children = _ref1157.children,
      style = _ref1157.style,
      tabIndex = _ref1157.tabIndex,
      rest = _objectWithoutProperties$2(_ref1157, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1157 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1157.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1157, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 17.6V15h-2v3a.91.91 0 0 0 .3.7l2.7 2.7V23H5v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 8-8 7.89 7.89 0 0 1 4 1.09V3.8a9.71 9.71 0 0 0-3-.8V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z'
  }), React.createElement('circle', {
    cx: '26',
    cy: '8',
    r: '4'
  }));
});
NotificationNew20.displayName = 'NotificationNew20';
NotificationNew20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationNew20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationOffFilled32 = React.forwardRef(function (_ref1158, ref) {
  var className = _ref1158.className,
      children = _ref1158.children,
      style = _ref1158.style,
      tabIndex = _ref1158.tabIndex,
      rest = _objectWithoutProperties$2(_ref1158, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1158 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1158.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1158, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 17.6V13a10 10 0 0 0-1.09-4.5L30 3.41 28.59 2 2 28.59 3.41 30l5-5H11a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm5.63-23.28A9.78 9.78 0 0 0 17 3V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v2.34z'
  }));
});
NotificationOffFilled32.displayName = 'NotificationOffFilled32';
NotificationOffFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationOffFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationOffFilled24 = React.forwardRef(function (_ref1159, ref) {
  var className = _ref1159.className,
      children = _ref1159.children,
      style = _ref1159.style,
      tabIndex = _ref1159.tabIndex,
      rest = _objectWithoutProperties$2(_ref1159, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1159 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1159.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1159, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 17.6V13a10 10 0 0 0-1.09-4.5L30 3.41 28.59 2 2 28.59 3.41 30l5-5H11a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm5.63-23.28A9.78 9.78 0 0 0 17 3V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v2.34z'
  }));
});
NotificationOffFilled24.displayName = 'NotificationOffFilled24';
NotificationOffFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationOffFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationOffFilled20 = React.forwardRef(function (_ref1160, ref) {
  var className = _ref1160.className,
      children = _ref1160.children,
      style = _ref1160.style,
      tabIndex = _ref1160.tabIndex,
      rest = _objectWithoutProperties$2(_ref1160, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1160 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1160.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1160, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 17.6V13a10 10 0 0 0-1.09-4.5L30 3.41 28.59 2 2 28.59 3.41 30l5-5H11a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm5.63-23.28A9.78 9.78 0 0 0 17 3V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v2.34z'
  }));
});
NotificationOffFilled20.displayName = 'NotificationOffFilled20';
NotificationOffFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationOffFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationOff32 = React.forwardRef(function (_ref1161, ref) {
  var className = _ref1161.className,
      children = _ref1161.children,
      style = _ref1161.style,
      tabIndex = _ref1161.tabIndex,
      rest = _objectWithoutProperties$2(_ref1161, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1161 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1161.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1161, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 23v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 13-6.24l1.44-1.43A9.79 9.79 0 0 0 17 3V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v2zm21-5.4V13a10 10 0 0 0-1.09-4.5L30 3.41 28.59 2 2 28.59 3.41 30l5-5H11a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm11-5H10.42l13-13a8.06 8.06 0 0 1 .58 3v5a.91.91 0 0 0 .3.7l2.7 2.7z'
  }));
});
NotificationOff32.displayName = 'NotificationOff32';
NotificationOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationOff24 = React.forwardRef(function (_ref1162, ref) {
  var className = _ref1162.className,
      children = _ref1162.children,
      style = _ref1162.style,
      tabIndex = _ref1162.tabIndex,
      rest = _objectWithoutProperties$2(_ref1162, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1162 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1162.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1162, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 23v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 13-6.24l1.44-1.43A9.79 9.79 0 0 0 17 3V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v2zm21-5.4V13a10 10 0 0 0-1.09-4.5L30 3.41 28.59 2 2 28.59 3.41 30l5-5H11a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm11-5H10.42l13-13a8.06 8.06 0 0 1 .58 3v5a.91.91 0 0 0 .3.7l2.7 2.7z'
  }));
});
NotificationOff24.displayName = 'NotificationOff24';
NotificationOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NotificationOff20 = React.forwardRef(function (_ref1163, ref) {
  var className = _ref1163.className,
      children = _ref1163.children,
      style = _ref1163.style,
      tabIndex = _ref1163.tabIndex,
      rest = _objectWithoutProperties$2(_ref1163, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1163 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1163.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1163, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 23v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 13-6.24l1.44-1.43A9.79 9.79 0 0 0 17 3V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v2zm21-5.4V13a10 10 0 0 0-1.09-4.5L30 3.41 28.59 2 2 28.59 3.41 30l5-5H11a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm11-5H10.42l13-13a8.06 8.06 0 0 1 .58 3v5a.91.91 0 0 0 .3.7l2.7 2.7z'
  }));
});
NotificationOff20.displayName = 'NotificationOff20';
NotificationOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NotificationOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Notification32 = React.forwardRef(function (_ref1164, ref) {
  var className = _ref1164.className,
      children = _ref1164.children,
      style = _ref1164.style,
      tabIndex = _ref1164.tabIndex,
      rest = _objectWithoutProperties$2(_ref1164, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1164 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1164.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1164, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.7 20.3L26 17.6V13a10.07 10.07 0 0 0-9-10V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm11-5H5v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 16 0v5a.91.91 0 0 0 .3.7l2.7 2.7z'
  }));
});
Notification32.displayName = 'Notification32';
Notification32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Notification32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Notification24 = React.forwardRef(function (_ref1165, ref) {
  var className = _ref1165.className,
      children = _ref1165.children,
      style = _ref1165.style,
      tabIndex = _ref1165.tabIndex,
      rest = _objectWithoutProperties$2(_ref1165, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1165 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1165.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1165, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.7 20.3L26 17.6V13a10.07 10.07 0 0 0-9-10V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm11-5H5v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 16 0v5a.91.91 0 0 0 .3.7l2.7 2.7z'
  }));
});
Notification24.displayName = 'Notification24';
Notification24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Notification24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Notification20 = React.forwardRef(function (_ref1166, ref) {
  var className = _ref1166.className,
      children = _ref1166.children,
      style = _ref1166.style,
      tabIndex = _ref1166.tabIndex,
      rest = _objectWithoutProperties$2(_ref1166, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1166 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1166.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1166, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.7 20.3L26 17.6V13a10.07 10.07 0 0 0-9-10V1h-2v2a10.15 10.15 0 0 0-9 10v4.6l-2.7 2.7a.91.91 0 0 0-.3.7v3a.94.94 0 0 0 1 1h7a5 5 0 0 0 10 0h7a.94.94 0 0 0 1-1v-3a.91.91 0 0 0-.3-.7zM16 28a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3zm11-5H5v-1.6l2.7-2.7A.91.91 0 0 0 8 18v-5a8 8 0 0 1 16 0v5a.91.91 0 0 0 .3.7l2.7 2.7z'
  }));
});
Notification20.displayName = 'Notification20';
Notification20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Notification20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_032 = React.forwardRef(function (_ref1167, ref) {
  var className = _ref1167.className,
      children = _ref1167.children,
      style = _ref1167.style,
      tabIndex = _ref1167.tabIndex,
      rest = _objectWithoutProperties$2(_ref1167, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1167 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1167.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1167, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11z'
  }), React.createElement('path', {
    d: 'M15 15h2v2h-2z'
  }));
});
Number_032.displayName = 'Number_032';
Number_032.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_032.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_024 = React.forwardRef(function (_ref1168, ref) {
  var className = _ref1168.className,
      children = _ref1168.children,
      style = _ref1168.style,
      tabIndex = _ref1168.tabIndex,
      rest = _objectWithoutProperties$2(_ref1168, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1168 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1168.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1168, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11z'
  }), React.createElement('path', {
    d: 'M15 15h2v2h-2z'
  }));
});
Number_024.displayName = 'Number_024';
Number_024.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_024.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_020 = React.forwardRef(function (_ref1169, ref) {
  var className = _ref1169.className,
      children = _ref1169.children,
      style = _ref1169.style,
      tabIndex = _ref1169.tabIndex,
      rest = _objectWithoutProperties$2(_ref1169, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1169 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1169.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1169, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2zm-4-12v10h4V11z'
  }), React.createElement('path', {
    d: 'M15 15h2v2h-2z'
  }));
});
Number_020.displayName = 'Number_020';
Number_020.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_020.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_132 = React.forwardRef(function (_ref1170, ref) {
  var className = _ref1170.className,
      children = _ref1170.children,
      style = _ref1170.style,
      tabIndex = _ref1170.tabIndex,
      rest = _objectWithoutProperties$2(_ref1170, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1170 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1170.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1170, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.5 22.5v-1h3v-11h-3v-1h4v12h3v1h-7z'
  }), React.createElement('path', {
    d: 'M16 10v12-12m1-1h-5v2h3v10h-3v2h8v-2h-3V9z'
  }));
});
Number_132.displayName = 'Number_132';
Number_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_124 = React.forwardRef(function (_ref1171, ref) {
  var className = _ref1171.className,
      children = _ref1171.children,
      style = _ref1171.style,
      tabIndex = _ref1171.tabIndex,
      rest = _objectWithoutProperties$2(_ref1171, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1171 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1171.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1171, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.5 22.5v-1h3v-11h-3v-1h4v12h3v1h-7z'
  }), React.createElement('path', {
    d: 'M16 10v12-12m1-1h-5v2h3v10h-3v2h8v-2h-3V9z'
  }));
});
Number_124.displayName = 'Number_124';
Number_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_120 = React.forwardRef(function (_ref1172, ref) {
  var className = _ref1172.className,
      children = _ref1172.children,
      style = _ref1172.style,
      tabIndex = _ref1172.tabIndex,
      rest = _objectWithoutProperties$2(_ref1172, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1172 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1172.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1172, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.5 22.5v-1h3v-11h-3v-1h4v12h3v1h-7z'
  }), React.createElement('path', {
    d: 'M16 10v12-12m1-1h-5v2h3v10h-3v2h8v-2h-3V9z'
  }));
});
Number_120.displayName = 'Number_120';
Number_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_232 = React.forwardRef(function (_ref1173, ref) {
  var className = _ref1173.className,
      children = _ref1173.children,
      style = _ref1173.style,
      tabIndex = _ref1173.tabIndex,
      rest = _objectWithoutProperties$2(_ref1173, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1173 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1173.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1173, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23h-8v-6a2 2 0 0 1 2-2h4v-4h-6V9h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4h6z'
  }));
});
Number_232.displayName = 'Number_232';
Number_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_224 = React.forwardRef(function (_ref1174, ref) {
  var className = _ref1174.className,
      children = _ref1174.children,
      style = _ref1174.style,
      tabIndex = _ref1174.tabIndex,
      rest = _objectWithoutProperties$2(_ref1174, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1174 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1174.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1174, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23h-8v-6a2 2 0 0 1 2-2h4v-4h-6V9h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4h6z'
  }));
});
Number_224.displayName = 'Number_224';
Number_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_220 = React.forwardRef(function (_ref1175, ref) {
  var className = _ref1175.className,
      children = _ref1175.children,
      style = _ref1175.style,
      tabIndex = _ref1175.tabIndex,
      rest = _objectWithoutProperties$2(_ref1175, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1175 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1175.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1175, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 23h-8v-6a2 2 0 0 1 2-2h4v-4h-6V9h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4v4h6z'
  }));
});
Number_220.displayName = 'Number_220';
Number_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_332 = React.forwardRef(function (_ref1176, ref) {
  var className = _ref1176.className,
      children = _ref1176.children,
      style = _ref1176.style,
      tabIndex = _ref1176.tabIndex,
      rest = _objectWithoutProperties$2(_ref1176, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1176 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1176.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1176, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-6v2h6v4h-4v2h4v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
Number_332.displayName = 'Number_332';
Number_332.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_332.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_324 = React.forwardRef(function (_ref1177, ref) {
  var className = _ref1177.className,
      children = _ref1177.children,
      style = _ref1177.style,
      tabIndex = _ref1177.tabIndex,
      rest = _objectWithoutProperties$2(_ref1177, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1177 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1177.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1177, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-6v2h6v4h-4v2h4v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
Number_324.displayName = 'Number_324';
Number_324.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_324.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_320 = React.forwardRef(function (_ref1178, ref) {
  var className = _ref1178.className,
      children = _ref1178.children,
      style = _ref1178.style,
      tabIndex = _ref1178.tabIndex,
      rest = _objectWithoutProperties$2(_ref1178, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1178 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1178.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1178, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-6v2h6v4h-4v2h4v4h-6v2h6a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z'
  }));
});
Number_320.displayName = 'Number_320';
Number_320.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_320.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_432 = React.forwardRef(function (_ref1179, ref) {
  var className = _ref1179.className,
      children = _ref1179.children,
      style = _ref1179.style,
      tabIndex = _ref1179.tabIndex,
      rest = _objectWithoutProperties$2(_ref1179, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1179 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1179.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1179, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.5 22.5v-4h-5v-9h1v8h4v-8h1v8h1v1h-1v4h-1z'
  }), React.createElement('path', {
    d: 'M18 10v8-8m1-1h-2v8h-3V9h-2v10h5v4h2v-4h1v-2h-1V9z'
  }));
});
Number_432.displayName = 'Number_432';
Number_432.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_432.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_424 = React.forwardRef(function (_ref1180, ref) {
  var className = _ref1180.className,
      children = _ref1180.children,
      style = _ref1180.style,
      tabIndex = _ref1180.tabIndex,
      rest = _objectWithoutProperties$2(_ref1180, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1180 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1180.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1180, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.5 22.5v-4h-5v-9h1v8h4v-8h1v8h1v1h-1v4h-1z'
  }), React.createElement('path', {
    d: 'M18 10v8-8m1-1h-2v8h-3V9h-2v10h5v4h2v-4h1v-2h-1V9z'
  }));
});
Number_424.displayName = 'Number_424';
Number_424.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_424.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_420 = React.forwardRef(function (_ref1181, ref) {
  var className = _ref1181.className,
      children = _ref1181.children,
      style = _ref1181.style,
      tabIndex = _ref1181.tabIndex,
      rest = _objectWithoutProperties$2(_ref1181, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1181 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1181.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1181, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.5 22.5v-4h-5v-9h1v8h4v-8h1v8h1v1h-1v4h-1z'
  }), React.createElement('path', {
    d: 'M18 10v8-8m1-1h-2v8h-3V9h-2v10h5v4h2v-4h1v-2h-1V9z'
  }));
});
Number_420.displayName = 'Number_420';
Number_420.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_420.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_532 = React.forwardRef(function (_ref1182, ref) {
  var className = _ref1182.className,
      children = _ref1182.children,
      style = _ref1182.style,
      tabIndex = _ref1182.tabIndex,
      rest = _objectWithoutProperties$2(_ref1182, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1182 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1182.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1182, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-6v-2h6v-4h-6V9h8v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Number_532.displayName = 'Number_532';
Number_532.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_532.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_524 = React.forwardRef(function (_ref1183, ref) {
  var className = _ref1183.className,
      children = _ref1183.children,
      style = _ref1183.style,
      tabIndex = _ref1183.tabIndex,
      rest = _objectWithoutProperties$2(_ref1183, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1183 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1183.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1183, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-6v-2h6v-4h-6V9h8v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Number_524.displayName = 'Number_524';
Number_524.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_524.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_520 = React.forwardRef(function (_ref1184, ref) {
  var className = _ref1184.className,
      children = _ref1184.children,
      style = _ref1184.style,
      tabIndex = _ref1184.tabIndex,
      rest = _objectWithoutProperties$2(_ref1184, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1184 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1184.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1184, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 23h-6v-2h6v-4h-6V9h8v2h-6v4h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2z'
  }));
});
Number_520.displayName = 'Number_520';
Number_520.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_520.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_632 = React.forwardRef(function (_ref1185, ref) {
  var className = _ref1185.className,
      children = _ref1185.children,
      style = _ref1185.style,
      tabIndex = _ref1185.tabIndex,
      rest = _objectWithoutProperties$2(_ref1185, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1185 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1185.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1185, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 14h-4v-3h5V9h-5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm-4 7v-5h4v5z'
  }));
});
Number_632.displayName = 'Number_632';
Number_632.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_632.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_624 = React.forwardRef(function (_ref1186, ref) {
  var className = _ref1186.className,
      children = _ref1186.children,
      style = _ref1186.style,
      tabIndex = _ref1186.tabIndex,
      rest = _objectWithoutProperties$2(_ref1186, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1186 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1186.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1186, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 14h-4v-3h5V9h-5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm-4 7v-5h4v5z'
  }));
});
Number_624.displayName = 'Number_624';
Number_624.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_624.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_620 = React.forwardRef(function (_ref1187, ref) {
  var className = _ref1187.className,
      children = _ref1187.children,
      style = _ref1187.style,
      tabIndex = _ref1187.tabIndex,
      rest = _objectWithoutProperties$2(_ref1187, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1187 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1187.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1187, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 14h-4v-3h5V9h-5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm-4 7v-5h4v5z'
  }));
});
Number_620.displayName = 'Number_620';
Number_620.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_620.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_732 = React.forwardRef(function (_ref1188, ref) {
  var className = _ref1188.className,
      children = _ref1188.children,
      style = _ref1188.style,
      tabIndex = _ref1188.tabIndex,
      rest = _objectWithoutProperties$2(_ref1188, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1188 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1188.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1188, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-8v4h2v-2h3.85L13 23h2.16L20 11V9z'
  }));
});
Number_732.displayName = 'Number_732';
Number_732.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_732.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_724 = React.forwardRef(function (_ref1189, ref) {
  var className = _ref1189.className,
      children = _ref1189.children,
      style = _ref1189.style,
      tabIndex = _ref1189.tabIndex,
      rest = _objectWithoutProperties$2(_ref1189, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1189 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1189.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1189, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-8v4h2v-2h3.85L13 23h2.16L20 11V9z'
  }));
});
Number_724.displayName = 'Number_724';
Number_724.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_724.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_720 = React.forwardRef(function (_ref1190, ref) {
  var className = _ref1190.className,
      children = _ref1190.children,
      style = _ref1190.style,
      tabIndex = _ref1190.tabIndex,
      rest = _objectWithoutProperties$2(_ref1190, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1190 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1190.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1190, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 9h-8v4h2v-2h3.85L13 23h2.16L20 11V9z'
  }));
});
Number_720.displayName = 'Number_720';
Number_720.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_720.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_832 = React.forwardRef(function (_ref1191, ref) {
  var className = _ref1191.className,
      children = _ref1191.children,
      style = _ref1191.style,
      tabIndex = _ref1191.tabIndex,
      rest = _objectWithoutProperties$2(_ref1191, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1191 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1191.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1191, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 2v4h-4v-4zm-4 10v-4h4v4z'
  }));
});
Number_832.displayName = 'Number_832';
Number_832.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_832.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_824 = React.forwardRef(function (_ref1192, ref) {
  var className = _ref1192.className,
      children = _ref1192.children,
      style = _ref1192.style,
      tabIndex = _ref1192.tabIndex,
      rest = _objectWithoutProperties$2(_ref1192, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1192 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1192.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1192, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 2v4h-4v-4zm-4 10v-4h4v4z'
  }));
});
Number_824.displayName = 'Number_824';
Number_824.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_824.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_820 = React.forwardRef(function (_ref1193, ref) {
  var className = _ref1193.className,
      children = _ref1193.children,
      style = _ref1193.style,
      tabIndex = _ref1193.tabIndex,
      rest = _objectWithoutProperties$2(_ref1193, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1193 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1193.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1193, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 2v4h-4v-4zm-4 10v-4h4v4z'
  }));
});
Number_820.displayName = 'Number_820';
Number_820.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_820.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_932 = React.forwardRef(function (_ref1194, ref) {
  var className = _ref1194.className,
      children = _ref1194.children,
      style = _ref1194.style,
      tabIndex = _ref1194.tabIndex,
      rest = _objectWithoutProperties$2(_ref1194, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1194 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1194.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1194, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4v3h-5v2h5a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 7h-4v-5h4z'
  }));
});
Number_932.displayName = 'Number_932';
Number_932.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_932.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_924 = React.forwardRef(function (_ref1195, ref) {
  var className = _ref1195.className,
      children = _ref1195.children,
      style = _ref1195.style,
      tabIndex = _ref1195.tabIndex,
      rest = _objectWithoutProperties$2(_ref1195, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1195 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1195.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1195, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4v3h-5v2h5a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 7h-4v-5h4z'
  }));
});
Number_924.displayName = 'Number_924';
Number_924.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_924.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Number_920 = React.forwardRef(function (_ref1196, ref) {
  var className = _ref1196.className,
      children = _ref1196.children,
      style = _ref1196.style,
      tabIndex = _ref1196.tabIndex,
      rest = _objectWithoutProperties$2(_ref1196, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1196 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1196.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1196, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 9h-4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4v3h-5v2h5a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm0 7h-4v-5h4z'
  }));
});
Number_920.displayName = 'Number_920';
Number_920.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Number_920.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_032 = React.forwardRef(function (_ref1197, ref) {
  var className = _ref1197.className,
      children = _ref1197.children,
      style = _ref1197.style,
      tabIndex = _ref1197.tabIndex,
      rest = _objectWithoutProperties$2(_ref1197, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1197 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1197.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1197, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6z'
  }));
});
NumberSmall_032.displayName = 'NumberSmall_032';
NumberSmall_032.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_032.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_024 = React.forwardRef(function (_ref1198, ref) {
  var className = _ref1198.className,
      children = _ref1198.children,
      style = _ref1198.style,
      tabIndex = _ref1198.tabIndex,
      rest = _objectWithoutProperties$2(_ref1198, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1198 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1198.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1198, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6z'
  }));
});
NumberSmall_024.displayName = 'NumberSmall_024';
NumberSmall_024.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_024.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_020 = React.forwardRef(function (_ref1199, ref) {
  var className = _ref1199.className,
      children = _ref1199.children,
      style = _ref1199.style,
      tabIndex = _ref1199.tabIndex,
      rest = _objectWithoutProperties$2(_ref1199, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1199 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1199.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1199, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6z'
  }));
});
NumberSmall_020.displayName = 'NumberSmall_020';
NumberSmall_020.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_020.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_132 = React.forwardRef(function (_ref1200, ref) {
  var className = _ref1200.className,
      children = _ref1200.children,
      style = _ref1200.style,
      tabIndex = _ref1200.tabIndex,
      rest = _objectWithoutProperties$2(_ref1200, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1200 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1200.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1200, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2z'
  }));
});
NumberSmall_132.displayName = 'NumberSmall_132';
NumberSmall_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_124 = React.forwardRef(function (_ref1201, ref) {
  var className = _ref1201.className,
      children = _ref1201.children,
      style = _ref1201.style,
      tabIndex = _ref1201.tabIndex,
      rest = _objectWithoutProperties$2(_ref1201, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1201 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1201.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1201, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2z'
  }));
});
NumberSmall_124.displayName = 'NumberSmall_124';
NumberSmall_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_120 = React.forwardRef(function (_ref1202, ref) {
  var className = _ref1202.className,
      children = _ref1202.children,
      style = _ref1202.style,
      tabIndex = _ref1202.tabIndex,
      rest = _objectWithoutProperties$2(_ref1202, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1202 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1202.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1202, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2z'
  }));
});
NumberSmall_120.displayName = 'NumberSmall_120';
NumberSmall_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_232 = React.forwardRef(function (_ref1203, ref) {
  var className = _ref1203.className,
      children = _ref1203.children,
      style = _ref1203.style,
      tabIndex = _ref1203.tabIndex,
      rest = _objectWithoutProperties$2(_ref1203, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1203 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1203.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1203, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 21h-6v-4a2 2 0 0 1 2-2h2v-2h-4v-2h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2h4z'
  }));
});
NumberSmall_232.displayName = 'NumberSmall_232';
NumberSmall_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_224 = React.forwardRef(function (_ref1204, ref) {
  var className = _ref1204.className,
      children = _ref1204.children,
      style = _ref1204.style,
      tabIndex = _ref1204.tabIndex,
      rest = _objectWithoutProperties$2(_ref1204, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1204 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1204.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1204, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 21h-6v-4a2 2 0 0 1 2-2h2v-2h-4v-2h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2h4z'
  }));
});
NumberSmall_224.displayName = 'NumberSmall_224';
NumberSmall_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_220 = React.forwardRef(function (_ref1205, ref) {
  var className = _ref1205.className,
      children = _ref1205.children,
      style = _ref1205.style,
      tabIndex = _ref1205.tabIndex,
      rest = _objectWithoutProperties$2(_ref1205, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1205 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1205.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1205, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 21h-6v-4a2 2 0 0 1 2-2h2v-2h-4v-2h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2h4z'
  }));
});
NumberSmall_220.displayName = 'NumberSmall_220';
NumberSmall_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_332 = React.forwardRef(function (_ref1206, ref) {
  var className = _ref1206.className,
      children = _ref1206.children,
      style = _ref1206.style,
      tabIndex = _ref1206.tabIndex,
      rest = _objectWithoutProperties$2(_ref1206, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1206 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1206.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1206, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11h-4v2h4v2h-3v2h3v2h-4v2h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z'
  }));
});
NumberSmall_332.displayName = 'NumberSmall_332';
NumberSmall_332.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_332.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_324 = React.forwardRef(function (_ref1207, ref) {
  var className = _ref1207.className,
      children = _ref1207.children,
      style = _ref1207.style,
      tabIndex = _ref1207.tabIndex,
      rest = _objectWithoutProperties$2(_ref1207, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1207 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1207.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1207, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11h-4v2h4v2h-3v2h3v2h-4v2h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z'
  }));
});
NumberSmall_324.displayName = 'NumberSmall_324';
NumberSmall_324.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_324.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_320 = React.forwardRef(function (_ref1208, ref) {
  var className = _ref1208.className,
      children = _ref1208.children,
      style = _ref1208.style,
      tabIndex = _ref1208.tabIndex,
      rest = _objectWithoutProperties$2(_ref1208, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1208 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1208.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1208, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11h-4v2h4v2h-3v2h3v2h-4v2h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z'
  }));
});
NumberSmall_320.displayName = 'NumberSmall_320';
NumberSmall_320.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_320.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_432 = React.forwardRef(function (_ref1209, ref) {
  var className = _ref1209.className,
      children = _ref1209.children,
      style = _ref1209.style,
      tabIndex = _ref1209.tabIndex,
      rest = _objectWithoutProperties$2(_ref1209, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1209 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1209.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1209, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11v4h-2v-4h-2v6h4v4h2V11h-2z'
  }));
});
NumberSmall_432.displayName = 'NumberSmall_432';
NumberSmall_432.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_432.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_424 = React.forwardRef(function (_ref1210, ref) {
  var className = _ref1210.className,
      children = _ref1210.children,
      style = _ref1210.style,
      tabIndex = _ref1210.tabIndex,
      rest = _objectWithoutProperties$2(_ref1210, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1210 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1210.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1210, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11v4h-2v-4h-2v6h4v4h2V11h-2z'
  }));
});
NumberSmall_424.displayName = 'NumberSmall_424';
NumberSmall_424.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_424.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_420 = React.forwardRef(function (_ref1211, ref) {
  var className = _ref1211.className,
      children = _ref1211.children,
      style = _ref1211.style,
      tabIndex = _ref1211.tabIndex,
      rest = _objectWithoutProperties$2(_ref1211, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1211 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1211.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1211, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11v4h-2v-4h-2v6h4v4h2V11h-2z'
  }));
});
NumberSmall_420.displayName = 'NumberSmall_420';
NumberSmall_420.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_420.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_532 = React.forwardRef(function (_ref1212, ref) {
  var className = _ref1212.className,
      children = _ref1212.children,
      style = _ref1212.style,
      tabIndex = _ref1212.tabIndex,
      rest = _objectWithoutProperties$2(_ref1212, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1212 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1212.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1212, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-4v-2h4v-2h-4v-6h6v2h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2z'
  }));
});
NumberSmall_532.displayName = 'NumberSmall_532';
NumberSmall_532.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_532.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_524 = React.forwardRef(function (_ref1213, ref) {
  var className = _ref1213.className,
      children = _ref1213.children,
      style = _ref1213.style,
      tabIndex = _ref1213.tabIndex,
      rest = _objectWithoutProperties$2(_ref1213, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1213 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1213.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1213, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-4v-2h4v-2h-4v-6h6v2h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2z'
  }));
});
NumberSmall_524.displayName = 'NumberSmall_524';
NumberSmall_524.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_524.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_520 = React.forwardRef(function (_ref1214, ref) {
  var className = _ref1214.className,
      children = _ref1214.children,
      style = _ref1214.style,
      tabIndex = _ref1214.tabIndex,
      rest = _objectWithoutProperties$2(_ref1214, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1214 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1214.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1214, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-4v-2h4v-2h-4v-6h6v2h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2z'
  }));
});
NumberSmall_520.displayName = 'NumberSmall_520';
NumberSmall_520.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_520.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_632 = React.forwardRef(function (_ref1215, ref) {
  var className = _ref1215.className,
      children = _ref1215.children,
      style = _ref1215.style,
      tabIndex = _ref1215.tabIndex,
      rest = _objectWithoutProperties$2(_ref1215, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1215 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1215.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1215, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3v2h-3v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-2-4v2h2v-2z'
  }));
});
NumberSmall_632.displayName = 'NumberSmall_632';
NumberSmall_632.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_632.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_624 = React.forwardRef(function (_ref1216, ref) {
  var className = _ref1216.className,
      children = _ref1216.children,
      style = _ref1216.style,
      tabIndex = _ref1216.tabIndex,
      rest = _objectWithoutProperties$2(_ref1216, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1216 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1216.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1216, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3v2h-3v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-2-4v2h2v-2z'
  }));
});
NumberSmall_624.displayName = 'NumberSmall_624';
NumberSmall_624.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_624.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_620 = React.forwardRef(function (_ref1217, ref) {
  var className = _ref1217.className,
      children = _ref1217.children,
      style = _ref1217.style,
      tabIndex = _ref1217.tabIndex,
      rest = _objectWithoutProperties$2(_ref1217, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1217 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1217.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1217, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3v2h-3v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-2-4v2h2v-2z'
  }));
});
NumberSmall_620.displayName = 'NumberSmall_620';
NumberSmall_620.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_620.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_732 = React.forwardRef(function (_ref1218, ref) {
  var className = _ref1218.className,
      children = _ref1218.children,
      style = _ref1218.style,
      tabIndex = _ref1218.tabIndex,
      rest = _objectWithoutProperties$2(_ref1218, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1218 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1218.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1218, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.44 21h-2L17 13h-2v1h-2v-3h6v2l-2.56 8z'
  }));
});
NumberSmall_732.displayName = 'NumberSmall_732';
NumberSmall_732.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_732.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_724 = React.forwardRef(function (_ref1219, ref) {
  var className = _ref1219.className,
      children = _ref1219.children,
      style = _ref1219.style,
      tabIndex = _ref1219.tabIndex,
      rest = _objectWithoutProperties$2(_ref1219, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1219 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1219.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1219, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.44 21h-2L17 13h-2v1h-2v-3h6v2l-2.56 8z'
  }));
});
NumberSmall_724.displayName = 'NumberSmall_724';
NumberSmall_724.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_724.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_720 = React.forwardRef(function (_ref1220, ref) {
  var className = _ref1220.className,
      children = _ref1220.children,
      style = _ref1220.style,
      tabIndex = _ref1220.tabIndex,
      rest = _objectWithoutProperties$2(_ref1220, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1220 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1220.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1220, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16.44 21h-2L17 13h-2v1h-2v-3h6v2l-2.56 8z'
  }));
});
NumberSmall_720.displayName = 'NumberSmall_720';
NumberSmall_720.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_720.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_832 = React.forwardRef(function (_ref1221, ref) {
  var className = _ref1221.className,
      children = _ref1221.children,
      style = _ref1221.style,
      tabIndex = _ref1221.tabIndex,
      rest = _objectWithoutProperties$2(_ref1221, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1221 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1221.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1221, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11h-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 2v2h-2v-2zm-2 6v-2h2v2z'
  }));
});
NumberSmall_832.displayName = 'NumberSmall_832';
NumberSmall_832.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_832.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_824 = React.forwardRef(function (_ref1222, ref) {
  var className = _ref1222.className,
      children = _ref1222.children,
      style = _ref1222.style,
      tabIndex = _ref1222.tabIndex,
      rest = _objectWithoutProperties$2(_ref1222, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1222 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1222.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1222, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11h-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 2v2h-2v-2zm-2 6v-2h2v2z'
  }));
});
NumberSmall_824.displayName = 'NumberSmall_824';
NumberSmall_824.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_824.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_820 = React.forwardRef(function (_ref1223, ref) {
  var className = _ref1223.className,
      children = _ref1223.children,
      style = _ref1223.style,
      tabIndex = _ref1223.tabIndex,
      rest = _objectWithoutProperties$2(_ref1223, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1223 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1223.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1223, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11h-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 2v2h-2v-2zm-2 6v-2h2v2z'
  }));
});
NumberSmall_820.displayName = 'NumberSmall_820';
NumberSmall_820.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_820.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_932 = React.forwardRef(function (_ref1224, ref) {
  var className = _ref1224.className,
      children = _ref1224.children,
      style = _ref1224.style,
      tabIndex = _ref1224.tabIndex,
      rest = _objectWithoutProperties$2(_ref1224, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1224 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1224.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1224, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-3v-2h3v-2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v2h2v-2z'
  }));
});
NumberSmall_932.displayName = 'NumberSmall_932';
NumberSmall_932.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_932.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_924 = React.forwardRef(function (_ref1225, ref) {
  var className = _ref1225.className,
      children = _ref1225.children,
      style = _ref1225.style,
      tabIndex = _ref1225.tabIndex,
      rest = _objectWithoutProperties$2(_ref1225, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1225 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1225.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1225, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-3v-2h3v-2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v2h2v-2z'
  }));
});
NumberSmall_924.displayName = 'NumberSmall_924';
NumberSmall_924.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_924.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var NumberSmall_920 = React.forwardRef(function (_ref1226, ref) {
  var className = _ref1226.className,
      children = _ref1226.children,
      style = _ref1226.style,
      tabIndex = _ref1226.tabIndex,
      rest = _objectWithoutProperties$2(_ref1226, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1226 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1226.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1226, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 21h-3v-2h3v-2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v2h2v-2z'
  }));
});
NumberSmall_920.displayName = 'NumberSmall_920';
NumberSmall_920.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
NumberSmall_920.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Opacity32 = React.forwardRef(function (_ref1227, ref) {
  var className = _ref1227.className,
      children = _ref1227.children,
      style = _ref1227.style,
      tabIndex = _ref1227.tabIndex,
      rest = _objectWithoutProperties$2(_ref1227, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1227 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1227.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1227, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h4v4H6zm4 4h4v4h-4zm4-4h4v4h-4zm8 0h4v4h-4zM6 14h4v4H6zm8 0h4v4h-4zm8 0h4v4h-4zM6 22h4v4H6zm8 0h4v4h-4zm8 0h4v4h-4zm-4-12h4v4h-4zm-8 8h4v4h-4zm8 0h4v4h-4z'
  }));
});
Opacity32.displayName = 'Opacity32';
Opacity32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Opacity32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Opacity24 = React.forwardRef(function (_ref1228, ref) {
  var className = _ref1228.className,
      children = _ref1228.children,
      style = _ref1228.style,
      tabIndex = _ref1228.tabIndex,
      rest = _objectWithoutProperties$2(_ref1228, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1228 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1228.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1228, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h4v4H6zm4 4h4v4h-4zm4-4h4v4h-4zm8 0h4v4h-4zM6 14h4v4H6zm8 0h4v4h-4zm8 0h4v4h-4zM6 22h4v4H6zm8 0h4v4h-4zm8 0h4v4h-4zm-4-12h4v4h-4zm-8 8h4v4h-4zm8 0h4v4h-4z'
  }));
});
Opacity24.displayName = 'Opacity24';
Opacity24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Opacity24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Opacity20 = React.forwardRef(function (_ref1229, ref) {
  var className = _ref1229.className,
      children = _ref1229.children,
      style = _ref1229.style,
      tabIndex = _ref1229.tabIndex,
      rest = _objectWithoutProperties$2(_ref1229, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1229 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1229.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1229, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h4v4H6zm4 4h4v4h-4zm4-4h4v4h-4zm8 0h4v4h-4zM6 14h4v4H6zm8 0h4v4h-4zm8 0h4v4h-4zM6 22h4v4H6zm8 0h4v4h-4zm8 0h4v4h-4zm-4-12h4v4h-4zm-8 8h4v4h-4zm8 0h4v4h-4z'
  }));
});
Opacity20.displayName = 'Opacity20';
Opacity20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Opacity20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelBottom32 = React.forwardRef(function (_ref1230, ref) {
  var className = _ref1230.className,
      children = _ref1230.children,
      style = _ref1230.style,
      tabIndex = _ref1230.tabIndex,
      rest = _objectWithoutProperties$2(_ref1230, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1230 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1230.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1230, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v12H4V6zM4 26v-6h24v6z'
  }));
});
OpenPanelBottom32.displayName = 'OpenPanelBottom32';
OpenPanelBottom32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelBottom32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelBottom24 = React.forwardRef(function (_ref1231, ref) {
  var className = _ref1231.className,
      children = _ref1231.children,
      style = _ref1231.style,
      tabIndex = _ref1231.tabIndex,
      rest = _objectWithoutProperties$2(_ref1231, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1231 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1231.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1231, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v12H4V6zM4 26v-6h24v6z'
  }));
});
OpenPanelBottom24.displayName = 'OpenPanelBottom24';
OpenPanelBottom24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelBottom24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelBottom20 = React.forwardRef(function (_ref1232, ref) {
  var className = _ref1232.className,
      children = _ref1232.children,
      style = _ref1232.style,
      tabIndex = _ref1232.tabIndex,
      rest = _objectWithoutProperties$2(_ref1232, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1232 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1232.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1232, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v12H4V6zM4 26v-6h24v6z'
  }));
});
OpenPanelBottom20.displayName = 'OpenPanelBottom20';
OpenPanelBottom20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelBottom20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledBottom32 = React.forwardRef(function (_ref1233, ref) {
  var className = _ref1233.className,
      children = _ref1233.children,
      style = _ref1233.style,
      tabIndex = _ref1233.tabIndex,
      rest = _objectWithoutProperties$2(_ref1233, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1233 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1233.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1233, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v12H4V6z'
  }));
});
OpenPanelFilledBottom32.displayName = 'OpenPanelFilledBottom32';
OpenPanelFilledBottom32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledBottom32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledBottom24 = React.forwardRef(function (_ref1234, ref) {
  var className = _ref1234.className,
      children = _ref1234.children,
      style = _ref1234.style,
      tabIndex = _ref1234.tabIndex,
      rest = _objectWithoutProperties$2(_ref1234, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1234 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1234.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1234, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v12H4V6z'
  }));
});
OpenPanelFilledBottom24.displayName = 'OpenPanelFilledBottom24';
OpenPanelFilledBottom24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledBottom24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledBottom20 = React.forwardRef(function (_ref1235, ref) {
  var className = _ref1235.className,
      children = _ref1235.children,
      style = _ref1235.style,
      tabIndex = _ref1235.tabIndex,
      rest = _objectWithoutProperties$2(_ref1235, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1235 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1235.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1235, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v12H4V6z'
  }));
});
OpenPanelFilledBottom20.displayName = 'OpenPanelFilledBottom20';
OpenPanelFilledBottom20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledBottom20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledLeft32 = React.forwardRef(function (_ref1236, ref) {
  var className = _ref1236.className,
      children = _ref1236.children,
      style = _ref1236.style,
      tabIndex = _ref1236.tabIndex,
      rest = _objectWithoutProperties$2(_ref1236, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1236 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1236.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1236, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H12V6h16z'
  }));
});
OpenPanelFilledLeft32.displayName = 'OpenPanelFilledLeft32';
OpenPanelFilledLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledLeft24 = React.forwardRef(function (_ref1237, ref) {
  var className = _ref1237.className,
      children = _ref1237.children,
      style = _ref1237.style,
      tabIndex = _ref1237.tabIndex,
      rest = _objectWithoutProperties$2(_ref1237, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1237 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1237.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1237, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H12V6h16z'
  }));
});
OpenPanelFilledLeft24.displayName = 'OpenPanelFilledLeft24';
OpenPanelFilledLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledLeft20 = React.forwardRef(function (_ref1238, ref) {
  var className = _ref1238.className,
      children = _ref1238.children,
      style = _ref1238.style,
      tabIndex = _ref1238.tabIndex,
      rest = _objectWithoutProperties$2(_ref1238, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1238 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1238.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1238, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H12V6h16z'
  }));
});
OpenPanelFilledLeft20.displayName = 'OpenPanelFilledLeft20';
OpenPanelFilledLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledRight32 = React.forwardRef(function (_ref1239, ref) {
  var className = _ref1239.className,
      children = _ref1239.children,
      style = _ref1239.style,
      tabIndex = _ref1239.tabIndex,
      rest = _objectWithoutProperties$2(_ref1239, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1239 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1239.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1239, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h16v20H4z'
  }));
});
OpenPanelFilledRight32.displayName = 'OpenPanelFilledRight32';
OpenPanelFilledRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledRight24 = React.forwardRef(function (_ref1240, ref) {
  var className = _ref1240.className,
      children = _ref1240.children,
      style = _ref1240.style,
      tabIndex = _ref1240.tabIndex,
      rest = _objectWithoutProperties$2(_ref1240, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1240 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1240.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1240, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h16v20H4z'
  }));
});
OpenPanelFilledRight24.displayName = 'OpenPanelFilledRight24';
OpenPanelFilledRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledRight20 = React.forwardRef(function (_ref1241, ref) {
  var className = _ref1241.className,
      children = _ref1241.children,
      style = _ref1241.style,
      tabIndex = _ref1241.tabIndex,
      rest = _objectWithoutProperties$2(_ref1241, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1241 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1241.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1241, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h16v20H4z'
  }));
});
OpenPanelFilledRight20.displayName = 'OpenPanelFilledRight20';
OpenPanelFilledRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledTop32 = React.forwardRef(function (_ref1242, ref) {
  var className = _ref1242.className,
      children = _ref1242.children,
      style = _ref1242.style,
      tabIndex = _ref1242.tabIndex,
      rest = _objectWithoutProperties$2(_ref1242, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1242 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1242.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1242, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 26V14h24v12z'
  }));
});
OpenPanelFilledTop32.displayName = 'OpenPanelFilledTop32';
OpenPanelFilledTop32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledTop32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledTop24 = React.forwardRef(function (_ref1243, ref) {
  var className = _ref1243.className,
      children = _ref1243.children,
      style = _ref1243.style,
      tabIndex = _ref1243.tabIndex,
      rest = _objectWithoutProperties$2(_ref1243, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1243 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1243.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1243, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 26V14h24v12z'
  }));
});
OpenPanelFilledTop24.displayName = 'OpenPanelFilledTop24';
OpenPanelFilledTop24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledTop24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelFilledTop20 = React.forwardRef(function (_ref1244, ref) {
  var className = _ref1244.className,
      children = _ref1244.children,
      style = _ref1244.style,
      tabIndex = _ref1244.tabIndex,
      rest = _objectWithoutProperties$2(_ref1244, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1244 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1244.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1244, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 26V14h24v12z'
  }));
});
OpenPanelFilledTop20.displayName = 'OpenPanelFilledTop20';
OpenPanelFilledTop20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelFilledTop20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelLeft32 = React.forwardRef(function (_ref1245, ref) {
  var className = _ref1245.className,
      children = _ref1245.children,
      style = _ref1245.style,
      tabIndex = _ref1245.tabIndex,
      rest = _objectWithoutProperties$2(_ref1245, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1245 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1245.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1245, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h6v20H4zm24 20H12V6h16z'
  }));
});
OpenPanelLeft32.displayName = 'OpenPanelLeft32';
OpenPanelLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelLeft24 = React.forwardRef(function (_ref1246, ref) {
  var className = _ref1246.className,
      children = _ref1246.children,
      style = _ref1246.style,
      tabIndex = _ref1246.tabIndex,
      rest = _objectWithoutProperties$2(_ref1246, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1246 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1246.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1246, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h6v20H4zm24 20H12V6h16z'
  }));
});
OpenPanelLeft24.displayName = 'OpenPanelLeft24';
OpenPanelLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelLeft20 = React.forwardRef(function (_ref1247, ref) {
  var className = _ref1247.className,
      children = _ref1247.children,
      style = _ref1247.style,
      tabIndex = _ref1247.tabIndex,
      rest = _objectWithoutProperties$2(_ref1247, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1247 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1247.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1247, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h6v20H4zm24 20H12V6h16z'
  }));
});
OpenPanelLeft20.displayName = 'OpenPanelLeft20';
OpenPanelLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelRight32 = React.forwardRef(function (_ref1248, ref) {
  var className = _ref1248.className,
      children = _ref1248.children,
      style = _ref1248.style,
      tabIndex = _ref1248.tabIndex,
      rest = _objectWithoutProperties$2(_ref1248, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1248 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1248.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1248, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h16v20H4zm24 20h-6V6h6z'
  }));
});
OpenPanelRight32.displayName = 'OpenPanelRight32';
OpenPanelRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelRight24 = React.forwardRef(function (_ref1249, ref) {
  var className = _ref1249.className,
      children = _ref1249.children,
      style = _ref1249.style,
      tabIndex = _ref1249.tabIndex,
      rest = _objectWithoutProperties$2(_ref1249, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1249 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1249.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1249, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h16v20H4zm24 20h-6V6h6z'
  }));
});
OpenPanelRight24.displayName = 'OpenPanelRight24';
OpenPanelRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelRight20 = React.forwardRef(function (_ref1250, ref) {
  var className = _ref1250.className,
      children = _ref1250.children,
      style = _ref1250.style,
      tabIndex = _ref1250.tabIndex,
      rest = _objectWithoutProperties$2(_ref1250, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1250 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1250.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1250, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h16v20H4zm24 20h-6V6h6z'
  }));
});
OpenPanelRight20.displayName = 'OpenPanelRight20';
OpenPanelRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelTop32 = React.forwardRef(function (_ref1251, ref) {
  var className = _ref1251.className,
      children = _ref1251.children,
      style = _ref1251.style,
      tabIndex = _ref1251.tabIndex,
      rest = _objectWithoutProperties$2(_ref1251, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1251 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1251.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1251, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v6H4V6zM4 26V14h24v12z'
  }));
});
OpenPanelTop32.displayName = 'OpenPanelTop32';
OpenPanelTop32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelTop32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelTop24 = React.forwardRef(function (_ref1252, ref) {
  var className = _ref1252.className,
      children = _ref1252.children,
      style = _ref1252.style,
      tabIndex = _ref1252.tabIndex,
      rest = _objectWithoutProperties$2(_ref1252, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1252 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1252.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1252, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v6H4V6zM4 26V14h24v12z'
  }));
});
OpenPanelTop24.displayName = 'OpenPanelTop24';
OpenPanelTop24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelTop24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OpenPanelTop20 = React.forwardRef(function (_ref1253, ref) {
  var className = _ref1253.className,
      children = _ref1253.children,
      style = _ref1253.style,
      tabIndex = _ref1253.tabIndex,
      rest = _objectWithoutProperties$2(_ref1253, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1253 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1253.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1253, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v6H4V6zM4 26V14h24v12z'
  }));
});
OpenPanelTop20.displayName = 'OpenPanelTop20';
OpenPanelTop20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OpenPanelTop20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuHorizontal32 = React.forwardRef(function (_ref1254, ref) {
  var className = _ref1254.className,
      children = _ref1254.children,
      style = _ref1254.style,
      tabIndex = _ref1254.tabIndex,
      rest = _objectWithoutProperties$2(_ref1254, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1254 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1254.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1254, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '6',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '2'
  }));
});
OverflowMenuHorizontal32.displayName = 'OverflowMenuHorizontal32';
OverflowMenuHorizontal32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuHorizontal32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuHorizontal24 = React.forwardRef(function (_ref1255, ref) {
  var className = _ref1255.className,
      children = _ref1255.children,
      style = _ref1255.style,
      tabIndex = _ref1255.tabIndex,
      rest = _objectWithoutProperties$2(_ref1255, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1255 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1255.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1255, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '6',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '2'
  }));
});
OverflowMenuHorizontal24.displayName = 'OverflowMenuHorizontal24';
OverflowMenuHorizontal24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuHorizontal24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuHorizontal20 = React.forwardRef(function (_ref1256, ref) {
  var className = _ref1256.className,
      children = _ref1256.children,
      style = _ref1256.style,
      tabIndex = _ref1256.tabIndex,
      rest = _objectWithoutProperties$2(_ref1256, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1256 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1256.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1256, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '6',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '2'
  }));
});
OverflowMenuHorizontal20.displayName = 'OverflowMenuHorizontal20';
OverflowMenuHorizontal20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuHorizontal20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuVertical32 = React.forwardRef(function (_ref1257, ref) {
  var className = _ref1257.className,
      children = _ref1257.children,
      style = _ref1257.style,
      tabIndex = _ref1257.tabIndex,
      rest = _objectWithoutProperties$2(_ref1257, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1257 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1257.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1257, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '16',
    cy: '6',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '26',
    r: '2'
  }));
});
OverflowMenuVertical32.displayName = 'OverflowMenuVertical32';
OverflowMenuVertical32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuVertical32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuVertical24 = React.forwardRef(function (_ref1258, ref) {
  var className = _ref1258.className,
      children = _ref1258.children,
      style = _ref1258.style,
      tabIndex = _ref1258.tabIndex,
      rest = _objectWithoutProperties$2(_ref1258, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1258 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1258.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1258, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '16',
    cy: '6',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '26',
    r: '2'
  }));
});
OverflowMenuVertical24.displayName = 'OverflowMenuVertical24';
OverflowMenuVertical24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuVertical24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var OverflowMenuVertical20 = React.forwardRef(function (_ref1259, ref) {
  var className = _ref1259.className,
      children = _ref1259.children,
      style = _ref1259.style,
      tabIndex = _ref1259.tabIndex,
      rest = _objectWithoutProperties$2(_ref1259, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1259 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1259.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1259, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '16',
    cy: '6',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), React.createElement('circle', {
    cx: '16',
    cy: '26',
    r: '2'
  }));
});
OverflowMenuVertical20.displayName = 'OverflowMenuVertical20';
OverflowMenuVertical20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
OverflowMenuVertical20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PageFirst32 = React.forwardRef(function (_ref1260, ref) {
  var className = _ref1260.className,
      children = _ref1260.children,
      style = _ref1260.style,
      tabIndex = _ref1260.tabIndex,
      rest = _objectWithoutProperties$2(_ref1260, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1260 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1260.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1260, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 16L24 6l1.4 1.4-8.6 8.6 8.6 8.6L24 26zM8 4h2v24H8z'
  }));
});
PageFirst32.displayName = 'PageFirst32';
PageFirst32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PageFirst32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PageFirst24 = React.forwardRef(function (_ref1261, ref) {
  var className = _ref1261.className,
      children = _ref1261.children,
      style = _ref1261.style,
      tabIndex = _ref1261.tabIndex,
      rest = _objectWithoutProperties$2(_ref1261, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1261 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1261.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1261, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 16L24 6l1.4 1.4-8.6 8.6 8.6 8.6L24 26zM8 4h2v24H8z'
  }));
});
PageFirst24.displayName = 'PageFirst24';
PageFirst24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PageFirst24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PageFirst20 = React.forwardRef(function (_ref1262, ref) {
  var className = _ref1262.className,
      children = _ref1262.children,
      style = _ref1262.style,
      tabIndex = _ref1262.tabIndex,
      rest = _objectWithoutProperties$2(_ref1262, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1262 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1262.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1262, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 16L24 6l1.4 1.4-8.6 8.6 8.6 8.6L24 26zM8 4h2v24H8z'
  }));
});
PageFirst20.displayName = 'PageFirst20';
PageFirst20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PageFirst20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PageLast32 = React.forwardRef(function (_ref1263, ref) {
  var className = _ref1263.className,
      children = _ref1263.children,
      style = _ref1263.style,
      tabIndex = _ref1263.tabIndex,
      rest = _objectWithoutProperties$2(_ref1263, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1263 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1263.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1263, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 16L8 26l-1.4-1.4 8.6-8.6-8.6-8.6L8 6zm4-12h2v24h-2z'
  }));
});
PageLast32.displayName = 'PageLast32';
PageLast32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PageLast32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PageLast24 = React.forwardRef(function (_ref1264, ref) {
  var className = _ref1264.className,
      children = _ref1264.children,
      style = _ref1264.style,
      tabIndex = _ref1264.tabIndex,
      rest = _objectWithoutProperties$2(_ref1264, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1264 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1264.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1264, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 16L8 26l-1.4-1.4 8.6-8.6-8.6-8.6L8 6zm4-12h2v24h-2z'
  }));
});
PageLast24.displayName = 'PageLast24';
PageLast24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PageLast24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PageLast20 = React.forwardRef(function (_ref1265, ref) {
  var className = _ref1265.className,
      children = _ref1265.children,
      style = _ref1265.style,
      tabIndex = _ref1265.tabIndex,
      rest = _objectWithoutProperties$2(_ref1265, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1265 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1265.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1265, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 16L8 26l-1.4-1.4 8.6-8.6-8.6-8.6L8 6zm4-12h2v24h-2z'
  }));
});
PageLast20.displayName = 'PageLast20';
PageLast20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PageLast20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PaintBrush32 = React.forwardRef(function (_ref1266, ref) {
  var className = _ref1266.className,
      children = _ref1266.children,
      style = _ref1266.style,
      tabIndex = _ref1266.tabIndex,
      rest = _objectWithoutProperties$2(_ref1266, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1266 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1266.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1266, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 23.17L23 17.33V13a1 1 0 0 0-.29-.71l-10-10a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42l10 10A1 1 0 0 0 13 23h4.34l5.83 5.84a4 4 0 0 0 5.66-5.66zM6 10.41l2.29 2.3 1.42-1.42L7.41 9 9 7.41l4.29 4.3 1.42-1.42L10.41 6 12 4.41 18.59 11 11 18.59 4.41 12zm21.41 17a2 2 0 0 1-2.82 0l-6.13-6.12a1.8 1.8 0 0 0-.71-.29h-4.34l-1-1L20 12.41l1 1v4.34a1 1 0 0 0 .29.7l6.12 6.14a2 2 0 0 1 0 2.82z'
  }));
});
PaintBrush32.displayName = 'PaintBrush32';
PaintBrush32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PaintBrush32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PaintBrush24 = React.forwardRef(function (_ref1267, ref) {
  var className = _ref1267.className,
      children = _ref1267.children,
      style = _ref1267.style,
      tabIndex = _ref1267.tabIndex,
      rest = _objectWithoutProperties$2(_ref1267, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1267 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1267.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1267, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 23.17L23 17.33V13a1 1 0 0 0-.29-.71l-10-10a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42l10 10A1 1 0 0 0 13 23h4.34l5.83 5.84a4 4 0 0 0 5.66-5.66zM6 10.41l2.29 2.3 1.42-1.42L7.41 9 9 7.41l4.29 4.3 1.42-1.42L10.41 6 12 4.41 18.59 11 11 18.59 4.41 12zm21.41 17a2 2 0 0 1-2.82 0l-6.13-6.12a1.8 1.8 0 0 0-.71-.29h-4.34l-1-1L20 12.41l1 1v4.34a1 1 0 0 0 .29.7l6.12 6.14a2 2 0 0 1 0 2.82z'
  }));
});
PaintBrush24.displayName = 'PaintBrush24';
PaintBrush24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PaintBrush24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PaintBrush20 = React.forwardRef(function (_ref1268, ref) {
  var className = _ref1268.className,
      children = _ref1268.children,
      style = _ref1268.style,
      tabIndex = _ref1268.tabIndex,
      rest = _objectWithoutProperties$2(_ref1268, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1268 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1268.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1268, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 23.17L23 17.33V13a1 1 0 0 0-.29-.71l-10-10a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42l10 10A1 1 0 0 0 13 23h4.34l5.83 5.84a4 4 0 0 0 5.66-5.66zM6 10.41l2.29 2.3 1.42-1.42L7.41 9 9 7.41l4.29 4.3 1.42-1.42L10.41 6 12 4.41 18.59 11 11 18.59 4.41 12zm21.41 17a2 2 0 0 1-2.82 0l-6.13-6.12a1.8 1.8 0 0 0-.71-.29h-4.34l-1-1L20 12.41l1 1v4.34a1 1 0 0 0 .29.7l6.12 6.14a2 2 0 0 1 0 2.82z'
  }));
});
PaintBrush20.displayName = 'PaintBrush20';
PaintBrush20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PaintBrush20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PanelExpansion32 = React.forwardRef(function (_ref1269, ref) {
  var className = _ref1269.className,
      children = _ref1269.children,
      style = _ref1269.style,
      tabIndex = _ref1269.tabIndex,
      rest = _objectWithoutProperties$2(_ref1269, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1269 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1269.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1269, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 6H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-6 8V8h6v6zm20-8h-6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-6 18V8h6v16z'
  }));
});
PanelExpansion32.displayName = 'PanelExpansion32';
PanelExpansion32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PanelExpansion32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PanelExpansion24 = React.forwardRef(function (_ref1270, ref) {
  var className = _ref1270.className,
      children = _ref1270.children,
      style = _ref1270.style,
      tabIndex = _ref1270.tabIndex,
      rest = _objectWithoutProperties$2(_ref1270, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1270 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1270.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1270, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 6H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-6 8V8h6v6zm20-8h-6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-6 18V8h6v16z'
  }));
});
PanelExpansion24.displayName = 'PanelExpansion24';
PanelExpansion24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PanelExpansion24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PanelExpansion20 = React.forwardRef(function (_ref1271, ref) {
  var className = _ref1271.className,
      children = _ref1271.children,
      style = _ref1271.style,
      tabIndex = _ref1271.tabIndex,
      rest = _objectWithoutProperties$2(_ref1271, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1271 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1271.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1271, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 6H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-6 8V8h6v6zm20-8h-6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-6 18V8h6v16z'
  }));
});
PanelExpansion20.displayName = 'PanelExpansion20';
PanelExpansion20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PanelExpansion20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ParentChild32 = React.forwardRef(function (_ref1272, ref) {
  var className = _ref1272.className,
      children = _ref1272.children,
      style = _ref1272.style,
      tabIndex = _ref1272.tabIndex,
      rest = _objectWithoutProperties$2(_ref1272, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1272 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1272.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1272, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h11v4H9a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H9v-4h14v4h-3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-3v-4a2 2 0 0 0-2-2h-6v-4zM12 28H4v-4h8zm16 0h-8v-4h8zM4 4h24v6H4z'
  }));
});
ParentChild32.displayName = 'ParentChild32';
ParentChild32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ParentChild32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ParentChild24 = React.forwardRef(function (_ref1273, ref) {
  var className = _ref1273.className,
      children = _ref1273.children,
      style = _ref1273.style,
      tabIndex = _ref1273.tabIndex,
      rest = _objectWithoutProperties$2(_ref1273, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1273 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1273.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1273, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h11v4H9a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H9v-4h14v4h-3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-3v-4a2 2 0 0 0-2-2h-6v-4zM12 28H4v-4h8zm16 0h-8v-4h8zM4 4h24v6H4z'
  }));
});
ParentChild24.displayName = 'ParentChild24';
ParentChild24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ParentChild24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ParentChild20 = React.forwardRef(function (_ref1274, ref) {
  var className = _ref1274.className,
      children = _ref1274.children,
      style = _ref1274.style,
      tabIndex = _ref1274.tabIndex,
      rest = _objectWithoutProperties$2(_ref1274, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1274 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1274.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1274, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h11v4H9a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H9v-4h14v4h-3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-3v-4a2 2 0 0 0-2-2h-6v-4zM12 28H4v-4h8zm16 0h-8v-4h8zM4 4h24v6H4z'
  }));
});
ParentChild20.displayName = 'ParentChild20';
ParentChild20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ParentChild20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Partnership32 = React.forwardRef(function (_ref1275, ref) {
  var className = _ref1275.className,
      children = _ref1275.children,
      style = _ref1275.style,
      tabIndex = _ref1275.tabIndex,
      rest = _objectWithoutProperties$2(_ref1275, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1275 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1275.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1275, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 9a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm16 6a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm2 27h-4a2 2 0 0 1-2-2v-7h2v7h4v-9h2v-6a1 1 0 0 0-1-1h-6.42L16 20l-4.58-8H5a1 1 0 0 0-1 1v6h2v9h4v-7h2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1-2-2v-6a3 3 0 0 1 3-3h7.58L16 16l3.42-6H27a3 3 0 0 1 3 3v6a2 2 0 0 1-2 2v7a2 2 0 0 1-2 2z'
  }));
});
Partnership32.displayName = 'Partnership32';
Partnership32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Partnership32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Partnership24 = React.forwardRef(function (_ref1276, ref) {
  var className = _ref1276.className,
      children = _ref1276.children,
      style = _ref1276.style,
      tabIndex = _ref1276.tabIndex,
      rest = _objectWithoutProperties$2(_ref1276, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1276 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1276.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1276, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 9a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm16 6a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm2 27h-4a2 2 0 0 1-2-2v-7h2v7h4v-9h2v-6a1 1 0 0 0-1-1h-6.42L16 20l-4.58-8H5a1 1 0 0 0-1 1v6h2v9h4v-7h2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1-2-2v-6a3 3 0 0 1 3-3h7.58L16 16l3.42-6H27a3 3 0 0 1 3 3v6a2 2 0 0 1-2 2v7a2 2 0 0 1-2 2z'
  }));
});
Partnership24.displayName = 'Partnership24';
Partnership24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Partnership24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Partnership20 = React.forwardRef(function (_ref1277, ref) {
  var className = _ref1277.className,
      children = _ref1277.children,
      style = _ref1277.style,
      tabIndex = _ref1277.tabIndex,
      rest = _objectWithoutProperties$2(_ref1277, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1277 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1277.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1277, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 9a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm16 6a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm2 27h-4a2 2 0 0 1-2-2v-7h2v7h4v-9h2v-6a1 1 0 0 0-1-1h-6.42L16 20l-4.58-8H5a1 1 0 0 0-1 1v6h2v9h4v-7h2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1-2-2v-6a3 3 0 0 1 3-3h7.58L16 16l3.42-6H27a3 3 0 0 1 3 3v6a2 2 0 0 1-2 2v7a2 2 0 0 1-2 2z'
  }));
});
Partnership20.displayName = 'Partnership20';
Partnership20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Partnership20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Password32 = React.forwardRef(function (_ref1278, ref) {
  var className = _ref1278.className,
      children = _ref1278.children,
      style = _ref1278.style,
      tabIndex = _ref1278.tabIndex,
      rest = _objectWithoutProperties$2(_ref1278, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1278 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1278.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1278, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2a9 9 0 0 0-9 9 8.87 8.87 0 0 0 .39 2.61L2 24v6h6l10.39-10.39A9 9 0 0 0 30 11.74a8.77 8.77 0 0 0-1.65-6A9 9 0 0 0 21 2zm0 16a7 7 0 0 1-2-.3l-1.15-.35-.85.85-3.18 3.18L12.41 20 11 21.41l1.38 1.38-1.59 1.59L9.41 23 8 24.41l1.38 1.38L7.17 28H4v-3.17L13.8 15l.85-.85-.29-.95a7.14 7.14 0 0 1 3.4-8.44 7 7 0 0 1 10.24 6 6.69 6.69 0 0 1-1.09 4A7 7 0 0 1 21 18z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '10',
    r: '2'
  }));
});
Password32.displayName = 'Password32';
Password32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Password32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Password24 = React.forwardRef(function (_ref1279, ref) {
  var className = _ref1279.className,
      children = _ref1279.children,
      style = _ref1279.style,
      tabIndex = _ref1279.tabIndex,
      rest = _objectWithoutProperties$2(_ref1279, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1279 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1279.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1279, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2a9 9 0 0 0-9 9 8.87 8.87 0 0 0 .39 2.61L2 24v6h6l10.39-10.39A9 9 0 0 0 30 11.74a8.77 8.77 0 0 0-1.65-6A9 9 0 0 0 21 2zm0 16a7 7 0 0 1-2-.3l-1.15-.35-.85.85-3.18 3.18L12.41 20 11 21.41l1.38 1.38-1.59 1.59L9.41 23 8 24.41l1.38 1.38L7.17 28H4v-3.17L13.8 15l.85-.85-.29-.95a7.14 7.14 0 0 1 3.4-8.44 7 7 0 0 1 10.24 6 6.69 6.69 0 0 1-1.09 4A7 7 0 0 1 21 18z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '10',
    r: '2'
  }));
});
Password24.displayName = 'Password24';
Password24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Password24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Password20 = React.forwardRef(function (_ref1280, ref) {
  var className = _ref1280.className,
      children = _ref1280.children,
      style = _ref1280.style,
      tabIndex = _ref1280.tabIndex,
      rest = _objectWithoutProperties$2(_ref1280, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1280 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1280.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1280, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2a9 9 0 0 0-9 9 8.87 8.87 0 0 0 .39 2.61L2 24v6h6l10.39-10.39A9 9 0 0 0 30 11.74a8.77 8.77 0 0 0-1.65-6A9 9 0 0 0 21 2zm0 16a7 7 0 0 1-2-.3l-1.15-.35-.85.85-3.18 3.18L12.41 20 11 21.41l1.38 1.38-1.59 1.59L9.41 23 8 24.41l1.38 1.38L7.17 28H4v-3.17L13.8 15l.85-.85-.29-.95a7.14 7.14 0 0 1 3.4-8.44 7 7 0 0 1 10.24 6 6.69 6.69 0 0 1-1.09 4A7 7 0 0 1 21 18z'
  }), React.createElement('circle', {
    cx: '22',
    cy: '10',
    r: '2'
  }));
});
Password20.displayName = 'Password20';
Password20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Password20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Paste32 = React.forwardRef(function (_ref1281, ref) {
  var className = _ref1281.className,
      children = _ref1281.children,
      style = _ref1281.style,
      tabIndex = _ref1281.tabIndex,
      rest = _objectWithoutProperties$2(_ref1281, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1281 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1281.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1281, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 20h-8.17l2.58-2.59L19 16l-5 5 5 5 1.41-1.41L17.83 22H26v8h2v-8a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M23.71 9.29l-7-7A1 1 0 0 0 16 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h8v-2H6V4h8v6a2 2 0 0 0 2 2h6v2h2v-4a1 1 0 0 0-.29-.71zM16 4.41L21.59 10H16z'
  }));
});
Paste32.displayName = 'Paste32';
Paste32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Paste32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Paste24 = React.forwardRef(function (_ref1282, ref) {
  var className = _ref1282.className,
      children = _ref1282.children,
      style = _ref1282.style,
      tabIndex = _ref1282.tabIndex,
      rest = _objectWithoutProperties$2(_ref1282, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1282 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1282.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1282, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 20h-8.17l2.58-2.59L19 16l-5 5 5 5 1.41-1.41L17.83 22H26v8h2v-8a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M23.71 9.29l-7-7A1 1 0 0 0 16 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h8v-2H6V4h8v6a2 2 0 0 0 2 2h6v2h2v-4a1 1 0 0 0-.29-.71zM16 4.41L21.59 10H16z'
  }));
});
Paste24.displayName = 'Paste24';
Paste24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Paste24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Paste20 = React.forwardRef(function (_ref1283, ref) {
  var className = _ref1283.className,
      children = _ref1283.children,
      style = _ref1283.style,
      tabIndex = _ref1283.tabIndex,
      rest = _objectWithoutProperties$2(_ref1283, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1283 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1283.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1283, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 20h-8.17l2.58-2.59L19 16l-5 5 5 5 1.41-1.41L17.83 22H26v8h2v-8a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M23.71 9.29l-7-7A1 1 0 0 0 16 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h8v-2H6V4h8v6a2 2 0 0 0 2 2h6v2h2v-4a1 1 0 0 0-.29-.71zM16 4.41L21.59 10H16z'
  }));
});
Paste20.displayName = 'Paste20';
Paste20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Paste20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutlineFilled32 = React.forwardRef(function (_ref1284, ref) {
  var className = _ref1284.className,
      children = _ref1284.children,
      style = _ref1284.style,
      tabIndex = _ref1284.tabIndex,
      rest = _objectWithoutProperties$2(_ref1284, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1284 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1284.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1284, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-2 20h-2V10h2zm6 0h-2V10h2z'
  }));
});
PauseOutlineFilled32.displayName = 'PauseOutlineFilled32';
PauseOutlineFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutlineFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutlineFilled24 = React.forwardRef(function (_ref1285, ref) {
  var className = _ref1285.className,
      children = _ref1285.children,
      style = _ref1285.style,
      tabIndex = _ref1285.tabIndex,
      rest = _objectWithoutProperties$2(_ref1285, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1285 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1285.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1285, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-2 20h-2V10h2zm6 0h-2V10h2z'
  }));
});
PauseOutlineFilled24.displayName = 'PauseOutlineFilled24';
PauseOutlineFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutlineFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutlineFilled20 = React.forwardRef(function (_ref1286, ref) {
  var className = _ref1286.className,
      children = _ref1286.children,
      style = _ref1286.style,
      tabIndex = _ref1286.tabIndex,
      rest = _objectWithoutProperties$2(_ref1286, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1286 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1286.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1286, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-2 20h-2V10h2zm6 0h-2V10h2z'
  }));
});
PauseOutlineFilled20.displayName = 'PauseOutlineFilled20';
PauseOutlineFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutlineFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutline32 = React.forwardRef(function (_ref1287, ref) {
  var className = _ref1287.className,
      children = _ref1287.children,
      style = _ref1287.style,
      tabIndex = _ref1287.tabIndex,
      rest = _objectWithoutProperties$2(_ref1287, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1287 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1287.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1287, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2v12h2V10zm6 0h-2v12h2V10z'
  }), React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }));
});
PauseOutline32.displayName = 'PauseOutline32';
PauseOutline32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutline32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutline24 = React.forwardRef(function (_ref1288, ref) {
  var className = _ref1288.className,
      children = _ref1288.children,
      style = _ref1288.style,
      tabIndex = _ref1288.tabIndex,
      rest = _objectWithoutProperties$2(_ref1288, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1288 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1288.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1288, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2v12h2V10zm6 0h-2v12h2V10z'
  }), React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }));
});
PauseOutline24.displayName = 'PauseOutline24';
PauseOutline24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutline24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PauseOutline20 = React.forwardRef(function (_ref1289, ref) {
  var className = _ref1289.className,
      children = _ref1289.children,
      style = _ref1289.style,
      tabIndex = _ref1289.tabIndex,
      rest = _objectWithoutProperties$2(_ref1289, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1289 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1289.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1289, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2v12h2V10zm6 0h-2v12h2V10z'
  }), React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }));
});
PauseOutline20.displayName = 'PauseOutline20';
PauseOutline20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PauseOutline20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pause32 = React.forwardRef(function (_ref1290, ref) {
  var className = _ref1290.className,
      children = _ref1290.children,
      style = _ref1290.style,
      tabIndex = _ref1290.tabIndex,
      rest = _objectWithoutProperties$2(_ref1290, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1290 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1290.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1290, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 8v16H8V8h4m0-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm12 2v16h-4V8h4m0-2h-4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z'
  }));
});
Pause32.displayName = 'Pause32';
Pause32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pause32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pause24 = React.forwardRef(function (_ref1291, ref) {
  var className = _ref1291.className,
      children = _ref1291.children,
      style = _ref1291.style,
      tabIndex = _ref1291.tabIndex,
      rest = _objectWithoutProperties$2(_ref1291, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1291 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1291.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1291, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 8v16H8V8h4m0-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm12 2v16h-4V8h4m0-2h-4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z'
  }));
});
Pause24.displayName = 'Pause24';
Pause24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pause24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pause20 = React.forwardRef(function (_ref1292, ref) {
  var className = _ref1292.className,
      children = _ref1292.children,
      style = _ref1292.style,
      tabIndex = _ref1292.tabIndex,
      rest = _objectWithoutProperties$2(_ref1292, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1292 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1292.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1292, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 8v16H8V8h4m0-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm12 2v16h-4V8h4m0-2h-4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z'
  }));
});
Pause20.displayName = 'Pause20';
Pause20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pause20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Person32 = React.forwardRef(function (_ref1293, ref) {
  var className = _ref1293.className,
      children = _ref1293.children,
      style = _ref1293.style,
      tabIndex = _ref1293.tabIndex,
      rest = _objectWithoutProperties$2(_ref1293, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1293 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1293.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1293, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 30h-4a2 2 0 0 1-2-2v-7a2 2 0 0 1-2-2v-6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a2 2 0 0 1-2 2v7a2 2 0 0 1-2 2zm-5-18a.94.94 0 0 0-1 1v6h2v9h4v-9h2v-6a.94.94 0 0 0-1-1zm3-3a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Person32.displayName = 'Person32';
Person32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Person32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Person24 = React.forwardRef(function (_ref1294, ref) {
  var className = _ref1294.className,
      children = _ref1294.children,
      style = _ref1294.style,
      tabIndex = _ref1294.tabIndex,
      rest = _objectWithoutProperties$2(_ref1294, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1294 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1294.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1294, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 30h-4a2 2 0 0 1-2-2v-7a2 2 0 0 1-2-2v-6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a2 2 0 0 1-2 2v7a2 2 0 0 1-2 2zm-5-18a.94.94 0 0 0-1 1v6h2v9h4v-9h2v-6a.94.94 0 0 0-1-1zm3-3a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Person24.displayName = 'Person24';
Person24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Person24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Person20 = React.forwardRef(function (_ref1295, ref) {
  var className = _ref1295.className,
      children = _ref1295.children,
      style = _ref1295.style,
      tabIndex = _ref1295.tabIndex,
      rest = _objectWithoutProperties$2(_ref1295, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1295 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1295.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1295, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 30h-4a2 2 0 0 1-2-2v-7a2 2 0 0 1-2-2v-6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a2 2 0 0 1-2 2v7a2 2 0 0 1-2 2zm-5-18a.94.94 0 0 0-1 1v6h2v9h4v-9h2v-6a.94.94 0 0 0-1-1zm3-3a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Person20.displayName = 'Person20';
Person20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Person20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneFilled32 = React.forwardRef(function (_ref1296, ref) {
  var className = _ref1296.className,
      children = _ref1296.children,
      style = _ref1296.style,
      tabIndex = _ref1296.tabIndex,
      rest = _objectWithoutProperties$2(_ref1296, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1296 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1296.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1296, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.33 21.48l2.24-2.24a2.19 2.19 0 0 1 2.34-.48l2.73 1.09a2.18 2.18 0 0 1 1.36 2v5A2.17 2.17 0 0 1 26.72 29C7.59 27.81 3.73 11.61 3 5.41A2.17 2.17 0 0 1 5.17 3H10a2.16 2.16 0 0 1 2 1.36l1.09 2.73a2.16 2.16 0 0 1-.47 2.34l-2.24 2.24s1.29 8.73 9.95 9.81z'
  }));
});
PhoneFilled32.displayName = 'PhoneFilled32';
PhoneFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneFilled24 = React.forwardRef(function (_ref1297, ref) {
  var className = _ref1297.className,
      children = _ref1297.children,
      style = _ref1297.style,
      tabIndex = _ref1297.tabIndex,
      rest = _objectWithoutProperties$2(_ref1297, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1297 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1297.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1297, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.33 21.48l2.24-2.24a2.19 2.19 0 0 1 2.34-.48l2.73 1.09a2.18 2.18 0 0 1 1.36 2v5A2.17 2.17 0 0 1 26.72 29C7.59 27.81 3.73 11.61 3 5.41A2.17 2.17 0 0 1 5.17 3H10a2.16 2.16 0 0 1 2 1.36l1.09 2.73a2.16 2.16 0 0 1-.47 2.34l-2.24 2.24s1.29 8.73 9.95 9.81z'
  }));
});
PhoneFilled24.displayName = 'PhoneFilled24';
PhoneFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneFilled20 = React.forwardRef(function (_ref1298, ref) {
  var className = _ref1298.className,
      children = _ref1298.children,
      style = _ref1298.style,
      tabIndex = _ref1298.tabIndex,
      rest = _objectWithoutProperties$2(_ref1298, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1298 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1298.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1298, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.33 21.48l2.24-2.24a2.19 2.19 0 0 1 2.34-.48l2.73 1.09a2.18 2.18 0 0 1 1.36 2v5A2.17 2.17 0 0 1 26.72 29C7.59 27.81 3.73 11.61 3 5.41A2.17 2.17 0 0 1 5.17 3H10a2.16 2.16 0 0 1 2 1.36l1.09 2.73a2.16 2.16 0 0 1-.47 2.34l-2.24 2.24s1.29 8.73 9.95 9.81z'
  }));
});
PhoneFilled20.displayName = 'PhoneFilled20';
PhoneFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneOffFilled32 = React.forwardRef(function (_ref1299, ref) {
  var className = _ref1299.className,
      children = _ref1299.children,
      style = _ref1299.style,
      tabIndex = _ref1299.tabIndex,
      rest = _objectWithoutProperties$2(_ref1299, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1299 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1299.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1299, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.74 19.56l-2.52-1a2 2 0 0 0-2.15.44L20 21.06a9.93 9.93 0 0 1-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0 0 28 26v-4.59a2 2 0 0 0-1.26-1.85zM8.15 18.19l3.52-3.52a11.68 11.68 0 0 1-.82-2.67l2.07-2.07a2 2 0 0 0 .44-2.15l-1-2.52A2 2 0 0 0 10.5 4H6a2 2 0 0 0-2 2.22 29 29 0 0 0 4.15 11.97z'
  }));
});
PhoneOffFilled32.displayName = 'PhoneOffFilled32';
PhoneOffFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneOffFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneOffFilled24 = React.forwardRef(function (_ref1300, ref) {
  var className = _ref1300.className,
      children = _ref1300.children,
      style = _ref1300.style,
      tabIndex = _ref1300.tabIndex,
      rest = _objectWithoutProperties$2(_ref1300, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1300 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1300.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1300, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.74 19.56l-2.52-1a2 2 0 0 0-2.15.44L20 21.06a9.93 9.93 0 0 1-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0 0 28 26v-4.59a2 2 0 0 0-1.26-1.85zM8.15 18.19l3.52-3.52a11.68 11.68 0 0 1-.82-2.67l2.07-2.07a2 2 0 0 0 .44-2.15l-1-2.52A2 2 0 0 0 10.5 4H6a2 2 0 0 0-2 2.22 29 29 0 0 0 4.15 11.97z'
  }));
});
PhoneOffFilled24.displayName = 'PhoneOffFilled24';
PhoneOffFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneOffFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneOffFilled20 = React.forwardRef(function (_ref1301, ref) {
  var className = _ref1301.className,
      children = _ref1301.children,
      style = _ref1301.style,
      tabIndex = _ref1301.tabIndex,
      rest = _objectWithoutProperties$2(_ref1301, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1301 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1301.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1301, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.74 19.56l-2.52-1a2 2 0 0 0-2.15.44L20 21.06a9.93 9.93 0 0 1-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0 0 28 26v-4.59a2 2 0 0 0-1.26-1.85zM8.15 18.19l3.52-3.52a11.68 11.68 0 0 1-.82-2.67l2.07-2.07a2 2 0 0 0 .44-2.15l-1-2.52A2 2 0 0 0 10.5 4H6a2 2 0 0 0-2 2.22 29 29 0 0 0 4.15 11.97z'
  }));
});
PhoneOffFilled20.displayName = 'PhoneOffFilled20';
PhoneOffFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneOffFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneOff32 = React.forwardRef(function (_ref1302, ref) {
  var className = _ref1302.className,
      children = _ref1302.children,
      style = _ref1302.style,
      tabIndex = _ref1302.tabIndex,
      rest = _objectWithoutProperties$2(_ref1302, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1302 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1302.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1302, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.19 18.56A25.66 25.66 0 0 1 5 6.08V6a1 1 0 0 1 1-1h5.28l1.5 3.77-2.84 2.87.06.48a13 13 0 0 0 1.46 4.17l1.46-1.46a9.34 9.34 0 0 1-.84-2.52l2.13-2.15A2 2 0 0 0 14.65 8l-1.52-3.74A2 2 0 0 0 11.27 3H5.76A3 3 0 0 0 3 6.23 28 28 0 0 0 7.79 20zm18.58.3L24 17.35a2 2 0 0 0-2.17.41l-2.17 2.15A9.17 9.17 0 0 1 15.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6h.2a3 3 0 0 0 3-3v-5.28a2 2 0 0 0-1.23-1.86zM27 26v.06a1 1 0 0 1-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0 0 19.88 22l.48.06 2.87-2.85L27 20.72z'
  }));
});
PhoneOff32.displayName = 'PhoneOff32';
PhoneOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneOff24 = React.forwardRef(function (_ref1303, ref) {
  var className = _ref1303.className,
      children = _ref1303.children,
      style = _ref1303.style,
      tabIndex = _ref1303.tabIndex,
      rest = _objectWithoutProperties$2(_ref1303, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1303 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1303.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1303, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.19 18.56A25.66 25.66 0 0 1 5 6.08V6a1 1 0 0 1 1-1h5.28l1.5 3.77-2.84 2.87.06.48a13 13 0 0 0 1.46 4.17l1.46-1.46a9.34 9.34 0 0 1-.84-2.52l2.13-2.15A2 2 0 0 0 14.65 8l-1.52-3.74A2 2 0 0 0 11.27 3H5.76A3 3 0 0 0 3 6.23 28 28 0 0 0 7.79 20zm18.58.3L24 17.35a2 2 0 0 0-2.17.41l-2.17 2.15A9.17 9.17 0 0 1 15.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6h.2a3 3 0 0 0 3-3v-5.28a2 2 0 0 0-1.23-1.86zM27 26v.06a1 1 0 0 1-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0 0 19.88 22l.48.06 2.87-2.85L27 20.72z'
  }));
});
PhoneOff24.displayName = 'PhoneOff24';
PhoneOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PhoneOff20 = React.forwardRef(function (_ref1304, ref) {
  var className = _ref1304.className,
      children = _ref1304.children,
      style = _ref1304.style,
      tabIndex = _ref1304.tabIndex,
      rest = _objectWithoutProperties$2(_ref1304, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1304 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1304.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1304, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.19 18.56A25.66 25.66 0 0 1 5 6.08V6a1 1 0 0 1 1-1h5.28l1.5 3.77-2.84 2.87.06.48a13 13 0 0 0 1.46 4.17l1.46-1.46a9.34 9.34 0 0 1-.84-2.52l2.13-2.15A2 2 0 0 0 14.65 8l-1.52-3.74A2 2 0 0 0 11.27 3H5.76A3 3 0 0 0 3 6.23 28 28 0 0 0 7.79 20zm18.58.3L24 17.35a2 2 0 0 0-2.17.41l-2.17 2.15A9.17 9.17 0 0 1 15.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6h.2a3 3 0 0 0 3-3v-5.28a2 2 0 0 0-1.23-1.86zM27 26v.06a1 1 0 0 1-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0 0 19.88 22l.48.06 2.87-2.85L27 20.72z'
  }));
});
PhoneOff20.displayName = 'PhoneOff20';
PhoneOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PhoneOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Phone32 = React.forwardRef(function (_ref1305, ref) {
  var className = _ref1305.className,
      children = _ref1305.children,
      style = _ref1305.style,
      tabIndex = _ref1305.tabIndex,
      rest = _objectWithoutProperties$2(_ref1305, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1305 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1305.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1305, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 0 1 5.76 3h5.51a2 2 0 0 1 1.86 1.26L14.65 8a2 2 0 0 1-.44 2.16l-2.13 2.15a9.37 9.37 0 0 0 7.58 7.6l2.17-2.15a2 2 0 0 1 2.17-.41l3.77 1.51A2 2 0 0 1 29 20.72V26a3 3 0 0 1-3 3zM6 5a1 1 0 0 0-1 1v.08C5.46 12 8.41 26 25.94 27a1 1 0 0 0 1.06-.94v-5.34l-3.77-1.51-2.87 2.85-.48-.06c-8.7-1.09-9.88-9.79-9.88-9.88l-.06-.48 2.84-2.87L11.28 5z'
  }));
});
Phone32.displayName = 'Phone32';
Phone32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Phone32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Phone24 = React.forwardRef(function (_ref1306, ref) {
  var className = _ref1306.className,
      children = _ref1306.children,
      style = _ref1306.style,
      tabIndex = _ref1306.tabIndex,
      rest = _objectWithoutProperties$2(_ref1306, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1306 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1306.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1306, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 0 1 5.76 3h5.51a2 2 0 0 1 1.86 1.26L14.65 8a2 2 0 0 1-.44 2.16l-2.13 2.15a9.37 9.37 0 0 0 7.58 7.6l2.17-2.15a2 2 0 0 1 2.17-.41l3.77 1.51A2 2 0 0 1 29 20.72V26a3 3 0 0 1-3 3zM6 5a1 1 0 0 0-1 1v.08C5.46 12 8.41 26 25.94 27a1 1 0 0 0 1.06-.94v-5.34l-3.77-1.51-2.87 2.85-.48-.06c-8.7-1.09-9.88-9.79-9.88-9.88l-.06-.48 2.84-2.87L11.28 5z'
  }));
});
Phone24.displayName = 'Phone24';
Phone24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Phone24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Phone20 = React.forwardRef(function (_ref1307, ref) {
  var className = _ref1307.className,
      children = _ref1307.children,
      style = _ref1307.style,
      tabIndex = _ref1307.tabIndex,
      rest = _objectWithoutProperties$2(_ref1307, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1307 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1307.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1307, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 0 1 5.76 3h5.51a2 2 0 0 1 1.86 1.26L14.65 8a2 2 0 0 1-.44 2.16l-2.13 2.15a9.37 9.37 0 0 0 7.58 7.6l2.17-2.15a2 2 0 0 1 2.17-.41l3.77 1.51A2 2 0 0 1 29 20.72V26a3 3 0 0 1-3 3zM6 5a1 1 0 0 0-1 1v.08C5.46 12 8.41 26 25.94 27a1 1 0 0 0 1.06-.94v-5.34l-3.77-1.51-2.87 2.85-.48-.06c-8.7-1.09-9.88-9.79-9.88-9.88l-.06-.48 2.84-2.87L11.28 5z'
  }));
});
Phone20.displayName = 'Phone20';
Phone20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Phone20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PillsAdd32 = React.forwardRef(function (_ref1308, ref) {
  var className = _ref1308.className,
      children = _ref1308.children,
      style = _ref1308.style,
      tabIndex = _ref1308.tabIndex,
      rest = _objectWithoutProperties$2(_ref1308, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1308 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1308.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1308, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.28 4.58A8 8 0 1 0 22 14zM11 4a5 5 0 0 1 5 5v6H6V9a5 5 0 0 1 5-5zm0 24a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 1 1 6-6 6 6 0 0 1-6 6z'
  }), React.createElement('path', {
    d: 'M25 21h-2v-2h-2v2h-2v2h2v2h2v-2h2v-2z'
  }));
});
PillsAdd32.displayName = 'PillsAdd32';
PillsAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PillsAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PillsAdd24 = React.forwardRef(function (_ref1309, ref) {
  var className = _ref1309.className,
      children = _ref1309.children,
      style = _ref1309.style,
      tabIndex = _ref1309.tabIndex,
      rest = _objectWithoutProperties$2(_ref1309, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1309 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1309.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1309, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.28 4.58A8 8 0 1 0 22 14zM11 4a5 5 0 0 1 5 5v6H6V9a5 5 0 0 1 5-5zm0 24a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 1 1 6-6 6 6 0 0 1-6 6z'
  }), React.createElement('path', {
    d: 'M25 21h-2v-2h-2v2h-2v2h2v2h2v-2h2v-2z'
  }));
});
PillsAdd24.displayName = 'PillsAdd24';
PillsAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PillsAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PillsAdd20 = React.forwardRef(function (_ref1310, ref) {
  var className = _ref1310.className,
      children = _ref1310.children,
      style = _ref1310.style,
      tabIndex = _ref1310.tabIndex,
      rest = _objectWithoutProperties$2(_ref1310, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1310 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1310.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1310, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.28 4.58A8 8 0 1 0 22 14zM11 4a5 5 0 0 1 5 5v6H6V9a5 5 0 0 1 5-5zm0 24a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 1 1 6-6 6 6 0 0 1-6 6z'
  }), React.createElement('path', {
    d: 'M25 21h-2v-2h-2v2h-2v2h2v2h2v-2h2v-2z'
  }));
});
PillsAdd20.displayName = 'PillsAdd20';
PillsAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PillsAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PillsSubtract32 = React.forwardRef(function (_ref1311, ref) {
  var className = _ref1311.className,
      children = _ref1311.children,
      style = _ref1311.style,
      tabIndex = _ref1311.tabIndex,
      rest = _objectWithoutProperties$2(_ref1311, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1311 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1311.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1311, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.28 4.58A8 8 0 1 0 22 14zM11 4a5 5 0 0 1 5 5v6H6V9a5 5 0 0 1 5-5zm0 24a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 1 1 6-6 6 6 0 0 1-6 6z'
  }), React.createElement('path', {
    d: 'M19 21h6v2h-6z'
  }));
});
PillsSubtract32.displayName = 'PillsSubtract32';
PillsSubtract32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PillsSubtract32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PillsSubtract24 = React.forwardRef(function (_ref1312, ref) {
  var className = _ref1312.className,
      children = _ref1312.children,
      style = _ref1312.style,
      tabIndex = _ref1312.tabIndex,
      rest = _objectWithoutProperties$2(_ref1312, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1312 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1312.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1312, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.28 4.58A8 8 0 1 0 22 14zM11 4a5 5 0 0 1 5 5v6H6V9a5 5 0 0 1 5-5zm0 24a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 1 1 6-6 6 6 0 0 1-6 6z'
  }), React.createElement('path', {
    d: 'M19 21h6v2h-6z'
  }));
});
PillsSubtract24.displayName = 'PillsSubtract24';
PillsSubtract24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PillsSubtract24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PillsSubtract20 = React.forwardRef(function (_ref1313, ref) {
  var className = _ref1313.className,
      children = _ref1313.children,
      style = _ref1313.style,
      tabIndex = _ref1313.tabIndex,
      rest = _objectWithoutProperties$2(_ref1313, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1313 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1313.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1313, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.28 4.58A8 8 0 1 0 22 14zM11 4a5 5 0 0 1 5 5v6H6V9a5 5 0 0 1 5-5zm0 24a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 1 1 6-6 6 6 0 0 1-6 6z'
  }), React.createElement('path', {
    d: 'M19 21h6v2h-6z'
  }));
});
PillsSubtract20.displayName = 'PillsSubtract20';
PillsSubtract20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PillsSubtract20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pills32 = React.forwardRef(function (_ref1314, ref) {
  var className = _ref1314.className,
      children = _ref1314.children,
      style = _ref1314.style,
      tabIndex = _ref1314.tabIndex,
      rest = _objectWithoutProperties$2(_ref1314, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1314 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1314.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1314, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.29 4.59A8 8 0 1 0 22 14zm0 2a6 6 0 0 1 5.91 5H16.09A6 6 0 0 1 22 16zM6 9a5 5 0 0 1 10 0v6H6zm5 19a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 0 1-5.91-5h11.82A6 6 0 0 1 22 28z'
  }));
});
Pills32.displayName = 'Pills32';
Pills32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pills32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pills24 = React.forwardRef(function (_ref1315, ref) {
  var className = _ref1315.className,
      children = _ref1315.children,
      style = _ref1315.style,
      tabIndex = _ref1315.tabIndex,
      rest = _objectWithoutProperties$2(_ref1315, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1315 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1315.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1315, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.29 4.59A8 8 0 1 0 22 14zm0 2a6 6 0 0 1 5.91 5H16.09A6 6 0 0 1 22 16zM6 9a5 5 0 0 1 10 0v6H6zm5 19a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 0 1-5.91-5h11.82A6 6 0 0 1 22 28z'
  }));
});
Pills24.displayName = 'Pills24';
Pills24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pills24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pills20 = React.forwardRef(function (_ref1316, ref) {
  var className = _ref1316.className,
      children = _ref1316.children,
      style = _ref1316.style,
      tabIndex = _ref1316.tabIndex,
      rest = _objectWithoutProperties$2(_ref1316, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1316 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1316.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1316, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 10h-2a2 2 0 0 0-2-2V6a4 4 0 0 1 4 4z'
  }), React.createElement('path', {
    d: 'M22 14a8 8 0 0 0-4 1.08V9A7 7 0 0 0 4 9v14a7 7 0 0 0 12.29 4.59A8 8 0 1 0 22 14zm0 2a6 6 0 0 1 5.91 5H16.09A6 6 0 0 1 22 16zM6 9a5 5 0 0 1 10 0v6H6zm5 19a5 5 0 0 1-5-5v-6h9.76a8 8 0 0 0-.76 8.93A5 5 0 0 1 11 28zm11 0a6 6 0 0 1-5.91-5h11.82A6 6 0 0 1 22 28z'
  }));
});
Pills20.displayName = 'Pills20';
Pills20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pills20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pin32 = React.forwardRef(function (_ref1317, ref) {
  var className = _ref1317.className,
      children = _ref1317.children,
      style = _ref1317.style,
      tabIndex = _ref1317.tabIndex,
      rest = _objectWithoutProperties$2(_ref1317, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1317 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1317.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1317, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.59 13.31L30 11.9 20 2l-1.31 1.42 1.18 1.18-11.49 9.72-1.72-1.71L5.25 14l5.66 5.68L2 28.58 3.41 30l8.91-8.91L18 26.75l1.39-1.42-1.71-1.71 9.72-11.49zM16.26 22.2L9.8 15.74 21.29 6 26 10.71z'
  }));
});
Pin32.displayName = 'Pin32';
Pin32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pin32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pin24 = React.forwardRef(function (_ref1318, ref) {
  var className = _ref1318.className,
      children = _ref1318.children,
      style = _ref1318.style,
      tabIndex = _ref1318.tabIndex,
      rest = _objectWithoutProperties$2(_ref1318, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1318 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1318.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1318, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.59 13.31L30 11.9 20 2l-1.31 1.42 1.18 1.18-11.49 9.72-1.72-1.71L5.25 14l5.66 5.68L2 28.58 3.41 30l8.91-8.91L18 26.75l1.39-1.42-1.71-1.71 9.72-11.49zM16.26 22.2L9.8 15.74 21.29 6 26 10.71z'
  }));
});
Pin24.displayName = 'Pin24';
Pin24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pin24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Pin20 = React.forwardRef(function (_ref1319, ref) {
  var className = _ref1319.className,
      children = _ref1319.children,
      style = _ref1319.style,
      tabIndex = _ref1319.tabIndex,
      rest = _objectWithoutProperties$2(_ref1319, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1319 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1319.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1319, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.59 13.31L30 11.9 20 2l-1.31 1.42 1.18 1.18-11.49 9.72-1.72-1.71L5.25 14l5.66 5.68L2 28.58 3.41 30l8.91-8.91L18 26.75l1.39-1.42-1.71-1.71 9.72-11.49zM16.26 22.2L9.8 15.74 21.29 6 26 10.71z'
  }));
});
Pin20.displayName = 'Pin20';
Pin20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pin20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Plane32 = React.forwardRef(function (_ref1320, ref) {
  var className = _ref1320.className,
      children = _ref1320.children,
      style = _ref1320.style,
      tabIndex = _ref1320.tabIndex,
      rest = _objectWithoutProperties$2(_ref1320, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1320 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1320.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1320, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.37 14.75L20 10V6a4 4 0 0 0-8 0v4l-9.37 4.75a1 1 0 0 0-.63.93v5a1 1 0 0 0 1 1 1 1 0 0 0 .29-.05L12 18v5l-3.45 1.72a1 1 0 0 0-.55.9V29a1 1 0 0 0 1 1 .9.9 0 0 0 .28 0L16 28l6.72 2a.9.9 0 0 0 .28 0 1 1 0 0 0 1-1v-3.38a1 1 0 0 0-.55-.9L20 23v-5l8.71 3.61a1 1 0 0 0 .29.05 1 1 0 0 0 1-1v-5a1 1 0 0 0-.63-.91zM28 19.15L18 15v9.24l4 2v1.43l-6-1.75-6 1.75v-1.43l4-2V15L4 19.15V16.3l10-5.07V6a2 2 0 0 1 4 0v5.23l10 5.07z'
  }));
});
Plane32.displayName = 'Plane32';
Plane32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Plane32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Plane24 = React.forwardRef(function (_ref1321, ref) {
  var className = _ref1321.className,
      children = _ref1321.children,
      style = _ref1321.style,
      tabIndex = _ref1321.tabIndex,
      rest = _objectWithoutProperties$2(_ref1321, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1321 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1321.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1321, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.37 14.75L20 10V6a4 4 0 0 0-8 0v4l-9.37 4.75a1 1 0 0 0-.63.93v5a1 1 0 0 0 1 1 1 1 0 0 0 .29-.05L12 18v5l-3.45 1.72a1 1 0 0 0-.55.9V29a1 1 0 0 0 1 1 .9.9 0 0 0 .28 0L16 28l6.72 2a.9.9 0 0 0 .28 0 1 1 0 0 0 1-1v-3.38a1 1 0 0 0-.55-.9L20 23v-5l8.71 3.61a1 1 0 0 0 .29.05 1 1 0 0 0 1-1v-5a1 1 0 0 0-.63-.91zM28 19.15L18 15v9.24l4 2v1.43l-6-1.75-6 1.75v-1.43l4-2V15L4 19.15V16.3l10-5.07V6a2 2 0 0 1 4 0v5.23l10 5.07z'
  }));
});
Plane24.displayName = 'Plane24';
Plane24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Plane24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Plane20 = React.forwardRef(function (_ref1322, ref) {
  var className = _ref1322.className,
      children = _ref1322.children,
      style = _ref1322.style,
      tabIndex = _ref1322.tabIndex,
      rest = _objectWithoutProperties$2(_ref1322, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1322 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1322.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1322, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.37 14.75L20 10V6a4 4 0 0 0-8 0v4l-9.37 4.75a1 1 0 0 0-.63.93v5a1 1 0 0 0 1 1 1 1 0 0 0 .29-.05L12 18v5l-3.45 1.72a1 1 0 0 0-.55.9V29a1 1 0 0 0 1 1 .9.9 0 0 0 .28 0L16 28l6.72 2a.9.9 0 0 0 .28 0 1 1 0 0 0 1-1v-3.38a1 1 0 0 0-.55-.9L20 23v-5l8.71 3.61a1 1 0 0 0 .29.05 1 1 0 0 0 1-1v-5a1 1 0 0 0-.63-.91zM28 19.15L18 15v9.24l4 2v1.43l-6-1.75-6 1.75v-1.43l4-2V15L4 19.15V16.3l10-5.07V6a2 2 0 0 1 4 0v5.23l10 5.07z'
  }));
});
Plane20.displayName = 'Plane20';
Plane20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Plane20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayFilled32 = React.forwardRef(function (_ref1323, ref) {
  var className = _ref1323.className,
      children = _ref1323.children,
      style = _ref1323.style,
      tabIndex = _ref1323.tabIndex,
      rest = _objectWithoutProperties$2(_ref1323, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1323 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1323.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1323, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm7.48 14.88l-11 6a1 1 0 0 1-1 0A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76z'
  }));
});
PlayFilled32.displayName = 'PlayFilled32';
PlayFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayFilled24 = React.forwardRef(function (_ref1324, ref) {
  var className = _ref1324.className,
      children = _ref1324.children,
      style = _ref1324.style,
      tabIndex = _ref1324.tabIndex,
      rest = _objectWithoutProperties$2(_ref1324, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1324 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1324.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1324, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm7.48 14.88l-11 6a1 1 0 0 1-1 0A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76z'
  }));
});
PlayFilled24.displayName = 'PlayFilled24';
PlayFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayFilled20 = React.forwardRef(function (_ref1325, ref) {
  var className = _ref1325.className,
      children = _ref1325.children,
      style = _ref1325.style,
      tabIndex = _ref1325.tabIndex,
      rest = _objectWithoutProperties$2(_ref1325, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1325 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1325.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1325, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm7.48 14.88l-11 6a1 1 0 0 1-1 0A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76z'
  }));
});
PlayFilled20.displayName = 'PlayFilled20';
PlayFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutlineFilled32 = React.forwardRef(function (_ref1326, ref) {
  var className = _ref1326.className,
      children = _ref1326.children,
      style = _ref1326.style,
      tabIndex = _ref1326.tabIndex,
      rest = _objectWithoutProperties$2(_ref1326, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1326 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1326.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1326, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm7.48 14.88l-11 6a1 1 0 0 1-1 0A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76z'
  }), React.createElement('path', {
    d: 'M13 20.32L20.91 16 13 11.69v8.63z'
  }));
});
PlayOutlineFilled32.displayName = 'PlayOutlineFilled32';
PlayOutlineFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutlineFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutlineFilled24 = React.forwardRef(function (_ref1327, ref) {
  var className = _ref1327.className,
      children = _ref1327.children,
      style = _ref1327.style,
      tabIndex = _ref1327.tabIndex,
      rest = _objectWithoutProperties$2(_ref1327, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1327 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1327.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1327, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm7.48 14.88l-11 6a1 1 0 0 1-1 0A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76z'
  }), React.createElement('path', {
    d: 'M13 20.32L20.91 16 13 11.69v8.63z'
  }));
});
PlayOutlineFilled24.displayName = 'PlayOutlineFilled24';
PlayOutlineFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutlineFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutlineFilled20 = React.forwardRef(function (_ref1328, ref) {
  var className = _ref1328.className,
      children = _ref1328.children,
      style = _ref1328.style,
      tabIndex = _ref1328.tabIndex,
      rest = _objectWithoutProperties$2(_ref1328, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1328 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1328.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1328, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm7.48 14.88l-11 6a1 1 0 0 1-1 0A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76z'
  }), React.createElement('path', {
    d: 'M13 20.32L20.91 16 13 11.69v8.63z'
  }));
});
PlayOutlineFilled20.displayName = 'PlayOutlineFilled20';
PlayOutlineFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutlineFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutline32 = React.forwardRef(function (_ref1329, ref) {
  var className = _ref1329.className,
      children = _ref1329.children,
      style = _ref1329.style,
      tabIndex = _ref1329.tabIndex,
      rest = _objectWithoutProperties$2(_ref1329, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1329 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1329.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1329, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M12 23a1 1 0 0 1-.51-.14A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76l-11 6a1 1 0 0 1-.49.1zm1-11.32v8.64L20.91 16z'
  }));
});
PlayOutline32.displayName = 'PlayOutline32';
PlayOutline32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutline32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutline24 = React.forwardRef(function (_ref1330, ref) {
  var className = _ref1330.className,
      children = _ref1330.children,
      style = _ref1330.style,
      tabIndex = _ref1330.tabIndex,
      rest = _objectWithoutProperties$2(_ref1330, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1330 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1330.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1330, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M12 23a1 1 0 0 1-.51-.14A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76l-11 6a1 1 0 0 1-.49.1zm1-11.32v8.64L20.91 16z'
  }));
});
PlayOutline24.displayName = 'PlayOutline24';
PlayOutline24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutline24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PlayOutline20 = React.forwardRef(function (_ref1331, ref) {
  var className = _ref1331.className,
      children = _ref1331.children,
      style = _ref1331.style,
      tabIndex = _ref1331.tabIndex,
      rest = _objectWithoutProperties$2(_ref1331, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1331 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1331.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1331, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M12 23a1 1 0 0 1-.51-.14A1 1 0 0 1 11 22V10a1 1 0 0 1 .49-.86 1 1 0 0 1 1 0l11 6a1 1 0 0 1 0 1.76l-11 6a1 1 0 0 1-.49.1zm1-11.32v8.64L20.91 16z'
  }));
});
PlayOutline20.displayName = 'PlayOutline20';
PlayOutline20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PlayOutline20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Play32 = React.forwardRef(function (_ref1332, ref) {
  var className = _ref1332.className,
      children = _ref1332.children,
      style = _ref1332.style,
      tabIndex = _ref1332.tabIndex,
      rest = _objectWithoutProperties$2(_ref1332, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1332 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1332.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1332, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 28a1 1 0 0 1-1-1V5a1 1 0 0 1 .5-.87 1 1 0 0 1 1 0l19 11a1 1 0 0 1 0 1.74l-19 11A1 1 0 0 1 7 28zM8 6.73v18.54L24 16z'
  }));
});
Play32.displayName = 'Play32';
Play32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Play32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Play24 = React.forwardRef(function (_ref1333, ref) {
  var className = _ref1333.className,
      children = _ref1333.children,
      style = _ref1333.style,
      tabIndex = _ref1333.tabIndex,
      rest = _objectWithoutProperties$2(_ref1333, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1333 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1333.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1333, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 28a1 1 0 0 1-1-1V5a1 1 0 0 1 .5-.87 1 1 0 0 1 1 0l19 11a1 1 0 0 1 0 1.74l-19 11A1 1 0 0 1 7 28zM8 6.73v18.54L24 16z'
  }));
});
Play24.displayName = 'Play24';
Play24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Play24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Play20 = React.forwardRef(function (_ref1334, ref) {
  var className = _ref1334.className,
      children = _ref1334.children,
      style = _ref1334.style,
      tabIndex = _ref1334.tabIndex,
      rest = _objectWithoutProperties$2(_ref1334, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1334 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1334.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1334, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 28a1 1 0 0 1-1-1V5a1 1 0 0 1 .5-.87 1 1 0 0 1 1 0l19 11a1 1 0 0 1 0 1.74l-19 11A1 1 0 0 1 7 28zM8 6.73v18.54L24 16z'
  }));
});
Play20.displayName = 'Play20';
Play20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Play20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Playlist32 = React.forwardRef(function (_ref1335, ref) {
  var className = _ref1335.className,
      children = _ref1335.children,
      style = _ref1335.style,
      tabIndex = _ref1335.tabIndex,
      rest = _objectWithoutProperties$2(_ref1335, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1335 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1335.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1335, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h18v2H4zm0 6h18v2H4zm0 6h12v2H4zm17 0l7 5-7 5V18z'
  }));
});
Playlist32.displayName = 'Playlist32';
Playlist32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Playlist32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Playlist24 = React.forwardRef(function (_ref1336, ref) {
  var className = _ref1336.className,
      children = _ref1336.children,
      style = _ref1336.style,
      tabIndex = _ref1336.tabIndex,
      rest = _objectWithoutProperties$2(_ref1336, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1336 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1336.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1336, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h18v2H4zm0 6h18v2H4zm0 6h12v2H4zm17 0l7 5-7 5V18z'
  }));
});
Playlist24.displayName = 'Playlist24';
Playlist24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Playlist24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Playlist20 = React.forwardRef(function (_ref1337, ref) {
  var className = _ref1337.className,
      children = _ref1337.children,
      style = _ref1337.style,
      tabIndex = _ref1337.tabIndex,
      rest = _objectWithoutProperties$2(_ref1337, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1337 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1337.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1337, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h18v2H4zm0 6h18v2H4zm0 6h12v2H4zm17 0l7 5-7 5V18z'
  }));
});
Playlist20.displayName = 'Playlist20';
Playlist20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Playlist20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Popup32 = React.forwardRef(function (_ref1338, ref) {
  var className = _ref1338.className,
      children = _ref1338.children,
      style = _ref1338.style,
      tabIndex = _ref1338.tabIndex,
      rest = _objectWithoutProperties$2(_ref1338, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1338 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1338.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1338, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H10V6h18z'
  }), React.createElement('path', {
    d: 'M16 26H4V16h2v-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2z'
  }));
});
Popup32.displayName = 'Popup32';
Popup32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Popup32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Popup24 = React.forwardRef(function (_ref1339, ref) {
  var className = _ref1339.className,
      children = _ref1339.children,
      style = _ref1339.style,
      tabIndex = _ref1339.tabIndex,
      rest = _objectWithoutProperties$2(_ref1339, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1339 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1339.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1339, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H10V6h18z'
  }), React.createElement('path', {
    d: 'M16 26H4V16h2v-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2z'
  }));
});
Popup24.displayName = 'Popup24';
Popup24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Popup24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Popup20 = React.forwardRef(function (_ref1340, ref) {
  var className = _ref1340.className,
      children = _ref1340.children,
      style = _ref1340.style,
      tabIndex = _ref1340.tabIndex,
      rest = _objectWithoutProperties$2(_ref1340, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1340 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1340.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1340, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H10V6h18z'
  }), React.createElement('path', {
    d: 'M16 26H4V16h2v-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2z'
  }));
});
Popup20.displayName = 'Popup20';
Popup20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Popup20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Portfolio32 = React.forwardRef(function (_ref1341, ref) {
  var className = _ref1341.className,
      children = _ref1341.children,
      style = _ref1341.style,
      tabIndex = _ref1341.tabIndex,
      rest = _objectWithoutProperties$2(_ref1341, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1341 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1341.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1341, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10h-6V6a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zM12 6h8v4h-8zM4 26V12h24v14z'
  }));
});
Portfolio32.displayName = 'Portfolio32';
Portfolio32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Portfolio32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Portfolio24 = React.forwardRef(function (_ref1342, ref) {
  var className = _ref1342.className,
      children = _ref1342.children,
      style = _ref1342.style,
      tabIndex = _ref1342.tabIndex,
      rest = _objectWithoutProperties$2(_ref1342, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1342 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1342.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1342, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10h-6V6a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zM12 6h8v4h-8zM4 26V12h24v14z'
  }));
});
Portfolio24.displayName = 'Portfolio24';
Portfolio24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Portfolio24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Portfolio20 = React.forwardRef(function (_ref1343, ref) {
  var className = _ref1343.className,
      children = _ref1343.children,
      style = _ref1343.style,
      tabIndex = _ref1343.tabIndex,
      rest = _objectWithoutProperties$2(_ref1343, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1343 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1343.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1343, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10h-6V6a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zM12 6h8v4h-8zM4 26V12h24v14z'
  }));
});
Portfolio20.displayName = 'Portfolio20';
Portfolio20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Portfolio20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Power32 = React.forwardRef(function (_ref1344, ref) {
  var className = _ref1344.className,
      children = _ref1344.children,
      style = _ref1344.style,
      tabIndex = _ref1344.tabIndex,
      rest = _objectWithoutProperties$2(_ref1344, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1344 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1344.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1344, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.5 5.74l-1 1.73a11 11 0 1 1-11 0l-1-1.73a13 13 0 1 0 13 0z'
  }), React.createElement('path', {
    d: 'M15 2h2v14h-2z'
  }));
});
Power32.displayName = 'Power32';
Power32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Power32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Power24 = React.forwardRef(function (_ref1345, ref) {
  var className = _ref1345.className,
      children = _ref1345.children,
      style = _ref1345.style,
      tabIndex = _ref1345.tabIndex,
      rest = _objectWithoutProperties$2(_ref1345, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1345 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1345.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1345, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.5 5.74l-1 1.73a11 11 0 1 1-11 0l-1-1.73a13 13 0 1 0 13 0z'
  }), React.createElement('path', {
    d: 'M15 2h2v14h-2z'
  }));
});
Power24.displayName = 'Power24';
Power24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Power24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Power20 = React.forwardRef(function (_ref1346, ref) {
  var className = _ref1346.className,
      children = _ref1346.children,
      style = _ref1346.style,
      tabIndex = _ref1346.tabIndex,
      rest = _objectWithoutProperties$2(_ref1346, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1346 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1346.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1346, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.5 5.74l-1 1.73a11 11 0 1 1-11 0l-1-1.73a13 13 0 1 0 13 0z'
  }), React.createElement('path', {
    d: 'M15 2h2v14h-2z'
  }));
});
Power20.displayName = 'Power20';
Power20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Power20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PresentationFile32 = React.forwardRef(function (_ref1347, ref) {
  var className = _ref1347.className,
      children = _ref1347.children,
      style = _ref1347.style,
      tabIndex = _ref1347.tabIndex,
      rest = _objectWithoutProperties$2(_ref1347, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1347 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1347.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1347, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 10h2v8h-2zm5 4h2v4h-2zm-10-2h2v6h-2z'
  }), React.createElement('path', {
    d: 'M25 4h-8V2h-2v2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8v6h-4v2h10v-2h-4v-6h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H7V6h18z'
  }));
});
PresentationFile32.displayName = 'PresentationFile32';
PresentationFile32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PresentationFile32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PresentationFile24 = React.forwardRef(function (_ref1348, ref) {
  var className = _ref1348.className,
      children = _ref1348.children,
      style = _ref1348.style,
      tabIndex = _ref1348.tabIndex,
      rest = _objectWithoutProperties$2(_ref1348, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1348 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1348.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1348, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 10h2v8h-2zm5 4h2v4h-2zm-10-2h2v6h-2z'
  }), React.createElement('path', {
    d: 'M25 4h-8V2h-2v2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8v6h-4v2h10v-2h-4v-6h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H7V6h18z'
  }));
});
PresentationFile24.displayName = 'PresentationFile24';
PresentationFile24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PresentationFile24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var PresentationFile20 = React.forwardRef(function (_ref1349, ref) {
  var className = _ref1349.className,
      children = _ref1349.children,
      style = _ref1349.style,
      tabIndex = _ref1349.tabIndex,
      rest = _objectWithoutProperties$2(_ref1349, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1349 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1349.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1349, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 10h2v8h-2zm5 4h2v4h-2zm-10-2h2v6h-2z'
  }), React.createElement('path', {
    d: 'M25 4h-8V2h-2v2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8v6h-4v2h10v-2h-4v-6h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H7V6h18z'
  }));
});
PresentationFile20.displayName = 'PresentationFile20';
PresentationFile20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
PresentationFile20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Printer32 = React.forwardRef(function (_ref1350, ref) {
  var className = _ref1350.className,
      children = _ref1350.children,
      style = _ref1350.style,
      tabIndex = _ref1350.tabIndex,
      rest = _objectWithoutProperties$2(_ref1350, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1350 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1350.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1350, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-3V3H7v6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3v6h18v-6h3a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM9 5h14v4H9zm14 22H9V17h14zm5-6h-3v-6H7v6H4V11h24z'
  }));
});
Printer32.displayName = 'Printer32';
Printer32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Printer32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Printer24 = React.forwardRef(function (_ref1351, ref) {
  var className = _ref1351.className,
      children = _ref1351.children,
      style = _ref1351.style,
      tabIndex = _ref1351.tabIndex,
      rest = _objectWithoutProperties$2(_ref1351, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1351 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1351.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1351, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-3V3H7v6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3v6h18v-6h3a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM9 5h14v4H9zm14 22H9V17h14zm5-6h-3v-6H7v6H4V11h24z'
  }));
});
Printer24.displayName = 'Printer24';
Printer24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Printer24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Printer20 = React.forwardRef(function (_ref1352, ref) {
  var className = _ref1352.className,
      children = _ref1352.children,
      style = _ref1352.style,
      tabIndex = _ref1352.tabIndex,
      rest = _objectWithoutProperties$2(_ref1352, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1352 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1352.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1352, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 9h-3V3H7v6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3v6h18v-6h3a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zM9 5h14v4H9zm14 22H9V17h14zm5-6h-3v-6H7v6H4V11h24z'
  }));
});
Printer20.displayName = 'Printer20';
Printer20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Printer20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Purchase32 = React.forwardRef(function (_ref1353, ref) {
  var className = _ref1353.className,
      children = _ref1353.children,
      style = _ref1353.style,
      tabIndex = _ref1353.tabIndex,
      rest = _objectWithoutProperties$2(_ref1353, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1353 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1353.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1353, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 2v3H4V8zM4 24V13h24v11z'
  }), React.createElement('path', {
    d: 'M6 20h10v2H6z'
  }));
});
Purchase32.displayName = 'Purchase32';
Purchase32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Purchase32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Purchase24 = React.forwardRef(function (_ref1354, ref) {
  var className = _ref1354.className,
      children = _ref1354.children,
      style = _ref1354.style,
      tabIndex = _ref1354.tabIndex,
      rest = _objectWithoutProperties$2(_ref1354, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1354 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1354.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1354, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 2v3H4V8zM4 24V13h24v11z'
  }), React.createElement('path', {
    d: 'M6 20h10v2H6z'
  }));
});
Purchase24.displayName = 'Purchase24';
Purchase24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Purchase24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Purchase20 = React.forwardRef(function (_ref1355, ref) {
  var className = _ref1355.className,
      children = _ref1355.children,
      style = _ref1355.style,
      tabIndex = _ref1355.tabIndex,
      rest = _objectWithoutProperties$2(_ref1355, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1355 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1355.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1355, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 2v3H4V8zM4 24V13h24v11z'
  }), React.createElement('path', {
    d: 'M6 20h10v2H6z'
  }));
});
Purchase20.displayName = 'Purchase20';
Purchase20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Purchase20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QueryQueue32 = React.forwardRef(function (_ref1356, ref) {
  var className = _ref1356.className,
      children = _ref1356.children,
      style = _ref1356.style,
      tabIndex = _ref1356.tabIndex,
      rest = _objectWithoutProperties$2(_ref1356, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1356 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1356.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1356, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6h18v2H10zm0 6h18v2H10zm5 6h13v2H15zm-5 6h18v2H10zM4 14l7 5-7 5V14z'
  }));
});
QueryQueue32.displayName = 'QueryQueue32';
QueryQueue32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QueryQueue32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QueryQueue24 = React.forwardRef(function (_ref1357, ref) {
  var className = _ref1357.className,
      children = _ref1357.children,
      style = _ref1357.style,
      tabIndex = _ref1357.tabIndex,
      rest = _objectWithoutProperties$2(_ref1357, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1357 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1357.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1357, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6h18v2H10zm0 6h18v2H10zm5 6h13v2H15zm-5 6h18v2H10zM4 14l7 5-7 5V14z'
  }));
});
QueryQueue24.displayName = 'QueryQueue24';
QueryQueue24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QueryQueue24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var QueryQueue20 = React.forwardRef(function (_ref1358, ref) {
  var className = _ref1358.className,
      children = _ref1358.children,
      style = _ref1358.style,
      tabIndex = _ref1358.tabIndex,
      rest = _objectWithoutProperties$2(_ref1358, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1358 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1358.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1358, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 6h18v2H10zm0 6h18v2H10zm5 6h13v2H15zm-5 6h18v2H10zM4 14l7 5-7 5V14z'
  }));
});
QueryQueue20.displayName = 'QueryQueue20';
QueryQueue20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
QueryQueue20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Quotes32 = React.forwardRef(function (_ref1359, ref) {
  var className = _ref1359.className,
      children = _ref1359.children,
      style = _ref1359.style,
      tabIndex = _ref1359.tabIndex,
      rest = _objectWithoutProperties$2(_ref1359, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1359 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1359.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1359, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 15H6.11A9 9 0 0 1 10 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 0 0 4 16.35V23a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm14 0h-5.89A9 9 0 0 1 24 8.86l1.79-1.2L24.7 6l-1.8 1.2a11 11 0 0 0-4.9 9.15V23a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z'
  }));
});
Quotes32.displayName = 'Quotes32';
Quotes32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Quotes32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Quotes24 = React.forwardRef(function (_ref1360, ref) {
  var className = _ref1360.className,
      children = _ref1360.children,
      style = _ref1360.style,
      tabIndex = _ref1360.tabIndex,
      rest = _objectWithoutProperties$2(_ref1360, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1360 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1360.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1360, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 15H6.11A9 9 0 0 1 10 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 0 0 4 16.35V23a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm14 0h-5.89A9 9 0 0 1 24 8.86l1.79-1.2L24.7 6l-1.8 1.2a11 11 0 0 0-4.9 9.15V23a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z'
  }));
});
Quotes24.displayName = 'Quotes24';
Quotes24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Quotes24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Quotes20 = React.forwardRef(function (_ref1361, ref) {
  var className = _ref1361.className,
      children = _ref1361.children,
      style = _ref1361.style,
      tabIndex = _ref1361.tabIndex,
      rest = _objectWithoutProperties$2(_ref1361, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1361 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1361.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1361, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 15H6.11A9 9 0 0 1 10 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 0 0 4 16.35V23a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm14 0h-5.89A9 9 0 0 1 24 8.86l1.79-1.2L24.7 6l-1.8 1.2a11 11 0 0 0-4.9 9.15V23a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z'
  }));
});
Quotes20.displayName = 'Quotes20';
Quotes20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Quotes20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RadioButtonChecked32 = React.forwardRef(function (_ref1362, ref) {
  var className = _ref1362.className,
      children = _ref1362.children,
      style = _ref1362.style,
      tabIndex = _ref1362.tabIndex,
      rest = _objectWithoutProperties$2(_ref1362, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1362 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1362.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1362, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RadioButtonChecked32.displayName = 'RadioButtonChecked32';
RadioButtonChecked32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RadioButtonChecked32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RadioButtonChecked24 = React.forwardRef(function (_ref1363, ref) {
  var className = _ref1363.className,
      children = _ref1363.children,
      style = _ref1363.style,
      tabIndex = _ref1363.tabIndex,
      rest = _objectWithoutProperties$2(_ref1363, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1363 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1363.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1363, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RadioButtonChecked24.displayName = 'RadioButtonChecked24';
RadioButtonChecked24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RadioButtonChecked24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RadioButtonChecked20 = React.forwardRef(function (_ref1364, ref) {
  var className = _ref1364.className,
      children = _ref1364.children,
      style = _ref1364.style,
      tabIndex = _ref1364.tabIndex,
      rest = _objectWithoutProperties$2(_ref1364, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1364 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1364.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1364, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RadioButtonChecked20.displayName = 'RadioButtonChecked20';
RadioButtonChecked20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RadioButtonChecked20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RadioButton32 = React.forwardRef(function (_ref1365, ref) {
  var className = _ref1365.className,
      children = _ref1365.children,
      style = _ref1365.style,
      tabIndex = _ref1365.tabIndex,
      rest = _objectWithoutProperties$2(_ref1365, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1365 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1365.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1365, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }));
});
RadioButton32.displayName = 'RadioButton32';
RadioButton32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RadioButton32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RadioButton24 = React.forwardRef(function (_ref1366, ref) {
  var className = _ref1366.className,
      children = _ref1366.children,
      style = _ref1366.style,
      tabIndex = _ref1366.tabIndex,
      rest = _objectWithoutProperties$2(_ref1366, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1366 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1366.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1366, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }));
});
RadioButton24.displayName = 'RadioButton24';
RadioButton24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RadioButton24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RadioButton20 = React.forwardRef(function (_ref1367, ref) {
  var className = _ref1367.className,
      children = _ref1367.children,
      style = _ref1367.style,
      tabIndex = _ref1367.tabIndex,
      rest = _objectWithoutProperties$2(_ref1367, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1367 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1367.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1367, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }));
});
RadioButton20.displayName = 'RadioButton20';
RadioButton20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RadioButton20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Radio32 = React.forwardRef(function (_ref1368, ref) {
  var className = _ref1368.className,
      children = _ref1368.children,
      style = _ref1368.style,
      tabIndex = _ref1368.tabIndex,
      rest = _objectWithoutProperties$2(_ref1368, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1368 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1368.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1368, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10h-4V2h-2v8h-9V8h-2v2H8V8H6v2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zM4 28V12h24v16z'
  }), React.createElement('path', {
    d: 'M10 26a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm-3-6h6v2H7zm10 2h9v2h-9zm0 4h9v2h-9zm0 4h9v2h-9z'
  }));
});
Radio32.displayName = 'Radio32';
Radio32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Radio32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Radio24 = React.forwardRef(function (_ref1369, ref) {
  var className = _ref1369.className,
      children = _ref1369.children,
      style = _ref1369.style,
      tabIndex = _ref1369.tabIndex,
      rest = _objectWithoutProperties$2(_ref1369, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1369 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1369.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1369, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10h-4V2h-2v8h-9V8h-2v2H8V8H6v2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zM4 28V12h24v16z'
  }), React.createElement('path', {
    d: 'M10 26a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm-3-6h6v2H7zm10 2h9v2h-9zm0 4h9v2h-9zm0 4h9v2h-9z'
  }));
});
Radio24.displayName = 'Radio24';
Radio24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Radio24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Radio20 = React.forwardRef(function (_ref1370, ref) {
  var className = _ref1370.className,
      children = _ref1370.children,
      style = _ref1370.style,
      tabIndex = _ref1370.tabIndex,
      rest = _objectWithoutProperties$2(_ref1370, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1370 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1370.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1370, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 10h-4V2h-2v8h-9V8h-2v2H8V8H6v2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zM4 28V12h24v16z'
  }), React.createElement('path', {
    d: 'M10 26a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2zm-3-6h6v2H7zm10 2h9v2h-9zm0 4h9v2h-9zm0 4h9v2h-9z'
  }));
});
Radio20.displayName = 'Radio20';
Radio20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Radio20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecentlyViewed32 = React.forwardRef(function (_ref1371, ref) {
  var className = _ref1371.className,
      children = _ref1371.children,
      style = _ref1371.style,
      tabIndex = _ref1371.tabIndex,
      rest = _objectWithoutProperties$2(_ref1371, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1371 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1371.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1371, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z'
  }), React.createElement('path', {
    d: 'M16 2A13.94 13.94 0 0 0 6 6.23V2H4v8h8V8H7.08A12 12 0 1 1 4 16H2A14 14 0 1 0 16 2z'
  }));
});
RecentlyViewed32.displayName = 'RecentlyViewed32';
RecentlyViewed32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecentlyViewed32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecentlyViewed24 = React.forwardRef(function (_ref1372, ref) {
  var className = _ref1372.className,
      children = _ref1372.children,
      style = _ref1372.style,
      tabIndex = _ref1372.tabIndex,
      rest = _objectWithoutProperties$2(_ref1372, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1372 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1372.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1372, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z'
  }), React.createElement('path', {
    d: 'M16 2A13.94 13.94 0 0 0 6 6.23V2H4v8h8V8H7.08A12 12 0 1 1 4 16H2A14 14 0 1 0 16 2z'
  }));
});
RecentlyViewed24.displayName = 'RecentlyViewed24';
RecentlyViewed24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecentlyViewed24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecentlyViewed20 = React.forwardRef(function (_ref1373, ref) {
  var className = _ref1373.className,
      children = _ref1373.children,
      style = _ref1373.style,
      tabIndex = _ref1373.tabIndex,
      rest = _objectWithoutProperties$2(_ref1373, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1373 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1373.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1373, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z'
  }), React.createElement('path', {
    d: 'M16 2A13.94 13.94 0 0 0 6 6.23V2H4v8h8V8H7.08A12 12 0 1 1 4 16H2A14 14 0 1 0 16 2z'
  }));
});
RecentlyViewed20.displayName = 'RecentlyViewed20';
RecentlyViewed20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecentlyViewed20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Recommend32 = React.forwardRef(function (_ref1374, ref) {
  var className = _ref1374.className,
      children = _ref1374.children,
      style = _ref1374.style,
      tabIndex = _ref1374.tabIndex,
      rest = _objectWithoutProperties$2(_ref1374, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1374 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1374.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1374, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a9 9 0 0 0-6 15.69V30l6-4 6 4V17.69A9 9 0 0 0 16 2zm4 24.26l-2.89-1.92L16 23.6l-1.11.74L12 26.26v-7.21a8.88 8.88 0 0 0 8 0zM20.89 16A7 7 0 1 1 23 11a7 7 0 0 1-2.11 5z'
  }));
});
Recommend32.displayName = 'Recommend32';
Recommend32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Recommend32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Recommend24 = React.forwardRef(function (_ref1375, ref) {
  var className = _ref1375.className,
      children = _ref1375.children,
      style = _ref1375.style,
      tabIndex = _ref1375.tabIndex,
      rest = _objectWithoutProperties$2(_ref1375, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1375 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1375.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1375, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a9 9 0 0 0-6 15.69V30l6-4 6 4V17.69A9 9 0 0 0 16 2zm4 24.26l-2.89-1.92L16 23.6l-1.11.74L12 26.26v-7.21a8.88 8.88 0 0 0 8 0zM20.89 16A7 7 0 1 1 23 11a7 7 0 0 1-2.11 5z'
  }));
});
Recommend24.displayName = 'Recommend24';
Recommend24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Recommend24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Recommend20 = React.forwardRef(function (_ref1376, ref) {
  var className = _ref1376.className,
      children = _ref1376.children,
      style = _ref1376.style,
      tabIndex = _ref1376.tabIndex,
      rest = _objectWithoutProperties$2(_ref1376, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1376 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1376.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1376, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a9 9 0 0 0-6 15.69V30l6-4 6 4V17.69A9 9 0 0 0 16 2zm4 24.26l-2.89-1.92L16 23.6l-1.11.74L12 26.26v-7.21a8.88 8.88 0 0 0 8 0zM20.89 16A7 7 0 1 1 23 11a7 7 0 0 1-2.11 5z'
  }));
});
Recommend20.displayName = 'Recommend20';
Recommend20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Recommend20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecordingFilledAlt32 = React.forwardRef(function (_ref1377, ref) {
  var className = _ref1377.className,
      children = _ref1377.children,
      style = _ref1377.style,
      tabIndex = _ref1377.tabIndex,
      rest = _objectWithoutProperties$2(_ref1377, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1377 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1377.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1377, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RecordingFilledAlt32.displayName = 'RecordingFilledAlt32';
RecordingFilledAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecordingFilledAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecordingFilledAlt24 = React.forwardRef(function (_ref1378, ref) {
  var className = _ref1378.className,
      children = _ref1378.children,
      style = _ref1378.style,
      tabIndex = _ref1378.tabIndex,
      rest = _objectWithoutProperties$2(_ref1378, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1378 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1378.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1378, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RecordingFilledAlt24.displayName = 'RecordingFilledAlt24';
RecordingFilledAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecordingFilledAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecordingFilledAlt20 = React.forwardRef(function (_ref1379, ref) {
  var className = _ref1379.className,
      children = _ref1379.children,
      style = _ref1379.style,
      tabIndex = _ref1379.tabIndex,
      rest = _objectWithoutProperties$2(_ref1379, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1379 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1379.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1379, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RecordingFilledAlt20.displayName = 'RecordingFilledAlt20';
RecordingFilledAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecordingFilledAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecordingFilled32 = React.forwardRef(function (_ref1380, ref) {
  var className = _ref1380.className,
      children = _ref1380.children,
      style = _ref1380.style,
      tabIndex = _ref1380.tabIndex,
      rest = _objectWithoutProperties$2(_ref1380, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1380 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1380.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1380, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RecordingFilled32.displayName = 'RecordingFilled32';
RecordingFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecordingFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecordingFilled24 = React.forwardRef(function (_ref1381, ref) {
  var className = _ref1381.className,
      children = _ref1381.children,
      style = _ref1381.style,
      tabIndex = _ref1381.tabIndex,
      rest = _objectWithoutProperties$2(_ref1381, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1381 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1381.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1381, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RecordingFilled24.displayName = 'RecordingFilled24';
RecordingFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecordingFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RecordingFilled20 = React.forwardRef(function (_ref1382, ref) {
  var className = _ref1382.className,
      children = _ref1382.children,
      style = _ref1382.style,
      tabIndex = _ref1382.tabIndex,
      rest = _objectWithoutProperties$2(_ref1382, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1382 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1382.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1382, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
RecordingFilled20.displayName = 'RecordingFilled20';
RecordingFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RecordingFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Recording32 = React.forwardRef(function (_ref1383, ref) {
  var className = _ref1383.className,
      children = _ref1383.children,
      style = _ref1383.style,
      tabIndex = _ref1383.tabIndex,
      rest = _objectWithoutProperties$2(_ref1383, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1383 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1383.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1383, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
Recording32.displayName = 'Recording32';
Recording32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Recording32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Recording24 = React.forwardRef(function (_ref1384, ref) {
  var className = _ref1384.className,
      children = _ref1384.children,
      style = _ref1384.style,
      tabIndex = _ref1384.tabIndex,
      rest = _objectWithoutProperties$2(_ref1384, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1384 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1384.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1384, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
Recording24.displayName = 'Recording24';
Recording24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Recording24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Recording20 = React.forwardRef(function (_ref1385, ref) {
  var className = _ref1385.className,
      children = _ref1385.children,
      style = _ref1385.style,
      tabIndex = _ref1385.tabIndex,
      rest = _objectWithoutProperties$2(_ref1385, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1385 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1385.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1385, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M16 12a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6z'
  }));
});
Recording20.displayName = 'Recording20';
Recording20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Recording20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Renew32 = React.forwardRef(function (_ref1386, ref) {
  var className = _ref1386.className,
      children = _ref1386.children,
      style = _ref1386.style,
      tabIndex = _ref1386.tabIndex,
      rest = _objectWithoutProperties$2(_ref1386, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1386 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1386.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1386, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 10H6.78A11 11 0 0 1 27 16h2A13 13 0 0 0 6 7.68V4H4v8h8zm8 12h5.22A11 11 0 0 1 5 16H3a13 13 0 0 0 23 8.32V28h2v-8h-8z'
  }));
});
Renew32.displayName = 'Renew32';
Renew32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Renew32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Renew24 = React.forwardRef(function (_ref1387, ref) {
  var className = _ref1387.className,
      children = _ref1387.children,
      style = _ref1387.style,
      tabIndex = _ref1387.tabIndex,
      rest = _objectWithoutProperties$2(_ref1387, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1387 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1387.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1387, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 10H6.78A11 11 0 0 1 27 16h2A13 13 0 0 0 6 7.68V4H4v8h8zm8 12h5.22A11 11 0 0 1 5 16H3a13 13 0 0 0 23 8.32V28h2v-8h-8z'
  }));
});
Renew24.displayName = 'Renew24';
Renew24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Renew24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Renew20 = React.forwardRef(function (_ref1388, ref) {
  var className = _ref1388.className,
      children = _ref1388.children,
      style = _ref1388.style,
      tabIndex = _ref1388.tabIndex,
      rest = _objectWithoutProperties$2(_ref1388, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1388 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1388.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1388, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 10H6.78A11 11 0 0 1 27 16h2A13 13 0 0 0 6 7.68V4H4v8h8zm8 12h5.22A11 11 0 0 1 5 16H3a13 13 0 0 0 23 8.32V28h2v-8h-8z'
  }));
});
Renew20.displayName = 'Renew20';
Renew20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Renew20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RepeatOne32 = React.forwardRef(function (_ref1389, ref) {
  var className = _ref1389.className,
      children = _ref1389.children,
      style = _ref1389.style,
      tabIndex = _ref1389.tabIndex,
      rest = _objectWithoutProperties$2(_ref1389, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1389 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1389.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1389, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H5.83l3.58-3.59L8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8a2 2 0 0 0-2-2zm-3.41 14.41L26.17 24H6v-7H4v7a2 2 0 0 0 2 2h20.17l-3.58 3.59L24 31l6-6-6-6z'
  }), React.createElement('path', {
    d: 'M17 19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2z'
  }));
});
RepeatOne32.displayName = 'RepeatOne32';
RepeatOne32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RepeatOne32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RepeatOne24 = React.forwardRef(function (_ref1390, ref) {
  var className = _ref1390.className,
      children = _ref1390.children,
      style = _ref1390.style,
      tabIndex = _ref1390.tabIndex,
      rest = _objectWithoutProperties$2(_ref1390, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1390 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1390.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1390, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H5.83l3.58-3.59L8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8a2 2 0 0 0-2-2zm-3.41 14.41L26.17 24H6v-7H4v7a2 2 0 0 0 2 2h20.17l-3.58 3.59L24 31l6-6-6-6z'
  }), React.createElement('path', {
    d: 'M17 19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2z'
  }));
});
RepeatOne24.displayName = 'RepeatOne24';
RepeatOne24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RepeatOne24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RepeatOne20 = React.forwardRef(function (_ref1391, ref) {
  var className = _ref1391.className,
      children = _ref1391.children,
      style = _ref1391.style,
      tabIndex = _ref1391.tabIndex,
      rest = _objectWithoutProperties$2(_ref1391, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1391 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1391.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1391, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H5.83l3.58-3.59L8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8a2 2 0 0 0-2-2zm-3.41 14.41L26.17 24H6v-7H4v7a2 2 0 0 0 2 2h20.17l-3.58 3.59L24 31l6-6-6-6z'
  }), React.createElement('path', {
    d: 'M17 19v-8h-2v1h-2v2h2v5h-2v2h6v-2h-2z'
  }));
});
RepeatOne20.displayName = 'RepeatOne20';
RepeatOne20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RepeatOne20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Repeat32 = React.forwardRef(function (_ref1392, ref) {
  var className = _ref1392.className,
      children = _ref1392.children,
      style = _ref1392.style,
      tabIndex = _ref1392.tabIndex,
      rest = _objectWithoutProperties$2(_ref1392, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1392 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1392.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1392, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H5.83l3.58-3.59L8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8a2 2 0 0 0-2-2zm-3.41 14.41L26.17 24H6v-7H4v7a2 2 0 0 0 2 2h20.17l-3.58 3.59L24 31l6-6-6-6z'
  }));
});
Repeat32.displayName = 'Repeat32';
Repeat32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Repeat32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Repeat24 = React.forwardRef(function (_ref1393, ref) {
  var className = _ref1393.className,
      children = _ref1393.children,
      style = _ref1393.style,
      tabIndex = _ref1393.tabIndex,
      rest = _objectWithoutProperties$2(_ref1393, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1393 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1393.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1393, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H5.83l3.58-3.59L8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8a2 2 0 0 0-2-2zm-3.41 14.41L26.17 24H6v-7H4v7a2 2 0 0 0 2 2h20.17l-3.58 3.59L24 31l6-6-6-6z'
  }));
});
Repeat24.displayName = 'Repeat24';
Repeat24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Repeat24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Repeat20 = React.forwardRef(function (_ref1394, ref) {
  var className = _ref1394.className,
      children = _ref1394.children,
      style = _ref1394.style,
      tabIndex = _ref1394.tabIndex,
      rest = _objectWithoutProperties$2(_ref1394, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1394 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1394.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1394, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H5.83l3.58-3.59L8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8a2 2 0 0 0-2-2zm-3.41 14.41L26.17 24H6v-7H4v7a2 2 0 0 0 2 2h20.17l-3.58 3.59L24 31l6-6-6-6z'
  }));
});
Repeat20.displayName = 'Repeat20';
Repeat20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Repeat20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Reply32 = React.forwardRef(function (_ref1395, ref) {
  var className = _ref1395.className,
      children = _ref1395.children,
      style = _ref1395.style,
      tabIndex = _ref1395.tabIndex,
      rest = _objectWithoutProperties$2(_ref1395, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1395 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1395.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1395, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.88 30a1 1 0 0 1-.88-.5A15.19 15.19 0 0 0 15 22v6a1 1 0 0 1-.62.92 1 1 0 0 1-1.09-.21l-12-12a1 1 0 0 1 0-1.42l12-12a1 1 0 0 1 1.09-.21A1 1 0 0 1 15 4v6.11a17.19 17.19 0 0 1 15 17 16.34 16.34 0 0 1-.13 2 1 1 0 0 1-.79.86zM14.5 20A17.62 17.62 0 0 1 28 26a15.31 15.31 0 0 0-14.09-14 1 1 0 0 1-.91-1V6.41L3.41 16 13 25.59V21a1 1 0 0 1 1-1h.54z'
  }));
});
Reply32.displayName = 'Reply32';
Reply32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Reply32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Reply24 = React.forwardRef(function (_ref1396, ref) {
  var className = _ref1396.className,
      children = _ref1396.children,
      style = _ref1396.style,
      tabIndex = _ref1396.tabIndex,
      rest = _objectWithoutProperties$2(_ref1396, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1396 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1396.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1396, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.88 30a1 1 0 0 1-.88-.5A15.19 15.19 0 0 0 15 22v6a1 1 0 0 1-.62.92 1 1 0 0 1-1.09-.21l-12-12a1 1 0 0 1 0-1.42l12-12a1 1 0 0 1 1.09-.21A1 1 0 0 1 15 4v6.11a17.19 17.19 0 0 1 15 17 16.34 16.34 0 0 1-.13 2 1 1 0 0 1-.79.86zM14.5 20A17.62 17.62 0 0 1 28 26a15.31 15.31 0 0 0-14.09-14 1 1 0 0 1-.91-1V6.41L3.41 16 13 25.59V21a1 1 0 0 1 1-1h.54z'
  }));
});
Reply24.displayName = 'Reply24';
Reply24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Reply24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Reply20 = React.forwardRef(function (_ref1397, ref) {
  var className = _ref1397.className,
      children = _ref1397.children,
      style = _ref1397.style,
      tabIndex = _ref1397.tabIndex,
      rest = _objectWithoutProperties$2(_ref1397, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1397 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1397.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1397, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.88 30a1 1 0 0 1-.88-.5A15.19 15.19 0 0 0 15 22v6a1 1 0 0 1-.62.92 1 1 0 0 1-1.09-.21l-12-12a1 1 0 0 1 0-1.42l12-12a1 1 0 0 1 1.09-.21A1 1 0 0 1 15 4v6.11a17.19 17.19 0 0 1 15 17 16.34 16.34 0 0 1-.13 2 1 1 0 0 1-.79.86zM14.5 20A17.62 17.62 0 0 1 28 26a15.31 15.31 0 0 0-14.09-14 1 1 0 0 1-.91-1V6.41L3.41 16 13 25.59V21a1 1 0 0 1 1-1h.54z'
  }));
});
Reply20.displayName = 'Reply20';
Reply20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Reply20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ReportData32 = React.forwardRef(function (_ref1398, ref) {
  var className = _ref1398.className,
      children = _ref1398.children,
      style = _ref1398.style,
      tabIndex = _ref1398.tabIndex,
      rest = _objectWithoutProperties$2(_ref1398, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1398 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1398.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1398, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 20h2v4h-2zm5-2h2v6h-2zm-10-4h2v10h-2z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
ReportData32.displayName = 'ReportData32';
ReportData32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ReportData32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ReportData24 = React.forwardRef(function (_ref1399, ref) {
  var className = _ref1399.className,
      children = _ref1399.children,
      style = _ref1399.style,
      tabIndex = _ref1399.tabIndex,
      rest = _objectWithoutProperties$2(_ref1399, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1399 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1399.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1399, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 20h2v4h-2zm5-2h2v6h-2zm-10-4h2v10h-2z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
ReportData24.displayName = 'ReportData24';
ReportData24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ReportData24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ReportData20 = React.forwardRef(function (_ref1400, ref) {
  var className = _ref1400.className,
      children = _ref1400.children,
      style = _ref1400.style,
      tabIndex = _ref1400.tabIndex,
      rest = _objectWithoutProperties$2(_ref1400, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1400 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1400.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1400, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 20h2v4h-2zm5-2h2v6h-2zm-10-4h2v10h-2z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
ReportData20.displayName = 'ReportData20';
ReportData20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ReportData20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Report32 = React.forwardRef(function (_ref1401, ref) {
  var className = _ref1401.className,
      children = _ref1401.children,
      style = _ref1401.style,
      tabIndex = _ref1401.tabIndex,
      rest = _objectWithoutProperties$2(_ref1401, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1401 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1401.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1401, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 18h8v2h-8zm0-5h12v2H10zm0 10h5v2h-5z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
Report32.displayName = 'Report32';
Report32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Report32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Report24 = React.forwardRef(function (_ref1402, ref) {
  var className = _ref1402.className,
      children = _ref1402.children,
      style = _ref1402.style,
      tabIndex = _ref1402.tabIndex,
      rest = _objectWithoutProperties$2(_ref1402, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1402 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1402.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1402, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 18h8v2h-8zm0-5h12v2H10zm0 10h5v2h-5z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
Report24.displayName = 'Report24';
Report24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Report24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Report20 = React.forwardRef(function (_ref1403, ref) {
  var className = _ref1403.className,
      children = _ref1403.children,
      style = _ref1403.style,
      tabIndex = _ref1403.tabIndex,
      rest = _objectWithoutProperties$2(_ref1403, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1403 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1403.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1403, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M10 18h8v2h-8zm0-5h12v2H10zm0 10h5v2h-5z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
Report20.displayName = 'Report20';
Report20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Report20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RequestQuote32 = React.forwardRef(function (_ref1404, ref) {
  var className = _ref1404.className,
      children = _ref1404.children,
      style = _ref1404.style,
      tabIndex = _ref1404.tabIndex,
      rest = _objectWithoutProperties$2(_ref1404, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1404 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1404.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1404, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 22v6H6V4h10V2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6z'
  }), React.createElement('path', {
    d: 'M29.54 5.76l-3.3-3.3a1.6 1.6 0 0 0-2.24 0l-14 14V22h5.53l14-14a1.6 1.6 0 0 0 0-2.24zM14.7 20H12v-2.7l9.44-9.45 2.71 2.71zM25.56 9.15l-2.71-2.71 2.27-2.27 2.71 2.71z'
  }));
});
RequestQuote32.displayName = 'RequestQuote32';
RequestQuote32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RequestQuote32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RequestQuote24 = React.forwardRef(function (_ref1405, ref) {
  var className = _ref1405.className,
      children = _ref1405.children,
      style = _ref1405.style,
      tabIndex = _ref1405.tabIndex,
      rest = _objectWithoutProperties$2(_ref1405, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1405 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1405.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1405, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 22v6H6V4h10V2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6z'
  }), React.createElement('path', {
    d: 'M29.54 5.76l-3.3-3.3a1.6 1.6 0 0 0-2.24 0l-14 14V22h5.53l14-14a1.6 1.6 0 0 0 0-2.24zM14.7 20H12v-2.7l9.44-9.45 2.71 2.71zM25.56 9.15l-2.71-2.71 2.27-2.27 2.71 2.71z'
  }));
});
RequestQuote24.displayName = 'RequestQuote24';
RequestQuote24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RequestQuote24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RequestQuote20 = React.forwardRef(function (_ref1406, ref) {
  var className = _ref1406.className,
      children = _ref1406.children,
      style = _ref1406.style,
      tabIndex = _ref1406.tabIndex,
      rest = _objectWithoutProperties$2(_ref1406, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1406 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1406.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1406, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 22v6H6V4h10V2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6z'
  }), React.createElement('path', {
    d: 'M29.54 5.76l-3.3-3.3a1.6 1.6 0 0 0-2.24 0l-14 14V22h5.53l14-14a1.6 1.6 0 0 0 0-2.24zM14.7 20H12v-2.7l9.44-9.45 2.71 2.71zM25.56 9.15l-2.71-2.71 2.27-2.27 2.71 2.71z'
  }));
});
RequestQuote20.displayName = 'RequestQuote20';
RequestQuote20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RequestQuote20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchBlochSphere32 = React.forwardRef(function (_ref1407, ref) {
  var className = _ref1407.className,
      children = _ref1407.children,
      style = _ref1407.style,
      tabIndex = _ref1407.tabIndex,
      rest = _objectWithoutProperties$2(_ref1407, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1407 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1407.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1407, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.87 7.84l-1.74-1L16 14a2 2 0 1 0 2 2 2 2 0 0 0-.27-1z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 11.17 7.65 25.69 25.69 0 0 0-3.69-1.5l-1 1.77a22.7 22.7 0 0 1 5.41 2.39 11.05 11.05 0 0 1 0 3.38A22.92 22.92 0 0 1 16 21a22.92 22.92 0 0 1-11.87-3.31 11.05 11.05 0 0 1 0-3.38A22.8 22.8 0 0 1 15 11V9a25 25 0 0 0-10.17 2.6A12 12 0 0 1 16 4zm0 24a12 12 0 0 1-11.17-7.65A24.88 24.88 0 0 0 16 23a24.88 24.88 0 0 0 11.17-2.65A12 12 0 0 1 16 28z'
  }));
});
ResearchBlochSphere32.displayName = 'ResearchBlochSphere32';
ResearchBlochSphere32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchBlochSphere32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchBlochSphere24 = React.forwardRef(function (_ref1408, ref) {
  var className = _ref1408.className,
      children = _ref1408.children,
      style = _ref1408.style,
      tabIndex = _ref1408.tabIndex,
      rest = _objectWithoutProperties$2(_ref1408, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1408 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1408.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1408, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.87 7.84l-1.74-1L16 14a2 2 0 1 0 2 2 2 2 0 0 0-.27-1z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 11.17 7.65 25.69 25.69 0 0 0-3.69-1.5l-1 1.77a22.7 22.7 0 0 1 5.41 2.39 11.05 11.05 0 0 1 0 3.38A22.92 22.92 0 0 1 16 21a22.92 22.92 0 0 1-11.87-3.31 11.05 11.05 0 0 1 0-3.38A22.8 22.8 0 0 1 15 11V9a25 25 0 0 0-10.17 2.6A12 12 0 0 1 16 4zm0 24a12 12 0 0 1-11.17-7.65A24.88 24.88 0 0 0 16 23a24.88 24.88 0 0 0 11.17-2.65A12 12 0 0 1 16 28z'
  }));
});
ResearchBlochSphere24.displayName = 'ResearchBlochSphere24';
ResearchBlochSphere24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchBlochSphere24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchBlochSphere20 = React.forwardRef(function (_ref1409, ref) {
  var className = _ref1409.className,
      children = _ref1409.children,
      style = _ref1409.style,
      tabIndex = _ref1409.tabIndex,
      rest = _objectWithoutProperties$2(_ref1409, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1409 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1409.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1409, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.87 7.84l-1.74-1L16 14a2 2 0 1 0 2 2 2 2 0 0 0-.27-1z'
  }), React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 2a12 12 0 0 1 11.17 7.65 25.69 25.69 0 0 0-3.69-1.5l-1 1.77a22.7 22.7 0 0 1 5.41 2.39 11.05 11.05 0 0 1 0 3.38A22.92 22.92 0 0 1 16 21a22.92 22.92 0 0 1-11.87-3.31 11.05 11.05 0 0 1 0-3.38A22.8 22.8 0 0 1 15 11V9a25 25 0 0 0-10.17 2.6A12 12 0 0 1 16 4zm0 24a12 12 0 0 1-11.17-7.65A24.88 24.88 0 0 0 16 23a24.88 24.88 0 0 0 11.17-2.65A12 12 0 0 1 16 28z'
  }));
});
ResearchBlochSphere20.displayName = 'ResearchBlochSphere20';
ResearchBlochSphere20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchBlochSphere20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchHintonPlot32 = React.forwardRef(function (_ref1410, ref) {
  var className = _ref1410.className,
      children = _ref1410.children,
      style = _ref1410.style,
      tabIndex = _ref1410.tabIndex,
      rest = _objectWithoutProperties$2(_ref1410, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1410 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1410.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1410, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 2h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 10h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 18h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 26h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4z'
  }));
});
ResearchHintonPlot32.displayName = 'ResearchHintonPlot32';
ResearchHintonPlot32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchHintonPlot32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchHintonPlot24 = React.forwardRef(function (_ref1411, ref) {
  var className = _ref1411.className,
      children = _ref1411.children,
      style = _ref1411.style,
      tabIndex = _ref1411.tabIndex,
      rest = _objectWithoutProperties$2(_ref1411, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1411 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1411.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1411, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 2h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 10h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 18h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 26h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4z'
  }));
});
ResearchHintonPlot24.displayName = 'ResearchHintonPlot24';
ResearchHintonPlot24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchHintonPlot24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchHintonPlot20 = React.forwardRef(function (_ref1412, ref) {
  var className = _ref1412.className,
      children = _ref1412.children,
      style = _ref1412.style,
      tabIndex = _ref1412.tabIndex,
      rest = _objectWithoutProperties$2(_ref1412, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1412 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1412.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1412, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 2h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 10h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 18h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4zM2 26h4v4H2zm8 0h4v4h-4zm8 0h4v4h-4zm8 0h4v4h-4z'
  }));
});
ResearchHintonPlot20.displayName = 'ResearchHintonPlot20';
ResearchHintonPlot20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchHintonPlot20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchMatrix32 = React.forwardRef(function (_ref1413, ref) {
  var className = _ref1413.className,
      children = _ref1413.children,
      style = _ref1413.style,
      tabIndex = _ref1413.tabIndex,
      rest = _objectWithoutProperties$2(_ref1413, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1413 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1413.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1413, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zm-1.5 7a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zM8 30H2V2h6v2H4v24h4v2zm22 0h-6v-2h4V4h-4V2h6v28z'
  }));
});
ResearchMatrix32.displayName = 'ResearchMatrix32';
ResearchMatrix32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchMatrix32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchMatrix24 = React.forwardRef(function (_ref1414, ref) {
  var className = _ref1414.className,
      children = _ref1414.children,
      style = _ref1414.style,
      tabIndex = _ref1414.tabIndex,
      rest = _objectWithoutProperties$2(_ref1414, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1414 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1414.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1414, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zm-1.5 7a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zM8 30H2V2h6v2H4v24h4v2zm22 0h-6v-2h4V4h-4V2h6v28z'
  }));
});
ResearchMatrix24.displayName = 'ResearchMatrix24';
ResearchMatrix24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchMatrix24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResearchMatrix20 = React.forwardRef(function (_ref1415, ref) {
  var className = _ref1415.className,
      children = _ref1415.children,
      style = _ref1415.style,
      tabIndex = _ref1415.tabIndex,
      rest = _objectWithoutProperties$2(_ref1415, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1415 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1415.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1415, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zm-1.5 7a3.5 3.5 0 1 1-3.5 3.5 3.5 3.5 0 0 1 3.5-3.5m0-2a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zM8 30H2V2h6v2H4v24h4v2zm22 0h-6v-2h4V4h-4V2h6v28z'
  }));
});
ResearchMatrix20.displayName = 'ResearchMatrix20';
ResearchMatrix20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResearchMatrix20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResetAlt32 = React.forwardRef(function (_ref1416, ref) {
  var className = _ref1416.className,
      children = _ref1416.children,
      style = _ref1416.style,
      tabIndex = _ref1416.tabIndex,
      rest = _objectWithoutProperties$2(_ref1416, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1416 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1416.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1416, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 8H6.83l3.58-3.59L9 3 3 9l6 6 1.41-1.41L6.83 10H27v16H7v-7H5v7a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z'
  }));
});
ResetAlt32.displayName = 'ResetAlt32';
ResetAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResetAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResetAlt24 = React.forwardRef(function (_ref1417, ref) {
  var className = _ref1417.className,
      children = _ref1417.children,
      style = _ref1417.style,
      tabIndex = _ref1417.tabIndex,
      rest = _objectWithoutProperties$2(_ref1417, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1417 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1417.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1417, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 8H6.83l3.58-3.59L9 3 3 9l6 6 1.41-1.41L6.83 10H27v16H7v-7H5v7a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z'
  }));
});
ResetAlt24.displayName = 'ResetAlt24';
ResetAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResetAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ResetAlt20 = React.forwardRef(function (_ref1418, ref) {
  var className = _ref1418.className,
      children = _ref1418.children,
      style = _ref1418.style,
      tabIndex = _ref1418.tabIndex,
      rest = _objectWithoutProperties$2(_ref1418, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1418 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1418.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1418, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 8H6.83l3.58-3.59L9 3 3 9l6 6 1.41-1.41L6.83 10H27v16H7v-7H5v7a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z'
  }));
});
ResetAlt20.displayName = 'ResetAlt20';
ResetAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ResetAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Reset32 = React.forwardRef(function (_ref1419, ref) {
  var className = _ref1419.className,
      children = _ref1419.children,
      style = _ref1419.style,
      tabIndex = _ref1419.tabIndex,
      rest = _objectWithoutProperties$2(_ref1419, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1419 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1419.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1419, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28A12 12 0 1 0 6 16v6.2l-3.6-3.6L1 20l6 6 6-6-1.4-1.4L8 22.2V16a10 10 0 1 1 10 10z'
  }));
});
Reset32.displayName = 'Reset32';
Reset32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Reset32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Reset24 = React.forwardRef(function (_ref1420, ref) {
  var className = _ref1420.className,
      children = _ref1420.children,
      style = _ref1420.style,
      tabIndex = _ref1420.tabIndex,
      rest = _objectWithoutProperties$2(_ref1420, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1420 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1420.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1420, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28A12 12 0 1 0 6 16v6.2l-3.6-3.6L1 20l6 6 6-6-1.4-1.4L8 22.2V16a10 10 0 1 1 10 10z'
  }));
});
Reset24.displayName = 'Reset24';
Reset24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Reset24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Reset20 = React.forwardRef(function (_ref1421, ref) {
  var className = _ref1421.className,
      children = _ref1421.children,
      style = _ref1421.style,
      tabIndex = _ref1421.tabIndex,
      rest = _objectWithoutProperties$2(_ref1421, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1421 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1421.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1421, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28A12 12 0 1 0 6 16v6.2l-3.6-3.6L1 20l6 6 6-6-1.4-1.4L8 22.2V16a10 10 0 1 1 10 10z'
  }));
});
Reset20.displayName = 'Reset20';
Reset20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Reset20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Restart32 = React.forwardRef(function (_ref1422, ref) {
  var className = _ref1422.className,
      children = _ref1422.children,
      style = _ref1422.style,
      tabIndex = _ref1422.tabIndex,
      rest = _objectWithoutProperties$2(_ref1422, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1422 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1422.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1422, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 18A10 10 0 1 1 15 8h6.18l-3.58 3.59L19 13l6-6-6-6-1.4 1.41L21.19 6H15a12 12 0 1 0 12 12z'
  }));
});
Restart32.displayName = 'Restart32';
Restart32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Restart32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Restart24 = React.forwardRef(function (_ref1423, ref) {
  var className = _ref1423.className,
      children = _ref1423.children,
      style = _ref1423.style,
      tabIndex = _ref1423.tabIndex,
      rest = _objectWithoutProperties$2(_ref1423, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1423 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1423.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1423, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 18A10 10 0 1 1 15 8h6.18l-3.58 3.59L19 13l6-6-6-6-1.4 1.41L21.19 6H15a12 12 0 1 0 12 12z'
  }));
});
Restart24.displayName = 'Restart24';
Restart24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Restart24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Restart20 = React.forwardRef(function (_ref1424, ref) {
  var className = _ref1424.className,
      children = _ref1424.children,
      style = _ref1424.style,
      tabIndex = _ref1424.tabIndex,
      rest = _objectWithoutProperties$2(_ref1424, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1424 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1424.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1424, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 18A10 10 0 1 1 15 8h6.18l-3.58 3.59L19 13l6-6-6-6-1.4 1.41L21.19 6H15a12 12 0 1 0 12 12z'
  }));
});
Restart20.displayName = 'Restart20';
Restart20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Restart20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Restaurant32 = React.forwardRef(function (_ref1425, ref) {
  var className = _ref1425.className,
      children = _ref1425.children,
      style = _ref1425.style,
      tabIndex = _ref1425.tabIndex,
      rest = _objectWithoutProperties$2(_ref1425, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1425 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1425.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1425, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 2h2v10H9z'
  }), React.createElement('path', {
    d: 'M14 11a4 4 0 0 1-8 0V2H4v9a6 6 0 0 0 5 5.91V30h2V16.91A6 6 0 0 0 16 11V2h-2zm8-9h-1v28h2V20h3a2 2 0 0 0 2-2V8a5.78 5.78 0 0 0-6-6zm4 16h-3V4.09c2.88.56 3 3.54 3 3.91z'
  }));
});
Restaurant32.displayName = 'Restaurant32';
Restaurant32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Restaurant32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Restaurant24 = React.forwardRef(function (_ref1426, ref) {
  var className = _ref1426.className,
      children = _ref1426.children,
      style = _ref1426.style,
      tabIndex = _ref1426.tabIndex,
      rest = _objectWithoutProperties$2(_ref1426, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1426 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1426.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1426, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 2h2v10H9z'
  }), React.createElement('path', {
    d: 'M14 11a4 4 0 0 1-8 0V2H4v9a6 6 0 0 0 5 5.91V30h2V16.91A6 6 0 0 0 16 11V2h-2zm8-9h-1v28h2V20h3a2 2 0 0 0 2-2V8a5.78 5.78 0 0 0-6-6zm4 16h-3V4.09c2.88.56 3 3.54 3 3.91z'
  }));
});
Restaurant24.displayName = 'Restaurant24';
Restaurant24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Restaurant24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Restaurant20 = React.forwardRef(function (_ref1427, ref) {
  var className = _ref1427.className,
      children = _ref1427.children,
      style = _ref1427.style,
      tabIndex = _ref1427.tabIndex,
      rest = _objectWithoutProperties$2(_ref1427, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1427 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1427.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1427, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 2h2v10H9z'
  }), React.createElement('path', {
    d: 'M14 11a4 4 0 0 1-8 0V2H4v9a6 6 0 0 0 5 5.91V30h2V16.91A6 6 0 0 0 16 11V2h-2zm8-9h-1v28h2V20h3a2 2 0 0 0 2-2V8a5.78 5.78 0 0 0-6-6zm4 16h-3V4.09c2.88.56 3 3.54 3 3.91z'
  }));
});
Restaurant20.displayName = 'Restaurant20';
Restaurant20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Restaurant20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_1032 = React.forwardRef(function (_ref1428, ref) {
  var className = _ref1428.className,
      children = _ref1428.children,
      style = _ref1428.style,
      tabIndex = _ref1428.tabIndex,
      rest = _objectWithoutProperties$2(_ref1428, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1428 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1428.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1428, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M19.63 22.13a2.84 2.84 0 0 1-1.28-.27 2.44 2.44 0 0 1-.89-.77 3.57 3.57 0 0 1-.52-1.25 7.69 7.69 0 0 1-.17-1.68 7.83 7.83 0 0 1 .17-1.68 3.65 3.65 0 0 1 .52-1.25 2.44 2.44 0 0 1 .89-.77 2.84 2.84 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.23 5.23 0 0 1 .7 2.93 5.23 5.23 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.16 1.08zm0-1.22a1.07 1.07 0 0 0 1-.55 3.38 3.38 0 0 0 .37-1.51v-1.38a3.31 3.31 0 0 0-.29-1.5 1.23 1.23 0 0 0-2.06 0 3.31 3.31 0 0 0-.29 1.5v1.38a3.38 3.38 0 0 0 .29 1.51 1.06 1.06 0 0 0 .98.55zm-9 1.09v-1.18h2v-5.19l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z'
  }));
});
Rewind_1032.displayName = 'Rewind_1032';
Rewind_1032.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_1032.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_1024 = React.forwardRef(function (_ref1429, ref) {
  var className = _ref1429.className,
      children = _ref1429.children,
      style = _ref1429.style,
      tabIndex = _ref1429.tabIndex,
      rest = _objectWithoutProperties$2(_ref1429, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1429 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1429.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1429, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M19.63 22.13a2.84 2.84 0 0 1-1.28-.27 2.44 2.44 0 0 1-.89-.77 3.57 3.57 0 0 1-.52-1.25 7.69 7.69 0 0 1-.17-1.68 7.83 7.83 0 0 1 .17-1.68 3.65 3.65 0 0 1 .52-1.25 2.44 2.44 0 0 1 .89-.77 2.84 2.84 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.23 5.23 0 0 1 .7 2.93 5.23 5.23 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.16 1.08zm0-1.22a1.07 1.07 0 0 0 1-.55 3.38 3.38 0 0 0 .37-1.51v-1.38a3.31 3.31 0 0 0-.29-1.5 1.23 1.23 0 0 0-2.06 0 3.31 3.31 0 0 0-.29 1.5v1.38a3.38 3.38 0 0 0 .29 1.51 1.06 1.06 0 0 0 .98.55zm-9 1.09v-1.18h2v-5.19l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z'
  }));
});
Rewind_1024.displayName = 'Rewind_1024';
Rewind_1024.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_1024.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_1020 = React.forwardRef(function (_ref1430, ref) {
  var className = _ref1430.className,
      children = _ref1430.children,
      style = _ref1430.style,
      tabIndex = _ref1430.tabIndex,
      rest = _objectWithoutProperties$2(_ref1430, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1430 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1430.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1430, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M19.63 22.13a2.84 2.84 0 0 1-1.28-.27 2.44 2.44 0 0 1-.89-.77 3.57 3.57 0 0 1-.52-1.25 7.69 7.69 0 0 1-.17-1.68 7.83 7.83 0 0 1 .17-1.68 3.65 3.65 0 0 1 .52-1.25 2.44 2.44 0 0 1 .89-.77 2.84 2.84 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.23 5.23 0 0 1 .7 2.93 5.23 5.23 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.16 1.08zm0-1.22a1.07 1.07 0 0 0 1-.55 3.38 3.38 0 0 0 .37-1.51v-1.38a3.31 3.31 0 0 0-.29-1.5 1.23 1.23 0 0 0-2.06 0 3.31 3.31 0 0 0-.29 1.5v1.38a3.38 3.38 0 0 0 .29 1.51 1.06 1.06 0 0 0 .98.55zm-9 1.09v-1.18h2v-5.19l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z'
  }));
});
Rewind_1020.displayName = 'Rewind_1020';
Rewind_1020.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_1020.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_3032 = React.forwardRef(function (_ref1431, ref) {
  var className = _ref1431.className,
      children = _ref1431.children,
      style = _ref1431.style,
      tabIndex = _ref1431.tabIndex,
      rest = _objectWithoutProperties$2(_ref1431, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1431 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1431.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1431, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M19.64 22.13a2.81 2.81 0 0 1-1.28-.27 2.36 2.36 0 0 1-.89-.77 3.39 3.39 0 0 1-.47-1.25 7.12 7.12 0 0 1-.17-1.68 7.24 7.24 0 0 1 .17-1.68 3.46 3.46 0 0 1 .52-1.25 2.36 2.36 0 0 1 .89-.77 2.81 2.81 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.31 5.31 0 0 1 .7 2.93 5.31 5.31 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.21 1.08zm0-1.22a1 1 0 0 0 1-.55 3.24 3.24 0 0 0 .3-1.51v-1.38a3.17 3.17 0 0 0-.3-1.5 1.22 1.22 0 0 0-2.05 0 3.18 3.18 0 0 0-.29 1.5v1.38a3.25 3.25 0 0 0 .29 1.51 1 1 0 0 0 1.05.55zm-7.02-3.49a1.46 1.46 0 0 0 1-.27.84.84 0 0 0 .31-.68v-.08a.94.94 0 0 0-.3-.74 1.2 1.2 0 0 0-.83-.27 1.65 1.65 0 0 0-.89.24 2.1 2.1 0 0 0-.68.68l-.93-.83a5.37 5.37 0 0 1 .44-.51 2.7 2.7 0 0 1 .54-.4 2.55 2.55 0 0 1 .7-.27 3.25 3.25 0 0 1 .87-.1 3.94 3.94 0 0 1 1.06.14 2.33 2.33 0 0 1 .82.4 1.91 1.91 0 0 1 .54.63 1.87 1.87 0 0 1 .18.83 2 2 0 0 1-.11.67 1.82 1.82 0 0 1-.32.52 1.79 1.79 0 0 1-.47.36 2.27 2.27 0 0 1-.57.2V18a2.34 2.34 0 0 1 .63.21 1.7 1.7 0 0 1 .51.38 1.89 1.89 0 0 1 .34.55 2.07 2.07 0 0 1 .12.73 2 2 0 0 1-.2.92 2 2 0 0 1-.58.72 2.66 2.66 0 0 1-.89.45 3.76 3.76 0 0 1-1.15.16 4.1 4.1 0 0 1-1-.11 3.1 3.1 0 0 1-.76-.31 2.76 2.76 0 0 1-.56-.45 4.22 4.22 0 0 1-.44-.55l1.07-.81a3.07 3.07 0 0 0 .28.42 1.94 1.94 0 0 0 .36.34 1.57 1.57 0 0 0 .45.22 2 2 0 0 0 .57.07 1.45 1.45 0 0 0 1-.3 1.12 1.12 0 0 0 .34-.85v-.08a1 1 0 0 0-.37-.8 1.78 1.78 0 0 0-1.06-.28h-.76v-1.21z'
  }));
});
Rewind_3032.displayName = 'Rewind_3032';
Rewind_3032.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_3032.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_3024 = React.forwardRef(function (_ref1432, ref) {
  var className = _ref1432.className,
      children = _ref1432.children,
      style = _ref1432.style,
      tabIndex = _ref1432.tabIndex,
      rest = _objectWithoutProperties$2(_ref1432, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1432 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1432.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1432, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M19.64 22.13a2.81 2.81 0 0 1-1.28-.27 2.36 2.36 0 0 1-.89-.77 3.39 3.39 0 0 1-.47-1.25 7.12 7.12 0 0 1-.17-1.68 7.24 7.24 0 0 1 .17-1.68 3.46 3.46 0 0 1 .52-1.25 2.36 2.36 0 0 1 .89-.77 2.81 2.81 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.31 5.31 0 0 1 .7 2.93 5.31 5.31 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.21 1.08zm0-1.22a1 1 0 0 0 1-.55 3.24 3.24 0 0 0 .3-1.51v-1.38a3.17 3.17 0 0 0-.3-1.5 1.22 1.22 0 0 0-2.05 0 3.18 3.18 0 0 0-.29 1.5v1.38a3.25 3.25 0 0 0 .29 1.51 1 1 0 0 0 1.05.55zm-7.02-3.49a1.46 1.46 0 0 0 1-.27.84.84 0 0 0 .31-.68v-.08a.94.94 0 0 0-.3-.74 1.2 1.2 0 0 0-.83-.27 1.65 1.65 0 0 0-.89.24 2.1 2.1 0 0 0-.68.68l-.93-.83a5.37 5.37 0 0 1 .44-.51 2.7 2.7 0 0 1 .54-.4 2.55 2.55 0 0 1 .7-.27 3.25 3.25 0 0 1 .87-.1 3.94 3.94 0 0 1 1.06.14 2.33 2.33 0 0 1 .82.4 1.91 1.91 0 0 1 .54.63 1.87 1.87 0 0 1 .18.83 2 2 0 0 1-.11.67 1.82 1.82 0 0 1-.32.52 1.79 1.79 0 0 1-.47.36 2.27 2.27 0 0 1-.57.2V18a2.34 2.34 0 0 1 .63.21 1.7 1.7 0 0 1 .51.38 1.89 1.89 0 0 1 .34.55 2.07 2.07 0 0 1 .12.73 2 2 0 0 1-.2.92 2 2 0 0 1-.58.72 2.66 2.66 0 0 1-.89.45 3.76 3.76 0 0 1-1.15.16 4.1 4.1 0 0 1-1-.11 3.1 3.1 0 0 1-.76-.31 2.76 2.76 0 0 1-.56-.45 4.22 4.22 0 0 1-.44-.55l1.07-.81a3.07 3.07 0 0 0 .28.42 1.94 1.94 0 0 0 .36.34 1.57 1.57 0 0 0 .45.22 2 2 0 0 0 .57.07 1.45 1.45 0 0 0 1-.3 1.12 1.12 0 0 0 .34-.85v-.08a1 1 0 0 0-.37-.8 1.78 1.78 0 0 0-1.06-.28h-.76v-1.21z'
  }));
});
Rewind_3024.displayName = 'Rewind_3024';
Rewind_3024.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_3024.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_3020 = React.forwardRef(function (_ref1433, ref) {
  var className = _ref1433.className,
      children = _ref1433.children,
      style = _ref1433.style,
      tabIndex = _ref1433.tabIndex,
      rest = _objectWithoutProperties$2(_ref1433, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1433 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1433.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1433, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M19.64 22.13a2.81 2.81 0 0 1-1.28-.27 2.36 2.36 0 0 1-.89-.77 3.39 3.39 0 0 1-.47-1.25 7.12 7.12 0 0 1-.17-1.68 7.24 7.24 0 0 1 .17-1.68 3.46 3.46 0 0 1 .52-1.25 2.36 2.36 0 0 1 .89-.77 2.81 2.81 0 0 1 1.28-.27 2.44 2.44 0 0 1 2.16 1 5.31 5.31 0 0 1 .7 2.93 5.31 5.31 0 0 1-.7 2.93 2.44 2.44 0 0 1-2.21 1.08zm0-1.22a1 1 0 0 0 1-.55 3.24 3.24 0 0 0 .3-1.51v-1.38a3.17 3.17 0 0 0-.3-1.5 1.22 1.22 0 0 0-2.05 0 3.18 3.18 0 0 0-.29 1.5v1.38a3.25 3.25 0 0 0 .29 1.51 1 1 0 0 0 1.05.55zm-7.02-3.49a1.46 1.46 0 0 0 1-.27.84.84 0 0 0 .31-.68v-.08a.94.94 0 0 0-.3-.74 1.2 1.2 0 0 0-.83-.27 1.65 1.65 0 0 0-.89.24 2.1 2.1 0 0 0-.68.68l-.93-.83a5.37 5.37 0 0 1 .44-.51 2.7 2.7 0 0 1 .54-.4 2.55 2.55 0 0 1 .7-.27 3.25 3.25 0 0 1 .87-.1 3.94 3.94 0 0 1 1.06.14 2.33 2.33 0 0 1 .82.4 1.91 1.91 0 0 1 .54.63 1.87 1.87 0 0 1 .18.83 2 2 0 0 1-.11.67 1.82 1.82 0 0 1-.32.52 1.79 1.79 0 0 1-.47.36 2.27 2.27 0 0 1-.57.2V18a2.34 2.34 0 0 1 .63.21 1.7 1.7 0 0 1 .51.38 1.89 1.89 0 0 1 .34.55 2.07 2.07 0 0 1 .12.73 2 2 0 0 1-.2.92 2 2 0 0 1-.58.72 2.66 2.66 0 0 1-.89.45 3.76 3.76 0 0 1-1.15.16 4.1 4.1 0 0 1-1-.11 3.1 3.1 0 0 1-.76-.31 2.76 2.76 0 0 1-.56-.45 4.22 4.22 0 0 1-.44-.55l1.07-.81a3.07 3.07 0 0 0 .28.42 1.94 1.94 0 0 0 .36.34 1.57 1.57 0 0 0 .45.22 2 2 0 0 0 .57.07 1.45 1.45 0 0 0 1-.3 1.12 1.12 0 0 0 .34-.85v-.08a1 1 0 0 0-.37-.8 1.78 1.78 0 0 0-1.06-.28h-.76v-1.21z'
  }));
});
Rewind_3020.displayName = 'Rewind_3020';
Rewind_3020.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_3020.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_532 = React.forwardRef(function (_ref1434, ref) {
  var className = _ref1434.className,
      children = _ref1434.children,
      style = _ref1434.style,
      tabIndex = _ref1434.tabIndex,
      rest = _objectWithoutProperties$2(_ref1434, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1434 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1434.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1434, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M18.58 15.58h-3.45L15 18.15a4.83 4.83 0 0 1 .26-.45 1.59 1.59 0 0 1 .33-.35 1.53 1.53 0 0 1 .44-.23 2 2 0 0 1 .6-.08 2.54 2.54 0 0 1 .92.16 2.06 2.06 0 0 1 .74.48 2.28 2.28 0 0 1 .5.77 2.73 2.73 0 0 1 .18 1 2.87 2.87 0 0 1-.19 1.07 2.36 2.36 0 0 1-.55.84 2.44 2.44 0 0 1-.89.55 3.23 3.23 0 0 1-1.21.2 3.79 3.79 0 0 1-.94-.11 3 3 0 0 1-.74-.32 2.45 2.45 0 0 1-.55-.45 4.13 4.13 0 0 1-.41-.55l1.06-.81.27.41a1.82 1.82 0 0 0 .34.34 1.59 1.59 0 0 0 .43.22 1.52 1.52 0 0 0 .55.08 1.29 1.29 0 0 0 1-.36 1.41 1.41 0 0 0 .33-1v-.06a1.18 1.18 0 0 0-1.28-1.27 1.44 1.44 0 0 0-.77.18 1.94 1.94 0 0 0-.48.39l-1.19-.17.29-4.31h4.52z'
  }));
});
Rewind_532.displayName = 'Rewind_532';
Rewind_532.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_532.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_524 = React.forwardRef(function (_ref1435, ref) {
  var className = _ref1435.className,
      children = _ref1435.children,
      style = _ref1435.style,
      tabIndex = _ref1435.tabIndex,
      rest = _objectWithoutProperties$2(_ref1435, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1435 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1435.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1435, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M18.58 15.58h-3.45L15 18.15a4.83 4.83 0 0 1 .26-.45 1.59 1.59 0 0 1 .33-.35 1.53 1.53 0 0 1 .44-.23 2 2 0 0 1 .6-.08 2.54 2.54 0 0 1 .92.16 2.06 2.06 0 0 1 .74.48 2.28 2.28 0 0 1 .5.77 2.73 2.73 0 0 1 .18 1 2.87 2.87 0 0 1-.19 1.07 2.36 2.36 0 0 1-.55.84 2.44 2.44 0 0 1-.89.55 3.23 3.23 0 0 1-1.21.2 3.79 3.79 0 0 1-.94-.11 3 3 0 0 1-.74-.32 2.45 2.45 0 0 1-.55-.45 4.13 4.13 0 0 1-.41-.55l1.06-.81.27.41a1.82 1.82 0 0 0 .34.34 1.59 1.59 0 0 0 .43.22 1.52 1.52 0 0 0 .55.08 1.29 1.29 0 0 0 1-.36 1.41 1.41 0 0 0 .33-1v-.06a1.18 1.18 0 0 0-1.28-1.27 1.44 1.44 0 0 0-.77.18 1.94 1.94 0 0 0-.48.39l-1.19-.17.29-4.31h4.52z'
  }));
});
Rewind_524.displayName = 'Rewind_524';
Rewind_524.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_524.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rewind_520 = React.forwardRef(function (_ref1436, ref) {
  var className = _ref1436.className,
      children = _ref1436.children,
      style = _ref1436.style,
      tabIndex = _ref1436.tabIndex,
      rest = _objectWithoutProperties$2(_ref1436, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1436 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1436.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1436, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 18A12 12 0 1 0 16 6h-4V1L6 7l6 6V8h4A10 10 0 1 1 6 18z'
  }), React.createElement('path', {
    d: 'M18.58 15.58h-3.45L15 18.15a4.83 4.83 0 0 1 .26-.45 1.59 1.59 0 0 1 .33-.35 1.53 1.53 0 0 1 .44-.23 2 2 0 0 1 .6-.08 2.54 2.54 0 0 1 .92.16 2.06 2.06 0 0 1 .74.48 2.28 2.28 0 0 1 .5.77 2.73 2.73 0 0 1 .18 1 2.87 2.87 0 0 1-.19 1.07 2.36 2.36 0 0 1-.55.84 2.44 2.44 0 0 1-.89.55 3.23 3.23 0 0 1-1.21.2 3.79 3.79 0 0 1-.94-.11 3 3 0 0 1-.74-.32 2.45 2.45 0 0 1-.55-.45 4.13 4.13 0 0 1-.41-.55l1.06-.81.27.41a1.82 1.82 0 0 0 .34.34 1.59 1.59 0 0 0 .43.22 1.52 1.52 0 0 0 .55.08 1.29 1.29 0 0 0 1-.36 1.41 1.41 0 0 0 .33-1v-.06a1.18 1.18 0 0 0-1.28-1.27 1.44 1.44 0 0 0-.77.18 1.94 1.94 0 0 0-.48.39l-1.19-.17.29-4.31h4.52z'
  }));
});
Rewind_520.displayName = 'Rewind_520';
Rewind_520.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rewind_520.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rocket32 = React.forwardRef(function (_ref1437, ref) {
  var className = _ref1437.className,
      children = _ref1437.children,
      style = _ref1437.style,
      tabIndex = _ref1437.tabIndex,
      rest = _objectWithoutProperties$2(_ref1437, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1437 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1437.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1437, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.288 23.292l7.997-7.997 1.414 1.414-7.997 7.997z'
  }), React.createElement('path', {
    d: 'M17 30a1 1 0 0 1-.37-.07 1 1 0 0 1-.62-.79l-1-7 2-.28.75 5.27L21 24.52V17a1 1 0 0 1 .29-.71l4.07-4.07A8.94 8.94 0 0 0 28 5.86V4h-1.86a8.94 8.94 0 0 0-6.36 2.64l-4.07 4.07A1 1 0 0 1 15 11H7.48l-2.61 3.26 5.27.75-.28 2-7-1a1 1 0 0 1-.79-.62 1 1 0 0 1 .15-1l4-5A1 1 0 0 1 7 9h7.59l3.77-3.78A10.92 10.92 0 0 1 26.14 2H28a2 2 0 0 1 2 2v1.86a10.92 10.92 0 0 1-3.22 7.78L23 17.41V25a1 1 0 0 1-.38.78l-5 4A1 1 0 0 1 17 30z'
  }));
});
Rocket32.displayName = 'Rocket32';
Rocket32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rocket32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rocket24 = React.forwardRef(function (_ref1438, ref) {
  var className = _ref1438.className,
      children = _ref1438.children,
      style = _ref1438.style,
      tabIndex = _ref1438.tabIndex,
      rest = _objectWithoutProperties$2(_ref1438, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1438 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1438.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1438, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.288 23.292l7.997-7.997 1.414 1.414-7.997 7.997z'
  }), React.createElement('path', {
    d: 'M17 30a1 1 0 0 1-.37-.07 1 1 0 0 1-.62-.79l-1-7 2-.28.75 5.27L21 24.52V17a1 1 0 0 1 .29-.71l4.07-4.07A8.94 8.94 0 0 0 28 5.86V4h-1.86a8.94 8.94 0 0 0-6.36 2.64l-4.07 4.07A1 1 0 0 1 15 11H7.48l-2.61 3.26 5.27.75-.28 2-7-1a1 1 0 0 1-.79-.62 1 1 0 0 1 .15-1l4-5A1 1 0 0 1 7 9h7.59l3.77-3.78A10.92 10.92 0 0 1 26.14 2H28a2 2 0 0 1 2 2v1.86a10.92 10.92 0 0 1-3.22 7.78L23 17.41V25a1 1 0 0 1-.38.78l-5 4A1 1 0 0 1 17 30z'
  }));
});
Rocket24.displayName = 'Rocket24';
Rocket24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rocket24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rocket20 = React.forwardRef(function (_ref1439, ref) {
  var className = _ref1439.className,
      children = _ref1439.children,
      style = _ref1439.style,
      tabIndex = _ref1439.tabIndex,
      rest = _objectWithoutProperties$2(_ref1439, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1439 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1439.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1439, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7.288 23.292l7.997-7.997 1.414 1.414-7.997 7.997z'
  }), React.createElement('path', {
    d: 'M17 30a1 1 0 0 1-.37-.07 1 1 0 0 1-.62-.79l-1-7 2-.28.75 5.27L21 24.52V17a1 1 0 0 1 .29-.71l4.07-4.07A8.94 8.94 0 0 0 28 5.86V4h-1.86a8.94 8.94 0 0 0-6.36 2.64l-4.07 4.07A1 1 0 0 1 15 11H7.48l-2.61 3.26 5.27.75-.28 2-7-1a1 1 0 0 1-.79-.62 1 1 0 0 1 .15-1l4-5A1 1 0 0 1 7 9h7.59l3.77-3.78A10.92 10.92 0 0 1 26.14 2H28a2 2 0 0 1 2 2v1.86a10.92 10.92 0 0 1-3.22 7.78L23 17.41V25a1 1 0 0 1-.38.78l-5 4A1 1 0 0 1 17 30z'
  }));
});
Rocket20.displayName = 'Rocket20';
Rocket20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rocket20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rotate32 = React.forwardRef(function (_ref1440, ref) {
  var className = _ref1440.className,
      children = _ref1440.children,
      style = _ref1440.style,
      tabIndex = _ref1440.tabIndex,
      rest = _objectWithoutProperties$2(_ref1440, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1440 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1440.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1440, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.91 26.82l.35 2a12.9 12.9 0 0 0 4.24-1.54l-1-1.73a10.88 10.88 0 0 1-3.59 1.27zm6.51-3.75L26 24.35a13 13 0 0 0 2.24-3.91l-1.87-.68a11 11 0 0 1-1.95 3.31zM9.5 27.25a12.9 12.9 0 0 0 4.24 1.54l.35-2a10.88 10.88 0 0 1-3.59-1.3zm-3.83-7.49l-1.87.68A13 13 0 0 0 6 24.35l.32-.26 1.22-1a11 11 0 0 1-1.91-3.31zM29 16a12.85 12.85 0 0 0-.8-4.44l-1.87.68A11.18 11.18 0 0 1 27 16zm-3-8.35a13 13 0 0 0-20 0V4H4v8h8v-2H6.81a11 11 0 0 1 17.61-1.07z'
  }));
});
Rotate32.displayName = 'Rotate32';
Rotate32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rotate32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rotate24 = React.forwardRef(function (_ref1441, ref) {
  var className = _ref1441.className,
      children = _ref1441.children,
      style = _ref1441.style,
      tabIndex = _ref1441.tabIndex,
      rest = _objectWithoutProperties$2(_ref1441, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1441 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1441.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1441, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.91 26.82l.35 2a12.9 12.9 0 0 0 4.24-1.54l-1-1.73a10.88 10.88 0 0 1-3.59 1.27zm6.51-3.75L26 24.35a13 13 0 0 0 2.24-3.91l-1.87-.68a11 11 0 0 1-1.95 3.31zM9.5 27.25a12.9 12.9 0 0 0 4.24 1.54l.35-2a10.88 10.88 0 0 1-3.59-1.3zm-3.83-7.49l-1.87.68A13 13 0 0 0 6 24.35l.32-.26 1.22-1a11 11 0 0 1-1.91-3.31zM29 16a12.85 12.85 0 0 0-.8-4.44l-1.87.68A11.18 11.18 0 0 1 27 16zm-3-8.35a13 13 0 0 0-20 0V4H4v8h8v-2H6.81a11 11 0 0 1 17.61-1.07z'
  }));
});
Rotate24.displayName = 'Rotate24';
Rotate24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rotate24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rotate20 = React.forwardRef(function (_ref1442, ref) {
  var className = _ref1442.className,
      children = _ref1442.children,
      style = _ref1442.style,
      tabIndex = _ref1442.tabIndex,
      rest = _objectWithoutProperties$2(_ref1442, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1442 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1442.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1442, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17.91 26.82l.35 2a12.9 12.9 0 0 0 4.24-1.54l-1-1.73a10.88 10.88 0 0 1-3.59 1.27zm6.51-3.75L26 24.35a13 13 0 0 0 2.24-3.91l-1.87-.68a11 11 0 0 1-1.95 3.31zM9.5 27.25a12.9 12.9 0 0 0 4.24 1.54l.35-2a10.88 10.88 0 0 1-3.59-1.3zm-3.83-7.49l-1.87.68A13 13 0 0 0 6 24.35l.32-.26 1.22-1a11 11 0 0 1-1.91-3.31zM29 16a12.85 12.85 0 0 0-.8-4.44l-1.87.68A11.18 11.18 0 0 1 27 16zm-3-8.35a13 13 0 0 0-20 0V4H4v8h8v-2H6.81a11 11 0 0 1 17.61-1.07z'
  }));
});
Rotate20.displayName = 'Rotate20';
Rotate20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rotate20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Row32 = React.forwardRef(function (_ref1443, ref) {
  var className = _ref1443.className,
      children = _ref1443.children,
      style = _ref1443.style,
      tabIndex = _ref1443.tabIndex,
      rest = _objectWithoutProperties$2(_ref1443, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1443 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1443.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1443, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 24h24v2H4zm22-6H6v-4h20v4m2 0v-4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2zM4 6h24v2H4z'
  }));
});
Row32.displayName = 'Row32';
Row32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Row32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Row24 = React.forwardRef(function (_ref1444, ref) {
  var className = _ref1444.className,
      children = _ref1444.children,
      style = _ref1444.style,
      tabIndex = _ref1444.tabIndex,
      rest = _objectWithoutProperties$2(_ref1444, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1444 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1444.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1444, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 24h24v2H4zm22-6H6v-4h20v4m2 0v-4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2zM4 6h24v2H4z'
  }));
});
Row24.displayName = 'Row24';
Row24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Row24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Row20 = React.forwardRef(function (_ref1445, ref) {
  var className = _ref1445.className,
      children = _ref1445.children,
      style = _ref1445.style,
      tabIndex = _ref1445.tabIndex,
      rest = _objectWithoutProperties$2(_ref1445, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1445 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1445.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1445, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 24h24v2H4zm22-6H6v-4h20v4m2 0v-4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2zM4 6h24v2H4z'
  }));
});
Row20.displayName = 'Row20';
Row20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Row20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rss32 = React.forwardRef(function (_ref1446, ref) {
  var className = _ref1446.className,
      children = _ref1446.children,
      style = _ref1446.style,
      tabIndex = _ref1446.tabIndex,
      rest = _objectWithoutProperties$2(_ref1446, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1446 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1446.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1446, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm22-4h-2C28 13 19 4 8 4V2c12.1 0 22 9.9 22 22z'
  }), React.createElement('path', {
    d: 'M22 24h-2c0-6.6-5.4-12-12-12v-2c7.7 0 14 6.3 14 14z'
  }));
});
Rss32.displayName = 'Rss32';
Rss32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rss32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rss24 = React.forwardRef(function (_ref1447, ref) {
  var className = _ref1447.className,
      children = _ref1447.children,
      style = _ref1447.style,
      tabIndex = _ref1447.tabIndex,
      rest = _objectWithoutProperties$2(_ref1447, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1447 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1447.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1447, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm22-4h-2C28 13 19 4 8 4V2c12.1 0 22 9.9 22 22z'
  }), React.createElement('path', {
    d: 'M22 24h-2c0-6.6-5.4-12-12-12v-2c7.7 0 14 6.3 14 14z'
  }));
});
Rss24.displayName = 'Rss24';
Rss24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rss24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Rss20 = React.forwardRef(function (_ref1448, ref) {
  var className = _ref1448.className,
      children = _ref1448.children,
      style = _ref1448.style,
      tabIndex = _ref1448.tabIndex,
      rest = _objectWithoutProperties$2(_ref1448, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1448 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1448.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1448, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm22-4h-2C28 13 19 4 8 4V2c12.1 0 22 9.9 22 22z'
  }), React.createElement('path', {
    d: 'M22 24h-2c0-6.6-5.4-12-12-12v-2c7.7 0 14 6.3 14 14z'
  }));
});
Rss20.displayName = 'Rss20';
Rss20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Rss20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RulerAlt32 = React.forwardRef(function (_ref1449, ref) {
  var className = _ref1449.className,
      children = _ref1449.children,
      style = _ref1449.style,
      tabIndex = _ref1449.tabIndex,
      rest = _objectWithoutProperties$2(_ref1449, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1449 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1449.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1449, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.41 21.67L10.34 2.58a2 2 0 0 0-2.83 0L2.59 7.51a2 2 0 0 0 0 2.82l19.07 19.09a2 2 0 0 0 1.42.58 2 2 0 0 0 1.41-.58l4.92-4.93a2 2 0 0 0 0-2.82zM23.08 28L4 8.92 8.92 4l3.79 3.79L10.46 10l1.41 1.41 2.25-2.21 4.13 4.13L16 15.58 17.42 17l2.25-2.25 4.13 4.13-2.25 2.25L23 22.54l2.25-2.25L28 23.08z'
  }));
});
RulerAlt32.displayName = 'RulerAlt32';
RulerAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RulerAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RulerAlt24 = React.forwardRef(function (_ref1450, ref) {
  var className = _ref1450.className,
      children = _ref1450.children,
      style = _ref1450.style,
      tabIndex = _ref1450.tabIndex,
      rest = _objectWithoutProperties$2(_ref1450, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1450 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1450.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1450, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.41 21.67L10.34 2.58a2 2 0 0 0-2.83 0L2.59 7.51a2 2 0 0 0 0 2.82l19.07 19.09a2 2 0 0 0 1.42.58 2 2 0 0 0 1.41-.58l4.92-4.93a2 2 0 0 0 0-2.82zM23.08 28L4 8.92 8.92 4l3.79 3.79L10.46 10l1.41 1.41 2.25-2.21 4.13 4.13L16 15.58 17.42 17l2.25-2.25 4.13 4.13-2.25 2.25L23 22.54l2.25-2.25L28 23.08z'
  }));
});
RulerAlt24.displayName = 'RulerAlt24';
RulerAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RulerAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var RulerAlt20 = React.forwardRef(function (_ref1451, ref) {
  var className = _ref1451.className,
      children = _ref1451.children,
      style = _ref1451.style,
      tabIndex = _ref1451.tabIndex,
      rest = _objectWithoutProperties$2(_ref1451, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1451 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1451.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1451, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.41 21.67L10.34 2.58a2 2 0 0 0-2.83 0L2.59 7.51a2 2 0 0 0 0 2.82l19.07 19.09a2 2 0 0 0 1.42.58 2 2 0 0 0 1.41-.58l4.92-4.93a2 2 0 0 0 0-2.82zM23.08 28L4 8.92 8.92 4l3.79 3.79L10.46 10l1.41 1.41 2.25-2.21 4.13 4.13L16 15.58 17.42 17l2.25-2.25 4.13 4.13-2.25 2.25L23 22.54l2.25-2.25L28 23.08z'
  }));
});
RulerAlt20.displayName = 'RulerAlt20';
RulerAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
RulerAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Ruler32 = React.forwardRef(function (_ref1452, ref) {
  var className = _ref1452.className,
      children = _ref1452.children,
      style = _ref1452.style,
      tabIndex = _ref1452.tabIndex,
      rest = _objectWithoutProperties$2(_ref1452, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1452 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1452.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1452, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 10H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-1 10H4v-8h4v4h2v-4h5v4h2v-4h5v4h2v-4h4z'
  }));
});
Ruler32.displayName = 'Ruler32';
Ruler32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Ruler32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Ruler24 = React.forwardRef(function (_ref1453, ref) {
  var className = _ref1453.className,
      children = _ref1453.children,
      style = _ref1453.style,
      tabIndex = _ref1453.tabIndex,
      rest = _objectWithoutProperties$2(_ref1453, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1453 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1453.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1453, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 10H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-1 10H4v-8h4v4h2v-4h5v4h2v-4h5v4h2v-4h4z'
  }));
});
Ruler24.displayName = 'Ruler24';
Ruler24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Ruler24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Ruler20 = React.forwardRef(function (_ref1454, ref) {
  var className = _ref1454.className,
      children = _ref1454.children,
      style = _ref1454.style,
      tabIndex = _ref1454.tabIndex,
      rest = _objectWithoutProperties$2(_ref1454, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1454 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1454.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1454, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 10H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-1 10H4v-8h4v4h2v-4h5v4h2v-4h5v4h2v-4h4z'
  }));
});
Ruler20.displayName = 'Ruler20';
Ruler20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Ruler20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Run32 = React.forwardRef(function (_ref1455, ref) {
  var className = _ref1455.className,
      children = _ref1455.children,
      style = _ref1455.style,
      tabIndex = _ref1455.tabIndex,
      rest = _objectWithoutProperties$2(_ref1455, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1455 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1455.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1455, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 16a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V12h22V6a2 2 0 0 0-2-2zM6 10V6h20v4z'
  }), React.createElement('path', {
    d: 'M19 19v6l5-3-5-3z'
  }));
});
Run32.displayName = 'Run32';
Run32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Run32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Run24 = React.forwardRef(function (_ref1456, ref) {
  var className = _ref1456.className,
      children = _ref1456.children,
      style = _ref1456.style,
      tabIndex = _ref1456.tabIndex,
      rest = _objectWithoutProperties$2(_ref1456, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1456 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1456.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1456, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 16a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V12h22V6a2 2 0 0 0-2-2zM6 10V6h20v4z'
  }), React.createElement('path', {
    d: 'M19 19v6l5-3-5-3z'
  }));
});
Run24.displayName = 'Run24';
Run24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Run24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Run20 = React.forwardRef(function (_ref1457, ref) {
  var className = _ref1457.className,
      children = _ref1457.children,
      style = _ref1457.style,
      tabIndex = _ref1457.tabIndex,
      rest = _objectWithoutProperties$2(_ref1457, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1457 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1457.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1457, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 16a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-2a8 8 0 1 0 8 8 8 8 0 0 0-8-8z'
  }), React.createElement('path', {
    d: 'M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4v-2H6V12h22V6a2 2 0 0 0-2-2zM6 10V6h20v4z'
  }), React.createElement('path', {
    d: 'M19 19v6l5-3-5-3z'
  }));
});
Run20.displayName = 'Run20';
Run20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Run20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Save32 = React.forwardRef(function (_ref1458, ref) {
  var className = _ref1458.className,
      children = _ref1458.children,
      style = _ref1458.style,
      tabIndex = _ref1458.tabIndex,
      rest = _objectWithoutProperties$2(_ref1458, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1458 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1458.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1458, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.71 9.29l-5-5A1 1 0 0 0 22 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V10a1 1 0 0 0-.29-.71zM12 6h8v4h-8zm8 20h-8v-8h8zm2 0v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8H6V6h4v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.41l4 4V26z'
  }));
});
Save32.displayName = 'Save32';
Save32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Save32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Save24 = React.forwardRef(function (_ref1459, ref) {
  var className = _ref1459.className,
      children = _ref1459.children,
      style = _ref1459.style,
      tabIndex = _ref1459.tabIndex,
      rest = _objectWithoutProperties$2(_ref1459, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1459 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1459.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1459, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.71 9.29l-5-5A1 1 0 0 0 22 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V10a1 1 0 0 0-.29-.71zM12 6h8v4h-8zm8 20h-8v-8h8zm2 0v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8H6V6h4v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.41l4 4V26z'
  }));
});
Save24.displayName = 'Save24';
Save24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Save24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Save20 = React.forwardRef(function (_ref1460, ref) {
  var className = _ref1460.className,
      children = _ref1460.children,
      style = _ref1460.style,
      tabIndex = _ref1460.tabIndex,
      rest = _objectWithoutProperties$2(_ref1460, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1460 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1460.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1460, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.71 9.29l-5-5A1 1 0 0 0 22 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V10a1 1 0 0 0-.29-.71zM12 6h8v4h-8zm8 20h-8v-8h8zm2 0v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8H6V6h4v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.41l4 4V26z'
  }));
});
Save20.displayName = 'Save20';
Save20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Save20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scale32 = React.forwardRef(function (_ref1461, ref) {
  var className = _ref1461.className,
      children = _ref1461.children,
      style = _ref1461.style,
      tabIndex = _ref1461.tabIndex,
      rest = _objectWithoutProperties$2(_ref1461, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1461 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1461.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1461, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 17H7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-6 8v-6h6v6z'
  }), React.createElement('path', {
    d: 'M19 21v2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v6h2V7h14v14'
  }));
});
Scale32.displayName = 'Scale32';
Scale32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scale32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scale24 = React.forwardRef(function (_ref1462, ref) {
  var className = _ref1462.className,
      children = _ref1462.children,
      style = _ref1462.style,
      tabIndex = _ref1462.tabIndex,
      rest = _objectWithoutProperties$2(_ref1462, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1462 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1462.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1462, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 17H7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-6 8v-6h6v6z'
  }), React.createElement('path', {
    d: 'M19 21v2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v6h2V7h14v14'
  }));
});
Scale24.displayName = 'Scale24';
Scale24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scale24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scale20 = React.forwardRef(function (_ref1463, ref) {
  var className = _ref1463.className,
      children = _ref1463.children,
      style = _ref1463.style,
      tabIndex = _ref1463.tabIndex,
      rest = _objectWithoutProperties$2(_ref1463, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1463 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1463.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1463, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 17H7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-6 8v-6h6v6z'
  }), React.createElement('path', {
    d: 'M19 21v2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v6h2V7h14v14'
  }));
});
Scale20.displayName = 'Scale20';
Scale20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scale20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scalpel32 = React.forwardRef(function (_ref1464, ref) {
  var className = _ref1464.className,
      children = _ref1464.children,
      style = _ref1464.style,
      tabIndex = _ref1464.tabIndex,
      rest = _objectWithoutProperties$2(_ref1464, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1464 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1464.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1464, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 5.17a4.1 4.1 0 0 0-5.66 0L.34 28h9.25a5 5 0 0 0 3.53-1.46l15.71-15.71a4 4 0 0 0 0-5.66zM12.29 18.88l2.09-2.09 2.83 2.83-2.09 2.09zm-.58 6.24a3 3 0 0 1-2.12.88H5.17l5.71-5.71 2.83 2.83zm15.7-15.71l-8.79 8.8-2.83-2.83 8.8-8.79a2 2 0 0 1 2.82 0 2 2 0 0 1 0 2.82z'
  }));
});
Scalpel32.displayName = 'Scalpel32';
Scalpel32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scalpel32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scalpel24 = React.forwardRef(function (_ref1465, ref) {
  var className = _ref1465.className,
      children = _ref1465.children,
      style = _ref1465.style,
      tabIndex = _ref1465.tabIndex,
      rest = _objectWithoutProperties$2(_ref1465, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1465 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1465.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1465, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 5.17a4.1 4.1 0 0 0-5.66 0L.34 28h9.25a5 5 0 0 0 3.53-1.46l15.71-15.71a4 4 0 0 0 0-5.66zM12.29 18.88l2.09-2.09 2.83 2.83-2.09 2.09zm-.58 6.24a3 3 0 0 1-2.12.88H5.17l5.71-5.71 2.83 2.83zm15.7-15.71l-8.79 8.8-2.83-2.83 8.8-8.79a2 2 0 0 1 2.82 0 2 2 0 0 1 0 2.82z'
  }));
});
Scalpel24.displayName = 'Scalpel24';
Scalpel24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scalpel24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scalpel20 = React.forwardRef(function (_ref1466, ref) {
  var className = _ref1466.className,
      children = _ref1466.children,
      style = _ref1466.style,
      tabIndex = _ref1466.tabIndex,
      rest = _objectWithoutProperties$2(_ref1466, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1466 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1466.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1466, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.83 5.17a4.1 4.1 0 0 0-5.66 0L.34 28h9.25a5 5 0 0 0 3.53-1.46l15.71-15.71a4 4 0 0 0 0-5.66zM12.29 18.88l2.09-2.09 2.83 2.83-2.09 2.09zm-.58 6.24a3 3 0 0 1-2.12.88H5.17l5.71-5.71 2.83 2.83zm15.7-15.71l-8.79 8.8-2.83-2.83 8.8-8.79a2 2 0 0 1 2.82 0 2 2 0 0 1 0 2.82z'
  }));
});
Scalpel20.displayName = 'Scalpel20';
Scalpel20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scalpel20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scan32 = React.forwardRef(function (_ref1467, ref) {
  var className = _ref1467.className,
      children = _ref1467.children,
      style = _ref1467.style,
      tabIndex = _ref1467.tabIndex,
      rest = _objectWithoutProperties$2(_ref1467, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1467 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1467.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1467, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 29H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16v2H5v22h16z'
  }), React.createElement('path', {
    d: 'M15 9h2v14h-2zm12 0h2v14h-2zm-6 0h2v14h-2z'
  }));
});
Scan32.displayName = 'Scan32';
Scan32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scan32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scan24 = React.forwardRef(function (_ref1468, ref) {
  var className = _ref1468.className,
      children = _ref1468.children,
      style = _ref1468.style,
      tabIndex = _ref1468.tabIndex,
      rest = _objectWithoutProperties$2(_ref1468, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1468 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1468.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1468, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 29H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16v2H5v22h16z'
  }), React.createElement('path', {
    d: 'M15 9h2v14h-2zm12 0h2v14h-2zm-6 0h2v14h-2z'
  }));
});
Scan24.displayName = 'Scan24';
Scan24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scan24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Scan20 = React.forwardRef(function (_ref1469, ref) {
  var className = _ref1469.className,
      children = _ref1469.children,
      style = _ref1469.style,
      tabIndex = _ref1469.tabIndex,
      rest = _objectWithoutProperties$2(_ref1469, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1469 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1469.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1469, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 29H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16v2H5v22h16z'
  }), React.createElement('path', {
    d: 'M15 9h2v14h-2zm12 0h2v14h-2zm-6 0h2v14h-2z'
  }));
});
Scan20.displayName = 'Scan20';
Scan20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Scan20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ScreenOff32 = React.forwardRef(function (_ref1470, ref) {
  var className = _ref1470.className,
      children = _ref1470.children,
      style = _ref1470.style,
      tabIndex = _ref1470.tabIndex,
      rest = _objectWithoutProperties$2(_ref1470, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1470 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1470.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1470, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 22H11.41L30 3.41 28.59 2l-2 2H4a2 2 0 0 0-2 2v16h2V6h20.59L2 28.59 3.41 30l6-6H12v4H8v2h16v-2h-4v-4h8a2 2 0 0 0 2-2V9h-2zm-10 6h-4v-4h4z'
  }));
});
ScreenOff32.displayName = 'ScreenOff32';
ScreenOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ScreenOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ScreenOff24 = React.forwardRef(function (_ref1471, ref) {
  var className = _ref1471.className,
      children = _ref1471.children,
      style = _ref1471.style,
      tabIndex = _ref1471.tabIndex,
      rest = _objectWithoutProperties$2(_ref1471, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1471 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1471.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1471, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 22H11.41L30 3.41 28.59 2l-2 2H4a2 2 0 0 0-2 2v16h2V6h20.59L2 28.59 3.41 30l6-6H12v4H8v2h16v-2h-4v-4h8a2 2 0 0 0 2-2V9h-2zm-10 6h-4v-4h4z'
  }));
});
ScreenOff24.displayName = 'ScreenOff24';
ScreenOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ScreenOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ScreenOff20 = React.forwardRef(function (_ref1472, ref) {
  var className = _ref1472.className,
      children = _ref1472.children,
      style = _ref1472.style,
      tabIndex = _ref1472.tabIndex,
      rest = _objectWithoutProperties$2(_ref1472, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1472 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1472.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1472, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 22H11.41L30 3.41 28.59 2l-2 2H4a2 2 0 0 0-2 2v16h2V6h20.59L2 28.59 3.41 30l6-6H12v4H8v2h16v-2h-4v-4h8a2 2 0 0 0 2-2V9h-2zm-10 6h-4v-4h4z'
  }));
});
ScreenOff20.displayName = 'ScreenOff20';
ScreenOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ScreenOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Screen32 = React.forwardRef(function (_ref1473, ref) {
  var className = _ref1473.className,
      children = _ref1473.children,
      style = _ref1473.style,
      tabIndex = _ref1473.tabIndex,
      rest = _objectWithoutProperties$2(_ref1473, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1473 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1473.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1473, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8v4H8v2h16v-2h-4v-4h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM18 28h-4v-4h4zm10-6H4V6h24z'
  }));
});
Screen32.displayName = 'Screen32';
Screen32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Screen32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Screen24 = React.forwardRef(function (_ref1474, ref) {
  var className = _ref1474.className,
      children = _ref1474.children,
      style = _ref1474.style,
      tabIndex = _ref1474.tabIndex,
      rest = _objectWithoutProperties$2(_ref1474, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1474 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1474.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1474, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8v4H8v2h16v-2h-4v-4h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM18 28h-4v-4h4zm10-6H4V6h24z'
  }));
});
Screen24.displayName = 'Screen24';
Screen24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Screen24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Screen20 = React.forwardRef(function (_ref1475, ref) {
  var className = _ref1475.className,
      children = _ref1475.children,
      style = _ref1475.style,
      tabIndex = _ref1475.tabIndex,
      rest = _objectWithoutProperties$2(_ref1475, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1475 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1475.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1475, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8v4H8v2h16v-2h-4v-4h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM18 28h-4v-4h4zm10-6H4V6h24z'
  }));
});
Screen20.displayName = 'Screen20';
Screen20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Screen20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Search32 = React.forwardRef(function (_ref1476, ref) {
  var className = _ref1476.className,
      children = _ref1476.children,
      style = _ref1476.style,
      tabIndex = _ref1476.tabIndex,
      rest = _objectWithoutProperties$2(_ref1476, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1476 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1476.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1476, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 28.59L22.45 21A11 11 0 1 0 21 22.45L28.59 30zM5 14a9 9 0 1 1 9 9 9 9 0 0 1-9-9z'
  }));
});
Search32.displayName = 'Search32';
Search32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Search32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Search24 = React.forwardRef(function (_ref1477, ref) {
  var className = _ref1477.className,
      children = _ref1477.children,
      style = _ref1477.style,
      tabIndex = _ref1477.tabIndex,
      rest = _objectWithoutProperties$2(_ref1477, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1477 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1477.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1477, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 28.59L22.45 21A11 11 0 1 0 21 22.45L28.59 30zM5 14a9 9 0 1 1 9 9 9 9 0 0 1-9-9z'
  }));
});
Search24.displayName = 'Search24';
Search24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Search24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Search20 = React.forwardRef(function (_ref1478, ref) {
  var className = _ref1478.className,
      children = _ref1478.children,
      style = _ref1478.style,
      tabIndex = _ref1478.tabIndex,
      rest = _objectWithoutProperties$2(_ref1478, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1478 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1478.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1478, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 28.59L22.45 21A11 11 0 1 0 21 22.45L28.59 30zM5 14a9 9 0 1 1 9 9 9 9 0 0 1-9-9z'
  }));
});
Search20.displayName = 'Search20';
Search20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Search20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SendFilled32 = React.forwardRef(function (_ref1479, ref) {
  var className = _ref1479.className,
      children = _ref1479.children,
      style = _ref1479.style,
      tabIndex = _ref1479.tabIndex,
      rest = _objectWithoutProperties$2(_ref1479, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1479 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1479.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1479, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.45 15.11l-22-11a1 1 0 0 0-1.08.12 1 1 0 0 0-.33 1L6.69 15H18v2H6.69L4 26.74A1 1 0 0 0 5 28a1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78z'
  }));
});
SendFilled32.displayName = 'SendFilled32';
SendFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SendFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SendFilled24 = React.forwardRef(function (_ref1480, ref) {
  var className = _ref1480.className,
      children = _ref1480.children,
      style = _ref1480.style,
      tabIndex = _ref1480.tabIndex,
      rest = _objectWithoutProperties$2(_ref1480, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1480 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1480.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1480, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.45 15.11l-22-11a1 1 0 0 0-1.08.12 1 1 0 0 0-.33 1L6.69 15H18v2H6.69L4 26.74A1 1 0 0 0 5 28a1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78z'
  }));
});
SendFilled24.displayName = 'SendFilled24';
SendFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SendFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SendFilled20 = React.forwardRef(function (_ref1481, ref) {
  var className = _ref1481.className,
      children = _ref1481.children,
      style = _ref1481.style,
      tabIndex = _ref1481.tabIndex,
      rest = _objectWithoutProperties$2(_ref1481, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1481 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1481.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1481, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.45 15.11l-22-11a1 1 0 0 0-1.08.12 1 1 0 0 0-.33 1L6.69 15H18v2H6.69L4 26.74A1 1 0 0 0 5 28a1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78z'
  }));
});
SendFilled20.displayName = 'SendFilled20';
SendFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SendFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Send32 = React.forwardRef(function (_ref1482, ref) {
  var className = _ref1482.className,
      children = _ref1482.children,
      style = _ref1482.style,
      tabIndex = _ref1482.tabIndex,
      rest = _objectWithoutProperties$2(_ref1482, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1482 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1482.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1482, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.45 15.11l-22-11a1 1 0 0 0-1.08.12 1 1 0 0 0-.33 1L7 16 4 26.74A1 1 0 0 0 5 28a1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78zm-20.9 10L8.76 17H18v-2H8.76L6.55 6.89 24.76 16z'
  }));
});
Send32.displayName = 'Send32';
Send32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Send32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Send24 = React.forwardRef(function (_ref1483, ref) {
  var className = _ref1483.className,
      children = _ref1483.children,
      style = _ref1483.style,
      tabIndex = _ref1483.tabIndex,
      rest = _objectWithoutProperties$2(_ref1483, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1483 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1483.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1483, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.45 15.11l-22-11a1 1 0 0 0-1.08.12 1 1 0 0 0-.33 1L7 16 4 26.74A1 1 0 0 0 5 28a1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78zm-20.9 10L8.76 17H18v-2H8.76L6.55 6.89 24.76 16z'
  }));
});
Send24.displayName = 'Send24';
Send24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Send24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Send20 = React.forwardRef(function (_ref1484, ref) {
  var className = _ref1484.className,
      children = _ref1484.children,
      style = _ref1484.style,
      tabIndex = _ref1484.tabIndex,
      rest = _objectWithoutProperties$2(_ref1484, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1484 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1484.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1484, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.45 15.11l-22-11a1 1 0 0 0-1.08.12 1 1 0 0 0-.33 1L7 16 4 26.74A1 1 0 0 0 5 28a1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78zm-20.9 10L8.76 17H18v-2H8.76L6.55 6.89 24.76 16z'
  }));
});
Send20.displayName = 'Send20';
Send20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Send20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SettingsAdjust32 = React.forwardRef(function (_ref1485, ref) {
  var className = _ref1485.className,
      children = _ref1485.children,
      style = _ref1485.style,
      tabIndex = _ref1485.tabIndex,
      rest = _objectWithoutProperties$2(_ref1485, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1485 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1485.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1485, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 7h-5.1a5 5 0 0 0-9.8 0H2v2h13.1a5 5 0 0 0 9.8 0H30zm-10 4a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM2 25h5.1a5 5 0 0 0 9.8 0H30v-2H16.9a5 5 0 0 0-9.8 0H2zm7-1a3 3 0 1 1 3 3 3 3 0 0 1-3-3z'
  }));
});
SettingsAdjust32.displayName = 'SettingsAdjust32';
SettingsAdjust32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SettingsAdjust32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SettingsAdjust24 = React.forwardRef(function (_ref1486, ref) {
  var className = _ref1486.className,
      children = _ref1486.children,
      style = _ref1486.style,
      tabIndex = _ref1486.tabIndex,
      rest = _objectWithoutProperties$2(_ref1486, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1486 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1486.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1486, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 7h-5.1a5 5 0 0 0-9.8 0H2v2h13.1a5 5 0 0 0 9.8 0H30zm-10 4a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM2 25h5.1a5 5 0 0 0 9.8 0H30v-2H16.9a5 5 0 0 0-9.8 0H2zm7-1a3 3 0 1 1 3 3 3 3 0 0 1-3-3z'
  }));
});
SettingsAdjust24.displayName = 'SettingsAdjust24';
SettingsAdjust24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SettingsAdjust24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SettingsAdjust20 = React.forwardRef(function (_ref1487, ref) {
  var className = _ref1487.className,
      children = _ref1487.children,
      style = _ref1487.style,
      tabIndex = _ref1487.tabIndex,
      rest = _objectWithoutProperties$2(_ref1487, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1487 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1487.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1487, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 7h-5.1a5 5 0 0 0-9.8 0H2v2h13.1a5 5 0 0 0 9.8 0H30zm-10 4a3 3 0 1 1 3-3 3 3 0 0 1-3 3zM2 25h5.1a5 5 0 0 0 9.8 0H30v-2H16.9a5 5 0 0 0-9.8 0H2zm7-1a3 3 0 1 1 3 3 3 3 0 0 1-3-3z'
  }));
});
SettingsAdjust20.displayName = 'SettingsAdjust20';
SettingsAdjust20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SettingsAdjust20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Settings32 = React.forwardRef(function (_ref1488, ref) {
  var className = _ref1488.className,
      children = _ref1488.children,
      style = _ref1488.style,
      tabIndex = _ref1488.tabIndex,
      rest = _objectWithoutProperties$2(_ref1488, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1488 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1488.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1488, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 16.76v-1.53l1.92-1.68A2 2 0 0 0 29.3 11l-2.36-4a2 2 0 0 0-1.73-1 2 2 0 0 0-.64.1l-2.43.82a11.35 11.35 0 0 0-1.31-.75l-.51-2.52a2 2 0 0 0-2-1.61h-4.68a2 2 0 0 0-2 1.61l-.51 2.52a11.48 11.48 0 0 0-1.32.75l-2.38-.86A2 2 0 0 0 6.79 6a2 2 0 0 0-1.73 1L2.7 11a2 2 0 0 0 .41 2.51L5 15.24v1.53l-1.89 1.68A2 2 0 0 0 2.7 21l2.36 4a2 2 0 0 0 1.73 1 2 2 0 0 0 .64-.1l2.43-.82a11.35 11.35 0 0 0 1.31.75l.51 2.52a2 2 0 0 0 2 1.61h4.72a2 2 0 0 0 2-1.61l.51-2.52a11.48 11.48 0 0 0 1.32-.75l2.42.82a2 2 0 0 0 .64.1 2 2 0 0 0 1.73-1l2.28-4a2 2 0 0 0-.41-2.51zM25.21 24l-3.43-1.16a8.86 8.86 0 0 1-2.71 1.57L18.36 28h-4.72l-.71-3.55a9.36 9.36 0 0 1-2.7-1.57L6.79 24l-2.36-4 2.72-2.4a8.9 8.9 0 0 1 0-3.13L4.43 12l2.36-4 3.43 1.16a8.86 8.86 0 0 1 2.71-1.57L13.64 4h4.72l.71 3.55a9.36 9.36 0 0 1 2.7 1.57L25.21 8l2.36 4-2.72 2.4a8.9 8.9 0 0 1 0 3.13L27.57 20z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 5.94 5.94 0 0 1-6 6zm0-10a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4z'
  }));
});
Settings32.displayName = 'Settings32';
Settings32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Settings32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Settings24 = React.forwardRef(function (_ref1489, ref) {
  var className = _ref1489.className,
      children = _ref1489.children,
      style = _ref1489.style,
      tabIndex = _ref1489.tabIndex,
      rest = _objectWithoutProperties$2(_ref1489, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1489 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1489.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1489, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 16.76v-1.53l1.92-1.68A2 2 0 0 0 29.3 11l-2.36-4a2 2 0 0 0-1.73-1 2 2 0 0 0-.64.1l-2.43.82a11.35 11.35 0 0 0-1.31-.75l-.51-2.52a2 2 0 0 0-2-1.61h-4.68a2 2 0 0 0-2 1.61l-.51 2.52a11.48 11.48 0 0 0-1.32.75l-2.38-.86A2 2 0 0 0 6.79 6a2 2 0 0 0-1.73 1L2.7 11a2 2 0 0 0 .41 2.51L5 15.24v1.53l-1.89 1.68A2 2 0 0 0 2.7 21l2.36 4a2 2 0 0 0 1.73 1 2 2 0 0 0 .64-.1l2.43-.82a11.35 11.35 0 0 0 1.31.75l.51 2.52a2 2 0 0 0 2 1.61h4.72a2 2 0 0 0 2-1.61l.51-2.52a11.48 11.48 0 0 0 1.32-.75l2.42.82a2 2 0 0 0 .64.1 2 2 0 0 0 1.73-1l2.28-4a2 2 0 0 0-.41-2.51zM25.21 24l-3.43-1.16a8.86 8.86 0 0 1-2.71 1.57L18.36 28h-4.72l-.71-3.55a9.36 9.36 0 0 1-2.7-1.57L6.79 24l-2.36-4 2.72-2.4a8.9 8.9 0 0 1 0-3.13L4.43 12l2.36-4 3.43 1.16a8.86 8.86 0 0 1 2.71-1.57L13.64 4h4.72l.71 3.55a9.36 9.36 0 0 1 2.7 1.57L25.21 8l2.36 4-2.72 2.4a8.9 8.9 0 0 1 0 3.13L27.57 20z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 5.94 5.94 0 0 1-6 6zm0-10a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4z'
  }));
});
Settings24.displayName = 'Settings24';
Settings24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Settings24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Settings20 = React.forwardRef(function (_ref1490, ref) {
  var className = _ref1490.className,
      children = _ref1490.children,
      style = _ref1490.style,
      tabIndex = _ref1490.tabIndex,
      rest = _objectWithoutProperties$2(_ref1490, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1490 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1490.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1490, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 16.76v-1.53l1.92-1.68A2 2 0 0 0 29.3 11l-2.36-4a2 2 0 0 0-1.73-1 2 2 0 0 0-.64.1l-2.43.82a11.35 11.35 0 0 0-1.31-.75l-.51-2.52a2 2 0 0 0-2-1.61h-4.68a2 2 0 0 0-2 1.61l-.51 2.52a11.48 11.48 0 0 0-1.32.75l-2.38-.86A2 2 0 0 0 6.79 6a2 2 0 0 0-1.73 1L2.7 11a2 2 0 0 0 .41 2.51L5 15.24v1.53l-1.89 1.68A2 2 0 0 0 2.7 21l2.36 4a2 2 0 0 0 1.73 1 2 2 0 0 0 .64-.1l2.43-.82a11.35 11.35 0 0 0 1.31.75l.51 2.52a2 2 0 0 0 2 1.61h4.72a2 2 0 0 0 2-1.61l.51-2.52a11.48 11.48 0 0 0 1.32-.75l2.42.82a2 2 0 0 0 .64.1 2 2 0 0 0 1.73-1l2.28-4a2 2 0 0 0-.41-2.51zM25.21 24l-3.43-1.16a8.86 8.86 0 0 1-2.71 1.57L18.36 28h-4.72l-.71-3.55a9.36 9.36 0 0 1-2.7-1.57L6.79 24l-2.36-4 2.72-2.4a8.9 8.9 0 0 1 0-3.13L4.43 12l2.36-4 3.43 1.16a8.86 8.86 0 0 1 2.71-1.57L13.64 4h4.72l.71 3.55a9.36 9.36 0 0 1 2.7 1.57L25.21 8l2.36 4-2.72 2.4a8.9 8.9 0 0 1 0 3.13L27.57 20z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 5.94 5.94 0 0 1-6 6zm0-10a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4z'
  }));
});
Settings20.displayName = 'Settings20';
Settings20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Settings20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Share32 = React.forwardRef(function (_ref1491, ref) {
  var className = _ref1491.className,
      children = _ref1491.children,
      style = _ref1491.style,
      tabIndex = _ref1491.tabIndex,
      rest = _objectWithoutProperties$2(_ref1491, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1491 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1491.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1491, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 20a5 5 0 0 0-3.89 1.89l-7.31-4.57a4.46 4.46 0 0 0 0-2.64l7.31-4.57A5 5 0 1 0 18 7a4.79 4.79 0 0 0 .2 1.32l-7.31 4.57a5 5 0 1 0 0 6.22l7.31 4.57A4.79 4.79 0 0 0 18 25a5 5 0 1 0 5-5zm0-16a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 19a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm16 9a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
Share32.displayName = 'Share32';
Share32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Share32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Share24 = React.forwardRef(function (_ref1492, ref) {
  var className = _ref1492.className,
      children = _ref1492.children,
      style = _ref1492.style,
      tabIndex = _ref1492.tabIndex,
      rest = _objectWithoutProperties$2(_ref1492, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1492 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1492.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1492, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 20a5 5 0 0 0-3.89 1.89l-7.31-4.57a4.46 4.46 0 0 0 0-2.64l7.31-4.57A5 5 0 1 0 18 7a4.79 4.79 0 0 0 .2 1.32l-7.31 4.57a5 5 0 1 0 0 6.22l7.31 4.57A4.79 4.79 0 0 0 18 25a5 5 0 1 0 5-5zm0-16a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 19a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm16 9a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
Share24.displayName = 'Share24';
Share24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Share24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Share20 = React.forwardRef(function (_ref1493, ref) {
  var className = _ref1493.className,
      children = _ref1493.children,
      style = _ref1493.style,
      tabIndex = _ref1493.tabIndex,
      rest = _objectWithoutProperties$2(_ref1493, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1493 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1493.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1493, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 20a5 5 0 0 0-3.89 1.89l-7.31-4.57a4.46 4.46 0 0 0 0-2.64l7.31-4.57A5 5 0 1 0 18 7a4.79 4.79 0 0 0 .2 1.32l-7.31 4.57a5 5 0 1 0 0 6.22l7.31 4.57A4.79 4.79 0 0 0 18 25a5 5 0 1 0 5-5zm0-16a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 19a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm16 9a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
Share20.displayName = 'Share20';
Share20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Share20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingBag32 = React.forwardRef(function (_ref1494, ref) {
  var className = _ref1494.className,
      children = _ref1494.children,
      style = _ref1494.style,
      tabIndex = _ref1494.tabIndex,
      rest = _objectWithoutProperties$2(_ref1494, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1494 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1494.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1494, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.76 11.35A1 1 0 0 0 28 11h-6V7a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v4H4a1 1 0 0 0-1 1.15L4.88 24.3a2 2 0 0 0 2 1.7h18.26a2 2 0 0 0 2-1.7L29 12.15a1 1 0 0 0-.24-.8zM12 7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4h-8zm13.14 17H6.86L5.17 13h21.66z'
  }));
});
ShoppingBag32.displayName = 'ShoppingBag32';
ShoppingBag32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingBag32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingBag24 = React.forwardRef(function (_ref1495, ref) {
  var className = _ref1495.className,
      children = _ref1495.children,
      style = _ref1495.style,
      tabIndex = _ref1495.tabIndex,
      rest = _objectWithoutProperties$2(_ref1495, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1495 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1495.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1495, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.76 11.35A1 1 0 0 0 28 11h-6V7a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v4H4a1 1 0 0 0-1 1.15L4.88 24.3a2 2 0 0 0 2 1.7h18.26a2 2 0 0 0 2-1.7L29 12.15a1 1 0 0 0-.24-.8zM12 7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4h-8zm13.14 17H6.86L5.17 13h21.66z'
  }));
});
ShoppingBag24.displayName = 'ShoppingBag24';
ShoppingBag24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingBag24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingBag20 = React.forwardRef(function (_ref1496, ref) {
  var className = _ref1496.className,
      children = _ref1496.children,
      style = _ref1496.style,
      tabIndex = _ref1496.tabIndex,
      rest = _objectWithoutProperties$2(_ref1496, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1496 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1496.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1496, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.76 11.35A1 1 0 0 0 28 11h-6V7a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v4H4a1 1 0 0 0-1 1.15L4.88 24.3a2 2 0 0 0 2 1.7h18.26a2 2 0 0 0 2-1.7L29 12.15a1 1 0 0 0-.24-.8zM12 7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4h-8zm13.14 17H6.86L5.17 13h21.66z'
  }));
});
ShoppingBag20.displayName = 'ShoppingBag20';
ShoppingBag20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingBag20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingCart32 = React.forwardRef(function (_ref1497, ref) {
  var className = _ref1497.className,
      children = _ref1497.children,
      style = _ref1497.style,
      tabIndex = _ref1497.tabIndex,
      rest = _objectWithoutProperties$2(_ref1497, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1497 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1497.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1497, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '28',
    r: '2'
  }), React.createElement('circle', {
    cx: '24',
    cy: '28',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 7H5.82L5 2.8A1 1 0 0 0 4 2H0v2h3.18L7 23.2a1 1 0 0 0 1 .8h18v-2H8.82L8 18h18a1 1 0 0 0 1-.78l2-9A1 1 0 0 0 28 7zm-2.8 9H7.62l-1.4-7h20.53z'
  }));
});
ShoppingCart32.displayName = 'ShoppingCart32';
ShoppingCart32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingCart32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingCart24 = React.forwardRef(function (_ref1498, ref) {
  var className = _ref1498.className,
      children = _ref1498.children,
      style = _ref1498.style,
      tabIndex = _ref1498.tabIndex,
      rest = _objectWithoutProperties$2(_ref1498, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1498 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1498.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1498, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '28',
    r: '2'
  }), React.createElement('circle', {
    cx: '24',
    cy: '28',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 7H5.82L5 2.8A1 1 0 0 0 4 2H0v2h3.18L7 23.2a1 1 0 0 0 1 .8h18v-2H8.82L8 18h18a1 1 0 0 0 1-.78l2-9A1 1 0 0 0 28 7zm-2.8 9H7.62l-1.4-7h20.53z'
  }));
});
ShoppingCart24.displayName = 'ShoppingCart24';
ShoppingCart24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingCart24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingCart20 = React.forwardRef(function (_ref1499, ref) {
  var className = _ref1499.className,
      children = _ref1499.children,
      style = _ref1499.style,
      tabIndex = _ref1499.tabIndex,
      rest = _objectWithoutProperties$2(_ref1499, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1499 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1499.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1499, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '28',
    r: '2'
  }), React.createElement('circle', {
    cx: '24',
    cy: '28',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 7H5.82L5 2.8A1 1 0 0 0 4 2H0v2h3.18L7 23.2a1 1 0 0 0 1 .8h18v-2H8.82L8 18h18a1 1 0 0 0 1-.78l2-9A1 1 0 0 0 28 7zm-2.8 9H7.62l-1.4-7h20.53z'
  }));
});
ShoppingCart20.displayName = 'ShoppingCart20';
ShoppingCart20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingCart20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingCatalog32 = React.forwardRef(function (_ref1500, ref) {
  var className = _ref1500.className,
      children = _ref1500.children,
      style = _ref1500.style,
      tabIndex = _ref1500.tabIndex,
      rest = _objectWithoutProperties$2(_ref1500, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1500 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1500.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1500, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 24h4v4h-4zm7 0h4v4h-4zm-7-7h4v4h-4zm7 0h4v4h-4z'
  }), React.createElement('path', {
    d: 'M28 11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7 0-3 1.3-3 3v4H4c-.6 0-1 .4-1 1v.2l1.9 12.1c.1 1 1 1.7 2 1.7H15v-2H6.9L5.2 13H28v-2zM12 7c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v4h-8V7z'
  }));
});
ShoppingCatalog32.displayName = 'ShoppingCatalog32';
ShoppingCatalog32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingCatalog32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingCatalog24 = React.forwardRef(function (_ref1501, ref) {
  var className = _ref1501.className,
      children = _ref1501.children,
      style = _ref1501.style,
      tabIndex = _ref1501.tabIndex,
      rest = _objectWithoutProperties$2(_ref1501, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1501 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1501.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1501, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 24h4v4h-4zm7 0h4v4h-4zm-7-7h4v4h-4zm7 0h4v4h-4z'
  }), React.createElement('path', {
    d: 'M28 11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7 0-3 1.3-3 3v4H4c-.6 0-1 .4-1 1v.2l1.9 12.1c.1 1 1 1.7 2 1.7H15v-2H6.9L5.2 13H28v-2zM12 7c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v4h-8V7z'
  }));
});
ShoppingCatalog24.displayName = 'ShoppingCatalog24';
ShoppingCatalog24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingCatalog24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ShoppingCatalog20 = React.forwardRef(function (_ref1502, ref) {
  var className = _ref1502.className,
      children = _ref1502.children,
      style = _ref1502.style,
      tabIndex = _ref1502.tabIndex,
      rest = _objectWithoutProperties$2(_ref1502, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1502 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1502.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1502, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 24h4v4h-4zm7 0h4v4h-4zm-7-7h4v4h-4zm7 0h4v4h-4z'
  }), React.createElement('path', {
    d: 'M28 11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7 0-3 1.3-3 3v4H4c-.6 0-1 .4-1 1v.2l1.9 12.1c.1 1 1 1.7 2 1.7H15v-2H6.9L5.2 13H28v-2zM12 7c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v4h-8V7z'
  }));
});
ShoppingCatalog20.displayName = 'ShoppingCatalog20';
ShoppingCatalog20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ShoppingCatalog20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Shuffle32 = React.forwardRef(function (_ref1503, ref) {
  var className = _ref1503.className,
      children = _ref1503.children,
      style = _ref1503.style,
      tabIndex = _ref1503.tabIndex,
      rest = _objectWithoutProperties$2(_ref1503, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1503 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1503.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1503, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.59 19.41L26.17 23h-6.62l-4.37-7 4.37-7h6.62l-3.58 3.59L24 14l6-6-6-6-1.41 1.41L26.17 7h-6.62a2 2 0 0 0-1.69.94L14 14.11l-3.86-6.17A2 2 0 0 0 8.45 7H2v2h6.45l4.37 7-4.37 7H2v2h6.45a2 2 0 0 0 1.69-.94L14 17.89l3.86 6.17a2 2 0 0 0 1.69.94h6.62l-3.58 3.59L24 30l6-6-6-6z'
  }));
});
Shuffle32.displayName = 'Shuffle32';
Shuffle32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Shuffle32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Shuffle24 = React.forwardRef(function (_ref1504, ref) {
  var className = _ref1504.className,
      children = _ref1504.children,
      style = _ref1504.style,
      tabIndex = _ref1504.tabIndex,
      rest = _objectWithoutProperties$2(_ref1504, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1504 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1504.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1504, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.59 19.41L26.17 23h-6.62l-4.37-7 4.37-7h6.62l-3.58 3.59L24 14l6-6-6-6-1.41 1.41L26.17 7h-6.62a2 2 0 0 0-1.69.94L14 14.11l-3.86-6.17A2 2 0 0 0 8.45 7H2v2h6.45l4.37 7-4.37 7H2v2h6.45a2 2 0 0 0 1.69-.94L14 17.89l3.86 6.17a2 2 0 0 0 1.69.94h6.62l-3.58 3.59L24 30l6-6-6-6z'
  }));
});
Shuffle24.displayName = 'Shuffle24';
Shuffle24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Shuffle24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Shuffle20 = React.forwardRef(function (_ref1505, ref) {
  var className = _ref1505.className,
      children = _ref1505.children,
      style = _ref1505.style,
      tabIndex = _ref1505.tabIndex,
      rest = _objectWithoutProperties$2(_ref1505, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1505 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1505.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1505, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22.59 19.41L26.17 23h-6.62l-4.37-7 4.37-7h6.62l-3.58 3.59L24 14l6-6-6-6-1.41 1.41L26.17 7h-6.62a2 2 0 0 0-1.69.94L14 14.11l-3.86-6.17A2 2 0 0 0 8.45 7H2v2h6.45l4.37 7-4.37 7H2v2h6.45a2 2 0 0 0 1.69-.94L14 17.89l3.86 6.17a2 2 0 0 0 1.69.94h6.62l-3.58 3.59L24 30l6-6-6-6z'
  }));
});
Shuffle20.displayName = 'Shuffle20';
Shuffle20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Shuffle20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Shuttle32 = React.forwardRef(function (_ref1506, ref) {
  var className = _ref1506.className,
      children = _ref1506.children,
      style = _ref1506.style,
      tabIndex = _ref1506.tabIndex,
      rest = _objectWithoutProperties$2(_ref1506, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1506 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1506.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1506, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.81 16l-7-9.56A1 1 0 0 0 22 6H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.44a1 1 0 0 0-.19-.56zM20 8h1.49l5.13 7H20zM4 8h14v7H4zm5 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-6h24z'
  }));
});
Shuttle32.displayName = 'Shuttle32';
Shuttle32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Shuttle32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Shuttle24 = React.forwardRef(function (_ref1507, ref) {
  var className = _ref1507.className,
      children = _ref1507.children,
      style = _ref1507.style,
      tabIndex = _ref1507.tabIndex,
      rest = _objectWithoutProperties$2(_ref1507, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1507 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1507.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1507, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.81 16l-7-9.56A1 1 0 0 0 22 6H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.44a1 1 0 0 0-.19-.56zM20 8h1.49l5.13 7H20zM4 8h14v7H4zm5 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-6h24z'
  }));
});
Shuttle24.displayName = 'Shuttle24';
Shuttle24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Shuttle24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Shuttle20 = React.forwardRef(function (_ref1508, ref) {
  var className = _ref1508.className,
      children = _ref1508.children,
      style = _ref1508.style,
      tabIndex = _ref1508.tabIndex,
      rest = _objectWithoutProperties$2(_ref1508, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1508 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1508.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1508, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.81 16l-7-9.56A1 1 0 0 0 22 6H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.44a1 1 0 0 0-.19-.56zM20 8h1.49l5.13 7H20zM4 8h14v7H4zm5 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-6h24z'
  }));
});
Shuttle20.displayName = 'Shuttle20';
Shuttle20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Shuttle20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SkipBack32 = React.forwardRef(function (_ref1509, ref) {
  var className = _ref1509.className,
      children = _ref1509.children,
      style = _ref1509.style,
      tabIndex = _ref1509.tabIndex,
      rest = _objectWithoutProperties$2(_ref1509, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1509 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1509.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1509, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 28a1 1 0 0 1-.5-.13l-19-11a1 1 0 0 1 0-1.74l19-11a1 1 0 0 1 1 0A1 1 0 0 1 28 5v22a1 1 0 0 1-1 1zM10 16l16 9.27V6.73zM2 4h2v24H2z'
  }));
});
SkipBack32.displayName = 'SkipBack32';
SkipBack32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SkipBack32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SkipBack24 = React.forwardRef(function (_ref1510, ref) {
  var className = _ref1510.className,
      children = _ref1510.children,
      style = _ref1510.style,
      tabIndex = _ref1510.tabIndex,
      rest = _objectWithoutProperties$2(_ref1510, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1510 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1510.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1510, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 28a1 1 0 0 1-.5-.13l-19-11a1 1 0 0 1 0-1.74l19-11a1 1 0 0 1 1 0A1 1 0 0 1 28 5v22a1 1 0 0 1-1 1zM10 16l16 9.27V6.73zM2 4h2v24H2z'
  }));
});
SkipBack24.displayName = 'SkipBack24';
SkipBack24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SkipBack24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SkipBack20 = React.forwardRef(function (_ref1511, ref) {
  var className = _ref1511.className,
      children = _ref1511.children,
      style = _ref1511.style,
      tabIndex = _ref1511.tabIndex,
      rest = _objectWithoutProperties$2(_ref1511, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1511 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1511.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1511, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 28a1 1 0 0 1-.5-.13l-19-11a1 1 0 0 1 0-1.74l19-11a1 1 0 0 1 1 0A1 1 0 0 1 28 5v22a1 1 0 0 1-1 1zM10 16l16 9.27V6.73zM2 4h2v24H2z'
  }));
});
SkipBack20.displayName = 'SkipBack20';
SkipBack20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SkipBack20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SkipForward32 = React.forwardRef(function (_ref1512, ref) {
  var className = _ref1512.className,
      children = _ref1512.children,
      style = _ref1512.style,
      tabIndex = _ref1512.tabIndex,
      rest = _objectWithoutProperties$2(_ref1512, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1512 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1512.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1512, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 28a1 1 0 0 1-1-1V5a1 1 0 0 1 .5-.87 1 1 0 0 1 1 0l19 11a1 1 0 0 1 0 1.74l-19 11A1 1 0 0 1 5 28zM6 6.73v18.54L22 16zM28 4h2v24h-2z'
  }));
});
SkipForward32.displayName = 'SkipForward32';
SkipForward32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SkipForward32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SkipForward24 = React.forwardRef(function (_ref1513, ref) {
  var className = _ref1513.className,
      children = _ref1513.children,
      style = _ref1513.style,
      tabIndex = _ref1513.tabIndex,
      rest = _objectWithoutProperties$2(_ref1513, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1513 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1513.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1513, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 28a1 1 0 0 1-1-1V5a1 1 0 0 1 .5-.87 1 1 0 0 1 1 0l19 11a1 1 0 0 1 0 1.74l-19 11A1 1 0 0 1 5 28zM6 6.73v18.54L22 16zM28 4h2v24h-2z'
  }));
});
SkipForward24.displayName = 'SkipForward24';
SkipForward24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SkipForward24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SkipForward20 = React.forwardRef(function (_ref1514, ref) {
  var className = _ref1514.className,
      children = _ref1514.children,
      style = _ref1514.style,
      tabIndex = _ref1514.tabIndex,
      rest = _objectWithoutProperties$2(_ref1514, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1514 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1514.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1514, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 28a1 1 0 0 1-1-1V5a1 1 0 0 1 .5-.87 1 1 0 0 1 1 0l19 11a1 1 0 0 1 0 1.74l-19 11A1 1 0 0 1 5 28zM6 6.73v18.54L22 16zM28 4h2v24h-2z'
  }));
});
SkipForward20.displayName = 'SkipForward20';
SkipForward20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SkipForward20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Smell32 = React.forwardRef(function (_ref1515, ref) {
  var className = _ref1515.className,
      children = _ref1515.children,
      style = _ref1515.style,
      tabIndex = _ref1515.tabIndex,
      rest = _objectWithoutProperties$2(_ref1515, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1515 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1515.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1515, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 15v-5h-2v7h2a3 3 0 0 1 0 6h-1v-2h-2v2a3 3 0 0 1-6 0v-2h-2v2h-1a3 3 0 0 1 0-6h2V9a3 3 0 0 1 3-3h1V4h-1a5 5 0 0 0-5 5v6a5 5 0 0 0 0 10h1.42a5 5 0 0 0 9.16 0H22a5 5 0 0 0 0-10z'
  }));
});
Smell32.displayName = 'Smell32';
Smell32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Smell32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Smell24 = React.forwardRef(function (_ref1516, ref) {
  var className = _ref1516.className,
      children = _ref1516.children,
      style = _ref1516.style,
      tabIndex = _ref1516.tabIndex,
      rest = _objectWithoutProperties$2(_ref1516, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1516 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1516.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1516, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 15v-5h-2v7h2a3 3 0 0 1 0 6h-1v-2h-2v2a3 3 0 0 1-6 0v-2h-2v2h-1a3 3 0 0 1 0-6h2V9a3 3 0 0 1 3-3h1V4h-1a5 5 0 0 0-5 5v6a5 5 0 0 0 0 10h1.42a5 5 0 0 0 9.16 0H22a5 5 0 0 0 0-10z'
  }));
});
Smell24.displayName = 'Smell24';
Smell24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Smell24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Smell20 = React.forwardRef(function (_ref1517, ref) {
  var className = _ref1517.className,
      children = _ref1517.children,
      style = _ref1517.style,
      tabIndex = _ref1517.tabIndex,
      rest = _objectWithoutProperties$2(_ref1517, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1517 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1517.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1517, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 15v-5h-2v7h2a3 3 0 0 1 0 6h-1v-2h-2v2a3 3 0 0 1-6 0v-2h-2v2h-1a3 3 0 0 1 0-6h2V9a3 3 0 0 1 3-3h1V4h-1a5 5 0 0 0-5 5v6a5 5 0 0 0 0 10h1.42a5 5 0 0 0 9.16 0H22a5 5 0 0 0 0-10z'
  }));
});
Smell20.displayName = 'Smell20';
Smell20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Smell20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SpellCheck32 = React.forwardRef(function (_ref1518, ref) {
  var className = _ref1518.className,
      children = _ref1518.children,
      style = _ref1518.style,
      tabIndex = _ref1518.tabIndex,
      rest = _objectWithoutProperties$2(_ref1518, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1518 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1518.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1518, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 22h2l-5-12h-2l-5 12h2l1.24-3h5.53zm-5.93-5l1.82-4.42h.25L18 17z'
  }), React.createElement('path', {
    d: 'M12 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v11h-2V6H6v20h6zm11-.82l-2.59-2.59L19 26l4 4 7-7-1.41-1.41L23 27.18z'
  }));
});
SpellCheck32.displayName = 'SpellCheck32';
SpellCheck32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SpellCheck32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SpellCheck24 = React.forwardRef(function (_ref1519, ref) {
  var className = _ref1519.className,
      children = _ref1519.children,
      style = _ref1519.style,
      tabIndex = _ref1519.tabIndex,
      rest = _objectWithoutProperties$2(_ref1519, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1519 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1519.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1519, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 22h2l-5-12h-2l-5 12h2l1.24-3h5.53zm-5.93-5l1.82-4.42h.25L18 17z'
  }), React.createElement('path', {
    d: 'M12 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v11h-2V6H6v20h6zm11-.82l-2.59-2.59L19 26l4 4 7-7-1.41-1.41L23 27.18z'
  }));
});
SpellCheck24.displayName = 'SpellCheck24';
SpellCheck24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SpellCheck24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SpellCheck20 = React.forwardRef(function (_ref1520, ref) {
  var className = _ref1520.className,
      children = _ref1520.children,
      style = _ref1520.style,
      tabIndex = _ref1520.tabIndex,
      rest = _objectWithoutProperties$2(_ref1520, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1520 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1520.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1520, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 22h2l-5-12h-2l-5 12h2l1.24-3h5.53zm-5.93-5l1.82-4.42h.25L18 17z'
  }), React.createElement('path', {
    d: 'M12 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v11h-2V6H6v20h6zm11-.82l-2.59-2.59L19 26l4 4 7-7-1.41-1.41L23 27.18z'
  }));
});
SpellCheck20.displayName = 'SpellCheck20';
SpellCheck20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SpellCheck20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SplitScreen32 = React.forwardRef(function (_ref1521, ref) {
  var className = _ref1521.className,
      children = _ref1521.children,
      style = _ref1521.style,
      tabIndex = _ref1521.tabIndex,
      rest = _objectWithoutProperties$2(_ref1521, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1521 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1521.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1521, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 4h2v24h-2zm-5 3v18H4V7h6m0-2H4a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm18 2v18h-6V7h6m0-2h-6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z'
  }));
});
SplitScreen32.displayName = 'SplitScreen32';
SplitScreen32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SplitScreen32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SplitScreen24 = React.forwardRef(function (_ref1522, ref) {
  var className = _ref1522.className,
      children = _ref1522.children,
      style = _ref1522.style,
      tabIndex = _ref1522.tabIndex,
      rest = _objectWithoutProperties$2(_ref1522, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1522 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1522.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1522, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 4h2v24h-2zm-5 3v18H4V7h6m0-2H4a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm18 2v18h-6V7h6m0-2h-6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z'
  }));
});
SplitScreen24.displayName = 'SplitScreen24';
SplitScreen24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SplitScreen24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SplitScreen20 = React.forwardRef(function (_ref1523, ref) {
  var className = _ref1523.className,
      children = _ref1523.children,
      style = _ref1523.style,
      tabIndex = _ref1523.tabIndex,
      rest = _objectWithoutProperties$2(_ref1523, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1523 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1523.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1523, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 4h2v24h-2zm-5 3v18H4V7h6m0-2H4a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm18 2v18h-6V7h6m0-2h-6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z'
  }));
});
SplitScreen20.displayName = 'SplitScreen20';
SplitScreen20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SplitScreen20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarFilled32 = React.forwardRef(function (_ref1524, ref) {
  var className = _ref1524.className,
      children = _ref1524.children,
      style = _ref1524.style,
      tabIndex = _ref1524.tabIndex,
      rest = _objectWithoutProperties$2(_ref1524, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1524 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1524.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1524, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2l-4.55 9.22-10.17 1.47 7.36 7.18L6.9 30l9.1-4.78L25.1 30l-1.74-10.13 7.36-7.17-10.17-1.48z'
  }));
});
StarFilled32.displayName = 'StarFilled32';
StarFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarFilled24 = React.forwardRef(function (_ref1525, ref) {
  var className = _ref1525.className,
      children = _ref1525.children,
      style = _ref1525.style,
      tabIndex = _ref1525.tabIndex,
      rest = _objectWithoutProperties$2(_ref1525, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1525 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1525.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1525, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2l-4.55 9.22-10.17 1.47 7.36 7.18L6.9 30l9.1-4.78L25.1 30l-1.74-10.13 7.36-7.17-10.17-1.48z'
  }));
});
StarFilled24.displayName = 'StarFilled24';
StarFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarFilled20 = React.forwardRef(function (_ref1526, ref) {
  var className = _ref1526.className,
      children = _ref1526.children,
      style = _ref1526.style,
      tabIndex = _ref1526.tabIndex,
      rest = _objectWithoutProperties$2(_ref1526, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1526 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1526.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1526, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2l-4.55 9.22-10.17 1.47 7.36 7.18L6.9 30l9.1-4.78L25.1 30l-1.74-10.13 7.36-7.17-10.17-1.48z'
  }));
});
StarFilled20.displayName = 'StarFilled20';
StarFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarHalf32 = React.forwardRef(function (_ref1527, ref) {
  var className = _ref1527.className,
      children = _ref1527.children,
      style = _ref1527.style,
      tabIndex = _ref1527.tabIndex,
      rest = _objectWithoutProperties$2(_ref1527, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1527 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1527.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1527, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.45 11.22L1.28 12.7l7.36 7.17L6.9 30l9.1-4.78V2l-4.55 9.22z'
  }));
});
StarHalf32.displayName = 'StarHalf32';
StarHalf32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarHalf32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarHalf24 = React.forwardRef(function (_ref1528, ref) {
  var className = _ref1528.className,
      children = _ref1528.children,
      style = _ref1528.style,
      tabIndex = _ref1528.tabIndex,
      rest = _objectWithoutProperties$2(_ref1528, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1528 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1528.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1528, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.45 11.22L1.28 12.7l7.36 7.17L6.9 30l9.1-4.78V2l-4.55 9.22z'
  }));
});
StarHalf24.displayName = 'StarHalf24';
StarHalf24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarHalf24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StarHalf20 = React.forwardRef(function (_ref1529, ref) {
  var className = _ref1529.className,
      children = _ref1529.children,
      style = _ref1529.style,
      tabIndex = _ref1529.tabIndex,
      rest = _objectWithoutProperties$2(_ref1529, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1529 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1529.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1529, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11.45 11.22L1.28 12.7l7.36 7.17L6.9 30l9.1-4.78V2l-4.55 9.22z'
  }));
});
StarHalf20.displayName = 'StarHalf20';
StarHalf20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StarHalf20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Star32 = React.forwardRef(function (_ref1530, ref) {
  var className = _ref1530.className,
      children = _ref1530.children,
      style = _ref1530.style,
      tabIndex = _ref1530.tabIndex,
      rest = _objectWithoutProperties$2(_ref1530, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1530 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1530.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1530, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 6.52l2.76 5.58.46 1 1 .15 6.16.89-4.38 4.3-.75.73.18 1 1.05 6.13-5.51-2.89L16 23l-.93.49-5.51 2.85 1-6.13.18-1-.74-.77-4.42-4.35 6.16-.89 1-.15.46-1L16 6.52M16 2l-4.55 9.22-10.17 1.47 7.36 7.18L6.9 30l9.1-4.78L25.1 30l-1.74-10.13 7.36-7.17-10.17-1.48z'
  }));
});
Star32.displayName = 'Star32';
Star32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Star32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Star24 = React.forwardRef(function (_ref1531, ref) {
  var className = _ref1531.className,
      children = _ref1531.children,
      style = _ref1531.style,
      tabIndex = _ref1531.tabIndex,
      rest = _objectWithoutProperties$2(_ref1531, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1531 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1531.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1531, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 6.52l2.76 5.58.46 1 1 .15 6.16.89-4.38 4.3-.75.73.18 1 1.05 6.13-5.51-2.89L16 23l-.93.49-5.51 2.85 1-6.13.18-1-.74-.77-4.42-4.35 6.16-.89 1-.15.46-1L16 6.52M16 2l-4.55 9.22-10.17 1.47 7.36 7.18L6.9 30l9.1-4.78L25.1 30l-1.74-10.13 7.36-7.17-10.17-1.48z'
  }));
});
Star24.displayName = 'Star24';
Star24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Star24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Star20 = React.forwardRef(function (_ref1532, ref) {
  var className = _ref1532.className,
      children = _ref1532.children,
      style = _ref1532.style,
      tabIndex = _ref1532.tabIndex,
      rest = _objectWithoutProperties$2(_ref1532, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1532 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1532.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1532, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 6.52l2.76 5.58.46 1 1 .15 6.16.89-4.38 4.3-.75.73.18 1 1.05 6.13-5.51-2.89L16 23l-.93.49-5.51 2.85 1-6.13.18-1-.74-.77-4.42-4.35 6.16-.89 1-.15.46-1L16 6.52M16 2l-4.55 9.22-10.17 1.47 7.36 7.18L6.9 30l9.1-4.78L25.1 30l-1.74-10.13 7.36-7.17-10.17-1.48z'
  }));
});
Star20.displayName = 'Star20';
Star20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Star20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopFilled32 = React.forwardRef(function (_ref1533, ref) {
  var className = _ref1533.className,
      children = _ref1533.children,
      style = _ref1533.style,
      tabIndex = _ref1533.tabIndex,
      rest = _objectWithoutProperties$2(_ref1533, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1533 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1533.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1533, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm6 18a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z'
  }));
});
StopFilled32.displayName = 'StopFilled32';
StopFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopFilled24 = React.forwardRef(function (_ref1534, ref) {
  var className = _ref1534.className,
      children = _ref1534.children,
      style = _ref1534.style,
      tabIndex = _ref1534.tabIndex,
      rest = _objectWithoutProperties$2(_ref1534, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1534 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1534.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1534, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm6 18a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z'
  }));
});
StopFilled24.displayName = 'StopFilled24';
StopFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopFilled20 = React.forwardRef(function (_ref1535, ref) {
  var className = _ref1535.className,
      children = _ref1535.children,
      style = _ref1535.style,
      tabIndex = _ref1535.tabIndex,
      rest = _objectWithoutProperties$2(_ref1535, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1535 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1535.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1535, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm6 18a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z'
  }));
});
StopFilled20.displayName = 'StopFilled20';
StopFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutlineFilled32 = React.forwardRef(function (_ref1536, ref) {
  var className = _ref1536.className,
      children = _ref1536.children,
      style = _ref1536.style,
      tabIndex = _ref1536.tabIndex,
      rest = _objectWithoutProperties$2(_ref1536, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1536 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1536.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1536, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm6 18a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M12 12h8v8h-8z'
  }));
});
StopOutlineFilled32.displayName = 'StopOutlineFilled32';
StopOutlineFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutlineFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutlineFilled24 = React.forwardRef(function (_ref1537, ref) {
  var className = _ref1537.className,
      children = _ref1537.children,
      style = _ref1537.style,
      tabIndex = _ref1537.tabIndex,
      rest = _objectWithoutProperties$2(_ref1537, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1537 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1537.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1537, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm6 18a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M12 12h8v8h-8z'
  }));
});
StopOutlineFilled24.displayName = 'StopOutlineFilled24';
StopOutlineFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutlineFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutlineFilled20 = React.forwardRef(function (_ref1538, ref) {
  var className = _ref1538.className,
      children = _ref1538.children,
      style = _ref1538.style,
      tabIndex = _ref1538.tabIndex,
      rest = _objectWithoutProperties$2(_ref1538, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1538 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1538.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1538, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm6 18a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M12 12h8v8h-8z'
  }));
});
StopOutlineFilled20.displayName = 'StopOutlineFilled20';
StopOutlineFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutlineFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutline32 = React.forwardRef(function (_ref1539, ref) {
  var className = _ref1539.className,
      children = _ref1539.children,
      style = _ref1539.style,
      tabIndex = _ref1539.tabIndex,
      rest = _objectWithoutProperties$2(_ref1539, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1539 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1539.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1539, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M20 12v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z'
  }));
});
StopOutline32.displayName = 'StopOutline32';
StopOutline32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutline32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutline24 = React.forwardRef(function (_ref1540, ref) {
  var className = _ref1540.className,
      children = _ref1540.children,
      style = _ref1540.style,
      tabIndex = _ref1540.tabIndex,
      rest = _objectWithoutProperties$2(_ref1540, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1540 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1540.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1540, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M20 12v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z'
  }));
});
StopOutline24.displayName = 'StopOutline24';
StopOutline24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutline24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var StopOutline20 = React.forwardRef(function (_ref1541, ref) {
  var className = _ref1541.className,
      children = _ref1541.children,
      style = _ref1541.style,
      tabIndex = _ref1541.tabIndex,
      rest = _objectWithoutProperties$2(_ref1541, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1541 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1541.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1541, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M20 12v8h-8v-8h8m0-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z'
  }));
});
StopOutline20.displayName = 'StopOutline20';
StopOutline20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
StopOutline20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Stop32 = React.forwardRef(function (_ref1542, ref) {
  var className = _ref1542.className,
      children = _ref1542.children,
      style = _ref1542.style,
      tabIndex = _ref1542.tabIndex,
      rest = _objectWithoutProperties$2(_ref1542, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1542 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1542.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1542, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 8v16H8V8h16m0-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z'
  }));
});
Stop32.displayName = 'Stop32';
Stop32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Stop32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Stop24 = React.forwardRef(function (_ref1543, ref) {
  var className = _ref1543.className,
      children = _ref1543.children,
      style = _ref1543.style,
      tabIndex = _ref1543.tabIndex,
      rest = _objectWithoutProperties$2(_ref1543, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1543 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1543.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1543, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 8v16H8V8h16m0-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z'
  }));
});
Stop24.displayName = 'Stop24';
Stop24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Stop24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Stop20 = React.forwardRef(function (_ref1544, ref) {
  var className = _ref1544.className,
      children = _ref1544.children,
      style = _ref1544.style,
      tabIndex = _ref1544.tabIndex,
      rest = _objectWithoutProperties$2(_ref1544, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1544 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1544.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1544, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 8v16H8V8h16m0-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z'
  }));
});
Stop20.displayName = 'Stop20';
Stop20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Stop20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Store32 = React.forwardRef(function (_ref1545, ref) {
  var className = _ref1545.className,
      children = _ref1545.children,
      style = _ref1545.style,
      tabIndex = _ref1545.tabIndex,
      rest = _objectWithoutProperties$2(_ref1545, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1545 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1545.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1545, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 10.68l-2-6A1 1 0 0 0 27 4H5a1 1 0 0 0-1 .68l-2 6A1.19 1.19 0 0 0 2 11v6a1 1 0 0 0 1 1h1v10h2V18h6v10h16V18h1a1 1 0 0 0 1-1v-6a1.19 1.19 0 0 0 0-.32zM26 26H14v-8h12zm2-10h-4v-4h-2v4h-5v-4h-2v4h-5v-4H8v4H4v-4.84L5.72 6h20.56L28 11.16z'
  }));
});
Store32.displayName = 'Store32';
Store32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Store32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Store24 = React.forwardRef(function (_ref1546, ref) {
  var className = _ref1546.className,
      children = _ref1546.children,
      style = _ref1546.style,
      tabIndex = _ref1546.tabIndex,
      rest = _objectWithoutProperties$2(_ref1546, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1546 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1546.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1546, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 10.68l-2-6A1 1 0 0 0 27 4H5a1 1 0 0 0-1 .68l-2 6A1.19 1.19 0 0 0 2 11v6a1 1 0 0 0 1 1h1v10h2V18h6v10h16V18h1a1 1 0 0 0 1-1v-6a1.19 1.19 0 0 0 0-.32zM26 26H14v-8h12zm2-10h-4v-4h-2v4h-5v-4h-2v4h-5v-4H8v4H4v-4.84L5.72 6h20.56L28 11.16z'
  }));
});
Store24.displayName = 'Store24';
Store24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Store24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Store20 = React.forwardRef(function (_ref1547, ref) {
  var className = _ref1547.className,
      children = _ref1547.children,
      style = _ref1547.style,
      tabIndex = _ref1547.tabIndex,
      rest = _objectWithoutProperties$2(_ref1547, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1547 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1547.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1547, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 10.68l-2-6A1 1 0 0 0 27 4H5a1 1 0 0 0-1 .68l-2 6A1.19 1.19 0 0 0 2 11v6a1 1 0 0 0 1 1h1v10h2V18h6v10h16V18h1a1 1 0 0 0 1-1v-6a1.19 1.19 0 0 0 0-.32zM26 26H14v-8h12zm2-10h-4v-4h-2v4h-5v-4h-2v4h-5v-4H8v4H4v-4.84L5.72 6h20.56L28 11.16z'
  }));
});
Store20.displayName = 'Store20';
Store20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Store20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SubtractAlt32 = React.forwardRef(function (_ref1548, ref) {
  var className = _ref1548.className,
      children = _ref1548.children,
      style = _ref1548.style,
      tabIndex = _ref1548.tabIndex,
      rest = _objectWithoutProperties$2(_ref1548, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1548 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1548.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1548, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M10 15h12v2H10z'
  }));
});
SubtractAlt32.displayName = 'SubtractAlt32';
SubtractAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SubtractAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SubtractAlt24 = React.forwardRef(function (_ref1549, ref) {
  var className = _ref1549.className,
      children = _ref1549.children,
      style = _ref1549.style,
      tabIndex = _ref1549.tabIndex,
      rest = _objectWithoutProperties$2(_ref1549, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1549 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1549.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1549, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M10 15h12v2H10z'
  }));
});
SubtractAlt24.displayName = 'SubtractAlt24';
SubtractAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SubtractAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var SubtractAlt20 = React.forwardRef(function (_ref1550, ref) {
  var className = _ref1550.className,
      children = _ref1550.children,
      style = _ref1550.style,
      tabIndex = _ref1550.tabIndex,
      rest = _objectWithoutProperties$2(_ref1550, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1550 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1550.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1550, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2z'
  }), React.createElement('path', {
    d: 'M10 15h12v2H10z'
  }));
});
SubtractAlt20.displayName = 'SubtractAlt20';
SubtractAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
SubtractAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Subtract32 = React.forwardRef(function (_ref1551, ref) {
  var className = _ref1551.className,
      children = _ref1551.children,
      style = _ref1551.style,
      tabIndex = _ref1551.tabIndex,
      rest = _objectWithoutProperties$2(_ref1551, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1551 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1551.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1551, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 15h18v2H7z'
  }));
});
Subtract32.displayName = 'Subtract32';
Subtract32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Subtract32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Subtract24 = React.forwardRef(function (_ref1552, ref) {
  var className = _ref1552.className,
      children = _ref1552.children,
      style = _ref1552.style,
      tabIndex = _ref1552.tabIndex,
      rest = _objectWithoutProperties$2(_ref1552, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1552 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1552.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1552, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 15h18v2H7z'
  }));
});
Subtract24.displayName = 'Subtract24';
Subtract24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Subtract24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Subtract20 = React.forwardRef(function (_ref1553, ref) {
  var className = _ref1553.className,
      children = _ref1553.children,
      style = _ref1553.style,
      tabIndex = _ref1553.tabIndex,
      rest = _objectWithoutProperties$2(_ref1553, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1553 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1553.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1553, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M7 15h18v2H7z'
  }));
});
Subtract20.displayName = 'Subtract20';
Subtract20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Subtract20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TableSplit32 = React.forwardRef(function (_ref1554, ref) {
  var className = _ref1554.className,
      children = _ref1554.children,
      style = _ref1554.style,
      tabIndex = _ref1554.tabIndex,
      rest = _objectWithoutProperties$2(_ref1554, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1554 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1554.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1554, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 3H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v4H5V5zm-10 6h10v7H17zm-2 7H5v-7h10zM5 20h10v7H5zm12 7v-7h10v7z'
  }));
});
TableSplit32.displayName = 'TableSplit32';
TableSplit32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TableSplit32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TableSplit24 = React.forwardRef(function (_ref1555, ref) {
  var className = _ref1555.className,
      children = _ref1555.children,
      style = _ref1555.style,
      tabIndex = _ref1555.tabIndex,
      rest = _objectWithoutProperties$2(_ref1555, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1555 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1555.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1555, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 3H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v4H5V5zm-10 6h10v7H17zm-2 7H5v-7h10zM5 20h10v7H5zm12 7v-7h10v7z'
  }));
});
TableSplit24.displayName = 'TableSplit24';
TableSplit24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TableSplit24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TableSplit20 = React.forwardRef(function (_ref1556, ref) {
  var className = _ref1556.className,
      children = _ref1556.children,
      style = _ref1556.style,
      tabIndex = _ref1556.tabIndex,
      rest = _objectWithoutProperties$2(_ref1556, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1556 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1556.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1556, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 3H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v4H5V5zm-10 6h10v7H17zm-2 7H5v-7h10zM5 20h10v7H5zm12 7v-7h10v7z'
  }));
});
TableSplit20.displayName = 'TableSplit20';
TableSplit20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TableSplit20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TableOfContents32 = React.forwardRef(function (_ref1557, ref) {
  var className = _ref1557.className,
      children = _ref1557.children,
      style = _ref1557.style,
      tabIndex = _ref1557.tabIndex,
      rest = _objectWithoutProperties$2(_ref1557, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1557 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1557.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1557, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h18v2H4zm0 6h18v2H4zm0 6h18v2H4zm0 6h18v2H4zM26 6h2v2h-2zm0 6h2v2h-2zm0 6h2v2h-2zm0 6h2v2h-2z'
  }));
});
TableOfContents32.displayName = 'TableOfContents32';
TableOfContents32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TableOfContents32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TableOfContents24 = React.forwardRef(function (_ref1558, ref) {
  var className = _ref1558.className,
      children = _ref1558.children,
      style = _ref1558.style,
      tabIndex = _ref1558.tabIndex,
      rest = _objectWithoutProperties$2(_ref1558, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1558 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1558.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1558, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h18v2H4zm0 6h18v2H4zm0 6h18v2H4zm0 6h18v2H4zM26 6h2v2h-2zm0 6h2v2h-2zm0 6h2v2h-2zm0 6h2v2h-2z'
  }));
});
TableOfContents24.displayName = 'TableOfContents24';
TableOfContents24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TableOfContents24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TableOfContents20 = React.forwardRef(function (_ref1559, ref) {
  var className = _ref1559.className,
      children = _ref1559.children,
      style = _ref1559.style,
      tabIndex = _ref1559.tabIndex,
      rest = _objectWithoutProperties$2(_ref1559, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1559 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1559.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1559, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 6h18v2H4zm0 6h18v2H4zm0 6h18v2H4zm0 6h18v2H4zM26 6h2v2h-2zm0 6h2v2h-2zm0 6h2v2h-2zm0 6h2v2h-2z'
  }));
});
TableOfContents20.displayName = 'TableOfContents20';
TableOfContents20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TableOfContents20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Table32 = React.forwardRef(function (_ref1560, ref) {
  var className = _ref1560.className,
      children = _ref1560.children,
      style = _ref1560.style,
      tabIndex = _ref1560.tabIndex,
      rest = _objectWithoutProperties$2(_ref1560, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1560 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1560.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1560, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2zm-2 0v4H5V5zm0 22H5v-4h22zm0-6H5v-4h22zm0-6H5v-4h22z'
  }));
});
Table32.displayName = 'Table32';
Table32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Table32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Table24 = React.forwardRef(function (_ref1561, ref) {
  var className = _ref1561.className,
      children = _ref1561.children,
      style = _ref1561.style,
      tabIndex = _ref1561.tabIndex,
      rest = _objectWithoutProperties$2(_ref1561, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1561 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1561.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1561, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2zm-2 0v4H5V5zm0 22H5v-4h22zm0-6H5v-4h22zm0-6H5v-4h22z'
  }));
});
Table24.displayName = 'Table24';
Table24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Table24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Table20 = React.forwardRef(function (_ref1562, ref) {
  var className = _ref1562.className,
      children = _ref1562.children,
      style = _ref1562.style,
      tabIndex = _ref1562.tabIndex,
      rest = _objectWithoutProperties$2(_ref1562, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1562 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1562.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1562, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2zm-2 0v4H5V5zm0 22H5v-4h22zm0-6H5v-4h22zm0-6H5v-4h22z'
  }));
});
Table20.displayName = 'Table20';
Table20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Table20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TagGroup32 = React.forwardRef(function (_ref1563, ref) {
  var className = _ref1563.className,
      children = _ref1563.children,
      style = _ref1563.style,
      tabIndex = _ref1563.tabIndex,
      rest = _objectWithoutProperties$2(_ref1563, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1563 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1563.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1563, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M16 30a1 1 0 0 1-.71-.29L4.59 19A2 2 0 0 1 4 17.59V10a2 2 0 0 1 2-2h7.59a2 2 0 0 1 1.41.59l10.71 10.7a1 1 0 0 1 0 1.42l-9 9A1 1 0 0 1 16 30zM6 10v7.59l10 10L23.59 20l-10-10z'
  }), React.createElement('path', {
    d: 'M27.71 13.29L17 2.59A2 2 0 0 0 15.59 2H8a2 2 0 0 0-2 2v2h2V4h7.59l10 10-1.3 1.29 1.42 1.42 2-2a1 1 0 0 0 0-1.42z'
  }));
});
TagGroup32.displayName = 'TagGroup32';
TagGroup32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TagGroup32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TagGroup24 = React.forwardRef(function (_ref1564, ref) {
  var className = _ref1564.className,
      children = _ref1564.children,
      style = _ref1564.style,
      tabIndex = _ref1564.tabIndex,
      rest = _objectWithoutProperties$2(_ref1564, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1564 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1564.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1564, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M16 30a1 1 0 0 1-.71-.29L4.59 19A2 2 0 0 1 4 17.59V10a2 2 0 0 1 2-2h7.59a2 2 0 0 1 1.41.59l10.71 10.7a1 1 0 0 1 0 1.42l-9 9A1 1 0 0 1 16 30zM6 10v7.59l10 10L23.59 20l-10-10z'
  }), React.createElement('path', {
    d: 'M27.71 13.29L17 2.59A2 2 0 0 0 15.59 2H8a2 2 0 0 0-2 2v2h2V4h7.59l10 10-1.3 1.29 1.42 1.42 2-2a1 1 0 0 0 0-1.42z'
  }));
});
TagGroup24.displayName = 'TagGroup24';
TagGroup24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TagGroup24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TagGroup20 = React.forwardRef(function (_ref1565, ref) {
  var className = _ref1565.className,
      children = _ref1565.children,
      style = _ref1565.style,
      tabIndex = _ref1565.tabIndex,
      rest = _objectWithoutProperties$2(_ref1565, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1565 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1565.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1565, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '10',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M16 30a1 1 0 0 1-.71-.29L4.59 19A2 2 0 0 1 4 17.59V10a2 2 0 0 1 2-2h7.59a2 2 0 0 1 1.41.59l10.71 10.7a1 1 0 0 1 0 1.42l-9 9A1 1 0 0 1 16 30zM6 10v7.59l10 10L23.59 20l-10-10z'
  }), React.createElement('path', {
    d: 'M27.71 13.29L17 2.59A2 2 0 0 0 15.59 2H8a2 2 0 0 0-2 2v2h2V4h7.59l10 10-1.3 1.29 1.42 1.42 2-2a1 1 0 0 0 0-1.42z'
  }));
});
TagGroup20.displayName = 'TagGroup20';
TagGroup20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TagGroup20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tag32 = React.forwardRef(function (_ref1566, ref) {
  var className = _ref1566.className,
      children = _ref1566.children,
      style = _ref1566.style,
      tabIndex = _ref1566.tabIndex,
      rest = _objectWithoutProperties$2(_ref1566, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1566 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1566.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1566, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18.52 30a3 3 0 0 1-2.12-.88L2.88 15.61A3 3 0 0 1 2 13.49V5a3 3 0 0 1 3-3h8.49a3 3 0 0 1 2.12.88l13.51 13.51a3 3 0 0 1 0 4.25l-8.48 8.48a3 3 0 0 1-2.12.88zM5 4a1 1 0 0 0-1 1v8.49a1 1 0 0 0 .3.71l13.51 13.51a1 1 0 0 0 1.41 0l8.49-8.49a1 1 0 0 0 0-1.41L14.2 4.3a1 1 0 0 0-.71-.3H5z'
  }), React.createElement('path', {
    d: 'M10 14a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Tag32.displayName = 'Tag32';
Tag32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tag32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tag24 = React.forwardRef(function (_ref1567, ref) {
  var className = _ref1567.className,
      children = _ref1567.children,
      style = _ref1567.style,
      tabIndex = _ref1567.tabIndex,
      rest = _objectWithoutProperties$2(_ref1567, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1567 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1567.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1567, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18.52 30a3 3 0 0 1-2.12-.88L2.88 15.61A3 3 0 0 1 2 13.49V5a3 3 0 0 1 3-3h8.49a3 3 0 0 1 2.12.88l13.51 13.51a3 3 0 0 1 0 4.25l-8.48 8.48a3 3 0 0 1-2.12.88zM5 4a1 1 0 0 0-1 1v8.49a1 1 0 0 0 .3.71l13.51 13.51a1 1 0 0 0 1.41 0l8.49-8.49a1 1 0 0 0 0-1.41L14.2 4.3a1 1 0 0 0-.71-.3H5z'
  }), React.createElement('path', {
    d: 'M10 14a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Tag24.displayName = 'Tag24';
Tag24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tag24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tag20 = React.forwardRef(function (_ref1568, ref) {
  var className = _ref1568.className,
      children = _ref1568.children,
      style = _ref1568.style,
      tabIndex = _ref1568.tabIndex,
      rest = _objectWithoutProperties$2(_ref1568, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1568 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1568.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1568, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18.52 30a3 3 0 0 1-2.12-.88L2.88 15.61A3 3 0 0 1 2 13.49V5a3 3 0 0 1 3-3h8.49a3 3 0 0 1 2.12.88l13.51 13.51a3 3 0 0 1 0 4.25l-8.48 8.48a3 3 0 0 1-2.12.88zM5 4a1 1 0 0 0-1 1v8.49a1 1 0 0 0 .3.71l13.51 13.51a1 1 0 0 0 1.41 0l8.49-8.49a1 1 0 0 0 0-1.41L14.2 4.3a1 1 0 0 0-.71-.3H5z'
  }), React.createElement('path', {
    d: 'M10 14a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0-2-2z'
  }));
});
Tag20.displayName = 'Tag20';
Tag20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tag20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Task32 = React.forwardRef(function (_ref1569, ref) {
  var className = _ref1569.className,
      children = _ref1569.children,
      style = _ref1569.style,
      tabIndex = _ref1569.tabIndex,
      rest = _objectWithoutProperties$2(_ref1569, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1569 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1569.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1569, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 20.18l-3.59-3.59L9 18l5 5 9-9-1.41-1.42-7.59 7.6z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
Task32.displayName = 'Task32';
Task32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Task32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Task24 = React.forwardRef(function (_ref1570, ref) {
  var className = _ref1570.className,
      children = _ref1570.children,
      style = _ref1570.style,
      tabIndex = _ref1570.tabIndex,
      rest = _objectWithoutProperties$2(_ref1570, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1570 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1570.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1570, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 20.18l-3.59-3.59L9 18l5 5 9-9-1.41-1.42-7.59 7.6z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
Task24.displayName = 'Task24';
Task24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Task24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Task20 = React.forwardRef(function (_ref1571, ref) {
  var className = _ref1571.className,
      children = _ref1571.children,
      style = _ref1571.style,
      tabIndex = _ref1571.tabIndex,
      rest = _objectWithoutProperties$2(_ref1571, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1571 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1571.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1571, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 20.18l-3.59-3.59L9 18l5 5 9-9-1.41-1.42-7.59 7.6z'
  }), React.createElement('path', {
    d: 'M25 5h-3V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1H7a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM12 4h8v4h-8zm13 24H7V7h3v3h12V7h3z'
  }));
});
Task20.displayName = 'Task20';
Task20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Task20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Taste32 = React.forwardRef(function (_ref1572, ref) {
  var className = _ref1572.className,
      children = _ref1572.children,
      style = _ref1572.style,
      tabIndex = _ref1572.tabIndex,
      rest = _objectWithoutProperties$2(_ref1572, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1572 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1572.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1572, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 4v2h4v8a8 8 0 0 0 16 0V6h4V4zm18 10a6 6 0 0 1-12 0V6h5v8h2V6h5zM11 26h2v2h-2zm-4-2h2v2H7zm8 0h2v2h-2zm4 2h2v2h-2zm4-2h2v2h-2z'
  }));
});
Taste32.displayName = 'Taste32';
Taste32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Taste32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Taste24 = React.forwardRef(function (_ref1573, ref) {
  var className = _ref1573.className,
      children = _ref1573.children,
      style = _ref1573.style,
      tabIndex = _ref1573.tabIndex,
      rest = _objectWithoutProperties$2(_ref1573, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1573 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1573.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1573, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 4v2h4v8a8 8 0 0 0 16 0V6h4V4zm18 10a6 6 0 0 1-12 0V6h5v8h2V6h5zM11 26h2v2h-2zm-4-2h2v2H7zm8 0h2v2h-2zm4 2h2v2h-2zm4-2h2v2h-2z'
  }));
});
Taste24.displayName = 'Taste24';
Taste24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Taste24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Taste20 = React.forwardRef(function (_ref1574, ref) {
  var className = _ref1574.className,
      children = _ref1574.children,
      style = _ref1574.style,
      tabIndex = _ref1574.tabIndex,
      rest = _objectWithoutProperties$2(_ref1574, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1574 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1574.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1574, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 4v2h4v8a8 8 0 0 0 16 0V6h4V4zm18 10a6 6 0 0 1-12 0V6h5v8h2V6h5zM11 26h2v2h-2zm-4-2h2v2H7zm8 0h2v2h-2zm4 2h2v2h-2zm4-2h2v2h-2z'
  }));
});
Taste20.displayName = 'Taste20';
Taste20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Taste20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Taxi32 = React.forwardRef(function (_ref1575, ref) {
  var className = _ref1575.className,
      children = _ref1575.children,
      style = _ref1575.style,
      tabIndex = _ref1575.tabIndex,
      rest = _objectWithoutProperties$2(_ref1575, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1575 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1575.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1575, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.39 16.08l-6.69-2.87-2.54-4.34-.08-.12A2 2 0 0 0 18.52 8h-8a2 2 0 0 0-1.67.89L5.46 14H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7a1 1 0 0 0-.61-.92zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-7h2a1 1 0 0 0 .83-.45L10.54 10h8l2.63 4.5a1 1 0 0 0 .47.42L28 17.66z'
  }));
});
Taxi32.displayName = 'Taxi32';
Taxi32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Taxi32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Taxi24 = React.forwardRef(function (_ref1576, ref) {
  var className = _ref1576.className,
      children = _ref1576.children,
      style = _ref1576.style,
      tabIndex = _ref1576.tabIndex,
      rest = _objectWithoutProperties$2(_ref1576, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1576 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1576.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1576, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.39 16.08l-6.69-2.87-2.54-4.34-.08-.12A2 2 0 0 0 18.52 8h-8a2 2 0 0 0-1.67.89L5.46 14H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7a1 1 0 0 0-.61-.92zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-7h2a1 1 0 0 0 .83-.45L10.54 10h8l2.63 4.5a1 1 0 0 0 .47.42L28 17.66z'
  }));
});
Taxi24.displayName = 'Taxi24';
Taxi24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Taxi24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Taxi20 = React.forwardRef(function (_ref1577, ref) {
  var className = _ref1577.className,
      children = _ref1577.children,
      style = _ref1577.style,
      tabIndex = _ref1577.tabIndex,
      rest = _objectWithoutProperties$2(_ref1577, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1577 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1577.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1577, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.39 16.08l-6.69-2.87-2.54-4.34-.08-.12A2 2 0 0 0 18.52 8h-8a2 2 0 0 0-1.67.89L5.46 14H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7a1 1 0 0 0-.61-.92zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4v-7h2a1 1 0 0 0 .83-.45L10.54 10h8l2.63 4.5a1 1 0 0 0 .47.42L28 17.66z'
  }));
});
Taxi20.displayName = 'Taxi20';
Taxi20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Taxi20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Temperature32 = React.forwardRef(function (_ref1578, ref) {
  var className = _ref1578.className,
      children = _ref1578.children,
      style = _ref1578.style,
      tabIndex = _ref1578.tabIndex,
      rest = _objectWithoutProperties$2(_ref1578, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1578 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1578.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1578, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 17.26V6a4 4 0 0 0-8 0v11.26a7 7 0 1 0 8 0zM9 4a2 2 0 0 1 2 2v7H7V6a2 2 0 0 1 2-2zm0 24a5 5 0 0 1-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 0 1 9 28zM20 4h10v2H20zm0 6h7v2h-7zm0 6h10v2H20zm0 6h7v2h-7z'
  }));
});
Temperature32.displayName = 'Temperature32';
Temperature32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Temperature32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Temperature24 = React.forwardRef(function (_ref1579, ref) {
  var className = _ref1579.className,
      children = _ref1579.children,
      style = _ref1579.style,
      tabIndex = _ref1579.tabIndex,
      rest = _objectWithoutProperties$2(_ref1579, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1579 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1579.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1579, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 17.26V6a4 4 0 0 0-8 0v11.26a7 7 0 1 0 8 0zM9 4a2 2 0 0 1 2 2v7H7V6a2 2 0 0 1 2-2zm0 24a5 5 0 0 1-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 0 1 9 28zM20 4h10v2H20zm0 6h7v2h-7zm0 6h10v2H20zm0 6h7v2h-7z'
  }));
});
Temperature24.displayName = 'Temperature24';
Temperature24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Temperature24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Temperature20 = React.forwardRef(function (_ref1580, ref) {
  var className = _ref1580.className,
      children = _ref1580.children,
      style = _ref1580.style,
      tabIndex = _ref1580.tabIndex,
      rest = _objectWithoutProperties$2(_ref1580, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1580 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1580.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1580, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 17.26V6a4 4 0 0 0-8 0v11.26a7 7 0 1 0 8 0zM9 4a2 2 0 0 1 2 2v7H7V6a2 2 0 0 1 2-2zm0 24a5 5 0 0 1-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 0 1 9 28zM20 4h10v2H20zm0 6h7v2h-7zm0 6h10v2H20zm0 6h7v2h-7z'
  }));
});
Temperature20.displayName = 'Temperature20';
Temperature20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Temperature20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Template32 = React.forwardRef(function (_ref1581, ref) {
  var className = _ref1581.className,
      children = _ref1581.children,
      style = _ref1581.style,
      tabIndex = _ref1581.tabIndex,
      rest = _objectWithoutProperties$2(_ref1581, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1581 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1581.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1581, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6v4H6V6h20m0-2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM10 16v10H6V16h4m0-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zm16 2v10H16V16h10m0-2H16a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2z'
  }));
});
Template32.displayName = 'Template32';
Template32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Template32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Template24 = React.forwardRef(function (_ref1582, ref) {
  var className = _ref1582.className,
      children = _ref1582.children,
      style = _ref1582.style,
      tabIndex = _ref1582.tabIndex,
      rest = _objectWithoutProperties$2(_ref1582, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1582 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1582.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1582, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6v4H6V6h20m0-2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM10 16v10H6V16h4m0-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zm16 2v10H16V16h10m0-2H16a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2z'
  }));
});
Template24.displayName = 'Template24';
Template24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Template24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Template20 = React.forwardRef(function (_ref1583, ref) {
  var className = _ref1583.className,
      children = _ref1583.children,
      style = _ref1583.style,
      tabIndex = _ref1583.tabIndex,
      rest = _objectWithoutProperties$2(_ref1583, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1583 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1583.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1583, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6v4H6V6h20m0-2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM10 16v10H6V16h4m0-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zm16 2v10H16V16h10m0-2H16a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2z'
  }));
});
Template20.displayName = 'Template20';
Template20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Template20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Terminal32 = React.forwardRef(function (_ref1584, ref) {
  var className = _ref1584.className,
      children = _ref1584.children,
      style = _ref1584.style,
      tabIndex = _ref1584.tabIndex,
      rest = _objectWithoutProperties$2(_ref1584, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1584 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1584.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1584, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4.01H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-20a2 2 0 0 0-2-2zm0 2v4H6v-4zm-20 20v-14h20v14z'
  }), React.createElement('path', {
    d: 'M10.76 16.18l2.82 2.83-2.82 2.83 1.41 1.41 4.24-4.24-4.24-4.24-1.41 1.41z'
  }));
});
Terminal32.displayName = 'Terminal32';
Terminal32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Terminal32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Terminal24 = React.forwardRef(function (_ref1585, ref) {
  var className = _ref1585.className,
      children = _ref1585.children,
      style = _ref1585.style,
      tabIndex = _ref1585.tabIndex,
      rest = _objectWithoutProperties$2(_ref1585, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1585 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1585.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1585, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4.01H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-20a2 2 0 0 0-2-2zm0 2v4H6v-4zm-20 20v-14h20v14z'
  }), React.createElement('path', {
    d: 'M10.76 16.18l2.82 2.83-2.82 2.83 1.41 1.41 4.24-4.24-4.24-4.24-1.41 1.41z'
  }));
});
Terminal24.displayName = 'Terminal24';
Terminal24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Terminal24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Terminal20 = React.forwardRef(function (_ref1586, ref) {
  var className = _ref1586.className,
      children = _ref1586.children,
      style = _ref1586.style,
      tabIndex = _ref1586.tabIndex,
      rest = _objectWithoutProperties$2(_ref1586, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1586 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1586.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1586, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 4.01H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-20a2 2 0 0 0-2-2zm0 2v4H6v-4zm-20 20v-14h20v14z'
  }), React.createElement('path', {
    d: 'M10.76 16.18l2.82 2.83-2.82 2.83 1.41 1.41 4.24-4.24-4.24-4.24-1.41 1.41z'
  }));
});
Terminal20.displayName = 'Terminal20';
Terminal20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Terminal20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignCenter32 = React.forwardRef(function (_ref1587, ref) {
  var className = _ref1587.className,
      children = _ref1587.children,
      style = _ref1587.style,
      tabIndex = _ref1587.tabIndex,
      rest = _objectWithoutProperties$2(_ref1587, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1587 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1587.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1587, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h20v2H6zm4 6h12v2H10zm-4 6h20v2H6zm4 6h12v2H10z'
  }));
});
TextAlignCenter32.displayName = 'TextAlignCenter32';
TextAlignCenter32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignCenter32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignCenter24 = React.forwardRef(function (_ref1588, ref) {
  var className = _ref1588.className,
      children = _ref1588.children,
      style = _ref1588.style,
      tabIndex = _ref1588.tabIndex,
      rest = _objectWithoutProperties$2(_ref1588, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1588 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1588.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1588, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h20v2H6zm4 6h12v2H10zm-4 6h20v2H6zm4 6h12v2H10z'
  }));
});
TextAlignCenter24.displayName = 'TextAlignCenter24';
TextAlignCenter24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignCenter24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignCenter20 = React.forwardRef(function (_ref1589, ref) {
  var className = _ref1589.className,
      children = _ref1589.children,
      style = _ref1589.style,
      tabIndex = _ref1589.tabIndex,
      rest = _objectWithoutProperties$2(_ref1589, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1589 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1589.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1589, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h20v2H6zm4 6h12v2H10zm-4 6h20v2H6zm4 6h12v2H10z'
  }));
});
TextAlignCenter20.displayName = 'TextAlignCenter20';
TextAlignCenter20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignCenter20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignLeft32 = React.forwardRef(function (_ref1590, ref) {
  var className = _ref1590.className,
      children = _ref1590.children,
      style = _ref1590.style,
      tabIndex = _ref1590.tabIndex,
      rest = _objectWithoutProperties$2(_ref1590, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1590 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1590.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1590, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 6h14v2H12zm0 6h10v2H12zm0 6h14v2H12zm0 6h10v2H12zM6 4h2v24H6z'
  }));
});
TextAlignLeft32.displayName = 'TextAlignLeft32';
TextAlignLeft32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignLeft32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignLeft24 = React.forwardRef(function (_ref1591, ref) {
  var className = _ref1591.className,
      children = _ref1591.children,
      style = _ref1591.style,
      tabIndex = _ref1591.tabIndex,
      rest = _objectWithoutProperties$2(_ref1591, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1591 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1591.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1591, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 6h14v2H12zm0 6h10v2H12zm0 6h14v2H12zm0 6h10v2H12zM6 4h2v24H6z'
  }));
});
TextAlignLeft24.displayName = 'TextAlignLeft24';
TextAlignLeft24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignLeft24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignLeft20 = React.forwardRef(function (_ref1592, ref) {
  var className = _ref1592.className,
      children = _ref1592.children,
      style = _ref1592.style,
      tabIndex = _ref1592.tabIndex,
      rest = _objectWithoutProperties$2(_ref1592, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1592 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1592.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1592, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 6h14v2H12zm0 6h10v2H12zm0 6h14v2H12zm0 6h10v2H12zM6 4h2v24H6z'
  }));
});
TextAlignLeft20.displayName = 'TextAlignLeft20';
TextAlignLeft20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignLeft20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignRight32 = React.forwardRef(function (_ref1593, ref) {
  var className = _ref1593.className,
      children = _ref1593.children,
      style = _ref1593.style,
      tabIndex = _ref1593.tabIndex,
      rest = _objectWithoutProperties$2(_ref1593, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1593 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1593.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1593, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h14v2H6zm4 6h10v2H10zm-4 6h14v2H6zm4 6h10v2H10zM24 4h2v24h-2z'
  }));
});
TextAlignRight32.displayName = 'TextAlignRight32';
TextAlignRight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignRight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignRight24 = React.forwardRef(function (_ref1594, ref) {
  var className = _ref1594.className,
      children = _ref1594.children,
      style = _ref1594.style,
      tabIndex = _ref1594.tabIndex,
      rest = _objectWithoutProperties$2(_ref1594, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1594 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1594.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1594, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h14v2H6zm4 6h10v2H10zm-4 6h14v2H6zm4 6h10v2H10zM24 4h2v24h-2z'
  }));
});
TextAlignRight24.displayName = 'TextAlignRight24';
TextAlignRight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignRight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAlignRight20 = React.forwardRef(function (_ref1595, ref) {
  var className = _ref1595.className,
      children = _ref1595.children,
      style = _ref1595.style,
      tabIndex = _ref1595.tabIndex,
      rest = _objectWithoutProperties$2(_ref1595, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1595 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1595.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1595, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 6h14v2H6zm4 6h10v2H10zm-4 6h14v2H6zm4 6h10v2H10zM24 4h2v24h-2z'
  }));
});
TextAlignRight20.displayName = 'TextAlignRight20';
TextAlignRight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAlignRight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAllCaps32 = React.forwardRef(function (_ref1596, ref) {
  var className = _ref1596.className,
      children = _ref1596.children,
      style = _ref1596.style,
      tabIndex = _ref1596.tabIndex,
      rest = _objectWithoutProperties$2(_ref1596, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1596 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1596.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1596, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M1 8v2h6v14h2V10h6V8H1zm16 0v2h6v14h2V10h6V8H17z'
  }));
});
TextAllCaps32.displayName = 'TextAllCaps32';
TextAllCaps32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAllCaps32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAllCaps24 = React.forwardRef(function (_ref1597, ref) {
  var className = _ref1597.className,
      children = _ref1597.children,
      style = _ref1597.style,
      tabIndex = _ref1597.tabIndex,
      rest = _objectWithoutProperties$2(_ref1597, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1597 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1597.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1597, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M1 8v2h6v14h2V10h6V8H1zm16 0v2h6v14h2V10h6V8H17z'
  }));
});
TextAllCaps24.displayName = 'TextAllCaps24';
TextAllCaps24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAllCaps24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextAllCaps20 = React.forwardRef(function (_ref1598, ref) {
  var className = _ref1598.className,
      children = _ref1598.children,
      style = _ref1598.style,
      tabIndex = _ref1598.tabIndex,
      rest = _objectWithoutProperties$2(_ref1598, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1598 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1598.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1598, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M1 8v2h6v14h2V10h6V8H1zm16 0v2h6v14h2V10h6V8H17z'
  }));
});
TextAllCaps20.displayName = 'TextAllCaps20';
TextAllCaps20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextAllCaps20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextBold32 = React.forwardRef(function (_ref1599, ref) {
  var className = _ref1599.className,
      children = _ref1599.children,
      style = _ref1599.style,
      tabIndex = _ref1599.tabIndex,
      rest = _objectWithoutProperties$2(_ref1599, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1599 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1599.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1599, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18.25 25H9V7h8.5a5.25 5.25 0 0 1 4 8.65A5.25 5.25 0 0 1 18.25 25zM12 22h6.23a2.25 2.25 0 1 0 0-4.5H12zm0-7.5h5.5a2.25 2.25 0 1 0 0-4.5H12z'
  }));
});
TextBold32.displayName = 'TextBold32';
TextBold32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextBold32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextBold24 = React.forwardRef(function (_ref1600, ref) {
  var className = _ref1600.className,
      children = _ref1600.children,
      style = _ref1600.style,
      tabIndex = _ref1600.tabIndex,
      rest = _objectWithoutProperties$2(_ref1600, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1600 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1600.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1600, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18.25 25H9V7h8.5a5.25 5.25 0 0 1 4 8.65A5.25 5.25 0 0 1 18.25 25zM12 22h6.23a2.25 2.25 0 1 0 0-4.5H12zm0-7.5h5.5a2.25 2.25 0 1 0 0-4.5H12z'
  }));
});
TextBold24.displayName = 'TextBold24';
TextBold24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextBold24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextBold20 = React.forwardRef(function (_ref1601, ref) {
  var className = _ref1601.className,
      children = _ref1601.children,
      style = _ref1601.style,
      tabIndex = _ref1601.tabIndex,
      rest = _objectWithoutProperties$2(_ref1601, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1601 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1601.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1601, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18.25 25H9V7h8.5a5.25 5.25 0 0 1 4 8.65A5.25 5.25 0 0 1 18.25 25zM12 22h6.23a2.25 2.25 0 1 0 0-4.5H12zm0-7.5h5.5a2.25 2.25 0 1 0 0-4.5H12z'
  }));
});
TextBold20.displayName = 'TextBold20';
TextBold20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextBold20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextColor32 = React.forwardRef(function (_ref1602, ref) {
  var className = _ref1602.className,
      children = _ref1602.children,
      style = _ref1602.style,
      tabIndex = _ref1602.tabIndex,
      rest = _objectWithoutProperties$2(_ref1602, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1602 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1602.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1602, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 21h2L17 4h-2L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24h20v4H6z'
  }));
});
TextColor32.displayName = 'TextColor32';
TextColor32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextColor32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextColor24 = React.forwardRef(function (_ref1603, ref) {
  var className = _ref1603.className,
      children = _ref1603.children,
      style = _ref1603.style,
      tabIndex = _ref1603.tabIndex,
      rest = _objectWithoutProperties$2(_ref1603, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1603 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1603.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1603, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 21h2L17 4h-2L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24h20v4H6z'
  }));
});
TextColor24.displayName = 'TextColor24';
TextColor24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextColor24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextColor20 = React.forwardRef(function (_ref1604, ref) {
  var className = _ref1604.className,
      children = _ref1604.children,
      style = _ref1604.style,
      tabIndex = _ref1604.tabIndex,
      rest = _objectWithoutProperties$2(_ref1604, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1604 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1604.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1604, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 21h2L17 4h-2L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24h20v4H6z'
  }));
});
TextColor20.displayName = 'TextColor20';
TextColor20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextColor20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextCreation32 = React.forwardRef(function (_ref1605, ref) {
  var className = _ref1605.className,
      children = _ref1605.children,
      style = _ref1605.style,
      tabIndex = _ref1605.tabIndex,
      rest = _objectWithoutProperties$2(_ref1605, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1605 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1605.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1605, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 22.14V9.86A4 4 0 1 0 22.14 5H9.86A4 4 0 1 0 5 9.86v12.28A4 4 0 1 0 9.86 27h12.28A4 4 0 1 0 27 22.14zM26 4a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm2 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm16.14-3H9.86A4 4 0 0 0 7 22.14V9.86A4 4 0 0 0 9.86 7h12.28A4 4 0 0 0 25 9.86v12.28A4 4 0 0 0 22.14 25zM26 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M21 11H11v2h4v9h2v-9h4v-2z'
  }));
});
TextCreation32.displayName = 'TextCreation32';
TextCreation32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextCreation32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextCreation24 = React.forwardRef(function (_ref1606, ref) {
  var className = _ref1606.className,
      children = _ref1606.children,
      style = _ref1606.style,
      tabIndex = _ref1606.tabIndex,
      rest = _objectWithoutProperties$2(_ref1606, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1606 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1606.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1606, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 22.14V9.86A4 4 0 1 0 22.14 5H9.86A4 4 0 1 0 5 9.86v12.28A4 4 0 1 0 9.86 27h12.28A4 4 0 1 0 27 22.14zM26 4a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm2 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm16.14-3H9.86A4 4 0 0 0 7 22.14V9.86A4 4 0 0 0 9.86 7h12.28A4 4 0 0 0 25 9.86v12.28A4 4 0 0 0 22.14 25zM26 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M21 11H11v2h4v9h2v-9h4v-2z'
  }));
});
TextCreation24.displayName = 'TextCreation24';
TextCreation24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextCreation24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextCreation20 = React.forwardRef(function (_ref1607, ref) {
  var className = _ref1607.className,
      children = _ref1607.children,
      style = _ref1607.style,
      tabIndex = _ref1607.tabIndex,
      rest = _objectWithoutProperties$2(_ref1607, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1607 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1607.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1607, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 22.14V9.86A4 4 0 1 0 22.14 5H9.86A4 4 0 1 0 5 9.86v12.28A4 4 0 1 0 9.86 27h12.28A4 4 0 1 0 27 22.14zM26 4a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm2 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm16.14-3H9.86A4 4 0 0 0 7 22.14V9.86A4 4 0 0 0 9.86 7h12.28A4 4 0 0 0 25 9.86v12.28A4 4 0 0 0 22.14 25zM26 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M21 11H11v2h4v9h2v-9h4v-2z'
  }));
});
TextCreation20.displayName = 'TextCreation20';
TextCreation20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextCreation20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextFill32 = React.forwardRef(function (_ref1608, ref) {
  var className = _ref1608.className,
      children = _ref1608.children,
      style = _ref1608.style,
      tabIndex = _ref1608.tabIndex,
      rest = _objectWithoutProperties$2(_ref1608, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1608 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1608.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1608, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v4H4z'
  }), React.createElement('path', {
    d: 'M26 14.54a1 1 0 0 0-.25-.69l-8.58-9.52A1.09 1.09 0 0 0 17 4.2V2h-2v3L4.32 14.74a1 1 0 0 0-.06 1.41l8.57 9.52a1 1 0 0 0 .69.33h.05a1 1 0 0 0 .68-.26L24 16.8V21a1 1 0 0 0 2 0v-6.46zm-12.35 9l-7.23-8L15 7.67V12h2V7.13l6.59 7.33z'
  }));
});
TextFill32.displayName = 'TextFill32';
TextFill32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextFill32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextFill24 = React.forwardRef(function (_ref1609, ref) {
  var className = _ref1609.className,
      children = _ref1609.children,
      style = _ref1609.style,
      tabIndex = _ref1609.tabIndex,
      rest = _objectWithoutProperties$2(_ref1609, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1609 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1609.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1609, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v4H4z'
  }), React.createElement('path', {
    d: 'M26 14.54a1 1 0 0 0-.25-.69l-8.58-9.52A1.09 1.09 0 0 0 17 4.2V2h-2v3L4.32 14.74a1 1 0 0 0-.06 1.41l8.57 9.52a1 1 0 0 0 .69.33h.05a1 1 0 0 0 .68-.26L24 16.8V21a1 1 0 0 0 2 0v-6.46zm-12.35 9l-7.23-8L15 7.67V12h2V7.13l6.59 7.33z'
  }));
});
TextFill24.displayName = 'TextFill24';
TextFill24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextFill24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextFill20 = React.forwardRef(function (_ref1610, ref) {
  var className = _ref1610.className,
      children = _ref1610.children,
      style = _ref1610.style,
      tabIndex = _ref1610.tabIndex,
      rest = _objectWithoutProperties$2(_ref1610, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1610 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1610.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1610, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v4H4z'
  }), React.createElement('path', {
    d: 'M26 14.54a1 1 0 0 0-.25-.69l-8.58-9.52A1.09 1.09 0 0 0 17 4.2V2h-2v3L4.32 14.74a1 1 0 0 0-.06 1.41l8.57 9.52a1 1 0 0 0 .69.33h.05a1 1 0 0 0 .68-.26L24 16.8V21a1 1 0 0 0 2 0v-6.46zm-12.35 9l-7.23-8L15 7.67V12h2V7.13l6.59 7.33z'
  }));
});
TextFill20.displayName = 'TextFill20';
TextFill20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextFill20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextHighlight32 = React.forwardRef(function (_ref1611, ref) {
  var className = _ref1611.className,
      children = _ref1611.children,
      style = _ref1611.style,
      tabIndex = _ref1611.tabIndex,
      rest = _objectWithoutProperties$2(_ref1611, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1611 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1611.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1611, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 15H5a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5V5a1 1 0 0 0-1-1H3V2h6a3 3 0 0 1 3 3zM5 9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5V9zm15 14v2a1 1 0 0 0 1 1h5v-4h-5a1 1 0 0 0-1 1z'
  }), React.createElement('path', {
    d: 'M2 30h28V2zm26-2h-7a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5v-2a1 1 0 0 0-1-1h-6v-2h6a3 3 0 0 1 3 3z'
  }));
});
TextHighlight32.displayName = 'TextHighlight32';
TextHighlight32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextHighlight32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextHighlight24 = React.forwardRef(function (_ref1612, ref) {
  var className = _ref1612.className,
      children = _ref1612.children,
      style = _ref1612.style,
      tabIndex = _ref1612.tabIndex,
      rest = _objectWithoutProperties$2(_ref1612, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1612 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1612.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1612, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 15H5a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5V5a1 1 0 0 0-1-1H3V2h6a3 3 0 0 1 3 3zM5 9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5V9zm15 14v2a1 1 0 0 0 1 1h5v-4h-5a1 1 0 0 0-1 1z'
  }), React.createElement('path', {
    d: 'M2 30h28V2zm26-2h-7a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5v-2a1 1 0 0 0-1-1h-6v-2h6a3 3 0 0 1 3 3z'
  }));
});
TextHighlight24.displayName = 'TextHighlight24';
TextHighlight24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextHighlight24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextHighlight20 = React.forwardRef(function (_ref1613, ref) {
  var className = _ref1613.className,
      children = _ref1613.children,
      style = _ref1613.style,
      tabIndex = _ref1613.tabIndex,
      rest = _objectWithoutProperties$2(_ref1613, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1613 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1613.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1613, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 15H5a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5V5a1 1 0 0 0-1-1H3V2h6a3 3 0 0 1 3 3zM5 9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5V9zm15 14v2a1 1 0 0 0 1 1h5v-4h-5a1 1 0 0 0-1 1z'
  }), React.createElement('path', {
    d: 'M2 30h28V2zm26-2h-7a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5v-2a1 1 0 0 0-1-1h-6v-2h6a3 3 0 0 1 3 3z'
  }));
});
TextHighlight20.displayName = 'TextHighlight20';
TextHighlight20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextHighlight20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndentLess32 = React.forwardRef(function (_ref1614, ref) {
  var className = _ref1614.className,
      children = _ref1614.children,
      style = _ref1614.style,
      tabIndex = _ref1614.tabIndex,
      rest = _objectWithoutProperties$2(_ref1614, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1614 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1614.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1614, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 6h10v2H2zm3 6h7v2H5zm-3 6h10v2H2zm3 6h7v2H5zM16 4h2v24h-2zm12.15 19.5l1.41-1.38L23.27 16l6.29-6.12-1.41-1.38-7.71 7.5 7.71 7.5z'
  }));
});
TextIndentLess32.displayName = 'TextIndentLess32';
TextIndentLess32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndentLess32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndentLess24 = React.forwardRef(function (_ref1615, ref) {
  var className = _ref1615.className,
      children = _ref1615.children,
      style = _ref1615.style,
      tabIndex = _ref1615.tabIndex,
      rest = _objectWithoutProperties$2(_ref1615, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1615 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1615.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1615, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 6h10v2H2zm3 6h7v2H5zm-3 6h10v2H2zm3 6h7v2H5zM16 4h2v24h-2zm12.15 19.5l1.41-1.38L23.27 16l6.29-6.12-1.41-1.38-7.71 7.5 7.71 7.5z'
  }));
});
TextIndentLess24.displayName = 'TextIndentLess24';
TextIndentLess24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndentLess24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndentLess20 = React.forwardRef(function (_ref1616, ref) {
  var className = _ref1616.className,
      children = _ref1616.children,
      style = _ref1616.style,
      tabIndex = _ref1616.tabIndex,
      rest = _objectWithoutProperties$2(_ref1616, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1616 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1616.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1616, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M2 6h10v2H2zm3 6h7v2H5zm-3 6h10v2H2zm3 6h7v2H5zM16 4h2v24h-2zm12.15 19.5l1.41-1.38L23.27 16l6.29-6.12-1.41-1.38-7.71 7.5 7.71 7.5z'
  }));
});
TextIndentLess20.displayName = 'TextIndentLess20';
TextIndentLess20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndentLess20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndentMore32 = React.forwardRef(function (_ref1617, ref) {
  var className = _ref1617.className,
      children = _ref1617.children,
      style = _ref1617.style,
      tabIndex = _ref1617.tabIndex,
      rest = _objectWithoutProperties$2(_ref1617, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1617 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1617.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1617, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 6h10v2H20zm0 6h7v2h-7zm0 6h10v2H20zm0 6h7v2h-7zM14 4h2v24h-2zM3.85 22.5l-1.41-1.38L8.73 15 2.44 8.88 3.85 7.5l7.71 7.5-7.71 7.5z'
  }));
});
TextIndentMore32.displayName = 'TextIndentMore32';
TextIndentMore32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndentMore32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndentMore24 = React.forwardRef(function (_ref1618, ref) {
  var className = _ref1618.className,
      children = _ref1618.children,
      style = _ref1618.style,
      tabIndex = _ref1618.tabIndex,
      rest = _objectWithoutProperties$2(_ref1618, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1618 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1618.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1618, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 6h10v2H20zm0 6h7v2h-7zm0 6h10v2H20zm0 6h7v2h-7zM14 4h2v24h-2zM3.85 22.5l-1.41-1.38L8.73 15 2.44 8.88 3.85 7.5l7.71 7.5-7.71 7.5z'
  }));
});
TextIndentMore24.displayName = 'TextIndentMore24';
TextIndentMore24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndentMore24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndentMore20 = React.forwardRef(function (_ref1619, ref) {
  var className = _ref1619.className,
      children = _ref1619.children,
      style = _ref1619.style,
      tabIndex = _ref1619.tabIndex,
      rest = _objectWithoutProperties$2(_ref1619, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1619 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1619.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1619, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 6h10v2H20zm0 6h7v2h-7zm0 6h10v2H20zm0 6h7v2h-7zM14 4h2v24h-2zM3.85 22.5l-1.41-1.38L8.73 15 2.44 8.88 3.85 7.5l7.71 7.5-7.71 7.5z'
  }));
});
TextIndentMore20.displayName = 'TextIndentMore20';
TextIndentMore20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndentMore20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndent32 = React.forwardRef(function (_ref1620, ref) {
  var className = _ref1620.className,
      children = _ref1620.children,
      style = _ref1620.style,
      tabIndex = _ref1620.tabIndex,
      rest = _objectWithoutProperties$2(_ref1620, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1620 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1620.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1620, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 6h14v2H14zm0 6h14v2H14zm-7 6h21v2H7zm0 6h21v2H7zM4 13.59L7.29 10 4 6.41 5.42 5l4.62 5-4.62 5L4 13.59z'
  }));
});
TextIndent32.displayName = 'TextIndent32';
TextIndent32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndent32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndent24 = React.forwardRef(function (_ref1621, ref) {
  var className = _ref1621.className,
      children = _ref1621.children,
      style = _ref1621.style,
      tabIndex = _ref1621.tabIndex,
      rest = _objectWithoutProperties$2(_ref1621, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1621 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1621.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1621, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 6h14v2H14zm0 6h14v2H14zm-7 6h21v2H7zm0 6h21v2H7zM4 13.59L7.29 10 4 6.41 5.42 5l4.62 5-4.62 5L4 13.59z'
  }));
});
TextIndent24.displayName = 'TextIndent24';
TextIndent24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndent24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextIndent20 = React.forwardRef(function (_ref1622, ref) {
  var className = _ref1622.className,
      children = _ref1622.children,
      style = _ref1622.style,
      tabIndex = _ref1622.tabIndex,
      rest = _objectWithoutProperties$2(_ref1622, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1622 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1622.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1622, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 6h14v2H14zm0 6h14v2H14zm-7 6h21v2H7zm0 6h21v2H7zM4 13.59L7.29 10 4 6.41 5.42 5l4.62 5-4.62 5L4 13.59z'
  }));
});
TextIndent20.displayName = 'TextIndent20';
TextIndent20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextIndent20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextItalic32 = React.forwardRef(function (_ref1623, ref) {
  var className = _ref1623.className,
      children = _ref1623.children,
      style = _ref1623.style,
      tabIndex = _ref1623.tabIndex,
      rest = _objectWithoutProperties$2(_ref1623, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1623 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1623.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1623, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 9V7H12v2h5.14l-4.37 14H7v2h13v-2h-5.14l4.37-14H25z'
  }));
});
TextItalic32.displayName = 'TextItalic32';
TextItalic32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextItalic32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextItalic24 = React.forwardRef(function (_ref1624, ref) {
  var className = _ref1624.className,
      children = _ref1624.children,
      style = _ref1624.style,
      tabIndex = _ref1624.tabIndex,
      rest = _objectWithoutProperties$2(_ref1624, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1624 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1624.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1624, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 9V7H12v2h5.14l-4.37 14H7v2h13v-2h-5.14l4.37-14H25z'
  }));
});
TextItalic24.displayName = 'TextItalic24';
TextItalic24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextItalic24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextItalic20 = React.forwardRef(function (_ref1625, ref) {
  var className = _ref1625.className,
      children = _ref1625.children,
      style = _ref1625.style,
      tabIndex = _ref1625.tabIndex,
      rest = _objectWithoutProperties$2(_ref1625, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1625 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1625.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1625, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25 9V7H12v2h5.14l-4.37 14H7v2h13v-2h-5.14l4.37-14H25z'
  }));
});
TextItalic20.displayName = 'TextItalic20';
TextItalic20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextItalic20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextKerning32 = React.forwardRef(function (_ref1626, ref) {
  var className = _ref1626.className,
      children = _ref1626.children,
      style = _ref1626.style,
      tabIndex = _ref1626.tabIndex,
      rest = _objectWithoutProperties$2(_ref1626, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1626 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1626.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1626, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 24H18.83l2.29-2.29-1.41-1.42L15 25l4.71 4.71 1.41-1.42L18.83 26H30v-2zm-16-3l6-17h-2l-6 17h2zM13 4L9 16 5 4H3l5 14h2l5-14h-2zm15 14h2L25 4h-2l-5 14h2l1-3h6zm-6.33-5L24 6l2.33 7z'
  }));
});
TextKerning32.displayName = 'TextKerning32';
TextKerning32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextKerning32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextKerning24 = React.forwardRef(function (_ref1627, ref) {
  var className = _ref1627.className,
      children = _ref1627.children,
      style = _ref1627.style,
      tabIndex = _ref1627.tabIndex,
      rest = _objectWithoutProperties$2(_ref1627, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1627 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1627.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1627, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 24H18.83l2.29-2.29-1.41-1.42L15 25l4.71 4.71 1.41-1.42L18.83 26H30v-2zm-16-3l6-17h-2l-6 17h2zM13 4L9 16 5 4H3l5 14h2l5-14h-2zm15 14h2L25 4h-2l-5 14h2l1-3h6zm-6.33-5L24 6l2.33 7z'
  }));
});
TextKerning24.displayName = 'TextKerning24';
TextKerning24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextKerning24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextKerning20 = React.forwardRef(function (_ref1628, ref) {
  var className = _ref1628.className,
      children = _ref1628.children,
      style = _ref1628.style,
      tabIndex = _ref1628.tabIndex,
      rest = _objectWithoutProperties$2(_ref1628, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1628 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1628.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1628, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 24H18.83l2.29-2.29-1.41-1.42L15 25l4.71 4.71 1.41-1.42L18.83 26H30v-2zm-16-3l6-17h-2l-6 17h2zM13 4L9 16 5 4H3l5 14h2l5-14h-2zm15 14h2L25 4h-2l-5 14h2l1-3h6zm-6.33-5L24 6l2.33 7z'
  }));
});
TextKerning20.displayName = 'TextKerning20';
TextKerning20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextKerning20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextLeading32 = React.forwardRef(function (_ref1629, ref) {
  var className = _ref1629.className,
      children = _ref1629.children,
      style = _ref1629.style,
      tabIndex = _ref1629.tabIndex,
      rest = _objectWithoutProperties$2(_ref1629, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1629 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1629.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1629, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 13h16v2H14zm1 15h15v2H15zm10.85-1H28l-4.36-10h-2.28L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zm5.1-11H28L23.64 2h-2.28L17 12h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 8zM6 15.83l2.58 2.58L10 17l-4-4-4 4 1.41 1.42L6 15.83zm0 11.34l-2.58-2.58L2 26l4 4 4-4-1.41-1.42L6 27.17z'
  }));
});
TextLeading32.displayName = 'TextLeading32';
TextLeading32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextLeading32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextLeading24 = React.forwardRef(function (_ref1630, ref) {
  var className = _ref1630.className,
      children = _ref1630.children,
      style = _ref1630.style,
      tabIndex = _ref1630.tabIndex,
      rest = _objectWithoutProperties$2(_ref1630, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1630 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1630.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1630, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 13h16v2H14zm1 15h15v2H15zm10.85-1H28l-4.36-10h-2.28L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zm5.1-11H28L23.64 2h-2.28L17 12h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 8zM6 15.83l2.58 2.58L10 17l-4-4-4 4 1.41 1.42L6 15.83zm0 11.34l-2.58-2.58L2 26l4 4 4-4-1.41-1.42L6 27.17z'
  }));
});
TextLeading24.displayName = 'TextLeading24';
TextLeading24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextLeading24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextLeading20 = React.forwardRef(function (_ref1631, ref) {
  var className = _ref1631.className,
      children = _ref1631.children,
      style = _ref1631.style,
      tabIndex = _ref1631.tabIndex,
      rest = _objectWithoutProperties$2(_ref1631, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1631 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1631.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1631, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 13h16v2H14zm1 15h15v2H15zm10.85-1H28l-4.36-10h-2.28L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zm5.1-11H28L23.64 2h-2.28L17 12h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 8zM6 15.83l2.58 2.58L10 17l-4-4-4 4 1.41 1.42L6 15.83zm0 11.34l-2.58-2.58L2 26l4 4 4-4-1.41-1.42L6 27.17z'
  }));
});
TextLeading20.displayName = 'TextLeading20';
TextLeading20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextLeading20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextLineSpacing32 = React.forwardRef(function (_ref1632, ref) {
  var className = _ref1632.className,
      children = _ref1632.children,
      style = _ref1632.style,
      tabIndex = _ref1632.tabIndex,
      rest = _objectWithoutProperties$2(_ref1632, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1632 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1632.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1632, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 6h13v2H17zm0 6h10v2H17zm0 6h13v2H17zm0 6h10v2H17zm-5.41-10.59L8 9.83l-3.59 3.59L3 12l5-5 5 5-1.41 1.41zm0 5.18L8 22.17l-3.59-3.59L3 20l5 5 5-5-1.41-1.41z'
  }));
});
TextLineSpacing32.displayName = 'TextLineSpacing32';
TextLineSpacing32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextLineSpacing32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextLineSpacing24 = React.forwardRef(function (_ref1633, ref) {
  var className = _ref1633.className,
      children = _ref1633.children,
      style = _ref1633.style,
      tabIndex = _ref1633.tabIndex,
      rest = _objectWithoutProperties$2(_ref1633, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1633 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1633.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1633, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 6h13v2H17zm0 6h10v2H17zm0 6h13v2H17zm0 6h10v2H17zm-5.41-10.59L8 9.83l-3.59 3.59L3 12l5-5 5 5-1.41 1.41zm0 5.18L8 22.17l-3.59-3.59L3 20l5 5 5-5-1.41-1.41z'
  }));
});
TextLineSpacing24.displayName = 'TextLineSpacing24';
TextLineSpacing24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextLineSpacing24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextLineSpacing20 = React.forwardRef(function (_ref1634, ref) {
  var className = _ref1634.className,
      children = _ref1634.children,
      style = _ref1634.style,
      tabIndex = _ref1634.tabIndex,
      rest = _objectWithoutProperties$2(_ref1634, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1634 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1634.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1634, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 6h13v2H17zm0 6h10v2H17zm0 6h13v2H17zm0 6h10v2H17zm-5.41-10.59L8 9.83l-3.59 3.59L3 12l5-5 5 5-1.41 1.41zm0 5.18L8 22.17l-3.59-3.59L3 20l5 5 5-5-1.41-1.41z'
  }));
});
TextLineSpacing20.displayName = 'TextLineSpacing20';
TextLineSpacing20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextLineSpacing20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextScale32 = React.forwardRef(function (_ref1635, ref) {
  var className = _ref1635.className,
      children = _ref1635.children,
      style = _ref1635.style,
      tabIndex = _ref1635.tabIndex,
      rest = _objectWithoutProperties$2(_ref1635, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1635 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1635.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1635, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 5v3h-8v18h-3V8h-8V5h19z'
  }), React.createElement('path', {
    d: 'M7 26V14H2v-2h12v2H9v12H7z'
  }));
});
TextScale32.displayName = 'TextScale32';
TextScale32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextScale32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextScale24 = React.forwardRef(function (_ref1636, ref) {
  var className = _ref1636.className,
      children = _ref1636.children,
      style = _ref1636.style,
      tabIndex = _ref1636.tabIndex,
      rest = _objectWithoutProperties$2(_ref1636, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1636 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1636.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1636, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 5v3h-8v18h-3V8h-8V5h19z'
  }), React.createElement('path', {
    d: 'M7 26V14H2v-2h12v2H9v12H7z'
  }));
});
TextScale24.displayName = 'TextScale24';
TextScale24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextScale24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextScale20 = React.forwardRef(function (_ref1637, ref) {
  var className = _ref1637.className,
      children = _ref1637.children,
      style = _ref1637.style,
      tabIndex = _ref1637.tabIndex,
      rest = _objectWithoutProperties$2(_ref1637, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1637 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1637.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1637, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 5v3h-8v18h-3V8h-8V5h19z'
  }), React.createElement('path', {
    d: 'M7 26V14H2v-2h12v2H9v12H7z'
  }));
});
TextScale20.displayName = 'TextScale20';
TextScale20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextScale20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSelection32 = React.forwardRef(function (_ref1638, ref) {
  var className = _ref1638.className,
      children = _ref1638.children,
      style = _ref1638.style,
      tabIndex = _ref1638.tabIndex,
      rest = _objectWithoutProperties$2(_ref1638, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1638 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1638.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1638, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 27h-7a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5v-2a1 1 0 0 0-1-1h-6v-2h6a3 3 0 0 1 3 3zm-7-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v-4zM13 7h3V5h-3a4 4 0 0 0-3 1.38A4 4 0 0 0 7 5H4v2h3a2 2 0 0 1 2 2v5H5v2h4v7a2 2 0 0 1-2 2H4v2h3a4 4 0 0 0 3-1.38A4 4 0 0 0 13 27h3v-2h-3a2 2 0 0 1-2-2v-7h4v-2h-4V9a2 2 0 0 1 2-2z'
  }));
});
TextSelection32.displayName = 'TextSelection32';
TextSelection32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSelection32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSelection24 = React.forwardRef(function (_ref1639, ref) {
  var className = _ref1639.className,
      children = _ref1639.children,
      style = _ref1639.style,
      tabIndex = _ref1639.tabIndex,
      rest = _objectWithoutProperties$2(_ref1639, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1639 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1639.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1639, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 27h-7a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5v-2a1 1 0 0 0-1-1h-6v-2h6a3 3 0 0 1 3 3zm-7-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v-4zM13 7h3V5h-3a4 4 0 0 0-3 1.38A4 4 0 0 0 7 5H4v2h3a2 2 0 0 1 2 2v5H5v2h4v7a2 2 0 0 1-2 2H4v2h3a4 4 0 0 0 3-1.38A4 4 0 0 0 13 27h3v-2h-3a2 2 0 0 1-2-2v-7h4v-2h-4V9a2 2 0 0 1 2-2z'
  }));
});
TextSelection24.displayName = 'TextSelection24';
TextSelection24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSelection24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSelection20 = React.forwardRef(function (_ref1640, ref) {
  var className = _ref1640.className,
      children = _ref1640.children,
      style = _ref1640.style,
      tabIndex = _ref1640.tabIndex,
      rest = _objectWithoutProperties$2(_ref1640, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1640 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1640.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1640, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 27h-7a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h5v-2a1 1 0 0 0-1-1h-6v-2h6a3 3 0 0 1 3 3zm-7-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v-4zM13 7h3V5h-3a4 4 0 0 0-3 1.38A4 4 0 0 0 7 5H4v2h3a2 2 0 0 1 2 2v5H5v2h4v7a2 2 0 0 1-2 2H4v2h3a4 4 0 0 0 3-1.38A4 4 0 0 0 13 27h3v-2h-3a2 2 0 0 1-2-2v-7h4v-2h-4V9a2 2 0 0 1 2-2z'
  }));
});
TextSelection20.displayName = 'TextSelection20';
TextSelection20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSelection20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSmallCaps32 = React.forwardRef(function (_ref1641, ref) {
  var className = _ref1641.className,
      children = _ref1641.children,
      style = _ref1641.style,
      tabIndex = _ref1641.tabIndex,
      rest = _objectWithoutProperties$2(_ref1641, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1641 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1641.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1641, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 27V15h-5v-2h12v2h-5v12h-2z'
  }), React.createElement('path', {
    d: 'M11 27V8H2V6h20v2h-9v19h-2z'
  }));
});
TextSmallCaps32.displayName = 'TextSmallCaps32';
TextSmallCaps32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSmallCaps32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSmallCaps24 = React.forwardRef(function (_ref1642, ref) {
  var className = _ref1642.className,
      children = _ref1642.children,
      style = _ref1642.style,
      tabIndex = _ref1642.tabIndex,
      rest = _objectWithoutProperties$2(_ref1642, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1642 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1642.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1642, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 27V15h-5v-2h12v2h-5v12h-2z'
  }), React.createElement('path', {
    d: 'M11 27V8H2V6h20v2h-9v19h-2z'
  }));
});
TextSmallCaps24.displayName = 'TextSmallCaps24';
TextSmallCaps24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSmallCaps24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSmallCaps20 = React.forwardRef(function (_ref1643, ref) {
  var className = _ref1643.className,
      children = _ref1643.children,
      style = _ref1643.style,
      tabIndex = _ref1643.tabIndex,
      rest = _objectWithoutProperties$2(_ref1643, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1643 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1643.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1643, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23 27V15h-5v-2h12v2h-5v12h-2z'
  }), React.createElement('path', {
    d: 'M11 27V8H2V6h20v2h-9v19h-2z'
  }));
});
TextSmallCaps20.displayName = 'TextSmallCaps20';
TextSmallCaps20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSmallCaps20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextStrikethrough32 = React.forwardRef(function (_ref1644, ref) {
  var className = _ref1644.className,
      children = _ref1644.children,
      style = _ref1644.style,
      tabIndex = _ref1644.tabIndex,
      rest = _objectWithoutProperties$2(_ref1644, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1644 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1644.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1644, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 7V5H6v2h9v8H6v2h9v9h2v-9h9v-2h-9V7h9z'
  }));
});
TextStrikethrough32.displayName = 'TextStrikethrough32';
TextStrikethrough32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextStrikethrough32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextStrikethrough24 = React.forwardRef(function (_ref1645, ref) {
  var className = _ref1645.className,
      children = _ref1645.children,
      style = _ref1645.style,
      tabIndex = _ref1645.tabIndex,
      rest = _objectWithoutProperties$2(_ref1645, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1645 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1645.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1645, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 7V5H6v2h9v8H6v2h9v9h2v-9h9v-2h-9V7h9z'
  }));
});
TextStrikethrough24.displayName = 'TextStrikethrough24';
TextStrikethrough24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextStrikethrough24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextStrikethrough20 = React.forwardRef(function (_ref1646, ref) {
  var className = _ref1646.className,
      children = _ref1646.children,
      style = _ref1646.style,
      tabIndex = _ref1646.tabIndex,
      rest = _objectWithoutProperties$2(_ref1646, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1646 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1646.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1646, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 7V5H6v2h9v8H6v2h9v9h2v-9h9v-2h-9V7h9z'
  }));
});
TextStrikethrough20.displayName = 'TextStrikethrough20';
TextStrikethrough20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextStrikethrough20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSubscript32 = React.forwardRef(function (_ref1647, ref) {
  var className = _ref1647.className,
      children = _ref1647.children,
      style = _ref1647.style,
      tabIndex = _ref1647.tabIndex,
      rest = _objectWithoutProperties$2(_ref1647, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1647 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1647.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1647, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 25h-6v-6h4v-2h-4v-2h6v6h-4v2h4v2zM5 7v2h7v16h2V9h7V7H5z'
  }));
});
TextSubscript32.displayName = 'TextSubscript32';
TextSubscript32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSubscript32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSubscript24 = React.forwardRef(function (_ref1648, ref) {
  var className = _ref1648.className,
      children = _ref1648.children,
      style = _ref1648.style,
      tabIndex = _ref1648.tabIndex,
      rest = _objectWithoutProperties$2(_ref1648, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1648 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1648.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1648, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 25h-6v-6h4v-2h-4v-2h6v6h-4v2h4v2zM5 7v2h7v16h2V9h7V7H5z'
  }));
});
TextSubscript24.displayName = 'TextSubscript24';
TextSubscript24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSubscript24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSubscript20 = React.forwardRef(function (_ref1649, ref) {
  var className = _ref1649.className,
      children = _ref1649.children,
      style = _ref1649.style,
      tabIndex = _ref1649.tabIndex,
      rest = _objectWithoutProperties$2(_ref1649, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1649 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1649.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1649, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 25h-6v-6h4v-2h-4v-2h6v6h-4v2h4v2zM5 7v2h7v16h2V9h7V7H5z'
  }));
});
TextSubscript20.displayName = 'TextSubscript20';
TextSubscript20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSubscript20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSuperscript32 = React.forwardRef(function (_ref1650, ref) {
  var className = _ref1650.className,
      children = _ref1650.children,
      style = _ref1650.style,
      tabIndex = _ref1650.tabIndex,
      rest = _objectWithoutProperties$2(_ref1650, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1650 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1650.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1650, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 17h-6v-6h4V9h-4V7h6v6h-4v2h4v2zM4 7v2h7v16h2V9h7V7H4z'
  }));
});
TextSuperscript32.displayName = 'TextSuperscript32';
TextSuperscript32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSuperscript32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSuperscript24 = React.forwardRef(function (_ref1651, ref) {
  var className = _ref1651.className,
      children = _ref1651.children,
      style = _ref1651.style,
      tabIndex = _ref1651.tabIndex,
      rest = _objectWithoutProperties$2(_ref1651, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1651 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1651.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1651, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 17h-6v-6h4V9h-4V7h6v6h-4v2h4v2zM4 7v2h7v16h2V9h7V7H4z'
  }));
});
TextSuperscript24.displayName = 'TextSuperscript24';
TextSuperscript24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSuperscript24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextSuperscript20 = React.forwardRef(function (_ref1652, ref) {
  var className = _ref1652.className,
      children = _ref1652.children,
      style = _ref1652.style,
      tabIndex = _ref1652.tabIndex,
      rest = _objectWithoutProperties$2(_ref1652, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1652 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1652.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1652, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 17h-6v-6h4V9h-4V7h6v6h-4v2h4v2zM4 7v2h7v16h2V9h7V7H4z'
  }));
});
TextSuperscript20.displayName = 'TextSuperscript20';
TextSuperscript20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextSuperscript20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextTracking32 = React.forwardRef(function (_ref1653, ref) {
  var className = _ref1653.className,
      children = _ref1653.children,
      style = _ref1653.style,
      tabIndex = _ref1653.tabIndex,
      rest = _objectWithoutProperties$2(_ref1653, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1653 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1653.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1653, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.29 19.29l-1.41 1.42L26.17 23H5.83l2.29-2.29-1.41-1.42L2 24l4.71 4.71 1.41-1.42L5.83 25h20.34l-2.29 2.29 1.41 1.42L30 24l-4.71-4.71zM26 17h2L23 3h-2l-5 14h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3l-4 12L6 3H4l5 14h2l5-14h-2z'
  }));
});
TextTracking32.displayName = 'TextTracking32';
TextTracking32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextTracking32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextTracking24 = React.forwardRef(function (_ref1654, ref) {
  var className = _ref1654.className,
      children = _ref1654.children,
      style = _ref1654.style,
      tabIndex = _ref1654.tabIndex,
      rest = _objectWithoutProperties$2(_ref1654, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1654 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1654.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1654, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.29 19.29l-1.41 1.42L26.17 23H5.83l2.29-2.29-1.41-1.42L2 24l4.71 4.71 1.41-1.42L5.83 25h20.34l-2.29 2.29 1.41 1.42L30 24l-4.71-4.71zM26 17h2L23 3h-2l-5 14h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3l-4 12L6 3H4l5 14h2l5-14h-2z'
  }));
});
TextTracking24.displayName = 'TextTracking24';
TextTracking24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextTracking24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextTracking20 = React.forwardRef(function (_ref1655, ref) {
  var className = _ref1655.className,
      children = _ref1655.children,
      style = _ref1655.style,
      tabIndex = _ref1655.tabIndex,
      rest = _objectWithoutProperties$2(_ref1655, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1655 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1655.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1655, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.29 19.29l-1.41 1.42L26.17 23H5.83l2.29-2.29-1.41-1.42L2 24l4.71 4.71 1.41-1.42L5.83 25h20.34l-2.29 2.29 1.41 1.42L30 24l-4.71-4.71zM26 17h2L23 3h-2l-5 14h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3l-4 12L6 3H4l5 14h2l5-14h-2z'
  }));
});
TextTracking20.displayName = 'TextTracking20';
TextTracking20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextTracking20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextUnderline32 = React.forwardRef(function (_ref1656, ref) {
  var className = _ref1656.className,
      children = _ref1656.children,
      style = _ref1656.style,
      tabIndex = _ref1656.tabIndex,
      rest = _objectWithoutProperties$2(_ref1656, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1656 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1656.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1656, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm12-3a7 7 0 0 1-7-7V5h2v11a5 5 0 0 0 10 0V5h2v11a7 7 0 0 1-7 7z'
  }));
});
TextUnderline32.displayName = 'TextUnderline32';
TextUnderline32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextUnderline32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextUnderline24 = React.forwardRef(function (_ref1657, ref) {
  var className = _ref1657.className,
      children = _ref1657.children,
      style = _ref1657.style,
      tabIndex = _ref1657.tabIndex,
      rest = _objectWithoutProperties$2(_ref1657, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1657 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1657.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1657, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm12-3a7 7 0 0 1-7-7V5h2v11a5 5 0 0 0 10 0V5h2v11a7 7 0 0 1-7 7z'
  }));
});
TextUnderline24.displayName = 'TextUnderline24';
TextUnderline24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextUnderline24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextUnderline20 = React.forwardRef(function (_ref1658, ref) {
  var className = _ref1658.className,
      children = _ref1658.children,
      style = _ref1658.style,
      tabIndex = _ref1658.tabIndex,
      rest = _objectWithoutProperties$2(_ref1658, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1658 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1658.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1658, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm12-3a7 7 0 0 1-7-7V5h2v11a5 5 0 0 0 10 0V5h2v11a7 7 0 0 1-7 7z'
  }));
});
TextUnderline20.displayName = 'TextUnderline20';
TextUnderline20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextUnderline20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextWrap32 = React.forwardRef(function (_ref1659, ref) {
  var className = _ref1659.className,
      children = _ref1659.children,
      style = _ref1659.style,
      tabIndex = _ref1659.tabIndex,
      rest = _objectWithoutProperties$2(_ref1659, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1659 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1659.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1659, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 23h8v2H4zm26-3.5a5.5 5.5 0 0 0-5.48-5.5H4v2h20.5a3.5 3.5 0 0 1 0 7H19l2.41-2.59L20 19l-5 5 5 5 1.41-1.41L19 25h5.53A5.5 5.5 0 0 0 30 19.5zM4 5h24v2H4z'
  }));
});
TextWrap32.displayName = 'TextWrap32';
TextWrap32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextWrap32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextWrap24 = React.forwardRef(function (_ref1660, ref) {
  var className = _ref1660.className,
      children = _ref1660.children,
      style = _ref1660.style,
      tabIndex = _ref1660.tabIndex,
      rest = _objectWithoutProperties$2(_ref1660, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1660 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1660.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1660, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 23h8v2H4zm26-3.5a5.5 5.5 0 0 0-5.48-5.5H4v2h20.5a3.5 3.5 0 0 1 0 7H19l2.41-2.59L20 19l-5 5 5 5 1.41-1.41L19 25h5.53A5.5 5.5 0 0 0 30 19.5zM4 5h24v2H4z'
  }));
});
TextWrap24.displayName = 'TextWrap24';
TextWrap24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextWrap24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TextWrap20 = React.forwardRef(function (_ref1661, ref) {
  var className = _ref1661.className,
      children = _ref1661.children,
      style = _ref1661.style,
      tabIndex = _ref1661.tabIndex,
      rest = _objectWithoutProperties$2(_ref1661, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1661 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1661.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1661, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 23h8v2H4zm26-3.5a5.5 5.5 0 0 0-5.48-5.5H4v2h20.5a3.5 3.5 0 0 1 0 7H19l2.41-2.59L20 19l-5 5 5 5 1.41-1.41L19 25h5.53A5.5 5.5 0 0 0 30 19.5zM4 5h24v2H4z'
  }));
});
TextWrap20.displayName = 'TextWrap20';
TextWrap20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TextWrap20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Thumbnail_132 = React.forwardRef(function (_ref1662, ref) {
  var className = _ref1662.className,
      children = _ref1662.children,
      style = _ref1662.style,
      tabIndex = _ref1662.tabIndex,
      rest = _objectWithoutProperties$2(_ref1662, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1662 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1662.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1662, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 4v14h24V4z'
  }));
});
Thumbnail_132.displayName = 'Thumbnail_132';
Thumbnail_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Thumbnail_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Thumbnail_124 = React.forwardRef(function (_ref1663, ref) {
  var className = _ref1663.className,
      children = _ref1663.children,
      style = _ref1663.style,
      tabIndex = _ref1663.tabIndex,
      rest = _objectWithoutProperties$2(_ref1663, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1663 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1663.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1663, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 4v14h24V4z'
  }));
});
Thumbnail_124.displayName = 'Thumbnail_124';
Thumbnail_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Thumbnail_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Thumbnail_120 = React.forwardRef(function (_ref1664, ref) {
  var className = _ref1664.className,
      children = _ref1664.children,
      style = _ref1664.style,
      tabIndex = _ref1664.tabIndex,
      rest = _objectWithoutProperties$2(_ref1664, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1664 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1664.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1664, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm4-4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 4v14h24V4z'
  }));
});
Thumbnail_120.displayName = 'Thumbnail_120';
Thumbnail_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Thumbnail_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Thumbnail_232 = React.forwardRef(function (_ref1665, ref) {
  var className = _ref1665.className,
      children = _ref1665.children,
      style = _ref1665.style,
      tabIndex = _ref1665.tabIndex,
      rest = _objectWithoutProperties$2(_ref1665, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1665 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1665.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1665, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zM8 20H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zM8 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM4 4v4h4V4zm14 6h-4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4V4zm14 6h-4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4V4z'
  }));
});
Thumbnail_232.displayName = 'Thumbnail_232';
Thumbnail_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Thumbnail_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Thumbnail_224 = React.forwardRef(function (_ref1666, ref) {
  var className = _ref1666.className,
      children = _ref1666.children,
      style = _ref1666.style,
      tabIndex = _ref1666.tabIndex,
      rest = _objectWithoutProperties$2(_ref1666, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1666 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1666.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1666, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zM8 20H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zM8 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM4 4v4h4V4zm14 6h-4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4V4zm14 6h-4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4V4z'
  }));
});
Thumbnail_224.displayName = 'Thumbnail_224';
Thumbnail_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Thumbnail_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Thumbnail_220 = React.forwardRef(function (_ref1667, ref) {
  var className = _ref1667.className,
      children = _ref1667.children,
      style = _ref1667.style,
      tabIndex = _ref1667.tabIndex,
      rest = _objectWithoutProperties$2(_ref1667, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1667 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1667.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1667, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zM8 20H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zm14 6h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4v-4zM8 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zM4 4v4h4V4zm14 6h-4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4V4zm14 6h-4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2zm-4-6v4h4V4z'
  }));
});
Thumbnail_220.displayName = 'Thumbnail_220';
Thumbnail_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Thumbnail_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ThumbsDown32 = React.forwardRef(function (_ref1668, ref) {
  var className = _ref1668.className,
      children = _ref1668.children,
      style = _ref1668.style,
      tabIndex = _ref1668.tabIndex,
      rest = _objectWithoutProperties$2(_ref1668, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1668 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1668.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1668, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.76 21A3.64 3.64 0 0 0 30 17v-6c0-3.65-1.56-8-9-8H2v14h6.46L12 22.37l1 6.34v.12A1.51 1.51 0 0 0 14.43 30H16a3.22 3.22 0 0 0 .76 0A3.64 3.64 0 0 0 20 26v-5h6a3.22 3.22 0 0 0 .76 0zM8 15H4V5h4zm20 2c0 1.44-.56 2-2 2h-8v7c0 1.44-.56 2-2 2h-1.13l-.14-1-.73-5.37-4-5.93V5h11c4.78 0 7 1.91 7 6z'
  }));
});
ThumbsDown32.displayName = 'ThumbsDown32';
ThumbsDown32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ThumbsDown32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ThumbsDown24 = React.forwardRef(function (_ref1669, ref) {
  var className = _ref1669.className,
      children = _ref1669.children,
      style = _ref1669.style,
      tabIndex = _ref1669.tabIndex,
      rest = _objectWithoutProperties$2(_ref1669, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1669 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1669.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1669, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.76 21A3.64 3.64 0 0 0 30 17v-6c0-3.65-1.56-8-9-8H2v14h6.46L12 22.37l1 6.34v.12A1.51 1.51 0 0 0 14.43 30H16a3.22 3.22 0 0 0 .76 0A3.64 3.64 0 0 0 20 26v-5h6a3.22 3.22 0 0 0 .76 0zM8 15H4V5h4zm20 2c0 1.44-.56 2-2 2h-8v7c0 1.44-.56 2-2 2h-1.13l-.14-1-.73-5.37-4-5.93V5h11c4.78 0 7 1.91 7 6z'
  }));
});
ThumbsDown24.displayName = 'ThumbsDown24';
ThumbsDown24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ThumbsDown24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ThumbsDown20 = React.forwardRef(function (_ref1670, ref) {
  var className = _ref1670.className,
      children = _ref1670.children,
      style = _ref1670.style,
      tabIndex = _ref1670.tabIndex,
      rest = _objectWithoutProperties$2(_ref1670, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1670 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1670.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1670, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.76 21A3.64 3.64 0 0 0 30 17v-6c0-3.65-1.56-8-9-8H2v14h6.46L12 22.37l1 6.34v.12A1.51 1.51 0 0 0 14.43 30H16a3.22 3.22 0 0 0 .76 0A3.64 3.64 0 0 0 20 26v-5h6a3.22 3.22 0 0 0 .76 0zM8 15H4V5h4zm20 2c0 1.44-.56 2-2 2h-8v7c0 1.44-.56 2-2 2h-1.13l-.14-1-.73-5.37-4-5.93V5h11c4.78 0 7 1.91 7 6z'
  }));
});
ThumbsDown20.displayName = 'ThumbsDown20';
ThumbsDown20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ThumbsDown20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ThumbsUp32 = React.forwardRef(function (_ref1671, ref) {
  var className = _ref1671.className,
      children = _ref1671.children,
      style = _ref1671.style,
      tabIndex = _ref1671.tabIndex,
      rest = _objectWithoutProperties$2(_ref1671, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1671 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1671.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1671, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 11h-6V6a3.64 3.64 0 0 0-3.24-4A3.22 3.22 0 0 0 16 2h-1.57A1.51 1.51 0 0 0 13 3.17v.12l-1 6.34L8.46 15H2v14h19c7.44 0 9-4.35 9-8v-6a3.64 3.64 0 0 0-3.24-4 3.22 3.22 0 0 0-.76 0zM8 27H4V17h4zm20-6c0 4.09-2.22 6-7 6H10V16.3l4-5.93.73-5.37.14-1H16c1.44 0 2 .56 2 2v7h8c1.44 0 2 .56 2 2z'
  }));
});
ThumbsUp32.displayName = 'ThumbsUp32';
ThumbsUp32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ThumbsUp32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ThumbsUp24 = React.forwardRef(function (_ref1672, ref) {
  var className = _ref1672.className,
      children = _ref1672.children,
      style = _ref1672.style,
      tabIndex = _ref1672.tabIndex,
      rest = _objectWithoutProperties$2(_ref1672, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1672 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1672.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1672, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 11h-6V6a3.64 3.64 0 0 0-3.24-4A3.22 3.22 0 0 0 16 2h-1.57A1.51 1.51 0 0 0 13 3.17v.12l-1 6.34L8.46 15H2v14h19c7.44 0 9-4.35 9-8v-6a3.64 3.64 0 0 0-3.24-4 3.22 3.22 0 0 0-.76 0zM8 27H4V17h4zm20-6c0 4.09-2.22 6-7 6H10V16.3l4-5.93.73-5.37.14-1H16c1.44 0 2 .56 2 2v7h8c1.44 0 2 .56 2 2z'
  }));
});
ThumbsUp24.displayName = 'ThumbsUp24';
ThumbsUp24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ThumbsUp24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ThumbsUp20 = React.forwardRef(function (_ref1673, ref) {
  var className = _ref1673.className,
      children = _ref1673.children,
      style = _ref1673.style,
      tabIndex = _ref1673.tabIndex,
      rest = _objectWithoutProperties$2(_ref1673, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1673 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1673.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1673, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 11h-6V6a3.64 3.64 0 0 0-3.24-4A3.22 3.22 0 0 0 16 2h-1.57A1.51 1.51 0 0 0 13 3.17v.12l-1 6.34L8.46 15H2v14h19c7.44 0 9-4.35 9-8v-6a3.64 3.64 0 0 0-3.24-4 3.22 3.22 0 0 0-.76 0zM8 27H4V17h4zm20-6c0 4.09-2.22 6-7 6H10V16.3l4-5.93.73-5.37.14-1H16c1.44 0 2 .56 2 2v7h8c1.44 0 2 .56 2 2z'
  }));
});
ThumbsUp20.displayName = 'ThumbsUp20';
ThumbsUp20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ThumbsUp20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Ticket32 = React.forwardRef(function (_ref1674, ref) {
  var className = _ref1674.className,
      children = _ref1674.children,
      style = _ref1674.style,
      tabIndex = _ref1674.tabIndex,
      rest = _objectWithoutProperties$2(_ref1674, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1674 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1674.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1674, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 14a1 1 0 0 0 1-1V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5a1 1 0 0 0 1 1 2 2 0 0 1 0 4 1 1 0 0 0-1 1v5a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1 2 2 0 0 1 0-4zm-1 5.87V24h-7v-3h-2v3H4v-4.13a4 4 0 0 0 0-7.74V8h15v3h2V8h7v4.13a4 4 0 0 0 0 7.74z'
  }), React.createElement('path', {
    d: 'M19 13h2v6h-2z'
  }));
});
Ticket32.displayName = 'Ticket32';
Ticket32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Ticket32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Ticket24 = React.forwardRef(function (_ref1675, ref) {
  var className = _ref1675.className,
      children = _ref1675.children,
      style = _ref1675.style,
      tabIndex = _ref1675.tabIndex,
      rest = _objectWithoutProperties$2(_ref1675, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1675 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1675.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1675, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 14a1 1 0 0 0 1-1V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5a1 1 0 0 0 1 1 2 2 0 0 1 0 4 1 1 0 0 0-1 1v5a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1 2 2 0 0 1 0-4zm-1 5.87V24h-7v-3h-2v3H4v-4.13a4 4 0 0 0 0-7.74V8h15v3h2V8h7v4.13a4 4 0 0 0 0 7.74z'
  }), React.createElement('path', {
    d: 'M19 13h2v6h-2z'
  }));
});
Ticket24.displayName = 'Ticket24';
Ticket24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Ticket24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Ticket20 = React.forwardRef(function (_ref1676, ref) {
  var className = _ref1676.className,
      children = _ref1676.children,
      style = _ref1676.style,
      tabIndex = _ref1676.tabIndex,
      rest = _objectWithoutProperties$2(_ref1676, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1676 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1676.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1676, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 14a1 1 0 0 0 1-1V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5a1 1 0 0 0 1 1 2 2 0 0 1 0 4 1 1 0 0 0-1 1v5a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1 2 2 0 0 1 0-4zm-1 5.87V24h-7v-3h-2v3H4v-4.13a4 4 0 0 0 0-7.74V8h15v3h2V8h7v4.13a4 4 0 0 0 0 7.74z'
  }), React.createElement('path', {
    d: 'M19 13h2v6h-2z'
  }));
});
Ticket20.displayName = 'Ticket20';
Ticket20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Ticket20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Time32 = React.forwardRef(function (_ref1677, ref) {
  var className = _ref1677.className,
      children = _ref1677.children,
      style = _ref1677.style,
      tabIndex = _ref1677.tabIndex,
      rest = _objectWithoutProperties$2(_ref1677, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1677 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1677.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1677, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }), React.createElement('path', {
    d: 'M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z'
  }));
});
Time32.displayName = 'Time32';
Time32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Time32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Time24 = React.forwardRef(function (_ref1678, ref) {
  var className = _ref1678.className,
      children = _ref1678.children,
      style = _ref1678.style,
      tabIndex = _ref1678.tabIndex,
      rest = _objectWithoutProperties$2(_ref1678, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1678 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1678.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1678, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }), React.createElement('path', {
    d: 'M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z'
  }));
});
Time24.displayName = 'Time24';
Time24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Time24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Time20 = React.forwardRef(function (_ref1679, ref) {
  var className = _ref1679.className,
      children = _ref1679.children,
      style = _ref1679.style,
      tabIndex = _ref1679.tabIndex,
      rest = _objectWithoutProperties$2(_ref1679, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1679 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1679.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1679, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }), React.createElement('path', {
    d: 'M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z'
  }));
});
Time20.displayName = 'Time20';
Time20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Time20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Timer32 = React.forwardRef(function (_ref1680, ref) {
  var className = _ref1680.className,
      children = _ref1680.children,
      style = _ref1680.style,
      tabIndex = _ref1680.tabIndex,
      rest = _objectWithoutProperties$2(_ref1680, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1680 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1680.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1680, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 11h2v9h-2zm-2-9h6v2h-6z'
  }), React.createElement('path', {
    d: 'M28 9l-1.42-1.41-2.25 2.25a10.94 10.94 0 1 0 1.18 1.65zM16 26a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
Timer32.displayName = 'Timer32';
Timer32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Timer32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Timer24 = React.forwardRef(function (_ref1681, ref) {
  var className = _ref1681.className,
      children = _ref1681.children,
      style = _ref1681.style,
      tabIndex = _ref1681.tabIndex,
      rest = _objectWithoutProperties$2(_ref1681, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1681 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1681.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1681, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 11h2v9h-2zm-2-9h6v2h-6z'
  }), React.createElement('path', {
    d: 'M28 9l-1.42-1.41-2.25 2.25a10.94 10.94 0 1 0 1.18 1.65zM16 26a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
Timer24.displayName = 'Timer24';
Timer24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Timer24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Timer20 = React.forwardRef(function (_ref1682, ref) {
  var className = _ref1682.className,
      children = _ref1682.children,
      style = _ref1682.style,
      tabIndex = _ref1682.tabIndex,
      rest = _objectWithoutProperties$2(_ref1682, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1682 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1682.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1682, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 11h2v9h-2zm-2-9h6v2h-6z'
  }), React.createElement('path', {
    d: 'M28 9l-1.42-1.41-2.25 2.25a10.94 10.94 0 1 0 1.18 1.65zM16 26a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
Timer20.displayName = 'Timer20';
Timer20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Timer20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ToolBox32 = React.forwardRef(function (_ref1683, ref) {
  var className = _ref1683.className,
      children = _ref1683.children,
      style = _ref1683.style,
      tabIndex = _ref1683.tabIndex,
      rest = _objectWithoutProperties$2(_ref1683, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1683 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1683.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1683, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 9h-3V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v3H5a3 3 0 0 0-3 3v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a3 3 0 0 0-3-3zM10 6h12v3H10zm18 20H4v-9h8v5h8v-5h8zm-14-9h4v3h-4zM4 15v-3a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v3z'
  }));
});
ToolBox32.displayName = 'ToolBox32';
ToolBox32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ToolBox32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ToolBox24 = React.forwardRef(function (_ref1684, ref) {
  var className = _ref1684.className,
      children = _ref1684.children,
      style = _ref1684.style,
      tabIndex = _ref1684.tabIndex,
      rest = _objectWithoutProperties$2(_ref1684, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1684 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1684.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1684, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 9h-3V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v3H5a3 3 0 0 0-3 3v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a3 3 0 0 0-3-3zM10 6h12v3H10zm18 20H4v-9h8v5h8v-5h8zm-14-9h4v3h-4zM4 15v-3a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v3z'
  }));
});
ToolBox24.displayName = 'ToolBox24';
ToolBox24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ToolBox24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ToolBox20 = React.forwardRef(function (_ref1685, ref) {
  var className = _ref1685.className,
      children = _ref1685.children,
      style = _ref1685.style,
      tabIndex = _ref1685.tabIndex,
      rest = _objectWithoutProperties$2(_ref1685, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1685 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1685.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1685, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27 9h-3V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v3H5a3 3 0 0 0-3 3v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V12a3 3 0 0 0-3-3zM10 6h12v3H10zm18 20H4v-9h8v5h8v-5h8zm-14-9h4v3h-4zM4 15v-3a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v3z'
  }));
});
ToolBox20.displayName = 'ToolBox20';
ToolBox20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ToolBox20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tools32 = React.forwardRef(function (_ref1686, ref) {
  var className = _ref1686.className,
      children = _ref1686.children,
      style = _ref1686.style,
      tabIndex = _ref1686.tabIndex,
      rest = _objectWithoutProperties$2(_ref1686, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1686 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1686.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1686, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.1 2a9.8 9.8 0 0 0-5.4 1.6l6.4 6.4a2.1 2.1 0 0 1 .2 3 2.1 2.1 0 0 1-3-.2L3.7 6.4A9.84 9.84 0 0 0 2 12.1a10.14 10.14 0 0 0 10.1 10.1 10.9 10.9 0 0 0 2.6-.3l6.7 6.7a5 5 0 0 0 7.1-7.1l-6.7-6.7a10.9 10.9 0 0 0 .3-2.6A10 10 0 0 0 12.1 2zm8 10.1a7.61 7.61 0 0 1-.3 2.1l-.3 1.1.8.8 6.7 6.7a2.88 2.88 0 0 1 .9 2.1A2.72 2.72 0 0 1 27 27a2.9 2.9 0 0 1-4.2 0l-6.7-6.7-.8-.8-1.1.3a7.61 7.61 0 0 1-2.1.3 8.27 8.27 0 0 1-5.7-2.3A7.63 7.63 0 0 1 4 12.1a8.33 8.33 0 0 1 .3-2.2l4.4 4.4a4.14 4.14 0 0 0 5.9.2 4.14 4.14 0 0 0-.2-5.9L10 4.2a6.45 6.45 0 0 1 2-.3 8.27 8.27 0 0 1 5.7 2.3 8.49 8.49 0 0 1 2.4 5.9z'
  }));
});
Tools32.displayName = 'Tools32';
Tools32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tools32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tools24 = React.forwardRef(function (_ref1687, ref) {
  var className = _ref1687.className,
      children = _ref1687.children,
      style = _ref1687.style,
      tabIndex = _ref1687.tabIndex,
      rest = _objectWithoutProperties$2(_ref1687, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1687 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1687.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1687, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.1 2a9.8 9.8 0 0 0-5.4 1.6l6.4 6.4a2.1 2.1 0 0 1 .2 3 2.1 2.1 0 0 1-3-.2L3.7 6.4A9.84 9.84 0 0 0 2 12.1a10.14 10.14 0 0 0 10.1 10.1 10.9 10.9 0 0 0 2.6-.3l6.7 6.7a5 5 0 0 0 7.1-7.1l-6.7-6.7a10.9 10.9 0 0 0 .3-2.6A10 10 0 0 0 12.1 2zm8 10.1a7.61 7.61 0 0 1-.3 2.1l-.3 1.1.8.8 6.7 6.7a2.88 2.88 0 0 1 .9 2.1A2.72 2.72 0 0 1 27 27a2.9 2.9 0 0 1-4.2 0l-6.7-6.7-.8-.8-1.1.3a7.61 7.61 0 0 1-2.1.3 8.27 8.27 0 0 1-5.7-2.3A7.63 7.63 0 0 1 4 12.1a8.33 8.33 0 0 1 .3-2.2l4.4 4.4a4.14 4.14 0 0 0 5.9.2 4.14 4.14 0 0 0-.2-5.9L10 4.2a6.45 6.45 0 0 1 2-.3 8.27 8.27 0 0 1 5.7 2.3 8.49 8.49 0 0 1 2.4 5.9z'
  }));
});
Tools24.displayName = 'Tools24';
Tools24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tools24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Tools20 = React.forwardRef(function (_ref1688, ref) {
  var className = _ref1688.className,
      children = _ref1688.children,
      style = _ref1688.style,
      tabIndex = _ref1688.tabIndex,
      rest = _objectWithoutProperties$2(_ref1688, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1688 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1688.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1688, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12.1 2a9.8 9.8 0 0 0-5.4 1.6l6.4 6.4a2.1 2.1 0 0 1 .2 3 2.1 2.1 0 0 1-3-.2L3.7 6.4A9.84 9.84 0 0 0 2 12.1a10.14 10.14 0 0 0 10.1 10.1 10.9 10.9 0 0 0 2.6-.3l6.7 6.7a5 5 0 0 0 7.1-7.1l-6.7-6.7a10.9 10.9 0 0 0 .3-2.6A10 10 0 0 0 12.1 2zm8 10.1a7.61 7.61 0 0 1-.3 2.1l-.3 1.1.8.8 6.7 6.7a2.88 2.88 0 0 1 .9 2.1A2.72 2.72 0 0 1 27 27a2.9 2.9 0 0 1-4.2 0l-6.7-6.7-.8-.8-1.1.3a7.61 7.61 0 0 1-2.1.3 8.27 8.27 0 0 1-5.7-2.3A7.63 7.63 0 0 1 4 12.1a8.33 8.33 0 0 1 .3-2.2l4.4 4.4a4.14 4.14 0 0 0 5.9.2 4.14 4.14 0 0 0-.2-5.9L10 4.2a6.45 6.45 0 0 1 2-.3 8.27 8.27 0 0 1 5.7 2.3 8.49 8.49 0 0 1 2.4 5.9z'
  }));
});
Tools20.displayName = 'Tools20';
Tools20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Tools20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Touch_132 = React.forwardRef(function (_ref1689, ref) {
  var className = _ref1689.className,
      children = _ref1689.children,
      style = _ref1689.style,
      tabIndex = _ref1689.tabIndex,
      rest = _objectWithoutProperties$2(_ref1689, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1689 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1689.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1689, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 8h-2A5 5 0 0 0 8 8H6a7 7 0 0 1 14 0z'
  }), React.createElement('path', {
    d: 'M25 15a2.94 2.94 0 0 0-1.47.4A3 3 0 0 0 21 14a2.94 2.94 0 0 0-1.47.4A3 3 0 0 0 16 13.18V8a3 3 0 0 0-6 0v11.1l-2.23-1.52A2.93 2.93 0 0 0 6 17a3 3 0 0 0-2.12 5.13l8 7.3A6.16 6.16 0 0 0 16 31h5a7 7 0 0 0 7-7v-6a3 3 0 0 0-3-3zm1 9a5 5 0 0 1-5 5h-5a4.17 4.17 0 0 1-2.76-1l-7.95-7.3A1 1 0 0 1 5 20a1 1 0 0 1 1.6-.8l5.4 3.7V8a1 1 0 0 1 2 0v11h2v-3a1 1 0 0 1 2 0v3h2v-2a1 1 0 0 1 2 0v2h2v-1a1 1 0 0 1 2 0z'
  }));
});
Touch_132.displayName = 'Touch_132';
Touch_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Touch_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Touch_124 = React.forwardRef(function (_ref1690, ref) {
  var className = _ref1690.className,
      children = _ref1690.children,
      style = _ref1690.style,
      tabIndex = _ref1690.tabIndex,
      rest = _objectWithoutProperties$2(_ref1690, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1690 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1690.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1690, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 8h-2A5 5 0 0 0 8 8H6a7 7 0 0 1 14 0z'
  }), React.createElement('path', {
    d: 'M25 15a2.94 2.94 0 0 0-1.47.4A3 3 0 0 0 21 14a2.94 2.94 0 0 0-1.47.4A3 3 0 0 0 16 13.18V8a3 3 0 0 0-6 0v11.1l-2.23-1.52A2.93 2.93 0 0 0 6 17a3 3 0 0 0-2.12 5.13l8 7.3A6.16 6.16 0 0 0 16 31h5a7 7 0 0 0 7-7v-6a3 3 0 0 0-3-3zm1 9a5 5 0 0 1-5 5h-5a4.17 4.17 0 0 1-2.76-1l-7.95-7.3A1 1 0 0 1 5 20a1 1 0 0 1 1.6-.8l5.4 3.7V8a1 1 0 0 1 2 0v11h2v-3a1 1 0 0 1 2 0v3h2v-2a1 1 0 0 1 2 0v2h2v-1a1 1 0 0 1 2 0z'
  }));
});
Touch_124.displayName = 'Touch_124';
Touch_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Touch_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Touch_120 = React.forwardRef(function (_ref1691, ref) {
  var className = _ref1691.className,
      children = _ref1691.children,
      style = _ref1691.style,
      tabIndex = _ref1691.tabIndex,
      rest = _objectWithoutProperties$2(_ref1691, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1691 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1691.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1691, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 8h-2A5 5 0 0 0 8 8H6a7 7 0 0 1 14 0z'
  }), React.createElement('path', {
    d: 'M25 15a2.94 2.94 0 0 0-1.47.4A3 3 0 0 0 21 14a2.94 2.94 0 0 0-1.47.4A3 3 0 0 0 16 13.18V8a3 3 0 0 0-6 0v11.1l-2.23-1.52A2.93 2.93 0 0 0 6 17a3 3 0 0 0-2.12 5.13l8 7.3A6.16 6.16 0 0 0 16 31h5a7 7 0 0 0 7-7v-6a3 3 0 0 0-3-3zm1 9a5 5 0 0 1-5 5h-5a4.17 4.17 0 0 1-2.76-1l-7.95-7.3A1 1 0 0 1 5 20a1 1 0 0 1 1.6-.8l5.4 3.7V8a1 1 0 0 1 2 0v11h2v-3a1 1 0 0 1 2 0v3h2v-2a1 1 0 0 1 2 0v2h2v-1a1 1 0 0 1 2 0z'
  }));
});
Touch_120.displayName = 'Touch_120';
Touch_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Touch_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Touch_232 = React.forwardRef(function (_ref1692, ref) {
  var className = _ref1692.className,
      children = _ref1692.children,
      style = _ref1692.style,
      tabIndex = _ref1692.tabIndex,
      rest = _objectWithoutProperties$2(_ref1692, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1692 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1692.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1692, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 15h-2a11 11 0 0 0-22 0H3a13 13 0 0 1 26 0z'
  }), React.createElement('path', {
    d: 'M25 28h-2V15a7 7 0 1 0-14 0v13H7V15a9 9 0 0 1 18 0z'
  }), React.createElement('path', {
    d: 'M21 20H11v-5a5 5 0 0 1 10 0zm-8-2h6v-3a3 3 0 0 0-6 0z'
  }));
});
Touch_232.displayName = 'Touch_232';
Touch_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Touch_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Touch_224 = React.forwardRef(function (_ref1693, ref) {
  var className = _ref1693.className,
      children = _ref1693.children,
      style = _ref1693.style,
      tabIndex = _ref1693.tabIndex,
      rest = _objectWithoutProperties$2(_ref1693, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1693 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1693.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1693, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 15h-2a11 11 0 0 0-22 0H3a13 13 0 0 1 26 0z'
  }), React.createElement('path', {
    d: 'M25 28h-2V15a7 7 0 1 0-14 0v13H7V15a9 9 0 0 1 18 0z'
  }), React.createElement('path', {
    d: 'M21 20H11v-5a5 5 0 0 1 10 0zm-8-2h6v-3a3 3 0 0 0-6 0z'
  }));
});
Touch_224.displayName = 'Touch_224';
Touch_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Touch_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Touch_220 = React.forwardRef(function (_ref1694, ref) {
  var className = _ref1694.className,
      children = _ref1694.children,
      style = _ref1694.style,
      tabIndex = _ref1694.tabIndex,
      rest = _objectWithoutProperties$2(_ref1694, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1694 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1694.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1694, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29 15h-2a11 11 0 0 0-22 0H3a13 13 0 0 1 26 0z'
  }), React.createElement('path', {
    d: 'M25 28h-2V15a7 7 0 1 0-14 0v13H7V15a9 9 0 0 1 18 0z'
  }), React.createElement('path', {
    d: 'M21 20H11v-5a5 5 0 0 1 10 0zm-8-2h6v-3a3 3 0 0 0-6 0z'
  }));
});
Touch_220.displayName = 'Touch_220';
Touch_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Touch_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Train32 = React.forwardRef(function (_ref1695, ref) {
  var className = _ref1695.className,
      children = _ref1695.children,
      style = _ref1695.style,
      tabIndex = _ref1695.tabIndex,
      rest = _objectWithoutProperties$2(_ref1695, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1695 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1695.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1695, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2H11a5 5 0 0 0-5 5v13a5 5 0 0 0 4.36 4.94L9 30h2.07l1.34-5h7.18l1.34 5H23l-1.36-5.06A5 5 0 0 0 26 20V7a5 5 0 0 0-5-5zm3 6v7H8V8zM11 4h10a3 3 0 0 1 2.82 2H8.18A3 3 0 0 1 11 4zm10 19H11a3 3 0 0 1-2.82-2H11v-2H8v-2h16v2h-3v2h2.82A3 3 0 0 1 21 23z'
  }));
});
Train32.displayName = 'Train32';
Train32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Train32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Train24 = React.forwardRef(function (_ref1696, ref) {
  var className = _ref1696.className,
      children = _ref1696.children,
      style = _ref1696.style,
      tabIndex = _ref1696.tabIndex,
      rest = _objectWithoutProperties$2(_ref1696, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1696 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1696.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1696, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2H11a5 5 0 0 0-5 5v13a5 5 0 0 0 4.36 4.94L9 30h2.07l1.34-5h7.18l1.34 5H23l-1.36-5.06A5 5 0 0 0 26 20V7a5 5 0 0 0-5-5zm3 6v7H8V8zM11 4h10a3 3 0 0 1 2.82 2H8.18A3 3 0 0 1 11 4zm10 19H11a3 3 0 0 1-2.82-2H11v-2H8v-2h16v2h-3v2h2.82A3 3 0 0 1 21 23z'
  }));
});
Train24.displayName = 'Train24';
Train24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Train24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Train20 = React.forwardRef(function (_ref1697, ref) {
  var className = _ref1697.className,
      children = _ref1697.children,
      style = _ref1697.style,
      tabIndex = _ref1697.tabIndex,
      rest = _objectWithoutProperties$2(_ref1697, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1697 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1697.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1697, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 2H11a5 5 0 0 0-5 5v13a5 5 0 0 0 4.36 4.94L9 30h2.07l1.34-5h7.18l1.34 5H23l-1.36-5.06A5 5 0 0 0 26 20V7a5 5 0 0 0-5-5zm3 6v7H8V8zM11 4h10a3 3 0 0 1 2.82 2H8.18A3 3 0 0 1 11 4zm10 19H11a3 3 0 0 1-2.82-2H11v-2H8v-2h16v2h-3v2h2.82A3 3 0 0 1 21 23z'
  }));
});
Train20.displayName = 'Train20';
Train20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Train20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Translate32 = React.forwardRef(function (_ref1698, ref) {
  var className = _ref1698.className,
      children = _ref1698.children,
      style = _ref1698.style,
      tabIndex = _ref1698.tabIndex,
      rest = _objectWithoutProperties$2(_ref1698, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1698 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1698.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1698, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.85 29H30l-6-15h-2.35l-6 15h2.15l1.6-4h6.85zm-7.65-6l2.62-6.56L25.45 23zM18 7V5h-7V2H9v3H2v2h10.74a14.71 14.71 0 0 1-3.19 6.18A13.5 13.5 0 0 1 7.26 9h-2.1a16.47 16.47 0 0 0 3 5.58A16.84 16.84 0 0 1 3 18l.75 1.86A18.47 18.47 0 0 0 9.53 16a16.92 16.92 0 0 0 5.76 3.84L16 18a14.48 14.48 0 0 1-5.12-3.37A17.64 17.64 0 0 0 14.8 7z'
  }));
});
Translate32.displayName = 'Translate32';
Translate32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Translate32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Translate24 = React.forwardRef(function (_ref1699, ref) {
  var className = _ref1699.className,
      children = _ref1699.children,
      style = _ref1699.style,
      tabIndex = _ref1699.tabIndex,
      rest = _objectWithoutProperties$2(_ref1699, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1699 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1699.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1699, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.85 29H30l-6-15h-2.35l-6 15h2.15l1.6-4h6.85zm-7.65-6l2.62-6.56L25.45 23zM18 7V5h-7V2H9v3H2v2h10.74a14.71 14.71 0 0 1-3.19 6.18A13.5 13.5 0 0 1 7.26 9h-2.1a16.47 16.47 0 0 0 3 5.58A16.84 16.84 0 0 1 3 18l.75 1.86A18.47 18.47 0 0 0 9.53 16a16.92 16.92 0 0 0 5.76 3.84L16 18a14.48 14.48 0 0 1-5.12-3.37A17.64 17.64 0 0 0 14.8 7z'
  }));
});
Translate24.displayName = 'Translate24';
Translate24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Translate24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Translate20 = React.forwardRef(function (_ref1700, ref) {
  var className = _ref1700.className,
      children = _ref1700.children,
      style = _ref1700.style,
      tabIndex = _ref1700.tabIndex,
      rest = _objectWithoutProperties$2(_ref1700, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1700 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1700.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1700, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.85 29H30l-6-15h-2.35l-6 15h2.15l1.6-4h6.85zm-7.65-6l2.62-6.56L25.45 23zM18 7V5h-7V2H9v3H2v2h10.74a14.71 14.71 0 0 1-3.19 6.18A13.5 13.5 0 0 1 7.26 9h-2.1a16.47 16.47 0 0 0 3 5.58A16.84 16.84 0 0 1 3 18l.75 1.86A18.47 18.47 0 0 0 9.53 16a16.92 16.92 0 0 0 5.76 3.84L16 18a14.48 14.48 0 0 1-5.12-3.37A17.64 17.64 0 0 0 14.8 7z'
  }));
});
Translate20.displayName = 'Translate20';
Translate20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Translate20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TrashCan32 = React.forwardRef(function (_ref1701, ref) {
  var className = _ref1701.className,
      children = _ref1701.children,
      style = _ref1701.style,
      tabIndex = _ref1701.tabIndex,
      rest = _objectWithoutProperties$2(_ref1701, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1701 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1701.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1701, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 12h2v12h-2zm6 0h2v12h-2z'
  }), React.createElement('path', {
    d: 'M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zm4-26h8v2h-8z'
  }));
});
TrashCan32.displayName = 'TrashCan32';
TrashCan32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TrashCan32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TrashCan24 = React.forwardRef(function (_ref1702, ref) {
  var className = _ref1702.className,
      children = _ref1702.children,
      style = _ref1702.style,
      tabIndex = _ref1702.tabIndex,
      rest = _objectWithoutProperties$2(_ref1702, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1702 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1702.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1702, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 12h2v12h-2zm6 0h2v12h-2z'
  }), React.createElement('path', {
    d: 'M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zm4-26h8v2h-8z'
  }));
});
TrashCan24.displayName = 'TrashCan24';
TrashCan24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TrashCan24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TrashCan20 = React.forwardRef(function (_ref1703, ref) {
  var className = _ref1703.className,
      children = _ref1703.children,
      style = _ref1703.style,
      tabIndex = _ref1703.tabIndex,
      rest = _objectWithoutProperties$2(_ref1703, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1703 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1703.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1703, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 12h2v12h-2zm6 0h2v12h-2z'
  }), React.createElement('path', {
    d: 'M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zm4-26h8v2h-8z'
  }));
});
TrashCan20.displayName = 'TrashCan20';
TrashCan20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TrashCan20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TreeView32 = React.forwardRef(function (_ref1704, ref) {
  var className = _ref1704.className,
      children = _ref1704.children,
      style = _ref1704.style,
      tabIndex = _ref1704.tabIndex,
      rest = _objectWithoutProperties$2(_ref1704, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1704 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1704.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1704, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 20v-8h-8v3h-5V7a2 2 0 0 0-2-2h-5V2H2v8h8V7h5v18a2 2 0 0 0 2 2h5v3h8v-8h-8v3h-5v-8h5v3zM8 8H4V4h4zm16 16h4v4h-4zm0-10h4v4h-4z'
  }));
});
TreeView32.displayName = 'TreeView32';
TreeView32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TreeView32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TreeView24 = React.forwardRef(function (_ref1705, ref) {
  var className = _ref1705.className,
      children = _ref1705.children,
      style = _ref1705.style,
      tabIndex = _ref1705.tabIndex,
      rest = _objectWithoutProperties$2(_ref1705, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1705 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1705.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1705, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 20v-8h-8v3h-5V7a2 2 0 0 0-2-2h-5V2H2v8h8V7h5v18a2 2 0 0 0 2 2h5v3h8v-8h-8v3h-5v-8h5v3zM8 8H4V4h4zm16 16h4v4h-4zm0-10h4v4h-4z'
  }));
});
TreeView24.displayName = 'TreeView24';
TreeView24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TreeView24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var TreeView20 = React.forwardRef(function (_ref1706, ref) {
  var className = _ref1706.className,
      children = _ref1706.children,
      style = _ref1706.style,
      tabIndex = _ref1706.tabIndex,
      rest = _objectWithoutProperties$2(_ref1706, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1706 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1706.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1706, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30 20v-8h-8v3h-5V7a2 2 0 0 0-2-2h-5V2H2v8h8V7h5v18a2 2 0 0 0 2 2h5v3h8v-8h-8v3h-5v-8h5v3zM8 8H4V4h4zm16 16h4v4h-4zm0-10h4v4h-4z'
  }));
});
TreeView20.displayName = 'TreeView20';
TreeView20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
TreeView20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Unlink32 = React.forwardRef(function (_ref1707, ref) {
  var className = _ref1707.className,
      children = _ref1707.children,
      style = _ref1707.style,
      tabIndex = _ref1707.tabIndex,
      rest = _objectWithoutProperties$2(_ref1707, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1707 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1707.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1707, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3.584 5.002l1.414-1.414 3.416 3.414L7 8.417zm19.997 19.99l1.415-1.414 3.414 3.416-1.414 1.414zM11 2h2v4h-2zm-9 9h4v2H2zm24 8h4v2h-4zm-7 7h2v4h-2zm-2.42-4.93l-3.71 3.72a4 4 0 1 1-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 0 0-.06 8.54A6 6 0 0 0 10 28a6.07 6.07 0 0 0 4.32-1.8L18 22.49zm-1.17-10.14l3.72-3.72a4 4 0 1 1 5.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 0 0 .06-8.54A6 6 0 0 0 22 4a6.07 6.07 0 0 0-4.32 1.8L14 9.51z'
  }));
});
Unlink32.displayName = 'Unlink32';
Unlink32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Unlink32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Unlink24 = React.forwardRef(function (_ref1708, ref) {
  var className = _ref1708.className,
      children = _ref1708.children,
      style = _ref1708.style,
      tabIndex = _ref1708.tabIndex,
      rest = _objectWithoutProperties$2(_ref1708, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1708 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1708.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1708, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3.584 5.002l1.414-1.414 3.416 3.414L7 8.417zm19.997 19.99l1.415-1.414 3.414 3.416-1.414 1.414zM11 2h2v4h-2zm-9 9h4v2H2zm24 8h4v2h-4zm-7 7h2v4h-2zm-2.42-4.93l-3.71 3.72a4 4 0 1 1-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 0 0-.06 8.54A6 6 0 0 0 10 28a6.07 6.07 0 0 0 4.32-1.8L18 22.49zm-1.17-10.14l3.72-3.72a4 4 0 1 1 5.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 0 0 .06-8.54A6 6 0 0 0 22 4a6.07 6.07 0 0 0-4.32 1.8L14 9.51z'
  }));
});
Unlink24.displayName = 'Unlink24';
Unlink24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Unlink24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Unlink20 = React.forwardRef(function (_ref1709, ref) {
  var className = _ref1709.className,
      children = _ref1709.children,
      style = _ref1709.style,
      tabIndex = _ref1709.tabIndex,
      rest = _objectWithoutProperties$2(_ref1709, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1709 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1709.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1709, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3.584 5.002l1.414-1.414 3.416 3.414L7 8.417zm19.997 19.99l1.415-1.414 3.414 3.416-1.414 1.414zM11 2h2v4h-2zm-9 9h4v2H2zm24 8h4v2h-4zm-7 7h2v4h-2zm-2.42-4.93l-3.71 3.72a4 4 0 1 1-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 0 0-.06 8.54A6 6 0 0 0 10 28a6.07 6.07 0 0 0 4.32-1.8L18 22.49zm-1.17-10.14l3.72-3.72a4 4 0 1 1 5.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 0 0 .06-8.54A6 6 0 0 0 22 4a6.07 6.07 0 0 0-4.32 1.8L14 9.51z'
  }));
});
Unlink20.displayName = 'Unlink20';
Unlink20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Unlink20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Unlocked32 = React.forwardRef(function (_ref1710, ref) {
  var className = _ref1710.className,
      children = _ref1710.children,
      style = _ref1710.style,
      tabIndex = _ref1710.tabIndex,
      rest = _objectWithoutProperties$2(_ref1710, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1710 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1710.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1710, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 14H12V8a4 4 0 0 1 8 0h2a6 6 0 0 0-12 0v6H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zm0 14H8V16h16z'
  }));
});
Unlocked32.displayName = 'Unlocked32';
Unlocked32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Unlocked32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Unlocked24 = React.forwardRef(function (_ref1711, ref) {
  var className = _ref1711.className,
      children = _ref1711.children,
      style = _ref1711.style,
      tabIndex = _ref1711.tabIndex,
      rest = _objectWithoutProperties$2(_ref1711, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1711 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1711.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1711, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 14H12V8a4 4 0 0 1 8 0h2a6 6 0 0 0-12 0v6H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zm0 14H8V16h16z'
  }));
});
Unlocked24.displayName = 'Unlocked24';
Unlocked24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Unlocked24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Unlocked20 = React.forwardRef(function (_ref1712, ref) {
  var className = _ref1712.className,
      children = _ref1712.children,
      style = _ref1712.style,
      tabIndex = _ref1712.tabIndex,
      rest = _objectWithoutProperties$2(_ref1712, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1712 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1712.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1712, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 14H12V8a4 4 0 0 1 8 0h2a6 6 0 0 0-12 0v6H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2zm0 14H8V16h16z'
  }));
});
Unlocked20.displayName = 'Unlocked20';
Unlocked20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Unlocked20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UpToTop32 = React.forwardRef(function (_ref1713, ref) {
  var className = _ref1713.className,
      children = _ref1713.children,
      style = _ref1713.style,
      tabIndex = _ref1713.tabIndex,
      rest = _objectWithoutProperties$2(_ref1713, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1713 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1713.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1713, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 13L6 23l1.41 1.41L16 15.83l8.59 8.58L26 23 16 13zM4 7h24v2H4z'
  }));
});
UpToTop32.displayName = 'UpToTop32';
UpToTop32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UpToTop32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UpToTop24 = React.forwardRef(function (_ref1714, ref) {
  var className = _ref1714.className,
      children = _ref1714.children,
      style = _ref1714.style,
      tabIndex = _ref1714.tabIndex,
      rest = _objectWithoutProperties$2(_ref1714, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1714 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1714.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1714, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 13L6 23l1.41 1.41L16 15.83l8.59 8.58L26 23 16 13zM4 7h24v2H4z'
  }));
});
UpToTop24.displayName = 'UpToTop24';
UpToTop24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UpToTop24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UpToTop20 = React.forwardRef(function (_ref1715, ref) {
  var className = _ref1715.className,
      children = _ref1715.children,
      style = _ref1715.style,
      tabIndex = _ref1715.tabIndex,
      rest = _objectWithoutProperties$2(_ref1715, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1715 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1715.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1715, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 13L6 23l1.41 1.41L16 15.83l8.59 8.58L26 23 16 13zM4 7h24v2H4z'
  }));
});
UpToTop20.displayName = 'UpToTop20';
UpToTop20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UpToTop20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Upload32 = React.forwardRef(function (_ref1716, ref) {
  var className = _ref1716.className,
      children = _ref1716.children,
      style = _ref1716.style,
      tabIndex = _ref1716.tabIndex,
      rest = _objectWithoutProperties$2(_ref1716, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1716 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1716.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1716, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 17l1.41 1.41L15 10.83V30h2V10.83l7.59 7.58L26 17 16 7 6 17z'
  }), React.createElement('path', {
    d: 'M6 8V4h20v4h2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4z'
  }));
});
Upload32.displayName = 'Upload32';
Upload32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Upload32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Upload24 = React.forwardRef(function (_ref1717, ref) {
  var className = _ref1717.className,
      children = _ref1717.children,
      style = _ref1717.style,
      tabIndex = _ref1717.tabIndex,
      rest = _objectWithoutProperties$2(_ref1717, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1717 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1717.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1717, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 17l1.41 1.41L15 10.83V30h2V10.83l7.59 7.58L26 17 16 7 6 17z'
  }), React.createElement('path', {
    d: 'M6 8V4h20v4h2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4z'
  }));
});
Upload24.displayName = 'Upload24';
Upload24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Upload24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Upload20 = React.forwardRef(function (_ref1718, ref) {
  var className = _ref1718.className,
      children = _ref1718.children,
      style = _ref1718.style,
      tabIndex = _ref1718.tabIndex,
      rest = _objectWithoutProperties$2(_ref1718, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1718 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1718.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1718, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 17l1.41 1.41L15 10.83V30h2V10.83l7.59 7.58L26 17 16 7 6 17z'
  }), React.createElement('path', {
    d: 'M6 8V4h20v4h2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4z'
  }));
});
Upload20.displayName = 'Upload20';
Upload20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Upload20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAdmin32 = React.forwardRef(function (_ref1719, ref) {
  var className = _ref1719.className,
      children = _ref1719.children,
      style = _ref1719.style,
      tabIndex = _ref1719.tabIndex,
      rest = _objectWithoutProperties$2(_ref1719, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1719 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1719.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1719, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm3-13.82l-2.59-2.59L21 15l4 4 7-7-1.41-1.41L25 16.18z'
  }));
});
UserAdmin32.displayName = 'UserAdmin32';
UserAdmin32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAdmin32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAdmin24 = React.forwardRef(function (_ref1720, ref) {
  var className = _ref1720.className,
      children = _ref1720.children,
      style = _ref1720.style,
      tabIndex = _ref1720.tabIndex,
      rest = _objectWithoutProperties$2(_ref1720, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1720 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1720.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1720, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm3-13.82l-2.59-2.59L21 15l4 4 7-7-1.41-1.41L25 16.18z'
  }));
});
UserAdmin24.displayName = 'UserAdmin24';
UserAdmin24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAdmin24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAdmin20 = React.forwardRef(function (_ref1721, ref) {
  var className = _ref1721.className,
      children = _ref1721.children,
      style = _ref1721.style,
      tabIndex = _ref1721.tabIndex,
      rest = _objectWithoutProperties$2(_ref1721, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1721 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1721.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1721, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm3-13.82l-2.59-2.59L21 15l4 4 7-7-1.41-1.41L25 16.18z'
  }));
});
UserAdmin20.displayName = 'UserAdmin20';
UserAdmin20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAdmin20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAvatarFilled32 = React.forwardRef(function (_ref1722, ref) {
  var className = _ref1722.className,
      children = _ref1722.children,
      style = _ref1722.style,
      tabIndex = _ref1722.tabIndex,
      rest = _objectWithoutProperties$2(_ref1722, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1722 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1722.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1722, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 5a4.5 4.5 0 1 1-4.5 4.5A4.49 4.49 0 0 1 16 7zm8 17.92a11.93 11.93 0 0 1-16 0v-.58A5.2 5.2 0 0 1 13 19h6a5.21 5.21 0 0 1 5 5.31v.61z'
  }));
});
UserAvatarFilled32.displayName = 'UserAvatarFilled32';
UserAvatarFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAvatarFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAvatarFilled24 = React.forwardRef(function (_ref1723, ref) {
  var className = _ref1723.className,
      children = _ref1723.children,
      style = _ref1723.style,
      tabIndex = _ref1723.tabIndex,
      rest = _objectWithoutProperties$2(_ref1723, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1723 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1723.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1723, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 5a4.5 4.5 0 1 1-4.5 4.5A4.49 4.49 0 0 1 16 7zm8 17.92a11.93 11.93 0 0 1-16 0v-.58A5.2 5.2 0 0 1 13 19h6a5.21 5.21 0 0 1 5 5.31v.61z'
  }));
});
UserAvatarFilled24.displayName = 'UserAvatarFilled24';
UserAvatarFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAvatarFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAvatarFilled20 = React.forwardRef(function (_ref1724, ref) {
  var className = _ref1724.className,
      children = _ref1724.children,
      style = _ref1724.style,
      tabIndex = _ref1724.tabIndex,
      rest = _objectWithoutProperties$2(_ref1724, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1724 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1724.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1724, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 5a4.5 4.5 0 1 1-4.5 4.5A4.49 4.49 0 0 1 16 7zm8 17.92a11.93 11.93 0 0 1-16 0v-.58A5.2 5.2 0 0 1 13 19h6a5.21 5.21 0 0 1 5 5.31v.61z'
  }));
});
UserAvatarFilled20.displayName = 'UserAvatarFilled20';
UserAvatarFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAvatarFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAvatar32 = React.forwardRef(function (_ref1725, ref) {
  var className = _ref1725.className,
      children = _ref1725.children,
      style = _ref1725.style,
      tabIndex = _ref1725.tabIndex,
      rest = _objectWithoutProperties$2(_ref1725, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1725 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1725.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1725, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-6 24.38v-2A3.22 3.22 0 0 1 13 21h6a3.22 3.22 0 0 1 3 3.39v2a11.92 11.92 0 0 1-12 0zm14-1.46v-.61A5.21 5.21 0 0 0 19 19h-6a5.2 5.2 0 0 0-5 5.31v.59a12 12 0 1 1 16 0z'
  }), React.createElement('path', {
    d: 'M16 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
UserAvatar32.displayName = 'UserAvatar32';
UserAvatar32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAvatar32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAvatar24 = React.forwardRef(function (_ref1726, ref) {
  var className = _ref1726.className,
      children = _ref1726.children,
      style = _ref1726.style,
      tabIndex = _ref1726.tabIndex,
      rest = _objectWithoutProperties$2(_ref1726, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1726 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1726.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1726, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-6 24.38v-2A3.22 3.22 0 0 1 13 21h6a3.22 3.22 0 0 1 3 3.39v2a11.92 11.92 0 0 1-12 0zm14-1.46v-.61A5.21 5.21 0 0 0 19 19h-6a5.2 5.2 0 0 0-5 5.31v.59a12 12 0 1 1 16 0z'
  }), React.createElement('path', {
    d: 'M16 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
UserAvatar24.displayName = 'UserAvatar24';
UserAvatar24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAvatar24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserAvatar20 = React.forwardRef(function (_ref1727, ref) {
  var className = _ref1727.className,
      children = _ref1727.children,
      style = _ref1727.style,
      tabIndex = _ref1727.tabIndex,
      rest = _objectWithoutProperties$2(_ref1727, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1727 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1727.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1727, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-6 24.38v-2A3.22 3.22 0 0 1 13 21h6a3.22 3.22 0 0 1 3 3.39v2a11.92 11.92 0 0 1-12 0zm14-1.46v-.61A5.21 5.21 0 0 0 19 19h-6a5.2 5.2 0 0 0-5 5.31v.59a12 12 0 1 1 16 0z'
  }), React.createElement('path', {
    d: 'M16 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
UserAvatar20.displayName = 'UserAvatar20';
UserAvatar20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserAvatar20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserFollow32 = React.forwardRef(function (_ref1728, ref) {
  var className = _ref1728.className,
      children = _ref1728.children,
      style = _ref1728.style,
      tabIndex = _ref1728.tabIndex,
      rest = _objectWithoutProperties$2(_ref1728, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1728 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1728.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1728, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M32 14h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
UserFollow32.displayName = 'UserFollow32';
UserFollow32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserFollow32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserFollow24 = React.forwardRef(function (_ref1729, ref) {
  var className = _ref1729.className,
      children = _ref1729.children,
      style = _ref1729.style,
      tabIndex = _ref1729.tabIndex,
      rest = _objectWithoutProperties$2(_ref1729, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1729 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1729.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1729, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M32 14h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
UserFollow24.displayName = 'UserFollow24';
UserFollow24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserFollow24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserFollow20 = React.forwardRef(function (_ref1730, ref) {
  var className = _ref1730.className,
      children = _ref1730.children,
      style = _ref1730.style,
      tabIndex = _ref1730.tabIndex,
      rest = _objectWithoutProperties$2(_ref1730, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1730 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1730.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1730, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M32 14h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
UserFollow20.displayName = 'UserFollow20';
UserFollow20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserFollow20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserOnline32 = React.forwardRef(function (_ref1731, ref) {
  var className = _ref1731.className,
      children = _ref1731.children,
      style = _ref1731.style,
      tabIndex = _ref1731.tabIndex,
      rest = _objectWithoutProperties$2(_ref1731, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1731 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1731.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1731, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '4'
  }), React.createElement('path', {
    d: 'M22 30h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7z'
  }));
});
UserOnline32.displayName = 'UserOnline32';
UserOnline32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserOnline32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserOnline24 = React.forwardRef(function (_ref1732, ref) {
  var className = _ref1732.className,
      children = _ref1732.children,
      style = _ref1732.style,
      tabIndex = _ref1732.tabIndex,
      rest = _objectWithoutProperties$2(_ref1732, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1732 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1732.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1732, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '4'
  }), React.createElement('path', {
    d: 'M22 30h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7z'
  }));
});
UserOnline24.displayName = 'UserOnline24';
UserOnline24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserOnline24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserOnline20 = React.forwardRef(function (_ref1733, ref) {
  var className = _ref1733.className,
      children = _ref1733.children,
      style = _ref1733.style,
      tabIndex = _ref1733.tabIndex,
      rest = _objectWithoutProperties$2(_ref1733, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1733 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1733.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1733, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '26',
    cy: '16',
    r: '4'
  }), React.createElement('path', {
    d: 'M22 30h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7z'
  }));
});
UserOnline20.displayName = 'UserOnline20';
UserOnline20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserOnline20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserProfile32 = React.forwardRef(function (_ref1734, ref) {
  var className = _ref1734.className,
      children = _ref1734.children,
      style = _ref1734.style,
      tabIndex = _ref1734.tabIndex,
      rest = _objectWithoutProperties$2(_ref1734, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1734 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1734.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1734, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm0-26h10v2H22zm0 5h10v2H22zm0 5h7v2h-7z'
  }));
});
UserProfile32.displayName = 'UserProfile32';
UserProfile32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserProfile32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserProfile24 = React.forwardRef(function (_ref1735, ref) {
  var className = _ref1735.className,
      children = _ref1735.children,
      style = _ref1735.style,
      tabIndex = _ref1735.tabIndex,
      rest = _objectWithoutProperties$2(_ref1735, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1735 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1735.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1735, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm0-26h10v2H22zm0 5h10v2H22zm0 5h7v2h-7z'
  }));
});
UserProfile24.displayName = 'UserProfile24';
UserProfile24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserProfile24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserProfile20 = React.forwardRef(function (_ref1736, ref) {
  var className = _ref1736.className,
      children = _ref1736.children,
      style = _ref1736.style,
      tabIndex = _ref1736.tabIndex,
      rest = _objectWithoutProperties$2(_ref1736, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1736 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1736.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1736, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm0-26h10v2H22zm0 5h10v2H22zm0 5h7v2h-7z'
  }));
});
UserProfile20.displayName = 'UserProfile20';
UserProfile20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserProfile20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserRole32 = React.forwardRef(function (_ref1737, ref) {
  var className = _ref1737.className,
      children = _ref1737.children,
      style = _ref1737.style,
      tabIndex = _ref1737.tabIndex,
      rest = _objectWithoutProperties$2(_ref1737, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1737 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1737.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1737, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.07 21L22 15l6.07-6 1.43 1.41L24.86 15l4.64 4.59L28.07 21zM22 30h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7z'
  }));
});
UserRole32.displayName = 'UserRole32';
UserRole32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserRole32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserRole24 = React.forwardRef(function (_ref1738, ref) {
  var className = _ref1738.className,
      children = _ref1738.children,
      style = _ref1738.style,
      tabIndex = _ref1738.tabIndex,
      rest = _objectWithoutProperties$2(_ref1738, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1738 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1738.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1738, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.07 21L22 15l6.07-6 1.43 1.41L24.86 15l4.64 4.59L28.07 21zM22 30h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7z'
  }));
});
UserRole24.displayName = 'UserRole24';
UserRole24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserRole24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var UserRole20 = React.forwardRef(function (_ref1739, ref) {
  var className = _ref1739.className,
      children = _ref1739.children,
      style = _ref1739.style,
      tabIndex = _ref1739.tabIndex,
      rest = _objectWithoutProperties$2(_ref1739, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1739 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1739.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1739, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28.07 21L22 15l6.07-6 1.43 1.41L24.86 15l4.64 4.59L28.07 21zM22 30h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7z'
  }));
});
UserRole20.displayName = 'UserRole20';
UserRole20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
UserRole20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var User32 = React.forwardRef(function (_ref1740, ref) {
  var className = _ref1740.className,
      children = _ref1740.children,
      style = _ref1740.style,
      tabIndex = _ref1740.tabIndex,
      rest = _objectWithoutProperties$2(_ref1740, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1740 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1740.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1740, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5H6v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
User32.displayName = 'User32';
User32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
User32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var User24 = React.forwardRef(function (_ref1741, ref) {
  var className = _ref1741.className,
      children = _ref1741.children,
      style = _ref1741.style,
      tabIndex = _ref1741.tabIndex,
      rest = _objectWithoutProperties$2(_ref1741, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1741 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1741.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1741, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5H6v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
User24.displayName = 'User24';
User24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
User24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var User20 = React.forwardRef(function (_ref1742, ref) {
  var className = _ref1742.className,
      children = _ref1742.children,
      style = _ref1742.style,
      tabIndex = _ref1742.tabIndex,
      rest = _objectWithoutProperties$2(_ref1742, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1742 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1742.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1742, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5H6v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
User20.displayName = 'User20';
User20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
User20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Van32 = React.forwardRef(function (_ref1743, ref) {
  var className = _ref1743.className,
      children = _ref1743.children,
      style = _ref1743.style,
      tabIndex = _ref1743.tabIndex,
      rest = _objectWithoutProperties$2(_ref1743, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1743 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1743.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1743, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.81 16l-7-9.56A1 1 0 0 0 22 6H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.44a1 1 0 0 0-.19-.56zM20 8h1.49l5.13 7H20zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4V8h14v9h10z'
  }));
});
Van32.displayName = 'Van32';
Van32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Van32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Van24 = React.forwardRef(function (_ref1744, ref) {
  var className = _ref1744.className,
      children = _ref1744.children,
      style = _ref1744.style,
      tabIndex = _ref1744.tabIndex,
      rest = _objectWithoutProperties$2(_ref1744, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1744 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1744.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1744, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.81 16l-7-9.56A1 1 0 0 0 22 6H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.44a1 1 0 0 0-.19-.56zM20 8h1.49l5.13 7H20zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4V8h14v9h10z'
  }));
});
Van24.displayName = 'Van24';
Van24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Van24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Van20 = React.forwardRef(function (_ref1745, ref) {
  var className = _ref1745.className,
      children = _ref1745.children,
      style = _ref1745.style,
      tabIndex = _ref1745.tabIndex,
      rest = _objectWithoutProperties$2(_ref1745, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1745 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1745.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1745, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.81 16l-7-9.56A1 1 0 0 0 22 6H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a1 1 0 0 0 1-1v-7.44a1 1 0 0 0-.19-.56zM20 8h1.49l5.13 7H20zM9 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm5-3h-1.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H4V8h14v9h10z'
  }));
});
Van20.displayName = 'Van20';
Van20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Van20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoAdd32 = React.forwardRef(function (_ref1746, ref) {
  var className = _ref1746.className,
      children = _ref1746.children,
      style = _ref1746.style,
      tabIndex = _ref1746.tabIndex,
      rest = _objectWithoutProperties$2(_ref1746, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1746 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1746.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1746, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 15h-4v-4h-2v4H8v2h4v4h2v-4h4v-2z'
  }), React.createElement('path', {
    d: 'M29.5 8.1a.91.91 0 0 0-1 0L23 11.3V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-3.3l5.5 3.2a.91.91 0 0 0 1 0 1.05 1.05 0 0 0 .5-.9V9a1.05 1.05 0 0 0-.5-.9zM28 21.3l-5.5-3.2a.91.91 0 0 0-1 0 1.19 1.19 0 0 0-.5.9v5H4V8h17v5a.94.94 0 0 0 1 1 .9.9 0 0 0 .5-.1l5.5-3.1z'
  }));
});
VideoAdd32.displayName = 'VideoAdd32';
VideoAdd32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoAdd32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoAdd24 = React.forwardRef(function (_ref1747, ref) {
  var className = _ref1747.className,
      children = _ref1747.children,
      style = _ref1747.style,
      tabIndex = _ref1747.tabIndex,
      rest = _objectWithoutProperties$2(_ref1747, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1747 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1747.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1747, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 15h-4v-4h-2v4H8v2h4v4h2v-4h4v-2z'
  }), React.createElement('path', {
    d: 'M29.5 8.1a.91.91 0 0 0-1 0L23 11.3V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-3.3l5.5 3.2a.91.91 0 0 0 1 0 1.05 1.05 0 0 0 .5-.9V9a1.05 1.05 0 0 0-.5-.9zM28 21.3l-5.5-3.2a.91.91 0 0 0-1 0 1.19 1.19 0 0 0-.5.9v5H4V8h17v5a.94.94 0 0 0 1 1 .9.9 0 0 0 .5-.1l5.5-3.1z'
  }));
});
VideoAdd24.displayName = 'VideoAdd24';
VideoAdd24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoAdd24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoAdd20 = React.forwardRef(function (_ref1748, ref) {
  var className = _ref1748.className,
      children = _ref1748.children,
      style = _ref1748.style,
      tabIndex = _ref1748.tabIndex,
      rest = _objectWithoutProperties$2(_ref1748, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1748 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1748.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1748, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 15h-4v-4h-2v4H8v2h4v4h2v-4h4v-2z'
  }), React.createElement('path', {
    d: 'M29.5 8.1a.91.91 0 0 0-1 0L23 11.3V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-3.3l5.5 3.2a.91.91 0 0 0 1 0 1.05 1.05 0 0 0 .5-.9V9a1.05 1.05 0 0 0-.5-.9zM28 21.3l-5.5-3.2a.91.91 0 0 0-1 0 1.19 1.19 0 0 0-.5.9v5H4V8h17v5a.94.94 0 0 0 1 1 .9.9 0 0 0 .5-.1l5.5-3.1z'
  }));
});
VideoAdd20.displayName = 'VideoAdd20';
VideoAdd20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoAdd20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoChat32 = React.forwardRef(function (_ref1749, ref) {
  var className = _ref1749.className,
      children = _ref1749.children,
      style = _ref1749.style,
      tabIndex = _ref1749.tabIndex,
      rest = _objectWithoutProperties$2(_ref1749, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1749 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1749.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1749, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.5 8.1a.91.91 0 0 0-1 0L23 11.3V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-3.3l5.5 3.2a.91.91 0 0 0 1 0 1.05 1.05 0 0 0 .5-.9V9a1.05 1.05 0 0 0-.5-.9zM28 21.3l-5.5-3.2a.91.91 0 0 0-1 0 1.19 1.19 0 0 0-.5.9v5H4V8h17v5a.94.94 0 0 0 1 1 .9.9 0 0 0 .5-.1l5.5-3.1z'
  }), React.createElement('path', {
    d: 'M8 12h9v2H8zm0 5h5v2H8z'
  }));
});
VideoChat32.displayName = 'VideoChat32';
VideoChat32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoChat32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoChat24 = React.forwardRef(function (_ref1750, ref) {
  var className = _ref1750.className,
      children = _ref1750.children,
      style = _ref1750.style,
      tabIndex = _ref1750.tabIndex,
      rest = _objectWithoutProperties$2(_ref1750, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1750 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1750.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1750, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.5 8.1a.91.91 0 0 0-1 0L23 11.3V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-3.3l5.5 3.2a.91.91 0 0 0 1 0 1.05 1.05 0 0 0 .5-.9V9a1.05 1.05 0 0 0-.5-.9zM28 21.3l-5.5-3.2a.91.91 0 0 0-1 0 1.19 1.19 0 0 0-.5.9v5H4V8h17v5a.94.94 0 0 0 1 1 .9.9 0 0 0 .5-.1l5.5-3.1z'
  }), React.createElement('path', {
    d: 'M8 12h9v2H8zm0 5h5v2H8z'
  }));
});
VideoChat24.displayName = 'VideoChat24';
VideoChat24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoChat24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoChat20 = React.forwardRef(function (_ref1751, ref) {
  var className = _ref1751.className,
      children = _ref1751.children,
      style = _ref1751.style,
      tabIndex = _ref1751.tabIndex,
      rest = _objectWithoutProperties$2(_ref1751, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1751 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1751.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1751, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.5 8.1a.91.91 0 0 0-1 0L23 11.3V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-3.3l5.5 3.2a.91.91 0 0 0 1 0 1.05 1.05 0 0 0 .5-.9V9a1.05 1.05 0 0 0-.5-.9zM28 21.3l-5.5-3.2a.91.91 0 0 0-1 0 1.19 1.19 0 0 0-.5.9v5H4V8h17v5a.94.94 0 0 0 1 1 .9.9 0 0 0 .5-.1l5.5-3.1z'
  }), React.createElement('path', {
    d: 'M8 12h9v2H8zm0 5h5v2H8z'
  }));
});
VideoChat20.displayName = 'VideoChat20';
VideoChat20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoChat20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoFilled32 = React.forwardRef(function (_ref1752, ref) {
  var className = _ref1752.className,
      children = _ref1752.children,
      style = _ref1752.style,
      tabIndex = _ref1752.tabIndex,
      rest = _objectWithoutProperties$2(_ref1752, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1752 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1752.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1752, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v4.06l5.42-3.87A1 1 0 0 1 30 9v14a1 1 0 0 1-1.58.81L23 19.94V24a2 2 0 0 1-2 2z'
  }));
});
VideoFilled32.displayName = 'VideoFilled32';
VideoFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoFilled24 = React.forwardRef(function (_ref1753, ref) {
  var className = _ref1753.className,
      children = _ref1753.children,
      style = _ref1753.style,
      tabIndex = _ref1753.tabIndex,
      rest = _objectWithoutProperties$2(_ref1753, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1753 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1753.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1753, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v4.06l5.42-3.87A1 1 0 0 1 30 9v14a1 1 0 0 1-1.58.81L23 19.94V24a2 2 0 0 1-2 2z'
  }));
});
VideoFilled24.displayName = 'VideoFilled24';
VideoFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoFilled20 = React.forwardRef(function (_ref1754, ref) {
  var className = _ref1754.className,
      children = _ref1754.children,
      style = _ref1754.style,
      tabIndex = _ref1754.tabIndex,
      rest = _objectWithoutProperties$2(_ref1754, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1754 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1754.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1754, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v4.06l5.42-3.87A1 1 0 0 1 30 9v14a1 1 0 0 1-1.58.81L23 19.94V24a2 2 0 0 1-2 2z'
  }));
});
VideoFilled20.displayName = 'VideoFilled20';
VideoFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoOffFilled32 = React.forwardRef(function (_ref1755, ref) {
  var className = _ref1755.className,
      children = _ref1755.children,
      style = _ref1755.style,
      tabIndex = _ref1755.tabIndex,
      rest = _objectWithoutProperties$2(_ref1755, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1755 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1755.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1755, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.31 6H4a2 2 0 0 0-2 2v16a2.85 2.85 0 0 0 0 .29zm9.15 2.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89z'
  }));
});
VideoOffFilled32.displayName = 'VideoOffFilled32';
VideoOffFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoOffFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoOffFilled24 = React.forwardRef(function (_ref1756, ref) {
  var className = _ref1756.className,
      children = _ref1756.children,
      style = _ref1756.style,
      tabIndex = _ref1756.tabIndex,
      rest = _objectWithoutProperties$2(_ref1756, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1756 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1756.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1756, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.31 6H4a2 2 0 0 0-2 2v16a2.85 2.85 0 0 0 0 .29zm9.15 2.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89z'
  }));
});
VideoOffFilled24.displayName = 'VideoOffFilled24';
VideoOffFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoOffFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoOffFilled20 = React.forwardRef(function (_ref1757, ref) {
  var className = _ref1757.className,
      children = _ref1757.children,
      style = _ref1757.style,
      tabIndex = _ref1757.tabIndex,
      rest = _objectWithoutProperties$2(_ref1757, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1757 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1757.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1757, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20.31 6H4a2 2 0 0 0-2 2v16a2.85 2.85 0 0 0 0 .29zm9.15 2.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89z'
  }));
});
VideoOffFilled20.displayName = 'VideoOffFilled20';
VideoOffFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoOffFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoOff32 = React.forwardRef(function (_ref1758, ref) {
  var className = _ref1758.className,
      children = _ref1758.children,
      style = _ref1758.style,
      tabIndex = _ref1758.tabIndex,
      rest = _objectWithoutProperties$2(_ref1758, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1758 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1758.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1758, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.46 8.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89zM28 21.06l-5.42-3.87A1 1 0 0 0 21 18v6H9.44L21 12.44V14a1 1 0 0 0 1.58.81L28 10.94zM4 24V8h16V6H4a2 2 0 0 0-2 2v16z'
  }));
});
VideoOff32.displayName = 'VideoOff32';
VideoOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoOff24 = React.forwardRef(function (_ref1759, ref) {
  var className = _ref1759.className,
      children = _ref1759.children,
      style = _ref1759.style,
      tabIndex = _ref1759.tabIndex,
      rest = _objectWithoutProperties$2(_ref1759, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1759 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1759.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1759, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.46 8.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89zM28 21.06l-5.42-3.87A1 1 0 0 0 21 18v6H9.44L21 12.44V14a1 1 0 0 0 1.58.81L28 10.94zM4 24V8h16V6H4a2 2 0 0 0-2 2v16z'
  }));
});
VideoOff24.displayName = 'VideoOff24';
VideoOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VideoOff20 = React.forwardRef(function (_ref1760, ref) {
  var className = _ref1760.className,
      children = _ref1760.children,
      style = _ref1760.style,
      tabIndex = _ref1760.tabIndex,
      rest = _objectWithoutProperties$2(_ref1760, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1760 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1760.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1760, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.46 8.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89zM28 21.06l-5.42-3.87A1 1 0 0 0 21 18v6H9.44L21 12.44V14a1 1 0 0 0 1.58.81L28 10.94zM4 24V8h16V6H4a2 2 0 0 0-2 2v16z'
  }));
});
VideoOff20.displayName = 'VideoOff20';
VideoOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VideoOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Video32 = React.forwardRef(function (_ref1761, ref) {
  var className = _ref1761.className,
      children = _ref1761.children,
      style = _ref1761.style,
      tabIndex = _ref1761.tabIndex,
      rest = _objectWithoutProperties$2(_ref1761, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1761 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1761.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1761, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v4.06l5.42-3.87A1 1 0 0 1 30 9v14a1 1 0 0 1-1.58.81L23 19.94V24a2 2 0 0 1-2 2zM4 8v16h17v-6a1 1 0 0 1 1.58-.81L28 21.06V10.94l-5.42 3.87A1 1 0 0 1 21 14V8z'
  }));
});
Video32.displayName = 'Video32';
Video32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Video32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Video24 = React.forwardRef(function (_ref1762, ref) {
  var className = _ref1762.className,
      children = _ref1762.children,
      style = _ref1762.style,
      tabIndex = _ref1762.tabIndex,
      rest = _objectWithoutProperties$2(_ref1762, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1762 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1762.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1762, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v4.06l5.42-3.87A1 1 0 0 1 30 9v14a1 1 0 0 1-1.58.81L23 19.94V24a2 2 0 0 1-2 2zM4 8v16h17v-6a1 1 0 0 1 1.58-.81L28 21.06V10.94l-5.42 3.87A1 1 0 0 1 21 14V8z'
  }));
});
Video24.displayName = 'Video24';
Video24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Video24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Video20 = React.forwardRef(function (_ref1763, ref) {
  var className = _ref1763.className,
      children = _ref1763.children,
      style = _ref1763.style,
      tabIndex = _ref1763.tabIndex,
      rest = _objectWithoutProperties$2(_ref1763, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1763 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1763.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1763, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21 26H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v4.06l5.42-3.87A1 1 0 0 1 30 9v14a1 1 0 0 1-1.58.81L23 19.94V24a2 2 0 0 1-2 2zM4 8v16h17v-6a1 1 0 0 1 1.58-.81L28 21.06V10.94l-5.42 3.87A1 1 0 0 1 21 14V8z'
  }));
});
Video20.displayName = 'Video20';
Video20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Video20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewFilled32 = React.forwardRef(function (_ref1764, ref) {
  var className = _ref1764.className,
      children = _ref1764.children,
      style = _ref1764.style,
      tabIndex = _ref1764.tabIndex,
      rest = _objectWithoutProperties$2(_ref1764, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1764 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1764.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1764, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '4'
  }), React.createElement('path', {
    d: 'M30.94 15.66A16.69 16.69 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 22.5a6.5 6.5 0 1 1 6.5-6.5 6.51 6.51 0 0 1-6.5 6.5z'
  }));
});
ViewFilled32.displayName = 'ViewFilled32';
ViewFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewFilled24 = React.forwardRef(function (_ref1765, ref) {
  var className = _ref1765.className,
      children = _ref1765.children,
      style = _ref1765.style,
      tabIndex = _ref1765.tabIndex,
      rest = _objectWithoutProperties$2(_ref1765, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1765 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1765.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1765, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '4'
  }), React.createElement('path', {
    d: 'M30.94 15.66A16.69 16.69 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 22.5a6.5 6.5 0 1 1 6.5-6.5 6.51 6.51 0 0 1-6.5 6.5z'
  }));
});
ViewFilled24.displayName = 'ViewFilled24';
ViewFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewFilled20 = React.forwardRef(function (_ref1766, ref) {
  var className = _ref1766.className,
      children = _ref1766.children,
      style = _ref1766.style,
      tabIndex = _ref1766.tabIndex,
      rest = _objectWithoutProperties$2(_ref1766, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1766 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1766.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1766, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '4'
  }), React.createElement('path', {
    d: 'M30.94 15.66A16.69 16.69 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 22.5a6.5 6.5 0 1 1 6.5-6.5 6.51 6.51 0 0 1-6.5 6.5z'
  }));
});
ViewFilled20.displayName = 'ViewFilled20';
ViewFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewMode_132 = React.forwardRef(function (_ref1767, ref) {
  var className = _ref1767.className,
      children = _ref1767.children,
      style = _ref1767.style,
      tabIndex = _ref1767.tabIndex,
      rest = _objectWithoutProperties$2(_ref1767, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1767 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1767.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1767, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm0-7h24v2H4zM26 6v6H6V6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
ViewMode_132.displayName = 'ViewMode_132';
ViewMode_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewMode_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewMode_124 = React.forwardRef(function (_ref1768, ref) {
  var className = _ref1768.className,
      children = _ref1768.children,
      style = _ref1768.style,
      tabIndex = _ref1768.tabIndex,
      rest = _objectWithoutProperties$2(_ref1768, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1768 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1768.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1768, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm0-7h24v2H4zM26 6v6H6V6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
ViewMode_124.displayName = 'ViewMode_124';
ViewMode_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewMode_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewMode_120 = React.forwardRef(function (_ref1769, ref) {
  var className = _ref1769.className,
      children = _ref1769.children,
      style = _ref1769.style,
      tabIndex = _ref1769.tabIndex,
      rest = _objectWithoutProperties$2(_ref1769, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1769 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1769.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1769, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm0-7h24v2H4zM26 6v6H6V6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
ViewMode_120.displayName = 'ViewMode_120';
ViewMode_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewMode_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewMode_232 = React.forwardRef(function (_ref1770, ref) {
  var className = _ref1770.className,
      children = _ref1770.children,
      style = _ref1770.style,
      tabIndex = _ref1770.tabIndex,
      rest = _objectWithoutProperties$2(_ref1770, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1770 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1770.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1770, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm0-7h24v2H4zm8-13v6H6V6h6m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm14 2v6h-6V6h6m0-2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
ViewMode_232.displayName = 'ViewMode_232';
ViewMode_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewMode_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewMode_224 = React.forwardRef(function (_ref1771, ref) {
  var className = _ref1771.className,
      children = _ref1771.children,
      style = _ref1771.style,
      tabIndex = _ref1771.tabIndex,
      rest = _objectWithoutProperties$2(_ref1771, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1771 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1771.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1771, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm0-7h24v2H4zm8-13v6H6V6h6m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm14 2v6h-6V6h6m0-2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
ViewMode_224.displayName = 'ViewMode_224';
ViewMode_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewMode_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewMode_220 = React.forwardRef(function (_ref1772, ref) {
  var className = _ref1772.className,
      children = _ref1772.children,
      style = _ref1772.style,
      tabIndex = _ref1772.tabIndex,
      rest = _objectWithoutProperties$2(_ref1772, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1772 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1772.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1772, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M4 26h24v2H4zm0-7h24v2H4zm8-13v6H6V6h6m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm14 2v6h-6V6h6m0-2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
ViewMode_220.displayName = 'ViewMode_220';
ViewMode_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewMode_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewOffFilled32 = React.forwardRef(function (_ref1773, ref) {
  var className = _ref1773.className,
      children = _ref1773.children,
      style = _ref1773.style,
      tabIndex = _ref1773.tabIndex,
      rest = _objectWithoutProperties$2(_ref1773, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1773 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1773.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1773, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30.94 15.66a16.4 16.4 0 0 0-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 22.5a6.46 6.46 0 0 1-3.83-1.26L14 19.43A4 4 0 0 0 19.43 14l1.81-1.81A6.49 6.49 0 0 1 16 22.5zm-11.47-.69l5-5A6.84 6.84 0 0 1 9.5 16 6.51 6.51 0 0 1 16 9.5a6.84 6.84 0 0 1 .79.05l3.78-3.77A14.39 14.39 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68 15.86 15.86 0 0 0 3.47 5.47z'
  }));
});
ViewOffFilled32.displayName = 'ViewOffFilled32';
ViewOffFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewOffFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewOffFilled24 = React.forwardRef(function (_ref1774, ref) {
  var className = _ref1774.className,
      children = _ref1774.children,
      style = _ref1774.style,
      tabIndex = _ref1774.tabIndex,
      rest = _objectWithoutProperties$2(_ref1774, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1774 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1774.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1774, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30.94 15.66a16.4 16.4 0 0 0-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 22.5a6.46 6.46 0 0 1-3.83-1.26L14 19.43A4 4 0 0 0 19.43 14l1.81-1.81A6.49 6.49 0 0 1 16 22.5zm-11.47-.69l5-5A6.84 6.84 0 0 1 9.5 16 6.51 6.51 0 0 1 16 9.5a6.84 6.84 0 0 1 .79.05l3.78-3.77A14.39 14.39 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68 15.86 15.86 0 0 0 3.47 5.47z'
  }));
});
ViewOffFilled24.displayName = 'ViewOffFilled24';
ViewOffFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewOffFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewOffFilled20 = React.forwardRef(function (_ref1775, ref) {
  var className = _ref1775.className,
      children = _ref1775.children,
      style = _ref1775.style,
      tabIndex = _ref1775.tabIndex,
      rest = _objectWithoutProperties$2(_ref1775, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1775 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1775.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1775, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30.94 15.66a16.4 16.4 0 0 0-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 22.5a6.46 6.46 0 0 1-3.83-1.26L14 19.43A4 4 0 0 0 19.43 14l1.81-1.81A6.49 6.49 0 0 1 16 22.5zm-11.47-.69l5-5A6.84 6.84 0 0 1 9.5 16 6.51 6.51 0 0 1 16 9.5a6.84 6.84 0 0 1 .79.05l3.78-3.77A14.39 14.39 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68 15.86 15.86 0 0 0 3.47 5.47z'
  }));
});
ViewOffFilled20.displayName = 'ViewOffFilled20';
ViewOffFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewOffFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewOff32 = React.forwardRef(function (_ref1776, ref) {
  var className = _ref1776.className,
      children = _ref1776.children,
      style = _ref1776.style,
      tabIndex = _ref1776.tabIndex,
      rest = _objectWithoutProperties$2(_ref1776, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1776 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1776.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1776, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5.24 22.51l1.43-1.42A14.06 14.06 0 0 1 3.07 16C5.1 10.93 10.7 7 16 7a12.38 12.38 0 0 1 4 .72l1.55-1.56A14.72 14.72 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68 16 16 0 0 0 4.18 6.17z'
  }), React.createElement('path', {
    d: 'M12 15.73a4 4 0 0 1 3.7-3.7l1.81-1.82a6 6 0 0 0-7.33 7.33zm18.94-.07a16.4 16.4 0 0 0-5.74-7.44L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM20 16a4 4 0 0 1-6 3.44L19.44 14a4 4 0 0 1 .56 2zm-4 9a13.05 13.05 0 0 1-6-1.58l2.54-2.54a6 6 0 0 0 8.35-8.35l2.87-2.87A14.54 14.54 0 0 1 28.93 16C26.9 21.07 21.3 25 16 25z'
  }));
});
ViewOff32.displayName = 'ViewOff32';
ViewOff32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewOff32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewOff24 = React.forwardRef(function (_ref1777, ref) {
  var className = _ref1777.className,
      children = _ref1777.children,
      style = _ref1777.style,
      tabIndex = _ref1777.tabIndex,
      rest = _objectWithoutProperties$2(_ref1777, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1777 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1777.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1777, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5.24 22.51l1.43-1.42A14.06 14.06 0 0 1 3.07 16C5.1 10.93 10.7 7 16 7a12.38 12.38 0 0 1 4 .72l1.55-1.56A14.72 14.72 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68 16 16 0 0 0 4.18 6.17z'
  }), React.createElement('path', {
    d: 'M12 15.73a4 4 0 0 1 3.7-3.7l1.81-1.82a6 6 0 0 0-7.33 7.33zm18.94-.07a16.4 16.4 0 0 0-5.74-7.44L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM20 16a4 4 0 0 1-6 3.44L19.44 14a4 4 0 0 1 .56 2zm-4 9a13.05 13.05 0 0 1-6-1.58l2.54-2.54a6 6 0 0 0 8.35-8.35l2.87-2.87A14.54 14.54 0 0 1 28.93 16C26.9 21.07 21.3 25 16 25z'
  }));
});
ViewOff24.displayName = 'ViewOff24';
ViewOff24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewOff24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ViewOff20 = React.forwardRef(function (_ref1778, ref) {
  var className = _ref1778.className,
      children = _ref1778.children,
      style = _ref1778.style,
      tabIndex = _ref1778.tabIndex,
      rest = _objectWithoutProperties$2(_ref1778, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1778 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1778.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1778, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5.24 22.51l1.43-1.42A14.06 14.06 0 0 1 3.07 16C5.1 10.93 10.7 7 16 7a12.38 12.38 0 0 1 4 .72l1.55-1.56A14.72 14.72 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68 16 16 0 0 0 4.18 6.17z'
  }), React.createElement('path', {
    d: 'M12 15.73a4 4 0 0 1 3.7-3.7l1.81-1.82a6 6 0 0 0-7.33 7.33zm18.94-.07a16.4 16.4 0 0 0-5.74-7.44L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM20 16a4 4 0 0 1-6 3.44L19.44 14a4 4 0 0 1 .56 2zm-4 9a13.05 13.05 0 0 1-6-1.58l2.54-2.54a6 6 0 0 0 8.35-8.35l2.87-2.87A14.54 14.54 0 0 1 28.93 16C26.9 21.07 21.3 25 16 25z'
  }));
});
ViewOff20.displayName = 'ViewOff20';
ViewOff20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ViewOff20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var View32 = React.forwardRef(function (_ref1779, ref) {
  var className = _ref1779.className,
      children = _ref1779.children,
      style = _ref1779.style,
      tabIndex = _ref1779.tabIndex,
      rest = _objectWithoutProperties$2(_ref1779, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1779 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1779.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1779, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30.94 15.66A16.69 16.69 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 25c-5.3 0-10.9-3.93-12.93-9C5.1 10.93 10.7 7 16 7s10.9 3.93 12.93 9C26.9 21.07 21.3 25 16 25z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
View32.displayName = 'View32';
View32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
View32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var View24 = React.forwardRef(function (_ref1780, ref) {
  var className = _ref1780.className,
      children = _ref1780.children,
      style = _ref1780.style,
      tabIndex = _ref1780.tabIndex,
      rest = _objectWithoutProperties$2(_ref1780, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1780 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1780.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1780, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30.94 15.66A16.69 16.69 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 25c-5.3 0-10.9-3.93-12.93-9C5.1 10.93 10.7 7 16 7s10.9 3.93 12.93 9C26.9 21.07 21.3 25 16 25z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
View24.displayName = 'View24';
View24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
View24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var View20 = React.forwardRef(function (_ref1781, ref) {
  var className = _ref1781.className,
      children = _ref1781.children,
      style = _ref1781.style,
      tabIndex = _ref1781.tabIndex,
      rest = _objectWithoutProperties$2(_ref1781, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1781 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1781.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1781, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M30.94 15.66A16.69 16.69 0 0 0 16 5 16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66 1 1 0 0 0 0-.68zM16 25c-5.3 0-10.9-3.93-12.93-9C5.1 10.93 10.7 7 16 7s10.9 3.93 12.93 9C26.9 21.07 21.3 25 16 25z'
  }), React.createElement('path', {
    d: 'M16 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
View20.displayName = 'View20';
View20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
View20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VisualRecognition32 = React.forwardRef(function (_ref1782, ref) {
  var className = _ref1782.className,
      children = _ref1782.children,
      style = _ref1782.style,
      tabIndex = _ref1782.tabIndex,
      rest = _objectWithoutProperties$2(_ref1782, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1782 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1782.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1782, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '12',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 5H16.24A8 8 0 1 0 6 16.92V27a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM4 10a6 6 0 0 1 11.19-3H8v2h7.91a6.64 6.64 0 0 1 .09 1 6.64 6.64 0 0 1-.09 1H10v2h5.19A6 6 0 0 1 4 10zm24 17H8l5-5 1.59 1.59a2 2 0 0 0 2.82 0L23 18l5 5zm0-6.83l-3.59-3.59a2 2 0 0 0-2.82 0L16 22.17l-1.59-1.59a2 2 0 0 0-2.82 0L8 24.17v-6.43a8.24 8.24 0 0 0 2 .26 8 8 0 0 0 8-8 7.9 7.9 0 0 0-.59-3H28z'
  }));
});
VisualRecognition32.displayName = 'VisualRecognition32';
VisualRecognition32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VisualRecognition32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VisualRecognition24 = React.forwardRef(function (_ref1783, ref) {
  var className = _ref1783.className,
      children = _ref1783.children,
      style = _ref1783.style,
      tabIndex = _ref1783.tabIndex,
      rest = _objectWithoutProperties$2(_ref1783, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1783 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1783.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1783, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '12',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 5H16.24A8 8 0 1 0 6 16.92V27a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM4 10a6 6 0 0 1 11.19-3H8v2h7.91a6.64 6.64 0 0 1 .09 1 6.64 6.64 0 0 1-.09 1H10v2h5.19A6 6 0 0 1 4 10zm24 17H8l5-5 1.59 1.59a2 2 0 0 0 2.82 0L23 18l5 5zm0-6.83l-3.59-3.59a2 2 0 0 0-2.82 0L16 22.17l-1.59-1.59a2 2 0 0 0-2.82 0L8 24.17v-6.43a8.24 8.24 0 0 0 2 .26 8 8 0 0 0 8-8 7.9 7.9 0 0 0-.59-3H28z'
  }));
});
VisualRecognition24.displayName = 'VisualRecognition24';
VisualRecognition24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VisualRecognition24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VisualRecognition20 = React.forwardRef(function (_ref1784, ref) {
  var className = _ref1784.className,
      children = _ref1784.children,
      style = _ref1784.style,
      tabIndex = _ref1784.tabIndex,
      rest = _objectWithoutProperties$2(_ref1784, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1784 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1784.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1784, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '12',
    r: '2'
  }), React.createElement('path', {
    d: 'M28 5H16.24A8 8 0 1 0 6 16.92V27a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM4 10a6 6 0 0 1 11.19-3H8v2h7.91a6.64 6.64 0 0 1 .09 1 6.64 6.64 0 0 1-.09 1H10v2h5.19A6 6 0 0 1 4 10zm24 17H8l5-5 1.59 1.59a2 2 0 0 0 2.82 0L23 18l5 5zm0-6.83l-3.59-3.59a2 2 0 0 0-2.82 0L16 22.17l-1.59-1.59a2 2 0 0 0-2.82 0L8 24.17v-6.43a8.24 8.24 0 0 0 2 .26 8 8 0 0 0 8-8 7.9 7.9 0 0 0-.59-3H28z'
  }));
});
VisualRecognition20.displayName = 'VisualRecognition20';
VisualRecognition20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VisualRecognition20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Voicemail32 = React.forwardRef(function (_ref1785, ref) {
  var className = _ref1785.className,
      children = _ref1785.children,
      style = _ref1785.style,
      tabIndex = _ref1785.tabIndex,
      rest = _objectWithoutProperties$2(_ref1785, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1785 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1785.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1785, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 10a6 6 0 0 0-4.46 10h-7.08A6 6 0 1 0 8 22h16a6 6 0 0 0 0-12zM4 16a4 4 0 1 1 4 4 4 4 0 0 1-4-4zm20 4a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
Voicemail32.displayName = 'Voicemail32';
Voicemail32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Voicemail32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Voicemail24 = React.forwardRef(function (_ref1786, ref) {
  var className = _ref1786.className,
      children = _ref1786.children,
      style = _ref1786.style,
      tabIndex = _ref1786.tabIndex,
      rest = _objectWithoutProperties$2(_ref1786, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1786 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1786.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1786, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 10a6 6 0 0 0-4.46 10h-7.08A6 6 0 1 0 8 22h16a6 6 0 0 0 0-12zM4 16a4 4 0 1 1 4 4 4 4 0 0 1-4-4zm20 4a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
Voicemail24.displayName = 'Voicemail24';
Voicemail24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Voicemail24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Voicemail20 = React.forwardRef(function (_ref1787, ref) {
  var className = _ref1787.className,
      children = _ref1787.children,
      style = _ref1787.style,
      tabIndex = _ref1787.tabIndex,
      rest = _objectWithoutProperties$2(_ref1787, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1787 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1787.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1787, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M24 10a6 6 0 0 0-4.46 10h-7.08A6 6 0 1 0 8 22h16a6 6 0 0 0 0-12zM4 16a4 4 0 1 1 4 4 4 4 0 0 1-4-4zm20 4a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
Voicemail20.displayName = 'Voicemail20';
Voicemail20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Voicemail20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeDownFilled32 = React.forwardRef(function (_ref1788, ref) {
  var className = _ref1788.className,
      children = _ref1788.children,
      style = _ref1788.style,
      tabIndex = _ref1788.tabIndex,
      rest = _objectWithoutProperties$2(_ref1788, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1788 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1788.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1788, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.1 10.66L23.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM20 30a1 1 0 0 1-.71-.3L11.67 22H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeDownFilled32.displayName = 'VolumeDownFilled32';
VolumeDownFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeDownFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeDownFilled24 = React.forwardRef(function (_ref1789, ref) {
  var className = _ref1789.className,
      children = _ref1789.children,
      style = _ref1789.style,
      tabIndex = _ref1789.tabIndex,
      rest = _objectWithoutProperties$2(_ref1789, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1789 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1789.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1789, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.1 10.66L23.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM20 30a1 1 0 0 1-.71-.3L11.67 22H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeDownFilled24.displayName = 'VolumeDownFilled24';
VolumeDownFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeDownFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeDownFilled20 = React.forwardRef(function (_ref1790, ref) {
  var className = _ref1790.className,
      children = _ref1790.children,
      style = _ref1790.style,
      tabIndex = _ref1790.tabIndex,
      rest = _objectWithoutProperties$2(_ref1790, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1790 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1790.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1790, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.1 10.66L23.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM20 30a1 1 0 0 1-.71-.3L11.67 22H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeDownFilled20.displayName = 'VolumeDownFilled20';
VolumeDownFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeDownFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeDown32 = React.forwardRef(function (_ref1791, ref) {
  var className = _ref1791.className,
      children = _ref1791.children,
      style = _ref1791.style,
      tabIndex = _ref1791.tabIndex,
      rest = _objectWithoutProperties$2(_ref1791, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1791 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1791.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1791, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.1 10.66L23.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM20 30a1 1 0 0 1-.71-.3L11.67 22H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM6 20h6a1.17 1.17 0 0 1 .79.3L19 26.57V5.43l-6.21 6.27a1.17 1.17 0 0 1-.79.3H6z'
  }));
});
VolumeDown32.displayName = 'VolumeDown32';
VolumeDown32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeDown32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeDown24 = React.forwardRef(function (_ref1792, ref) {
  var className = _ref1792.className,
      children = _ref1792.children,
      style = _ref1792.style,
      tabIndex = _ref1792.tabIndex,
      rest = _objectWithoutProperties$2(_ref1792, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1792 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1792.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1792, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.1 10.66L23.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM20 30a1 1 0 0 1-.71-.3L11.67 22H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM6 20h6a1.17 1.17 0 0 1 .79.3L19 26.57V5.43l-6.21 6.27a1.17 1.17 0 0 1-.79.3H6z'
  }));
});
VolumeDown24.displayName = 'VolumeDown24';
VolumeDown24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeDown24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeDown20 = React.forwardRef(function (_ref1793, ref) {
  var className = _ref1793.className,
      children = _ref1793.children,
      style = _ref1793.style,
      tabIndex = _ref1793.tabIndex,
      rest = _objectWithoutProperties$2(_ref1793, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1793 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1793.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1793, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M25.1 10.66L23.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM20 30a1 1 0 0 1-.71-.3L11.67 22H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM6 20h6a1.17 1.17 0 0 1 .79.3L19 26.57V5.43l-6.21 6.27a1.17 1.17 0 0 1-.79.3H6z'
  }));
});
VolumeDown20.displayName = 'VolumeDown20';
VolumeDown20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeDown20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeMuteFilled32 = React.forwardRef(function (_ref1794, ref) {
  var className = _ref1794.className,
      children = _ref1794.children,
      style = _ref1794.style,
      tabIndex = _ref1794.tabIndex,
      rest = _objectWithoutProperties$2(_ref1794, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1794 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1794.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1794, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeMuteFilled32.displayName = 'VolumeMuteFilled32';
VolumeMuteFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeMuteFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeMuteFilled24 = React.forwardRef(function (_ref1795, ref) {
  var className = _ref1795.className,
      children = _ref1795.children,
      style = _ref1795.style,
      tabIndex = _ref1795.tabIndex,
      rest = _objectWithoutProperties$2(_ref1795, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1795 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1795.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1795, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeMuteFilled24.displayName = 'VolumeMuteFilled24';
VolumeMuteFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeMuteFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeMuteFilled20 = React.forwardRef(function (_ref1796, ref) {
  var className = _ref1796.className,
      children = _ref1796.children,
      style = _ref1796.style,
      tabIndex = _ref1796.tabIndex,
      rest = _objectWithoutProperties$2(_ref1796, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1796 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1796.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1796, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeMuteFilled20.displayName = 'VolumeMuteFilled20';
VolumeMuteFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeMuteFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeMute32 = React.forwardRef(function (_ref1797, ref) {
  var className = _ref1797.className,
      children = _ref1797.children,
      style = _ref1797.style,
      tabIndex = _ref1797.tabIndex,
      rest = _objectWithoutProperties$2(_ref1797, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1797 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1797.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1797, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM4 20h6a1.17 1.17 0 0 1 .79.3L17 26.57V5.43l-6.21 6.27a1.17 1.17 0 0 1-.79.3H4z'
  }));
});
VolumeMute32.displayName = 'VolumeMute32';
VolumeMute32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeMute32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeMute24 = React.forwardRef(function (_ref1798, ref) {
  var className = _ref1798.className,
      children = _ref1798.children,
      style = _ref1798.style,
      tabIndex = _ref1798.tabIndex,
      rest = _objectWithoutProperties$2(_ref1798, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1798 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1798.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1798, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM4 20h6a1.17 1.17 0 0 1 .79.3L17 26.57V5.43l-6.21 6.27a1.17 1.17 0 0 1-.79.3H4z'
  }));
});
VolumeMute24.displayName = 'VolumeMute24';
VolumeMute24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeMute24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeMute20 = React.forwardRef(function (_ref1799, ref) {
  var className = _ref1799.className,
      children = _ref1799.children,
      style = _ref1799.style,
      tabIndex = _ref1799.tabIndex,
      rest = _objectWithoutProperties$2(_ref1799, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1799 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1799.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1799, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM4 20h6a1.17 1.17 0 0 1 .79.3L17 26.57V5.43l-6.21 6.27a1.17 1.17 0 0 1-.79.3H4z'
  }));
});
VolumeMute20.displayName = 'VolumeMute20';
VolumeMute20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeMute20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeUpFilled32 = React.forwardRef(function (_ref1800, ref) {
  var className = _ref1800.className,
      children = _ref1800.children,
      style = _ref1800.style,
      tabIndex = _ref1800.tabIndex,
      rest = _objectWithoutProperties$2(_ref1800, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1800 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1800.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1800, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.16 8.08l-1.53 1.29a10 10 0 0 1-.29 13.23l1.47 1.4a12 12 0 0 0 .35-15.88z'
  }), React.createElement('path', {
    d: 'M21.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeUpFilled32.displayName = 'VolumeUpFilled32';
VolumeUpFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeUpFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeUpFilled24 = React.forwardRef(function (_ref1801, ref) {
  var className = _ref1801.className,
      children = _ref1801.children,
      style = _ref1801.style,
      tabIndex = _ref1801.tabIndex,
      rest = _objectWithoutProperties$2(_ref1801, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1801 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1801.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1801, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.16 8.08l-1.53 1.29a10 10 0 0 1-.29 13.23l1.47 1.4a12 12 0 0 0 .35-15.88z'
  }), React.createElement('path', {
    d: 'M21.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeUpFilled24.displayName = 'VolumeUpFilled24';
VolumeUpFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeUpFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeUpFilled20 = React.forwardRef(function (_ref1802, ref) {
  var className = _ref1802.className,
      children = _ref1802.children,
      style = _ref1802.style,
      tabIndex = _ref1802.tabIndex,
      rest = _objectWithoutProperties$2(_ref1802, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1802 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1802.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1802, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.16 8.08l-1.53 1.29a10 10 0 0 1-.29 13.23l1.47 1.4a12 12 0 0 0 .35-15.88z'
  }), React.createElement('path', {
    d: 'M21.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1z'
  }));
});
VolumeUpFilled20.displayName = 'VolumeUpFilled20';
VolumeUpFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeUpFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeUp32 = React.forwardRef(function (_ref1803, ref) {
  var className = _ref1803.className,
      children = _ref1803.children,
      style = _ref1803.style,
      tabIndex = _ref1803.tabIndex,
      rest = _objectWithoutProperties$2(_ref1803, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1803 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1803.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1803, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.16 8.08l-1.53 1.29a10 10 0 0 1-.29 13.23l1.47 1.4a12 12 0 0 0 .35-15.88z'
  }), React.createElement('path', {
    d: 'M21.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM4 20h6.08a1 1 0 0 1 .71.3L17 26.57V5.43l-6.21 6.27a1 1 0 0 1-.71.3H4z'
  }));
});
VolumeUp32.displayName = 'VolumeUp32';
VolumeUp32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeUp32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeUp24 = React.forwardRef(function (_ref1804, ref) {
  var className = _ref1804.className,
      children = _ref1804.children,
      style = _ref1804.style,
      tabIndex = _ref1804.tabIndex,
      rest = _objectWithoutProperties$2(_ref1804, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1804 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1804.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1804, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.16 8.08l-1.53 1.29a10 10 0 0 1-.29 13.23l1.47 1.4a12 12 0 0 0 .35-15.88z'
  }), React.createElement('path', {
    d: 'M21.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM4 20h6.08a1 1 0 0 1 .71.3L17 26.57V5.43l-6.21 6.27a1 1 0 0 1-.71.3H4z'
  }));
});
VolumeUp24.displayName = 'VolumeUp24';
VolumeUp24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeUp24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var VolumeUp20 = React.forwardRef(function (_ref1805, ref) {
  var className = _ref1805.className,
      children = _ref1805.children,
      style = _ref1805.style,
      tabIndex = _ref1805.tabIndex,
      rest = _objectWithoutProperties$2(_ref1805, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1805 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1805.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1805, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.16 8.08l-1.53 1.29a10 10 0 0 1-.29 13.23l1.47 1.4a12 12 0 0 0 .35-15.88z'
  }), React.createElement('path', {
    d: 'M21.58 12a6 6 0 0 1-.18 7.94l1.47 1.36a8 8 0 0 0 .23-10.59zM18 30a1 1 0 0 1-.71-.3L9.67 22H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h6.67l7.62-7.7a1 1 0 0 1 1.41 0 1 1 0 0 1 .3.7v26a1 1 0 0 1-1 1zM4 20h6.08a1 1 0 0 1 .71.3L17 26.57V5.43l-6.21 6.27a1 1 0 0 1-.71.3H4z'
  }));
});
VolumeUp20.displayName = 'VolumeUp20';
VolumeUp20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
VolumeUp20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wallet32 = React.forwardRef(function (_ref1806, ref) {
  var className = _ref1806.className,
      children = _ref1806.children,
      style = _ref1806.style,
      tabIndex = _ref1806.tabIndex,
      rest = _objectWithoutProperties$2(_ref1806, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1806 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1806.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1806, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 17h2v2h-2z'
  }), React.createElement('path', {
    d: 'M28 8H4V5h22V3H4a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM4 26V10h24v3h-8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8v3zm24-11v6h-8v-6z'
  }));
});
Wallet32.displayName = 'Wallet32';
Wallet32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wallet32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wallet24 = React.forwardRef(function (_ref1807, ref) {
  var className = _ref1807.className,
      children = _ref1807.children,
      style = _ref1807.style,
      tabIndex = _ref1807.tabIndex,
      rest = _objectWithoutProperties$2(_ref1807, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1807 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1807.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1807, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 17h2v2h-2z'
  }), React.createElement('path', {
    d: 'M28 8H4V5h22V3H4a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM4 26V10h24v3h-8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8v3zm24-11v6h-8v-6z'
  }));
});
Wallet24.displayName = 'Wallet24';
Wallet24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wallet24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wallet20 = React.forwardRef(function (_ref1808, ref) {
  var className = _ref1808.className,
      children = _ref1808.children,
      style = _ref1808.style,
      tabIndex = _ref1808.tabIndex,
      rest = _objectWithoutProperties$2(_ref1808, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1808 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1808.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1808, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 17h2v2h-2z'
  }), React.createElement('path', {
    d: 'M28 8H4V5h22V3H4a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM4 26V10h24v3h-8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8v3zm24-11v6h-8v-6z'
  }));
});
Wallet20.displayName = 'Wallet20';
Wallet20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wallet20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAltFilled32 = React.forwardRef(function (_ref1809, ref) {
  var className = _ref1809.className,
      children = _ref1809.children,
      style = _ref1809.style,
      tabIndex = _ref1809.tabIndex,
      rest = _objectWithoutProperties$2(_ref1809, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1809 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1809.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1809, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.88 27.52l-13-25a1 1 0 0 0-1.76 0l-13 25a1 1 0 0 0 0 1A1 1 0 0 0 3 29h26a1 1 0 0 0 .86-.49 1 1 0 0 0 .02-.99zM14.88 10h2.25v10h-2.25zM16 26a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 26z'
  }));
});
WarningAltFilled32.displayName = 'WarningAltFilled32';
WarningAltFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAltFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAltFilled24 = React.forwardRef(function (_ref1810, ref) {
  var className = _ref1810.className,
      children = _ref1810.children,
      style = _ref1810.style,
      tabIndex = _ref1810.tabIndex,
      rest = _objectWithoutProperties$2(_ref1810, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1810 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1810.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1810, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.88 27.52l-13-25a1 1 0 0 0-1.76 0l-13 25a1 1 0 0 0 0 1A1 1 0 0 0 3 29h26a1 1 0 0 0 .86-.49 1 1 0 0 0 .02-.99zM14.88 10h2.25v10h-2.25zM16 26a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 26z'
  }));
});
WarningAltFilled24.displayName = 'WarningAltFilled24';
WarningAltFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAltFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAltFilled20 = React.forwardRef(function (_ref1811, ref) {
  var className = _ref1811.className,
      children = _ref1811.children,
      style = _ref1811.style,
      tabIndex = _ref1811.tabIndex,
      rest = _objectWithoutProperties$2(_ref1811, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1811 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1811.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1811, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M29.88 27.52l-13-25a1 1 0 0 0-1.76 0l-13 25a1 1 0 0 0 0 1A1 1 0 0 0 3 29h26a1 1 0 0 0 .86-.49 1 1 0 0 0 .02-.99zM14.88 10h2.25v10h-2.25zM16 26a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 26z'
  }));
});
WarningAltFilled20.displayName = 'WarningAltFilled20';
WarningAltFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAltFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAlt32 = React.forwardRef(function (_ref1812, ref) {
  var className = _ref1812.className,
      children = _ref1812.children,
      style = _ref1812.style,
      tabIndex = _ref1812.tabIndex,
      rest = _objectWithoutProperties$2(_ref1812, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1812 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1812.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1812, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22zm-1-11h2v9h-2z'
  }), React.createElement('path', {
    d: 'M29 29H3a1 1 0 0 1-.89-1.46l13-25a1 1 0 0 1 1.78 0l13 25A1 1 0 0 1 29 29zM4.65 27h22.7L16 5.17z'
  }));
});
WarningAlt32.displayName = 'WarningAlt32';
WarningAlt32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAlt32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAlt24 = React.forwardRef(function (_ref1813, ref) {
  var className = _ref1813.className,
      children = _ref1813.children,
      style = _ref1813.style,
      tabIndex = _ref1813.tabIndex,
      rest = _objectWithoutProperties$2(_ref1813, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1813 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1813.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1813, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22zm-1-11h2v9h-2z'
  }), React.createElement('path', {
    d: 'M29 29H3a1 1 0 0 1-.89-1.46l13-25a1 1 0 0 1 1.78 0l13 25A1 1 0 0 1 29 29zM4.65 27h22.7L16 5.17z'
  }));
});
WarningAlt24.displayName = 'WarningAlt24';
WarningAlt24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAlt24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningAlt20 = React.forwardRef(function (_ref1814, ref) {
  var className = _ref1814.className,
      children = _ref1814.children,
      style = _ref1814.style,
      tabIndex = _ref1814.tabIndex,
      rest = _objectWithoutProperties$2(_ref1814, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1814 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1814.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1814, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 22a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22zm-1-11h2v9h-2z'
  }), React.createElement('path', {
    d: 'M29 29H3a1 1 0 0 1-.89-1.46l13-25a1 1 0 0 1 1.78 0l13 25A1 1 0 0 1 29 29zM4.65 27h22.7L16 5.17z'
  }));
});
WarningAlt20.displayName = 'WarningAlt20';
WarningAlt20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningAlt20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningFilled32 = React.forwardRef(function (_ref1815, ref) {
  var className = _ref1815.className,
      children = _ref1815.children,
      style = _ref1815.style,
      tabIndex = _ref1815.tabIndex,
      rest = _objectWithoutProperties$2(_ref1815, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1815 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1815.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1815, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-1.13 6h2.25v11h-2.25zM16 25a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 25z'
  }));
});
WarningFilled32.displayName = 'WarningFilled32';
WarningFilled32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningFilled32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningFilled24 = React.forwardRef(function (_ref1816, ref) {
  var className = _ref1816.className,
      children = _ref1816.children,
      style = _ref1816.style,
      tabIndex = _ref1816.tabIndex,
      rest = _objectWithoutProperties$2(_ref1816, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1816 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1816.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1816, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-1.13 6h2.25v11h-2.25zM16 25a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 25z'
  }));
});
WarningFilled24.displayName = 'WarningFilled24';
WarningFilled24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningFilled24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WarningFilled20 = React.forwardRef(function (_ref1817, ref) {
  var className = _ref1817.className,
      children = _ref1817.children,
      style = _ref1817.style,
      tabIndex = _ref1817.tabIndex,
      rest = _objectWithoutProperties$2(_ref1817, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1817 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1817.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1817, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-1.13 6h2.25v11h-2.25zM16 25a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 25z'
  }));
});
WarningFilled20.displayName = 'WarningFilled20';
WarningFilled20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WarningFilled20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Warning32 = React.forwardRef(function (_ref1818, ref) {
  var className = _ref1818.className,
      children = _ref1818.children,
      style = _ref1818.style,
      tabIndex = _ref1818.tabIndex,
      rest = _objectWithoutProperties$2(_ref1818, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1818 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1818.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1818, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M15 8h2v11h-2zm1 14a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22z'
  }));
});
Warning32.displayName = 'Warning32';
Warning32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Warning32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Warning24 = React.forwardRef(function (_ref1819, ref) {
  var className = _ref1819.className,
      children = _ref1819.children,
      style = _ref1819.style,
      tabIndex = _ref1819.tabIndex,
      rest = _objectWithoutProperties$2(_ref1819, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1819 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1819.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1819, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M15 8h2v11h-2zm1 14a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22z'
  }));
});
Warning24.displayName = 'Warning24';
Warning24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Warning24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Warning20 = React.forwardRef(function (_ref1820, ref) {
  var className = _ref1820.className,
      children = _ref1820.children,
      style = _ref1820.style,
      tabIndex = _ref1820.tabIndex,
      rest = _objectWithoutProperties$2(_ref1820, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1820 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1820.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1820, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M15 8h2v11h-2zm1 14a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22z'
  }));
});
Warning20.displayName = 'Warning20';
Warning20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Warning20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Watch32 = React.forwardRef(function (_ref1821, ref) {
  var className = _ref1821.className,
      children = _ref1821.children,
      style = _ref1821.style,
      tabIndex = _ref1821.tabIndex,
      rest = _objectWithoutProperties$2(_ref1821, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1821 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1821.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1821, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 8h-1V2h-2v6h-6V2h-2v6h-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h1v6h2v-6h6v6h2v-6h1a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM10 22V10h12v12zm15-8h2v4h-2z'
  }));
});
Watch32.displayName = 'Watch32';
Watch32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Watch32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Watch24 = React.forwardRef(function (_ref1822, ref) {
  var className = _ref1822.className,
      children = _ref1822.children,
      style = _ref1822.style,
      tabIndex = _ref1822.tabIndex,
      rest = _objectWithoutProperties$2(_ref1822, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1822 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1822.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1822, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 8h-1V2h-2v6h-6V2h-2v6h-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h1v6h2v-6h6v6h2v-6h1a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM10 22V10h12v12zm15-8h2v4h-2z'
  }));
});
Watch24.displayName = 'Watch24';
Watch24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Watch24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Watch20 = React.forwardRef(function (_ref1823, ref) {
  var className = _ref1823.className,
      children = _ref1823.children,
      style = _ref1823.style,
      tabIndex = _ref1823.tabIndex,
      rest = _objectWithoutProperties$2(_ref1823, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1823 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1823.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1823, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 8h-1V2h-2v6h-6V2h-2v6h-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h1v6h2v-6h6v6h2v-6h1a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM10 22V10h12v12zm15-8h2v4h-2z'
  }));
});
Watch20.displayName = 'Watch20';
Watch20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Watch20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonMachineLearning32 = React.forwardRef(function (_ref1824, ref) {
  var className = _ref1824.className,
      children = _ref1824.children,
      style = _ref1824.style,
      tabIndex = _ref1824.tabIndex,
      rest = _objectWithoutProperties$2(_ref1824, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1824 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1824.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1824, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26h-2v-8.24l-3.23 3.88a1 1 0 0 1-1.54 0L12 17.76V26h-2V15a1 1 0 0 1 .66-.94 1 1 0 0 1 1.11.3L16 19.44l4.23-5.08a1 1 0 0 1 1.11-.3A1 1 0 0 1 22 15zM4.16 14.65l-3-1.75a.76.76 0 1 0-.76 1.32l3 1.78a.76.76 0 1 0 .76-1.31zm4.13-4.13a.73.73 0 0 0 1 .27.75.75 0 0 0 .28-1l-1.74-3a.76.76 0 1 0-1.32.76zM16 9a.76.76 0 0 0 .76-.76V4.76a.76.76 0 1 0-1.52 0v3.49A.76.76 0 0 0 16 9zm6.68 1.79a.75.75 0 0 0 .37.11.76.76 0 0 0 .66-.38l1.75-3a.76.76 0 0 0-1.32-.76l-1.74 3a.75.75 0 0 0 .28 1.03zm9.22 2.39a.76.76 0 0 0-1-.28l-3 1.75a.76.76 0 0 0 .7 1.35l3-1.74a.77.77 0 0 0 .3-1.08z'
  }));
});
WatsonMachineLearning32.displayName = 'WatsonMachineLearning32';
WatsonMachineLearning32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonMachineLearning32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonMachineLearning24 = React.forwardRef(function (_ref1825, ref) {
  var className = _ref1825.className,
      children = _ref1825.children,
      style = _ref1825.style,
      tabIndex = _ref1825.tabIndex,
      rest = _objectWithoutProperties$2(_ref1825, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1825 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1825.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1825, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26h-2v-8.24l-3.23 3.88a1 1 0 0 1-1.54 0L12 17.76V26h-2V15a1 1 0 0 1 .66-.94 1 1 0 0 1 1.11.3L16 19.44l4.23-5.08a1 1 0 0 1 1.11-.3A1 1 0 0 1 22 15zM4.16 14.65l-3-1.75a.76.76 0 1 0-.76 1.32l3 1.78a.76.76 0 1 0 .76-1.31zm4.13-4.13a.73.73 0 0 0 1 .27.75.75 0 0 0 .28-1l-1.74-3a.76.76 0 1 0-1.32.76zM16 9a.76.76 0 0 0 .76-.76V4.76a.76.76 0 1 0-1.52 0v3.49A.76.76 0 0 0 16 9zm6.68 1.79a.75.75 0 0 0 .37.11.76.76 0 0 0 .66-.38l1.75-3a.76.76 0 0 0-1.32-.76l-1.74 3a.75.75 0 0 0 .28 1.03zm9.22 2.39a.76.76 0 0 0-1-.28l-3 1.75a.76.76 0 0 0 .7 1.35l3-1.74a.77.77 0 0 0 .3-1.08z'
  }));
});
WatsonMachineLearning24.displayName = 'WatsonMachineLearning24';
WatsonMachineLearning24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonMachineLearning24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonMachineLearning20 = React.forwardRef(function (_ref1826, ref) {
  var className = _ref1826.className,
      children = _ref1826.children,
      style = _ref1826.style,
      tabIndex = _ref1826.tabIndex,
      rest = _objectWithoutProperties$2(_ref1826, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1826 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1826.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1826, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 26h-2v-8.24l-3.23 3.88a1 1 0 0 1-1.54 0L12 17.76V26h-2V15a1 1 0 0 1 .66-.94 1 1 0 0 1 1.11.3L16 19.44l4.23-5.08a1 1 0 0 1 1.11-.3A1 1 0 0 1 22 15zM4.16 14.65l-3-1.75a.76.76 0 1 0-.76 1.32l3 1.78a.76.76 0 1 0 .76-1.31zm4.13-4.13a.73.73 0 0 0 1 .27.75.75 0 0 0 .28-1l-1.74-3a.76.76 0 1 0-1.32.76zM16 9a.76.76 0 0 0 .76-.76V4.76a.76.76 0 1 0-1.52 0v3.49A.76.76 0 0 0 16 9zm6.68 1.79a.75.75 0 0 0 .37.11.76.76 0 0 0 .66-.38l1.75-3a.76.76 0 0 0-1.32-.76l-1.74 3a.75.75 0 0 0 .28 1.03zm9.22 2.39a.76.76 0 0 0-1-.28l-3 1.75a.76.76 0 0 0 .7 1.35l3-1.74a.77.77 0 0 0 .3-1.08z'
  }));
});
WatsonMachineLearning20.displayName = 'WatsonMachineLearning20';
WatsonMachineLearning20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonMachineLearning20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCursor32 = React.forwardRef(function (_ref1827, ref) {
  var className = _ref1827.className,
      children = _ref1827.children,
      style = _ref1827.style,
      tabIndex = _ref1827.tabIndex,
      rest = _objectWithoutProperties$2(_ref1827, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1827 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1827.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1827, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 4H4v9.01h2V6h7V4zm16.49 9.12l-9-5a1 1 0 0 0-1 0l-9 5A1 1 0 0 0 10 14v10a1 1 0 0 0 .52.87l9 5A1 1 0 0 0 20 30a1.05 1.05 0 0 0 .49-.13l9-5A1 1 0 0 0 30 24V14a1 1 0 0 0-.51-.88zM19 27.3l-7-3.89v-7.72l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56l-7 3.89v-7.72l7-3.89z'
  }));
});
WatsonHealth3DCursor32.displayName = 'WatsonHealth3DCursor32';
WatsonHealth3DCursor32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCursor32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCursor24 = React.forwardRef(function (_ref1828, ref) {
  var className = _ref1828.className,
      children = _ref1828.children,
      style = _ref1828.style,
      tabIndex = _ref1828.tabIndex,
      rest = _objectWithoutProperties$2(_ref1828, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1828 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1828.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1828, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 4H4v9.01h2V6h7V4zm16.49 9.12l-9-5a1 1 0 0 0-1 0l-9 5A1 1 0 0 0 10 14v10a1 1 0 0 0 .52.87l9 5A1 1 0 0 0 20 30a1.05 1.05 0 0 0 .49-.13l9-5A1 1 0 0 0 30 24V14a1 1 0 0 0-.51-.88zM19 27.3l-7-3.89v-7.72l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56l-7 3.89v-7.72l7-3.89z'
  }));
});
WatsonHealth3DCursor24.displayName = 'WatsonHealth3DCursor24';
WatsonHealth3DCursor24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCursor24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCursor20 = React.forwardRef(function (_ref1829, ref) {
  var className = _ref1829.className,
      children = _ref1829.children,
      style = _ref1829.style,
      tabIndex = _ref1829.tabIndex,
      rest = _objectWithoutProperties$2(_ref1829, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1829 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1829.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1829, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 4H4v9.01h2V6h7V4zm16.49 9.12l-9-5a1 1 0 0 0-1 0l-9 5A1 1 0 0 0 10 14v10a1 1 0 0 0 .52.87l9 5A1 1 0 0 0 20 30a1.05 1.05 0 0 0 .49-.13l9-5A1 1 0 0 0 30 24V14a1 1 0 0 0-.51-.88zM19 27.3l-7-3.89v-7.72l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56l-7 3.89v-7.72l7-3.89z'
  }));
});
WatsonHealth3DCursor20.displayName = 'WatsonHealth3DCursor20';
WatsonHealth3DCursor20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCursor20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DMprToggle32 = React.forwardRef(function (_ref1830, ref) {
  var className = _ref1830.className,
      children = _ref1830.children,
      style = _ref1830.style,
      tabIndex = _ref1830.tabIndex,
      rest = _objectWithoutProperties$2(_ref1830, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1830 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1830.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1830, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 2H2v9h2V4h7V2zM2 21v9h9v-2H4v-7H2zm28-10V2h-9v2h7v7h2zm-9 19h9v-9h-2v7h-7v2zm4.49-19.87l-9-5a1 1 0 0 0-1 0l-9 5A1 1 0 0 0 6 11v10a1 1 0 0 0 .51.87l9 5a1 1 0 0 0 1 0l9-5A1 1 0 0 0 26 21V11a1 1 0 0 0-.51-.87zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89v7.71l-7-3.89zm9 11.6v-7.71l7-3.89v7.71z'
  }));
});
WatsonHealth3DMprToggle32.displayName = 'WatsonHealth3DMprToggle32';
WatsonHealth3DMprToggle32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DMprToggle32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DMprToggle24 = React.forwardRef(function (_ref1831, ref) {
  var className = _ref1831.className,
      children = _ref1831.children,
      style = _ref1831.style,
      tabIndex = _ref1831.tabIndex,
      rest = _objectWithoutProperties$2(_ref1831, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1831 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1831.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1831, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 2H2v9h2V4h7V2zM2 21v9h9v-2H4v-7H2zm28-10V2h-9v2h7v7h2zm-9 19h9v-9h-2v7h-7v2zm4.49-19.87l-9-5a1 1 0 0 0-1 0l-9 5A1 1 0 0 0 6 11v10a1 1 0 0 0 .51.87l9 5a1 1 0 0 0 1 0l9-5A1 1 0 0 0 26 21V11a1 1 0 0 0-.51-.87zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89v7.71l-7-3.89zm9 11.6v-7.71l7-3.89v7.71z'
  }));
});
WatsonHealth3DMprToggle24.displayName = 'WatsonHealth3DMprToggle24';
WatsonHealth3DMprToggle24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DMprToggle24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DMprToggle20 = React.forwardRef(function (_ref1832, ref) {
  var className = _ref1832.className,
      children = _ref1832.children,
      style = _ref1832.style,
      tabIndex = _ref1832.tabIndex,
      rest = _objectWithoutProperties$2(_ref1832, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1832 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1832.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1832, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 2H2v9h2V4h7V2zM2 21v9h9v-2H4v-7H2zm28-10V2h-9v2h7v7h2zm-9 19h9v-9h-2v7h-7v2zm4.49-19.87l-9-5a1 1 0 0 0-1 0l-9 5A1 1 0 0 0 6 11v10a1 1 0 0 0 .51.87l9 5a1 1 0 0 0 1 0l9-5A1 1 0 0 0 26 21V11a1 1 0 0 0-.51-.87zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89v7.71l-7-3.89zm9 11.6v-7.71l7-3.89v7.71z'
  }));
});
WatsonHealth3DMprToggle20.displayName = 'WatsonHealth3DMprToggle20';
WatsonHealth3DMprToggle20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DMprToggle20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveAutoColon32 = React.forwardRef(function (_ref1833, ref) {
  var className = _ref1833.className,
      children = _ref1833.children,
      style = _ref1833.style,
      tabIndex = _ref1833.tabIndex,
      rest = _objectWithoutProperties$2(_ref1833, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1833 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1833.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1833, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.5 8h10.6a5 5 0 1 0 0-2H9.5a5.5 5.5 0 0 0 0 11h11a3.5 3.5 0 0 1 0 7h-8.6a5 5 0 1 0 0 2h8.6a5.5 5.5 0 0 0 0-11h-11a3.5 3.5 0 0 1 0-7zM25 4a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 28a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveAutoColon32.displayName = 'WatsonHealth3DCurveAutoColon32';
WatsonHealth3DCurveAutoColon32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveAutoColon32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveAutoColon24 = React.forwardRef(function (_ref1834, ref) {
  var className = _ref1834.className,
      children = _ref1834.children,
      style = _ref1834.style,
      tabIndex = _ref1834.tabIndex,
      rest = _objectWithoutProperties$2(_ref1834, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1834 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1834.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1834, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.5 8h10.6a5 5 0 1 0 0-2H9.5a5.5 5.5 0 0 0 0 11h11a3.5 3.5 0 0 1 0 7h-8.6a5 5 0 1 0 0 2h8.6a5.5 5.5 0 0 0 0-11h-11a3.5 3.5 0 0 1 0-7zM25 4a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 28a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveAutoColon24.displayName = 'WatsonHealth3DCurveAutoColon24';
WatsonHealth3DCurveAutoColon24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveAutoColon24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveAutoColon20 = React.forwardRef(function (_ref1835, ref) {
  var className = _ref1835.className,
      children = _ref1835.children,
      style = _ref1835.style,
      tabIndex = _ref1835.tabIndex,
      rest = _objectWithoutProperties$2(_ref1835, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1835 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1835.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1835, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9.5 8h10.6a5 5 0 1 0 0-2H9.5a5.5 5.5 0 0 0 0 11h11a3.5 3.5 0 0 1 0 7h-8.6a5 5 0 1 0 0 2h8.6a5.5 5.5 0 0 0 0-11h-11a3.5 3.5 0 0 1 0-7zM25 4a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 28a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveAutoColon20.displayName = 'WatsonHealth3DCurveAutoColon20';
WatsonHealth3DCurveAutoColon20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveAutoColon20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveAutoVessels32 = React.forwardRef(function (_ref1836, ref) {
  var className = _ref1836.className,
      children = _ref1836.children,
      style = _ref1836.style,
      tabIndex = _ref1836.tabIndex,
      rest = _objectWithoutProperties$2(_ref1836, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1836 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1836.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1836, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11a3 3 0 0 1 3-3h.1a5 5 0 1 0 0-2H20a5 5 0 0 0-5 5v1h-2a3 3 0 0 1-3-3V7a5 5 0 0 0-5-5H4v2h1a3 3 0 0 1 3 3v2a5 5 0 0 0 5 5h2v7a3 3 0 0 1-3 3h-.1a5 5 0 1 0 0 2h.1a5 5 0 0 0 5-5h2.5a2.5 2.5 0 0 1 2.5 2.5 4.51 4.51 0 0 0 4.5 4.5H28v-2h-1.5a2.5 2.5 0 0 1-2.5-2.5 4.51 4.51 0 0 0-4.5-4.5H17zm8-7a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 28a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveAutoVessels32.displayName = 'WatsonHealth3DCurveAutoVessels32';
WatsonHealth3DCurveAutoVessels32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveAutoVessels32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveAutoVessels24 = React.forwardRef(function (_ref1837, ref) {
  var className = _ref1837.className,
      children = _ref1837.children,
      style = _ref1837.style,
      tabIndex = _ref1837.tabIndex,
      rest = _objectWithoutProperties$2(_ref1837, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1837 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1837.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1837, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11a3 3 0 0 1 3-3h.1a5 5 0 1 0 0-2H20a5 5 0 0 0-5 5v1h-2a3 3 0 0 1-3-3V7a5 5 0 0 0-5-5H4v2h1a3 3 0 0 1 3 3v2a5 5 0 0 0 5 5h2v7a3 3 0 0 1-3 3h-.1a5 5 0 1 0 0 2h.1a5 5 0 0 0 5-5h2.5a2.5 2.5 0 0 1 2.5 2.5 4.51 4.51 0 0 0 4.5 4.5H28v-2h-1.5a2.5 2.5 0 0 1-2.5-2.5 4.51 4.51 0 0 0-4.5-4.5H17zm8-7a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 28a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveAutoVessels24.displayName = 'WatsonHealth3DCurveAutoVessels24';
WatsonHealth3DCurveAutoVessels24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveAutoVessels24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveAutoVessels20 = React.forwardRef(function (_ref1838, ref) {
  var className = _ref1838.className,
      children = _ref1838.children,
      style = _ref1838.style,
      tabIndex = _ref1838.tabIndex,
      rest = _objectWithoutProperties$2(_ref1838, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1838 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1838.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1838, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M17 11a3 3 0 0 1 3-3h.1a5 5 0 1 0 0-2H20a5 5 0 0 0-5 5v1h-2a3 3 0 0 1-3-3V7a5 5 0 0 0-5-5H4v2h1a3 3 0 0 1 3 3v2a5 5 0 0 0 5 5h2v7a3 3 0 0 1-3 3h-.1a5 5 0 1 0 0 2h.1a5 5 0 0 0 5-5h2.5a2.5 2.5 0 0 1 2.5 2.5 4.51 4.51 0 0 0 4.5 4.5H28v-2h-1.5a2.5 2.5 0 0 1-2.5-2.5 4.51 4.51 0 0 0-4.5-4.5H17zm8-7a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM7 28a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveAutoVessels20.displayName = 'WatsonHealth3DCurveAutoVessels20';
WatsonHealth3DCurveAutoVessels20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveAutoVessels20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveManual32 = React.forwardRef(function (_ref1839, ref) {
  var className = _ref1839.className,
      children = _ref1839.children,
      style = _ref1839.style,
      tabIndex = _ref1839.tabIndex,
      rest = _objectWithoutProperties$2(_ref1839, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1839 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1839.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1839, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 21a3 3 0 0 1-3 3h-.1a5 5 0 1 0 0 2h.1a5 5 0 0 0 5-5zm-8 7a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm8-15h2v6h-2zM25 2a5 5 0 0 0-4.9 4H20a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3h.1A5 5 0 1 0 25 2zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveManual32.displayName = 'WatsonHealth3DCurveManual32';
WatsonHealth3DCurveManual32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveManual32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveManual24 = React.forwardRef(function (_ref1840, ref) {
  var className = _ref1840.className,
      children = _ref1840.children,
      style = _ref1840.style,
      tabIndex = _ref1840.tabIndex,
      rest = _objectWithoutProperties$2(_ref1840, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1840 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1840.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1840, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 21a3 3 0 0 1-3 3h-.1a5 5 0 1 0 0 2h.1a5 5 0 0 0 5-5zm-8 7a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm8-15h2v6h-2zM25 2a5 5 0 0 0-4.9 4H20a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3h.1A5 5 0 1 0 25 2zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveManual24.displayName = 'WatsonHealth3DCurveManual24';
WatsonHealth3DCurveManual24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveManual24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3DCurveManual20 = React.forwardRef(function (_ref1841, ref) {
  var className = _ref1841.className,
      children = _ref1841.children,
      style = _ref1841.style,
      tabIndex = _ref1841.tabIndex,
      rest = _objectWithoutProperties$2(_ref1841, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1841 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1841.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1841, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 21a3 3 0 0 1-3 3h-.1a5 5 0 1 0 0 2h.1a5 5 0 0 0 5-5zm-8 7a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm8-15h2v6h-2zM25 2a5 5 0 0 0-4.9 4H20a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3h.1A5 5 0 1 0 25 2zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z'
  }));
});
WatsonHealth3DCurveManual20.displayName = 'WatsonHealth3DCurveManual20';
WatsonHealth3DCurveManual20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3DCurveManual20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3rdPartyConnected32 = React.forwardRef(function (_ref1842, ref) {
  var className = _ref1842.className,
      children = _ref1842.children,
      style = _ref1842.style,
      tabIndex = _ref1842.tabIndex,
      rest = _objectWithoutProperties$2(_ref1842, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1842 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1842.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1842, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 22a3.86 3.86 0 0 0-2 .57l-3.09-3.1a6 6 0 0 0 0-6.94L24 9.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-4-4 3.86 3.86 0 0 0 .57 2l-3.1 3.09a6 6 0 0 0-6.94 0L9.43 8A3.86 3.86 0 0 0 10 6a4 4 0 1 0-4 4 3.86 3.86 0 0 0 2-.57l3.09 3.1a6 6 0 0 0 0 6.94L8 22.57A3.86 3.86 0 0 0 6 22a4 4 0 1 0 4 4 3.86 3.86 0 0 0-.57-2l3.1-3.09a6 6 0 0 0 6.94 0l3.1 3.09a3.86 3.86 0 0 0-.57 2 4 4 0 1 0 4-4zm-10-2a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealth3rdPartyConnected32.displayName = 'WatsonHealth3rdPartyConnected32';
WatsonHealth3rdPartyConnected32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3rdPartyConnected32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3rdPartyConnected24 = React.forwardRef(function (_ref1843, ref) {
  var className = _ref1843.className,
      children = _ref1843.children,
      style = _ref1843.style,
      tabIndex = _ref1843.tabIndex,
      rest = _objectWithoutProperties$2(_ref1843, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1843 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1843.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1843, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 22a3.86 3.86 0 0 0-2 .57l-3.09-3.1a6 6 0 0 0 0-6.94L24 9.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-4-4 3.86 3.86 0 0 0 .57 2l-3.1 3.09a6 6 0 0 0-6.94 0L9.43 8A3.86 3.86 0 0 0 10 6a4 4 0 1 0-4 4 3.86 3.86 0 0 0 2-.57l3.09 3.1a6 6 0 0 0 0 6.94L8 22.57A3.86 3.86 0 0 0 6 22a4 4 0 1 0 4 4 3.86 3.86 0 0 0-.57-2l3.1-3.09a6 6 0 0 0 6.94 0l3.1 3.09a3.86 3.86 0 0 0-.57 2 4 4 0 1 0 4-4zm-10-2a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealth3rdPartyConnected24.displayName = 'WatsonHealth3rdPartyConnected24';
WatsonHealth3rdPartyConnected24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3rdPartyConnected24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealth3rdPartyConnected20 = React.forwardRef(function (_ref1844, ref) {
  var className = _ref1844.className,
      children = _ref1844.children,
      style = _ref1844.style,
      tabIndex = _ref1844.tabIndex,
      rest = _objectWithoutProperties$2(_ref1844, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1844 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1844.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1844, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 22a3.86 3.86 0 0 0-2 .57l-3.09-3.1a6 6 0 0 0 0-6.94L24 9.43a3.86 3.86 0 0 0 2 .57 4 4 0 1 0-4-4 3.86 3.86 0 0 0 .57 2l-3.1 3.09a6 6 0 0 0-6.94 0L9.43 8A3.86 3.86 0 0 0 10 6a4 4 0 1 0-4 4 3.86 3.86 0 0 0 2-.57l3.09 3.1a6 6 0 0 0 0 6.94L8 22.57A3.86 3.86 0 0 0 6 22a4 4 0 1 0 4 4 3.86 3.86 0 0 0-.57-2l3.1-3.09a6 6 0 0 0 6.94 0l3.1 3.09a3.86 3.86 0 0 0-.57 2 4 4 0 1 0 4-4zm-10-2a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealth3rdPartyConnected20.displayName = 'WatsonHealth3rdPartyConnected20';
WatsonHealth3rdPartyConnected20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealth3rdPartyConnected20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAngle32 = React.forwardRef(function (_ref1845, ref) {
  var className = _ref1845.className,
      children = _ref1845.children,
      style = _ref1845.style,
      tabIndex = _ref1845.tabIndex,
      rest = _objectWithoutProperties$2(_ref1845, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1845 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1845.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1845, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 24a3.51 3.51 0 0 0-.88-1.86l9.53-16.58-1.73-1-9.57 16.56A3.06 3.06 0 0 0 5.5 21a3.5 3.5 0 1 0 3.15 5H28v-2zm-3.5 2A1.5 1.5 0 1 1 7 24.5 1.5 1.5 0 0 1 5.5 26z'
  }), React.createElement('path', {
    d: 'M22 21h2a13 13 0 0 0-5.42-10.56l-1.16 1.62A11 11 0 0 1 22 21z'
  }));
});
WatsonHealthAngle32.displayName = 'WatsonHealthAngle32';
WatsonHealthAngle32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAngle32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAngle24 = React.forwardRef(function (_ref1846, ref) {
  var className = _ref1846.className,
      children = _ref1846.children,
      style = _ref1846.style,
      tabIndex = _ref1846.tabIndex,
      rest = _objectWithoutProperties$2(_ref1846, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1846 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1846.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1846, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 24a3.51 3.51 0 0 0-.88-1.86l9.53-16.58-1.73-1-9.57 16.56A3.06 3.06 0 0 0 5.5 21a3.5 3.5 0 1 0 3.15 5H28v-2zm-3.5 2A1.5 1.5 0 1 1 7 24.5 1.5 1.5 0 0 1 5.5 26z'
  }), React.createElement('path', {
    d: 'M22 21h2a13 13 0 0 0-5.42-10.56l-1.16 1.62A11 11 0 0 1 22 21z'
  }));
});
WatsonHealthAngle24.displayName = 'WatsonHealthAngle24';
WatsonHealthAngle24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAngle24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAngle20 = React.forwardRef(function (_ref1847, ref) {
  var className = _ref1847.className,
      children = _ref1847.children,
      style = _ref1847.style,
      tabIndex = _ref1847.tabIndex,
      rest = _objectWithoutProperties$2(_ref1847, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1847 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1847.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1847, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 24a3.51 3.51 0 0 0-.88-1.86l9.53-16.58-1.73-1-9.57 16.56A3.06 3.06 0 0 0 5.5 21a3.5 3.5 0 1 0 3.15 5H28v-2zm-3.5 2A1.5 1.5 0 1 1 7 24.5 1.5 1.5 0 0 1 5.5 26z'
  }), React.createElement('path', {
    d: 'M22 21h2a13 13 0 0 0-5.42-10.56l-1.16 1.62A11 11 0 0 1 22 21z'
  }));
});
WatsonHealthAngle20.displayName = 'WatsonHealthAngle20';
WatsonHealthAngle20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAngle20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAnnotationVisibility32 = React.forwardRef(function (_ref1848, ref) {
  var className = _ref1848.className,
      children = _ref1848.children,
      style = _ref1848.style,
      tabIndex = _ref1848.tabIndex,
      rest = _objectWithoutProperties$2(_ref1848, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1848 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1848.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1848, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H4V6h24z'
  }), React.createElement('path', {
    d: 'M21 20h-8a3.51 3.51 0 0 0-.88-1.86l3.8-6.64-1.74-1-3.78 6.62a3.35 3.35 0 0 0-.9-.12 3.5 3.5 0 1 0 3.15 5H21zM9.5 22a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9.5 22zM19 8h7v2h-7zm0 4h4v2h-4z'
  }));
});
WatsonHealthAnnotationVisibility32.displayName = 'WatsonHealthAnnotationVisibility32';
WatsonHealthAnnotationVisibility32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAnnotationVisibility32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAnnotationVisibility24 = React.forwardRef(function (_ref1849, ref) {
  var className = _ref1849.className,
      children = _ref1849.children,
      style = _ref1849.style,
      tabIndex = _ref1849.tabIndex,
      rest = _objectWithoutProperties$2(_ref1849, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1849 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1849.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1849, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H4V6h24z'
  }), React.createElement('path', {
    d: 'M21 20h-8a3.51 3.51 0 0 0-.88-1.86l3.8-6.64-1.74-1-3.78 6.62a3.35 3.35 0 0 0-.9-.12 3.5 3.5 0 1 0 3.15 5H21zM9.5 22a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9.5 22zM19 8h7v2h-7zm0 4h4v2h-4z'
  }));
});
WatsonHealthAnnotationVisibility24.displayName = 'WatsonHealthAnnotationVisibility24';
WatsonHealthAnnotationVisibility24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAnnotationVisibility24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAnnotationVisibility20 = React.forwardRef(function (_ref1850, ref) {
  var className = _ref1850.className,
      children = _ref1850.children,
      style = _ref1850.style,
      tabIndex = _ref1850.tabIndex,
      rest = _objectWithoutProperties$2(_ref1850, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1850 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1850.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1850, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 22H4V6h24z'
  }), React.createElement('path', {
    d: 'M21 20h-8a3.51 3.51 0 0 0-.88-1.86l3.8-6.64-1.74-1-3.78 6.62a3.35 3.35 0 0 0-.9-.12 3.5 3.5 0 1 0 3.15 5H21zM9.5 22a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9.5 22zM19 8h7v2h-7zm0 4h4v2h-4z'
  }));
});
WatsonHealthAnnotationVisibility20.displayName = 'WatsonHealthAnnotationVisibility20';
WatsonHealthAnnotationVisibility20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAnnotationVisibility20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthArrowAnnotation32 = React.forwardRef(function (_ref1851, ref) {
  var className = _ref1851.className,
      children = _ref1851.children,
      style = _ref1851.style,
      tabIndex = _ref1851.tabIndex,
      rest = _objectWithoutProperties$2(_ref1851, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1851 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1851.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1851, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.71 12.29L7.42 6H14V4H4v9.99l2 .02v-6.6l6.29 6.29 1.42-1.41zM28 10H18v2h10v16H12V18h-2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M19 25h2v-7h3v-2h-8v2h3v7z'
  }));
});
WatsonHealthArrowAnnotation32.displayName = 'WatsonHealthArrowAnnotation32';
WatsonHealthArrowAnnotation32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthArrowAnnotation32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthArrowAnnotation24 = React.forwardRef(function (_ref1852, ref) {
  var className = _ref1852.className,
      children = _ref1852.children,
      style = _ref1852.style,
      tabIndex = _ref1852.tabIndex,
      rest = _objectWithoutProperties$2(_ref1852, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1852 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1852.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1852, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.71 12.29L7.42 6H14V4H4v9.99l2 .02v-6.6l6.29 6.29 1.42-1.41zM28 10H18v2h10v16H12V18h-2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M19 25h2v-7h3v-2h-8v2h3v7z'
  }));
});
WatsonHealthArrowAnnotation24.displayName = 'WatsonHealthArrowAnnotation24';
WatsonHealthArrowAnnotation24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthArrowAnnotation24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthArrowAnnotation20 = React.forwardRef(function (_ref1853, ref) {
  var className = _ref1853.className,
      children = _ref1853.children,
      style = _ref1853.style,
      tabIndex = _ref1853.tabIndex,
      rest = _objectWithoutProperties$2(_ref1853, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1853 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1853.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1853, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.71 12.29L7.42 6H14V4H4v9.99l2 .02v-6.6l6.29 6.29 1.42-1.41zM28 10H18v2h10v16H12V18h-2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M19 25h2v-7h3v-2h-8v2h3v7z'
  }));
});
WatsonHealthArrowAnnotation20.displayName = 'WatsonHealthArrowAnnotation20';
WatsonHealthArrowAnnotation20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthArrowAnnotation20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAutoScroll32 = React.forwardRef(function (_ref1854, ref) {
  var className = _ref1854.className,
      children = _ref1854.children,
      style = _ref1854.style,
      tabIndex = _ref1854.tabIndex,
      rest = _objectWithoutProperties$2(_ref1854, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1854 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1854.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1854, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 16a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm-2 11.17l-5.6-5.59L9 23l7 7 7-7-1.41-1.41L16 27.17zm0-22.34l5.58 5.57L23 9l-7-7-7 7 1.41 1.41L16 4.83z'
  }));
});
WatsonHealthAutoScroll32.displayName = 'WatsonHealthAutoScroll32';
WatsonHealthAutoScroll32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAutoScroll32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAutoScroll24 = React.forwardRef(function (_ref1855, ref) {
  var className = _ref1855.className,
      children = _ref1855.children,
      style = _ref1855.style,
      tabIndex = _ref1855.tabIndex,
      rest = _objectWithoutProperties$2(_ref1855, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1855 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1855.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1855, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 16a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm-2 11.17l-5.6-5.59L9 23l7 7 7-7-1.41-1.41L16 27.17zm0-22.34l5.58 5.57L23 9l-7-7-7 7 1.41 1.41L16 4.83z'
  }));
});
WatsonHealthAutoScroll24.displayName = 'WatsonHealthAutoScroll24';
WatsonHealthAutoScroll24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAutoScroll24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthAutoScroll20 = React.forwardRef(function (_ref1856, ref) {
  var className = _ref1856.className,
      children = _ref1856.children,
      style = _ref1856.style,
      tabIndex = _ref1856.tabIndex,
      rest = _objectWithoutProperties$2(_ref1856, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1856 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1856.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1856, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 16a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm-2 11.17l-5.6-5.59L9 23l7 7 7-7-1.41-1.41L16 27.17zm0-22.34l5.58 5.57L23 9l-7-7-7 7 1.41 1.41L16 4.83z'
  }));
});
WatsonHealthAutoScroll20.displayName = 'WatsonHealthAutoScroll20';
WatsonHealthAutoScroll20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthAutoScroll20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdArchive32 = React.forwardRef(function (_ref1857, ref) {
  var className = _ref1857.className,
      children = _ref1857.children,
      style = _ref1857.style,
      tabIndex = _ref1857.tabIndex,
      rest = _objectWithoutProperties$2(_ref1857, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1857 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1857.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1857, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10 10 0 0 0 16 6z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }));
});
WatsonHealthCdArchive32.displayName = 'WatsonHealthCdArchive32';
WatsonHealthCdArchive32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdArchive32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdArchive24 = React.forwardRef(function (_ref1858, ref) {
  var className = _ref1858.className,
      children = _ref1858.children,
      style = _ref1858.style,
      tabIndex = _ref1858.tabIndex,
      rest = _objectWithoutProperties$2(_ref1858, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1858 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1858.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1858, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10 10 0 0 0 16 6z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }));
});
WatsonHealthCdArchive24.displayName = 'WatsonHealthCdArchive24';
WatsonHealthCdArchive24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdArchive24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdArchive20 = React.forwardRef(function (_ref1859, ref) {
  var className = _ref1859.className,
      children = _ref1859.children,
      style = _ref1859.style,
      tabIndex = _ref1859.tabIndex,
      rest = _objectWithoutProperties$2(_ref1859, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1859 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1859.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1859, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10 10 0 0 0 16 6z'
  }), React.createElement('path', {
    d: 'M16 22a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }));
});
WatsonHealthCdArchive20.displayName = 'WatsonHealthCdArchive20';
WatsonHealthCdArchive20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdArchive20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdCreateArchive32 = React.forwardRef(function (_ref1860, ref) {
  var className = _ref1860.className,
      children = _ref1860.children,
      style = _ref1860.style,
      tabIndex = _ref1860.tabIndex,
      rest = _objectWithoutProperties$2(_ref1860, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1860 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1860.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1860, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 20a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('circle', {
    cx: '14',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M17 23.54A10 10 0 1 1 24 14c0 .34 0 .67-.05 1h2c0-.33.05-.66.05-1a12 12 0 1 0-12 12 12.33 12.33 0 0 0 3-.39z'
  }), React.createElement('path', {
    d: 'M25 30l-2.14-1A5 5 0 0 1 20 24.47V18h10v6.47A5 5 0 0 1 27.14 29zm-3-10v4.47a3 3 0 0 0 1.72 2.71l1.28.61 1.28-.61A3 3 0 0 0 28 24.47V20z'
  }));
});
WatsonHealthCdCreateArchive32.displayName = 'WatsonHealthCdCreateArchive32';
WatsonHealthCdCreateArchive32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdCreateArchive32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdCreateArchive24 = React.forwardRef(function (_ref1861, ref) {
  var className = _ref1861.className,
      children = _ref1861.children,
      style = _ref1861.style,
      tabIndex = _ref1861.tabIndex,
      rest = _objectWithoutProperties$2(_ref1861, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1861 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1861.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1861, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 20a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('circle', {
    cx: '14',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M17 23.54A10 10 0 1 1 24 14c0 .34 0 .67-.05 1h2c0-.33.05-.66.05-1a12 12 0 1 0-12 12 12.33 12.33 0 0 0 3-.39z'
  }), React.createElement('path', {
    d: 'M25 30l-2.14-1A5 5 0 0 1 20 24.47V18h10v6.47A5 5 0 0 1 27.14 29zm-3-10v4.47a3 3 0 0 0 1.72 2.71l1.28.61 1.28-.61A3 3 0 0 0 28 24.47V20z'
  }));
});
WatsonHealthCdCreateArchive24.displayName = 'WatsonHealthCdCreateArchive24';
WatsonHealthCdCreateArchive24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdCreateArchive24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdCreateArchive20 = React.forwardRef(function (_ref1862, ref) {
  var className = _ref1862.className,
      children = _ref1862.children,
      style = _ref1862.style,
      tabIndex = _ref1862.tabIndex,
      rest = _objectWithoutProperties$2(_ref1862, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1862 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1862.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1862, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M14 20a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }), React.createElement('circle', {
    cx: '14',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M17 23.54A10 10 0 1 1 24 14c0 .34 0 .67-.05 1h2c0-.33.05-.66.05-1a12 12 0 1 0-12 12 12.33 12.33 0 0 0 3-.39z'
  }), React.createElement('path', {
    d: 'M25 30l-2.14-1A5 5 0 0 1 20 24.47V18h10v6.47A5 5 0 0 1 27.14 29zm-3-10v4.47a3 3 0 0 0 1.72 2.71l1.28.61 1.28-.61A3 3 0 0 0 28 24.47V20z'
  }));
});
WatsonHealthCdCreateArchive20.displayName = 'WatsonHealthCdCreateArchive20';
WatsonHealthCdCreateArchive20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdCreateArchive20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdCreateExchange32 = React.forwardRef(function (_ref1863, ref) {
  var className = _ref1863.className,
      children = _ref1863.children,
      style = _ref1863.style,
      tabIndex = _ref1863.tabIndex,
      rest = _objectWithoutProperties$2(_ref1863, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1863 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1863.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1863, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '14',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M14 2a12 12 0 0 0 0 24v-2a10 10 0 1 1 10-10 8.27 8.27 0 0 1 0 1h2c0-.33.05-.66.05-1A12 12 0 0 0 14 2z'
  }), React.createElement('path', {
    d: 'M17 24h9.17l-2.59 2.59L25 28l5-5-5-5-1.42 1.42L26.17 22H17v2zm-3-4a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }));
});
WatsonHealthCdCreateExchange32.displayName = 'WatsonHealthCdCreateExchange32';
WatsonHealthCdCreateExchange32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdCreateExchange32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdCreateExchange24 = React.forwardRef(function (_ref1864, ref) {
  var className = _ref1864.className,
      children = _ref1864.children,
      style = _ref1864.style,
      tabIndex = _ref1864.tabIndex,
      rest = _objectWithoutProperties$2(_ref1864, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1864 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1864.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1864, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '14',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M14 2a12 12 0 0 0 0 24v-2a10 10 0 1 1 10-10 8.27 8.27 0 0 1 0 1h2c0-.33.05-.66.05-1A12 12 0 0 0 14 2z'
  }), React.createElement('path', {
    d: 'M17 24h9.17l-2.59 2.59L25 28l5-5-5-5-1.42 1.42L26.17 22H17v2zm-3-4a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }));
});
WatsonHealthCdCreateExchange24.displayName = 'WatsonHealthCdCreateExchange24';
WatsonHealthCdCreateExchange24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdCreateExchange24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCdCreateExchange20 = React.forwardRef(function (_ref1865, ref) {
  var className = _ref1865.className,
      children = _ref1865.children,
      style = _ref1865.style,
      tabIndex = _ref1865.tabIndex,
      rest = _objectWithoutProperties$2(_ref1865, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1865 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1865.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1865, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '14',
    cy: '14',
    r: '2'
  }), React.createElement('path', {
    d: 'M14 2a12 12 0 0 0 0 24v-2a10 10 0 1 1 10-10 8.27 8.27 0 0 1 0 1h2c0-.33.05-.66.05-1A12 12 0 0 0 14 2z'
  }), React.createElement('path', {
    d: 'M17 24h9.17l-2.59 2.59L25 28l5-5-5-5-1.42 1.42L26.17 22H17v2zm-3-4a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0-4-4z'
  }));
});
WatsonHealthCdCreateExchange20.displayName = 'WatsonHealthCdCreateExchange20';
WatsonHealthCdCreateExchange20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCdCreateExchange20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCircleMeasurement32 = React.forwardRef(function (_ref1866, ref) {
  var className = _ref1866.className,
      children = _ref1866.children,
      style = _ref1866.style,
      tabIndex = _ref1866.tabIndex,
      rest = _objectWithoutProperties$2(_ref1866, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1866 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1866.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1866, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }), React.createElement('path', {
    d: 'M21 12.41V16h2V9h-7v2h3.59L11 19.59V16H9v7h7v-2h-3.59z'
  }));
});
WatsonHealthCircleMeasurement32.displayName = 'WatsonHealthCircleMeasurement32';
WatsonHealthCircleMeasurement32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCircleMeasurement32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCircleMeasurement24 = React.forwardRef(function (_ref1867, ref) {
  var className = _ref1867.className,
      children = _ref1867.children,
      style = _ref1867.style,
      tabIndex = _ref1867.tabIndex,
      rest = _objectWithoutProperties$2(_ref1867, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1867 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1867.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1867, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }), React.createElement('path', {
    d: 'M21 12.41V16h2V9h-7v2h3.59L11 19.59V16H9v7h7v-2h-3.59z'
  }));
});
WatsonHealthCircleMeasurement24.displayName = 'WatsonHealthCircleMeasurement24';
WatsonHealthCircleMeasurement24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCircleMeasurement24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCircleMeasurement20 = React.forwardRef(function (_ref1868, ref) {
  var className = _ref1868.className,
      children = _ref1868.children,
      style = _ref1868.style,
      tabIndex = _ref1868.tabIndex,
      rest = _objectWithoutProperties$2(_ref1868, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1868 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1868.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1868, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4z'
  }), React.createElement('path', {
    d: 'M21 12.41V16h2V9h-7v2h3.59L11 19.59V16H9v7h7v-2h-3.59z'
  }));
});
WatsonHealthCircleMeasurement20.displayName = 'WatsonHealthCircleMeasurement20';
WatsonHealthCircleMeasurement20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCircleMeasurement20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCobbAngle32 = React.forwardRef(function (_ref1869, ref) {
  var className = _ref1869.className,
      children = _ref1869.children,
      style = _ref1869.style,
      tabIndex = _ref1869.tabIndex,
      rest = _objectWithoutProperties$2(_ref1869, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1869 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1869.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1869, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 17v-2a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zm-10-2h8v2h-8zm13.42 9.48A2 2 0 0 0 21 23.06l-7.73 2.07a2 2 0 0 0-1.42 2.44l.52 1.93a2 2 0 0 0 1.9 1.5 3 3 0 0 0 .52-.07l7.73-2.07a2 2 0 0 0 1.41-2.45zM14.27 29l-.51-1.94L21.48 25l.52 1.92zM13.24 6.86L21 8.93a2.24 2.24 0 0 0 .51.07 2 2 0 0 0 1.94-1.48L24 5.58a2 2 0 0 0-1.41-2.45l-7.8-2.07a2 2 0 0 0-2.45 1.41l-.52 1.93a2 2 0 0 0 1.42 2.44zm1-3.86L22 5.07 21.48 7l-7.72-2.07zM14 21h2v2h-2zm0-12h2v2h-2z'
  }));
});
WatsonHealthCobbAngle32.displayName = 'WatsonHealthCobbAngle32';
WatsonHealthCobbAngle32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCobbAngle32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCobbAngle24 = React.forwardRef(function (_ref1870, ref) {
  var className = _ref1870.className,
      children = _ref1870.children,
      style = _ref1870.style,
      tabIndex = _ref1870.tabIndex,
      rest = _objectWithoutProperties$2(_ref1870, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1870 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1870.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1870, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 17v-2a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zm-10-2h8v2h-8zm13.42 9.48A2 2 0 0 0 21 23.06l-7.73 2.07a2 2 0 0 0-1.42 2.44l.52 1.93a2 2 0 0 0 1.9 1.5 3 3 0 0 0 .52-.07l7.73-2.07a2 2 0 0 0 1.41-2.45zM14.27 29l-.51-1.94L21.48 25l.52 1.92zM13.24 6.86L21 8.93a2.24 2.24 0 0 0 .51.07 2 2 0 0 0 1.94-1.48L24 5.58a2 2 0 0 0-1.41-2.45l-7.8-2.07a2 2 0 0 0-2.45 1.41l-.52 1.93a2 2 0 0 0 1.42 2.44zm1-3.86L22 5.07 21.48 7l-7.72-2.07zM14 21h2v2h-2zm0-12h2v2h-2z'
  }));
});
WatsonHealthCobbAngle24.displayName = 'WatsonHealthCobbAngle24';
WatsonHealthCobbAngle24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCobbAngle24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCobbAngle20 = React.forwardRef(function (_ref1871, ref) {
  var className = _ref1871.className,
      children = _ref1871.children,
      style = _ref1871.style,
      tabIndex = _ref1871.tabIndex,
      rest = _objectWithoutProperties$2(_ref1871, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1871 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1871.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1871, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 17v-2a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zm-10-2h8v2h-8zm13.42 9.48A2 2 0 0 0 21 23.06l-7.73 2.07a2 2 0 0 0-1.42 2.44l.52 1.93a2 2 0 0 0 1.9 1.5 3 3 0 0 0 .52-.07l7.73-2.07a2 2 0 0 0 1.41-2.45zM14.27 29l-.51-1.94L21.48 25l.52 1.92zM13.24 6.86L21 8.93a2.24 2.24 0 0 0 .51.07 2 2 0 0 0 1.94-1.48L24 5.58a2 2 0 0 0-1.41-2.45l-7.8-2.07a2 2 0 0 0-2.45 1.41l-.52 1.93a2 2 0 0 0 1.42 2.44zm1-3.86L22 5.07 21.48 7l-7.72-2.07zM14 21h2v2h-2zm0-12h2v2h-2z'
  }));
});
WatsonHealthCobbAngle20.displayName = 'WatsonHealthCobbAngle20';
WatsonHealthCobbAngle20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCobbAngle20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCrossReference32 = React.forwardRef(function (_ref1872, ref) {
  var className = _ref1872.className,
      children = _ref1872.children,
      style = _ref1872.style,
      tabIndex = _ref1872.tabIndex,
      rest = _objectWithoutProperties$2(_ref1872, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1872 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1872.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1872, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 24h4v2h-4zm-6 0h4v2H5zm18 0h4v2h-4zm-6 0h4v2h-4zm-8-2a4.92 4.92 0 0 1 4-2h6a5.22 5.22 0 0 1 4 2h2.3a6.87 6.87 0 0 0-6.3-4h-6a6.87 6.87 0 0 0-6.3 4zm15 6h2v2h-2zM6 28h2v2H6zm10-12a7 7 0 1 1 7-7 7 7 0 0 1-7 7zm0-12a5 5 0 0 0-5 5 5 5 0 0 0 10 0 5 5 0 0 0-5-5z'
  }));
});
WatsonHealthCrossReference32.displayName = 'WatsonHealthCrossReference32';
WatsonHealthCrossReference32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCrossReference32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCrossReference24 = React.forwardRef(function (_ref1873, ref) {
  var className = _ref1873.className,
      children = _ref1873.children,
      style = _ref1873.style,
      tabIndex = _ref1873.tabIndex,
      rest = _objectWithoutProperties$2(_ref1873, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1873 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1873.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1873, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 24h4v2h-4zm-6 0h4v2H5zm18 0h4v2h-4zm-6 0h4v2h-4zm-8-2a4.92 4.92 0 0 1 4-2h6a5.22 5.22 0 0 1 4 2h2.3a6.87 6.87 0 0 0-6.3-4h-6a6.87 6.87 0 0 0-6.3 4zm15 6h2v2h-2zM6 28h2v2H6zm10-12a7 7 0 1 1 7-7 7 7 0 0 1-7 7zm0-12a5 5 0 0 0-5 5 5 5 0 0 0 10 0 5 5 0 0 0-5-5z'
  }));
});
WatsonHealthCrossReference24.displayName = 'WatsonHealthCrossReference24';
WatsonHealthCrossReference24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCrossReference24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthCrossReference20 = React.forwardRef(function (_ref1874, ref) {
  var className = _ref1874.className,
      children = _ref1874.children,
      style = _ref1874.style,
      tabIndex = _ref1874.tabIndex,
      rest = _objectWithoutProperties$2(_ref1874, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1874 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1874.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1874, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 24h4v2h-4zm-6 0h4v2H5zm18 0h4v2h-4zm-6 0h4v2h-4zm-8-2a4.92 4.92 0 0 1 4-2h6a5.22 5.22 0 0 1 4 2h2.3a6.87 6.87 0 0 0-6.3-4h-6a6.87 6.87 0 0 0-6.3 4zm15 6h2v2h-2zM6 28h2v2H6zm10-12a7 7 0 1 1 7-7 7 7 0 0 1-7 7zm0-12a5 5 0 0 0-5 5 5 5 0 0 0 10 0 5 5 0 0 0-5-5z'
  }));
});
WatsonHealthCrossReference20.displayName = 'WatsonHealthCrossReference20';
WatsonHealthCrossReference20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthCrossReference20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthDicom_600032 = React.forwardRef(function (_ref1875, ref) {
  var className = _ref1875.className,
      children = _ref1875.children,
      style = _ref1875.style,
      tabIndex = _ref1875.tabIndex,
      rest = _objectWithoutProperties$2(_ref1875, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1875 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1875.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1875, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 11H7a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm10 0h10v2H20zm0 4h10v2H20zm0 4h6v2h-6zM5 30H3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3v2H3v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-2-4v2h2v-2zm10 4h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6zm10 8h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6zm10 8h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6z'
  }));
});
WatsonHealthDicom_600032.displayName = 'WatsonHealthDicom_600032';
WatsonHealthDicom_600032.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthDicom_600032.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthDicom_600024 = React.forwardRef(function (_ref1876, ref) {
  var className = _ref1876.className,
      children = _ref1876.children,
      style = _ref1876.style,
      tabIndex = _ref1876.tabIndex,
      rest = _objectWithoutProperties$2(_ref1876, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1876 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1876.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1876, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 11H7a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm10 0h10v2H20zm0 4h10v2H20zm0 4h6v2h-6zM5 30H3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3v2H3v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-2-4v2h2v-2zm10 4h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6zm10 8h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6zm10 8h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6z'
  }));
});
WatsonHealthDicom_600024.displayName = 'WatsonHealthDicom_600024';
WatsonHealthDicom_600024.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthDicom_600024.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthDicom_600020 = React.forwardRef(function (_ref1877, ref) {
  var className = _ref1877.className,
      children = _ref1877.children,
      style = _ref1877.style,
      tabIndex = _ref1877.tabIndex,
      rest = _objectWithoutProperties$2(_ref1877, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1877 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1877.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1877, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13 11H7a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm10 0h10v2H20zm0 4h10v2H20zm0 4h6v2h-6zM5 30H3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h3v2H3v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-2-4v2h2v-2zm10 4h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6zm10 8h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6zm10 8h-2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-2-8v6h2v-6z'
  }));
});
WatsonHealthDicom_600020.displayName = 'WatsonHealthDicom_600020';
WatsonHealthDicom_600020.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthDicom_600020.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthDicomOverlay32 = React.forwardRef(function (_ref1878, ref) {
  var className = _ref1878.className,
      children = _ref1878.children,
      style = _ref1878.style,
      tabIndex = _ref1878.tabIndex,
      rest = _objectWithoutProperties$2(_ref1878, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1878 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1878.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1878, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6v20H4V6h24m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M6 8h10v2H6zm0 4h10v2H6zm0 4h6v2H6z'
  }));
});
WatsonHealthDicomOverlay32.displayName = 'WatsonHealthDicomOverlay32';
WatsonHealthDicomOverlay32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthDicomOverlay32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthDicomOverlay24 = React.forwardRef(function (_ref1879, ref) {
  var className = _ref1879.className,
      children = _ref1879.children,
      style = _ref1879.style,
      tabIndex = _ref1879.tabIndex,
      rest = _objectWithoutProperties$2(_ref1879, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1879 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1879.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1879, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6v20H4V6h24m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M6 8h10v2H6zm0 4h10v2H6zm0 4h6v2H6z'
  }));
});
WatsonHealthDicomOverlay24.displayName = 'WatsonHealthDicomOverlay24';
WatsonHealthDicomOverlay24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthDicomOverlay24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthDicomOverlay20 = React.forwardRef(function (_ref1880, ref) {
  var className = _ref1880.className,
      children = _ref1880.children,
      style = _ref1880.style,
      tabIndex = _ref1880.tabIndex,
      rest = _objectWithoutProperties$2(_ref1880, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1880 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1880.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1880, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M28 6v20H4V6h24m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }), React.createElement('path', {
    d: 'M6 8h10v2H6zm0 4h10v2H6zm0 4h6v2H6z'
  }));
});
WatsonHealthDicomOverlay20.displayName = 'WatsonHealthDicomOverlay20';
WatsonHealthDicomOverlay20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthDicomOverlay20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthEditFilter32 = React.forwardRef(function (_ref1881, ref) {
  var className = _ref1881.className,
      children = _ref1881.children,
      style = _ref1881.style,
      tabIndex = _ref1881.tabIndex,
      rest = _objectWithoutProperties$2(_ref1881, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1881 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1881.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1881, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H4v3.17l7.41 7.42.59.58V26h4v-2h2v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8l-7.41-7.41A2 2 0 0 1 2 9.17V6a2 2 0 0 1 2-2h22z'
  }), React.createElement('path', {
    d: 'M29.71 11.29l-3-3a1 1 0 0 0-1.42 0L16 17.59V22h4.41l9.3-9.29a1 1 0 0 0 0-1.42zM19.59 20H18v-1.59l5-5L24.59 15zM26 13.59L24.41 12 26 10.41 27.59 12z'
  }));
});
WatsonHealthEditFilter32.displayName = 'WatsonHealthEditFilter32';
WatsonHealthEditFilter32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthEditFilter32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthEditFilter24 = React.forwardRef(function (_ref1882, ref) {
  var className = _ref1882.className,
      children = _ref1882.children,
      style = _ref1882.style,
      tabIndex = _ref1882.tabIndex,
      rest = _objectWithoutProperties$2(_ref1882, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1882 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1882.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1882, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H4v3.17l7.41 7.42.59.58V26h4v-2h2v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8l-7.41-7.41A2 2 0 0 1 2 9.17V6a2 2 0 0 1 2-2h22z'
  }), React.createElement('path', {
    d: 'M29.71 11.29l-3-3a1 1 0 0 0-1.42 0L16 17.59V22h4.41l9.3-9.29a1 1 0 0 0 0-1.42zM19.59 20H18v-1.59l5-5L24.59 15zM26 13.59L24.41 12 26 10.41 27.59 12z'
  }));
});
WatsonHealthEditFilter24.displayName = 'WatsonHealthEditFilter24';
WatsonHealthEditFilter24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthEditFilter24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthEditFilter20 = React.forwardRef(function (_ref1883, ref) {
  var className = _ref1883.className,
      children = _ref1883.children,
      style = _ref1883.style,
      tabIndex = _ref1883.tabIndex,
      rest = _objectWithoutProperties$2(_ref1883, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1883 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1883.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1883, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26 6H4v3.17l7.41 7.42.59.58V26h4v-2h2v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8l-7.41-7.41A2 2 0 0 1 2 9.17V6a2 2 0 0 1 2-2h22z'
  }), React.createElement('path', {
    d: 'M29.71 11.29l-3-3a1 1 0 0 0-1.42 0L16 17.59V22h4.41l9.3-9.29a1 1 0 0 0 0-1.42zM19.59 20H18v-1.59l5-5L24.59 15zM26 13.59L24.41 12 26 10.41 27.59 12z'
  }));
});
WatsonHealthEditFilter20.displayName = 'WatsonHealthEditFilter20';
WatsonHealthEditFilter20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthEditFilter20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthFusionBlender32 = React.forwardRef(function (_ref1884, ref) {
  var className = _ref1884.className,
      children = _ref1884.children,
      style = _ref1884.style,
      tabIndex = _ref1884.tabIndex,
      rest = _objectWithoutProperties$2(_ref1884, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1884 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1884.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1884, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 12h-3V4h3V2h-8v2h3v8h-3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3v8h-3v2h8v-2h-3v-8h3a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-8 6v-4h8v4z'
  }));
});
WatsonHealthFusionBlender32.displayName = 'WatsonHealthFusionBlender32';
WatsonHealthFusionBlender32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthFusionBlender32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthFusionBlender24 = React.forwardRef(function (_ref1885, ref) {
  var className = _ref1885.className,
      children = _ref1885.children,
      style = _ref1885.style,
      tabIndex = _ref1885.tabIndex,
      rest = _objectWithoutProperties$2(_ref1885, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1885 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1885.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1885, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 12h-3V4h3V2h-8v2h3v8h-3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3v8h-3v2h8v-2h-3v-8h3a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-8 6v-4h8v4z'
  }));
});
WatsonHealthFusionBlender24.displayName = 'WatsonHealthFusionBlender24';
WatsonHealthFusionBlender24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthFusionBlender24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthFusionBlender20 = React.forwardRef(function (_ref1886, ref) {
  var className = _ref1886.className,
      children = _ref1886.children,
      style = _ref1886.style,
      tabIndex = _ref1886.tabIndex,
      rest = _objectWithoutProperties$2(_ref1886, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1886 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1886.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1886, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 12h-3V4h3V2h-8v2h3v8h-3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3v8h-3v2h8v-2h-3v-8h3a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-8 6v-4h8v4z'
  }));
});
WatsonHealthFusionBlender20.displayName = 'WatsonHealthFusionBlender20';
WatsonHealthFusionBlender20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthFusionBlender20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthHangingProtocol32 = React.forwardRef(function (_ref1887, ref) {
  var className = _ref1887.className,
      children = _ref1887.children,
      style = _ref1887.style,
      tabIndex = _ref1887.tabIndex,
      rest = _objectWithoutProperties$2(_ref1887, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1887 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1887.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1887, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.37 20.52L17 15.41v-1.55A4 4 0 1 0 12 10h2a2 2 0 1 1 4 .34A2.08 2.08 0 0 1 15.89 12a.89.89 0 0 0-.89.89v2.52l-9.37 5.11A3.1 3.1 0 0 0 4.25 22a2.83 2.83 0 0 0 2.56 4h18.38a2.83 2.83 0 0 0 2.56-4 3.1 3.1 0 0 0-1.38-1.48zM25.19 24H6.81a.81.81 0 0 1-.81-.81 1 1 0 0 1 .52-.88L16 17.14l9.48 5.17a1 1 0 0 1 .52.88.81.81 0 0 1-.81.81z'
  }));
});
WatsonHealthHangingProtocol32.displayName = 'WatsonHealthHangingProtocol32';
WatsonHealthHangingProtocol32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthHangingProtocol32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthHangingProtocol24 = React.forwardRef(function (_ref1888, ref) {
  var className = _ref1888.className,
      children = _ref1888.children,
      style = _ref1888.style,
      tabIndex = _ref1888.tabIndex,
      rest = _objectWithoutProperties$2(_ref1888, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1888 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1888.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1888, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.37 20.52L17 15.41v-1.55A4 4 0 1 0 12 10h2a2 2 0 1 1 4 .34A2.08 2.08 0 0 1 15.89 12a.89.89 0 0 0-.89.89v2.52l-9.37 5.11A3.1 3.1 0 0 0 4.25 22a2.83 2.83 0 0 0 2.56 4h18.38a2.83 2.83 0 0 0 2.56-4 3.1 3.1 0 0 0-1.38-1.48zM25.19 24H6.81a.81.81 0 0 1-.81-.81 1 1 0 0 1 .52-.88L16 17.14l9.48 5.17a1 1 0 0 1 .52.88.81.81 0 0 1-.81.81z'
  }));
});
WatsonHealthHangingProtocol24.displayName = 'WatsonHealthHangingProtocol24';
WatsonHealthHangingProtocol24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthHangingProtocol24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthHangingProtocol20 = React.forwardRef(function (_ref1889, ref) {
  var className = _ref1889.className,
      children = _ref1889.children,
      style = _ref1889.style,
      tabIndex = _ref1889.tabIndex,
      rest = _objectWithoutProperties$2(_ref1889, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1889 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1889.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1889, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M26.37 20.52L17 15.41v-1.55A4 4 0 1 0 12 10h2a2 2 0 1 1 4 .34A2.08 2.08 0 0 1 15.89 12a.89.89 0 0 0-.89.89v2.52l-9.37 5.11A3.1 3.1 0 0 0 4.25 22a2.83 2.83 0 0 0 2.56 4h18.38a2.83 2.83 0 0 0 2.56-4 3.1 3.1 0 0 0-1.38-1.48zM25.19 24H6.81a.81.81 0 0 1-.81-.81 1 1 0 0 1 .52-.88L16 17.14l9.48 5.17a1 1 0 0 1 .52.88.81.81 0 0 1-.81.81z'
  }));
});
WatsonHealthHangingProtocol20.displayName = 'WatsonHealthHangingProtocol20';
WatsonHealthHangingProtocol20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthHangingProtocol20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthICa_3D32 = React.forwardRef(function (_ref1890, ref) {
  var className = _ref1890.className,
      children = _ref1890.children,
      style = _ref1890.style,
      tabIndex = _ref1890.tabIndex,
      rest = _objectWithoutProperties$2(_ref1890, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1890 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1890.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1890, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 .59-1.42A3.57 3.57 0 0 1 10 2h5v2h-5v8h5zM4 6h2v8H4zm0-4h2v2H4zm23.45 17.11l-6-3a1 1 0 0 0-.9 0l-6 3A1 1 0 0 0 14 20v7a1 1 0 0 0 .55.89l6 3a1 1 0 0 0 .9 0l6-3A1 1 0 0 0 28 27v-7a1 1 0 0 0-.55-.89zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76v-4.75l4-2v4.76zM23 2h-4a2 2 0 0 0-2 2v10h2v-4h4v4h2V4a2 2 0 0 0-2-2zm-4 6V4h4v4z'
  }));
});
WatsonHealthICa_3D32.displayName = 'WatsonHealthICa_3D32';
WatsonHealthICa_3D32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthICa_3D32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthICa_3D24 = React.forwardRef(function (_ref1891, ref) {
  var className = _ref1891.className,
      children = _ref1891.children,
      style = _ref1891.style,
      tabIndex = _ref1891.tabIndex,
      rest = _objectWithoutProperties$2(_ref1891, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1891 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1891.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1891, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 .59-1.42A3.57 3.57 0 0 1 10 2h5v2h-5v8h5zM4 6h2v8H4zm0-4h2v2H4zm23.45 17.11l-6-3a1 1 0 0 0-.9 0l-6 3A1 1 0 0 0 14 20v7a1 1 0 0 0 .55.89l6 3a1 1 0 0 0 .9 0l6-3A1 1 0 0 0 28 27v-7a1 1 0 0 0-.55-.89zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76v-4.75l4-2v4.76zM23 2h-4a2 2 0 0 0-2 2v10h2v-4h4v4h2V4a2 2 0 0 0-2-2zm-4 6V4h4v4z'
  }));
});
WatsonHealthICa_3D24.displayName = 'WatsonHealthICa_3D24';
WatsonHealthICa_3D24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthICa_3D24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthICa_3D20 = React.forwardRef(function (_ref1892, ref) {
  var className = _ref1892.className,
      children = _ref1892.children,
      style = _ref1892.style,
      tabIndex = _ref1892.tabIndex,
      rest = _objectWithoutProperties$2(_ref1892, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1892 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1892.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1892, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 .59-1.42A3.57 3.57 0 0 1 10 2h5v2h-5v8h5zM4 6h2v8H4zm0-4h2v2H4zm23.45 17.11l-6-3a1 1 0 0 0-.9 0l-6 3A1 1 0 0 0 14 20v7a1 1 0 0 0 .55.89l6 3a1 1 0 0 0 .9 0l6-3A1 1 0 0 0 28 27v-7a1 1 0 0 0-.55-.89zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76v-4.75l4-2v4.76zM23 2h-4a2 2 0 0 0-2 2v10h2v-4h4v4h2V4a2 2 0 0 0-2-2zm-4 6V4h4v4z'
  }));
});
WatsonHealthICa_3D20.displayName = 'WatsonHealthICa_3D20';
WatsonHealthICa_3D20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthICa_3D20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_132 = React.forwardRef(function (_ref1893, ref) {
  var className = _ref1893.className,
      children = _ref1893.children,
      style = _ref1893.style,
      tabIndex = _ref1893.tabIndex,
      rest = _objectWithoutProperties$2(_ref1893, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1893 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1893.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1893, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '25',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 22v6H6v-6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-5.41-9.41L17 14.17V2h-2v12.17l-3.59-3.58L10 12l6 6 6-6-1.41-1.41z'
  }), React.createElement('path', {
    d: 'M8 24h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_132.displayName = 'WatsonHealthLaunchStudy_132';
WatsonHealthLaunchStudy_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_124 = React.forwardRef(function (_ref1894, ref) {
  var className = _ref1894.className,
      children = _ref1894.children,
      style = _ref1894.style,
      tabIndex = _ref1894.tabIndex,
      rest = _objectWithoutProperties$2(_ref1894, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1894 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1894.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1894, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '25',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 22v6H6v-6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-5.41-9.41L17 14.17V2h-2v12.17l-3.59-3.58L10 12l6 6 6-6-1.41-1.41z'
  }), React.createElement('path', {
    d: 'M8 24h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_124.displayName = 'WatsonHealthLaunchStudy_124';
WatsonHealthLaunchStudy_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_120 = React.forwardRef(function (_ref1895, ref) {
  var className = _ref1895.className,
      children = _ref1895.children,
      style = _ref1895.style,
      tabIndex = _ref1895.tabIndex,
      rest = _objectWithoutProperties$2(_ref1895, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1895 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1895.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1895, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '25',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 22v6H6v-6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-5.41-9.41L17 14.17V2h-2v12.17l-3.59-3.58L10 12l6 6 6-6-1.41-1.41z'
  }), React.createElement('path', {
    d: 'M8 24h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_120.displayName = 'WatsonHealthLaunchStudy_120';
WatsonHealthLaunchStudy_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_232 = React.forwardRef(function (_ref1896, ref) {
  var className = _ref1896.className,
      children = _ref1896.children,
      style = _ref1896.style,
      tabIndex = _ref1896.tabIndex,
      rest = _objectWithoutProperties$2(_ref1896, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1896 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1896.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1896, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '7',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 4v6H6V4h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-5.41 19.41L17 17.83V30h-2V17.83l-3.59 3.58L10 20l6-6 6 6-1.41 1.41z'
  }), React.createElement('path', {
    d: 'M8 6h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_232.displayName = 'WatsonHealthLaunchStudy_232';
WatsonHealthLaunchStudy_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_224 = React.forwardRef(function (_ref1897, ref) {
  var className = _ref1897.className,
      children = _ref1897.children,
      style = _ref1897.style,
      tabIndex = _ref1897.tabIndex,
      rest = _objectWithoutProperties$2(_ref1897, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1897 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1897.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1897, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '7',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 4v6H6V4h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-5.41 19.41L17 17.83V30h-2V17.83l-3.59 3.58L10 20l6-6 6 6-1.41 1.41z'
  }), React.createElement('path', {
    d: 'M8 6h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_224.displayName = 'WatsonHealthLaunchStudy_224';
WatsonHealthLaunchStudy_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_220 = React.forwardRef(function (_ref1898, ref) {
  var className = _ref1898.className,
      children = _ref1898.children,
      style = _ref1898.style,
      tabIndex = _ref1898.tabIndex,
      rest = _objectWithoutProperties$2(_ref1898, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1898 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1898.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1898, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '7',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 4v6H6V4h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-5.41 19.41L17 17.83V30h-2V17.83l-3.59 3.58L10 20l6-6 6 6-1.41 1.41z'
  }), React.createElement('path', {
    d: 'M8 6h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_220.displayName = 'WatsonHealthLaunchStudy_220';
WatsonHealthLaunchStudy_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_332 = React.forwardRef(function (_ref1899, ref) {
  var className = _ref1899.className,
      children = _ref1899.children,
      style = _ref1899.style,
      tabIndex = _ref1899.tabIndex,
      rest = _objectWithoutProperties$2(_ref1899, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1899 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1899.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1899, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '25',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 22v6H6v-6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM20.59 4.59L17 8.17V0h-2v8.17l-3.59-3.58L10 6l6 6 6-6-1.41-1.41z'
  }), React.createElement('path', {
    d: 'M20.59 10.59L16 15.16l-4.59-4.57L10 12l6 6 6-6-1.41-1.41zM8 24h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_332.displayName = 'WatsonHealthLaunchStudy_332';
WatsonHealthLaunchStudy_332.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_332.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_324 = React.forwardRef(function (_ref1900, ref) {
  var className = _ref1900.className,
      children = _ref1900.children,
      style = _ref1900.style,
      tabIndex = _ref1900.tabIndex,
      rest = _objectWithoutProperties$2(_ref1900, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1900 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1900.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1900, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '25',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 22v6H6v-6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM20.59 4.59L17 8.17V0h-2v8.17l-3.59-3.58L10 6l6 6 6-6-1.41-1.41z'
  }), React.createElement('path', {
    d: 'M20.59 10.59L16 15.16l-4.59-4.57L10 12l6 6 6-6-1.41-1.41zM8 24h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_324.displayName = 'WatsonHealthLaunchStudy_324';
WatsonHealthLaunchStudy_324.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_324.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthLaunchStudy_320 = React.forwardRef(function (_ref1901, ref) {
  var className = _ref1901.className,
      children = _ref1901.children,
      style = _ref1901.style,
      tabIndex = _ref1901.tabIndex,
      rest = _objectWithoutProperties$2(_ref1901, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1901 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1901.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1901, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('circle', {
    cx: '23',
    cy: '25',
    r: '1'
  }), React.createElement('path', {
    d: 'M26 22v6H6v-6h20m0-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zM20.59 4.59L17 8.17V0h-2v8.17l-3.59-3.58L10 6l6 6 6-6-1.41-1.41z'
  }), React.createElement('path', {
    d: 'M20.59 10.59L16 15.16l-4.59-4.57L10 12l6 6 6-6-1.41-1.41zM8 24h12v2H8z'
  }));
});
WatsonHealthLaunchStudy_320.displayName = 'WatsonHealthLaunchStudy_320';
WatsonHealthLaunchStudy_320.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthLaunchStudy_320.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthMagnify32 = React.forwardRef(function (_ref1902, ref) {
  var className = _ref1902.className,
      children = _ref1902.children,
      style = _ref1902.style,
      tabIndex = _ref1902.tabIndex,
      rest = _objectWithoutProperties$2(_ref1902, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1902 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1902.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1902, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 21H4V4h18v8h2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h8z'
  }), React.createElement('path', {
    d: 'M30 28.58l-3.11-3.11a6 6 0 1 0-1.42 1.42L28.58 30zM22 26a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealthMagnify32.displayName = 'WatsonHealthMagnify32';
WatsonHealthMagnify32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthMagnify32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthMagnify24 = React.forwardRef(function (_ref1903, ref) {
  var className = _ref1903.className,
      children = _ref1903.children,
      style = _ref1903.style,
      tabIndex = _ref1903.tabIndex,
      rest = _objectWithoutProperties$2(_ref1903, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1903 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1903.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1903, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 21H4V4h18v8h2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h8z'
  }), React.createElement('path', {
    d: 'M30 28.58l-3.11-3.11a6 6 0 1 0-1.42 1.42L28.58 30zM22 26a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealthMagnify24.displayName = 'WatsonHealthMagnify24';
WatsonHealthMagnify24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthMagnify24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthMagnify20 = React.forwardRef(function (_ref1904, ref) {
  var className = _ref1904.className,
      children = _ref1904.children,
      style = _ref1904.style,
      tabIndex = _ref1904.tabIndex,
      rest = _objectWithoutProperties$2(_ref1904, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1904 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1904.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1904, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M12 21H4V4h18v8h2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h8z'
  }), React.createElement('path', {
    d: 'M30 28.58l-3.11-3.11a6 6 0 1 0-1.42 1.42L28.58 30zM22 26a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealthMagnify20.displayName = 'WatsonHealthMagnify20';
WatsonHealthMagnify20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthMagnify20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPageScroll32 = React.forwardRef(function (_ref1905, ref) {
  var className = _ref1905.className,
      children = _ref1905.children,
      style = _ref1905.style,
      tabIndex = _ref1905.tabIndex,
      rest = _objectWithoutProperties$2(_ref1905, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1905 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1905.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1905, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28H4a1.89 1.89 0 0 1-2-2V14a1.89 1.89 0 0 1 2-2h12a1.89 1.89 0 0 1 2 2v12a1.89 1.89 0 0 1-2 2zM4 14v12h12V14z'
  }), React.createElement('path', {
    d: 'M22 19h-2v-9H10V8h10a1.89 1.89 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M26 14h-2V6h-8V4h8a1.89 1.89 0 0 1 2 2zm-2 3v2h2.8L22 24.4V22h-2v6h6v-2h-2.8l4.8-5.4V23h2v-6h-6z'
  }));
});
WatsonHealthPageScroll32.displayName = 'WatsonHealthPageScroll32';
WatsonHealthPageScroll32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPageScroll32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPageScroll24 = React.forwardRef(function (_ref1906, ref) {
  var className = _ref1906.className,
      children = _ref1906.children,
      style = _ref1906.style,
      tabIndex = _ref1906.tabIndex,
      rest = _objectWithoutProperties$2(_ref1906, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1906 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1906.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1906, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28H4a1.89 1.89 0 0 1-2-2V14a1.89 1.89 0 0 1 2-2h12a1.89 1.89 0 0 1 2 2v12a1.89 1.89 0 0 1-2 2zM4 14v12h12V14z'
  }), React.createElement('path', {
    d: 'M22 19h-2v-9H10V8h10a1.89 1.89 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M26 14h-2V6h-8V4h8a1.89 1.89 0 0 1 2 2zm-2 3v2h2.8L22 24.4V22h-2v6h6v-2h-2.8l4.8-5.4V23h2v-6h-6z'
  }));
});
WatsonHealthPageScroll24.displayName = 'WatsonHealthPageScroll24';
WatsonHealthPageScroll24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPageScroll24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPageScroll20 = React.forwardRef(function (_ref1907, ref) {
  var className = _ref1907.className,
      children = _ref1907.children,
      style = _ref1907.style,
      tabIndex = _ref1907.tabIndex,
      rest = _objectWithoutProperties$2(_ref1907, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1907 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1907.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1907, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 28H4a1.89 1.89 0 0 1-2-2V14a1.89 1.89 0 0 1 2-2h12a1.89 1.89 0 0 1 2 2v12a1.89 1.89 0 0 1-2 2zM4 14v12h12V14z'
  }), React.createElement('path', {
    d: 'M22 19h-2v-9H10V8h10a1.89 1.89 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M26 14h-2V6h-8V4h8a1.89 1.89 0 0 1 2 2zm-2 3v2h2.8L22 24.4V22h-2v6h6v-2h-2.8l4.8-5.4V23h2v-6h-6z'
  }));
});
WatsonHealthPageScroll20.displayName = 'WatsonHealthPageScroll20';
WatsonHealthPageScroll20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPageScroll20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPetImageB32 = React.forwardRef(function (_ref1908, ref) {
  var className = _ref1908.className,
      children = _ref1908.children,
      style = _ref1908.style,
      tabIndex = _ref1908.tabIndex,
      rest = _objectWithoutProperties$2(_ref1908, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1908 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1908.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1908, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 21h2v3h-2zm0-21h2v3h-2zM8 11h3v2H8zm21 0h3v2h-3zM10.816 4.216l1.4-1.4 2.122 2.12-1.4 1.401zm14.862 14.84l1.4-1.4 2.121 2.121-1.4 1.4zm-14.851.717l2.121-2.121 1.4 1.4-2.12 2.121zm14.84-14.847l2.122-2.122 1.4 1.4-2.122 2.122zM20 5a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 12a5 5 0 0 1 0-10zM5 18H0v14h5a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2A3 3 0 0 0 8 23v-2a3 3 0 0 0-3-3zm-3 2h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2zm4 9a1 1 0 0 1-1 1H2v-4h3a1 1 0 0 1 1 1zM2 2h7V0H0v9h2V2z'
  }));
});
WatsonHealthPetImageB32.displayName = 'WatsonHealthPetImageB32';
WatsonHealthPetImageB32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPetImageB32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPetImageB24 = React.forwardRef(function (_ref1909, ref) {
  var className = _ref1909.className,
      children = _ref1909.children,
      style = _ref1909.style,
      tabIndex = _ref1909.tabIndex,
      rest = _objectWithoutProperties$2(_ref1909, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1909 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1909.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1909, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 21h2v3h-2zm0-21h2v3h-2zM8 11h3v2H8zm21 0h3v2h-3zM10.816 4.216l1.4-1.4 2.122 2.12-1.4 1.401zm14.862 14.84l1.4-1.4 2.121 2.121-1.4 1.4zm-14.851.717l2.121-2.121 1.4 1.4-2.12 2.121zm14.84-14.847l2.122-2.122 1.4 1.4-2.122 2.122zM20 5a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 12a5 5 0 0 1 0-10zM5 18H0v14h5a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2A3 3 0 0 0 8 23v-2a3 3 0 0 0-3-3zm-3 2h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2zm4 9a1 1 0 0 1-1 1H2v-4h3a1 1 0 0 1 1 1zM2 2h7V0H0v9h2V2z'
  }));
});
WatsonHealthPetImageB24.displayName = 'WatsonHealthPetImageB24';
WatsonHealthPetImageB24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPetImageB24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPetImageB20 = React.forwardRef(function (_ref1910, ref) {
  var className = _ref1910.className,
      children = _ref1910.children,
      style = _ref1910.style,
      tabIndex = _ref1910.tabIndex,
      rest = _objectWithoutProperties$2(_ref1910, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1910 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1910.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1910, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 21h2v3h-2zm0-21h2v3h-2zM8 11h3v2H8zm21 0h3v2h-3zM10.816 4.216l1.4-1.4 2.122 2.12-1.4 1.401zm14.862 14.84l1.4-1.4 2.121 2.121-1.4 1.4zm-14.851.717l2.121-2.121 1.4 1.4-2.12 2.121zm14.84-14.847l2.122-2.122 1.4 1.4-2.122 2.122zM20 5a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 12a5 5 0 0 1 0-10zM5 18H0v14h5a3 3 0 0 0 3-3v-2a3 3 0 0 0-.78-2A3 3 0 0 0 8 23v-2a3 3 0 0 0-3-3zm-3 2h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2zm4 9a1 1 0 0 1-1 1H2v-4h3a1 1 0 0 1 1 1zM2 2h7V0H0v9h2V2z'
  }));
});
WatsonHealthPetImageB20.displayName = 'WatsonHealthPetImageB20';
WatsonHealthPetImageB20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPetImageB20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPetImageO32 = React.forwardRef(function (_ref1911, ref) {
  var className = _ref1911.className,
      children = _ref1911.children,
      style = _ref1911.style,
      tabIndex = _ref1911.tabIndex,
      rest = _objectWithoutProperties$2(_ref1911, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1911 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1911.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1911, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 29h2v3h-2zm0-21h2v3h-2zM0 19h3v2H0zm21 0h3v2h-3zM2.82 12.233l1.4-1.4 2.122 2.121-1.4 1.4zm14.855 14.833l1.4-1.4 2.121 2.122-1.4 1.4zm-14.844.724l2.121-2.12 1.4 1.4-2.12 2.12zm14.833-14.853l2.121-2.121 1.4 1.4-2.121 2.121zM12 13a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 12a5 5 0 0 1 0-10zM2 2h7V0H0v9h2V2zm28-2h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-4 12V2h4v10z'
  }));
});
WatsonHealthPetImageO32.displayName = 'WatsonHealthPetImageO32';
WatsonHealthPetImageO32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPetImageO32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPetImageO24 = React.forwardRef(function (_ref1912, ref) {
  var className = _ref1912.className,
      children = _ref1912.children,
      style = _ref1912.style,
      tabIndex = _ref1912.tabIndex,
      rest = _objectWithoutProperties$2(_ref1912, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1912 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1912.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1912, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 29h2v3h-2zm0-21h2v3h-2zM0 19h3v2H0zm21 0h3v2h-3zM2.82 12.233l1.4-1.4 2.122 2.121-1.4 1.4zm14.855 14.833l1.4-1.4 2.121 2.122-1.4 1.4zm-14.844.724l2.121-2.12 1.4 1.4-2.12 2.12zm14.833-14.853l2.121-2.121 1.4 1.4-2.121 2.121zM12 13a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 12a5 5 0 0 1 0-10zM2 2h7V0H0v9h2V2zm28-2h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-4 12V2h4v10z'
  }));
});
WatsonHealthPetImageO24.displayName = 'WatsonHealthPetImageO24';
WatsonHealthPetImageO24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPetImageO24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPetImageO20 = React.forwardRef(function (_ref1913, ref) {
  var className = _ref1913.className,
      children = _ref1913.children,
      style = _ref1913.style,
      tabIndex = _ref1913.tabIndex,
      rest = _objectWithoutProperties$2(_ref1913, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1913 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1913.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1913, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M11 29h2v3h-2zm0-21h2v3h-2zM0 19h3v2H0zm21 0h3v2h-3zM2.82 12.233l1.4-1.4 2.122 2.121-1.4 1.4zm14.855 14.833l1.4-1.4 2.121 2.122-1.4 1.4zm-14.844.724l2.121-2.12 1.4 1.4-2.12 2.12zm14.833-14.853l2.121-2.121 1.4 1.4-2.121 2.121zM12 13a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm0 12a5 5 0 0 1 0-10zM2 2h7V0H0v9h2V2zm28-2h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-4 12V2h4v10z'
  }));
});
WatsonHealthPetImageO20.displayName = 'WatsonHealthPetImageO20';
WatsonHealthPetImageO20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPetImageO20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPointerText32 = React.forwardRef(function (_ref1914, ref) {
  var className = _ref1914.className,
      children = _ref1914.children,
      style = _ref1914.style,
      tabIndex = _ref1914.tabIndex,
      rest = _objectWithoutProperties$2(_ref1914, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1914 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1914.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1914, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.71 12.29L7.41 6H13V4H4v9h2V7.41l6.29 6.3 1.42-1.42zM28 30H12a2 2 0 0 1-2-2V18h2v10h16V12H18v-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M22 15h-5v2h5v2h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v-8a2 2 0 0 0-2-2zm0 8h-4v-2h4z'
  }));
});
WatsonHealthPointerText32.displayName = 'WatsonHealthPointerText32';
WatsonHealthPointerText32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPointerText32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPointerText24 = React.forwardRef(function (_ref1915, ref) {
  var className = _ref1915.className,
      children = _ref1915.children,
      style = _ref1915.style,
      tabIndex = _ref1915.tabIndex,
      rest = _objectWithoutProperties$2(_ref1915, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1915 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1915.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1915, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.71 12.29L7.41 6H13V4H4v9h2V7.41l6.29 6.3 1.42-1.42zM28 30H12a2 2 0 0 1-2-2V18h2v10h16V12H18v-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M22 15h-5v2h5v2h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v-8a2 2 0 0 0-2-2zm0 8h-4v-2h4z'
  }));
});
WatsonHealthPointerText24.displayName = 'WatsonHealthPointerText24';
WatsonHealthPointerText24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPointerText24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthPointerText20 = React.forwardRef(function (_ref1916, ref) {
  var className = _ref1916.className,
      children = _ref1916.children,
      style = _ref1916.style,
      tabIndex = _ref1916.tabIndex,
      rest = _objectWithoutProperties$2(_ref1916, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1916 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1916.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1916, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M13.71 12.29L7.41 6H13V4H4v9h2V7.41l6.29 6.3 1.42-1.42zM28 30H12a2 2 0 0 1-2-2V18h2v10h16V12H18v-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M22 15h-5v2h5v2h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v-8a2 2 0 0 0-2-2zm0 8h-4v-2h4z'
  }));
});
WatsonHealthPointerText20.displayName = 'WatsonHealthPointerText20';
WatsonHealthPointerText20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthPointerText20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveAnnotation32 = React.forwardRef(function (_ref1917, ref) {
  var className = _ref1917.className,
      children = _ref1917.children,
      style = _ref1917.style,
      tabIndex = _ref1917.tabIndex,
      rest = _objectWithoutProperties$2(_ref1917, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1917 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1917.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1917, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M28 20h-3v-2h3V4H8v3H6V4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M20 6h6v2h-6zm2 4h4v2h-4z'
  }));
});
WatsonHealthSaveAnnotation32.displayName = 'WatsonHealthSaveAnnotation32';
WatsonHealthSaveAnnotation32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveAnnotation32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveAnnotation24 = React.forwardRef(function (_ref1918, ref) {
  var className = _ref1918.className,
      children = _ref1918.children,
      style = _ref1918.style,
      tabIndex = _ref1918.tabIndex,
      rest = _objectWithoutProperties$2(_ref1918, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1918 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1918.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1918, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M28 20h-3v-2h3V4H8v3H6V4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M20 6h6v2h-6zm2 4h4v2h-4z'
  }));
});
WatsonHealthSaveAnnotation24.displayName = 'WatsonHealthSaveAnnotation24';
WatsonHealthSaveAnnotation24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveAnnotation24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveAnnotation20 = React.forwardRef(function (_ref1919, ref) {
  var className = _ref1919.className,
      children = _ref1919.children,
      style = _ref1919.style,
      tabIndex = _ref1919.tabIndex,
      rest = _objectWithoutProperties$2(_ref1919, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1919 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1919.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1919, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M28 20h-3v-2h3V4H8v3H6V4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z'
  }), React.createElement('path', {
    d: 'M20 6h6v2h-6zm2 4h4v2h-4z'
  }));
});
WatsonHealthSaveAnnotation20.displayName = 'WatsonHealthSaveAnnotation20';
WatsonHealthSaveAnnotation20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveAnnotation20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveImage32 = React.forwardRef(function (_ref1920, ref) {
  var className = _ref1920.className,
      children = _ref1920.children,
      style = _ref1920.style,
      tabIndex = _ref1920.tabIndex,
      rest = _objectWithoutProperties$2(_ref1920, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1920 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1920.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1920, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M28 20h-3v-2h3V4H14v3h-2V4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z'
  }));
});
WatsonHealthSaveImage32.displayName = 'WatsonHealthSaveImage32';
WatsonHealthSaveImage32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveImage32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveImage24 = React.forwardRef(function (_ref1921, ref) {
  var className = _ref1921.className,
      children = _ref1921.children,
      style = _ref1921.style,
      tabIndex = _ref1921.tabIndex,
      rest = _objectWithoutProperties$2(_ref1921, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1921 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1921.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1921, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M28 20h-3v-2h3V4H14v3h-2V4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z'
  }));
});
WatsonHealthSaveImage24.displayName = 'WatsonHealthSaveImage24';
WatsonHealthSaveImage24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveImage24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveImage20 = React.forwardRef(function (_ref1922, ref) {
  var className = _ref1922.className,
      children = _ref1922.children,
      style = _ref1922.style,
      tabIndex = _ref1922.tabIndex,
      rest = _objectWithoutProperties$2(_ref1922, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1922 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1922.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1922, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M28 20h-3v-2h3V4H14v3h-2V4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z'
  }));
});
WatsonHealthSaveImage20.displayName = 'WatsonHealthSaveImage20';
WatsonHealthSaveImage20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveImage20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveSeries32 = React.forwardRef(function (_ref1923, ref) {
  var className = _ref1923.className,
      children = _ref1923.children,
      style = _ref1923.style,
      tabIndex = _ref1923.tabIndex,
      rest = _objectWithoutProperties$2(_ref1923, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1923 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1923.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1923, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M27 21h-2V7H11V5h14a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M32 14h-2V2H18V0h12a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthSaveSeries32.displayName = 'WatsonHealthSaveSeries32';
WatsonHealthSaveSeries32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveSeries32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveSeries24 = React.forwardRef(function (_ref1924, ref) {
  var className = _ref1924.className,
      children = _ref1924.children,
      style = _ref1924.style,
      tabIndex = _ref1924.tabIndex,
      rest = _objectWithoutProperties$2(_ref1924, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1924 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1924.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1924, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M27 21h-2V7H11V5h14a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M32 14h-2V2H18V0h12a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthSaveSeries24.displayName = 'WatsonHealthSaveSeries24';
WatsonHealthSaveSeries24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveSeries24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSaveSeries20 = React.forwardRef(function (_ref1925, ref) {
  var className = _ref1925.className,
      children = _ref1925.children,
      style = _ref1925.style,
      tabIndex = _ref1925.tabIndex,
      rest = _objectWithoutProperties$2(_ref1925, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1925 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1925.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1925, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.56 15.1l-3.48-4.35a2 2 0 0 0-1.56-.75H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V16.35a2 2 0 0 0-.44-1.25zM9 12h6v3H9zm6 16H9v-6h6zm2 0v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6H4V12h3v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2.4l3 3.75V28z'
  }), React.createElement('path', {
    d: 'M27 21h-2V7H11V5h14a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M32 14h-2V2H18V0h12a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthSaveSeries20.displayName = 'WatsonHealthSaveSeries20';
WatsonHealthSaveSeries20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSaveSeries20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSpineLabel32 = React.forwardRef(function (_ref1926, ref) {
  var className = _ref1926.className,
      children = _ref1926.children,
      style = _ref1926.style,
      tabIndex = _ref1926.tabIndex,
      rest = _objectWithoutProperties$2(_ref1926, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1926 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1926.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1926, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 11v2h5.59l-6.3 6.29 1.42 1.42 6.29-6.3V20h2v-9H3zm23 2h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2zm8 6h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2zm8-24h-3V2h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2V9h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-8 4V5h8v2z'
  }));
});
WatsonHealthSpineLabel32.displayName = 'WatsonHealthSpineLabel32';
WatsonHealthSpineLabel32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSpineLabel32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSpineLabel24 = React.forwardRef(function (_ref1927, ref) {
  var className = _ref1927.className,
      children = _ref1927.children,
      style = _ref1927.style,
      tabIndex = _ref1927.tabIndex,
      rest = _objectWithoutProperties$2(_ref1927, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1927 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1927.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1927, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 11v2h5.59l-6.3 6.29 1.42 1.42 6.29-6.3V20h2v-9H3zm23 2h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2zm8 6h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2zm8-24h-3V2h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2V9h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-8 4V5h8v2z'
  }));
});
WatsonHealthSpineLabel24.displayName = 'WatsonHealthSpineLabel24';
WatsonHealthSpineLabel24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSpineLabel24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthSpineLabel20 = React.forwardRef(function (_ref1928, ref) {
  var className = _ref1928.className,
      children = _ref1928.children,
      style = _ref1928.style,
      tabIndex = _ref1928.tabIndex,
      rest = _objectWithoutProperties$2(_ref1928, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1928 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1928.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1928, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M3 11v2h5.59l-6.3 6.29 1.42 1.42 6.29-6.3V20h2v-9H3zm23 2h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2zm8 6h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2zm8-24h-3V2h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2V9h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-8 4V5h8v2z'
  }));
});
WatsonHealthSpineLabel20.displayName = 'WatsonHealthSpineLabel20';
WatsonHealthSpineLabel20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthSpineLabel20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedMove32 = React.forwardRef(function (_ref1929, ref) {
  var className = _ref1929.className,
      children = _ref1929.children,
      style = _ref1929.style,
      tabIndex = _ref1929.tabIndex,
      rest = _objectWithoutProperties$2(_ref1929, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1929 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1929.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1929, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 28H4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2zM4 11v15h11V11z'
  }), React.createElement('path', {
    d: 'M26 6l-1.41 1.41L27 10h-5V6a2 2 0 0 0-2-2H10v2h10v14h2v-8h5l-2.41 2.59L26 16l5-5z'
  }));
});
WatsonHealthStackedMove32.displayName = 'WatsonHealthStackedMove32';
WatsonHealthStackedMove32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedMove32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedMove24 = React.forwardRef(function (_ref1930, ref) {
  var className = _ref1930.className,
      children = _ref1930.children,
      style = _ref1930.style,
      tabIndex = _ref1930.tabIndex,
      rest = _objectWithoutProperties$2(_ref1930, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1930 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1930.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1930, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 28H4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2zM4 11v15h11V11z'
  }), React.createElement('path', {
    d: 'M26 6l-1.41 1.41L27 10h-5V6a2 2 0 0 0-2-2H10v2h10v14h2v-8h5l-2.41 2.59L26 16l5-5z'
  }));
});
WatsonHealthStackedMove24.displayName = 'WatsonHealthStackedMove24';
WatsonHealthStackedMove24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedMove24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedMove20 = React.forwardRef(function (_ref1931, ref) {
  var className = _ref1931.className,
      children = _ref1931.children,
      style = _ref1931.style,
      tabIndex = _ref1931.tabIndex,
      rest = _objectWithoutProperties$2(_ref1931, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1931 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1931.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1931, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 28H4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2zM4 11v15h11V11z'
  }), React.createElement('path', {
    d: 'M26 6l-1.41 1.41L27 10h-5V6a2 2 0 0 0-2-2H10v2h10v14h2v-8h5l-2.41 2.59L26 16l5-5z'
  }));
});
WatsonHealthStackedMove20.displayName = 'WatsonHealthStackedMove20';
WatsonHealthStackedMove20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedMove20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedScrolling_132 = React.forwardRef(function (_ref1932, ref) {
  var className = _ref1932.className,
      children = _ref1932.children,
      style = _ref1932.style,
      tabIndex = _ref1932.tabIndex,
      rest = _objectWithoutProperties$2(_ref1932, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1932 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1932.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1932, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 30H4a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 14v14h14V14z'
  }), React.createElement('path', {
    d: 'M25 23h-2V9H9V7h14a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M30 16h-2V4H16V2h12a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthStackedScrolling_132.displayName = 'WatsonHealthStackedScrolling_132';
WatsonHealthStackedScrolling_132.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedScrolling_132.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedScrolling_124 = React.forwardRef(function (_ref1933, ref) {
  var className = _ref1933.className,
      children = _ref1933.children,
      style = _ref1933.style,
      tabIndex = _ref1933.tabIndex,
      rest = _objectWithoutProperties$2(_ref1933, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1933 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1933.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1933, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 30H4a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 14v14h14V14z'
  }), React.createElement('path', {
    d: 'M25 23h-2V9H9V7h14a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M30 16h-2V4H16V2h12a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthStackedScrolling_124.displayName = 'WatsonHealthStackedScrolling_124';
WatsonHealthStackedScrolling_124.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedScrolling_124.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedScrolling_120 = React.forwardRef(function (_ref1934, ref) {
  var className = _ref1934.className,
      children = _ref1934.children,
      style = _ref1934.style,
      tabIndex = _ref1934.tabIndex,
      rest = _objectWithoutProperties$2(_ref1934, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1934 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1934.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1934, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 30H4a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM4 14v14h14V14z'
  }), React.createElement('path', {
    d: 'M25 23h-2V9H9V7h14a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M30 16h-2V4H16V2h12a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthStackedScrolling_120.displayName = 'WatsonHealthStackedScrolling_120';
WatsonHealthStackedScrolling_120.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedScrolling_120.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedScrolling_232 = React.forwardRef(function (_ref1935, ref) {
  var className = _ref1935.className,
      children = _ref1935.children,
      style = _ref1935.style,
      tabIndex = _ref1935.tabIndex,
      rest = _objectWithoutProperties$2(_ref1935, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1935 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1935.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1935, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H2a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM2 14v14h6V14zm18 16h-6a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zm-6-16v14h6V14z'
  }), React.createElement('path', {
    d: 'M27 21h-2V9h-8V7h8a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M32 16h-2V4h-8V2h8a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthStackedScrolling_232.displayName = 'WatsonHealthStackedScrolling_232';
WatsonHealthStackedScrolling_232.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedScrolling_232.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedScrolling_224 = React.forwardRef(function (_ref1936, ref) {
  var className = _ref1936.className,
      children = _ref1936.children,
      style = _ref1936.style,
      tabIndex = _ref1936.tabIndex,
      rest = _objectWithoutProperties$2(_ref1936, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1936 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1936.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1936, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H2a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM2 14v14h6V14zm18 16h-6a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zm-6-16v14h6V14z'
  }), React.createElement('path', {
    d: 'M27 21h-2V9h-8V7h8a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M32 16h-2V4h-8V2h8a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthStackedScrolling_224.displayName = 'WatsonHealthStackedScrolling_224';
WatsonHealthStackedScrolling_224.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedScrolling_224.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStackedScrolling_220 = React.forwardRef(function (_ref1937, ref) {
  var className = _ref1937.className,
      children = _ref1937.children,
      style = _ref1937.style,
      tabIndex = _ref1937.tabIndex,
      rest = _objectWithoutProperties$2(_ref1937, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1937 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1937.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1937, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 30H2a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM2 14v14h6V14zm18 16h-6a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zm-6-16v14h6V14z'
  }), React.createElement('path', {
    d: 'M27 21h-2V9h-8V7h8a2 2 0 0 1 2 2z'
  }), React.createElement('path', {
    d: 'M32 16h-2V4h-8V2h8a2 2 0 0 1 2 2z'
  }));
});
WatsonHealthStackedScrolling_220.displayName = 'WatsonHealthStackedScrolling_220';
WatsonHealthStackedScrolling_220.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStackedScrolling_220.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStressBreathEditor32 = React.forwardRef(function (_ref1938, ref) {
  var className = _ref1938.className,
      children = _ref1938.children,
      style = _ref1938.style,
      tabIndex = _ref1938.tabIndex,
      rest = _objectWithoutProperties$2(_ref1938, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1938 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1938.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1938, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5h-2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM11 8H5a3 3 0 0 1-3-3V3h2v2a1 1 0 0 0 1 1h6zm-7 7H2v-2a3 3 0 0 1 3-3h6v2H5a1 1 0 0 0-1 1z'
  }));
});
WatsonHealthStressBreathEditor32.displayName = 'WatsonHealthStressBreathEditor32';
WatsonHealthStressBreathEditor32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStressBreathEditor32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStressBreathEditor24 = React.forwardRef(function (_ref1939, ref) {
  var className = _ref1939.className,
      children = _ref1939.children,
      style = _ref1939.style,
      tabIndex = _ref1939.tabIndex,
      rest = _objectWithoutProperties$2(_ref1939, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1939 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1939.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1939, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5h-2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM11 8H5a3 3 0 0 1-3-3V3h2v2a1 1 0 0 0 1 1h6zm-7 7H2v-2a3 3 0 0 1 3-3h6v2H5a1 1 0 0 0-1 1z'
  }));
});
WatsonHealthStressBreathEditor24.displayName = 'WatsonHealthStressBreathEditor24';
WatsonHealthStressBreathEditor24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStressBreathEditor24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStressBreathEditor20 = React.forwardRef(function (_ref1940, ref) {
  var className = _ref1940.className,
      children = _ref1940.children,
      style = _ref1940.style,
      tabIndex = _ref1940.tabIndex,
      rest = _objectWithoutProperties$2(_ref1940, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1940 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1940.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1940, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M20 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5h-2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zM11 8H5a3 3 0 0 1-3-3V3h2v2a1 1 0 0 0 1 1h6zm-7 7H2v-2a3 3 0 0 1 3-3h6v2H5a1 1 0 0 0-1 1z'
  }));
});
WatsonHealthStressBreathEditor20.displayName = 'WatsonHealthStressBreathEditor20';
WatsonHealthStressBreathEditor20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStressBreathEditor20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudyNext32 = React.forwardRef(function (_ref1941, ref) {
  var className = _ref1941.className,
      children = _ref1941.children,
      style = _ref1941.style,
      tabIndex = _ref1941.tabIndex,
      rest = _objectWithoutProperties$2(_ref1941, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1941 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1941.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1941, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.93 21L30 15l-6.07-6-1.43 1.41L27.14 15l-4.64 4.59L23.93 21zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
WatsonHealthStudyNext32.displayName = 'WatsonHealthStudyNext32';
WatsonHealthStudyNext32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudyNext32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudyNext24 = React.forwardRef(function (_ref1942, ref) {
  var className = _ref1942.className,
      children = _ref1942.children,
      style = _ref1942.style,
      tabIndex = _ref1942.tabIndex,
      rest = _objectWithoutProperties$2(_ref1942, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1942 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1942.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1942, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.93 21L30 15l-6.07-6-1.43 1.41L27.14 15l-4.64 4.59L23.93 21zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
WatsonHealthStudyNext24.displayName = 'WatsonHealthStudyNext24';
WatsonHealthStudyNext24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudyNext24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudyNext20 = React.forwardRef(function (_ref1943, ref) {
  var className = _ref1943.className,
      children = _ref1943.children,
      style = _ref1943.style,
      tabIndex = _ref1943.tabIndex,
      rest = _objectWithoutProperties$2(_ref1943, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1943 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1943.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1943, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M23.93 21L30 15l-6.07-6-1.43 1.41L27.14 15l-4.64 4.59L23.93 21zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
WatsonHealthStudyNext20.displayName = 'WatsonHealthStudyNext20';
WatsonHealthStudyNext20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudyNext20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudyPrevious32 = React.forwardRef(function (_ref1944, ref) {
  var className = _ref1944.className,
      children = _ref1944.children,
      style = _ref1944.style,
      tabIndex = _ref1944.tabIndex,
      rest = _objectWithoutProperties$2(_ref1944, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1944 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1944.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1944, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.07 21L2 15l6.07-6 1.43 1.41L4.86 15l4.64 4.59L8.07 21zM20 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5h-2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
WatsonHealthStudyPrevious32.displayName = 'WatsonHealthStudyPrevious32';
WatsonHealthStudyPrevious32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudyPrevious32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudyPrevious24 = React.forwardRef(function (_ref1945, ref) {
  var className = _ref1945.className,
      children = _ref1945.children,
      style = _ref1945.style,
      tabIndex = _ref1945.tabIndex,
      rest = _objectWithoutProperties$2(_ref1945, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1945 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1945.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1945, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.07 21L2 15l6.07-6 1.43 1.41L4.86 15l4.64 4.59L8.07 21zM20 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5h-2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
WatsonHealthStudyPrevious24.displayName = 'WatsonHealthStudyPrevious24';
WatsonHealthStudyPrevious24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudyPrevious24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudyPrevious20 = React.forwardRef(function (_ref1946, ref) {
  var className = _ref1946.className,
      children = _ref1946.children,
      style = _ref1946.style,
      tabIndex = _ref1946.tabIndex,
      rest = _objectWithoutProperties$2(_ref1946, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1946 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1946.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1946, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8.07 21L2 15l6.07-6 1.43 1.41L4.86 15l4.64 4.59L8.07 21zM20 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5h-6a5 5 0 0 0-5 5v5h-2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z'
  }));
});
WatsonHealthStudyPrevious20.displayName = 'WatsonHealthStudyPrevious20';
WatsonHealthStudyPrevious20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudyPrevious20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudySkip32 = React.forwardRef(function (_ref1947, ref) {
  var className = _ref1947.className,
      children = _ref1947.children,
      style = _ref1947.style,
      tabIndex = _ref1947.tabIndex,
      rest = _objectWithoutProperties$2(_ref1947, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1947 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1947.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1947, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 9h5.2A11 11 0 0 0 7 15H5a13 13 0 0 1 23-8.3V3h2v8h-8z'
  }), React.createElement('path', {
    d: 'M16 12a3 3 0 1 1-3 3 2.95 2.95 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm7 20h-2v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3H9v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5z'
  }));
});
WatsonHealthStudySkip32.displayName = 'WatsonHealthStudySkip32';
WatsonHealthStudySkip32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudySkip32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudySkip24 = React.forwardRef(function (_ref1948, ref) {
  var className = _ref1948.className,
      children = _ref1948.children,
      style = _ref1948.style,
      tabIndex = _ref1948.tabIndex,
      rest = _objectWithoutProperties$2(_ref1948, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1948 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1948.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1948, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 9h5.2A11 11 0 0 0 7 15H5a13 13 0 0 1 23-8.3V3h2v8h-8z'
  }), React.createElement('path', {
    d: 'M16 12a3 3 0 1 1-3 3 2.95 2.95 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm7 20h-2v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3H9v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5z'
  }));
});
WatsonHealthStudySkip24.displayName = 'WatsonHealthStudySkip24';
WatsonHealthStudySkip24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudySkip24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthStudySkip20 = React.forwardRef(function (_ref1949, ref) {
  var className = _ref1949.className,
      children = _ref1949.children,
      style = _ref1949.style,
      tabIndex = _ref1949.tabIndex,
      rest = _objectWithoutProperties$2(_ref1949, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1949 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1949.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1949, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M22 9h5.2A11 11 0 0 0 7 15H5a13 13 0 0 1 23-8.3V3h2v8h-8z'
  }), React.createElement('path', {
    d: 'M16 12a3 3 0 1 1-3 3 2.95 2.95 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm7 20h-2v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3H9v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5z'
  }));
});
WatsonHealthStudySkip20.displayName = 'WatsonHealthStudySkip20';
WatsonHealthStudySkip20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthStudySkip20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowAuto32 = React.forwardRef(function (_ref1950, ref) {
  var className = _ref1950.className,
      children = _ref1950.children,
      style = _ref1950.style,
      tabIndex = _ref1950.tabIndex,
      rest = _objectWithoutProperties$2(_ref1950, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1950 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1950.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1950, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 4h2v3h-2zm10 11h3v2h-3zM15 25h2v3h-2zM4 15h3v2H4zm2.777-6.811L8.19 6.775l2.121 2.12-1.414 1.415zm14.91.711l2.121-2.12 1.414 1.414-2.12 2.121zm-.001 14.197l1.414-1.415 2.121 2.122-1.414 1.414zM6.78 23.8l2.12-2.122 1.414 1.414-2.121 2.122zM4 30h24v2H4zM4 0h24v2H4zm12 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm-4 6a4 4 0 0 1 4-4v8a4 4 0 0 1-4-4z'
  }));
});
WatsonHealthWindowAuto32.displayName = 'WatsonHealthWindowAuto32';
WatsonHealthWindowAuto32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowAuto32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowAuto24 = React.forwardRef(function (_ref1951, ref) {
  var className = _ref1951.className,
      children = _ref1951.children,
      style = _ref1951.style,
      tabIndex = _ref1951.tabIndex,
      rest = _objectWithoutProperties$2(_ref1951, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1951 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1951.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1951, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 4h2v3h-2zm10 11h3v2h-3zM15 25h2v3h-2zM4 15h3v2H4zm2.777-6.811L8.19 6.775l2.121 2.12-1.414 1.415zm14.91.711l2.121-2.12 1.414 1.414-2.12 2.121zm-.001 14.197l1.414-1.415 2.121 2.122-1.414 1.414zM6.78 23.8l2.12-2.122 1.414 1.414-2.121 2.122zM4 30h24v2H4zM4 0h24v2H4zm12 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm-4 6a4 4 0 0 1 4-4v8a4 4 0 0 1-4-4z'
  }));
});
WatsonHealthWindowAuto24.displayName = 'WatsonHealthWindowAuto24';
WatsonHealthWindowAuto24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowAuto24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowAuto20 = React.forwardRef(function (_ref1952, ref) {
  var className = _ref1952.className,
      children = _ref1952.children,
      style = _ref1952.style,
      tabIndex = _ref1952.tabIndex,
      rest = _objectWithoutProperties$2(_ref1952, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1952 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1952.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1952, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 4h2v3h-2zm10 11h3v2h-3zM15 25h2v3h-2zM4 15h3v2H4zm2.777-6.811L8.19 6.775l2.121 2.12-1.414 1.415zm14.91.711l2.121-2.12 1.414 1.414-2.12 2.121zm-.001 14.197l1.414-1.415 2.121 2.122-1.414 1.414zM6.78 23.8l2.12-2.122 1.414 1.414-2.121 2.122zM4 30h24v2H4zM4 0h24v2H4zm12 10a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm-4 6a4 4 0 0 1 4-4v8a4 4 0 0 1-4-4z'
  }));
});
WatsonHealthWindowAuto20.displayName = 'WatsonHealthWindowAuto20';
WatsonHealthWindowAuto20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowAuto20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowBase32 = React.forwardRef(function (_ref1953, ref) {
  var className = _ref1953.className,
      children = _ref1953.children,
      style = _ref1953.style,
      tabIndex = _ref1953.tabIndex,
      rest = _objectWithoutProperties$2(_ref1953, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1953 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1953.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1953, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v3h-2zm10 11h3v2h-3zM15 23h2v3h-2zM4 13h3v2H4zm2.775-6.812L8.19 4.773l2.122 2.122-1.414 1.414zm14.921.712l2.12-2.122 1.415 1.415-2.121 2.12zm-.005 14.188l1.415-1.414 2.12 2.122-1.413 1.414zm-14.913.725L8.9 19.69l1.414 1.414-2.121 2.122zM4 28h24v2H4zm12-8a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10v8a4 4 0 0 1 0-8z'
  }));
});
WatsonHealthWindowBase32.displayName = 'WatsonHealthWindowBase32';
WatsonHealthWindowBase32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowBase32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowBase24 = React.forwardRef(function (_ref1954, ref) {
  var className = _ref1954.className,
      children = _ref1954.children,
      style = _ref1954.style,
      tabIndex = _ref1954.tabIndex,
      rest = _objectWithoutProperties$2(_ref1954, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1954 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1954.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1954, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v3h-2zm10 11h3v2h-3zM15 23h2v3h-2zM4 13h3v2H4zm2.775-6.812L8.19 4.773l2.122 2.122-1.414 1.414zm14.921.712l2.12-2.122 1.415 1.415-2.121 2.12zm-.005 14.188l1.415-1.414 2.12 2.122-1.413 1.414zm-14.913.725L8.9 19.69l1.414 1.414-2.121 2.122zM4 28h24v2H4zm12-8a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10v8a4 4 0 0 1 0-8z'
  }));
});
WatsonHealthWindowBase24.displayName = 'WatsonHealthWindowBase24';
WatsonHealthWindowBase24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowBase24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowBase20 = React.forwardRef(function (_ref1955, ref) {
  var className = _ref1955.className,
      children = _ref1955.children,
      style = _ref1955.style,
      tabIndex = _ref1955.tabIndex,
      rest = _objectWithoutProperties$2(_ref1955, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1955 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1955.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1955, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 2h2v3h-2zm10 11h3v2h-3zM15 23h2v3h-2zM4 13h3v2H4zm2.775-6.812L8.19 4.773l2.122 2.122-1.414 1.414zm14.921.712l2.12-2.122 1.415 1.415-2.121 2.12zm-.005 14.188l1.415-1.414 2.12 2.122-1.413 1.414zm-14.913.725L8.9 19.69l1.414 1.414-2.121 2.122zM4 28h24v2H4zm12-8a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10v8a4 4 0 0 1 0-8z'
  }));
});
WatsonHealthWindowBase20.displayName = 'WatsonHealthWindowBase20';
WatsonHealthWindowBase20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowBase20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowOverlay32 = React.forwardRef(function (_ref1956, ref) {
  var className = _ref1956.className,
      children = _ref1956.children,
      style = _ref1956.style,
      tabIndex = _ref1956.tabIndex,
      rest = _objectWithoutProperties$2(_ref1956, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1956 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1956.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1956, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 6h2v3h-2zm10 11h3v2h-3zM15 27h2v3h-2zM4 17h3v2H4zm2.774-6.814l1.414-1.414 2.122 2.122-1.415 1.414zm14.92.712l2.121-2.122 1.415 1.415-2.122 2.121zm-.004 14.189l1.414-1.415 2.121 2.122-1.414 1.414zm-14.913.723l2.12-2.121 1.415 1.414-2.121 2.121zM4 2h24v2H4zm12 22a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10v8a4 4 0 0 1 0-8z'
  }));
});
WatsonHealthWindowOverlay32.displayName = 'WatsonHealthWindowOverlay32';
WatsonHealthWindowOverlay32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowOverlay32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowOverlay24 = React.forwardRef(function (_ref1957, ref) {
  var className = _ref1957.className,
      children = _ref1957.children,
      style = _ref1957.style,
      tabIndex = _ref1957.tabIndex,
      rest = _objectWithoutProperties$2(_ref1957, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1957 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1957.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1957, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 6h2v3h-2zm10 11h3v2h-3zM15 27h2v3h-2zM4 17h3v2H4zm2.774-6.814l1.414-1.414 2.122 2.122-1.415 1.414zm14.92.712l2.121-2.122 1.415 1.415-2.122 2.121zm-.004 14.189l1.414-1.415 2.121 2.122-1.414 1.414zm-14.913.723l2.12-2.121 1.415 1.414-2.121 2.121zM4 2h24v2H4zm12 22a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10v8a4 4 0 0 1 0-8z'
  }));
});
WatsonHealthWindowOverlay24.displayName = 'WatsonHealthWindowOverlay24';
WatsonHealthWindowOverlay24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowOverlay24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthWindowOverlay20 = React.forwardRef(function (_ref1958, ref) {
  var className = _ref1958.className,
      children = _ref1958.children,
      style = _ref1958.style,
      tabIndex = _ref1958.tabIndex,
      rest = _objectWithoutProperties$2(_ref1958, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1958 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1958.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1958, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M15 6h2v3h-2zm10 11h3v2h-3zM15 27h2v3h-2zM4 17h3v2H4zm2.774-6.814l1.414-1.414 2.122 2.122-1.415 1.414zm14.92.712l2.121-2.122 1.415 1.415-2.122 2.121zm-.004 14.189l1.414-1.415 2.121 2.122-1.414 1.414zm-14.913.723l2.12-2.121 1.415 1.414-2.121 2.121zM4 2h24v2H4zm12 22a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-10v8a4 4 0 0 1 0-8z'
  }));
});
WatsonHealthWindowOverlay20.displayName = 'WatsonHealthWindowOverlay20';
WatsonHealthWindowOverlay20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthWindowOverlay20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthZoomPan32 = React.forwardRef(function (_ref1959, ref) {
  var className = _ref1959.className,
      children = _ref1959.children,
      style = _ref1959.style,
      tabIndex = _ref1959.tabIndex,
      rest = _objectWithoutProperties$2(_ref1959, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1959 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1959.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1959, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.01 12l-1.41 1.41L28.18 16l-2.59 2.59L27.01 20l4-4-4-4zm-20.6 1.42L5 12l-4 4 4 4 1.42-1.41L3.83 16l2.58-2.58zM16 28.17l-2.59-2.59L12 27l4 4 4-4-1.41-1.41L16 28.17zm0-24.34l2.58 2.58L20 5l-4-4-4 4 1.41 1.42L16 3.83zM22 16a6 6 0 1 0-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0 0 22 16zm-6 4a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealthZoomPan32.displayName = 'WatsonHealthZoomPan32';
WatsonHealthZoomPan32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthZoomPan32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthZoomPan24 = React.forwardRef(function (_ref1960, ref) {
  var className = _ref1960.className,
      children = _ref1960.children,
      style = _ref1960.style,
      tabIndex = _ref1960.tabIndex,
      rest = _objectWithoutProperties$2(_ref1960, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1960 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1960.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1960, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.01 12l-1.41 1.41L28.18 16l-2.59 2.59L27.01 20l4-4-4-4zm-20.6 1.42L5 12l-4 4 4 4 1.42-1.41L3.83 16l2.58-2.58zM16 28.17l-2.59-2.59L12 27l4 4 4-4-1.41-1.41L16 28.17zm0-24.34l2.58 2.58L20 5l-4-4-4 4 1.41 1.42L16 3.83zM22 16a6 6 0 1 0-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0 0 22 16zm-6 4a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealthZoomPan24.displayName = 'WatsonHealthZoomPan24';
WatsonHealthZoomPan24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthZoomPan24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WatsonHealthZoomPan20 = React.forwardRef(function (_ref1961, ref) {
  var className = _ref1961.className,
      children = _ref1961.children,
      style = _ref1961.style,
      tabIndex = _ref1961.tabIndex,
      rest = _objectWithoutProperties$2(_ref1961, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1961 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1961.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1961, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M27.01 12l-1.41 1.41L28.18 16l-2.59 2.59L27.01 20l4-4-4-4zm-20.6 1.42L5 12l-4 4 4 4 1.42-1.41L3.83 16l2.58-2.58zM16 28.17l-2.59-2.59L12 27l4 4 4-4-1.41-1.41L16 28.17zm0-24.34l2.58 2.58L20 5l-4-4-4 4 1.41 1.42L16 3.83zM22 16a6 6 0 1 0-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0 0 22 16zm-6 4a4 4 0 1 1 4-4 4 4 0 0 1-4 4z'
  }));
});
WatsonHealthZoomPan20.displayName = 'WatsonHealthZoomPan20';
WatsonHealthZoomPan20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WatsonHealthZoomPan20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Watson32 = React.forwardRef(function (_ref1962, ref) {
  var className = _ref1962.className,
      children = _ref1962.children,
      style = _ref1962.style,
      tabIndex = _ref1962.tabIndex,
      rest = _objectWithoutProperties$2(_ref1962, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1962 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1962.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1962, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.74 9.49A11.41 11.41 0 0 0 16 8a.76.76 0 1 0 0 1.51 10.15 10.15 0 0 1 1.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 0 0-2 4.44A9.58 9.58 0 0 1 7 17.22a3.43 3.43 0 0 1 .28-2.66c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 0 0 .74-.78.75.75 0 0 0-.78-.74c-2.68.04-4.77 1.08-5.87 2.9a4.84 4.84 0 0 0-.44 3.79 12 12 0 0 0 3.2 5.22A11.36 11.36 0 0 0 8.52 26a10 10 0 0 1-2-3.48.75.75 0 0 0-.95-.52.76.76 0 0 0-.49 1 11.45 11.45 0 0 0 5.18 6.38A11.42 11.42 0 0 0 16 30.92a11.74 11.74 0 0 0 3-.39 11.48 11.48 0 0 0 2.77-21zm-3.16 19.57a9.9 9.9 0 0 1-7.56-1c-.86-.49-1.21-2-.94-4a18.85 18.85 0 0 0 2.48 1.72 13.92 13.92 0 0 0 6.93 2 11 11 0 0 0 2.42-.28 9.78 9.78 0 0 1-3.33 1.56zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 0 1-2.89-2.12 21.08 21.08 0 0 1 2.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62a10 10 0 0 1 3.66 13.6zM4.16 11.72L1.14 10a.76.76 0 1 0-.76 1.31L3.4 13a.86.86 0 0 0 .38.1.77.77 0 0 0 .66-.38.76.76 0 0 0-.28-1zm4.13-4.13a.74.74 0 0 0 .65.41.75.75 0 0 0 .38-.1.76.76 0 0 0 .28-1l-1.74-3a.76.76 0 0 0-1-.27.75.75 0 0 0-.28 1zM16 6.08a.76.76 0 0 0 .76-.76V1.83a.76.76 0 0 0-1.52 0v3.49a.76.76 0 0 0 .76.76zm6.68 1.79a.75.75 0 0 0 1-.28l1.75-3a.75.75 0 0 0-.28-1 .76.76 0 0 0-1 .27l-1.74 3a.76.76 0 0 0 .27 1.01zm9.22 2.38a.76.76 0 0 0-1-.27l-3 1.74a.76.76 0 0 0-.28 1 .77.77 0 0 0 .66.38.86.86 0 0 0 .38-.1l3-1.75a.76.76 0 0 0 .24-1z'
  }));
});
Watson32.displayName = 'Watson32';
Watson32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Watson32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Watson24 = React.forwardRef(function (_ref1963, ref) {
  var className = _ref1963.className,
      children = _ref1963.children,
      style = _ref1963.style,
      tabIndex = _ref1963.tabIndex,
      rest = _objectWithoutProperties$2(_ref1963, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1963 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1963.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1963, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.74 9.49A11.41 11.41 0 0 0 16 8a.76.76 0 1 0 0 1.51 10.15 10.15 0 0 1 1.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 0 0-2 4.44A9.58 9.58 0 0 1 7 17.22a3.43 3.43 0 0 1 .28-2.66c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 0 0 .74-.78.75.75 0 0 0-.78-.74c-2.68.04-4.77 1.08-5.87 2.9a4.84 4.84 0 0 0-.44 3.79 12 12 0 0 0 3.2 5.22A11.36 11.36 0 0 0 8.52 26a10 10 0 0 1-2-3.48.75.75 0 0 0-.95-.52.76.76 0 0 0-.49 1 11.45 11.45 0 0 0 5.18 6.38A11.42 11.42 0 0 0 16 30.92a11.74 11.74 0 0 0 3-.39 11.48 11.48 0 0 0 2.77-21zm-3.16 19.57a9.9 9.9 0 0 1-7.56-1c-.86-.49-1.21-2-.94-4a18.85 18.85 0 0 0 2.48 1.72 13.92 13.92 0 0 0 6.93 2 11 11 0 0 0 2.42-.28 9.78 9.78 0 0 1-3.33 1.56zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 0 1-2.89-2.12 21.08 21.08 0 0 1 2.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62a10 10 0 0 1 3.66 13.6zM4.16 11.72L1.14 10a.76.76 0 1 0-.76 1.31L3.4 13a.86.86 0 0 0 .38.1.77.77 0 0 0 .66-.38.76.76 0 0 0-.28-1zm4.13-4.13a.74.74 0 0 0 .65.41.75.75 0 0 0 .38-.1.76.76 0 0 0 .28-1l-1.74-3a.76.76 0 0 0-1-.27.75.75 0 0 0-.28 1zM16 6.08a.76.76 0 0 0 .76-.76V1.83a.76.76 0 0 0-1.52 0v3.49a.76.76 0 0 0 .76.76zm6.68 1.79a.75.75 0 0 0 1-.28l1.75-3a.75.75 0 0 0-.28-1 .76.76 0 0 0-1 .27l-1.74 3a.76.76 0 0 0 .27 1.01zm9.22 2.38a.76.76 0 0 0-1-.27l-3 1.74a.76.76 0 0 0-.28 1 .77.77 0 0 0 .66.38.86.86 0 0 0 .38-.1l3-1.75a.76.76 0 0 0 .24-1z'
  }));
});
Watson24.displayName = 'Watson24';
Watson24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Watson24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Watson20 = React.forwardRef(function (_ref1964, ref) {
  var className = _ref1964.className,
      children = _ref1964.children,
      style = _ref1964.style,
      tabIndex = _ref1964.tabIndex,
      rest = _objectWithoutProperties$2(_ref1964, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1964 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1964.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1964, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M21.74 9.49A11.41 11.41 0 0 0 16 8a.76.76 0 1 0 0 1.51 10.15 10.15 0 0 1 1.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 0 0-2 4.44A9.58 9.58 0 0 1 7 17.22a3.43 3.43 0 0 1 .28-2.66c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 0 0 .74-.78.75.75 0 0 0-.78-.74c-2.68.04-4.77 1.08-5.87 2.9a4.84 4.84 0 0 0-.44 3.79 12 12 0 0 0 3.2 5.22A11.36 11.36 0 0 0 8.52 26a10 10 0 0 1-2-3.48.75.75 0 0 0-.95-.52.76.76 0 0 0-.49 1 11.45 11.45 0 0 0 5.18 6.38A11.42 11.42 0 0 0 16 30.92a11.74 11.74 0 0 0 3-.39 11.48 11.48 0 0 0 2.77-21zm-3.16 19.57a9.9 9.9 0 0 1-7.56-1c-.86-.49-1.21-2-.94-4a18.85 18.85 0 0 0 2.48 1.72 13.92 13.92 0 0 0 6.93 2 11 11 0 0 0 2.42-.28 9.78 9.78 0 0 1-3.33 1.56zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 0 1-2.89-2.12 21.08 21.08 0 0 1 2.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62a10 10 0 0 1 3.66 13.6zM4.16 11.72L1.14 10a.76.76 0 1 0-.76 1.31L3.4 13a.86.86 0 0 0 .38.1.77.77 0 0 0 .66-.38.76.76 0 0 0-.28-1zm4.13-4.13a.74.74 0 0 0 .65.41.75.75 0 0 0 .38-.1.76.76 0 0 0 .28-1l-1.74-3a.76.76 0 0 0-1-.27.75.75 0 0 0-.28 1zM16 6.08a.76.76 0 0 0 .76-.76V1.83a.76.76 0 0 0-1.52 0v3.49a.76.76 0 0 0 .76.76zm6.68 1.79a.75.75 0 0 0 1-.28l1.75-3a.75.75 0 0 0-.28-1 .76.76 0 0 0-1 .27l-1.74 3a.76.76 0 0 0 .27 1.01zm9.22 2.38a.76.76 0 0 0-1-.27l-3 1.74a.76.76 0 0 0-.28 1 .77.77 0 0 0 .66.38.86.86 0 0 0 .38-.1l3-1.75a.76.76 0 0 0 .24-1z'
  }));
});
Watson20.displayName = 'Watson20';
Watson20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Watson20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wikis32 = React.forwardRef(function (_ref1965, ref) {
  var className = _ref1965.className,
      children = _ref1965.children,
      style = _ref1965.style,
      tabIndex = _ref1965.tabIndex,
      rest = _objectWithoutProperties$2(_ref1965, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1965 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1965.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1965, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm12 13h-6a24.26 24.26 0 0 0-2.79-10.55A12 12 0 0 1 28 15zM16 28a5 5 0 0 1-.67 0A21.85 21.85 0 0 1 12 17h8a21.85 21.85 0 0 1-3.3 11 5 5 0 0 1-.7 0zm-4-13a21.85 21.85 0 0 1 3.3-11 6 6 0 0 1 1.34 0A21.85 21.85 0 0 1 20 15zm.76-10.55A24.26 24.26 0 0 0 10 15H4a12 12 0 0 1 8.79-10.55zM4.05 17h6a24.26 24.26 0 0 0 2.75 10.55A12 12 0 0 1 4.05 17zm15.16 10.55A24.26 24.26 0 0 0 22 17h6a12 12 0 0 1-8.79 10.55z'
  }));
});
Wikis32.displayName = 'Wikis32';
Wikis32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wikis32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wikis24 = React.forwardRef(function (_ref1966, ref) {
  var className = _ref1966.className,
      children = _ref1966.children,
      style = _ref1966.style,
      tabIndex = _ref1966.tabIndex,
      rest = _objectWithoutProperties$2(_ref1966, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1966 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1966.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1966, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm12 13h-6a24.26 24.26 0 0 0-2.79-10.55A12 12 0 0 1 28 15zM16 28a5 5 0 0 1-.67 0A21.85 21.85 0 0 1 12 17h8a21.85 21.85 0 0 1-3.3 11 5 5 0 0 1-.7 0zm-4-13a21.85 21.85 0 0 1 3.3-11 6 6 0 0 1 1.34 0A21.85 21.85 0 0 1 20 15zm.76-10.55A24.26 24.26 0 0 0 10 15H4a12 12 0 0 1 8.79-10.55zM4.05 17h6a24.26 24.26 0 0 0 2.75 10.55A12 12 0 0 1 4.05 17zm15.16 10.55A24.26 24.26 0 0 0 22 17h6a12 12 0 0 1-8.79 10.55z'
  }));
});
Wikis24.displayName = 'Wikis24';
Wikis24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wikis24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Wikis20 = React.forwardRef(function (_ref1967, ref) {
  var className = _ref1967.className,
      children = _ref1967.children,
      style = _ref1967.style,
      tabIndex = _ref1967.tabIndex,
      rest = _objectWithoutProperties$2(_ref1967, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1967 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1967.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1967, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm12 13h-6a24.26 24.26 0 0 0-2.79-10.55A12 12 0 0 1 28 15zM16 28a5 5 0 0 1-.67 0A21.85 21.85 0 0 1 12 17h8a21.85 21.85 0 0 1-3.3 11 5 5 0 0 1-.7 0zm-4-13a21.85 21.85 0 0 1 3.3-11 6 6 0 0 1 1.34 0A21.85 21.85 0 0 1 20 15zm.76-10.55A24.26 24.26 0 0 0 10 15H4a12 12 0 0 1 8.79-10.55zM4.05 17h6a24.26 24.26 0 0 0 2.75 10.55A12 12 0 0 1 4.05 17zm15.16 10.55A24.26 24.26 0 0 0 22 17h6a12 12 0 0 1-8.79 10.55z'
  }));
});
Wikis20.displayName = 'Wikis20';
Wikis20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Wikis20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WirelessCheckout32 = React.forwardRef(function (_ref1968, ref) {
  var className = _ref1968.className,
      children = _ref1968.children,
      style = _ref1968.style,
      tabIndex = _ref1968.tabIndex,
      rest = _objectWithoutProperties$2(_ref1968, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1968 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1968.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1968, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28v-2a10 10 0 0 0 10-10h2a12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M18 23v-2a5 5 0 0 0 5-5h2a7 7 0 0 1-7 7z'
  }), React.createElement('path', {
    d: 'M27 11h-6V7a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v4H3a1 1 0 0 0-1 1.15L3.88 24.3a2 2 0 0 0 2 1.7H15v-2H5.86L4.17 13H27zM11 7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4h-8z'
  }));
});
WirelessCheckout32.displayName = 'WirelessCheckout32';
WirelessCheckout32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WirelessCheckout32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WirelessCheckout24 = React.forwardRef(function (_ref1969, ref) {
  var className = _ref1969.className,
      children = _ref1969.children,
      style = _ref1969.style,
      tabIndex = _ref1969.tabIndex,
      rest = _objectWithoutProperties$2(_ref1969, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1969 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1969.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1969, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28v-2a10 10 0 0 0 10-10h2a12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M18 23v-2a5 5 0 0 0 5-5h2a7 7 0 0 1-7 7z'
  }), React.createElement('path', {
    d: 'M27 11h-6V7a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v4H3a1 1 0 0 0-1 1.15L3.88 24.3a2 2 0 0 0 2 1.7H15v-2H5.86L4.17 13H27zM11 7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4h-8z'
  }));
});
WirelessCheckout24.displayName = 'WirelessCheckout24';
WirelessCheckout24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WirelessCheckout24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var WirelessCheckout20 = React.forwardRef(function (_ref1970, ref) {
  var className = _ref1970.className,
      children = _ref1970.children,
      style = _ref1970.style,
      tabIndex = _ref1970.tabIndex,
      rest = _objectWithoutProperties$2(_ref1970, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1970 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1970.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1970, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M18 28v-2a10 10 0 0 0 10-10h2a12 12 0 0 1-12 12z'
  }), React.createElement('path', {
    d: 'M18 23v-2a5 5 0 0 0 5-5h2a7 7 0 0 1-7 7z'
  }), React.createElement('path', {
    d: 'M27 11h-6V7a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v4H3a1 1 0 0 0-1 1.15L3.88 24.3a2 2 0 0 0 2 1.7H15v-2H5.86L4.17 13H27zM11 7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4h-8z'
  }));
});
WirelessCheckout20.displayName = 'WirelessCheckout20';
WirelessCheckout20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
WirelessCheckout20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Workspace32 = React.forwardRef(function (_ref1971, ref) {
  var className = _ref1971.className,
      children = _ref1971.children,
      style = _ref1971.style,
      tabIndex = _ref1971.tabIndex,
      rest = _objectWithoutProperties$2(_ref1971, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1971 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1971.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1971, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 17v8H6v-8h10m0-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm11-9v5H17V6h10m0-2H17a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 13v5h-5v-5h5m0-2h-5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zM11 6v5H6V6h5m0-2H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
Workspace32.displayName = 'Workspace32';
Workspace32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Workspace32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Workspace24 = React.forwardRef(function (_ref1972, ref) {
  var className = _ref1972.className,
      children = _ref1972.children,
      style = _ref1972.style,
      tabIndex = _ref1972.tabIndex,
      rest = _objectWithoutProperties$2(_ref1972, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1972 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1972.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1972, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 17v8H6v-8h10m0-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm11-9v5H17V6h10m0-2H17a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 13v5h-5v-5h5m0-2h-5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zM11 6v5H6V6h5m0-2H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
Workspace24.displayName = 'Workspace24';
Workspace24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Workspace24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var Workspace20 = React.forwardRef(function (_ref1973, ref) {
  var className = _ref1973.className,
      children = _ref1973.children,
      style = _ref1973.style,
      tabIndex = _ref1973.tabIndex,
      rest = _objectWithoutProperties$2(_ref1973, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1973 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1973.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1973, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M16 17v8H6v-8h10m0-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm11-9v5H17V6h10m0-2H17a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 13v5h-5v-5h5m0-2h-5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zM11 6v5H6V6h5m0-2H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z'
  }));
});
Workspace20.displayName = 'Workspace20';
Workspace20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Workspace20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomIn32 = React.forwardRef(function (_ref1974, ref) {
  var className = _ref1974.className,
      children = _ref1974.children,
      style = _ref1974.style,
      tabIndex = _ref1974.tabIndex,
      rest = _objectWithoutProperties$2(_ref1974, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1974 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1974.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1974, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13h-4V9h-2v4H9v2h4v4h2v-4h4v-2z'
  }), React.createElement('path', {
    d: 'M22.45 21A10.87 10.87 0 0 0 25 14a11 11 0 1 0-11 11 10.87 10.87 0 0 0 7-2.55L28.59 30 30 28.59zM14 23a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
ZoomIn32.displayName = 'ZoomIn32';
ZoomIn32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomIn32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomIn24 = React.forwardRef(function (_ref1975, ref) {
  var className = _ref1975.className,
      children = _ref1975.children,
      style = _ref1975.style,
      tabIndex = _ref1975.tabIndex,
      rest = _objectWithoutProperties$2(_ref1975, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1975 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1975.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1975, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13h-4V9h-2v4H9v2h4v4h2v-4h4v-2z'
  }), React.createElement('path', {
    d: 'M22.45 21A10.87 10.87 0 0 0 25 14a11 11 0 1 0-11 11 10.87 10.87 0 0 0 7-2.55L28.59 30 30 28.59zM14 23a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
ZoomIn24.displayName = 'ZoomIn24';
ZoomIn24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomIn24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomIn20 = React.forwardRef(function (_ref1976, ref) {
  var className = _ref1976.className,
      children = _ref1976.children,
      style = _ref1976.style,
      tabIndex = _ref1976.tabIndex,
      rest = _objectWithoutProperties$2(_ref1976, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1976 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1976.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1976, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M19 13h-4V9h-2v4H9v2h4v4h2v-4h4v-2z'
  }), React.createElement('path', {
    d: 'M22.45 21A10.87 10.87 0 0 0 25 14a11 11 0 1 0-11 11 10.87 10.87 0 0 0 7-2.55L28.59 30 30 28.59zM14 23a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
ZoomIn20.displayName = 'ZoomIn20';
ZoomIn20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomIn20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomOut32 = React.forwardRef(function (_ref1977, ref) {
  var className = _ref1977.className,
      children = _ref1977.children,
      style = _ref1977.style,
      tabIndex = _ref1977.tabIndex,
      rest = _objectWithoutProperties$2(_ref1977, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1977 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1977.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1977, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 13h10v2H9z'
  }), React.createElement('path', {
    d: 'M22.45 21A10.87 10.87 0 0 0 25 14a11 11 0 1 0-11 11 10.87 10.87 0 0 0 7-2.55L28.59 30 30 28.59zM14 23a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
ZoomOut32.displayName = 'ZoomOut32';
ZoomOut32.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomOut32.defaultProps = {
  width: 32,
  height: 32,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomOut24 = React.forwardRef(function (_ref1978, ref) {
  var className = _ref1978.className,
      children = _ref1978.children,
      style = _ref1978.style,
      tabIndex = _ref1978.tabIndex,
      rest = _objectWithoutProperties$2(_ref1978, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1978 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1978.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1978, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 13h10v2H9z'
  }), React.createElement('path', {
    d: 'M22.45 21A10.87 10.87 0 0 0 25 14a11 11 0 1 0-11 11 10.87 10.87 0 0 0 7-2.55L28.59 30 30 28.59zM14 23a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
ZoomOut24.displayName = 'ZoomOut24';
ZoomOut24.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomOut24.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ZoomOut20 = React.forwardRef(function (_ref1979, ref) {
  var className = _ref1979.className,
      children = _ref1979.children,
      style = _ref1979.style,
      tabIndex = _ref1979.tabIndex,
      rest = _objectWithoutProperties$2(_ref1979, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1979 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1979.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1979, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M9 13h10v2H9z'
  }), React.createElement('path', {
    d: 'M22.45 21A10.87 10.87 0 0 0 25 14a11 11 0 1 0-11 11 10.87 10.87 0 0 0 7-2.55L28.59 30 30 28.59zM14 23a9 9 0 1 1 9-9 9 9 0 0 1-9 9z'
  }));
});
ZoomOut20.displayName = 'ZoomOut20';
ZoomOut20.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ZoomOut20.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretDownGlyph = React.forwardRef(function (_ref1980, ref) {
  var className = _ref1980.className,
      children = _ref1980.children,
      style = _ref1980.style,
      tabIndex = _ref1980.tabIndex,
      rest = _objectWithoutProperties$2(_ref1980, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1980 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1980.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1980, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M8 0L4 4 0 0z'
  }));
});
CaretDownGlyph.displayName = 'CaretDownGlyph';
CaretDownGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretDownGlyph.defaultProps = {
  width: 8,
  height: 4,
  viewBox: '0 0 8 4',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretLeftGlyph = React.forwardRef(function (_ref1981, ref) {
  var className = _ref1981.className,
      children = _ref1981.children,
      style = _ref1981.style,
      tabIndex = _ref1981.tabIndex,
      rest = _objectWithoutProperties$2(_ref1981, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1981 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1981.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1981, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 8L0 4l5-4z'
  }));
});
CaretLeftGlyph.displayName = 'CaretLeftGlyph';
CaretLeftGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretLeftGlyph.defaultProps = {
  width: 5,
  height: 8,
  viewBox: '0 0 5 8',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretRightGlyph = React.forwardRef(function (_ref1982, ref) {
  var className = _ref1982.className,
      children = _ref1982.children,
      style = _ref1982.style,
      tabIndex = _ref1982.tabIndex,
      rest = _objectWithoutProperties$2(_ref1982, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1982 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1982.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1982, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M0 0l5 4-5 4z'
  }));
});
CaretRightGlyph.displayName = 'CaretRightGlyph';
CaretRightGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretRightGlyph.defaultProps = {
  width: 5,
  height: 8,
  viewBox: '0 0 5 8',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var CaretUpGlyph = React.forwardRef(function (_ref1983, ref) {
  var className = _ref1983.className,
      children = _ref1983.children,
      style = _ref1983.style,
      tabIndex = _ref1983.tabIndex,
      rest = _objectWithoutProperties$2(_ref1983, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1983 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1983.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1983, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M0 4l4-4 4 4z'
  }));
});
CaretUpGlyph.displayName = 'CaretUpGlyph';
CaretUpGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
CaretUpGlyph.defaultProps = {
  width: 8,
  height: 4,
  viewBox: '0 0 8 4',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronDownGlyph = React.forwardRef(function (_ref1984, ref) {
  var className = _ref1984.className,
      children = _ref1984.children,
      style = _ref1984.style,
      tabIndex = _ref1984.tabIndex,
      rest = _objectWithoutProperties$2(_ref1984, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1984 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1984.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1984, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 6L0 1 .7.3 5 4.6 9.3.3l.7.7z'
  }));
});
ChevronDownGlyph.displayName = 'ChevronDownGlyph';
ChevronDownGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronDownGlyph.defaultProps = {
  width: 10,
  height: 6,
  viewBox: '0 0 10 6',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronLeftGlyph = React.forwardRef(function (_ref1985, ref) {
  var className = _ref1985.className,
      children = _ref1985.children,
      style = _ref1985.style,
      tabIndex = _ref1985.tabIndex,
      rest = _objectWithoutProperties$2(_ref1985, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1985 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1985.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1985, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M0 5l5-5 .7.7L1.4 5l4.3 4.3-.7.7z'
  }));
});
ChevronLeftGlyph.displayName = 'ChevronLeftGlyph';
ChevronLeftGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronLeftGlyph.defaultProps = {
  width: 6,
  height: 10,
  viewBox: '0 0 6 10',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronRightGlyph = React.forwardRef(function (_ref1986, ref) {
  var className = _ref1986.className,
      children = _ref1986.children,
      style = _ref1986.style,
      tabIndex = _ref1986.tabIndex,
      rest = _objectWithoutProperties$2(_ref1986, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1986 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1986.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1986, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M6 5l-5 5-.7-.7L4.6 5 .3.7 1 0z'
  }));
});
ChevronRightGlyph.displayName = 'ChevronRightGlyph';
ChevronRightGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronRightGlyph.defaultProps = {
  width: 6,
  height: 10,
  viewBox: '0 0 6 10',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var ChevronUpGlyph = React.forwardRef(function (_ref1987, ref) {
  var className = _ref1987.className,
      children = _ref1987.children,
      style = _ref1987.style,
      tabIndex = _ref1987.tabIndex,
      rest = _objectWithoutProperties$2(_ref1987, ["className", "children", "style", "tabIndex"]);

  var _getAttributes1987 = getAttributes(_objectSpread$2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes1987.tabindex,
      props = _objectWithoutProperties$2(_getAttributes1987, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (_typeof$1(style) === 'object') {
    props.style = _objectSpread$2({}, defaultStyle, style);
  } else {
    props.style = defaultStyle;
  }

  if (ref) {
    props.ref = ref;
  }

  return React.createElement('svg', props, children, React.createElement('path', {
    d: 'M5 0l5 5-.7.7L5 1.4.7 5.7 0 5z'
  }));
});
ChevronUpGlyph.displayName = 'ChevronUpGlyph';
ChevronUpGlyph.propTypes = {
  'aria-hidden': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
ChevronUpGlyph.defaultProps = {
  width: 10,
  height: 6,
  viewBox: '0 0 10 6',
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};
var prefix$3 = settings.prefix;

var WebsiteBackToTopBtn = function WebsiteBackToTopBtn() {
  return React.createElement(ScrollToTop, {
    showUnder: 300,
    style: {
      zIndex: 9999
    }
  }, React.createElement("button", {
    className: "".concat(prefix$3, "--back-to-top"),
    "aria-label": "Back to Top"
  }, React.createElement(UpToTop20, null)));
};

var prefix$4 = settings.prefix;

var Grid = function Grid(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement("div", {
    className: classnames(["".concat(prefix$4, "--grid")], className)
  }, children);
};

Grid.propTypes = {
  children: PropTypes.node,

  /**
   * Specify a class name for row
   */
  className: PropTypes.string
};

var Row = function Row(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return React.createElement("div", {
    className: classnames(["".concat(prefix$4, "--row")], className)
  }, children);
};

Row.propTypes = {
  children: PropTypes.node,

  /**
   * Specify a class name for row
   */
  className: PropTypes.string
};

var Column = function Column(_ref3) {
  var _classnames;

  var children = _ref3.children,
      colSm = _ref3.colSm,
      colMd = _ref3.colMd,
      colLg = _ref3.colLg,
      offsetLg = _ref3.offsetLg,
      offsetMd = _ref3.offsetMd,
      offsetSm = _ref3.offsetSm,
      noGutterSm = _ref3.noGutterSm,
      noGutterMd = _ref3.noGutterMd,
      noGutterLg = _ref3.noGutterLg,
      noGutterSmLeft = _ref3.noGutterSmLeft,
      noGutterMdLeft = _ref3.noGutterMdLeft,
      noGutterLgLeft = _ref3.noGutterLgLeft,
      className = _ref3.className;
  var colClasses = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$4, "--no-gutter-sm"), noGutterSm), _defineProperty(_classnames, "".concat(prefix$4, "--no-gutter-md"), noGutterMd), _defineProperty(_classnames, "".concat(prefix$4, "--no-gutter-lg"), noGutterLg), _defineProperty(_classnames, "".concat(prefix$4, "--no-gutter-sm--left"), noGutterSmLeft), _defineProperty(_classnames, "".concat(prefix$4, "--no-gutter-md--left"), noGutterMdLeft), _defineProperty(_classnames, "".concat(prefix$4, "--no-gutter-lg--left"), noGutterLgLeft), _defineProperty(_classnames, "".concat(prefix$4, "--offset-sm-").concat(offsetSm), offsetSm), _defineProperty(_classnames, "".concat(prefix$4, "--offset-md-").concat(offsetMd), offsetMd), _defineProperty(_classnames, "".concat(prefix$4, "--offset-lg-").concat(offsetLg), offsetLg), _defineProperty(_classnames, "".concat(prefix$4, "--col-lg-").concat(colLg), colLg), _defineProperty(_classnames, "".concat(prefix$4, "--col-md-").concat(colMd), colMd), _defineProperty(_classnames, "".concat(prefix$4, "--col-sm-").concat(colSm), colSm), _defineProperty(_classnames, className, className), _classnames));
  return React.createElement("div", {
    className: colClasses
  }, children);
};

Column.defaultProps = {
  colLg: '12',
  bleed: false
};
Column.propTypes = {
  children: PropTypes.node,

  /**
   * Specify the col width at small breakpoint
   */
  colSm: PropTypes.number,

  /**
   * Specify the col width at medium breakpoint
   */
  colMd: PropTypes.number,

  /**
   * Specify the col width at large breakpoint
   */
  colLg: PropTypes.number,

  /**
   * Specify the col offset at large breakpoint
   */
  offsetLg: PropTypes.number,

  /**
   * Specify the col offset at medium breakpoint
   */
  offsetMd: PropTypes.number,

  /**
   * Specify the col offset at small breakpoint
   */
  offsetSm: PropTypes.number,

  /**
   * Specify a no-gutter class
   */
  noGutterSm: PropTypes.bool,

  /**
   * Specify a no-gutter class
   */
  noGutterMd: PropTypes.bool,

  /**
   * Specify a no-gutter class
   */
  noGutterLg: PropTypes.bool,

  /**
   * Specify a no-gutter class at small breakpoint
   */
  noGutterSmLeft: PropTypes.bool,

  /**
   * Specify a no-gutter class at medium breakpoint
   */
  noGutterMdLeft: PropTypes.bool,

  /**
   * Specify a no-gutter class at large breakpoint
   */
  noGutterLgLeft: PropTypes.bool,

  /**
   * Specify a class name for column
   */
  className: PropTypes.string
};

var TypefaceSubFamilies =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TypefaceSubFamilies, _React$Component);

  function TypefaceSubFamilies() {
    var _this;

    _classCallCheck(this, TypefaceSubFamilies);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TypefaceSubFamilies).call(this));

    _this.onChange = function (label, value) {
      _this.setState({
        fontVariant: value,
        fontVariantLabel: label
      });
    };

    _this.updateDimensions = function () {
      if (window.innerWidth < 750) {
        _this.setState({
          displayMobile: true
        });
      } else {
        _this.setState({
          displayMobile: false
        });
      }
    };

    _this.state = {
      fontVariant: 'type-serif',
      fontVariantLabel: 'IBM Plex Serif',
      displayMobile: false
    };
    return _this;
  }

  _createClass(TypefaceSubFamilies, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _classnames2,
          _classnames3,
          _this2 = this;

      var prefix = settings.prefix;
      var fontVariants = [{
        label: 'IBM Plex Sans',
        value: 'type-sans'
      }, {
        label: 'IBM Plex Mono',
        value: 'type-mono'
      }, {
        label: 'IBM Plex Serif',
        value: 'type-serif'
      }, {
        label: 'IBM Plex Condensed',
        value: 'type-sans-condensed'
      }];
      var classNamesMenuDropdown = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "--hide"), !this.state.displayMobile), _defineProperty(_classnames, "".concat(prefix, "--show"), this.state.displayMobile), _classnames));
      var classNamesMenuTabs = classnames((_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefix, "--subfamilies-tabs-container"), true), _defineProperty(_classnames2, "".concat(prefix, "--hide"), this.state.displayMobile), _defineProperty(_classnames2, "".concat(prefix, "--show"), !this.state.displayMobile), _classnames2));
      var classNamesContainer = classnames((_classnames3 = {}, _defineProperty(_classnames3, "".concat(prefix, "--subfamilies-TypeTesterExample"), true), _defineProperty(_classnames3, "".concat(prefix, "--col-md-8"), true), _defineProperty(_classnames3, "".concat(prefix, "--col-sm-4"), true), _defineProperty(_classnames3, 'flex-wrap', true), _defineProperty(_classnames3, "".concat(prefix + '--' + this.state.fontVariant), true), _classnames3));
      return React.createElement("div", {
        className: "".concat(prefix, "--subfamilies")
      }, React.createElement("div", {
        className: "".concat(prefix, "--row ").concat(prefix, "--offset-lg-4")
      }, React.createElement("div", {
        className: "".concat(prefix, "--subfamilies-dropdown-container")
      }, React.createElement("div", {
        className: classNamesMenuDropdown
      }, React.createElement(Dropdown, {
        items: fontVariants,
        label: this.state.fontVariantLabel,
        selected: this.state.fontVariant,
        onChange: function onChange(_ref) {
          var selectedItem = _ref.selectedItem;
          setTimeout(function () {
            return _this2.setState({
              fontVariant: selectedItem.value,
              fontVariantLabel: selectedItem.label
            });
          }, 100);
        },
        selectedItem: this.state.selectedItem
      }))), React.createElement("div", {
        className: classNamesMenuTabs
      }, fontVariants.map(function (fontVariant) {
        return React.createElement("button", {
          className: fontVariant.label === _this2.state.fontVariantLabel ? "".concat(prefix, "--subfamilies-button active") : "".concat(prefix, "--subfamilies-button"),
          onClick: function onClick() {
            _this2.setState({
              fontVariant: fontVariant.value,
              fontVariantLabel: fontVariant.label
            });
          }
        }, fontVariant.label);
      })), React.createElement("div", {
        className: classNamesContainer
      }, React.createElement("div", {
        className: "".concat(prefix, "--padding-left-none ").concat(prefix, "--padding--horizontal ").concat(prefix, "--col-md-4")
      }, React.createElement("div", {
        style: {
          fontWeight: 100
        }
      }, "Thin"), React.createElement("div", {
        style: {
          fontWeight: 100
        },
        className: "".concat(prefix, "--type-italic")
      }, "Thin Italic"), React.createElement("div", {
        style: {
          fontWeight: 200
        }
      }, "ExtraLight"), React.createElement("div", {
        style: {
          fontWeight: 200
        },
        className: "".concat(prefix, "--type-italic")
      }, "ExtraLight Italic"), React.createElement("div", {
        style: {
          fontWeight: 300
        }
      }, "Light"), React.createElement("div", {
        style: {
          fontWeight: 300
        },
        className: "".concat(prefix, "--type-italic")
      }, "Light Italic"), React.createElement("div", {
        style: {
          fontWeight: 400
        }
      }, "Regular"), React.createElement("div", {
        style: {
          fontWeight: 400
        },
        className: "".concat(prefix, "--type-italic")
      }, "Regular Italic")), React.createElement("div", {
        className: "".concat(prefix, "--padding-left-none ").concat(prefix, "--padding--horizontal ").concat(prefix, "--col-md-4")
      }, React.createElement("div", {
        style: {
          fontWeight: 450
        }
      }, "Text"), React.createElement("div", {
        style: {
          fontWeight: 450
        },
        className: "".concat(prefix, "--type-italic")
      }, "Text Italic"), React.createElement("div", {
        style: {
          fontWeight: 500
        }
      }, "Medium"), React.createElement("div", {
        style: {
          fontWeight: 500
        },
        className: "".concat(prefix, "--type-italic")
      }, "Medium Italic"), React.createElement("div", {
        style: {
          fontWeight: 600
        }
      }, "SemiBold"), React.createElement("div", {
        style: {
          fontWeight: 600
        },
        className: "".concat(prefix, "--type-italic")
      }, "SemiBold Italic"), React.createElement("div", {
        style: {
          fontWeight: 700
        }
      }, "Bold"), React.createElement("div", {
        style: {
          fontWeight: 700
        },
        className: "".concat(prefix, "--type-italic")
      }, "Bold Italic")))));
    }
  }]);

  return TypefaceSubFamilies;
}(React.Component);

var prefix$5 = settings.prefix;

var AnchorLinks =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AnchorLinks, _React$Component);

  function AnchorLinks() {
    _classCallCheck(this, AnchorLinks);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnchorLinks).apply(this, arguments));
  }

  _createClass(AnchorLinks, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          children = _this$props.children,
          small = _this$props.small;
      var isColumn = React.Children.toArray(children.props.children).length > 6;
      var classNames = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$5, "--anchor-links"), true), _defineProperty(_classnames, "".concat(prefix$5, "--anchor-links--small"), small), _defineProperty(_classnames, "".concat(prefix$5, "--anchor-links--column"), isColumn), _classnames));
      return React.createElement("div", {
        className: classNames
      }, children);
    }
  }]);

  return AnchorLinks;
}(React.Component);

AnchorLinks.propTypes = {
  children: PropTypes.node,
  small: PropTypes.bool
};
var prefix$6 = settings.prefix;

var PlayPauseButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PlayPauseButton, _React$Component);

  function PlayPauseButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PlayPauseButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PlayPauseButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hover: false
    };

    _this.onOver = function () {
      _this.setState({
        hover: true
      });
    };

    _this.onOut = function () {
      _this.setState({
        hover: false
      });
    };

    return _this;
  }

  _createClass(PlayPauseButton, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          onClick = _this$props.onClick,
          playing = _this$props.playing,
          loop = _this$props.loop,
          cornerPlayButton = _this$props.cornerPlayButton,
          hovering = _this$props.hovering;
      var hover = this.state.hover;
      return React.createElement("button", {
        className: classnames("".concat(prefix$6, "--play-pause-button"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefix$6, "--play-pause-hide-on-mobile"), loop), _defineProperty(_classnames, "".concat(prefix$6, "--play-pause-corner"), cornerPlayButton), _defineProperty(_classnames, "".concat(prefix$6, "--play-pause-hovering"), hovering), _classnames)),
        onMouseOver: this.onOver,
        onMouseOut: this.onOut,
        onClick: onClick
      }, // corner play button - ex homepage player
      cornerPlayButton && React.createElement(React.Fragment, null, React.createElement("span", {
        className: classnames("".concat(prefix$6, "--play-pause-icon"), {
          active: playing && hover
        })
      }, React.createElement(PauseOutlineFilled20, null)), React.createElement("span", {
        className: classnames("".concat(prefix$6, "--play-pause-icon"), {
          active: playing && !hover
        })
      }, React.createElement(PauseOutline20, null)), React.createElement("span", {
        className: classnames("".concat(prefix$6, "--play-pause-icon"), {
          active: !playing && hover
        })
      }, React.createElement(PlayOutlineFilled20, null)), React.createElement("span", {
        className: classnames("".concat(prefix$6, "--play-pause-icon"), {
          active: !playing && !hover
        })
      }, React.createElement(PlayOutline20, null))), // standard center play button - use by default
      !cornerPlayButton && React.createElement(React.Fragment, null, React.createElement("span", {
        className: "".concat(prefix$6, "--play-pause-background")
      }), React.createElement("span", {
        className: classnames("".concat(prefix$6, "--play-pause-icon"), {
          active: playing
        })
      }, React.createElement(Pause32, null)), React.createElement("span", {
        className: classnames("".concat(prefix$6, "--play-pause-icon"), {
          active: !playing
        })
      }, React.createElement(Play32, null))));
    }
  }]);

  return PlayPauseButton;
}(React.Component);

PlayPauseButton.propTypes = {
  // action to do on click
  onClick: PropTypes.func,
  // status of media
  playing: PropTypes.bool,
  // use corner button
  cornerPlayButton: PropTypes.bool,
  // video is looping
  loop: PropTypes.bool,
  // parent determines play/pause visibility
  hovering: PropTypes.bool
};
var prefix$7 = settings.prefix;

var VideoInternal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(VideoInternal, _React$Component);

  function VideoInternal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VideoInternal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VideoInternal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      playing: true,
      hovering: false
    };

    _this.onPlayPauseClick = function () {
      _this.setState({
        playing: !_this.state.playing
      });
    };

    _this.onVideoEnded = function () {
      var loop = _this.props.loop;

      if (!loop) {
        _this.setState({
          playing: false
        });
      }
    };

    _this.onMouseOver = function () {
      _this.setState({
        hovering: true
      });
    };

    _this.onMouseOut = function () {
      _this.setState({
        hovering: false
      });
    };

    return _this;
  }

  _createClass(VideoInternal, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextState.playing !== this.state.playing) {
        nextState.playing ? this.videoRef.play() : this.videoRef.pause();
      }

      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.videoRef.addEventListener('ended', this.onVideoEnded);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.videoRef.removeEventListener('ended', this.onVideoEnded);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          poster = _this$props.poster,
          src = _this$props.src,
          loop = _this$props.loop,
          overlay = _this$props.overlay,
          cornerPlayButton = _this$props.cornerPlayButton,
          children = _this$props.children;
      var _this$state = this.state,
          playing = _this$state.playing,
          hovering = _this$state.hovering;
      return React.createElement("div", {
        className: "".concat(prefix$7, "--video-internal-container"),
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut
      }, React.createElement("video", {
        className: "".concat(prefix$7, "--video-internal"),
        controls: false,
        autoPlay: true,
        loop: loop,
        muted: true,
        preload: "auto",
        playsInline: true,
        poster: poster,
        type: "video/mp4",
        ref: function ref(video) {
          return _this2.videoRef = video;
        }
      }, React.createElement("source", {
        src: src,
        type: "video/mp4"
      }), "Your browser does not support the video tag."), overlay && React.createElement("div", {
        className: "".concat(prefix$7, "--video-internal-overlay")
      }), children, React.createElement(PlayPauseButton, {
        onClick: this.onPlayPauseClick,
        playing: playing,
        loop: loop,
        cornerPlayButton: cornerPlayButton,
        hovering: hovering
      }));
    }
  }]);

  return VideoInternal;
}(React.Component);

VideoInternal.propTypes = {
  // poster image path
  poster: PropTypes.string,
  // video image path
  src: PropTypes.string,
  // loop boolean
  loop: PropTypes.bool,
  // black overlay over video
  overlay: PropTypes.bool,
  // button in lower left corner
  cornerPlayButton: PropTypes.bool
};
/**
 * Copyright IBM Corp. 2018, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Convert
// Default, Use with em() and rem() functions

var baseFontSize = 16;
/**
 * Convert a given px unit to a rem unit
 * @param {number} px
 * @returns {string}
 */

function rem(px) {
  return "".concat(px / baseFontSize, "rem");
} // Initial map of our breakpoints and their values


var breakpoints = {
  sm: {
    width: rem(320),
    columns: 4,
    margin: '0'
  },
  md: {
    width: rem(672),
    columns: 8,
    margin: rem(16)
  },
  lg: {
    width: rem(1056),
    columns: 16,
    margin: rem(16)
  },
  xlg: {
    width: rem(1312),
    columns: 16,
    margin: rem(16)
  },
  max: {
    width: rem(1584),
    columns: 16,
    margin: rem(16)
  }
};
var prefix$8 = settings.prefix;

var HomepageVideo =
/*#__PURE__*/
function (_Component) {
  _inherits(HomepageVideo, _Component);

  function HomepageVideo() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HomepageVideo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HomepageVideo)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      loop: true
    };

    _this.onResize = function () {
      var loop = _this.state.loop;

      if (window.matchMedia("(max-width: ".concat(breakpoints.md.width, ")")).matches) {
        if (loop) {
          _this.setState({
            loop: false
          });
        }
      } else {
        if (!loop) {
          _this.setState({
            loop: true
          });
        }
      }
    };

    return _this;
  }

  _createClass(HomepageVideo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var loop = this.state.loop;
      var _this$props = this.props,
          src = _this$props.src,
          poster = _this$props.poster;
      return React.createElement("div", {
        className: "".concat(prefix$8, "--homepage-video-container")
      }, React.createElement("div", {
        className: "".concat(prefix$8, "--homepage-video-wrapper")
      }, React.createElement(VideoInternal, {
        loop: loop,
        poster: poster,
        src: src,
        overlay: true,
        cornerPlayButton: true
      }, React.createElement("div", {
        className: "".concat(prefix$8, "--homepage-video-overlay-content ").concat(prefix$8, "--grid")
      }, React.createElement("div", {
        className: "".concat(prefix$8, "--homepage-video-container-cta ").concat(prefix$8, "--row")
      }, React.createElement(Link, {
        className: "".concat(prefix$8, "--homepage-video-cta ").concat(prefix$8, "--offset-md-4 ").concat(prefix$8, "--col-md-2 ").concat(prefix$8, "--offset-lg-8 ").concat(prefix$8, "--col-lg-4"),
        to: "/philosophy/"
      }, React.createElement("p", {
        className: "".concat(prefix$8, "--type-expressive-heading-03")
      }, "Philosophy"), React.createElement("div", {
        className: "".concat(prefix$8, "--homepage-video-arrow-container")
      }, React.createElement(ArrowRight20, {
        className: "".concat(prefix$8, "--homepage-video-cta-icon")
      }))), React.createElement(Link, {
        className: "".concat(prefix$8, "--homepage-video-cta ").concat(prefix$8, "--col-md-2 ").concat(prefix$8, "--col-lg-4"),
        to: "/gallery/"
      }, React.createElement("p", {
        className: "".concat(prefix$8, "--type-expressive-heading-03")
      }, "Gallery"), React.createElement("div", {
        className: "".concat(prefix$8, "--homepage-video-arrow-container")
      }, React.createElement(ArrowRight20, {
        className: "".concat(prefix$8, "--homepage-video-cta-icon")
      }))))))));
    }
  }]);

  return HomepageVideo;
}(Component);

HomepageVideo.defaultProps = {
  poster: 'images/hero-video-poster.jpg',
  src: 'videos/hero-video.mp4'
};
HomepageVideo.propTypes = {
  // url to video
  src: PropTypes.string,
  // url to poster
  poster: PropTypes.string
};

(function (Prism) {
  var insideString = {
    variable: [// Arithmetic Environment
    {
      pattern: /\$?\(\([\s\S]+?\)\)/,
      inside: {
        // If there is a $ sign at the beginning highlight $(( and )) as variable
        variable: [{
          pattern: /(^\$\(\([\s\S]+)\)\)/,
          lookbehind: true
        }, /^\$\(\(/],
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee]-?\d+)?/,
        // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
        operator: /--?|-=|\+\+?|\+=|!=?|~|\*\*?|\*=|\/=?|%=?|<<=?|>>=?|<=?|>=?|==?|&&?|&=|\^=?|\|\|?|\|=|\?|:/,
        // If there is no $ sign at the beginning highlight (( and )) as punctuation
        punctuation: /\(\(?|\)\)?|,|;/
      }
    }, // Command Substitution
    {
      pattern: /\$\([^)]+\)|`[^`]+`/,
      greedy: true,
      inside: {
        variable: /^\$\(|^`|\)$|`$/
      }
    }, /\$(?:[\w#?*!@]+|\{[^}]+\})/i]
  };
  Prism.languages.bash = {
    'shebang': {
      pattern: /^#!\s*\/bin\/bash|^#!\s*\/bin\/sh/,
      alias: 'important'
    },
    'comment': {
      pattern: /(^|[^"{\\])#.*/,
      lookbehind: true
    },
    'string': [//Support for Here-Documents https://en.wikipedia.org/wiki/Here_document
    {
      pattern: /((?:^|[^<])<<\s*)["']?(\w+?)["']?\s*\r?\n(?:[\s\S])*?\r?\n\2/,
      lookbehind: true,
      greedy: true,
      inside: insideString
    }, {
      pattern: /(["'])(?:\\[\s\S]|\$\([^)]+\)|`[^`]+`|(?!\1)[^\\])*\1/,
      greedy: true,
      inside: insideString
    }],
    'variable': insideString.variable,
    // Originally based on http://ss64.com/bash/
    'function': {
      pattern: /(^|[\s;|&])(?:add|alias|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|builtin|bzip2|cal|cat|cd|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|comm|command|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|enable|env|ethtool|eval|exec|expand|expect|export|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|getopts|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|hash|head|help|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logout|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|popd|pr|printcap|printenv|printf|ps|pushd|pv|pwd|quota|quotacheck|quotactl|ram|rar|rcp|read|readarray|readonly|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|shift|shopt|shutdown|sleep|slocate|sort|source|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tail|tar|tee|test|time|timeout|times|top|touch|tr|traceroute|trap|tsort|tty|type|ulimit|umask|umount|unalias|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zip|zypper)(?=$|[\s;|&])/,
      lookbehind: true
    },
    'keyword': {
      pattern: /(^|[\s;|&])(?:let|:|\.|if|then|else|elif|fi|for|break|continue|while|in|case|function|select|do|done|until|echo|exit|return|set|declare)(?=$|[\s;|&])/,
      lookbehind: true
    },
    'boolean': {
      pattern: /(^|[\s;|&])(?:true|false)(?=$|[\s;|&])/,
      lookbehind: true
    },
    'operator': /&&?|\|\|?|==?|!=?|<<<?|>>|<=?|>=?|=~/,
    'punctuation': /\$?\(\(?|\)\)?|\.\.|[{}[\];]/
  };
  var inside = insideString.variable[1].inside;
  inside.string = Prism.languages.bash.string;
  inside['function'] = Prism.languages.bash['function'];
  inside.keyword = Prism.languages.bash.keyword;
  inside['boolean'] = Prism.languages.bash['boolean'];
  inside.operator = Prism.languages.bash.operator;
  inside.punctuation = Prism.languages.bash.punctuation;
  Prism.languages.shell = Prism.languages.bash;
})(Prism);

Prism.languages.scss = Prism.languages.extend('css', {
  'comment': {
    pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
    lookbehind: true
  },
  'atrule': {
    pattern: /@[\w-]+(?:\([^()]+\)|[^(])*?(?=\s+[{;])/,
    inside: {
      'rule': /@[\w-]+/ // See rest below

    }
  },
  // url, compassified
  'url': /(?:[-a-z]+-)*url(?=\()/i,
  // CSS selector regex is not appropriate for Sass
  // since there can be lot more things (var, @ directive, nesting..)
  // a selector must start at the end of a property or after a brace (end of other rules or nesting)
  // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
  // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
  // can "pass" as a selector- e.g: proper#{$erty})
  // this one was hard to do, so please be careful if you edit this one :)
  'selector': {
    // Initial look-ahead is used to prevent matching of blank selectors
    pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()]|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}]+[:{][^}]+))/m,
    inside: {
      'parent': {
        pattern: /&/,
        alias: 'important'
      },
      'placeholder': /%[-\w]+/,
      'variable': /\$[-\w]+|#\{\$[-\w]+\}/
    }
  },
  'property': {
    pattern: /(?:[\w-]|\$[-\w]+|#\{\$[-\w]+\})+(?=\s*:)/,
    inside: {
      'variable': /\$[-\w]+|#\{\$[-\w]+\}/
    }
  }
});
Prism.languages.insertBefore('scss', 'atrule', {
  'keyword': [/@(?:if|else(?: if)?|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)/i, {
    pattern: /( +)(?:from|through)(?= )/,
    lookbehind: true
  }]
});
Prism.languages.insertBefore('scss', 'important', {
  // var and interpolated vars
  'variable': /\$[-\w]+|#\{\$[-\w]+\}/
});
Prism.languages.insertBefore('scss', 'function', {
  'placeholder': {
    pattern: /%[-\w]+/,
    alias: 'selector'
  },
  'statement': {
    pattern: /\B!(?:default|optional)\b/i,
    alias: 'keyword'
  },
  'boolean': /\b(?:true|false)\b/,
  'null': {
    pattern: /\bnull\b/,
    alias: 'keyword'
  },
  'operator': {
    pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|or|not)(?=\s)/,
    lookbehind: true
  }
});
Prism.languages.scss['atrule'].inside.rest = Prism.languages.scss;
var prefix$9 = settings.prefix;

var WebsiteCodeSnippet =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WebsiteCodeSnippet, _React$Component);

  function WebsiteCodeSnippet() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, WebsiteCodeSnippet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WebsiteCodeSnippet)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      copied: false,
      multi: true
    };
    return _this;
  }

  _createClass(WebsiteCodeSnippet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Prism$1.highlightAll();

      if (this.codeRef) {
        if (this.codeRef.clientHeight > 20) {
          this.setState({
            multi: true
          });
        } else {
          this.setState({
            multi: false
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      Prism$1.highlightAll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var type = this.state.multi ? 'multi' : 'single';
      return React.createElement("div", {
        className: "".concat(prefix$9, "--row")
      }, React.createElement("div", {
        className: "".concat(prefix$9, "--col-lg-8 ").concat(prefix$9, "--offset-lg-4 ").concat(prefix$9, "--no-gutter")
      }, React.createElement("div", {
        className: "".concat(prefix$9, "--snippet--website")
      }, React.createElement(CopyToClipboard, {
        onCopy: function onCopy() {
          return _this2.setState({
            copied: true
          });
        }
      }, React.createElement(CodeSnippet, {
        type: type
      }, React.createElement("div", {
        ref: function ref(element) {
          return _this2.codeRef = element;
        }
      }, children))))));
    }
  }]);

  return WebsiteCodeSnippet;
}(React.Component);

WebsiteCodeSnippet.propTypes = {
  children: PropTypes.array
};
var prefix$a = settings.prefix;

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Overlay)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      showOverlay: false
    };
    return _this;
  }

  _createClass(Overlay, [{
    key: "getImage",
    value: function getImage(reactTree, image) {
      var _this2 = this;

      React.Children.forEach(reactTree, function (node) {
        if (node.type === 'img') {
          image.title = node.props.title;
          image.src = node.props.src;
          image.alt = node.props.alt;
          image.caption = node.props.caption;
        } else if (node.props && node.props.children) {
          _this2.getImage(node.props.children, image);
        }
      });
      return image;
    }
  }, {
    key: "render",
    value: function render() {
      var image = this.getImage(this.props.children, {}); //const { children } = this.props;

      var displayTitle = image.title ? image.title : this.props.caption;
      return React.createElement("div", {
        className: "".concat(prefix$a, "--overlay-content")
      }, React.createElement("div", {
        className: "".concat(prefix$a, "--overlay-bg")
      }), React.createElement("div", {
        className: "".concat(prefix$a, "--overlay-leftArea"),
        show: this.props.show
      }, React.createElement("div", {
        className: "".concat(prefix$a, "--overlay-caption ").concat(prefix$a, "--type-heading-02")
      }, displayTitle)), React.createElement("div", {
        className: "".concat(prefix$a, "--overlay-centerArea"),
        show: this.props.show
      }, React.createElement("img", {
        className: "".concat(prefix$a, "--overlay-image"),
        src: image.src,
        alt: image.alt
      })), React.createElement("div", {
        className: "".concat(prefix$a, "--overlay-rightArea"),
        show: this.props.show
      }, this.props.closeElement));
    }
  }]);

  return Overlay;
}(React.Component);

Overlay.propTypes = {
  children: PropTypes.element,

  /** caption (optional) */
  caption: PropTypes.string,

  /** default to false, set to true for dark background */
  dark: PropTypes.string,
  show: PropTypes.bool
};
Overlay.propTypes = {
  /**
   * Specify an array of links
   */
};
var prefix$b = settings.prefix;

var ImageComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(ImageComponent, _Component);

  function ImageComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ImageComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ImageComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      showOverlay: false
    };

    _this.handleKeyboardEvent = function (e) {
      var key = e.key;

      if (_this.state.showOverlay && key === 'Escape') {
        _this.setState({
          showOverlay: false
        }, function () {
          document.body.style.overflow = 'visible';
        });
      }
    };

    _this.handleImageClick = function () {
      if (_this.props.zoom) {
        if (window.innerWidth < 672) return;

        _this.setState({
          showOverlay: true
        }, function () {
          document.body.style.overflow = 'hidden';
        });
      }
    };

    _this.handleCloseClick = function () {
      _this.setState({
        showOverlay: false
      }, function () {
        document.body.style.overflow = 'visible';
      });
    };

    return _this;
  }

  _createClass(ImageComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyboardEvent, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyboardEvent, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames, _classnames2, _classnames3;

      var _this$props = this.props,
          caption = _this$props.caption,
          children = _this$props.children,
          cols = _this$props.cols,
          border = _this$props.border,
          className = _this$props.className,
          fixed = _this$props.fixed,
          bg = _this$props.bg,
          zoom = _this$props.zoom;
      var columnClasses = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$b, "--col-lg-12 ").concat(prefix$b, "--offset-lg-4"), cols == 12), _defineProperty(_classnames, "".concat(prefix$b, "--col-lg-8 ").concat(prefix$b, "--offset-lg-4"), cols == 8), _defineProperty(_classnames, "".concat(prefix$b, "--col-lg-6 ").concat(prefix$b, "--col-md-6 ").concat(prefix$b, "--offset-lg-4"), cols == 6), _defineProperty(_classnames, "".concat(prefix$b, "--col-lg-4 ").concat(prefix$b, "--offset-lg-4"), cols == 4), _classnames));
      var imgComponentClasses = classnames(className, (_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefix$b, "--image-component"), true), _defineProperty(_classnames2, 'no-caption', caption === undefined), _defineProperty(_classnames2, "border", border === 'true'), _defineProperty(_classnames2, 'transparent-bg', bg === 'none'), _defineProperty(_classnames2, 'fixed-default', fixed === 'default'), _defineProperty(_classnames2, 'fixed-large', fixed === 'large'), _defineProperty(_classnames2, "zoom", zoom === 'true'), _classnames2));
      var magnifierClasses = classnames((_classnames3 = {}, _defineProperty(_classnames3, "".concat(prefix$b, "--image-component-magnifier"), zoom === 'true'), _defineProperty(_classnames3, "".concat(prefix$b, "--image-component-magnifier-hide"), zoom != 'true'), _classnames3));
      var imgWrapperClasses = classnames(_defineProperty({}, "".concat(prefix$b, "--image-component-wrapper-zoom"), zoom === 'true'));
      if (this.state.showOverlay) return React.createElement(Overlay, {
        show: this.state.showOverlay,
        caption: caption,
        closeElement: React.createElement("div", {
          className: "".concat(prefix$b, "--imageZoom-close"),
          onClick: this.handleCloseClick
        }, React.createElement(Close32, null))
      }, children);
      return React.createElement("div", {
        className: "".concat(prefix$b, "--image-component__container ").concat(prefix$b, "--row"),
        onClick: this.handleImageClick
      }, React.createElement("div", {
        className: columnClasses
      }, React.createElement("div", {
        className: imgWrapperClasses
      }, React.createElement("div", {
        className: imgComponentClasses
      }, children), React.createElement("div", {
        className: magnifierClasses
      }, React.createElement(ZoomIn20, null)))), caption && React.createElement("div", {
        className: "".concat(prefix$b, "--col-lg-4 ").concat(prefix$b, "--col-md-4 ").concat(prefix$b, "--offset-lg-4")
      }, React.createElement("p", {
        className: "".concat(prefix$b, "--image-component__caption")
      }, caption)));
    }
  }]);

  return ImageComponent;
}(Component);

ImageComponent.propTypes = {
  caption: PropTypes.string,
  cols: PropTypes.number,
  children: PropTypes.node,
  border: PropTypes.string,
  className: PropTypes.string,
  fixed: PropTypes.string,
  bg: PropTypes.string,
  zoom: PropTypes.bool
};
ImageComponent.defaultProps = {
  cols: '12',
  zoom: false
};
var prefix$c = settings.prefix;

var DoDontExample =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DoDontExample, _React$Component);

  function DoDontExample() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DoDontExample);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DoDontExample)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderCaption = function (label, description) {
      if (label || description) {
        return React.createElement("div", {
          className: "".concat(prefix$c, "--example__caption ").concat(prefix$c, "--row")
        }, label && React.createElement("p", {
          className: "".concat(prefix$c, "--example__title")
        }, label), description && React.createElement("p", {
          className: "".concat(prefix$c, "--example__description")
        }, description));
      }
    };

    return _this;
  }

  _createClass(DoDontExample, [{
    key: "render",
    value: function render() {
      var _classnames, _classnames2;

      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          description = _this$props.description,
          text = _this$props.text,
          dark = _this$props.dark,
          square = _this$props.square,
          correct = _this$props.correct;
      var wrapperClassNames = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefix$c, "--example"), true), _defineProperty(_classnames, "".concat(prefix$c, "--example--square"), square), _defineProperty(_classnames, "".concat(prefix$c, "--example--correct"), correct), _defineProperty(_classnames, "".concat(prefix$c, "--example--incorrect"), !correct), _defineProperty(_classnames, "".concat(prefix$c, "--example--dark"), dark), _classnames));
      var iconClassNames = classnames((_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefix$c, "--example__icon"), true), _defineProperty(_classnames2, "".concat(prefix$c, "--example__icon--correct"), correct), _defineProperty(_classnames2, "".concat(prefix$c, "--example__icon--incorrect"), !correct), _classnames2));
      return React.createElement("div", {
        className: wrapperClassNames
      }, React.createElement("div", {
        className: "".concat(prefix$c, "--example-card")
      }, React.createElement("div", {
        className: "".concat(prefix$c, "--example-card__content")
      }, correct ? React.createElement(CheckmarkFilled24, {
        className: iconClassNames
      }) : React.createElement(CloseFilled16, {
        className: iconClassNames
      }), React.createElement("div", {
        className: "".concat(prefix$c, "--example__content")
      }, children, text ? React.createElement("p", {
        className: "".concat(prefix$c, "--example__text")
      }, text) : null))), this.renderCaption(label, description));
    }
  }]);

  return DoDontExample;
}(React.Component);

DoDontExample.propTypes = {
  children: PropTypes.node,

  /** title for the caption (optional) */
  label: PropTypes.string,

  /** description for the card caption (optional) */
  description: PropTypes.string,

  /** text displayed in the example card */
  text: PropTypes.string,

  /** path to the image displayed in the example card, starting under `src` folder. e.g.: `content/guidelines/content/img-test.svg` */
  imgpath: PropTypes.string,

  /** mark card as true? if not defined, card will be marked as false */
  correct: PropTypes.bool,

  /** default to false, set to true for dark background */
  dark: PropTypes.bool,

  /** default to false, set to true for forced aspect ratio */
  square: PropTypes.bool
};
export { WebsiteFooter, WebsiteSwitcher, FourOhFour, WebsiteBackToTopBtn, Row, Column, TypefaceSubFamilies, AnchorLinks, VideoInternal, PlayPauseButton, HomepageVideo, WebsiteCodeSnippet, ImageComponent, DoDontExample };